(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7399,9542],{

/***/ 47554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(868);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);








var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        default: {
            background: "transparent"
        },
        btnType: function(param) {
            var btnType = param.btnType, hover = param.hover, hoverColor = param.hoverColor;
            var ref, ref1;
            return {
                backgroundColor: ((ref = theme.palette[btnType]) === null || ref === void 0 ? void 0 : ref.main) || "transparent",
                padding: "6px 0px",
                borderRadius: "20px",
                fontFamily: "googlesansmedium",
                textAlign: "center",
                "&:hover": {
                    backgroundColor: hover ? (ref1 = theme.palette[hover]) === null || ref1 === void 0 ? void 0 : ref1.light : "transparent",
                    transition: "all 0.2s ease-in",
                    color: hoverColor || "unset"
                }
            };
        },
        startIcon: {
            marginRight: "4px",
            marginBottom: "2px"
        },
        endIcon: {
            marginLeft: "4px",
            marginBottom: "2px"
        }
    };
});
function ButtonV2(_param) {
    var _tooltipTitle = _param.tooltipTitle, tooltipTitle = _tooltipTitle === void 0 ? "" : _tooltipTitle, children = _param.children, startIcon = _param.startIcon, endIcon = _param.endIcon, className = _param.className, btnType = _param.btnType, _hover = _param.hover, hover = _hover === void 0 ? false : _hover, hoverColor = _param.hoverColor, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "tooltipTitle",
        "children",
        "startIcon",
        "endIcon",
        "className",
        "btnType",
        "hover",
        "hoverColor"
    ]);
    var classes = useStyles({
        btnType: btnType,
        hover: hover,
        hoverColor: hoverColor
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        title: tooltipTitle,
        disableHoverListener: !tooltipTitle && true,
        arrow: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.btnType, className),
            classes: {
                startIcon: classes.startIcon,
                endIcon: classes.endIcon
            },
            startIcon: startIcon,
            endIcon: endIcon
        }, restProps), {
            children: children
        }))
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ButtonV2); // btnType contain: 'success' , 'warning', 'info', 'error', 'primary', 'secondary'
 // hover contain: default is false, true will obey light color with btnType color


/***/ }),

/***/ 77753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71569);
/* harmony import */ var constants_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43004);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);





var _obj;
var ICON_SIZE = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .FLUCTUATED_TYPE.INCREASED */ .w4.INCREASED, {
    src: constants_Icons__WEBPACK_IMPORTED_MODULE_2__/* .PRICE_INCREASE_ICON */ .Hq,
    width: 18,
    height: 18
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .FLUCTUATED_TYPE.DECREASED */ .w4.DECREASED, {
    src: constants_Icons__WEBPACK_IMPORTED_MODULE_2__/* .PRICE_DECREASE_ICON */ .KB,
    width: 16,
    height: 16
}), _obj);
var FluctuatedPriceIcon = function(param) {
    var fluctuatedType = param.fluctuatedType;
    var icon = ICON_SIZE[fluctuatedType];
    if (!icon) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: icon.src,
        width: icon.width,
        height: icon.height,
        layout: "fixed",
        alt: fluctuatedType === constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .FLUCTUATED_TYPE.INCREASED */ .w4.INCREASED ? "price increased" : "price decreased"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FluctuatedPriceIcon);


/***/ }),

/***/ 50586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39636);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80366);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43775);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);








var BottomDrawerMV2 = function(param) {
    var isShow = param.isShow, handleClose = param.handleClose, titleClass = param.titleClass, _title = param.title, title = _title === void 0 ? "" : _title, _offHeader = param.offHeader, offHeader = _offHeader === void 0 ? false : _offHeader, classContainer = param.classContainer, classContent = param.classContent, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        classes: {
            paper: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().drawerContainer), classContainer)
        },
        anchor: "bottom",
        open: isShow,
        onClose: handleClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
            children: [
                !offHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            classes: {
                                root: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().iconButton)
                            },
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: titleClass,
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().content), classContent),
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomDrawerMV2);


/***/ }),

/***/ 48748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(282);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #d4323b;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  color: #fff;\n  font-size: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #d4323b;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  position: absolute;\n  top: 11%;\n  right: 5%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.MuiButtonBase-root {\n    min-width: 48px;\n  }\n  &.Mui-disabled {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var CustomQuantity = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-a3d6d602-0"
})(_templateObject(), function(props) {
    return props.isProductPage ? "-11%" : "5%";
}, function(props) {
    return props.isProductPage ? "0%" : "5%";
}, function(props) {
    return props.quantity >= props.max ? "10px" : "12px";
});
var Dots = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-a3d6d602-1"
})(_templateObject1());
var MobileBadge = function(props) {
    var children = props.children, className = props.className, _quantity = props.quantity, quantity = _quantity === void 0 ? 0 : _quantity, _isAvartar = props.isAvartar, isAvartar = _isAvartar === void 0 ? false : _isAvartar, handleOnClick = props.handleOnClick, _isDot = props.isDot, isDot = _isDot === void 0 ? false : _isDot, _optSort = props.optSort, optSort = _optSort === void 0 ? "" : _optSort, _isProductPage = props.isProductPage, isProductPage = _isProductPage === void 0 ? false : _isProductPage, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "children",
        "className",
        "quantity",
        "isAvartar",
        "handleOnClick",
        "isDot",
        "optSort",
        "isProductPage"
    ]);
    var max = 100;
    if (isAvartar) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            className: className,
            onClick: handleOnClick
        }, restProps), {
            children: children
        }));
    }
    if (isDot) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            className: className,
            onClick: handleOnClick
        }, restProps), {
            children: [
                children,
                optSort && optSort !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Dots, {})
            ]
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: className,
        onClick: handleOnClick
    }, restProps), {
        children: [
            children,
            quantity > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomQuantity, {
                quantity: quantity,
                max: max,
                isProductPage: isProductPage,
                children: quantity >= max ? "99+" : quantity
            }) : ""
        ]
    }));
};
var StyledBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(MobileBadge).withConfig({
    componentId: "sc-a3d6d602-2"
})(_templateObject2());
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(StyledBadge));


/***/ }),

/***/ 73238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71569);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5596);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);






function PasswordWarningText(param) {
    var className = param.className;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().text_warning), className && className),
        children: translatePopupAction("popup_login.password_security_login").replace("{BRAND_NAME}", constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .BRAND_NAME */ .RS)
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PasswordWarningText);


/***/ }),

/***/ 47448:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var shimmer = function(w, h, color) {
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#f3f3f3" offset="20%" />\n      <stop stop-color="#f3f3f3" offset="50%" />\n      <stop stop-color="#f3f3f3" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="').concat(color, '" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
};
/* harmony default export */ __webpack_exports__["Z"] = (shimmer);


/***/ }),

/***/ 37566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_CartPriceFluctuationModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandLess.js
var ExpandLess = __webpack_require__(35025);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components-v2/atoms/Mobile/BottomDrawer/index.js
var BottomDrawer = __webpack_require__(50586);
// EXTERNAL MODULE: ./src/clients/index.js + 21 modules
var clients = __webpack_require__(38169);
// EXTERNAL MODULE: ./src/components-v2/atoms/FluctuatedPriceIcon/index.js
var FluctuatedPriceIcon = __webpack_require__(77753);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./src/components/mocules/TagComponent/index.js + 2 modules
var TagComponent = __webpack_require__(22535);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/components-v2/mocules/CartPriceFluctuationItem/styles.module.css
var styles_module = __webpack_require__(99182);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CartPriceFluctuationItem/index.js




















// product là cart item đã enrich, kèm price (giá mới) / currentPrice (giá lúc thêm vào
// giỏ) / fluctuatedType / warningMessage lấy từ fluctuatedItems của BE.
// isQuantityReadOnly: ở /checkout chỉ cho xem số lượng, muốn sửa thì quay lại giỏ hàng.
var CartPriceFluctuationItem = function(param) {
    var product = param.product, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isQuantityReadOnly = param.isQuantityReadOnly, isQuantityReadOnly = _isQuantityReadOnly === void 0 ? false : _isQuantityReadOnly;
    var ref = (0,esm/* useTranslation */.$G)("cart"), translateCart = ref.t;
    var ref1 = (0,context/* useCart */.jD)(), updateCartItem = ref1.updateCartItem, validate200Item = ref1.validate200Item;
    var ref2 = product || {}, sku = ref2.sku, _name = ref2.name, name = _name === void 0 ? "" : _name, _slug = ref2.slug, slug = _slug === void 0 ? "" : _slug, _volume = ref2.volume, volume = _volume === void 0 ? "" : _volume, _tags = ref2.tags, tags = _tags === void 0 ? [] : _tags, _statusData = ref2.statusData, statusData = _statusData === void 0 ? {} : _statusData, _expiredDate = ref2.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate, _lotDates = ref2.lotDates, lotDates = _lotDates === void 0 ? [] : _lotDates, _isDeal = ref2.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = ref2.deal, deal = _deal === void 0 ? null : _deal, _quantity = ref2.quantity, quantity = _quantity === void 0 ? 0 : _quantity, _price = ref2.price, price = _price === void 0 ? 0 : _price, _currentPrice = ref2.currentPrice, currentPrice = _currentPrice === void 0 ? 0 : _currentPrice, fluctuatedType = ref2.fluctuatedType, _warningMessage = ref2.warningMessage, warningMessage = _warningMessage === void 0 ? "" : _warningMessage, _imagesProxy = ref2.imagesProxy, imagesProxy = _imagesProxy === void 0 ? [] : _imagesProxy, _isGift = ref2.isGift, isGift = _isGift === void 0 ? false : _isGift, _maxQuantity = ref2.maxQuantity, maxQuantity = _maxQuantity === void 0 ? 0 : _maxQuantity, _messageLimitOrder = ref2.messageLimitOrder, messageLimitOrder = _messageLimitOrder === void 0 ? "" : _messageLimitOrder;
    var ref3 = (0,react.useState)(quantity), value = ref3[0], setValue = ref3[1];
    var ref4 = (0,react.useState)(false), isUpdating = ref4[0], setIsUpdating = ref4[1];
    (0,react.useEffect)(function() {
        setValue(quantity);
    }, [
        quantity
    ]);
    var isIncreased = fluctuatedType === Enums/* FLUCTUATED_TYPE.INCREASED */.w4.INCREASED;
    var remainingPrice = Math.abs(price - currentPrice);
    // ngày cận date nằm ở lô có isNearExpired, expiredDate của cart item thường rỗng
    var nearExpiredLot = lotDates === null || lotDates === void 0 ? void 0 : lotDates.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.isNearExpired) === true;
    });
    var handleUpdateQuantity = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newQuantity) {
            var response, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (newQuantity < 1) return [
                            2
                        ];
                        setValue(newQuantity);
                        if (newQuantity === quantity) return [
                            2
                        ];
                        setIsUpdating(true);
                        _tmp = {};
                        return [
                            4,
                            updateCartItem((_tmp.product = product, _tmp.q = newQuantity, _tmp), true, true)
                        ];
                    case 1:
                        response = _state.sent();
                        setIsUpdating(false);
                        // BE từ chối (vượt giới hạn mua...) thì trả input về số lượng thật trong giỏ
                        if (!(0,clients/* isValid */.JY)(response)) setValue(quantity);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdateQuantity(newQuantity) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDecrease = function() {
        return handleUpdateQuantity(value - 1);
    };
    var handleIncrease = function() {
        if (!validate200Item(sku)) return;
        handleUpdateQuantity(value + 1);
    };
    var handleInputChange = function(e) {
        var ref, ref1;
        var val = e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.replace(/[^\d]/g, "");
        setValue(val === "" ? "" : Number(val));
    };
    var handleBlur = function() {
        var newQuantity = Number(value) || 0;
        if (newQuantity < 1) {
            setValue(quantity);
            return;
        }
        handleUpdateQuantity(maxQuantity > 0 ? Math.min(newQuantity, maxQuantity) : newQuantity);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((styles_module_default()).item, isMobile && (styles_module_default()).item_mobile),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (styles_module_default()).image_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                    src: (imagesProxy === null || imagesProxy === void 0 ? void 0 : imagesProxy[0]) || (isGift ? Images/* GIFT_IMAGE */.AON : Images/* MISSING_IMAGE */.g_W),
                    fallbackSrc: isGift ? Images/* GIFT_IMAGE */.AON : Images/* MISSING_IMAGE */.g_W,
                    width: isMobile ? 96 : 72,
                    height: isMobile ? 96 : 72,
                    quality: 100,
                    alt: "product-img-".concat(sku),
                    className: (styles_module_default()).image
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (styles_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                        href: "/product/".concat(slug || "", "/loading"),
                        prefetch: false,
                        className: (styles_module_default()).link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).product_name,
                            children: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name
                        })
                    }),
                    !!volume && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (styles_module_default()).product_volume,
                        children: volume
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (styles_module_default()).product_tags,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                            product: {
                                tags: tags,
                                statusData: statusData,
                                expiredDate: (nearExpiredLot === null || nearExpiredLot === void 0 ? void 0 : nearExpiredLot.expiredDate) || expiredDate || ""
                            },
                            isGift: isGift
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (styles_module_default()).price_block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).price_row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).price_label,
                                children: translateCart("original_price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).old_price,
                                children: (0,FormatNumber/* formatCurrency */.xG)(currentPrice)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).price_row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).price_label, (styles_module_default()).price_label_strong),
                                children: translateCart("new_price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).new_price,
                                children: (0,FormatNumber/* formatCurrency */.xG)(price)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).fluctuation_row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuatedPriceIcon/* default */.Z, {
                                fluctuatedType: fluctuatedType
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).fluctuation_text, isIncreased && (styles_module_default()).increased),
                                children: "".concat(isIncreased ? translateCart("price_increase") : translateCart("price_save"), " ").concat((0,FormatNumber/* formatCurrency */.xG)(remainingPrice))
                            })
                        ]
                    }),
                    !!warningMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).price_row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).price_label,
                                children: translateCart("price_change_reason")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).reason_text,
                                children: warningMessage
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (styles_module_default()).quantity_block,
                children: [
                    !!messageLimitOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (styles_module_default()).limit_text,
                        children: messageLimitOrder
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).quantity_control,
                        children: [
                            !isQuantityReadOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MinusButton */.P4, {
                                className: (styles_module_default()).minus_button,
                                disabled: isUpdating || value <= 1,
                                onClick: handleDecrease
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (styles_module_default()).quantity_input_wrapper,
                                children: [
                                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Icons/* CART_QUANTITY_ICON */.ik,
                                        width: 14,
                                        height: 13,
                                        layout: "fixed",
                                        alt: "quantity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InputProduct */._W, {
                                        className: (styles_module_default()).quantity_input,
                                        product: product,
                                        value: value,
                                        onChange: handleInputChange,
                                        onBlur: handleBlur,
                                        disabled: isUpdating || isQuantityReadOnly,
                                        style: isMobile ? {
                                            width: "".concat(String(value !== null && value !== void 0 ? value : "").length + 1, "ch")
                                        } : undefined
                                    })
                                ]
                            }),
                            !isQuantityReadOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* PlusButton */.sS, {
                                disabled: isUpdating || maxQuantity > 0 && value >= maxQuantity,
                                onClick: handleIncrease
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_CartPriceFluctuationItem = (CartPriceFluctuationItem);

// EXTERNAL MODULE: ./src/components-v2/mocules/CartPriceFluctuationModal/styles.module.css
var CartPriceFluctuationModal_styles_module = __webpack_require__(57624);
var CartPriceFluctuationModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(CartPriceFluctuationModal_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CartPriceFluctuationModal/index.js
















var VISIBLE_ITEMS = 2;
var FluctuationGroup = function(param) {
    var _products = param.products, products = _products === void 0 ? [] : _products, _isIncreased = param.isIncreased, isIncreased = _isIncreased === void 0 ? false : _isIncreased, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isQuantityReadOnly = param.isQuantityReadOnly, isQuantityReadOnly = _isQuantityReadOnly === void 0 ? false : _isQuantityReadOnly;
    var ref = (0,esm/* useTranslation */.$G)("cart"), translateCart = ref.t;
    var ref1 = (0,react.useState)(false), isExpanded = ref1[0], setIsExpanded = ref1[1];
    if (products.length === 0) return null;
    var isCollapsible = products.length > VISIBLE_ITEMS;
    var visibleProducts = isCollapsible && !isExpanded ? products.slice(0, VISIBLE_ITEMS) : products;
    var groupTitle = isIncreased ? translateCart("price_increased_group") : translateCart("price_decreased_group");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (CartPriceFluctuationModal_styles_module_default()).group,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((CartPriceFluctuationModal_styles_module_default()).group_header, isIncreased && (CartPriceFluctuationModal_styles_module_default()).group_header_increased),
                children: groupTitle.replace("{number}", products.length)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((CartPriceFluctuationModal_styles_module_default()).items, isCollapsible && !isExpanded && (CartPriceFluctuationModal_styles_module_default()).items_collapsed),
                children: visibleProducts.map(function(product) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(mocules_CartPriceFluctuationItem, {
                        product: product,
                        isMobile: isMobile,
                        isQuantityReadOnly: isQuantityReadOnly
                    }, "fluctuation-".concat(product === null || product === void 0 ? void 0 : product.sku));
                })
            }),
            isCollapsible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (CartPriceFluctuationModal_styles_module_default()).see_all,
                onClick: function() {
                    return setIsExpanded(!isExpanded);
                },
                endIcon: isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                "data-test": "btn-fluctuation-see-all",
                children: isExpanded ? translateCart("price_collapse") : translateCart("price_see_all")
            })
        ]
    });
};
/**
 * Xác nhận biến động giá, dùng ở 2 chỗ:
 *  - /cart: bấm thanh toán -> xác nhận giá mới rồi mới sang /checkout.
 *  - /checkout: bấm đặt hàng -> xác nhận giá mới rồi đặt hàng luôn (isFromCheckout).
 */ var CartPriceFluctuationModal = function(param) {
    var visible = param.visible, onClose = param.onClose, onBack = param.onBack, onConfirm = param.onConfirm, _products = param.products, products = _products === void 0 ? [] : _products, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isFromCheckout = param.isFromCheckout, isFromCheckout = _isFromCheckout === void 0 ? false : _isFromCheckout;
    var ref = (0,esm/* useTranslation */.$G)("cart"), translateCart = ref.t;
    var ref1 = (0,react.useState)(false), isConfirming = ref1[0], setIsConfirming = ref1[1];
    var decreasedProducts = products.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.fluctuatedType) === Enums/* FLUCTUATED_TYPE.DECREASED */.w4.DECREASED;
    });
    var increasedProducts = products.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.fluctuatedType) === Enums/* FLUCTUATED_TYPE.INCREASED */.w4.INCREASED;
    });
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsConfirming(true);
                        return [
                            4,
                            onConfirm()
                        ];
                    case 1:
                        _state.sent();
                        setIsConfirming(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (CartPriceFluctuationModal_styles_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (CartPriceFluctuationModal_styles_module_default()).title,
                    "data-test": "fluctuation-modal-title",
                    children: translateCart("price_fluctuation_title").replace("{number}", products.length)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (CartPriceFluctuationModal_styles_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuationGroup, {
                        products: decreasedProducts,
                        isMobile: isMobile,
                        isQuantityReadOnly: isFromCheckout
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuationGroup, {
                        products: increasedProducts,
                        isIncreased: true,
                        isMobile: isMobile,
                        isQuantityReadOnly: isFromCheckout
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (CartPriceFluctuationModal_styles_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (CartPriceFluctuationModal_styles_module_default()).disclaimer,
                        children: translateCart("price_fluctuation_disclaimer")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (CartPriceFluctuationModal_styles_module_default()).actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (CartPriceFluctuationModal_styles_module_default()).btn_back,
                                onClick: onBack || onClose,
                                "data-test": "btn-fluctuation-back",
                                children: translateCart("back_to_cart")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (CartPriceFluctuationModal_styles_module_default()).btn_continue,
                                onClick: handleConfirm,
                                disabled: isConfirming,
                                "data-test": "btn-fluctuation-continue",
                                children: isFromCheckout ? translateCart("price_fluctuation_checkout") : translateCart("price_fluctuation_continue")
                            })
                        ]
                    })
                ]
            })
        ]
    });
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomDrawer/* default */.Z, {
            isShow: visible,
            handleClose: onClose,
            offHeader: true,
            classContainer: (CartPriceFluctuationModal_styles_module_default()).drawer_paper,
            classContent: (CartPriceFluctuationModal_styles_module_default()).drawer_content,
            children: content
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
        open: visible,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (CartPriceFluctuationModal_styles_module_default()).wrapper,
            children: content
        })
    });
};
/* harmony default export */ var mocules_CartPriceFluctuationModal = (CartPriceFluctuationModal);


/***/ }),

/***/ 36401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69251);
/* harmony import */ var constants_ErrorCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83084);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34588);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93454);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);









function ErrProductCard(param) {
    var _product = param.product, product = _product === void 0 ? null : _product;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("alert-action"), translateAlertAction = ref.t;
    var _deal = product.deal, deal = _deal === void 0 ? null : _deal, _isDeal = product.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _defaultImage = product.defaultImage, defaultImage = _defaultImage === void 0 ? null : _defaultImage, _name = product.name, name = _name === void 0 ? "" : _name, _quantity = product.quantity, quantity = _quantity === void 0 ? 0 : _quantity, _errorCode = product.errorCode, errorCode = _errorCode === void 0 ? null : _errorCode, _slug = product.slug, slug = _slug === void 0 ? "" : _slug, _imagesProxy = product.imagesProxy, imagesProxy = _imagesProxy === void 0 ? [] : _imagesProxy, _errorMessage = product.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage;
    var errProductMessage = errorCode === constants_ErrorCart__WEBPACK_IMPORTED_MODULE_2__/* .ERROR_CODE_CART.REQUIRED_CERTIFICATE */ .M5.REQUIRED_CERTIFICATE ? translateAlertAction("message_error_cart.REQUIRED_CERTIFICATE_SORT") : translateAlertAction("message_error_cart.".concat(errorCode)) || errorMessage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        item: true,
        container: true,
        alignItems: "center",
        style: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                item: true,
                xs: 4,
                style: {
                    padding: "20px 0px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().img_container),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_5__/* .ImageFallbackProductImage */ .nZ, {
                        width: 56,
                        height: 56,
                        alt: "product-img-".concat(slug),
                        fallbackSrc: imagesProxy[0] || defaultImage,
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().imageMain),
                        src: defaultImage,
                        quality: 100
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                item: true,
                xs: 8,
                container: true,
                justifyContent: "flex-start",
                alignItems: "center",
                style: {
                    minHeight: "86px"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                            href: "/product/".concat(slug || "", "/loading"),
                            prefetch: false,
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                align: "left",
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().text_product_name),
                                children: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name || ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            align: "right",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().text_product_quantity),
                            children: [
                                "x",
                                quantity
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            align: "right",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().text_product_err),
                            children: errProductMessage
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(ErrProductCard));


/***/ }),

/***/ 17863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55517);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41749);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33436);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ErrProductCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36401);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4890);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);








function ErrorProductsPayment() {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    var ref1 = (0,context__WEBPACK_IMPORTED_MODULE_1__/* .useCart */ .jD)(), _errProducts = ref1.errProducts, errProducts = _errProducts === void 0 ? [] : _errProducts;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            container: true,
            direction: "column",
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    item: true,
                    container: true,
                    justifyContent: "space-between",
                    alignItems: "center",
                    style: {
                        width: "100%",
                        padding: "0px 19px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: translateCommon("total_error_products")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: (errProducts === null || errProducts === void 0 ? void 0 : errProducts.length) || 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    item: true,
                    container: true,
                    direction: "row",
                    style: {
                        width: "100%",
                        padding: "0px 19px",
                        marginTop: "20px",
                        maxHeight: "373px",
                        overflowY: "auto"
                    },
                    children: errProducts.map(function(item) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrProductCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    product: item
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    style: {
                                        width: "100%"
                                    }
                                })
                            ]
                        }, item === null || item === void 0 ? void 0 : item.sku);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ErrorProductsPayment);


/***/ }),

/***/ 40907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55517);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80366);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69251);
/* harmony import */ var constants_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43004);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var _ErrProductCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36401);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72910);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);















function ModalListProduct(_param) {
    var _content = _param.content, content = _content === void 0 ? null : _content, _title = _param.title, title = _title === void 0 ? "" : _title, _isShowPopupConfirm = _param.isShowPopupConfirm, isShowPopupConfirm = _isShowPopupConfirm === void 0 ? false : _isShowPopupConfirm, handleClosePopup = _param.handleClosePopup, handleClick = _param.handleClick, _icon = _param.icon, icon = _icon === void 0 ? true : _icon, _btnCancelText = _param.btnCancelText, btnCancelText = _btnCancelText === void 0 ? "" : _btnCancelText, _btnOkText = _param.btnOkText, btnOkText = _btnOkText === void 0 ? "" : _btnOkText, _products = _param.products, products = _products === void 0 ? [] : _products, _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "content",
        "title",
        "isShowPopupConfirm",
        "handleClosePopup",
        "handleClick",
        "icon",
        "btnCancelText",
        "btnOkText",
        "products",
        "isMobile"
    ]);
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, restProps), {
            open: isShowPopupConfirm,
            onClose: handleClosePopup,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().modal_mobile_wrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                container: true,
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: 11,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            align: "left",
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().text_top_mobile),
                                            children: translatePopupAction("popup-products.check_again_cart_have_err_products")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            onClick: handleClosePopup,
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().btn_ic_close),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().icon_close)
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                container: true,
                                style: {
                                    maxHeight: "373px",
                                    overflowY: "auto"
                                },
                                children: products && products.length > 0 && products.map(function(product) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrProductCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                product: product
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                style: {
                                                    width: "100%"
                                                }
                                            })
                                        ]
                                    }, product === null || product === void 0 ? void 0 : product.sku);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        container: true,
                        justifyContent: "center",
                        alignItems: "center",
                        style: {
                            width: "100%",
                            marginTop: "20px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().btn_ok_mobile),
                            onClick: handleClick,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(constants_Icons__WEBPACK_IMPORTED_MODULE_2__/* .ICON_WISHLIST_DEL_V2 */ .G9, {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().icon_del)
                                }),
                                translatePopupAction("popup-products.delete_all_products")
                            ]
                        })
                    })
                ]
            })
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, restProps), {
        open: isShowPopupConfirm,
        onClose: handleClosePopup,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().modal_wrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().text_icon),
                                children: "!"
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().text_title),
                            children: title
                        }),
                        content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: content
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            container: true,
                            style: {
                                maxHeight: "373px",
                                overflowY: "auto"
                            },
                            children: products && products.length > 0 && products.map(function(product) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrProductCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            product: product
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            style: {
                                                width: "100%"
                                            }
                                        })
                                    ]
                                }, product === null || product === void 0 ? void 0 : product.sku);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    container: true,
                    justifyContent: "space-between",
                    alignItems: "center",
                    style: {
                        width: "100%",
                        marginTop: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().btn_cancel),
                            onClick: handleClosePopup,
                            children: btnCancelText || translatePopupAction("popup-products.re_check")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().btn_ok),
                            onClick: handleClick,
                            children: btnOkText || translatePopupAction("popup-products.agree")
                        })
                    ]
                })
            ]
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ModalListProduct);


/***/ }),

/***/ 53371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BLUR_DATA_URL */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32692);
/* harmony import */ var _material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(4024);
/* harmony import */ var _material_ui_core_Fade__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72578);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(18042);
/* harmony import */ var _material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(98121);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86010);
/* harmony import */ var components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47448);
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66520);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13270);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46680);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34588);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94328);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_15__);

























var BLUR_DATA_URL = {
    DART_PC: "data:image/svg+xml;base64,".concat(utils__WEBPACK_IMPORTED_MODULE_7__/* .StringUtils.toBase64 */ .xZ.toBase64((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(300, 300, "#bcbcbc1c"))),
    DART_MOBILE: "data:image/svg+xml;base64,".concat(utils__WEBPACK_IMPORTED_MODULE_7__/* .StringUtils.toBase64 */ .xZ.toBase64((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(42, 42, "#bcbcbc1c"))),
    BRIGHT_PC: "data:image/svg+xml;base64,".concat(utils__WEBPACK_IMPORTED_MODULE_7__/* .StringUtils.toBase64 */ .xZ.toBase64((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(545, 545, "#f3f3f3"))),
    BRIGHT_MOBILE: "data:image/svg+xml;base64,".concat(utils__WEBPACK_IMPORTED_MODULE_7__/* .StringUtils.toBase64 */ .xZ.toBase64((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(42, 42, "#f3f3f3")))
};
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        modal: {
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: "#FFFFFF",
            width: "940px",
            height: "651px",
            borderRadius: "10px",
            boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.05)"
        },
        mobileModal: {
            position: "absolute",
            display: "flex",
            width: "95%",
            height: "400px",
            borderRadius: "10px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.05)"
        },
        closeBtn: {
            width: "30px",
            height: "30px",
            color: "#C0C0C0"
        },
        nameBoxText: {
            display: "box",
            lineClamp: 2,
            boxOrient: "vertical",
            overflow: "hidden"
        },
        navigateBtn: {
            width: "40px",
            height: "40px",
            background: "rgba(0, 0, 0, 0.15)",
            position: "absolute",
            color: "#ffffff",
            "&:hover": {
                background: "rgba(0, 0, 0, 0.15)",
                color: "#2CD888"
            }
        },
        navigateIc: {
            width: "40px",
            height: "40px"
        },
        navBtnMobile: {
            background: "rgba(0, 0, 0, 0.15)",
            width: "40px",
            height: "40px"
        }
    });
});
function getModalStyle() {
    return {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
}
var PopupMultilImage = function(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _images = param.images, images = _images === void 0 ? [] : _images, _open = param.open, open = _open === void 0 ? false : _open, handleClose = param.handleClose, _imageName = param.imageName, imageName = _imageName === void 0 ? "" : _imageName, _selectedImage = param.selectedImage, selectedImage = _selectedImage === void 0 ? 0 : _selectedImage, handleClickImage = param.handleClickImage, handlePrevious = param.handlePrevious, handleNext = param.handleNext;
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(getModalStyle), modalStyle = ref[0];
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            open: open,
            onClose: handleClose,
            "aria-labelledby": "image-gallery-title",
            "aria-describedby": "image-gallery-description",
            closeAfterTransition: true,
            BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
            BackdropProps: {
                timeout: 500
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: modalStyle,
                className: classes.mobileModal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    container: true,
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            item: true,
                            container: true,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapperMobileImg),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        onClick: handlePrevious,
                                        "aria-label": "prev",
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(classes.navBtnMobile, (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().leftNavBtn)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: classes.navigateIc
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackProductImage */ .nZ, {
                                        width: 300,
                                        height: 300,
                                        layout: "fill",
                                        alt: "image-gallery-item",
                                        fallbackSrc: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MISSING_IMAGE */ .g_W,
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().imageMainMobile),
                                        src: "".concat(images[selectedImage], "?size=origin"),
                                        quality: 100,
                                        isUseLoaderCache: true,
                                        placeholder: "blur",
                                        blurDataURL: BLUR_DATA_URL.DART_PC
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        onClick: handleNext,
                                        "aria-label": "next",
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(classes.navBtnMobile, (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().rightNavBtn)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            className: classes.navigateIc
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            item: true,
                            container: true,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapper_mobile_thumbnail),
                                children: (images === null || images === void 0 ? void 0 : images.length) === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().flex_center),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image_wrapper_mobile), (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_selected)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackProductImage */ .nZ, {
                                            width: 42,
                                            height: 42,
                                            alt: "thumbnailImage",
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image),
                                            src: images && "".concat(images[0]),
                                            fallbackSrc: images[0],
                                            quality: 100,
                                            placeholder: "blur",
                                            blurDataURL: BLUR_DATA_URL.DART_MOBILE
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().slider)
                                }, constants_data__WEBPACK_IMPORTED_MODULE_1__/* .settingsMobileMultiImageBoxV2 */ .As), {
                                    children: images === null || images === void 0 ? void 0 : images.map(function(img, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return handleClickImage(idx);
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image_wrapper_mobile), idx === selectedImage && (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_selected)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackProductImage */ .nZ, {
                                                width: 42,
                                                height: 42,
                                                alt: "thumbnailImage",
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image),
                                                src: "".concat(img),
                                                fallbackSrc: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MISSING_IMAGE */ .g_W,
                                                quality: 100,
                                                placeholder: "blur",
                                                blurDataURL: BLUR_DATA_URL.DART_MOBILE
                                            })
                                        }, img);
                                    })
                                }))
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "image-gallery-title",
        "aria-describedby": "image-gallery-description",
        closeAfterTransition: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Fade__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: modalStyle,
                className: classes.modal,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().closeWrapper),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            onClick: handleClose,
                            "aria-label": "close",
                            style: {
                                height: "18px",
                                width: "18px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                className: classes.closeBtn
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            container: true,
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapperImg),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                onClick: handlePrevious,
                                                className: classes.navigateBtn,
                                                "aria-label": "prev",
                                                style: {
                                                    left: "40px",
                                                    zIndex: 10
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    className: classes.navigateIc
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils__WEBPACK_IMPORTED_MODULE_7__/* .ImageFallback */ .oy, {
                                                width: 545,
                                                height: 545,
                                                // layout="fill"
                                                alt: "image-gallery-item",
                                                fallbackSrc: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MISSING_IMAGE */ .g_W,
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().imageMain),
                                                src: "".concat(images[selectedImage], "?size=origin"),
                                                quality: 100,
                                                isUseLoaderCache: true,
                                                placeholder: "blur",
                                                blurDataURL: BLUR_DATA_URL.BRIGHT_PC
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                onClick: handleNext,
                                                className: classes.navigateBtn,
                                                "aria-label": "next",
                                                style: {
                                                    left: "590px",
                                                    zIndex: 10
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    className: classes.navigateIc
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    style: {
                                        width: "250px",
                                        marginLeft: "50px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().imageNameText), classes.nameBoxText),
                                            children: imageName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapper_thumbnail), (images === null || images === void 0 ? void 0 : images.length) > 21 && (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().scroll_vertical)),
                                            children: images === null || images === void 0 ? void 0 : images.map(function(img, idx) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    onClick: function() {
                                                        return handleClickImage(idx);
                                                    },
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image_wrapper), idx === selectedImage && (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_selected)),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackProductImage */ .nZ, {
                                                        width: 42,
                                                        height: 42,
                                                        alt: "thumbnailImage",
                                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image),
                                                        src: img && "".concat(img),
                                                        fallbackSrc: img,
                                                        quality: 100,
                                                        isUseLoaderCache: true,
                                                        placeholder: "blur",
                                                        blurDataURL: BLUR_DATA_URL.BRIGHT_MOBILE
                                                    })
                                                }, img);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PopupMultilImage);


/***/ }),

/***/ 57096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A1": function() { return /* reexport */ CardProduct_ProductCardVertical; }
});

// UNUSED EXPORTS: ProductCardHorizontal, default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components-v2/mocules/mobile/CardProduct/ProductCardHorizontal/index.js

function ProductCardHorizontal() {
    return /*#__PURE__*/ _jsx("div", {
        children: "ProductCardHorizontal"
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/mocules/ProductCardNew/index.js + 1 modules
var ProductCardNew = __webpack_require__(35632);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductCard/index.js + 3 modules
var ProductCard = __webpack_require__(92101);
;// CONCATENATED MODULE: ./src/components-v2/mocules/mobile/CardProduct/ProductCardVertical/index.js




// styleContainer, isCampaignPage = false, ...propsProduct
// comment card mới -> sử dụng card cũ (restyle theo mobile v2)
function ProductCardVertical(_param) {
    var _isCampaignPage = _param.isCampaignPage, isCampaignPage = _isCampaignPage === void 0 ? false : _isCampaignPage, _isHalfProgress = _param.isHalfProgress, isHalfProgress = _isHalfProgress === void 0 ? false : _isHalfProgress, propsProduct = (0,_object_without_properties/* default */.Z)(_param, [
        "isCampaignPage",
        "isHalfProgress"
    ]);
    // const { getNameSeller } = useSetting();
    // const sellerInfo = getNameSeller({
    //   seller: propsProduct?.seller,
    //   tags: propsProduct?.tags,
    // });
    // const flagshipStore = getHardcodeStoreByTagList(propsProduct?.tags);
    // const { isCampaign, isHappeningCampaign, productType, percentDealSold, campaign, displayPrice } = propsProduct;
    // // handle label hợp đồng/deal
    // let labelName;
    // if (propsProduct?.isContractPrice) {
    //   labelName = 'Giá Hợp Đồng';
    // }
    // if (propsProduct?.discountPercent) {
    //   labelName = `-${propsProduct?.discountPercent}%`;
    // }
    // function OrderMaximumProduct() {
    //   if (
    //     (isCampaign && isHappeningCampaign && percentDealSold < 100) ||
    //     (isCampaign && productType === 'MEGA_DAY' && isHappeningCampaign && percentDealSold < 100)
    //   ) {
    //     return <Typography>{/* Đặt tối đa {formatNumber(availableProducts)} {unit || 'sản phẩm'} với giá khuyến mãi */}</Typography>;
    //   }
    //   if (isHappeningCampaign && percentDealSold === 100 && isCampaignPage) {
    //     return <Typography className={styles.errorMessage}>Bạn đã bỏ lỡ giá khuyến mãi {formatCurrency(campaign?.retailPriceValue) || ''}</Typography>;
    //   }
    //   if (isHappeningCampaign && productType === 'NORMAL' && percentDealSold === 100 && isCampaignPage) {
    //     return <Typography className={styles.errorMessage}>Bạn đã bỏ lỡ giá khuyến mãi {formatCurrency(displayPrice) || ''}</Typography>;
    //   }
    //   return (
    //     <div className={styles.text_danger} styles={{ height: '18px' }}>
    //       {' '}
    //     </div>
    //   );
    // }
    // return (
    //   <LinkComp href={`product/${propsProduct?.slug || ''}/loading`} className={styles.root} style={styleContainer}>
    //     <div className={styles.imgWrapper}>
    //       <ImageFallbackProductImage
    //         className={styles.image}
    //         fallbackSrc={propsProduct?.imagesProxy?.length >= 1 ? propsProduct?.imagesProxy[0] : MISSING_IMAGE}
    //         src={propsProduct?.imagesProxy?.length >= 1 ? `${propsProduct?.imagesProxy[0]}` : MISSING_IMAGE}
    //         width={150}
    //         height={100}
    //         loading="lazy"
    //         title={propsProduct?.name && propsProduct?.name}
    //       />
    //     </div>
    //     <div className={styles.wrapperContent}>
    //       <div style={{ height: '20px' }}>
    //         {propsProduct?.point > 0 && (
    //           <div>
    //             <strong style={{ color: '#0E1983', fontSize: '12px' }}>+{propsProduct?.point}</strong>
    //             <span style={{ margin: '0px 5px', color: '#0E1983', fontSize: '10px' }}>Điểm Tích Lũy</span>
    //             {propsProduct?.pointMultiplier > 1 && <strong className={styles.productCardMultiple}>x{propsProduct?.pointMultiplier}</strong>}
    //           </div>
    //         )}
    //       </div>
    //       <NameComponent propsProduct={propsProduct} sellerInfo={sellerInfo} />
    //       <div className={styles.productVolume}>{propsProduct?.volume}</div>
    //       <div className={styles.alignCenter}>
    //         {flagshipStore ? (
    //           <Tooltip title={flagshipStore?.name}>
    //             <LinkComp className={styles.wrapperSeller} href={flagshipStore?.url}>
    //               <div style={{ flexShrink: 0, display: 'flex' }}>
    //                 <ImageFallback src={SELLER_ICON} />
    //               </div>
    //               <span className={styles.storeName}>{flagshipStore?.name}</span>
    //             </LinkComp>
    //           </Tooltip>
    //         ) : (
    //           sellerInfo?.sellerName && (
    //             <Tooltip title={sellerInfo?.sellerName}>
    //               <LinkComp className={styles.wrapperSeller} href={sellerInfo?.linkStore}>
    //                 <div style={{ flexShrink: 0, display: 'flex' }}>
    //                   <ImageFallback src={SELLER_ICON} />
    //                 </div>
    //                 <span className={styles.storeName}>{sellerInfo?.sellerName}</span>
    //               </LinkComp>
    //             </Tooltip>
    //           )
    //         )}
    //       </div>
    //       <div
    //         role="button"
    //         tabIndex={-1}
    //         className={styles.tagSection}
    //         onClick={(e) => {
    //           e.preventDefault();
    //         }}
    //         onKeyDown={(e) => {
    //           e.preventDefault();
    //         }}
    //       >
    //         <TagComponent
    //           product={{ tags: propsProduct?.tags, statusData: propsProduct?.statusData }}
    //           isMobile
    //           isProductCard
    //           isGift={propsProduct?.isGift}
    //         />
    //       </div>
    //       <CountDownSellout propsProduct={propsProduct} />
    //       {/* khi sku đang bị lỗi */}
    //     </div>
    //     {propsProduct?.errorMessageProduct ? (
    //       <Typography className={styles.errorMessage} style={{ padding: '0px 13.5px' }}>
    //         {propsProduct?.errorMessageProduct || propsProduct?.errorMessage || 'Đang cập nhật giá'}
    //       </Typography>
    //     ) : (
    //       <div className={styles.wrapperTextPrice}>
    //         {OrderMaximumProduct()}
    //         <PriceComponent propsProduct={propsProduct} />
    //         {productType === 'FLASH_SALE' ? (
    //           <div className="lineLimit2" style={{ minHeight: '34px' }} />
    //         ) : (
    //           <div className="lineLimit2" style={{ minHeight: '34px' }}>
    //             {propsProduct?.messageLimitOrder && <small>{propsProduct?.messageLimitOrder}</small>}
    //           </div>
    //         )}
    //         <div className={styles.addWishlist}>
    //           <WishListAction propsProduct={propsProduct} />
    //         </div>
    //         {labelName && (
    //           <div
    //             className={clsx({
    //               [styles.discount]: true,
    //               [styles.contractStyles]: propsProduct?.isContractPrice,
    //             })}
    //           >
    //             {labelName}
    //           </div>
    //         )}
    //       </div>
    //     )}
    //   </LinkComp>
    // );
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
        product: propsProduct,
        isMobile: true,
        isHalfProgress: isHalfProgress,
        isCampaignPage: isCampaignPage
    });
}
/* harmony default export */ var CardProduct_ProductCardVertical = (ProductCardVertical);

;// CONCATENATED MODULE: ./src/components-v2/mocules/mobile/CardProduct/index.js


/* harmony default export */ var CardProduct = ({});


/***/ }),

/***/ 17368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_NoSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46680);







// thuannc
// TODO:
// MUST FIX
function MobileCountdownTimer(_param) {
    var prefix = _param.prefix, dealEndDay = _param.dealEndDay, translateCommon = _param.translateCommon, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "prefix",
        "dealEndDay",
        "translateCommon"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeLeft */ .VZ)(dealEndDay)), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer = setTimeout(function() {
            setTimeLeft((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeLeft */ .VZ)(dealEndDay));
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function(interval) {
        var val = timeLeft[interval];
        if (!val) {
            return;
        }
        // 05Jan2022 -> nếu > 30 ngày thì set lại 30 ngày, dài quá bể UI
        /**
     *  bổ sung rules cho UI mobile v2
     *  + countdown có thêm ngày -> chia 2 dòng 1 dòng ngày 1 dòng giờ:phút:giây
     *  + countdown không có ngày -> 1 dòng giờ:phút:giây
     */ // 28Sep2023: product card v5.1 -> count down is one line
        var Tag = "span";
        // if (interval === 'days') Tag = 'div';
        timerComponents.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, {
            style: interval === "days" ? {
                marginRight: "4px"
            } : {},
            children: [
                val,
                interval === "days" ? " ".concat(translateCommon("days")) : null
            ]
        }, "timer-".concat(Math.random())));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_NoSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, otherProps), {
            children: [
                prefix,
                " ",
                timerComponents.length ? timerComponents : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: translateCommon("voucher.end_of_promotion")
                })
            ]
        }))
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (MobileCountdownTimer);


/***/ }),

/***/ 2452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58365);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24357);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);




var ProductCardVertical = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 120
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 13,
                style: {
                    marginTop: 6,
                    borderRadius: 3,
                    marginRight: 50
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 26,
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 12,
                width: "40%",
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 12,
                width: "60%",
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 12,
                width: "60%",
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 13,
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: "rect",
                        height: 13,
                        width: "40%",
                        style: {
                            marginTop: 6,
                            borderRadius: 3
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: "rect",
                        height: 13,
                        style: {
                            marginTop: 6,
                            borderRadius: 3
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 17,
                width: "40%",
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 20,
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 16,
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "rect",
                height: 20,
                style: {
                    marginTop: 6,
                    borderRadius: 3
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardVertical);


/***/ }),

/***/ 28677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51436);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var _material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51907);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66520);
/* harmony import */ var constants_Images_mobile_Icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76726);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _Skeleton_ProductCardVertical__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2452);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7060);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87653);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_10__);














var CustomNextArrow = function(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: className,
        style: style,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__.FontAwesomeIcon, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().arrowIcon), (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().arrowLeft)),
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__.faAngleRight
        })
    });
};
var CustomPrevArrow = function(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: className,
        style: style,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__.FontAwesomeIcon, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().arrowIcon), (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().arrowRight)),
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__.faAngleLeft
        })
    });
};
var StoreSlideNextArrow = function(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(className, (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().store_arrowLeft)),
        style: style,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(constants_Images_mobile_Icons__WEBPACK_IMPORTED_MODULE_3__/* .ICON_MOBILE_ICON_SLIDE_ARROW_RIGHT */ .B6, {})
    });
};
var StoreSlidePrevArrow = function(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(className, (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().store_arrowRight)),
        style: style,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(constants_Images_mobile_Icons__WEBPACK_IMPORTED_MODULE_3__/* .ICON_MOBILE_ICON_SLIDE_ARROW_LEFT */ .dJ, {})
    });
};
var settings = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, constants_data__WEBPACK_IMPORTED_MODULE_2__/* .swiperSettings */ .wv), {
    pagination: false,
    navigation: {
        enable: true,
        nextEl: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomNextArrow, {}),
        prevEl: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomPrevArrow, {})
    }
});
var settingsStore = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, constants_data__WEBPACK_IMPORTED_MODULE_2__/* .swiperSettings */ .wv), {
    pagination: false,
    navigation: {
        enable: true,
        nextEl: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreSlideNextArrow, {}),
        prevEl: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreSlidePrevArrow, {})
    }
});
function ProductPreview(param) {
    var _slideItems = param.slideItems, slideItems = _slideItems === void 0 ? [] : _slideItems, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _appendSettings = param.appendSettings, appendSettings = _appendSettings === void 0 ? {} : _appendSettings, _isMobileSeller = param.isMobileSeller, isMobileSeller = _isMobileSeller === void 0 ? false : _isMobileSeller;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var numProductSlide = 2;
    // create array every element is an array item product with ${numProductSlide} element
    var SlideItemsGroup = [];
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < Math.ceil(slideItems.length / numProductSlide); ++i){
        var arr = [];
        // eslint-disable-next-line no-plusplus
        for(var j = 0; j < numProductSlide; ++j){
            var cI = numProductSlide * i;
            arr.push(slideItems[cI + j]);
        }
        SlideItemsGroup.push(arr);
    }
    var SlideItems = SlideItemsGroup.map(function(item, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().wrapperProductPreview)),
            children: [
                item[0] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().productPreviewItem),
                    children: item[0]
                }),
                item[1] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().productPreviewItem),
                    children: item[1]
                }),
                item[2] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().productPreviewItem),
                    children: item[2]
                }),
                item[3] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().productPreviewItem),
                    children: item[3]
                }),
                item[4] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().productPreviewItem),
                    children: item[4]
                })
            ]
        }, index);
    });
    if (isLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            gap: "13px",
            padding: "10px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton_ProductCardVertical__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton_ProductCardVertical__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        ]
    });
    if (slideItems.length === 0 && !isLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().emptyProduct),
        children: t("common:loading_product_list")
    });
    if (isMobileSeller) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            slideItems: SlideItems,
            options: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, settingsStore, appendSettings),
            isMobileSeller: true
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        slideItems: SlideItems,
        options: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, settings, appendSettings)
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_5__.memo)(ProductPreview));


/***/ }),

/***/ 7060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30719);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87653);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_11__);
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 











// Import Swiper styles
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(_param) {
    var slideItems = _param.slideItems, options = _param.options, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "slideItems",
        "options"
    ]);
    var _isMobileSeller = restProps.isMobileSeller, isMobileSeller = _isMobileSeller === void 0 ? false : _isMobileSeller, _isBestProducts = restProps.isBestProducts, isBestProducts = _isBestProducts === void 0 ? false : _isBestProducts;
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleNext = function() {
        swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.current.swiper.slideNext();
    };
    var handlePrev = function() {
        swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.current.swiper.slidePrev();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, options), {
        ref: swiperRef,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileGroupProduct_block), isMobileSeller && (_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileProductSeller_block), isBestProducts && (_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileBestProdSeller_block)),
        children: [
            slideItems.length > 0 && slideItems.map(function(SlideItem) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                    children: SlideItem
                }, SlideItem.key);
            }),
            (options === null || options === void 0 ? void 0 : options.navigation) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default().customSwiper_prev), "swiper-button-prev"),
                        onClick: handlePrev,
                        children: options.navigation.prevEl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default().customSwiper_next), "swiper-button-next"),
                        onClick: handleNext,
                        children: options.navigation.nextEl
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 84722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38799);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25150);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* eslint-disable func-names */ 






var NewInputProduct = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, name = _param.name, searchInput = _param.searchInput, defaultValue = _param.defaultValue, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, value = _param.value, product = _param.product, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _onBlur = _param.onBlur, onBlur = _onBlur === void 0 ? function() {} : _onBlur, _onKeyDown = _param.onKeyDown, onKeyDown = _onKeyDown === void 0 ? function() {} : _onKeyDown, _onFocus = _param.onFocus, onFocus = _onFocus === void 0 ? function() {} : _onFocus, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "name",
        "searchInput",
        "defaultValue",
        "onChange",
        "value",
        "product",
        "disabled",
        "onBlur",
        "onKeyDown",
        "onFocus"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        type: "text",
        min: "0",
        step: "1",
        pattern: "\\d*",
        name: name,
        inputRef: searchInput,
        classes: {
            root: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().root_input), className),
            input: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().input),
            focused: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().focus)
        },
        disableUnderline: true,
        placeholder: "0",
        onChange: function(e) {
            return onChange(e, product);
        },
        onBlur: function(e) {
            return onBlur(e, product);
        },
        onKeyDown: function(e) {
            return onKeyDown(e, product);
        },
        value: value,
        defaultValue: defaultValue,
        disabled: disabled,
        onFocus: onFocus
    }, restProps));
});
/* harmony default export */ __webpack_exports__["Z"] = (NewInputProduct);


/***/ }),

/***/ 77378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96282);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);








var NewMinusButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, restProps), {
            classes: {
                root: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().buttons), (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_root_minus))
            },
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_minus), className),
            children: "-"
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (NewMinusButton);


/***/ }),

/***/ 661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96282);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);








var NewPlusButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, disabled = _param.disabled, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "disabled"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, restProps), {
            disabled: disabled,
            classes: {
                root: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().buttons), disabled ? ((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().plus_disabled), (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_plus)) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_plus), className)
            },
            children: "+"
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (NewPlusButton);


/***/ }),

/***/ 74330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports WISHLIST_IMAGE_INACTIVE, WISHLIST_IMAGE_ACTIVE */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Fab__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33758);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(868);
/* harmony import */ var _material_ui_icons_Favorite__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(76324);
/* harmony import */ var _material_ui_icons_FavoriteBorder__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(28106);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86010);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13270);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33436);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34588);
/* harmony import */ var zustand_lib_storeMobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35810);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76094);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_12__);

















var WISHLIST_IMAGE_INACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_5__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_ICON_1 */ .kvq,
        width: 18,
        height: 18
    });
});
var WISHLIST_IMAGE_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_5__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_ICON_4 */ .fPw,
        width: 18,
        height: 18
    });
});
var FavoriteButton = function(param) {
    var product = param.product, _isProductCard = param.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard;
    var isMobileV2 = (0,zustand_lib_storeMobile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.isMobileV2();
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isBookmarked = ref[0], setIsFavorite = ref[1];
    var ref1 = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useWishList */ .L4)(), getWishlistBySkus = ref1.getWishlistBySkus, handleDeleteProductWishlist = ref1.handleDeleteProductWishlist, handleUpdateWishlist = ref1.handleUpdateWishlist, loading = ref1.loading;
    var ref2 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common"), translateCommon = ref2.t;
    var loadData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getWishlistBySkus(product)
                        ];
                    case 1:
                        res = _state.sent();
                        setIsFavorite(res);
                        return [
                            2
                        ];
                }
            });
        });
        return function loadData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                    if (!loading) {
                        loadData();
                    }
                    return [
                        2
                    ];
                });
            });
            return _fetchData.apply(this, arguments);
        }
        fetchData();
    }, [
        loading
    ]);
    var handleUpdateFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(item) {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleUpdateWishlist(item)
                        ];
                    case 1:
                        res = _state.sent();
                        setIsFavorite(res);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdateFavorite(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(item) {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleDeleteProductWishlist(item)
                        ];
                    case 1:
                        res = _state.sent();
                        setIsFavorite(res);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteFavorite(item) {
            return _ref.apply(this, arguments);
        };
    }();
    if (isProductCard) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
            title: !isBookmarked ? translateCommon("btn.mark_wishlist_product") : translateCommon("btn.unmark_wishlist_product"),
            children: isBookmarked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().favorite_icon_wrapper), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().mobile_favorite_icon_wrapper), isMobileV2)),
                onClick: function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    handleDeleteFavorite(product);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WISHLIST_IMAGE_ACTIVE, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().favorite_icon)
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().favorite_icon_wrapper), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().mobile_favorite_icon_wrapper), isMobileV2)),
                onClick: function(e) {
                    e.stopPropagation();
                    handleUpdateFavorite(product);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WISHLIST_IMAGE_INACTIVE, {})
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
        title: !isBookmarked ? translateCommon("btn.mark_wishlist_product") : translateCommon("btn.unmark_wishlist_product"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Fab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().icon),
            size: "small",
            "aria-label": "like",
            onClick: function(e) {
                e.stopPropagation();
                if (isBookmarked) {
                    handleDeleteFavorite(product);
                } else {
                    handleUpdateFavorite(product);
                }
            },
            children: isBookmarked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Favorite__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                style: {
                    fontSize: 24
                },
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().like)
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_FavoriteBorder__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                style: {
                    fontSize: 24,
                    color: "#606060"
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (FavoriteButton);


/***/ }),

/***/ 92101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/FavoriteButton/index.js
var FavoriteButton = __webpack_require__(74330);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/TrendingDown.js
var TrendingDown = __webpack_require__(15527);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/TrendingUp.js
var TrendingUp = __webpack_require__(84618);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./src/components/mocules/PointOfProduct/index.js
var PointOfProduct = __webpack_require__(2337);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/ErrorCart/index.js
var ErrorCart = __webpack_require__(83084);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(46680);
// EXTERNAL MODULE: ./src/utils/FormatDate.js
var FormatDate = __webpack_require__(45901);
// EXTERNAL MODULE: ./src/utils/MonitorUtils.js + 1 modules
var MonitorUtils = __webpack_require__(79903);
// EXTERNAL MODULE: ./src/zustand-lib/useGetTagPromotion.js
var useGetTagPromotion = __webpack_require__(98300);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js + 2 modules
var useSellers = __webpack_require__(14626);
// EXTERNAL MODULE: ./src/components/mocules/index.js + 103 modules
var mocules = __webpack_require__(10565);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductCardContent/styles.module.css
var styles_module = __webpack_require__(41212);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductCardContent/index.js
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable camelcase */ 





























var ProductCardContent = function(param) {
    var _row = param.row, row = _row === void 0 ? false : _row, _product = param.product, product = _product === void 0 ? {} : _product, _isSellerList = param.isSellerList, isSellerList = _isSellerList === void 0 ? false : _isSellerList, _className = param.className, className = _className === void 0 ? "" : _className, _errorCode = param.errorCode, errorCode = _errorCode === void 0 ? null : _errorCode, _wishlist = param.wishlist, wishlist = _wishlist === void 0 ? false : _wishlist, _isCampaignPage = param.isCampaignPage, isCampaignPage = _isCampaignPage === void 0 ? false : _isCampaignPage, _translateCommon = param.translateCommon, translateCommon = _translateCommon === void 0 ? function() {} : _translateCommon, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2;
    var GetPrice = function GetPrice() {
        // BV-1586: giá sau ưu đãi (deal + chiết khấu thanh toán + voucher), giá gạch = giá niêm yết.
        // Card không có popover. Trang campaign đang che giá (???) thì giữ như cũ.
        if (isShowPriceAfterDiscount && !wishlist && !(isCampaign && !isHappeningCampaign && isCampaignPage)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 1,
                alignItems: "center",
                className: (0,clsx_m/* default */.Z)((styles_module_default()).displayPrice_wrapper),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            padding: "0",
                            width: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).display_price_mv2, isMobileV2)),
                            "data-test": "price-after-discount",
                            children: priceAfterDiscountFormated
                        })
                    }),
                    originPriceFormated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            padding: "0",
                            width: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).sale_price_mv2, isMobileV2)),
                            children: originPriceFormated
                        })
                    })
                ]
            });
        }
        // wishlist page v2
        if (wishlist) {
            // khuyến mãi
            if (isDeal && deal || isCampaign && percentDealSold < 100) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 1,
                        alignItems: "center",
                        className: (0,clsx_m/* default */.Z)((styles_module_default()).display_wishlist_price_wrapper),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    isContractPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractPrice, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)(isMobileV2 ? (styles_module_default()).discount_percent_v2 : (styles_module_default()).discount_percent, (0,_define_property/* default */.Z)({}, (styles_module_default()).hidden, discountPercent === 0)),
                                        children: "-".concat(discountPercent, "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, isMobileV2 && (styles_module_default()).fs_12, (0,_define_property/* default */.Z)({}, (styles_module_default()).hidden, salePriceFormated === displayPriceFormated)),
                                        children: salePriceFormated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                style: {
                                    padding: "0",
                                    width: "auto"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).fs_12, isMobileV2)),
                                    children: displayPriceFormated
                                })
                            })
                        ]
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: row ? (styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((styles_module_default()).price_wrapper, (styles_module_default()).price_wrapper_column),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        alignItems: "stretch",
                        className: (0,clsx_m/* default */.Z)((styles_module_default()).wishlist_price_wrapper),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                style: {
                                    paddingLeft: "0",
                                    width: "auto"
                                },
                                children: [
                                    isContractPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractPrice, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)((styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).display_price_mv2, isMobileV2)),
                                        children: displayPriceFormated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                children: [
                                    errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice > displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDown/* default */.Z, {
                                        className: (styles_module_default()).down
                                    }),
                                    errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice < displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingUp/* default */.Z, {
                                        className: (styles_module_default()).up
                                    })
                                ]
                            })
                        ]
                    }),
                    isDeal && deal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            width: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).sale_price_mv2, isMobileV2)),
                            children: salePriceFormated
                        })
                    })
                ]
            });
        }
        if (isSellerList) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).salePrice_wrapper,
                        children: [
                            isHappeningCampaign && salePrice && percentDealSold < 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            }),
                            !isHappeningCampaign && displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 2,
                        alignItems: "center",
                        className: (0,clsx_m/* default */.Z)((styles_module_default()).displayPrice_wrapper, (0,_define_property/* default */.Z)({}, (styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).display_price_mv2, isMobileV2)),
                                children: [
                                    ((productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold < 100 || !isHappeningCampaign && !isCampaignPage) && displayPriceFormated,
                                    (productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold === 100 && salePriceFormated
                                ]
                            })
                        })
                    })
                ]
            });
        }
        if (isCampaign && percentDealSold < 100) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 2,
                    alignItems: "center",
                    className: (0,clsx_m/* default */.Z)((styles_module_default()).displayPrice_wrapper),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).display_price_mv2, isMobileV2)),
                                children: [
                                    ((productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold < 100 || !isHappeningCampaign && !isCampaignPage) && displayPriceFormated,
                                    (productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold === 100 && salePriceFormated,
                                    !isHappeningCampaign && isCampaignPage && (sysconfig/* ENV_COUNTRY */.ng === "vn" ? "".concat(hidenPrice, "đ") : "$ ".concat(hidenPrice))
                                ]
                            })
                        }),
                        !isHappeningCampaign && isCampaignPage && displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        isHappeningCampaign && salePrice && percentDealSold < 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            })
                        })
                    ]
                })
            });
        // eslint-disable-next-line no-else-return
        } else if (isDeal && deal) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 1,
                    alignItems: "center",
                    className: (0,clsx_m/* default */.Z)((styles_module_default()).displayPrice_wrapper),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).display_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            })
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: row ? (styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((styles_module_default()).price_wrapper, (styles_module_default()).price_wrapper_column),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    alignItems: "stretch",
                    className: (0,clsx_m/* default */.Z)((styles_module_default()).displayPrice_wrapper),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                paddingLeft: "0",
                                width: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).display_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            children: [
                                errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice > displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDown/* default */.Z, {
                                    className: (styles_module_default()).down
                                }),
                                errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice < displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingUp/* default */.Z, {
                                    className: (styles_module_default()).up
                                })
                            ]
                        })
                    ]
                }),
                isDeal && deal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    style: {
                        width: "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)((styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (styles_module_default()).sale_price_mv2, isMobileV2)),
                        children: salePriceFormated
                    })
                })
            ]
        });
    };
    var router = (0,next_router.useRouter)();
    var getNameSeller = (0,context/* useSetting */.yu)().getNameSeller;
    var ref = (0,useGetTagPromotion/* default */.Z)(), dataByPromoListsDetail = ref.dataByPromoListsDetail, filterTagGift = ref.filterTagGift;
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var _name = product.name, name = _name === void 0 ? "" : _name, _isNew = product.isNew, isNew = _isNew === void 0 ? false : _isNew, _volume = product.volume, volume = _volume === void 0 ? "" : _volume, _point = product.point, point = _point === void 0 ? null : _point, _pointMultiplier = product.pointMultiplier, pointMultiplier = _pointMultiplier === void 0 ? null : _pointMultiplier, _tags = product.tags, tags = _tags === void 0 ? [] : _tags, _slug = product.slug, slug = _slug === void 0 ? "" : _slug, _seller = product.seller, seller = _seller === void 0 ? {} : _seller, _isDeal = product.isDeal, isDeal = _isDeal === void 0 ? null : _isDeal, _deal = product.deal, deal = _deal === void 0 ? null : _deal, _sellerCode = product.sellerCode, sellerCode = _sellerCode === void 0 ? "" : _sellerCode, _isGift = product.isGift, isGift = _isGift === void 0 ? false : _isGift, _sku = product.sku, sku = _sku === void 0 ? "" : _sku, tmp = product.skuId, productCode = tmp === void 0 ? "" : tmp, _salePrice = product.salePrice, salePrice = _salePrice === void 0 ? 0 : _salePrice, _displayPrice = product.displayPrice, displayPrice = _displayPrice === void 0 ? 0 : _displayPrice, _productType = product.productType, productType = _productType === void 0 ? "" : _productType, _isHappeningCampaign = product.isHappeningCampaign, isHappeningCampaign = _isHappeningCampaign === void 0 ? false : _isHappeningCampaign, _salePriceFormated = product.salePriceFormated, salePriceFormated = _salePriceFormated === void 0 ? "" : _salePriceFormated, _displayPriceFormated = product.displayPriceFormated, displayPriceFormated = _displayPriceFormated === void 0 ? "" : _displayPriceFormated, _percentDealSold = product.percentDealSold, percentDealSold = _percentDealSold === void 0 ? 0 : _percentDealSold, _isCampaign = product.isCampaign, isCampaign = _isCampaign === void 0 ? false : _isCampaign, _campaign = product.campaign, campaign = _campaign === void 0 ? {} : _campaign, _discountPercent = product.discountPercent, discountPercent = _discountPercent === void 0 ? 0 : _discountPercent, _isContractPrice = product.isContractPrice, isContractPrice = _isContractPrice === void 0 ? false : _isContractPrice, _currentPrice = product.currentPrice, currentPrice = _currentPrice === void 0 ? 0 : _currentPrice, _expiredDate = product.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate, status = product.status, _isShowPriceAfterDiscount = product.// BV-1586: field giá sau ưu đãi do WebService.convertProductV2 map từ BFF
    isShowPriceAfterDiscount, isShowPriceAfterDiscount = _isShowPriceAfterDiscount === void 0 ? false : _isShowPriceAfterDiscount, _priceAfterDiscountFormated = product.priceAfterDiscountFormated, priceAfterDiscountFormated = _priceAfterDiscountFormated === void 0 ? "" : _priceAfterDiscountFormated, _originPriceFormated = product.originPriceFormated, originPriceFormated = _originPriceFormated === void 0 ? "" : _originPriceFormated;
    var needHidePrice = status === "OUT_OF_STOCK" || status === "SUSPENDED";
    var ref1 = getNameSeller({
        seller: seller
    }) || {}, _isVip = ref1.isVip, isVip = _isVip === void 0 ? null : _isVip, _isStore = ref1.isStore, isStore = _isStore === void 0 ? false : _isStore;
    // productCardContent use productCode and productCardContentNew use skuId
    var isTagGift = filterTagGift(sku, dataByPromoListsDetail, productCode);
    var SellerVip = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (0,clsx_m/* default */.Z)(isTagGift ? (styles_module_default()).prioritizedGiftTag : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#B98F0F",
                        fontSize: "14px",
                        fontFamily: "googleSansMedium"
                    },
                    children: translateCommon(Enums/* FLAGSHIP_LABEL */.Yo)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        fontSize: "14px",
                        color: "#000"
                    },
                    children: " - "
                })
            ]
        });
    };
    var isTagGiftByPromotion = function() {
        return isTagGift ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (styles_module_default()).giftPromo,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        fontFamily: "ggsm"
                    },
                    children: translateCommon("gift_tag")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "black"
                    },
                    children: " - "
                })
            ]
        }) : "";
    };
    var hidenPrice = campaign === null || campaign === void 0 ? void 0 : campaign.salePriceLabel;
    if (isCampaign && (campaign === null || campaign === void 0 ? void 0 : campaign.isValid) === false) {
        var ref2, ref3, ref4;
        var lengthSalePriceLabel = campaign === null || campaign === void 0 ? void 0 : (ref2 = campaign.salePriceLabel) === null || ref2 === void 0 ? void 0 : ref2.length;
        if (lengthSalePriceLabel > 3) hidenPrice = "".concat(campaign === null || campaign === void 0 ? void 0 : (ref3 = campaign.salePriceLabel) === null || ref3 === void 0 ? void 0 : ref3.slice(0, lengthSalePriceLabel - 3), ".").concat(campaign === null || campaign === void 0 ? void 0 : (ref4 = campaign.salePriceLabel) === null || ref4 === void 0 ? void 0 : ref4.slice(lengthSalePriceLabel - 3));
    }
    var ContractPrice = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (styles_module_default()).contractLabel,
            children: translateCommon("contract_price")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(className, !isMobileV2 ? (styles_module_default()).product_content : (styles_module_default()).mobile_product_content, (0,_define_property/* default */.Z)({}, (styles_module_default()).product_content_column, !row)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).product_title_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).product_title,
                    children: isGift ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (isVip && isStore || (tags === null || tags === void 0 ? void 0 : tags.indexOf("DUREX")) >= 0 || (tags === null || tags === void 0 ? void 0 : tags.indexOf("SANOFI")) >= 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerVip, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).product_name, (styles_module_default()).giftlink, (0,_define_property/* default */.Z)({}, (styles_module_default()).product_name_mv2, isMobileV2)),
                                gutterBottom: true,
                                variant: "h5",
                                component: "h2",
                                children: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        style: {
                            lineHeight: "1.2"
                        },
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var sellerInfoData, _tmp, _tmp1, _tmp2, _tmp3;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = {};
                                        return [
                                            4,
                                            getSellerByCode((_tmp.code = sellerCode, _tmp.tags = tags, _tmp))
                                        ];
                                    case 1:
                                        sellerInfoData = _state.sent();
                                        _tmp1 = {};
                                        utils/* gtag.viewItemInPage */.SX.viewItemInPage((_tmp1.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                            sellerInfoData: sellerInfoData
                                        }), _tmp1.path = router.pathname, _tmp1));
                                        _tmp2 = {};
                                        _tmp3 = {};
                                        MonitorUtils/* default.sendSKUEvent */.ZP.sendSKUEvent(Enums/* MONITORING_COLLECTOR_TYPE.SKU_DETAIL_VIEW */.Hq.SKU_DETAIL_VIEW, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, product), (_tmp3.sellerInfoData = sellerInfoData, _tmp3)), router.pathname);
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: [
                            isNew && !isVip && !isTagGift && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "".concat(Paths/* PRODUCTS_LOADING_URL */.iB, "?tag=").concat(sysconfig/* TAG_NEW */.cC),
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (styles_module_default()).new_tag,
                                            children: [
                                                translateCommon("text_new"),
                                                " "
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (styles_module_default()).dash_tag,
                                            children: " - "
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    (isVip && isStore || (tags === null || tags === void 0 ? void 0 : tags.indexOf("DUREX")) >= 0 || (tags === null || tags === void 0 ? void 0 : tags.indexOf("SANOFI")) >= 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerVip, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                        href: "/product/".concat(slug || "", "/loading"),
                                        prefetch: false,
                                        style: {
                                            padding: "0",
                                            display: "inline"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                            title: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (0,clsx_m/* default */.Z)((styles_module_default()).product_name, (0,_define_property/* default */.Z)({}, (styles_module_default()).product_name_mv2, isMobileV2)),
                                                children: [
                                                    isTagGiftByPromotion(),
                                                    " ",
                                                    isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            !needHidePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (styles_module_default()).wishlist_price : (styles_module_default()).mobile_wishlist_price),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetPrice, {})
            }),
            expiredDate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: expiredDate,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    component: "p",
                    className: (styles_module_default()).product_expiredDate,
                    children: [
                        translateCommon("expire"),
                        ": ",
                        (0,FormatDate/* formatDate3 */.T6)(expiredDate, true)
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                component: "p",
                className: (styles_module_default()).product_expiredDate
            }),
            volume ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: volume,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (styles_module_default()).product_volume,
                    variant: "body2",
                    component: "p",
                    children: volume
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (styles_module_default()).product_volume,
                variant: "body2",
                component: "p"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).seller_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules/* SellerInfo */.Nq, {
                    seller: seller,
                    tags: tags,
                    isProductCard: true
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_ProductCardContent = (ProductCardContent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardActions/CardActions.js
var CardActions = __webpack_require__(51907);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./src/clients/index.js + 21 modules
var clients = __webpack_require__(38169);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/atoms/NewInputProduct/index.js
var NewInputProduct = __webpack_require__(84722);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/atoms/QuantityButton/NewMinusButton.js
var NewMinusButton = __webpack_require__(77378);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/atoms/QuantityButton/NewPlusButton.js
var NewPlusButton = __webpack_require__(661);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(33681);
// EXTERNAL MODULE: ./src/components-v2/mocules/mobile/CountdownTimer/index.js
var CountdownTimer = __webpack_require__(17368);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/mocules/CountdownTimer/index.js
var mocules_CountdownTimer = __webpack_require__(72640);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/DealSection/styles.module.css
var DealSection_styles_module = __webpack_require__(12954);
var DealSection_styles_module_default = /*#__PURE__*/__webpack_require__.n(DealSection_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/DealSection/index.js












var DealSection = function(param) {
    var dealEndDay = param.dealEndDay, dealReady = param.dealReady, dealStartTime = param.dealStartTime, _totalSold = param.totalSold, totalSold = _totalSold === void 0 ? 0 : _totalSold, _isHappeningCampaign = param.isHappeningCampaign, isHappeningCampaign = _isHappeningCampaign === void 0 ? false : _isHappeningCampaign, _percentDealSold = param.percentDealSold, percentDealSold = _percentDealSold === void 0 ? 0 : _percentDealSold;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var startDate = (0,FormatDate/* formatDate */.p6)(dealStartTime);
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        container: true,
        className: (0,clsx_m/* default */.Z)((DealSection_styles_module_default()).deal_section, (0,_define_property/* default */.Z)({}, (DealSection_styles_module_default()).deal_section_mv2, isMobileV2)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                // eslint-disable-next-line no-nested-ternary
                className: (0,clsx_m/* default */.Z)((DealSection_styles_module_default()).process_wrapper, (0,_define_property/* default */.Z)({}, (DealSection_styles_module_default()).process_wrapper_mv2, isMobileV2)),
                children: isHappeningCampaign && dealReady && percentDealSold === 100 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
                            classes: {
                                root: (0,clsx_m/* default */.Z)((DealSection_styles_module_default()).root_process, isMobileV2 && (DealSection_styles_module_default()).root_process_mv2),
                                barColorPrimary: (DealSection_styles_module_default()).bar_background,
                                colorPrimary: (DealSection_styles_module_default()).blur_background
                            },
                            variant: "determinate",
                            value: percentDealSold
                        }),
                        !isHappeningCampaign && dealReady && percentDealSold === 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (DealSection_styles_module_default()).process_content,
                            children: translateCommon("deal.sold_out")
                        }),
                        dealReady && percentDealSold < 75 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (DealSection_styles_module_default()).process_content,
                            children: "".concat(translateCommon("deal.sold"), ": ").concat(totalSold)
                        }),
                        !dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (DealSection_styles_module_default()).process_content,
                            children: translateCommon("deal.on_sale_soon")
                        }),
                        dealReady && percentDealSold >= 75 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (DealSection_styles_module_default()).process_content,
                            children: translateCommon("deal.out_of_stock_soon")
                        })
                    ]
                })
            }),
            isHappeningCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) || dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                className: (DealSection_styles_module_default()).count_down_container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)(isMobileV2 && (DealSection_styles_module_default()).countdown_timer_mv2),
                    item: true,
                    children: isMobileV2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTimer/* default */.Z, {
                        translateCommon: translateCommon,
                        className: (DealSection_styles_module_default()).count_down,
                        dealEndDay: dealEndDay
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CountdownTimer/* default */.Z, {
                        translateCommon: translateCommon,
                        className: (DealSection_styles_module_default()).count_down,
                        dealEndDay: dealEndDay
                    })
                })
            }) || !dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                className: (0,clsx_m/* default */.Z)((DealSection_styles_module_default()).startDate, (0,_define_property/* default */.Z)({}, (DealSection_styles_module_default()).startDate_mv2, isMobileV2)),
                children: startDate
            })
        ]
    });
};
/* harmony default export */ var mocules_DealSection = (DealSection);

// EXTERNAL MODULE: ./src/components/organisms/RemoveProductModal/index.js + 1 modules
var RemoveProductModal = __webpack_require__(39796);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/hooks/useModal.js
var useModal = __webpack_require__(16028);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductCardInput/styles.module.css
var ProductCardInput_styles_module = __webpack_require__(53267);
var ProductCardInput_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCardInput_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductCardInput/index.js
/* eslint-disable no-nested-ternary */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable no-else-return */ 




































var ProductCardInput = function(param) {
    var productMaxQuantity = param.maxQuantity, noSupportDelivery = param.not_support_delivery, _salePrice = param.salePrice, salePrice = _salePrice === void 0 ? 0 : _salePrice, _displayPrice = param.displayPrice, displayPrice = _displayPrice === void 0 ? 0 : _displayPrice, _isDeal = param.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = param.deal, deal = _deal === void 0 ? {} : _deal, row = param.row, type = param.type, searchInput = param.searchInput, cart = param.cart, productId = param.productId, name = param.name, product = param.product, isMobile = param.isMobile, scrollTo = param.scrollTo, _errorCode = param.errorCode, errorCode = _errorCode === void 0 ? null : _errorCode, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? null : _errorMessage, status = param.status, _errorMessageProduct = param.errorMessageProduct, errorMessageProduct = _errorMessageProduct === void 0 ? null : _errorMessageProduct, index = param.index, currentPrice = param.currentPrice, _wishlist = param.wishlist, wishlist = _wishlist === void 0 ? false : _wishlist, handleDelete = param.handleDelete, _isCampaign = param.// unit,
    isCampaign, isCampaign = _isCampaign === void 0 ? false : _isCampaign, productType = param.productType, _isHappeningCampaign = param.isHappeningCampaign, isHappeningCampaign = _isHappeningCampaign === void 0 ? false : _isHappeningCampaign, campaign = param.campaign, availableProducts = param.availableProducts, salePriceFormated = param.salePriceFormated, displayPriceFormated = param.displayPriceFormated, _isSellerList = param.isSellerList, isSellerList = _isSellerList === void 0 ? false : _isSellerList, _isHalfProgress = param.isHalfProgress, isHalfProgress = _isHalfProgress === void 0 ? false : _isHalfProgress, _percentDealSold = param.percentDealSold, percentDealSold = _percentDealSold === void 0 ? 0 : _percentDealSold, _isCampaignPage = param.isCampaignPage, isCampaignPage = _isCampaignPage === void 0 ? false : _isCampaignPage, messageLimitOrder = param.messageLimitOrder, sku = param.sku, _discountPercent = param.discountPercent, discountPercent = _discountPercent === void 0 ? 0 : _discountPercent, isContractPrice = param.isContractPrice, _isDisplayPrice = param.isDisplayPrice, isDisplayPrice = _isDisplayPrice === void 0 ? false : _isDisplayPrice;
    var GetPrice = function GetPrice() {
        // wishlist page v2
        if (wishlist) {
            // khuyến mãi
            if (isDeal && deal || isCampaign && percentDealSold < 100) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 1,
                        alignItems: "center",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_wishlist_price_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    isContractPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractPrice, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).discount_percent_v2 : (ProductCardInput_styles_module_default()).discount_percent, discountPercent === 0 && (ProductCardInput_styles_module_default()).hidden),
                                        children: "-".concat(discountPercent, "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, isMobile && (ProductCardInput_styles_module_default()).fs_12, salePriceFormated === displayPriceFormated && (ProductCardInput_styles_module_default()).hidden),
                                        children: salePriceFormated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                style: {
                                    padding: "0",
                                    width: isMobile && !beta ? "100%" : "auto"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, isMobile && (ProductCardInput_styles_module_default()).fs_12),
                                    children: displayPriceFormated
                                })
                            })
                        ]
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        alignItems: "stretch",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).wishlist_price_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2), !isMobile && (ProductCardInput_styles_module_default()).pt_55),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                style: {
                                    paddingLeft: "0",
                                    width: isMobile && !beta ? "100%" : "auto"
                                },
                                children: [
                                    isContractPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractPrice, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                        children: displayPriceFormated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                children: [
                                    errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice > displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDown/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).down
                                    }),
                                    errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice < displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingUp/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).up
                                    })
                                ]
                            })
                        ]
                    }),
                    isDeal && deal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            width: isMobile && !beta ? "100%" : "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                            children: salePriceFormated
                        })
                    })
                ]
            });
        }
        if (isSellerList) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCardInput_styles_module_default()).salePrice_wrapper,
                        children: [
                            isHappeningCampaign && salePrice && percentDealSold < 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            }),
                            !isHappeningCampaign && displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 2,
                        alignItems: "center",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: [
                                    ((productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold < 100 || !isHappeningCampaign && !isCampaignPage) && displayPriceFormated,
                                    (productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold === 100 && salePriceFormated
                                ]
                            })
                        })
                    })
                ]
            });
        }
        if (isCampaign && percentDealSold < 100) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 2,
                    alignItems: "center",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: [
                                    ((productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold < 100 || !isHappeningCampaign && !isCampaignPage) && displayPriceFormated,
                                    (productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold === 100 && salePriceFormated,
                                    !isHappeningCampaign && isCampaignPage && (sysconfig/* ENV_COUNTRY */.ng === "vn" ? "".concat(hidenPrice, "đ") : "$ ".concat(hidenPrice))
                                ]
                            })
                        }),
                        !isHappeningCampaign && isCampaignPage && displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        isHappeningCampaign && salePrice && percentDealSold < 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            })
                        })
                    ]
                })
            });
        } else if (isDeal && deal) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 1,
                    alignItems: "center",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            })
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    alignItems: "stretch",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2), wishlist && (ProductCardInput_styles_module_default()).pt_55),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                paddingLeft: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            children: [
                                errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice > displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDown/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).down
                                }),
                                errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice < displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingUp/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).up
                                })
                            ]
                        })
                    ]
                }),
                isDeal && deal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    style: {
                        width: isMobile && !beta ? "100%" : "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                        children: salePriceFormated
                    })
                })
            ]
        });
    };
    var OrderMaximumProduct = function OrderMaximumProduct() {
        if (isCampaign && isHappeningCampaign && percentDealSold < 100 || isCampaign && productType === "MEGA_DAY" && isHappeningCampaign && percentDealSold < 100) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc)
            });
        } else if (isHappeningCampaign && percentDealSold === 100 && isCampaignPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (ProductCardInput_styles_module_default()).text_danger,
                children: translateCommon("product_card.missed_promo_price").replace("{displayPrice}", (0,FormatNumber/* formatCurrency */.xG)(campaign === null || campaign === void 0 ? void 0 : campaign.retailPriceValue) || "")
            });
        } else if (isHappeningCampaign && productType === "NORMAL" && percentDealSold === 100 && isCampaignPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (ProductCardInput_styles_module_default()).text_danger,
                children: translateCommon("product_card.missed_promo_price").replace("{displayPrice}", (0,FormatNumber/* formatCurrency */.xG)(displayPrice) || "")
            });
        } else if (messageLimitOrder) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc),
                children: messageLimitOrder
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ProductCardInput_styles_module_default()).text_danger,
            children: " "
        });
    };
    var ref, ref1, ref2;
    var ref3 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref3.t;
    var ref4 = (0,context/* useCart */.jD)(), updateCartItem = ref4.updateCartItem, removeCartItem = ref4.removeCartItem, mapQuantity = ref4.mapQuantity, validate200Item = ref4.validate200Item, cartItems = ref4.cartItems;
    var ref5 = (0,context/* useAuth */.aC)(), isAuthenticated = ref5.isAuthenticated, toggleLogin = ref5.toggleLogin;
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    var ref6 = (0,context/* useProduct */.iB)(), getInfoProductPerDay = ref6.getInfoProductPerDay, getProductError = ref6.getProductError;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(), 2), isShowModalRemove = ref7[0], toggleRemove = ref7[1];
    var ref8 = (0,react.useState)(false), isFocus = ref8[0], setIsFocus = ref8[1];
    var inputElement = Object.values(searchInput.current)[0];
    var ref9 = (0,react.useState)(product.quantity || 0), value = ref9[0], setValue = ref9[1];
    (0,react.useEffect)(function() {
        var quantity = mapQuantity.get(sku);
        if (quantity && inputElement) {
            inputElement.value = quantity;
        }
    }, [
        cartItems,
        inputElement
    ]);
    var ref10 = campaign || {}, _soldQuantity = ref10.soldQuantity, soldQuantity = _soldQuantity === void 0 ? 0 : _soldQuantity;
    var maxQuantityProduct = isCampaign && availableProducts || isDeal && availableProducts || productMaxQuantity;
    var percentDeal = ((deal === null || deal === void 0 ? void 0 : deal.quantity) || 0) / (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) * 100;
    var outOfStock = (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) === ((deal === null || deal === void 0 ? void 0 : deal.quantity) || 0) || false;
    var timeLeft = (0,utils/* calculateTimeLeft */.VZ)(deal === null || deal === void 0 ? void 0 : deal.startTime) || (0,utils/* calculateTimeLeft */.VZ)(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.campaign) === null || ref === void 0 ? void 0 : ref.startTime) || {};
    var dealReady = Object.keys(timeLeft).length === 0 || false;
    var outOfDate = deal && deal.endTime && new Date(deal.endTime) < new Date() || false;
    var importantList = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
        return item.isSelected && item.isImportant;
    });
    var historyBySku = getInfoProductPerDay();
    var ref11 = getProductError({
        product: product
    }), _errorRequiredCertificate = ref11.errorRequiredCertificate, errorRequiredCertificate = _errorRequiredCertificate === void 0 ? false : _errorRequiredCertificate, errorRequiredCertificateMessage = ref11.errorRequiredCertificateMessage;
    var canDeleteProduct = function() {
        var quantityAfterDel = cartItems.length - 1;
        var importantQuantity = importantList.length;
        var importantQuantityMax = Math.floor(quantityAfterDel * data/* IMPORTANT_PERCENT_MAX */.en);
        if (product.isImportant) importantQuantity -= 1;
        return !(importantQuantity > importantQuantityMax);
    };
    var updateCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(q) {
            var isReload, response, _tmp, ref, tmp, quantityResponse, _tmp1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        if (!q) {
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            updateCartItem((_tmp.product = product, _tmp.q = parseFloat(q), _tmp), isReload, cart)
                        ];
                    case 1:
                        response = _state.sent();
                        _tmp1 = {};
                        if ((0,clients/* isValid */.JY)(response)) {
                            ref = (0,clients/* getFirst */.Xi)(response, _tmp1), tmp = ref.quantity, quantityResponse = tmp === void 0 ? null : tmp;
                            if (quantityResponse !== null) {
                                setValue(quantityResponse);
                            }
                        } else {
                            setValue(0);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function updateCart(q) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!cart) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            removeCartItem(product, true)
                        ];
                    case 1:
                        _state.sent();
                        inputElement.value = 0;
                        setValue(0);
                        toggleRemove();
                        return [
                            2
                        ];
                    case 2:
                        if (!canDeleteProduct()) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            removeCartItem(product, cart)
                        ];
                    case 3:
                        _state.sent();
                        inputElement.value = 0;
                        setValue(0);
                        scrollTo(window.pageYOffset);
                        return [
                            2
                        ];
                    case 4:
                        toggleRemove();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemove() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancle = function() {
        toggleRemove();
        inputElement.value = value;
        if (value === 0) {
            updateCart(1);
            setValue(1);
        }
    };
    var handleCart = function(val, updateType) {
        if (updateType === "remove") {
            toggleRemove();
        }
        if (updateType === "update") {
            updateCart(val);
        }
    };
    var handleClickInput = function(e) {
        e.stopPropagation();
    };
    var handler = (0,react.useCallback)(function(val, updateType) {
        if (isMobile) {
            (0,debounce/* debounceFunc1000 */.zB)(function() {
                return handleCart(val, updateType);
            });
        } else {
            (0,debounce/* debounceFunc400 */.EI)(function() {
                return handleCart(val, updateType);
            });
        }
    }, []);
    var handleDecrease = function(e) {
        e.stopPropagation();
        if (inputElement.value < 1) return;
        var q = parseInt(inputElement.value, 10) - 1;
        if (q < 1) {
            handler(product, "remove");
            return;
        }
        inputElement.value = q;
        setValue(q);
        handler(q, "update");
    };
    var handleIncrease = function(e) {
        e.stopPropagation();
        if (validate200Item(product === null || product === void 0 ? void 0 : product.sku)) {
            var q = parseInt(inputElement.value, 10) + 1;
            inputElement.value = q;
            setValue(q);
            handler(q, "update");
        }
    };
    var handleInputChange = function(e) {
        try {
            var ref;
            var val = e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.value.replace(/[^\d]/g, "");
            // eslint-disable-next-line no-param-reassign
            searchInput.current[index].parentNode.className = "MuiInputBase-root MuiInput-root ".concat((0,clsx_m/* default */.Z)(val > 0 && (ProductCardInput_styles_module_default()).has_item, (ProductCardInput_styles_module_default()).root_input), " ").concat((ProductCardInput_styles_module_default())["card_input_pl_".concat(Math.min(maxQuantityProduct, val).toString().length)] || (ProductCardInput_styles_module_default()).card_input);
            Object.values(searchInput.current)[0].value = Math.min(maxQuantityProduct, val);
        } catch (error) {
            console.error("Error : ", error);
        }
    };
    var handleOnBlur = function(e) {
        setIsFocus(false);
        if (validate200Item(product === null || product === void 0 ? void 0 : product.sku)) {
            var ref;
            var val = (e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.value) || value;
            if (/^\d+$/.test(val) && +val >= 0) {
                var curValue = parseFloat(val || 0);
                curValue = Math.min(maxQuantityProduct, curValue);
                if (curValue === value) return;
                // nếu value là 0 thì sẽ remove && quanity trong cartItems
                // TODO: nếu onblur 0 , rồi nhấn vào nút - cho kế bên
                if (curValue === 0 && (mapQuantity === null || mapQuantity === void 0 ? void 0 : mapQuantity.get(product === null || product === void 0 ? void 0 : product.sku)) > 0) {
                    handler(product, "remove");
                    return;
                }
                setValue(curValue);
                if (curValue || curValue !== 0) handler(+curValue, "update");
            }
        } else {
            setValue(0);
            Object.values(searchInput.current)[0].value = 0;
        }
    };
    var handleOnKeyDown = function(e) {
        var positionEl = Number(Object.keys(searchInput.current)[0]);
        var inputs = document === null || document === void 0 ? void 0 : document.querySelectorAll("[class*='product_action'] input");
        if (e.keyCode === 13) {
            var ref;
            handleOnBlur(e);
            (ref = (inputs === null || inputs === void 0 ? void 0 : inputs[positionEl]) || (inputs === null || inputs === void 0 ? void 0 : inputs[positionEl + 1])) === null || ref === void 0 ? void 0 : ref.focus();
        }
        if (e.keyCode === 9) {
            var ref1;
            e.preventDefault();
            inputs === null || inputs === void 0 ? void 0 : (ref1 = inputs[positionEl + 1]) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    var checkProductAvailable = function() {
        return status === "OUT_OF_STOCK" || status === "SUSPENDED" || outOfStock || outOfDate;
    };
    if (errorMessageProduct || !product.salePrice || product.status === "STOP_SELLING" || product.salePrice === 0) {
        if (wishlist) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: isMobile ? (ProductCardInput_styles_module_default()).wishlist_err_wrapper_mobile : (ProductCardInput_styles_module_default()).wishlist_err_wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: row ? (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).text_center) : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_danger),
                        children: errorMessageProduct && translateCommon("product_error.".concat(errorMessageProduct)) || errorMessage || translateCommon("productStatus.STOP_SELLING")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).btn_del_m_wrapper : (ProductCardInput_styles_module_default()).product_action_column, !isMobile && (ProductCardInput_styles_module_default()).p_0),
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (ProductCardInput_styles_module_default()).btn_del_text,
                            onClick: handleDelete,
                            children: translateCommon("btn.delete")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                            title: translateCommon("cardBuy.remove_wishlist"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).remove_icon,
                                onClick: handleDelete,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                    className: (ProductCardInput_styles_module_default()).icon
                                })
                            })
                        })
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: row ? (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).text_center, (ProductCardInput_styles_module_default()).text_padding) : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_danger),
                    children: errorMessageProduct && translateCommon("product_error.".concat(errorMessageProduct)) || errorMessage || translateCommon("productStatus.STOP_SELLING")
                })
            ]
        });
    }
    var hidenPrice = campaign === null || campaign === void 0 ? void 0 : campaign.salePriceLabel;
    if (isCampaign && (campaign === null || campaign === void 0 ? void 0 : campaign.isValid) === false) {
        var ref12, ref13, ref14;
        var lengthSalePriceLabel = campaign === null || campaign === void 0 ? void 0 : (ref12 = campaign.salePriceLabel) === null || ref12 === void 0 ? void 0 : ref12.length;
        if (lengthSalePriceLabel > 3) hidenPrice = "".concat(campaign === null || campaign === void 0 ? void 0 : (ref13 = campaign.salePriceLabel) === null || ref13 === void 0 ? void 0 : ref13.slice(0, lengthSalePriceLabel - 3), ".").concat(campaign === null || campaign === void 0 ? void 0 : (ref14 = campaign.salePriceLabel) === null || ref14 === void 0 ? void 0 : ref14.slice(lengthSalePriceLabel - 3));
    }
    var ContractPrice = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (ProductCardInput_styles_module_default()).contractLabel,
            children: translateCommon("contract_price")
        });
    };
    var checkAndRenderQuantityProduct = function() {
        var text = "";
        historyBySku === null || historyBySku === void 0 ? void 0 : historyBySku.forEach(function(item) {
            if ((item === null || item === void 0 ? void 0 : item.sku) === sku) {
                // text = item?.quantity > 0 && `Bạn đã mua ${formatNumber(item?.quantity)} / ${formatNumber(item?.limitQuantity)} sản phẩm trong ngày`;
                text = (item === null || item === void 0 ? void 0 : item.quantity) > 0 && "".concat(translateCommon("product_card").replace("{quantity}", (0,FormatNumber/* formatNumber */.uf)(item === null || item === void 0 ? void 0 : item.quantity)).replace("{limitQuantity}", (0,FormatNumber/* formatNumber */.uf)(item === null || item === void 0 ? void 0 : item.limitQuantity)));
            }
            if ((item === null || item === void 0 ? void 0 : item.quantity) > (item === null || item === void 0 ? void 0 : item.limitQuantity)) {
                text = "";
            }
        });
        return text;
    };
    var handleOnFocus = function(e) {
        e.preventDefault();
        setIsFocus(true);
    };
    // wishlist page v2
    if (wishlist) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).card_wishlist_mobile_wrapper : (ProductCardInput_styles_module_default()).card_wishlist_wrapper),
            children: [
                errorRequiredCertificate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                marginBottom: ""
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        marginBottom: ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    style: {
                                        textAlign: "center"
                                    },
                                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger),
                                    children: errorRequiredCertificateMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                            title: translateCommon("cardBuy.remove_wishlist"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).remove_icon,
                                onClick: handleDelete,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                    className: (ProductCardInput_styles_module_default()).icon
                                })
                            })
                        })
                    ]
                }) : noSupportDelivery ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginBottom: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                marginBottom: "16px"
                            },
                            className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).deal_price,
                                children: (0,FormatNumber/* formatCurrency */.xG)(salePrice)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            style: {
                                textAlign: "center"
                            },
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).center),
                            children: translateCommon("product_card.not_supporting_province")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProductCardInput_styles_module_default()).wishlist_input_container,
                    children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !isSellerList && errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: row ? (ProductCardInput_styles_module_default()).text_danger : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_change_price, (ProductCardInput_styles_module_default()).text_danger),
                                children: [
                                    translateCommon("cardBuy.product_change_price_Old_price"),
                                    " ",
                                    (0,FormatNumber/* formatCurrency */.xG)(currentPrice)
                                ]
                            }),
                            messageLimitOrder && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).text_desc_wishlist,
                                children: messageLimitOrder
                            }),
                            checkAndRenderQuantityProduct() && !isMobile(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).text_quantity_wishlist,
                                children: checkAndRenderQuantityProduct()
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).wishlist_price, isMobile && (ProductCardInput_styles_module_default()).ml_10),
                                children: isDisplayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetPrice, {})
                            }),
                            isDeal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: !dealReady,
                                                onClick: handleDecrease,
                                                className: (ProductCardInput_styles_module_default()).minus_btn
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onBlur: handleOnBlur,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                onClick: handleClickInput,
                                                onKeyDown: handleOnKeyDown,
                                                type: type,
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, (ProductCardInput_styles_module_default())["card_input_pl_".concat(value.length)] || (ProductCardInput_styles_module_default()).card_input),
                                                disabled: checkProductAvailable() || !dealReady,
                                                onFocus: handleOnFocus,
                                                startAdornment: // eslint-disable-next-line react/jsx-wrap-multilines
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                    position: "start",
                                                    className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCardInput_styles_module_default()).cart_icon : (ProductCardInput_styles_module_default()).mobile_cart_icon),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                        src: "/images/icon/cart.svg",
                                                        alt: "cart",
                                                        width: 18,
                                                        height: 18,
                                                        className: (0,clsx_m/* default */.Z)(!isMobileV2 && (ProductCardInput_styles_module_default()).cart_img),
                                                        q: 100
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || !dealReady || maxQuantityProduct && value >= maxQuantityProduct,
                                                onClick: function(e) {
                                                    return handleIncrease(e);
                                                },
                                                className: (ProductCardInput_styles_module_default()).plus_btn
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }) || isCampaign && availableProducts > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: !dealReady,
                                                onClick: handleDecrease,
                                                className: (ProductCardInput_styles_module_default()).minus_btn
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onClick: handleClickInput,
                                                onBlur: handleOnBlur,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                onKeyDown: handleOnKeyDown,
                                                type: type,
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, (ProductCardInput_styles_module_default()).card_input),
                                                disabled: checkProductAvailable() || !dealReady,
                                                onFocus: handleOnFocus,
                                                startAdornment: // eslint-disable-next-line react/jsx-wrap-multilines
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                    position: "start",
                                                    className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCardInput_styles_module_default()).cart_icon : (ProductCardInput_styles_module_default()).mobile_cart_icon),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                        src: "/images/icon/cart.svg",
                                                        alt: "cart",
                                                        width: 18,
                                                        height: 18,
                                                        className: (0,clsx_m/* default */.Z)(!isMobileV2 && (ProductCardInput_styles_module_default()).cart_img),
                                                        q: 100
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || !dealReady || availableProducts && value >= availableProducts,
                                                onClick: function() {
                                                    return handleIncrease();
                                                },
                                                className: (ProductCardInput_styles_module_default()).plus_btn
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: checkProductAvailable(),
                                                onClick: handleDecrease,
                                                className: (ProductCardInput_styles_module_default()).minus_btn
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onBlur: handleOnBlur,
                                                onKeyDown: handleOnKeyDown,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, (ProductCardInput_styles_module_default()).card_input),
                                                disabled: checkProductAvailable(),
                                                onFocus: handleOnFocus,
                                                startAdornment: // eslint-disable-next-line react/jsx-wrap-multilines
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                    position: "start",
                                                    className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCardInput_styles_module_default()).cart_icon : (ProductCardInput_styles_module_default()).mobile_cart_icon),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                        src: "/images/icon/cart.svg",
                                                        alt: "cart",
                                                        width: 18,
                                                        height: 18,
                                                        className: (0,clsx_m/* default */.Z)(!isMobileV2 && (ProductCardInput_styles_module_default()).cart_img),
                                                        q: 100
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || maxQuantityProduct && value >= maxQuantityProduct,
                                                onClick: function(e) {
                                                    return handleIncrease(e);
                                                },
                                                className: (ProductCardInput_styles_module_default()).plus_btn
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }),
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductCardInput_styles_module_default()).btn_del_m_wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).btn_del_text,
                                    onClick: handleDelete,
                                    children: translateCommon("btn.delete")
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                title: translateCommon("cardBuy.remove_wishlist"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).remove_icon,
                                    onClick: handleDelete,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                        className: (ProductCardInput_styles_module_default()).icon
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardInput_styles_module_default()).view_signin_btn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            color: "#fff",
                            backgroundColor: "#005C29",
                            className: (ProductCardInput_styles_module_default()).signin_btn,
                            onClick: toggleLogin,
                            children: translateCommon("cardBuy.login_to_see_prices")
                        })
                    })
                }),
                isShowModalRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                    product: product,
                    visible: isShowModalRemove,
                    onClose: handleCancle,
                    onRemove: handleRemove
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).card_wrapper, isMobileV2 && (ProductCardInput_styles_module_default()).card_wrapper_mv2),
        children: [
            !isSellerList && isHalfProgress && (isDeal || isDeal && isHappeningCampaign && percentDealSold === 100) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductCardInput_styles_module_default()).deal_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_DealSection, {
                    dealStartTime: deal === null || deal === void 0 ? void 0 : deal.startTime,
                    dealEndDay: deal === null || deal === void 0 ? void 0 : deal.endTime,
                    dealReady: dealReady,
                    maxQuantity: deal === null || deal === void 0 ? void 0 : deal.maxQuantity,
                    totalSold: (deal === null || deal === void 0 ? void 0 : deal.quantity) || 0,
                    percentDealSold: percentDeal || 0
                })
            }),
            noSupportDelivery ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginBottom: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginBottom: "16px"
                        },
                        className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (ProductCardInput_styles_module_default()).deal_price,
                            children: (0,FormatNumber/* formatCurrency */.xG)(salePrice)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        style: {
                            textAlign: "center"
                        },
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).center),
                        children: translateCommon("product_card.not_supporting_province")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isSellerList && errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).text_danger : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_change_price, (ProductCardInput_styles_module_default()).text_danger),
                            children: [
                                translateCommon("cardBuy.product_change_price_Old_price"),
                                " ",
                                (0,FormatNumber/* formatCurrency */.xG)(currentPrice)
                            ]
                        }),
                        !isSellerList && (isHappeningCampaign && percentDealSold < 100 || isHappeningCampaign && isDeal && availableProducts > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProductCardInput_styles_module_default()).campaign_deal_container,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_DealSection, {
                                dealReady: productType === "NORMAL" ? dealReady : isHappeningCampaign,
                                isHappeningCampaign: isHappeningCampaign,
                                dealStartTime: campaign === null || campaign === void 0 ? void 0 : (ref1 = campaign.campaign) === null || ref1 === void 0 ? void 0 : ref1.startTime,
                                dealEndDay: campaign === null || campaign === void 0 ? void 0 : (ref2 = campaign.campaign) === null || ref2 === void 0 ? void 0 : ref2.endTime,
                                totalSold: soldQuantity || 0,
                                percentDealSold: percentDealSold
                            })
                        }),
                        isDisplayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetPrice, {}),
                        !isSellerList && (isDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: !dealReady,
                                        onClick: handleDecrease,
                                        className: (ProductCardInput_styles_module_default()).minus_btn
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        onClick: handleClickInput,
                                        onKeyDown: handleOnKeyDown,
                                        type: type,
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, (ProductCardInput_styles_module_default()).card_input),
                                        disabled: checkProductAvailable() || !dealReady,
                                        onFocus: handleOnFocus,
                                        startAdornment: // eslint-disable-next-line react/jsx-wrap-multilines
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "start",
                                            className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCardInput_styles_module_default()).cart_icon : (ProductCardInput_styles_module_default()).mobile_cart_icon),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                src: "/images/icon/cart.svg",
                                                alt: "cart",
                                                width: 18,
                                                height: 18,
                                                className: (0,clsx_m/* default */.Z)(!isMobileV2 && (ProductCardInput_styles_module_default()).cart_img),
                                                q: 100
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || !dealReady || maxQuantityProduct && value >= maxQuantityProduct,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: (ProductCardInput_styles_module_default()).plus_btn
                                    })
                                ]
                            })
                        }) || isCampaign && availableProducts > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: !dealReady,
                                        onClick: handleDecrease,
                                        className: (ProductCardInput_styles_module_default()).minus_btn
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        onClick: handleClickInput,
                                        onKeyDown: handleOnKeyDown,
                                        type: type,
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, (ProductCardInput_styles_module_default()).card_input),
                                        disabled: checkProductAvailable() || !dealReady,
                                        onFocus: handleOnFocus,
                                        startAdornment: // eslint-disable-next-line react/jsx-wrap-multilines
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "start",
                                            className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCardInput_styles_module_default()).cart_icon : (ProductCardInput_styles_module_default()).mobile_cart_icon),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                src: "/images/icon/cart.svg",
                                                alt: "cart",
                                                width: 18,
                                                height: 18,
                                                className: (0,clsx_m/* default */.Z)(!isMobileV2 && (ProductCardInput_styles_module_default()).cart_img),
                                                q: 100
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || !dealReady || availableProducts && value >= availableProducts,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: (ProductCardInput_styles_module_default()).plus_btn
                                    })
                                ]
                            })
                        }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: checkProductAvailable(),
                                        onClick: handleDecrease,
                                        className: (ProductCardInput_styles_module_default()).minus_btn
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        onKeyDown: handleOnKeyDown,
                                        onClick: handleClickInput,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, (ProductCardInput_styles_module_default())["card_input_pl_".concat(value.toString().length)] || (ProductCardInput_styles_module_default()).card_input),
                                        disabled: checkProductAvailable(),
                                        onFocus: handleOnFocus,
                                        startAdornment: // eslint-disable-next-line react/jsx-wrap-multilines
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "start",
                                            className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCardInput_styles_module_default()).cart_icon : (ProductCardInput_styles_module_default()).mobile_cart_icon),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                src: "/images/icon/cart.svg",
                                                alt: "cart",
                                                width: 18,
                                                height: 18,
                                                className: (0,clsx_m/* default */.Z)(!isMobileV2 && (ProductCardInput_styles_module_default()).cart_img),
                                                q: 100
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || maxQuantityProduct && value >= maxQuantityProduct,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: (ProductCardInput_styles_module_default()).plus_btn
                                    })
                                ]
                            })
                        })),
                        !isSellerList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc),
                            children: checkAndRenderQuantityProduct()
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProductCardInput_styles_module_default()).view_signin_btn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        color: "#fff",
                        backgroundColor: "#005C29",
                        className: (ProductCardInput_styles_module_default()).signin_btn,
                        onClick: toggleLogin,
                        children: translateCommon("cardBuy.login_to_see_prices")
                    })
                })
            }),
            isShowModalRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                product: product,
                visible: isShowModalRemove,
                onClose: handleCancle,
                onRemove: handleRemove
            })
        ]
    });
};
/* harmony default export */ var mocules_ProductCardInput = (ProductCardInput);

// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/TagComponent/index.js + 3 modules
var TagComponent = __webpack_require__(51051);
// EXTERNAL MODULE: ./src/hooks/useTrackingMonitor.js
var useTrackingMonitor = __webpack_require__(64875);
// EXTERNAL MODULE: ./src/utils/ImageUtils.js
var ImageUtils = __webpack_require__(13744);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductCard/styles.module.css
var ProductCard_styles_module = __webpack_require__(38103);
var ProductCard_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCard_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductCard/index.js




























// contain mobile v2 style
var ProductCard = function(param) {
    var product = param.product, type = param.type, tag = param.tag, index = param.index, isMobile = param.isMobile, _isHalfProgress = param.isHalfProgress, isHalfProgress = _isHalfProgress === void 0 ? false : _isHalfProgress, _isCampaignPage = param.isCampaignPage, isCampaignPage = _isCampaignPage === void 0 ? false : _isCampaignPage, link = param.link, isLinkTagDeal = param.isLinkTagDeal, className = param.className;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var searchInput = (0,react.useRef)([]);
    var router = (0,next_router.useRouter)();
    var trackingRef = (0,react.useRef)(null);
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var _isContractPrice = product.isContractPrice, isContractPrice = _isContractPrice === void 0 ? false : _isContractPrice, name = product.name, slug = product.slug, discountPercent = product.discountPercent, defaultImage = product.defaultImage, tags = product.tags, _expiredDate = product.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate, isGift = product.isGift;
    (0,useTrackingMonitor/* default */.Z)(trackingRef, product, isMobile);
    var moveToDetail = function() {
        if (isMobileV2) router.push("/product/".concat(slug || "", "/loading"));
    };
    // udpate giá hợp đồng
    var nameLabel = "";
    if (isContractPrice) {
        nameLabel = translateCommon("contract_price");
    } else if (discountPercent) {
        nameLabel = "- ".concat(discountPercent, "%");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        direction: "column",
        justifyContent: "space-between",
        alignItems: "stretch",
        className: (0,clsx_m/* default */.Z)((ProductCard_styles_module_default()).product_card, (0,_define_property/* default */.Z)({}, (ProductCard_styles_module_default()).mobile_product_card, isMobileV2), className),
        onClick: moveToDetail,
        ref: trackingRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                item: true,
                container: true,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative",
                            width: "100%"
                        },
                        children: [
                            nameLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: nameLabel,
                                className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCard_styles_module_default()).product_tag : (ProductCard_styles_module_default()).mobile_product_tag, (0,_define_property/* default */.Z)({}, (ProductCard_styles_module_default()).product_tab_contract, isContractPrice))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteButton/* default */.ZP, {
                                product: product,
                                isProductCard: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCard_styles_module_default()).product_image : (ProductCard_styles_module_default()).mobile_product_image),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                    href: "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat(slug || "", "/loading"),
                                    prefetch: false,
                                    "data-test": "product-no-".concat(index),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                        src: (0,ImageUtils/* getLinkGCS */.jA)(defaultImage),
                                        fallbackSrc: (0,ImageUtils/* getLinkProxyCDNFallback */.F4)(defaultImage),
                                        alt: name && name,
                                        title: name && name,
                                        className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCard_styles_module_default()).image : (ProductCard_styles_module_default()).image_mobile),
                                        layout: "fill",
                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            var sellerInfo, _tmp, _tmp1, _tmp2, _tmp3;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {};
                                                        return [
                                                            4,
                                                            getSellerByCode((_tmp.code = product === null || product === void 0 ? void 0 : product.sellerCode, _tmp.tags = tags, _tmp))
                                                        ];
                                                    case 1:
                                                        sellerInfo = _state.sent();
                                                        _tmp1 = {};
                                                        utils/* gtag.viewItemInPage */.SX.viewItemInPage((_tmp1.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                            sellerInfo: sellerInfo
                                                        }), _tmp1.path = router.pathname, _tmp1));
                                                        _tmp2 = {};
                                                        _tmp3 = {};
                                                        MonitorUtils/* default.sendSKUEvent */.ZP.sendSKUEvent(Enums/* MONITORING_COLLECTOR_TYPE.SKU_DETAIL_VIEW */.Hq.SKU_DETAIL_VIEW, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, product), (_tmp3.sellerInfo = sellerInfo, _tmp3)), router.pathname);
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    marginLeft: -1,
                                    marginRight: -1
                                },
                                className: (0,clsx_m/* default */.Z)(!isMobileV2 ? (ProductCard_styles_module_default()).product_tags : (ProductCard_styles_module_default()).mobile_product_tags),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                                    product: {
                                        tags: tags
                                    },
                                    variant: "card",
                                    isGift: isGift,
                                    link: link,
                                    isLinkTagDeal: isLinkTagDeal
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_ProductCardContent, {
                        row: true,
                        product: product,
                        tag: tag,
                        translateCommon: translateCommon,
                        isMobileV2: isMobileV2,
                        isCampaignPage: isCampaignPage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                children: /*#__PURE__*/ (0,react.createElement)(mocules_ProductCardInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    searchInput: searchInput,
                    index: index,
                    product: product,
                    type: type,
                    row: true,
                    isHalfProgress: isHalfProgress,
                    isCampaignPage: isCampaignPage
                }, product), {
                    key: product === null || product === void 0 ? void 0 : product.sku,
                    isMobile: isMobile,
                    isDisplayPrice: false
                }))
            })
        ]
    });
};
/* harmony default export */ var mocules_ProductCard = (/*#__PURE__*/(0,react.memo)(ProductCard));


/***/ }),

/***/ 51051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_TagComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var index_es = __webpack_require__(78947);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__(51417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var react_fontawesome_index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(46680);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductTag/tag.module.css
var tag_module = __webpack_require__(65496);
var tag_module_default = /*#__PURE__*/__webpack_require__.n(tag_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/ProductTag/index.js
/* eslint-disable no-param-reassign */ 
















var iconList = [
    {
        label: "✯ Ng\xf4i sao",
        value: "star",
        icon: free_solid_svg_icons_index_es.faStar
    },
    {
        label: "＋ Cộng",
        value: "plus",
        icon: free_solid_svg_icons_index_es.faPlus
    },
    {
        label: "♫ Nốt nhạc",
        value: "music",
        icon: free_solid_svg_icons_index_es.faMusic
    },
    {
        label: "❄ Tuyết",
        value: "snowflake",
        icon: free_solid_svg_icons_index_es.faSnowflake
    },
    {
        label: "✈ M\xe1y bay",
        value: "plane",
        icon: free_solid_svg_icons_index_es.faPlane
    },
    {
        label: "❤ Tr\xe1i tim",
        value: "heart",
        icon: free_solid_svg_icons_index_es.faHeart
    },
    {
        label: "ϟ S\xe9t",
        value: "bolt",
        icon: free_solid_svg_icons_index_es.faBolt
    },
    {
        label: "☀ Mặt trời",
        value: "sun",
        icon: free_solid_svg_icons_index_es.faSun
    },
    {
        label: "☁ M\xe2y",
        value: "cloud",
        icon: free_solid_svg_icons_index_es.faCloud
    },
    {
        label: "♨ Lửa",
        value: "fab gripfire",
        icon: free_brands_svg_icons_index_es.faGripfire
    },
    {
        label: "Qu\xe0 tặng",
        value: "gift",
        icon: free_solid_svg_icons_index_es.faGift
    },
    {
        label: "Giao nhanh",
        value: "shipping-fast",
        icon: free_solid_svg_icons_index_es.faShippingFast
    },
    {
        label: "H\xf3a đơn",
        value: "file-invoice-dollar",
        icon: free_solid_svg_icons_index_es.faFileInvoiceDollar
    },
    {
        label: "B\xe1nh sinh nhật",
        value: "birthday-cake",
        icon: free_solid_svg_icons_index_es.faBirthdayCake
    },
    {
        label: "Huy chương",
        value: "medal",
        icon: free_solid_svg_icons_index_es.faMedal
    },
    {
        label: "Th\xedch",
        value: "thumbs-up",
        icon: free_solid_svg_icons_index_es.faThumbsUp
    },
    {
        label: "Trẻ em",
        value: "baby",
        icon: free_solid_svg_icons_index_es.faBaby
    },
    {
        label: "Giọt nước",
        value: "tint",
        icon: free_solid_svg_icons_index_es.faTint
    },
    {
        label: "B\xf9ng nổ",
        value: "bahai",
        icon: free_solid_svg_icons_index_es.faBahai
    }, 
];
iconList.forEach(function(icon) {
    index_es.library.add(icon.icon);
});
index_es.dom.watch();
var getUrlTag = function(param) {
    var slug = param.slug, url = param.url, code = param.code;
    if (url) return url;
    if (slug) return "/tag/".concat(slug);
    return "".concat(Paths/* PRODUCTS_LOADING_URL */.iB, "?tag=").concat(code);
};
function ProductTag(param) {
    var name = param.name, preIcon = param.preIcon, _Icon = param.Icon, Icon = _Icon === void 0 ? null : _Icon, nameAsTooltip = param.nameAsTooltip, textColor = param.textColor, style = param.style, styleName = param.styleName, code = param.code, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#f2f4fd" : _backgroundColor, date = param.date, _isTooltip = param.isTooltip, isTooltip = _isTooltip === void 0 ? false : _isTooltip, _url = param.url, url = _url === void 0 ? null : _url, borderColor = param.borderColor, _isStyleV2 = param.isStyleV2, isStyleV2 = _isStyleV2 === void 0 ? false : _isStyleV2, slug = param.slug, link = param.link, isLinkTagDeal = param.isLinkTagDeal, index = param.index;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    // R8: màu nền lấy từ `textColor` của CMS (đã resolve và truyền xuống), chỉ còn 2 ngoại lệ.
    var tagColor = (0,react.useMemo)(function() {
        if (code === "DEAL") return "#FFCB13";
        if (code === "FLASH_SALE") return "rgb(220, 53, 69)";
        return textColor || "#D67EFF";
    }, [
        code,
        textColor
    ]);
    // parse preIcon
    if (preIcon) {
        if (typeof preIcon === "string") {
            if (preIcon.indexOf(" ") > 0) {
                preIcon = preIcon.split(" ");
            }
        } else if (typeof preIcon === "object" && preIcon.value) {
            preIcon = preIcon.value;
        }
    }
    var iconToDisplay;
    if (preIcon) {
        var foundIcon = iconList.find(function(icon) {
            return preIcon === icon.value;
        });
        if (foundIcon) {
            iconToDisplay = foundIcon.icon;
        }
    }
    if (isTooltip && (Icon || preIcon)) {
        var urlTag = getUrlTag({
            code: code,
            url: code === "DEAL" && isLinkTagDeal ? link : url,
            slug: slug
        });
        var _obj;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
            stopProp: true,
            removeStyles: true,
            href: urlTag,
            "data-test": "tags-".concat(code),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    style: (0,_object_spread/* default */.Z)({
                        borderColor: borderColor || backgroundColor,
                        color: textColor,
                        backgroundColor: backgroundColor
                    }, style || {}),
                    // className={isStyleV2 ? styles.tag_containerv2 : styles.icon_tag_container}
                    className: (0,clsx_m/* default */.Z)((_obj = {}, (0,_define_property/* default */.Z)(_obj, (tag_module_default()).icon_tag_container, !isStyleV2), (0,_define_property/* default */.Z)(_obj, (tag_module_default()).tag_containerv2, isStyleV2), (0,_define_property/* default */.Z)(_obj, (tag_module_default()).tag_container_mobilev2, isMobileV2), _obj)),
                    onClick: function() {
                        utils/* gtag.clickTagInProduct */.SX.clickTagInProduct(name);
                    },
                    children: [
                        Icon && Icon,
                        preIcon && Boolean(iconToDisplay) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                            icon: iconToDisplay
                        })
                    ]
                })
            })
        });
    }
    // normal display
    if (!nameAsTooltip && name) {
        var urlTag1 = getUrlTag({
            code: code,
            url: code === "DEAL" && isLinkTagDeal ? link : url,
            slug: slug
        });
        var paddingLeft = 0;
        if (index === 0) paddingLeft = "8px";
        else {
            paddingLeft = isMobileV2 ? "12px" : "16px";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
            style: {
                paddingLeft: paddingLeft,
                background: tagColor,
                zIndex: 10 - index
            },
            stopProp: true,
            removeStyles: true,
            href: urlTag1,
            "data-test": "tags-".concat(code),
            prefetch: false,
            className: (0,clsx_m/* default */.Z)((tag_module_default()).tag_item),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    !isMobileV2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            Icon && Icon,
                            preIcon && Boolean(iconToDisplay) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                                icon: iconToDisplay,
                                style: {
                                    color: "#fff",
                                    marginRight: 2,
                                    fontSize: 12
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color: "#fff",
                            fontWeight: "600",
                            fontSize: "10px"
                        },
                        children: name
                    })
                ]
            })
        });
    }
    // quick order display
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: preIcon && name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
            title: name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: (0,_object_spread/* default */.Z)({
                    borderColor: borderColor || backgroundColor,
                    color: textColor,
                    backgroundColor: backgroundColor
                }, style || {}),
                className: isStyleV2 ? (tag_module_default()).tag_containerv2 : (tag_module_default()).tag_container,
                data: "no link",
                children: [
                    Icon && Icon,
                    preIcon && Boolean(iconToDisplay) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                        icon: iconToDisplay
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
;// CONCATENATED MODULE: ./src/utils/TagUtils.js



/**
 * Policy hiển thị tag sản phẩm.
 *
 * Nguồn sự thật là registry tag của CMS (`zustand.tags`, nạp qua SsrService -> MockService.getTags).
 * Module này cố tình không phụ thuộc React / zustand để có thể unit-test và để phía export
 * (XLSX) dùng lại mà không kéo theo MUI.
 *
 * Rule:
 *  R1 - chỉ hiển thị code có trong registry và `visible === true`.
 *  R2 - thứ tự: `priority` giảm dần -> vị trí trong registry tăng dần -> code tăng dần.
 *  R3 - dedupe theo code sau khi alias.
 *  R6 - `NEAR_EXPIRATION` (FE tự sinh) là alias của code cận date bên CMS; `PROMOTIONS` -> `DEAL`.
 *  R7 - nhãn lấy từ `name` của CMS, i18n chỉ là fallback.
 */ // Code do FE tự sinh ở ProductServiceV2/WebService từ lotDates[].isNearExpired.
var LEGACY_NEAR_EXPIRED_CODE = "NEAR_EXPIRATION";
// BE không có tag DEAL, FE không có PROMOTIONS -> quy về một code.
var STATIC_ALIASES = {
    PROMOTIONS: "DEAL"
};
// Tập key `tag.*` đang tồn tại trong public/locales/*/common.json.
// Chỉ dùng làm fallback cho code KHÔNG có entry CMS visible. Không thêm key mới ở đây:
// đa ngôn ngữ cho tag là bài toán dữ liệu CMS (per-locale `name`).
var TAG_I18N_FALLBACK = new Set([
    "DEAL",
    "LIMIT",
    "NEAR_EXPIRATION",
    "HOADONNHANH",
    "3ABC",
    "2ABC",
    "PROMOTION",
    "FV2U", 
]);
var EMPTY_REGISTRY = new Map();
/**
 * Chuẩn hoá danh sách code lấy từ `product.tags`: bỏ giá trị rỗng, áp alias, dedupe.
 *
 * `nearExpiredCode` rỗng (ví dụ .env.local không set NEXT_PUBLIC_TAG_PRODUCT_NEAR_EXPIRE)
 * thì giữ nguyên NEAR_EXPIRATION để còn fallback qua i18n, thay vì alias sang chuỗi rỗng.
 */ var normalizeTagCodes = function() {
    var codes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _nearExpiredCode = ref.nearExpiredCode, nearExpiredCode = _nearExpiredCode === void 0 ? sysconfig/* TAG_PRODUCT_NEAR_EXPIRED */.n8 : _nearExpiredCode;
    if (!Array.isArray(codes)) return [];
    var seen = new Set();
    var result = [];
    codes.forEach(function(rawCode) {
        if (!rawCode) return;
        var code = STATIC_ALIASES[rawCode] || rawCode;
        if (code === LEGACY_NEAR_EXPIRED_CODE && nearExpiredCode) code = nearExpiredCode;
        if (seen.has(code)) return;
        seen.add(code);
        result.push(code);
    });
    return result;
};
/** Dựng Map code -> tag (chỉ tag visible), kèm vị trí gốc để tie-break ổn định. */ var buildTagRegistry = function() {
    var tags = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!Array.isArray(tags) || tags.length === 0) return EMPTY_REGISTRY;
    var registry = new Map();
    tags.forEach(function(tag, index) {
        if (!(tag === null || tag === void 0 ? void 0 : tag.code) || !tag.visible || registry.has(tag.code)) return;
        registry.set(tag.code, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
            registryIndex: index
        }));
    });
    return registry;
};
// Registry chỉ đổi khi mảng `tags` trong store đổi identity (mỗi lần hydrate SSR),
// nên memo theo identity là đủ và tránh quét tuyến tính mỗi lần render card.
var REGISTRY_CACHE = new WeakMap();
var getTagRegistry = function(tags) {
    if (!Array.isArray(tags) || tags.length === 0) return EMPTY_REGISTRY;
    var cached = REGISTRY_CACHE.get(tags);
    if (cached) return cached;
    var registry = buildTagRegistry(tags);
    REGISTRY_CACHE.set(tags, registry);
    return registry;
};
var toPriority = function(value) {
    return Number.isFinite(value) ? value : Number.NEGATIVE_INFINITY;
};
// R2. Ba khoá, vì thứ tự đầu vào (`product.tags`) khác nhau giữa các đường dữ liệu BE,
// nên chỉ dựa vào tính ổn định của Array.sort là chưa đủ.
var compareTags = function(a, b) {
    var priorityA = toPriority(a.priority);
    var priorityB = toPriority(b.priority);
    if (priorityA !== priorityB) return priorityB - priorityA;
    if (a.registryIndex !== b.registryIndex) return a.registryIndex - b.registryIndex;
    return String(a.code).localeCompare(String(b.code));
};
/**
 * Lọc + sắp xếp + cắt theo giới hạn của surface.
 * Trả về object tag đã resolve để tầng render không phải hỏi lại store.
 */ var resolveVisibleTags = function(param) {
    var _codes = param.codes, codes = _codes === void 0 ? [] : _codes, _registry = param.registry, registry = _registry === void 0 ? EMPTY_REGISTRY : _registry, _max = param.max, max = _max === void 0 ? Infinity : _max;
    if (!(registry === null || registry === void 0 ? void 0 : registry.size) || !(codes === null || codes === void 0 ? void 0 : codes.length)) return [];
    var resolved = [];
    codes.forEach(function(code) {
        var tag = registry.get(code);
        if (tag) resolved.push(tag);
    });
    resolved.sort(compareTags);
    return Number.isFinite(max) ? resolved.slice(0, Math.max(0, max)) : resolved;
};
/** R7. `name` của CMS thắng; i18n chỉ đỡ cho code không có entry CMS visible. */ var getTagLabel = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _tag = ref.tag, tag = _tag === void 0 ? null : _tag, _code = ref.code, code = _code === void 0 ? null : _code, _t = ref.t, t = _t === void 0 ? null : _t;
    if (tag === null || tag === void 0 ? void 0 : tag.name) return tag.name;
    var key = code || (tag === null || tag === void 0 ? void 0 : tag.code);
    if (key && TAG_I18N_FALLBACK.has(key) && typeof t === "function") return t("tag.".concat(key));
    return "";
};
/* harmony default export */ var TagUtils = ({
    LEGACY_NEAR_EXPIRED_CODE: LEGACY_NEAR_EXPIRED_CODE,
    normalizeTagCodes: normalizeTagCodes,
    buildTagRegistry: buildTagRegistry,
    getTagRegistry: getTagRegistry,
    resolveVisibleTags: resolveVisibleTags,
    getTagLabel: getTagLabel
});

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/TagType/index.js




/**
 * Render một tag đã được resolve từ registry CMS.
 *
 * Component này cố tình KHÔNG nhận code thô và KHÔNG tự tra store: việc lọc/sắp xếp/alias
 * nằm ở utils/TagUtils, được TagComponent gọi một lần cho cả sản phẩm. Nhờ vậy tránh được
 * hai lỗi cũ: tra store lặp lại cho từng tag, và ghi đè (mutate) thẳng vào object trong store.
 */ var TagType = function(param) {
    var tag = param.tag, index = param.index, link = param.link, isLinkTagDeal = param.isLinkTagDeal;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    if (!(tag === null || tag === void 0 ? void 0 : tag.code)) return null;
    var name = getTagLabel({
        tag: tag,
        t: translateCommon
    });
    if (!name) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag, {
        code: tag.code,
        name: name,
        slug: tag.slug,
        textColor: tag.textColor,
        preIcon: tag.preIcon,
        nameAsTooltip: tag.nameAsTooltip,
        style: tag.style,
        index: index,
        link: link,
        isLinkTagDeal: isLinkTagDeal
    });
};
/* harmony default export */ var mocules_TagType = (TagType);

// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/landingPageCam/mocules/TagComponent/index.js




/**
 * Hiển thị tag của sản phẩm.
 *
 * Rule đầy đủ: docs/product-tag-display-spec.md. Tóm tắt:
 *  - CMS là allow-list duy nhất: chỉ tag có trong registry và `visible = true` mới hiện (R1).
 *  - Thứ tự do `priority` của CMS quyết định, không phụ thuộc thứ tự BE trả về (R2).
 *  - Card tối đa 2 tag, phần dư bỏ (không có nút overflow) (R4, R5).
 *  - Trang chi tiết hiển thị toàn bộ tag visible (R4).
 */ // R4
var MAX_TAGS_BY_VARIANT = {
    card: 2,
    detail: Infinity
};
var TagComponent = function(param) {
    var product = param.product, _variant = param.variant, variant = _variant === void 0 ? "card" : _variant, _isGift = param.isGift, isGift = _isGift === void 0 ? false : _isGift, link = param.link, isLinkTagDeal = param.isLinkTagDeal;
    var tags = (0,storeGlobal/* useStore */.o)(function(state) {
        return state === null || state === void 0 ? void 0 : state.tags;
    });
    // R9: SKU quà tặng không hiển thị tag.
    if (isGift) return null;
    var visibleTags = resolveVisibleTags({
        codes: normalizeTagCodes(product === null || product === void 0 ? void 0 : product.tags),
        registry: getTagRegistry(tags),
        max: MAX_TAGS_BY_VARIANT[variant] || MAX_TAGS_BY_VARIANT.card
    });
    if (visibleTags.length === 0) return null;
    return visibleTags.map(function(tag, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_TagType, {
            tag: tag,
            index: index,
            link: link,
            isLinkTagDeal: isLinkTagDeal
        }, tag.code);
    });
};
/* harmony default export */ var mocules_TagComponent = (TagComponent);


/***/ }),

/***/ 50979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5233);


// BV-1586: nhãn dưới giá đã giảm của dòng giỏ (cart.priceAfterVoucher).
// Tách component để chỉ dùng namespace cart khi dòng giỏ thật sự có priceAfterVoucher
// (ProductCardBuy còn được dùng ở các trang không tải namespace cart).
var CartPriceAfterVoucherLabel = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("cart").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: className,
        "data-test": "price-after-voucher-label",
        children: t("priceAfterVoucher")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CartPriceAfterVoucherLabel);


/***/ }),

/***/ 27890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38799);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26380);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* eslint-disable func-names */ 






var NewInputProduct = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, name = _param.name, searchInput = _param.searchInput, defaultValue = _param.defaultValue, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, value = _param.value, product = _param.product, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _onBlur = _param.onBlur, onBlur = _onBlur === void 0 ? function() {} : _onBlur, _onKeyDown = _param.onKeyDown, onKeyDown = _onKeyDown === void 0 ? function() {} : _onKeyDown, _onFocus = _param.onFocus, onFocus = _onFocus === void 0 ? function() {} : _onFocus, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "name",
        "searchInput",
        "defaultValue",
        "onChange",
        "value",
        "product",
        "disabled",
        "onBlur",
        "onKeyDown",
        "onFocus"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        type: "text",
        min: "0",
        step: "1",
        pattern: "\\d*",
        name: name,
        inputRef: searchInput,
        classes: {
            root: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().root_input), className),
            input: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().input),
            focused: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().focus)
        },
        disableUnderline: true,
        placeholder: "0",
        onChange: function(e) {
            return onChange(e, product);
        },
        onBlur: function(e) {
            return onBlur(e, product);
        },
        onKeyDown: function(e) {
            return onKeyDown(e, product);
        },
        value: value,
        defaultValue: defaultValue,
        disabled: disabled,
        onFocus: onFocus
    }, restProps));
});
/* harmony default export */ __webpack_exports__["Z"] = (NewInputProduct);


/***/ }),

/***/ 30851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5007);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);








var NewMinusButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, restProps), {
            classes: {
                root: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().buttons), (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_root_minus))
            },
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_minus), className),
            children: "-"
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (NewMinusButton);


/***/ }),

/***/ 92959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5007);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);








var NewPlusButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, disabled = _param.disabled, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "disabled"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, restProps), {
            disabled: disabled,
            classes: {
                root: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().buttons), disabled ? ((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().plus_disabled), (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_plus)) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_plus), className)
            },
            children: "+"
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (NewPlusButton);


/***/ }),

/***/ 86635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_TextareaAutosize__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87343);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38169);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33436);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46680);
/* harmony import */ var utils_debounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74118);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97230);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_10__);











var CartNote = function() {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    var note = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useCart */ .jD)().note;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(note), noteValue = ref1[0], setNoteValue = ref1[1];
    var handleUpdateNote = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(val) {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients__WEBPACK_IMPORTED_MODULE_1__/* .CartClientV2.updateNote */ .HP.updateNote(val)
                        ];
                    case 1:
                        res = _state.sent();
                        if ((0,clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(res)) {
                            utils__WEBPACK_IMPORTED_MODULE_5__/* .NotifyUtils.success */ .QP.success(translateCommon("update_note_success"));
                        } else {
                            utils__WEBPACK_IMPORTED_MODULE_5__/* .NotifyUtils.error */ .QP.error((res === null || res === void 0 ? void 0 : res.message) || translateCommon("update_note_fail"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(val) {
            return _ref.apply(this, arguments);
        };
    }());
    var handleSetNote = function(e) {
        var valNote = e.target.value;
        setNoteValue(valNote);
        (0,utils_debounce__WEBPACK_IMPORTED_MODULE_6__/* .debounceFunc500 */ .X4)(function() {
            return handleUpdateNote(valNote);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setNoteValue(note);
    }, [
        note
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextareaAutosize__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        name: "note",
        value: noteValue,
        onChange: handleSetNote,
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().text_area),
        "aria-label": "Ghi ch\xfa của kh\xe1ch h\xe0ng",
        placeholder: translateCommon("note_of_customer"),
        maxRows: 4,
        "data-test": "note-cart"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.memo(CartNote));


/***/ }),

/***/ 72640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_NoSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46680);







// thuannc
// TODO:
// MUST FIX
function CountdownTimer(_param) {
    var prefix = _param.prefix, dealEndDay = _param.dealEndDay, translateCommon = _param.translateCommon, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "prefix",
        "dealEndDay",
        "translateCommon"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeLeft */ .VZ)(dealEndDay)), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer = setTimeout(function() {
            setTimeLeft((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeLeft */ .VZ)(dealEndDay));
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function(interval) {
        var val = timeLeft[interval];
        if (!val) {
            return;
        }
        // 05Jan2022 -> nếu > 30 ngày thì set lại 30 ngày, dài quá bể UI
        timerComponents.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            style: interval === "days" ? {
                marginRight: "4px"
            } : {},
            children: [
                val,
                interval === "days" ? " ".concat(translateCommon("days"), " ") : null
            ]
        }, "timer-".concat(Math.random())));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_NoSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, otherProps), {
            children: [
                prefix,
                " ",
                timerComponents.length ? timerComponents : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: translateCommon("voucher.end_of_promotion")
                })
            ]
        }))
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CountdownTimer);


/***/ }),

/***/ 39542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69251);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13402);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_3__);







var CustomModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var _icon = param.icon, icon = _icon === void 0 ? true : _icon, children = param.children, onClose = param.onClose, onClickOk = param.onClickOk, visible = param.visible, className = param.className, restProps = param.restProps, title = param.title, content = param.content, _btnOk = param.btnOk, btnOk = _btnOk === void 0 ? "C\xf3" : _btnOk, _btnOnClose = param.btnOnClose, btnOnClose = _btnOnClose === void 0 ? "Kh\xf4ng" : _btnOnClose, _btnCloseRender = param.btnCloseRender, btnCloseRender = _btnCloseRender === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .ButtonDefaultLogin */ .O2, {
        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().font_gg),
        btnType: "warning",
        onClick: onClose,
        "data-test": "btn-custom-modal-cancel",
        children: btnOnClose
    }) : _btnCloseRender, _btnOkRender = param.btnOkRender, btnOkRender = _btnOkRender === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .ButtonDefaultLogin */ .O2, {
        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().font_gg),
        onClick: onClickOk,
        "data-test": "btn-custom-modal-ok",
        children: btnOk
    }) : _btnOkRender, customBtnRender = param.customBtnRender;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().confirm_modal_wrap),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_icon),
                                children: "!"
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().modal_title),
                            "data-test": "modal-custom-title",
                            children: title
                        }),
                        content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().modal_content),
                            "data-test": "modal-custom-content",
                            children: content
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        textAlign: "center",
                        marginTop: "16px"
                    },
                    children: [
                        btnCloseRender && btnCloseRender,
                        btnOkRender && btnOkRender,
                        customBtnRender && customBtnRender
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(CustomModal));


/***/ }),

/***/ 80550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33681);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5233);
/* harmony import */ var utils_FormatDate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45901);
/* harmony import */ var _CountdownTimer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72640);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13122);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);







var DealSection = function(param) {
    var dealEndDay = param.dealEndDay, dealReady = param.dealReady, dealStartTime = param.dealStartTime, maxQuantity = param.maxQuantity, _totalSold = param.totalSold, totalSold = _totalSold === void 0 ? 0 : _totalSold, _total = param.total, total = _total === void 0 ? 0 : _total;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    var startDate = (0,utils_FormatDate__WEBPACK_IMPORTED_MODULE_2__/* .formatDate */ .p6)(dealStartTime);
    var totalSoldPercent = totalSold / total * 100;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().deal_section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().process_wrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        classes: {
                            root: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().root_process),
                            barColorPrimary: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().bar_background),
                            colorPrimary: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().blur_background)
                        },
                        variant: "determinate",
                        value: totalSoldPercent
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().process_content),
                        children: [
                            dealReady && maxQuantity === totalSold && translateCommon("deal.sold_out"),
                            dealReady && maxQuantity > totalSold && totalSoldPercent < 75 && "".concat(translateCommon("deal.sold"), " ").concat(totalSold),
                            dealReady && maxQuantity > totalSold && totalSoldPercent >= 75 && translateCommon("deal.out_of_stock_soon"),
                            !dealReady && translateCommon("deal.on_sale_soon")
                        ]
                    })
                ]
            }),
            dealReady ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CountdownTimer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                translateCommon: translateCommon,
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().count_down),
                dealEndDay: dealEndDay
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().startDate),
                children: startDate
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DealSection);


/***/ }),

/***/ 40174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69251);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68786);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_6__);










var DeleteAddressModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(props) {
    var onClose = props.onClose, onClickOk = props.onClickOk, visible = props.visible, className = props.className, restProps = props.restProps;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().confirm_modal_wrap),
            "data-test": "modal-delete-address",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().text_icon),
                                children: "!"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_title),
                            children: translatePopupAction("popup-removeAddress.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_content),
                            children: translatePopupAction("popup-removeAddress.content")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        marginTop: "16px",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().brown_btn)),
                            onClick: onClose,
                            children: translatePopupAction("popup-removeAddress.no")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            onClick: onClickOk,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().fill_btn)),
                            "data-test": "btn-ok-delete-modal",
                            children: translatePopupAction("popup-removeAddress.yes")
                        })
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (DeleteAddressModal);


/***/ }),

/***/ 59784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69251);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39335);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_6__);










var EditOrderModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(function(props) {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    var onClose = props.onClose, onClickOk = props.onClickOk, visible = props.visible, className = props.className, restProps = props.restProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().confirm_modal_wrap),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().text_icon),
                                children: "!"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_title),
                            children: translatePopupAction("popup-edit-order.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_content),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: translatePopupAction("popup-edit-order.content")
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        marginTop: "16px",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().brown_btn)),
                            onClick: onClose,
                            "data-test": "btn-cancel-edit-order",
                            children: translatePopupAction("popup-edit-order.cancel")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            onClick: onClickOk,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().fill_btn)),
                            "data-test": "btn-ok-edit-order",
                            children: translatePopupAction("popup-edit-order.confirm")
                        })
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (EditOrderModal);


/***/ }),

/***/ 50267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_FavoriteButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fab/Fab.js
var Fab = __webpack_require__(33758);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Favorite.js
var Favorite = __webpack_require__(76324);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FavoriteBorder.js
var FavoriteBorder = __webpack_require__(28106);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/lib/useEffecOnce.ts


function useEffectOnce(fn, deps) {
    var ref = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (ref.current) {
            fn();
        }
        return function() {
            ref.current = true;
        };
    }, (0,_to_consumable_array/* default */.Z)(deps).concat([
        fn
    ]));
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/mocules/FavoriteButton/styles.module.css
var styles_module = __webpack_require__(58152);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/FavoriteButton/index.js















var FavoriteButton = function(param) {
    var product = param.product, _isProductCard = param.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard, className = param.className;
    var ref = (0,react.useState)(false), isBookmarked = ref[0], setIsFavorite = ref[1];
    var ref1 = (0,context/* useWishList */.L4)(), getWishlistBySkus = ref1.getWishlistBySkus, handleDeleteProductWishlist = ref1.handleDeleteProductWishlist, handleUpdateWishlist = ref1.handleUpdateWishlist, loading = ref1.loading;
    var ref2 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref2.t;
    var loadData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getWishlistBySkus(product)
                        ];
                    case 1:
                        res = _state.sent();
                        setIsFavorite(res);
                        return [
                            2
                        ];
                }
            });
        });
        return function loadData() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffectOnce(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (!loading) {
                        loadData();
                    }
                    return [
                        2
                    ];
                });
            });
            return _fetchData.apply(this, arguments);
        }
        fetchData();
    }, [
        loading
    ]);
    var handleUpdateFavorite = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleUpdateWishlist(item)
                        ];
                    case 1:
                        res = _state.sent();
                        setIsFavorite(res);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdateFavorite(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteFavorite = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleDeleteProductWishlist(item)
                        ];
                    case 1:
                        res = _state.sent();
                        setIsFavorite(res);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteFavorite(item) {
            return _ref.apply(this, arguments);
        };
    }();
    if (isProductCard) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
            title: !isBookmarked ? translateCommon("btn.mark_wishlist_product") : translateCommon("btn.unmark_wishlist_product"),
            children: isBookmarked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                className: (styles_module_default()).favorite_icon_wrapper,
                onClick: function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    handleDeleteFavorite(product);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* WISHLIST_IMAGE_ACTIVE */.gu, {
                    className: (styles_module_default()).favorite_icon
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                className: (styles_module_default()).favorite_icon_wrapper,
                onClick: function(e) {
                    e.stopPropagation();
                    handleUpdateFavorite(product);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* WISHLIST_IMAGE_INACTIVE */.xA, {})
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
        title: !isBookmarked ? translateCommon("btn.mark_wishlist_product") : translateCommon("btn.unmark_wishlist_product"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
            className: (0,clsx_m/* default */.Z)((styles_module_default()).icon, className && className),
            size: "small",
            "aria-label": "like",
            onClick: function(e) {
                e.stopPropagation();
                if (isBookmarked) {
                    handleDeleteFavorite(product);
                } else {
                    handleUpdateFavorite(product);
                }
            },
            children: isBookmarked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite/* default */.Z, {
                style: {
                    fontSize: 24
                },
                className: (styles_module_default()).like
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorder/* default */.Z, {
                style: {
                    fontSize: 24,
                    color: "#AFAFAF"
                }
            })
        })
    });
};
/* harmony default export */ var mocules_FavoriteButton = (FavoriteButton);


/***/ }),

/***/ 28222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41749);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5233);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72045);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3681);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);






var IngredientList = function(param) {
    var _ingredients = param.ingredients, ingredients = _ingredients === void 0 ? [] : _ingredients, _text = param.text, text = _text === void 0 ? "" : _text, totalIngredient = param.totalIngredient, startIngredientIndex = param.startIngredientIndex, endIngredientIndex = param.endIngredientIndex;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("ingredients"), translateIngredients = ref.t;
    var listIngredients = ingredients.slice(startIngredientIndex, endIngredientIndex).map(function(val) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().item),
            item: true,
            xs: 6,
            md: 3,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "ingredients/".concat(val.slug),
                prefetch: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().ingredient),
                    children: [
                        " ",
                        val === null || val === void 0 ? void 0 : val.name,
                        " "
                    ]
                })
            })
        }, "ingredients-".concat((0,uuid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)()));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().ingredientList),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().total),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: translateIngredients("total_search_results")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().totalIngredient),
                        children: totalIngredient
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                        children: [
                            " ",
                            text === "" ? translateIngredients("total") : text,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                container: true,
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
                children: listIngredients
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (IngredientList);


/***/ }),

/***/ 87895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69251);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48765);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);










var InvoiceInfoDeleteModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(function(props) {
    var onClose = props.onClose, onClickOk = props.onClickOk, visible = props.visible, className = props.className, restProps = props.restProps;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().confirm_modal_wrap),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().text_icon),
                                children: "!"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_title),
                            children: translatePopupAction("popup-remove-invoice-info.confirmation")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_content),
                            children: translatePopupAction("popup-remove-invoice-info.content")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        marginTop: "16px",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().brown_btn)),
                            onClick: onClose,
                            children: translatePopupAction("popup-remove-invoice-info.no")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            onClick: onClickOk,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().fill_btn)),
                            children: translatePopupAction("popup-remove-invoice-info.yes")
                        })
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (InvoiceInfoDeleteModal);


/***/ }),

/***/ 38319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41749);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72045);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99009);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);





var ManufacturerList = function(param) {
    var _manufacturers = param.manufacturers, manufacturers = _manufacturers === void 0 ? [] : _manufacturers, _text = param.text, text = _text === void 0 ? "" : _text, translateCommon = param.translateCommon;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().total),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        children: translateCommon("display-amount-for-search-result").replace("{total}", manufacturers.length || 0)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                        children: [
                            " ",
                            text === "" ? translateCommon("all") : text,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                container: true,
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
                spacing: 2,
                children: manufacturers.map(function(val) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        item: true,
                        xs: 3,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "manufacturers/".concat(val.slug),
                            prefetch: false,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().manufacturer),
                                children: [
                                    " ",
                                    val === null || val === void 0 ? void 0 : val.name,
                                    " "
                                ]
                            })
                        })
                    }, (0,uuid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)());
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ManufacturerList);


/***/ }),

/***/ 27733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewRegisterOrderInvoiceForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47533);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(64839);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38169);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69251);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87536);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46680);
/* harmony import */ var utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25872);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74231);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47638);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_14__);
/* eslint-disable react/jsx-wrap-multilines */ 


















function NewRegisterOrderInvoiceForm(param) {
    var invoice = param.invoice, orderId = param.orderId, className = param.className, onClose = param.onClose, getValueInvoice = param.getValueInvoice, invoiceRes = param.invoiceRes, invoiceInfoChooserItem = param.invoiceInfoChooserItem, customerEmail = param.customerEmail, check = param.check;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("detailOrders"), translateDetailOrder = ref.t;
    var schema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape({
        companyName: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(translateDetailOrder("new_reg_order_invoice_form.validate_name")),
        taxCode: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_()// .matches(/^[0-9]+$/, 'Bạn chưa nhập mã số thuế')
        .min(10, translateDetailOrder("new_reg_order_invoice_form.validate_tax_number.min")).max(14, translateDetailOrder("new_reg_order_invoice_form.validate_tax_number.max")).test("check number", translateDetailOrder("new_reg_order_invoice_form.validate_tax_number.check_num"), function(value) {
            return value.match(/^[0-9][0-9 -]*$/);
        }).test("check-min-max", translateDetailOrder("new_reg_order_invoice_form.validate_tax_number.check_min_max"), function(value) {
            return !(value.length !== 10 && value.length !== 14);
        }).test("check -", translateDetailOrder("new_reg_order_invoice_form.validate_tax_number.check-"), function(value) {
            return value.length === 14 ? value.includes("-") : true;
        }),
        companyAddress: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(translateDetailOrder("new_reg_order_invoice_form.validate_address"))
    });
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_8__/* .yupResolver */ .X)(schema)
    }), errors = ref1.formState.errors, control = ref1.control, handleSubmit = ref1.handleSubmit;
    var handleSendRequest = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(value) {
            var data, _tmp, _tmp1, requestInvoiceResult, message, errorCode, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_tmp, value), (_tmp1.orderId = orderId, _tmp1.email = (invoice === null || invoice === void 0 ? void 0 : invoice.email) || customerEmail || "", _tmp1.invoiceRequest = true, _tmp1));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            clients__WEBPACK_IMPORTED_MODULE_1__/* .CustomerClient.updateInvoiceInfoOrder */ .YP.updateInvoiceInfoOrder(data)
                        ];
                    case 2:
                        requestInvoiceResult = _state.sent();
                        if (!(0,clients__WEBPACK_IMPORTED_MODULE_1__/* .isValidWithoutData */ .Wk)(requestInvoiceResult)) {
                            message = "";
                            errorCode = requestInvoiceResult.errorCode;
                            switch(errorCode){
                                case "ERR_UPDATE_MANUALLY_EXPORTED_INVOICE":
                                    message = translateDetailOrder("error_message.ERR_UPDATE_MANUALLY_EXPORTED_INVOICE");
                                    break;
                                case "ERR_UPDATE_MANUALLY_IMPORTED_INVOICE":
                                    message = translateDetailOrder("error_message.ERR_UPDATE_MANUALLY_IMPORTED_INVOICE");
                                    break;
                                case "ERR_UPDATE_INVOICE_MULTIPLE_TIMES":
                                    message = translateDetailOrder("error_message.ERR_UPDATE_INVOICE_MULTIPLE_TIMES");
                                    break;
                                case "ERR_INVALID_CHANGE_REQUEST_TIME":
                                    message = translateDetailOrder("error_message.ERR_INVALID_CHANGE_REQUEST_TIME");
                                    break;
                                case "ERR_INVALID_CHANGE_INVOICE_INFO_TIME":
                                    message = translateDetailOrder("error_message.ERR_INVALID_CHANGE_INVOICE_INFO_TIME");
                                    break;
                                default:
                                    message = requestInvoiceResult.message || translateDetailOrder("error_message.DEFAULT");
                            }
                            throw new Error(message);
                        }
                        utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].success */ .Z.success(translateDetailOrder("success_message_send_invoice_update"));
                        // clear
                        onClose();
                        getValueInvoice(data);
                        utils__WEBPACK_IMPORTED_MODULE_4__/* .gtag.requestInvoice */ .SX.requestInvoice();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].error */ .Z.error(error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendRequest(value) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(className, (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().form_sign_up), (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().slideLeft)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            className: className,
            onSubmit: handleSubmit(function(data) {
                return handleSendRequest(data);
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .Controller */ .Qr, {
                    name: "companyName",
                    defaultValue: check ? invoiceInfoChooserItem === null || invoiceInfoChooserItem === void 0 ? void 0 : invoiceInfoChooserItem.companyName : (invoiceRes === null || invoiceRes === void 0 ? void 0 : invoiceRes.companyName) || "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        var ref, ref1;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .InputV2 */ .b0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        display: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                children: translateDetailOrder("new_reg_order_invoice_form.name")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textRequired),
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    id: "companyName",
                                    error: !!errors.companyName,
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().input)
                                }, field)),
                                ((ref = errors.companyName) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textError),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().iconError)
                                        }),
                                        " ",
                                        (ref1 = errors.companyName) === null || ref1 === void 0 ? void 0 : ref1.message
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .Controller */ .Qr, {
                    name: "taxCode",
                    defaultValue: check ? invoiceInfoChooserItem === null || invoiceInfoChooserItem === void 0 ? void 0 : invoiceInfoChooserItem.taxCode : (invoiceRes === null || invoiceRes === void 0 ? void 0 : invoiceRes.taxCode) || "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        var ref, ref1, ref2;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .InputV2 */ .b0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        display: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                children: translateDetailOrder("new_reg_order_invoice_form.tax_number")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textRequired),
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    error: !!errors.taxCode,
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().input)
                                }, field)),
                                ((ref = errors.taxCode) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textError),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().iconError)
                                        }),
                                        " ",
                                        (ref1 = errors.taxCode) === null || ref1 === void 0 ? void 0 : ref1.message,
                                        console.log("{errors.taxCode?.message}", (ref2 = errors.taxCode) === null || ref2 === void 0 ? void 0 : ref2.message)
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .Controller */ .Qr, {
                    name: "companyAddress",
                    defaultValue: check ? invoiceInfoChooserItem === null || invoiceInfoChooserItem === void 0 ? void 0 : invoiceInfoChooserItem.companyAddress : (invoiceRes === null || invoiceRes === void 0 ? void 0 : invoiceRes.companyAddress) || "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .InputV2 */ .b0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        display: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                children: translateDetailOrder("new_reg_order_invoice_form.address")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textRequired),
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    error: !!errors.companyAddress,
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().input)
                                }, field)),
                                errors.companyAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textError),
                                    "data-test": "signup-err-username",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().iconError)
                                        }),
                                        " ",
                                        errors.companyAddress.message
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    textAlign: "center",
                    marginTop: "30px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().sendData),
                        type: "submit",
                        children: translateDetailOrder("new_reg_order_invoice_form.send")
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5233);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66727);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);





var PointOfProduct = function(param) {
    var point = param.point, pointMultiplier = param.pointMultiplier, _isDetailMV2 = param.isDetailMV2, isDetailMV2 = _isDetailMV2 === void 0 ? false : _isDetailMV2;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().wrapPoint), point >= 100 && (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().pointTextSmall)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().point), isDetailMV2 && (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().point_mv2)),
                    children: [
                        "+",
                        point
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().titlePoint)),
                children: translateCommon("loyalty_point")
            }),
            pointMultiplier > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().pointMultiplierWrap), isDetailMV2 && (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().pointMultiplierWrap_mv2)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().coefficient), isDetailMV2 && (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().coefficient_mv2)),
                    children: [
                        "x",
                        pointMultiplier
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PointOfProduct);


/***/ }),

/***/ 19963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_ProductCardContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components-v2/atoms/FluctuatedPriceIcon/index.js
var FluctuatedPriceIcon = __webpack_require__(77753);
// EXTERNAL MODULE: ./src/components-v3/organisms/PriceBreakdown/CartPriceAfterVoucherLabel.js
var CartPriceAfterVoucherLabel = __webpack_require__(50979);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/PriceBreakdownUtils.js
var PriceBreakdownUtils = __webpack_require__(85998);
// EXTERNAL MODULE: ./src/components-v2/mocules/CartItemPriceMobile/styles.module.css
var styles_module = __webpack_require__(9904);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CartItemPriceMobile/index.js






var CartItemPriceMobile = function(param) {
    var product = param.product;
    var ref = product || {}, _displayPrice = ref.displayPrice, displayPrice = _displayPrice === void 0 ? 0 : _displayPrice, _salePrice = ref.salePrice, salePrice = _salePrice === void 0 ? 0 : _salePrice, _currentPrice = ref.// currentPrice là giá tại thời điểm thêm vào giỏ, không phải giá hiện tại
    currentPrice, currentPrice = _currentPrice === void 0 ? 0 : _currentPrice, fluctuatedType = ref.fluctuatedType, _isDeal = ref.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = ref.deal, deal = _deal === void 0 ? null : _deal;
    // BV-1586: dòng có voucher phân bổ vào SKU -> giá chính = priceAfterVoucher, gạch ngang price của
    // cart item (deal/campaign/deal advanced thì là giá đó), nhãn cart.priceAfterVoucher. Không có field thì như cũ.
    var cartPriceAfterVoucher = (0,PriceBreakdownUtils/* getCartItemPriceAfterVoucher */.M_)(product);
    if (cartPriceAfterVoucher) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).price_after_voucher,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).price_row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuatedPriceIcon/* default */.Z, {
                            fluctuatedType: fluctuatedType
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).current_price,
                            "data-test": "price-after-voucher-mobile",
                            children: (0,FormatNumber/* formatCurrency */.xG)(cartPriceAfterVoucher.priceAfterVoucher)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).old_price,
                            "data-test": "old-price-text-mobile",
                            children: (0,FormatNumber/* formatCurrency */.xG)(cartPriceAfterVoucher.price)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPriceAfterVoucherLabel/* default */.Z, {
                    className: (styles_module_default()).price_after_voucher_label
                })
            ]
        });
    }
    // Item biến động giá: gạch ngang currentPrice, giống bản desktop ở ProductCardBuy.
    // Chặn currentPrice = 0 để không render ra giá gạch ngang bằng 0 khi thiếu data.
    var isShowFluctuatedPrice = !!fluctuatedType && currentPrice > 0;
    // Item deal: giữ nguyên hành vi cũ, gạch ngang salePrice.
    var isShowDealPrice = isDeal && !!deal && salePrice > 0 && salePrice !== displayPrice;
    var oldPrice = isShowFluctuatedPrice && currentPrice || isShowDealPrice && salePrice || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).price_row,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuatedPriceIcon/* default */.Z, {
                fluctuatedType: fluctuatedType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).current_price,
                children: (0,FormatNumber/* formatCurrency */.xG)(displayPrice)
            }),
            oldPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).old_price,
                "data-test": "old-price-text-mobile",
                children: (0,FormatNumber/* formatCurrency */.xG)(oldPrice)
            })
        ]
    });
};
/* harmony default export */ var mocules_CartItemPriceMobile = (CartItemPriceMobile);

// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(46680);
// EXTERNAL MODULE: ./src/utils/MonitorUtils.js + 1 modules
var MonitorUtils = __webpack_require__(79903);
// EXTERNAL MODULE: ./src/zustand-lib/useGetTagPromotion.js
var useGetTagPromotion = __webpack_require__(98300);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js + 2 modules
var useSellers = __webpack_require__(14626);
// EXTERNAL MODULE: ./src/components/mocules/SellerInfo/index.js
var SellerInfo = __webpack_require__(69200);
// EXTERNAL MODULE: ./src/components/mocules/TagComponent/index.js + 2 modules
var TagComponent = __webpack_require__(22535);
// EXTERNAL MODULE: ./src/components/mocules/ProductCardContent/styles.module.css
var ProductCardContent_styles_module = __webpack_require__(37315);
var ProductCardContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCardContent_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductCardContent/index.js
/* eslint-disable no-nested-ternary */ 























var ProductCardContent = function(param) {
    var page = param.page, cate = param.cate, cart = param.cart, className = param.className, row = param.row, isMobile = param.isMobile, isMobileV2 = param.isMobileV2, product = param.product, link = param.link, isLinkTagDeal = param.isLinkTagDeal, _mobileV2Horizontal = param.mobileV2Horizontal, mobileV2Horizontal = _mobileV2Horizontal === void 0 ? false : _mobileV2Horizontal;
    var _Math;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var productMaxQuantity = product.maxQuantity, _name = product.name, name = _name === void 0 ? "" : _name, // productTags, // display in the cart
    tags = product.tags, volume = product.volume, _categoryCodes = product.categoryCodes, categoryCodes = _categoryCodes === void 0 ? [] : _categoryCodes, slug = product.slug, _seller = product.seller, seller = _seller === void 0 ? "" : _seller, _isDeal = product.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = product.deal, deal = _deal === void 0 ? null : _deal, cartItemType = product.type, _statusData = product.statusData, statusData = _statusData === void 0 ? {} : _statusData, isGift = product.isGift, _requireGPPMessage = product.requireGPPMessage, requireGPPMessage = _requireGPPMessage === void 0 ? null : _requireGPPMessage, isCampaign = product.isCampaign, messageLimitOrder = product.messageLimitOrder, maxQuantityPerDay = product.maxQuantityPerDay, _availableProducts = product.availableProducts, availableProducts = _availableProducts === void 0 ? 0 : _availableProducts, quantityPurchasedToday = product.quantityPurchasedToday, _errorCode = product.errorCode, errorCode = _errorCode === void 0 ? null : _errorCode, _errorMessage = product.errorMessage, errorMessage = _errorMessage === void 0 ? null : _errorMessage, _sellerCode = product.sellerCode, sellerCode = _sellerCode === void 0 ? null : _sellerCode, _lotDates = product.lotDates, lotDates = _lotDates === void 0 ? [] : _lotDates, expiredDate = product.expiredDate, _isNearOutOfStock = product.isNearOutOfStock, isNearOutOfStock = _isNearOutOfStock === void 0 ? false : _isNearOutOfStock, sku = product.sku, _skuId = product.skuId, skuId = _skuId === void 0 ? "" : _skuId, _productCode = product.productCode, productCode = _productCode === void 0 ? "" : _productCode, maxQuantity = product.maxQuantity;
    var isNearExpiration = lotDates === null || lotDates === void 0 ? void 0 : lotDates.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.isNearExpired) === true;
    });
    var mapSeller = (0,context/* useSetting */.yu)().mapSeller;
    var getErrorCart = (0,context/* useCart */.jD)().getErrorCart;
    var sellerInfo = (mapSeller === null || mapSeller === void 0 ? void 0 : mapSeller.get((seller === null || seller === void 0 ? void 0 : seller.code) || sellerCode)) || null;
    var maxQtyDeal = (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) - (deal === null || deal === void 0 ? void 0 : deal.quantity) || 0;
    // const percentDiscount = deal ? Math.round(100 - (dealPrice / salePrice) * 100) : null;
    var listMaxQuantity = [
        productMaxQuantity
    ];
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var router = (0,next_router.useRouter)();
    // nếu có số theo ngày thì mới tính
    if (maxQuantityPerDay > 0) {
        listMaxQuantity.push(maxQuantityPerDay - quantityPurchasedToday);
    }
    // limit theo ngày ( tìm min ) , nếu < 0 thì set lại về 0
    var maxQuantityProduct = isCampaign && availableProducts || isDeal && maxQtyDeal || (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(listMaxQuantity));
    if (maxQuantityProduct < 0) {
        maxQuantityProduct = 0;
    }
    // tags promo gift
    var ref1 = (0,useGetTagPromotion/* default */.Z)(), dataByPromoListsDetail = ref1.dataByPromoListsDetail, filterTagGift = ref1.filterTagGift;
    // productCardContent use productCode and productCardContentNew use skuId
    var isTagGift = filterTagGift(sku, dataByPromoListsDetail, skuId || productCode);
    var TagGiftComp = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (ProductCardContent_styles_module_default()).giftPromo,
                    children: translateCommon("gift_tag")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: " - "
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
        className: "".concat(className, "\n      ").concat(row ? (ProductCardContent_styles_module_default()).product_content : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_content, (ProductCardContent_styles_module_default()).product_content_column)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: row ? (ProductCardContent_styles_module_default()).product_title_wrap : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_title_wrap, (ProductCardContent_styles_module_default()).product_title_column_wrap),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCardContent_styles_module_default()).product_title,
                        children: [
                            isTagGift && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagGiftComp, {}),
                            ((sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isVip) && (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isStore) || (tags === null || tags === void 0 ? void 0 : tags.includes("DUREX")) || (tags === null || tags === void 0 ? void 0 : tags.includes("SANOFI"))) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#B98F0F",
                                            fontSize: isMobileV2 ? "12px" : "16px",
                                            fontFamily: "googleSansMedium"
                                        },
                                        className: (0,clsx_m/* default */.Z)(isTagGift ? (ProductCardContent_styles_module_default()).prioritizedPromo : ""),
                                        children: translateCommon(Enums/* FLAGSHIP_LABEL */.Yo)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            display: isTagGift ? "none" : ""
                                        },
                                        children: "\xa0 -\xa0 "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                href: "/product/".concat(slug || "", "/loading"),
                                prefetch: false,
                                padding: "5px 0px 5px 0px",
                                className: isMobileV2 ? (ProductCardContent_styles_module_default()).linkMobile : (ProductCardContent_styles_module_default()).link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_name, !isMobile && (ProductCardContent_styles_module_default()).flex_wrap, isMobileV2 && (ProductCardContent_styles_module_default()).product_name_mv2, mobileV2Horizontal && (ProductCardContent_styles_module_default()).product_name_mv2_horizontal),
                                    gutterBottom: true,
                                    variant: "h5",
                                    component: "h2",
                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        var sellerInfoGA, _tmp, _tmp1, _tmp2, _tmp3;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _tmp = {};
                                                    return [
                                                        4,
                                                        getSellerByCode((_tmp.code = sellerCode, _tmp.tags = tags, _tmp))
                                                    ];
                                                case 1:
                                                    sellerInfoGA = _state.sent();
                                                    _tmp1 = {};
                                                    utils/* gtag.viewItemInPage */.SX.viewItemInPage((_tmp1.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                        sellerInfo: sellerInfoGA
                                                    }), _tmp1.path = router.pathname, _tmp1));
                                                    _tmp2 = {};
                                                    _tmp3 = {};
                                                    MonitorUtils/* default.sendSKUEvent */.ZP.sendSKUEvent(Enums/* MONITORING_COLLECTOR_TYPE.SKU_DETAIL_VIEW */.Hq.SKU_DETAIL_VIEW, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, product), (_tmp3.sellerInfo = sellerInfoGA, _tmp3)), router.pathname);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    "data-test": "product-content-name",
                                    children: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name || ""
                                })
                            }),
                            cart && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CartItemPriceMobile, {
                                product: product
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(isMobileV2 ? (ProductCardContent_styles_module_default()).mobileProduct_type : (ProductCardContent_styles_module_default()).product_type, (ProductCardContent_styles_module_default()).muted),
                                children: cart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "textSecondary",
                                    component: "p",
                                    children: volume || ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_tags, (ProductCardContent_styles_module_default()).product_tags_column),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                                    product: {
                                        tags: tags,
                                        statusData: statusData,
                                        expiredDate: (isNearExpiration === null || isNearExpiration === void 0 ? void 0 : isNearExpiration.expiredDate) || expiredDate || ""
                                    },
                                    isMobile: isMobile,
                                    isMobileV2: isMobileV2,
                                    page: page,
                                    isGift: isGift,
                                    link: link,
                                    isLinkTagDeal: isLinkTagDeal
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: row ? (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_type, (ProductCardContent_styles_module_default()).muted) : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_type, (ProductCardContent_styles_module_default()).muted, (ProductCardContent_styles_module_default()).align_center),
                        children: cart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            color: "textSecondary",
                            component: "p",
                            children: volume || ""
                        })
                    })
                ]
            }),
            row === cate && categoryCodes && categoryCodes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category, (ProductCardContent_styles_module_default()).muted),
                variant: "body2",
                color: "textSecondary",
                component: "p"
            }),
            requireGPPMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                variant: "body2",
                color: "error",
                component: "p",
                children: translateCommon("productStatus.".concat(requireGPPMessage))
            }),
            cart && (cartItemType === "DEAL" || cartItemType === "COMBO") && maxQtyDeal > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: row ? (ProductCardContent_styles_module_default()).product_title_wrap : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_title_wrap, (ProductCardContent_styles_module_default()).product_title_column_wrap),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    variant: "body2",
                    color: "error",
                    component: "p",
                    children: [
                        translateCommon("only_x_product_1"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: utils/* FormatNumber.formatNumber */.AV.formatNumber(maxQtyDeal)
                        }),
                        " ",
                        translateCommon("only_x_product_2")
                    ]
                })
            }),
            cart && messageLimitOrder && !isGift ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (ProductCardContent_styles_module_default()).boxPerDay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    color: "textSecondary",
                    variant: "body2",
                    component: "p",
                    children: messageLimitOrder || ""
                })
            }) : null,
            cart && isNearOutOfStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: row ? (ProductCardContent_styles_module_default()).product_title_wrap : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_title_wrap, (ProductCardContent_styles_module_default()).product_title_column_wrap),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    variant: "body2",
                    color: "error",
                    component: "p",
                    children: translateCommon("only_quantity_product").replace("{quantity}", utils/* FormatNumber.formatNumber */.AV.formatNumber(statusData === null || statusData === void 0 ? void 0 : statusData.quantity))
                })
            }),
            cart && errorCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: row ? (ProductCardContent_styles_module_default()).product_title_wrap : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_title_wrap, (ProductCardContent_styles_module_default()).product_title_column_wrap),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    variant: "body2",
                    color: "error",
                    component: "p",
                    children: errorCode === "MAX_QUANTITY" && !isNearOutOfStock ? maxQuantityProduct === 0 ? translateCommon("message_order_exceed_limit_day") : quantityPurchasedToday === 0 ? translateCommon("only_quantity_please_update").replace("{quantity}", maxQuantityProduct) : translateCommon("buy_x_per_y_only_z").replace("{quantityPurchasedToday}", quantityPurchasedToday).replace("{maxQuantityPerDay}", maxQuantityPerDay || maxQuantity || 0).replace("{maxQuantityProduct}", maxQuantityProduct) : getErrorCart({
                        errorCode: errorCode,
                        errorMessage: errorMessage
                    })
                })
            }),
            errorCode !== "MAX_QUANTITY" && maxQuantityPerDay > 0 && maxQuantityProduct < data/* MAX_PRODUCT_QTY_DISPLAY */.Im && quantityPurchasedToday > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (ProductCardContent_styles_module_default()).boxPerDay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    color: "textSecondary",
                    variant: "body2",
                    component: "p",
                    children: translateCommon("buy_x_per_y_in_day").replace("{quantity}", quantityPurchasedToday).replace("{limit}", maxQuantityPerDay || maxQuantityProduct)
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_ProductCardContent = (ProductCardContent);


/***/ }),

/***/ 77524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_ProductCardInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardActions/CardActions.js
var CardActions = __webpack_require__(51907);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/TrendingDown.js
var TrendingDown = __webpack_require__(15527);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/TrendingUp.js
var TrendingUp = __webpack_require__(84618);
// EXTERNAL MODULE: ./src/clients/index.js + 21 modules
var clients = __webpack_require__(38169);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./src/components/atoms/NewInputProduct/index.js
var NewInputProduct = __webpack_require__(27890);
// EXTERNAL MODULE: ./src/components/atoms/QuantityButton/NewMinusButton.js
var NewMinusButton = __webpack_require__(30851);
// EXTERNAL MODULE: ./src/components/atoms/QuantityButton/NewPlusButton.js
var NewPlusButton = __webpack_require__(92959);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(33681);
// EXTERNAL MODULE: ./src/components-v2/mocules/mobile/CountdownTimer/index.js
var CountdownTimer = __webpack_require__(17368);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./src/utils/FormatDate.js
var FormatDate = __webpack_require__(45901);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/mocules/CountdownTimer/index.js
var mocules_CountdownTimer = __webpack_require__(72640);
// EXTERNAL MODULE: ./src/components/mocules/DealSectionNew/styles.module.css
var styles_module = __webpack_require__(67364);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/DealSectionNew/index.js
/* eslint-disable no-nested-ternary */ 











var DealSectionNew = function(param) {
    var dealEndDay = param.dealEndDay, dealReady = param.dealReady, dealStartTime = param.dealStartTime, _totalSold = param.totalSold, totalSold = _totalSold === void 0 ? 0 : _totalSold, _isHappeningCampaign = param.isHappeningCampaign, isHappeningCampaign = _isHappeningCampaign === void 0 ? false : _isHappeningCampaign, _percentDealSold = param.percentDealSold, percentDealSold = _percentDealSold === void 0 ? 0 : _percentDealSold;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var startDate = (0,FormatDate/* formatDate */.p6)(dealStartTime);
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        container: true,
        spacing: isMobileV2 ? 0 : 1,
        className: (0,clsx_m/* default */.Z)((styles_module_default()).deal_section, (0,_define_property/* default */.Z)({}, (styles_module_default()).deal_section_mv2, isMobileV2)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: isMobileV2 ? dealReady ? 12 : 8 : 12,
                className: (0,clsx_m/* default */.Z)((styles_module_default()).process_wrapper, (0,_define_property/* default */.Z)({}, (styles_module_default()).process_wrapper_mv2, isMobileV2)),
                children: isHappeningCampaign && dealReady && percentDealSold === 100 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
                            classes: {
                                root: (0,clsx_m/* default */.Z)((styles_module_default()).root_process, isMobileV2 && (styles_module_default()).root_process_mv2),
                                barColorPrimary: (styles_module_default()).bar_background,
                                colorPrimary: (styles_module_default()).blur_background
                            },
                            variant: "determinate",
                            value: percentDealSold
                        }),
                        !isHappeningCampaign && dealReady && percentDealSold === 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).process_content,
                            children: translateCommon("deal.sold_out")
                        }),
                        dealReady && percentDealSold < 75 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).process_content,
                            children: "".concat(translateCommon("deal.sold"), " ").concat(totalSold)
                        }),
                        !dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).process_content,
                            children: translateCommon("deal.on_sale_soon")
                        }),
                        dealReady && percentDealSold >= 75 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).process_content,
                            children: translateCommon("deal.out_of_stock_soon")
                        })
                    ]
                })
            }),
            isHappeningCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) || dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                xs: isMobileV2 ? 4 : 12,
                item: true,
                className: (styles_module_default()).count_down_container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)(isMobileV2 && (styles_module_default()).countdown_timer_mv2),
                    item: true,
                    children: isMobileV2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTimer/* default */.Z, {
                        translateCommon: translateCommon,
                        className: (styles_module_default()).count_down,
                        dealEndDay: dealEndDay
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CountdownTimer/* default */.Z, {
                        translateCommon: translateCommon,
                        className: (styles_module_default()).count_down,
                        dealEndDay: dealEndDay
                    })
                })
            }) || !dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                className: (0,clsx_m/* default */.Z)((styles_module_default()).startDate, (0,_define_property/* default */.Z)({}, (styles_module_default()).startDate_mv2, isMobileV2)),
                children: startDate
            })
        ]
    });
};
/* harmony default export */ var mocules_DealSectionNew = (DealSectionNew);

// EXTERNAL MODULE: ./src/components/organisms/RemoveProductModal/index.js + 1 modules
var RemoveProductModal = __webpack_require__(39796);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/constants/ErrorCart/index.js
var ErrorCart = __webpack_require__(83084);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./src/hooks/useModal.js
var useModal = __webpack_require__(16028);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(46680);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/components/mocules/ProductCardInput/styles.module.css
var ProductCardInput_styles_module = __webpack_require__(29606);
var ProductCardInput_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCardInput_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductCardInput/index.js
/* eslint-disable no-nested-ternary */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable no-else-return */ 


































var ProductCardInput = function(param) {
    var productMaxQuantity = param.maxQuantity, noSupportDelivery = param.not_support_delivery, _salePrice = param.salePrice, salePrice = _salePrice === void 0 ? 0 : _salePrice, _displayPrice = param.displayPrice, displayPrice = _displayPrice === void 0 ? 0 : _displayPrice, _isDeal = param.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = param.deal, deal = _deal === void 0 ? {} : _deal, row = param.row, type = param.type, searchInput = param.searchInput, cart = param.cart, productId = param.productId, name = param.name, product = param.product, isMobile = param.isMobile, cartItems = param.cartItems, scrollTo = param.scrollTo, _errorCode = param.errorCode, errorCode = _errorCode === void 0 ? null : _errorCode, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? null : _errorMessage, status = param.status, _errorMessageProduct = param.errorMessageProduct, errorMessageProduct = _errorMessageProduct === void 0 ? null : _errorMessageProduct, index = param.index, currentPrice = param.currentPrice, _wishlist = param.wishlist, wishlist = _wishlist === void 0 ? false : _wishlist, handleDelete = param.handleDelete, _isCampaign = param.// unit,
    isCampaign, isCampaign = _isCampaign === void 0 ? false : _isCampaign, productType = param.productType, _isHappeningCampaign = param.isHappeningCampaign, isHappeningCampaign = _isHappeningCampaign === void 0 ? false : _isHappeningCampaign, campaign = param.campaign, availableProducts = param.availableProducts, salePriceFormated = param.salePriceFormated, displayPriceFormated = param.displayPriceFormated, _isSellerList = param.isSellerList, isSellerList = _isSellerList === void 0 ? false : _isSellerList, _isHalfProgress = param.isHalfProgress, isHalfProgress = _isHalfProgress === void 0 ? false : _isHalfProgress, _percentDealSold = param.percentDealSold, percentDealSold = _percentDealSold === void 0 ? 0 : _percentDealSold, _isCampaignPage = param.isCampaignPage, isCampaignPage = _isCampaignPage === void 0 ? false : _isCampaignPage, messageLimitOrder = param.messageLimitOrder, sku = param.sku, _discountPercent = param.discountPercent, discountPercent = _discountPercent === void 0 ? 0 : _discountPercent, isContractPrice = param.isContractPrice;
    var GetPrice = function GetPrice() {
        // BV-1586: giá sau ưu đãi (deal + chiết khấu thanh toán + voucher), giá gạch = giá niêm yết.
        // PLP không có popover. Trang campaign đang che giá (???) thì giữ như cũ.
        if (isShowPriceAfterDiscount && !wishlist && !cart && !(isCampaign && !isHappeningCampaign && isCampaignPage)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 1,
                alignItems: "center",
                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            padding: "0",
                            width: isMobile && !beta ? "100%" : "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                            "data-test": "price-after-discount",
                            children: priceAfterDiscountFormated
                        })
                    }),
                    originPriceFormated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            padding: "0",
                            paddingLeft: "10px",
                            width: isMobile && !beta ? "100%" : "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                            children: originPriceFormated
                        })
                    })
                ]
            });
        }
        // wishlist page v2
        if (wishlist) {
            // khuyến mãi
            if (isDeal && deal || isCampaign && percentDealSold < 100) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 1,
                        alignItems: "center",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_wishlist_price_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    isContractPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractPrice, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).discount_percent_v2 : (ProductCardInput_styles_module_default()).discount_percent, discountPercent === 0 && (ProductCardInput_styles_module_default()).hidden),
                                        children: "-".concat(discountPercent, "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, isMobile && (ProductCardInput_styles_module_default()).fs_12, salePriceFormated === displayPriceFormated && (ProductCardInput_styles_module_default()).hidden),
                                        children: salePriceFormated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                style: {
                                    padding: "0",
                                    width: isMobile && !beta ? "100%" : "auto"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, isMobile && (ProductCardInput_styles_module_default()).fs_12),
                                    children: displayPriceFormated
                                })
                            })
                        ]
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        alignItems: "stretch",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).wishlist_price_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2), !isMobile && (ProductCardInput_styles_module_default()).pt_55),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                style: {
                                    paddingLeft: "0",
                                    width: isMobile && !beta ? "100%" : "auto"
                                },
                                children: [
                                    isContractPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractPrice, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                        children: displayPriceFormated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                children: [
                                    errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice > displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDown/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).down
                                    }),
                                    errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice < displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingUp/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).up
                                    })
                                ]
                            })
                        ]
                    }),
                    isDeal && deal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            width: isMobile && !beta ? "100%" : "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                            children: salePriceFormated
                        })
                    })
                ]
            });
        }
        if (isSellerList) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCardInput_styles_module_default()).salePrice_wrapper,
                        children: [
                            isHappeningCampaign && salePrice && percentDealSold < 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            }),
                            !isHappeningCampaign && displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 2,
                        alignItems: "center",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: [
                                    ((productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold < 100 || !isHappeningCampaign && !isCampaignPage) && displayPriceFormated,
                                    (productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold === 100 && salePriceFormated
                                ]
                            })
                        })
                    })
                ]
            });
        }
        if (isCampaign && percentDealSold < 100) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 2,
                    alignItems: "center",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: [
                                    ((productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold < 100 || !isHappeningCampaign && !isCampaignPage) && displayPriceFormated,
                                    (productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold === 100 && salePriceFormated,
                                    !isHappeningCampaign && isCampaignPage && (sysconfig/* ENV_COUNTRY */.ng === "vn" ? "".concat(hidenPrice, "đ") : "$ ".concat(hidenPrice))
                                ]
                            })
                        }),
                        !isHappeningCampaign && isCampaignPage && displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        isHappeningCampaign && salePrice && percentDealSold < 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            })
                        })
                    ]
                })
            });
        } else if (isDeal && deal) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 1,
                    alignItems: "center",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            })
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    alignItems: "stretch",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2), wishlist && (ProductCardInput_styles_module_default()).pt_55),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                paddingLeft: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            children: [
                                errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice > displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDown/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).down
                                }),
                                errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice < displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingUp/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).up
                                })
                            ]
                        })
                    ]
                }),
                isDeal && deal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    style: {
                        width: isMobile && !beta ? "100%" : "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                        children: salePriceFormated
                    })
                })
            ]
        });
    };
    var OrderMaximumProduct = function OrderMaximumProduct() {
        if (isCampaign && isHappeningCampaign && percentDealSold < 100 || isCampaign && productType === "MEGA_DAY" && isHappeningCampaign && percentDealSold < 100) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc)
            });
        } else if (isHappeningCampaign && percentDealSold === 100 && isCampaignPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (ProductCardInput_styles_module_default()).text_danger,
                children: translateCommon("product_card.missed_promo_price").replace("{displayPrice}", (0,FormatNumber/* formatCurrency */.xG)(campaign === null || campaign === void 0 ? void 0 : campaign.retailPriceValue) || "")
            });
        } else if (isHappeningCampaign && productType === "NORMAL" && percentDealSold === 100 && isCampaignPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (ProductCardInput_styles_module_default()).text_danger,
                children: translateCommon("product_card.missed_promo_price").replace("{displayPrice}", (0,FormatNumber/* formatCurrency */.xG)(displayPrice) || "")
            });
        } else if (messageLimitOrder) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc),
                children: messageLimitOrder
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ProductCardInput_styles_module_default()).text_danger,
            children: " "
        });
    };
    var ref, ref1, ref2;
    var ref3 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref3.t;
    var ref4 = (0,context/* useCart */.jD)(), updateCartItem = ref4.updateCartItem, removeCartItem = ref4.removeCartItem, mapQuantity = ref4.mapQuantity, validate200Item = ref4.validate200Item;
    var ref5 = (0,context/* useAuth */.aC)(), isAuthenticated = ref5.isAuthenticated, toggleLogin = ref5.toggleLogin;
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    var ref6 = (0,context/* useProduct */.iB)(), getInfoProductPerDay = ref6.getInfoProductPerDay, getProductError = ref6.getProductError;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(), 2), isShowModalRemove = ref7[0], toggleRemove = ref7[1];
    var ref8 = (0,react.useState)(false), isFocus = ref8[0], setIsFocus = ref8[1];
    var ref9 = (0,react.useState)(), inputElement = ref9[0], setInputElement = ref9[1];
    var ref10 = (0,react.useState)(product.quantity || 0), value = ref10[0], setValue = ref10[1];
    var ref11 = campaign || {}, _soldQuantity = ref11.soldQuantity, soldQuantity = _soldQuantity === void 0 ? 0 : _soldQuantity;
    // BV-1586: field giá sau ưu đãi do WebService.convertProductV2 map từ BFF
    var ref12 = product || {}, _isShowPriceAfterDiscount = ref12.isShowPriceAfterDiscount, isShowPriceAfterDiscount = _isShowPriceAfterDiscount === void 0 ? false : _isShowPriceAfterDiscount, _priceAfterDiscountFormated = ref12.priceAfterDiscountFormated, priceAfterDiscountFormated = _priceAfterDiscountFormated === void 0 ? "" : _priceAfterDiscountFormated, _originPriceFormated = ref12.originPriceFormated, originPriceFormated = _originPriceFormated === void 0 ? "" : _originPriceFormated;
    var maxQuantityProduct = isCampaign && availableProducts || isDeal && availableProducts || productMaxQuantity;
    var percentDeal = ((deal === null || deal === void 0 ? void 0 : deal.quantity) || 0) / (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) * 100;
    var outOfStock = (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) === ((deal === null || deal === void 0 ? void 0 : deal.quantity) || 0) || false;
    var timeLeft = (0,utils/* calculateTimeLeft */.VZ)(deal === null || deal === void 0 ? void 0 : deal.startTime) || (0,utils/* calculateTimeLeft */.VZ)(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.campaign) === null || ref === void 0 ? void 0 : ref.startTime) || {};
    var dealReady = Object.keys(timeLeft).length === 0 || false;
    var outOfDate = deal && deal.endTime && new Date(deal.endTime) < new Date() || false;
    var importantList = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
        return item.isSelected && item.isImportant;
    });
    var historyBySku = getInfoProductPerDay();
    var ref13 = getProductError({
        product: product
    }), _errorRequiredCertificate = ref13.errorRequiredCertificate, errorRequiredCertificate = _errorRequiredCertificate === void 0 ? false : _errorRequiredCertificate, errorRequiredCertificateMessage = ref13.errorRequiredCertificateMessage;
    (0,react.useEffect)(function() {
        setInputElement(Object.values(searchInput.current)[0]);
    }, []);
    var canDeleteProduct = function() {
        var quantityAfterDel = cartItems.length - 1;
        var importantQuantity = importantList.length;
        var importantQuantityMax = Math.floor(quantityAfterDel * data/* IMPORTANT_PERCENT_MAX */.en);
        if (product.isImportant) importantQuantity -= 1;
        return !(importantQuantity > importantQuantityMax);
    };
    var updateCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(q) {
            var isReload, response, _tmp, ref, tmp, quantityResponse, _tmp1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        if (!q) {
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            updateCartItem((_tmp.product = product, _tmp.q = parseFloat(q), _tmp), isReload, cart)
                        ];
                    case 1:
                        response = _state.sent();
                        _tmp1 = {};
                        if ((0,clients/* isValid */.JY)(response)) {
                            ref = (0,clients/* getFirst */.Xi)(response, _tmp1), tmp = ref.quantity, quantityResponse = tmp === void 0 ? null : tmp;
                            if (quantityResponse !== null) {
                                setValue(quantityResponse);
                            }
                        } else {
                            setValue(0);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function updateCart(q) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!cart) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            removeCartItem(product, true)
                        ];
                    case 1:
                        _state.sent();
                        inputElement.value = 0;
                        setValue(0);
                        toggleRemove();
                        return [
                            2
                        ];
                    case 2:
                        if (!canDeleteProduct()) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            removeCartItem(product, cart)
                        ];
                    case 3:
                        _state.sent();
                        inputElement.value = 0;
                        setValue(0);
                        scrollTo(window.pageYOffset);
                        return [
                            2
                        ];
                    case 4:
                        toggleRemove();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemove() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancle = function() {
        toggleRemove();
        inputElement.value = value;
        if (value === 0) {
            updateCart(1);
            setValue(1);
        }
    };
    var handleCart = function(val, updateType) {
        if (updateType === "remove") {
            toggleRemove();
        }
        if (updateType === "update") {
            updateCart(val);
        }
    };
    var handleClickInput = function(e) {
        e.stopPropagation();
    };
    var handler = (0,react.useCallback)(function(val, updateType) {
        if (isMobile) {
            (0,debounce/* debounceFunc1000 */.zB)(function() {
                return handleCart(val, updateType);
            });
        } else {
            (0,debounce/* debounceFunc400 */.EI)(function() {
                return handleCart(val, updateType);
            });
        }
    }, []);
    var handleDecrease = function(e) {
        e.stopPropagation();
        if (inputElement.value < 1) return;
        var q = parseInt(inputElement.value, 10) - 1;
        if (q < 1) {
            handler(product, "remove");
            return;
        }
        inputElement.value = q;
        setValue(q);
        handler(q, "update");
    };
    var handleIncrease = function(e) {
        e.stopPropagation();
        if (validate200Item(product === null || product === void 0 ? void 0 : product.sku)) {
            var q = parseInt(inputElement.value, 10) + 1;
            inputElement.value = q;
            setValue(q);
            handler(q, "update");
        }
    };
    var handleInputChange = function(e) {
        try {
            var ref;
            var val = e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.value.replace(/[^\d]/g, "");
            Object.values(searchInput.current)[0].value = Math.min(maxQuantityProduct, val);
        } catch (error) {
            console.error("Error : ", error);
        }
    };
    var handleOnBlur = function(e) {
        setIsFocus(false);
        if (validate200Item(product === null || product === void 0 ? void 0 : product.sku)) {
            var ref;
            var val = (e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.value) || value;
            if (/^\d+$/.test(val) && +val >= 0) {
                var curValue = parseFloat(val || 0);
                curValue = Math.min(maxQuantityProduct, curValue);
                if (curValue === value) return;
                // nếu value là 0 thì sẽ remove && quanity trong cartItems
                // TODO: nếu onblur 0 , rồi nhấn vào nút - cho kế bên
                if (curValue === 0 && (mapQuantity === null || mapQuantity === void 0 ? void 0 : mapQuantity.get(product === null || product === void 0 ? void 0 : product.sku)) > 0) {
                    handler(product, "remove");
                    return;
                }
                setValue(curValue);
                if (curValue || curValue !== 0) handler(+curValue, "update");
            }
        } else {
            setValue(0);
            Object.values(searchInput.current)[0].value = 0;
        }
    };
    var handleOnKeyDown = function(e) {
        var positionEl = Number(Object.keys(searchInput.current)[0]);
        var inputs = document === null || document === void 0 ? void 0 : document.querySelectorAll("[class*='product_action'] input");
        if (e.keyCode === 13) {
            var ref;
            handleOnBlur(e);
            (ref = (inputs === null || inputs === void 0 ? void 0 : inputs[positionEl]) || (inputs === null || inputs === void 0 ? void 0 : inputs[positionEl + 1])) === null || ref === void 0 ? void 0 : ref.focus();
        }
        if (e.keyCode === 9) {
            var ref1;
            e.preventDefault();
            inputs === null || inputs === void 0 ? void 0 : (ref1 = inputs[positionEl + 1]) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    var checkProductAvailable = function() {
        return status === "OUT_OF_STOCK" || status === "SUSPENDED" || outOfStock || outOfDate;
    };
    if (errorMessageProduct || !product.salePrice || product.status === "STOP_SELLING" || product.salePrice === 0) {
        if (wishlist) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: isMobile ? (ProductCardInput_styles_module_default()).wishlist_err_wrapper_mobile : (ProductCardInput_styles_module_default()).wishlist_err_wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: row ? (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).text_center) : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_danger),
                        children: errorMessageProduct && translateCommon("product_error.".concat(errorMessageProduct)) || errorMessage || translateCommon("productStatus.STOP_SELLING")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).btn_del_m_wrapper : (ProductCardInput_styles_module_default()).product_action_column, !isMobile && (ProductCardInput_styles_module_default()).p_0),
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (ProductCardInput_styles_module_default()).btn_del_text,
                            onClick: handleDelete,
                            children: translateCommon("btn.delete")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                            title: translateCommon("cardBuy.remove_wishlist"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).remove_icon,
                                onClick: handleDelete,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                    className: (ProductCardInput_styles_module_default()).icon
                                })
                            })
                        })
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: row ? (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).text_center, (ProductCardInput_styles_module_default()).text_padding) : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_danger),
                    children: errorMessageProduct && translateCommon("product_error.".concat(errorMessageProduct)) || errorMessage || translateCommon("productStatus.STOP_SELLING")
                })
            ]
        });
    }
    var hidenPrice = campaign === null || campaign === void 0 ? void 0 : campaign.salePriceLabel;
    if (isCampaign && (campaign === null || campaign === void 0 ? void 0 : campaign.isValid) === false) {
        var ref14, ref15, ref16;
        var lengthSalePriceLabel = campaign === null || campaign === void 0 ? void 0 : (ref14 = campaign.salePriceLabel) === null || ref14 === void 0 ? void 0 : ref14.length;
        if (lengthSalePriceLabel > 3) hidenPrice = "".concat(campaign === null || campaign === void 0 ? void 0 : (ref15 = campaign.salePriceLabel) === null || ref15 === void 0 ? void 0 : ref15.slice(0, lengthSalePriceLabel - 3), ".").concat(campaign === null || campaign === void 0 ? void 0 : (ref16 = campaign.salePriceLabel) === null || ref16 === void 0 ? void 0 : ref16.slice(lengthSalePriceLabel - 3));
    }
    var ContractPrice = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (ProductCardInput_styles_module_default()).contractLabel,
            children: translateCommon("contract_price")
        });
    };
    var checkAndRenderQuantityProduct = function() {
        var text = "";
        historyBySku === null || historyBySku === void 0 ? void 0 : historyBySku.forEach(function(item) {
            if ((item === null || item === void 0 ? void 0 : item.sku) === sku) {
                // text = item?.quantity > 0 && `Bạn đã mua ${formatNumber(item?.quantity)} / ${formatNumber(item?.limitQuantity)} sản phẩm trong ngày`;
                text = (item === null || item === void 0 ? void 0 : item.quantity) > 0 && "".concat(translateCommon("product_card").replace("{quantity}", (0,FormatNumber/* formatNumber */.uf)(item === null || item === void 0 ? void 0 : item.quantity)).replace("{limitQuantity}", (0,FormatNumber/* formatNumber */.uf)(item === null || item === void 0 ? void 0 : item.limitQuantity)));
            }
            if ((item === null || item === void 0 ? void 0 : item.quantity) > (item === null || item === void 0 ? void 0 : item.limitQuantity)) {
                text = "";
            }
        });
        return text;
    };
    var handleOnFocus = function(e) {
        e.preventDefault();
        setIsFocus(true);
    };
    // wishlist page v2
    if (wishlist) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).card_wishlist_mobile_wrapper : (ProductCardInput_styles_module_default()).card_wishlist_wrapper),
            children: [
                errorRequiredCertificate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                marginBottom: ""
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        marginBottom: ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    style: {
                                        textAlign: "center"
                                    },
                                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger),
                                    children: errorRequiredCertificateMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                            title: translateCommon("cardBuy.remove_wishlist"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).remove_icon,
                                onClick: handleDelete,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                    className: (ProductCardInput_styles_module_default()).icon
                                })
                            })
                        })
                    ]
                }) : noSupportDelivery ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginBottom: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                marginBottom: "16px"
                            },
                            className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).deal_price,
                                children: (0,FormatNumber/* formatCurrency */.xG)(salePrice)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            style: {
                                textAlign: "center"
                            },
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).center),
                            children: translateCommon("product_card.not_supporting_province")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProductCardInput_styles_module_default()).wishlist_input_container,
                    children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !isSellerList && errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: row ? (ProductCardInput_styles_module_default()).text_danger : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_change_price, (ProductCardInput_styles_module_default()).text_danger),
                                children: [
                                    translateCommon("cardBuy.product_change_price_Old_price"),
                                    " ",
                                    (0,FormatNumber/* formatCurrency */.xG)(currentPrice)
                                ]
                            }),
                            messageLimitOrder && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).text_desc_wishlist,
                                children: messageLimitOrder
                            }),
                            checkAndRenderQuantityProduct() && !isMobile(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).text_quantity_wishlist,
                                children: checkAndRenderQuantityProduct()
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).wishlist_price, isMobile && (ProductCardInput_styles_module_default()).ml_10),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetPrice, {})
                            }),
                            isDeal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: !dealReady,
                                                onClick: handleDecrease,
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onBlur: handleOnBlur,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                onClick: handleClickInput,
                                                onKeyDown: handleOnKeyDown,
                                                type: type,
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                                disabled: checkProductAvailable() || !dealReady,
                                                onFocus: handleOnFocus
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || !dealReady || maxQuantityProduct && value >= maxQuantityProduct,
                                                onClick: function(e) {
                                                    return handleIncrease(e);
                                                },
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }) || isCampaign && availableProducts > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: !dealReady,
                                                onClick: handleDecrease,
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onClick: handleClickInput,
                                                onBlur: handleOnBlur,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                onKeyDown: handleOnKeyDown,
                                                type: type,
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                                disabled: checkProductAvailable() || !dealReady,
                                                onFocus: handleOnFocus
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || !dealReady || availableProducts && value >= availableProducts,
                                                onClick: function() {
                                                    return handleIncrease();
                                                },
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: checkProductAvailable(),
                                                onClick: handleDecrease,
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onBlur: handleOnBlur,
                                                onKeyDown: handleOnKeyDown,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                                disabled: checkProductAvailable(),
                                                onFocus: handleOnFocus
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || maxQuantityProduct && value >= maxQuantityProduct,
                                                onClick: function(e) {
                                                    return handleIncrease(e);
                                                },
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }),
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductCardInput_styles_module_default()).btn_del_m_wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).btn_del_text,
                                    onClick: handleDelete,
                                    children: translateCommon("btn.delete")
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                title: translateCommon("cardBuy.remove_wishlist"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).remove_icon,
                                    onClick: handleDelete,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                        className: (ProductCardInput_styles_module_default()).icon
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardInput_styles_module_default()).view_signin_btn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            color: "#fff",
                            backgroundColor: "#005C29",
                            className: (ProductCardInput_styles_module_default()).signin_btn,
                            onClick: toggleLogin,
                            children: translateCommon("cardBuy.login_to_see_prices")
                        })
                    })
                }),
                isShowModalRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                    product: product,
                    visible: isShowModalRemove,
                    onClose: handleCancle,
                    onRemove: handleRemove
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).card_wrapper, isMobileV2 && (ProductCardInput_styles_module_default()).card_wrapper_mv2),
        children: [
            !isSellerList && isHalfProgress && (isDeal || isDeal && isHappeningCampaign && percentDealSold === 100) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductCardInput_styles_module_default()).deal_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_DealSectionNew, {
                    dealStartTime: deal === null || deal === void 0 ? void 0 : deal.startTime,
                    dealEndDay: deal === null || deal === void 0 ? void 0 : deal.endTime,
                    dealReady: dealReady,
                    maxQuantity: deal === null || deal === void 0 ? void 0 : deal.maxQuantity,
                    totalSold: (deal === null || deal === void 0 ? void 0 : deal.quantity) || 0,
                    percentDealSold: percentDeal || 0
                })
            }),
            noSupportDelivery ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginBottom: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginBottom: "16px"
                        },
                        className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (ProductCardInput_styles_module_default()).deal_price,
                            children: (0,FormatNumber/* formatCurrency */.xG)(salePrice)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        style: {
                            textAlign: "center"
                        },
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).center),
                        children: translateCommon("product_card.not_supporting_province")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isSellerList && errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).text_danger : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_change_price, (ProductCardInput_styles_module_default()).text_danger),
                            children: [
                                translateCommon("cardBuy.product_change_price_Old_price"),
                                " ",
                                (0,FormatNumber/* formatCurrency */.xG)(currentPrice)
                            ]
                        }),
                        !isSellerList && (isHappeningCampaign && percentDealSold < 100 || isHappeningCampaign && isDeal && availableProducts > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProductCardInput_styles_module_default()).campaign_deal_container,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_DealSectionNew, {
                                dealReady: productType === "NORMAL" ? dealReady : isHappeningCampaign,
                                isHappeningCampaign: isHappeningCampaign,
                                dealStartTime: campaign === null || campaign === void 0 ? void 0 : (ref1 = campaign.campaign) === null || ref1 === void 0 ? void 0 : ref1.startTime,
                                dealEndDay: campaign === null || campaign === void 0 ? void 0 : (ref2 = campaign.campaign) === null || ref2 === void 0 ? void 0 : ref2.endTime,
                                totalSold: soldQuantity || 0,
                                percentDealSold: percentDealSold
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GetPrice, {}),
                        !isSellerList && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderMaximumProduct, {}),
                        !isSellerList && (isDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: !dealReady,
                                        onClick: handleDecrease,
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        onClick: handleClickInput,
                                        onKeyDown: handleOnKeyDown,
                                        type: type,
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                        disabled: checkProductAvailable() || !dealReady,
                                        onFocus: handleOnFocus
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || !dealReady || maxQuantityProduct && value >= maxQuantityProduct,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                    })
                                ]
                            })
                        }) || isCampaign && availableProducts > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: !dealReady,
                                        onClick: handleDecrease,
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        onClick: handleClickInput,
                                        onKeyDown: handleOnKeyDown,
                                        type: type,
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                        disabled: checkProductAvailable() || !dealReady,
                                        onFocus: handleOnFocus
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || !dealReady || availableProducts && value >= availableProducts,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                    })
                                ]
                            })
                        }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: checkProductAvailable(),
                                        onClick: handleDecrease,
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        onKeyDown: handleOnKeyDown,
                                        onClick: handleClickInput,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                        disabled: checkProductAvailable(),
                                        onFocus: handleOnFocus
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || maxQuantityProduct && value >= maxQuantityProduct,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                    })
                                ]
                            })
                        })),
                        !isSellerList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc),
                            children: checkAndRenderQuantityProduct()
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProductCardInput_styles_module_default()).view_signin_btn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        color: "#fff",
                        backgroundColor: "#005C29",
                        className: (ProductCardInput_styles_module_default()).signin_btn,
                        onClick: toggleLogin,
                        children: translateCommon("cardBuy.login_to_see_prices")
                    })
                })
            }),
            isShowModalRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                product: product,
                visible: isShowModalRemove,
                onClose: handleCancle,
                onRemove: handleRemove
            })
        ]
    });
};
/* harmony default export */ var mocules_ProductCardInput = (ProductCardInput);


/***/ }),

/***/ 35632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_ProductCardNew; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(18463);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/hooks/useTrackingMonitor.js
var useTrackingMonitor = __webpack_require__(64875);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(46680);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/utils/MonitorUtils.js + 1 modules
var MonitorUtils = __webpack_require__(79903);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js + 2 modules
var useSellers = __webpack_require__(14626);
// EXTERNAL MODULE: ./src/components/mocules/FavoriteButton/index.js + 1 modules
var FavoriteButton = __webpack_require__(50267);
// EXTERNAL MODULE: ./src/components/mocules/ProductCardInput/index.js + 1 modules
var ProductCardInput = __webpack_require__(77524);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/zustand-lib/useGetTagPromotion.js
var useGetTagPromotion = __webpack_require__(98300);
// EXTERNAL MODULE: ./src/components/mocules/index.js + 103 modules
var mocules = __webpack_require__(10565);
// EXTERNAL MODULE: ./src/components/mocules/PointOfProduct/index.js
var PointOfProduct = __webpack_require__(2337);
// EXTERNAL MODULE: ./src/components/mocules/TagComponent/index.js + 2 modules
var TagComponent = __webpack_require__(22535);
// EXTERNAL MODULE: ./src/components/mocules/ProductCartContentNew/styles.module.css
var styles_module = __webpack_require__(67868);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductCartContentNew/index.js
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable camelcase */ 



























var ProductCardContentNew = function(param) {
    var row = param.row, product = param.product, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, isSellerList = param.isSellerList, _className = param.className, className = _className === void 0 ? "" : _className, link = param.link, isLinkTagDeal = param.isLinkTagDeal;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var _name = product.name, name = _name === void 0 ? "" : _name, isNew = product.isNew, point = product.point, pointMultiplier = product.pointMultiplier, tags = product.tags, volume = product.volume, slug = product.slug, seller = product.seller, _isDeal = product.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = product.deal, deal = _deal === void 0 ? null : _deal, _statusData = product.statusData, statusData = _statusData === void 0 ? {} : _statusData, sellerCode = product.sellerCode, isGift = product.isGift, _expiredDate = product.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate, _lotDates = product.lotDates, lotDates = _lotDates === void 0 ? [] : _lotDates, _sku = product.sku, sku = _sku === void 0 ? "" : _sku, tmp = product.skuId, productCode = tmp === void 0 ? "" : tmp;
    var isNearExpiration = (lotDates === null || lotDates === void 0 ? void 0 : lotDates.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.isNearExpired) === true;
    })) || {};
    var getNameSeller = (0,context/* useSetting */.yu)().getNameSeller;
    var sellerInfo = getNameSeller({
        seller: seller
    });
    var ref1 = sellerInfo || {}, _isVip = ref1.isVip, isVip = _isVip === void 0 ? null : _isVip, _isStore = ref1.isStore, isStore = _isStore === void 0 ? false : _isStore;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    // tag gifts promotion
    var ref2 = (0,useGetTagPromotion/* default */.Z)(), dataByPromoListsDetail = ref2.dataByPromoListsDetail, filterTagGift = ref2.filterTagGift;
    // productCardContent use productCode and productCardContentNew use skuId
    var isTagGift = filterTagGift(sku, dataByPromoListsDetail, productCode);
    var router = (0,next_router.useRouter)();
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    // const shortTagNameList = tags?.filter((item) => item !== 'NEAR_EXPIRATION' && item !== 'HOADONNHANH' && item !== 'W80T' && item !== 'BANCHAY');
    var SellerVip = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (0,clsx_m/* default */.Z)(isTagGift ? (styles_module_default()).prioritizedGiftTag : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#B98F0F",
                        fontSize: "14px",
                        fontFamily: "googleSansMedium"
                    },
                    children: translateCommon(Enums/* FLAGSHIP_LABEL */.Yo)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        fontSize: "14px",
                        color: "#000"
                    },
                    children: " - "
                })
            ]
        });
    };
    var isTagGiftByPromotion = function() {
        return isTagGift ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (styles_module_default()).giftPromo,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        fontFamily: "ggsm"
                    },
                    children: translateCommon("gift_tag")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "black"
                    },
                    children: " - "
                })
            ]
        }) : "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(className, (styles_module_default()).product_content, (0,_define_property/* default */.Z)({}, (styles_module_default()).product_content_column, !row)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                direction: "row",
                alignItems: "center",
                className: (0,clsx_m/* default */.Z)((styles_module_default()).wrapPlusPoint, (0,_define_property/* default */.Z)({}, (styles_module_default()).wrapPlusPoint_mv2, isMobileV2)),
                children: !isSellerList && point > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PointOfProduct/* default */.Z, {
                    point: point,
                    pointMultiplier: pointMultiplier
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).product_title,
                children: isGift ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (isVip && isStore || (tags === null || tags === void 0 ? void 0 : tags.indexOf("DUREX")) >= 0 || (tags === null || tags === void 0 ? void 0 : tags.indexOf("SANOFI")) >= 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerVip, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((styles_module_default()).product_name, (styles_module_default()).giftlink, (0,_define_property/* default */.Z)({}, (styles_module_default()).product_name_mv2, isMobileV2)),
                            gutterBottom: true,
                            variant: "h5",
                            component: "h2",
                            children: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    style: {
                        lineHeight: "1.2"
                    },
                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        var sellerInfoData, _tmp, _tmp1, _tmp2, _tmp3;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _tmp = {};
                                    return [
                                        4,
                                        getSellerByCode((_tmp.code = sellerCode, _tmp.tags = tags, _tmp))
                                    ];
                                case 1:
                                    sellerInfoData = _state.sent();
                                    _tmp1 = {};
                                    utils/* gtag.viewItemInPage */.SX.viewItemInPage((_tmp1.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                        sellerInfoData: sellerInfoData
                                    }), _tmp1.path = router.pathname, _tmp1));
                                    _tmp2 = {};
                                    _tmp3 = {};
                                    MonitorUtils/* default.sendSKUEvent */.ZP.sendSKUEvent(Enums/* MONITORING_COLLECTOR_TYPE.SKU_DETAIL_VIEW */.Hq.SKU_DETAIL_VIEW, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, product), (_tmp3.sellerInfoData = sellerInfoData, _tmp3)), router.pathname);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: [
                        isNew && !isVip && !isTagGift && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(Paths/* PRODUCTS_LOADING_URL */.iB, "?tag=").concat(sysconfig/* TAG_NEW */.cC),
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (styles_module_default()).new_tag,
                                        children: [
                                            translateCommon("text_new"),
                                            " "
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).dash_tag,
                                        children: " - "
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                (isVip && isStore || (tags === null || tags === void 0 ? void 0 : tags.indexOf("DUREX")) >= 0 || (tags === null || tags === void 0 ? void 0 : tags.indexOf("SANOFI")) >= 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerVip, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                    href: "/product/".concat(slug || "", "/loading"),
                                    prefetch: false,
                                    style: {
                                        paddingLeft: "0",
                                        display: "inline"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                        title: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (0,clsx_m/* default */.Z)((styles_module_default()).product_name, (0,_define_property/* default */.Z)({}, (styles_module_default()).product_name_mv2, isMobileV2)),
                                            children: [
                                                isTagGiftByPromotion(),
                                                " ",
                                                isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            !isSellerList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: volume,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (styles_module_default()).product_volume,
                    variant: "body2",
                    color: "textSecondary",
                    component: "p",
                    children: "".concat(volume, " ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((styles_module_default()).product_tags, (styles_module_default()).product_tags_column, (0,_define_property/* default */.Z)({}, (styles_module_default()).product_tag_mv2, isMobileV2)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                    product: {
                        tags: tags,
                        statusData: statusData,
                        expiredDate: (isNearExpiration === null || isNearExpiration === void 0 ? void 0 : isNearExpiration.expiredDate) || expiredDate || ""
                    },
                    isMobile: isMobile,
                    isMobileV2: isMobileV2,
                    isProductCard: true,
                    isGift: isGift,
                    link: link,
                    isLinkTagDeal: isLinkTagDeal
                })
            })
        ]
    });
};
/* harmony default export */ var ProductCartContentNew = (ProductCardContentNew);

// EXTERNAL MODULE: ./src/components/mocules/ProductCardNew/styles.module.css
var ProductCardNew_styles_module = __webpack_require__(17688);
var ProductCardNew_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCardNew_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductCardNew/index.js




























// contain mobile v2 style
var ProductCardNew = function(param) {
    var product = param.product, type = param.type, tag = param.tag, onIncrement = param.onIncrement, index = param.index, isMobile = param.isMobile, _isSellerList = param.isSellerList, isSellerList = _isSellerList === void 0 ? false : _isSellerList, _isHalfProgress = param.isHalfProgress, isHalfProgress = _isHalfProgress === void 0 ? false : _isHalfProgress, _isCampaignPage = param.isCampaignPage, isCampaignPage = _isCampaignPage === void 0 ? false : _isCampaignPage, _isBestProduct = param.isBestProduct, isBestProduct = _isBestProduct === void 0 ? false : _isBestProduct, link = param.link, isLinkTagDeal = param.isLinkTagDeal;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var _isContractPrice = product.isContractPrice, isContractPrice = _isContractPrice === void 0 ? false : _isContractPrice, name = product.name, slug = product.slug, discountPercent = product.discountPercent, defaultImage = product.defaultImage, tags = product.tags;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var searchInput = (0,react.useRef)([]);
    var router = (0,next_router.useRouter)();
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var trackingRef = (0,react.useRef)(null);
    var moveToDetail = function() {
        if (isMobileV2) router.push("/product/".concat(slug || "", "/loading"));
    };
    (0,useTrackingMonitor/* default */.Z)(trackingRef, product, isMobile);
    // udpate giá hợp đồng
    // let nameLabel = null;
    var nameLabel = "";
    if (isContractPrice) {
        nameLabel = translateCommon("contract_price");
    } else if (discountPercent) {
        nameLabel = "- ".concat(discountPercent, "%");
    }
    var _obj;
    // promotion
    // const { getPromoLists } = useGetTagPromotion();
    // useEffect(() => {
    //   const controller = new AbortController();
    //   const { signal } = controller;
    //   getPromoLists({ skus: [product?.sku], getVoucherInfo: false, signal });
    //   return () => controller.abort();
    // }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        onClick: moveToDetail,
        className: (ProductCardNew_styles_module_default()).container,
        ref: trackingRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            className: (0,clsx_m/* default */.Z)((ProductCardNew_styles_module_default()).product_card, isBestProduct && (ProductCardNew_styles_module_default()).product_card_bestProduct, (0,_define_property/* default */.Z)({}, (ProductCardNew_styles_module_default()).product_card_mv2, isMobileV2)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ProductCardNew_styles_module_default()).icon_wrapper,
                            children: [
                                nameLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    label: nameLabel,
                                    className: (0,clsx_m/* default */.Z)((ProductCardNew_styles_module_default()).product_tag, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (ProductCardNew_styles_module_default()).product_tag_mv2, isMobileV2), (0,_define_property/* default */.Z)(_obj, (ProductCardNew_styles_module_default()).product_tab_contract, isContractPrice), _obj))
                                }),
                                !isSellerList && /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteButton/* default */.Z, {
                                    product: product,
                                    isProductCard: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProductCardNew_styles_module_default()).product_image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                style: {
                                    width: "100%",
                                    height: "160px",
                                    position: "relative",
                                    transform: "scale(0.85)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                    href: "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat(slug || "", "/loading"),
                                    prefetch: false,
                                    style: {
                                        padding: "0px"
                                    },
                                    "data-test": "product-no-".concat(index),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                        src: defaultImage,
                                        fallbackSrc: defaultImage,
                                        alt: name && name,
                                        title: name && name,
                                        className: (0,clsx_m/* default */.Z)([
                                            (ProductCardNew_styles_module_default()).image,
                                            isMobile && (ProductCardNew_styles_module_default()).image_mobile
                                        ]),
                                        layout: "fill",
                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            var sellerInfo, _tmp, _tmp1, _tmp2, _tmp3;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {};
                                                        return [
                                                            4,
                                                            getSellerByCode((_tmp.code = product === null || product === void 0 ? void 0 : product.sellerCode, _tmp.tags = tags, _tmp))
                                                        ];
                                                    case 1:
                                                        sellerInfo = _state.sent();
                                                        _tmp1 = {};
                                                        utils/* gtag.viewItemInPage */.SX.viewItemInPage((_tmp1.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                            sellerInfo: sellerInfo
                                                        }), _tmp1.path = router.pathname, _tmp1));
                                                        _tmp2 = {};
                                                        _tmp3 = {};
                                                        MonitorUtils/* default.sendSKUEvent */.ZP.sendSKUEvent(Enums/* MONITORING_COLLECTOR_TYPE.SKU_DETAIL_VIEW */.Hq.SKU_DETAIL_VIEW, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, product), (_tmp3.sellerInfo = sellerInfo, _tmp3)), router.pathname);
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCartContentNew, {
                            tag: tag,
                            row: true,
                            product: product,
                            isMobile: isMobile,
                            isSellerList: isSellerList,
                            link: link,
                            isLinkTagDeal: isLinkTagDeal
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,react.createElement)(ProductCardInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        searchInput: searchInput,
                        index: index,
                        product: product,
                        onIncrement: onIncrement,
                        type: type,
                        row: true,
                        isSellerList: isSellerList,
                        isHalfProgress: isHalfProgress,
                        isCampaignPage: isCampaignPage
                    }, product), {
                        key: product === null || product === void 0 ? void 0 : product.sku,
                        isMobile: isMobile
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_ProductCardNew = (/*#__PURE__*/(0,react.memo)(ProductCardNew));


/***/ }),

/***/ 88491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductDetailTabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41423);
/* harmony import */ var _material_ui_lab_TabContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78207);
/* harmony import */ var _material_ui_lab_TabList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37313);
/* harmony import */ var _material_ui_lab_TabPanel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64532);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72045);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65369);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable react/no-danger */ 








function ProductDetailTabs(param) {
    var data = param.data, product = param.product, handleChange = param.handleChange, value = param.value, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("ingredient"), translateIngredient = ref.t;
    var ref1 = product || {}, _description = ref1.description, description = _description === void 0 ? {} : _description;
    var tabData = (data === null || data === void 0 ? void 0 : data.filter(function(item) {
        return item.value === value;
    })[0]) || {};
    var des = description && description[tabData.code] !== "" ? description[tabData.code] : translateIngredient("updating");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().root),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_lab_TabContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
            value: value,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_TabList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        TabIndicatorProps: {
                            className: isMobileV2 ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().mobileIndicator) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().indicator)
                        },
                        onChange: handleChange,
                        "aria-label": "product details tabs",
                        variant: "scrollable",
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().tabs),
                        children: data.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                classes: {
                                    root: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().tab)
                                },
                                label: translateIngredient("tab.".concat(item.code)),
                                value: item.value
                            }, (0,uuid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)());
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_TabPanel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().tab_panel),
                    value: tabData === null || tabData === void 0 ? void 0 : tabData.value,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().content),
                        dangerouslySetInnerHTML: {
                            __html: des
                        }
                    })
                }, (0,uuid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)())
            ]
        })
    });
};


/***/ }),

/***/ 66926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_SearchProduct; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./src/clients/index.js + 21 modules
var clients = __webpack_require__(38169);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/index.js
var styles = __webpack_require__(71637);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
// EXTERNAL MODULE: ./src/components/mocules/SearchDropdownFeedback/styles.module.css
var styles_module = __webpack_require__(55166);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchDropdownFeedback/index.js






var SearchDropdownFeedback = function(props) {
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var data = props.data, keyword = props.keyword, onClickItem = props.onClickItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).searchDropdown,
        children: data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: data === null || data === void 0 ? void 0 : data.map(function(item) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                    className: (styles_module_default()).searchResults,
                    href: (0,Paths/* getPathProductBySlug */.hq)(item.sku.slug),
                    onClick: function(e) {
                        e.preventDefault();
                        if (onClickItem) onClickItem(item);
                    },
                    children: item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref.name
                }, (0,v4/* default */.Z)());
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (styles_module_default()).searchResults,
            children: [
                translateCommon("nav_bar.no_product"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                    children: keyword
                }),
                "\xa0\xa0",
                translateCommon("nav_bar.in"),
                "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    className: (styles_module_default()).textPrimary,
                    children: translateCommon("all_products")
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_SearchDropdownFeedback = (SearchDropdownFeedback);

// EXTERNAL MODULE: ./src/components/mocules/SearchProduct/styles.module.css
var SearchProduct_styles_module = __webpack_require__(70179);
var SearchProduct_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchProduct_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchProduct/index.js

















var SearchProduct = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var classCustom = _param.classCustom, text = _param.text, handleKeyDown = _param.handleKeyDown, onClickItem = _param.onClickItem, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "classCustom",
        "text",
        "handleKeyDown",
        "onClickItem"
    ]);
    var ref = (0,react.useState)([]), searchProduct = ref[0], setSearchProduct = ref[1];
    var ref1 = (0,react.useState)(text || ""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,react.useState)(false), hidden = ref2[0], setHidden = ref2[1];
    var ref3 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref3.t;
    var handleSearchbox = function(e) {
        var val = e.target.value;
        setKeyword(val);
        setHidden(true);
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                clients/* SearchClient.searchKeywords */.w9.searchKeywords(val)
                            ];
                        case 1:
                            res = _state.sent();
                            setSearchProduct(res);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        (0,debounce/* debounceFunc200 */.dW)(fetchData);
    };
    var clickProduct = function(product) {
        onClickItem(product);
        setKeyword(product.product.name || text);
    };
    var handleKeyDownDefault = function(event) {
        if (event.keyCode === 13) {
            handleKeyDown({
                keyword: keyword
            });
            // router.push(`/products?text=${keyword}`);
            event.preventDefault();
            event.target.blur();
        }
    };
    var handleFocus = function(e) {
        var ref;
        var val = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        if (val && val.length > 0) {
            setHidden(true);
            setKeyword(e.target.value);
        }
    };
    var handleBlur = function() {
        (0,debounce/* debounceFunc200 */.dW)(function() {
            return setHidden(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((SearchProduct_styles_module_default()).search_wrap, classCustom),
        onBlur: handleBlur,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    value: keyword
                }, restProps), {
                    classes: {
                        root: (SearchProduct_styles_module_default()).root_input
                    },
                    style: {
                        width: "100%"
                    },
                    async: true,
                    onChange: handleSearchbox,
                    onKeyDown: handleKeyDownDefault,
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                style: {
                                    color: styles/* WEB_STYLES.COLORS.GREEN */.i.COLORS.GREEN
                                }
                            })
                        }),
                        placeholder: translateCommon("input_product_name"),
                        autoComplete: "off",
                        type: "search",
                        classes: {
                            focused: (SearchProduct_styles_module_default()).focus
                        }
                    },
                    onFocus: handleFocus
                }))
            }),
            hidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchDropdownFeedback, {
                keyword: keyword,
                data: searchProduct,
                onClickItem: clickProduct
            })
        ]
    });
});
/* harmony default export */ var mocules_SearchProduct = (SearchProduct);


/***/ }),

/***/ 69200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(868);
/* harmony import */ var _material_ui_icons_OpenInNew__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(34276);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69251);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71569);
/* harmony import */ var constants_flagship_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30984);
/* harmony import */ var constants_Icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43004);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33436);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34588);
/* harmony import */ var zustand_lib_storeMobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35810);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72303);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_12__);
/* eslint-disable react/destructuring-assignment */ 
















/*
 Internal Seller: 
- Có Hóa Đơn => "MedX"
- Không hóa đơn => Không hiện thị
External Seller:
- Doanh nghiệp => hiện tên doanh nghiệp
- Cá nhân => "Đối tác của thuocsi"



*/ var SellerInfo = function(props) {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    // const partnerName = translateCommon('partner_of_buymed').replace('{BRAND_NAME}', BRAND_NAME);
    // const getSellerByCode = useSellers((state) => state.getSellerByCode);
    var isMobileV2 = (0,zustand_lib_storeMobile__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(state) {
        return state.isMobileV2();
    });
    // gọi tới cache chung lấy seller map
    var _seller = props.seller, seller = _seller === void 0 ? {} : _seller, _tags = props.tags, tags = _tags === void 0 ? [] : _tags, _isProductCard = props.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard, _isWishlist = props.isWishlist, isWishlist = _isWishlist === void 0 ? false : _isWishlist, _isChat = props.isChat, isChat = _isChat === void 0 ? false : _isChat, containerClass = props.containerClass, _isWebView = props.isWebView, isWebView = _isWebView === void 0 ? false : _isWebView;
    var code = seller.code;
    var ref1 = (0,context__WEBPACK_IMPORTED_MODULE_5__/* .useSetting */ .yu)(), _mapStoreActives = ref1.mapStoreActives, mapStoreActives = _mapStoreActives === void 0 ? new Map() : _mapStoreActives, getNameSeller = ref1.getNameSeller;
    var ref2 = getNameSeller({
        seller: seller,
        tags: tags
    }), fullNameSeller = ref2.fullNameSeller, isDisplayStore = ref2.isDisplayStore, linkSeller = ref2.linkSeller, linkStore = ref2.linkStore, tcode = ref2.tcode;
    var displayName = tcode !== "seller" ? translateCommon("seller.".concat(tcode)).replace("{BRAND_NAME}", constants_Enums__WEBPACK_IMPORTED_MODULE_2__/* .BRAND_NAME */ .RS) : fullNameSeller;
    // const isActiveStore = mapStoreActives?.get(code) || null;
    // hiển thị với seller là doanh nghiệp ngoài
    // hard code store
    var flagshipStore = (0,constants_flagship_store__WEBPACK_IMPORTED_MODULE_3__/* .getHardcodeStoreByTagList */ ._h)(tags);
    if (flagshipStore) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplierTitle), containerClass, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplierTitle_mv2), isMobileV2), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().m0)),
            item: true,
            xs: 12,
            container: true,
            justifyContent: "flex-start",
            direction: "row",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                disableTouchListener: isMobileV2,
                title: flagshipStore.name,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    className: isWishlist ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().name),
                    item: true,
                    xs: 12,
                    container: true,
                    justifyContent: "flex-start",
                    direction: "row",
                    children: [
                        !isProductCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                            children: [
                                translateCommon("provided_by"),
                                ": "
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackStatic */ .ez, {
                            width: "14",
                            height: "16",
                            src: constants_Icons__WEBPACK_IMPORTED_MODULE_4__/* .COLOR_STORE */ .bV,
                            alt: flagshipStore.name,
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().image_logo)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: isWebView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link_mv2), isMobileV2), isWishlist && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().sellerProduct)),
                                stopProp: true,
                                style: {
                                    fontSize: !isChat && 12
                                },
                                children: flagshipStore.name
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                                target: "_blank",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link_mv2), isMobileV2), isWishlist && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().sellerProduct)),
                                stopProp: true,
                                style: {
                                    fontSize: !isChat && 12
                                },
                                href: flagshipStore.url,
                                children: flagshipStore.name
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplierTitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplierTitle_mv2), isMobileV2), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().m0)),
        item: true,
        xs: 12,
        container: true,
        justifyContent: "flex-start",
        direction: "row",
        children: displayName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
            disableTouchListener: isMobileV2,
            title: displayName,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                className: isWishlist ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().name),
                item: true,
                xs: 12,
                container: true,
                justifyContent: "flex-start",
                direction: "row",
                children: [
                    !isProductCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                        children: [
                            translateCommon("provided_by"),
                            ": "
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackStatic */ .ez, {
                        width: "14",
                        height: "16",
                        src: constants_Icons__WEBPACK_IMPORTED_MODULE_4__/* .COLOR_STORE */ .bV,
                        alt: displayName,
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().image_logo)
                    }),
                    (mapStoreActives === null || mapStoreActives === void 0 ? void 0 : mapStoreActives.get(code)) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: isWebView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            stopProp: true,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link_mv2), isMobileV2), isWishlist && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().sellerProduct)),
                            children: [
                                displayName,
                                !isProductCard && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    title: translateCommon("view_store"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_OpenInNew__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        style: {
                                            color: "#676F77",
                                            paddingTop: "10px",
                                            marginBottom: "-3px"
                                        }
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                            stopProp: true,
                            target: "_blank",
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link_mv2), isMobileV2), isWishlist && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().sellerProduct)),
                            href: linkStore,
                            children: [
                                displayName,
                                !isProductCard && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    title: translateCommon("view_store"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_OpenInNew__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        style: {
                                            color: "#676F77",
                                            paddingTop: "10px",
                                            marginBottom: "-3px"
                                        }
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: isDisplayStore ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: isWebView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                stopProp: true,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link_mv2), isMobileV2), isWishlist && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().sellerProduct)),
                                children: displayName
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                                stopProp: true,
                                target: "_blank",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link_mv2), isMobileV2), isWishlist && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().sellerProduct)),
                                href: linkSeller,
                                children: displayName
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: isWebView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                stopProp: true,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link_mv2), isMobileV2), isWishlist && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2), tcode === "seller_partner" && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().text_tf_none), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().sellerProduct)),
                                children: displayName
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                                stopProp: true,
                                target: "_blank",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().link_mv2), isMobileV2), isWishlist && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().supplier_title_v2), tcode === "seller_partner" && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().text_tf_none), isChat && (_styles_module_css__WEBPACK_IMPORTED_MODULE_12___default().sellerProduct)),
                                href: linkSeller,
                                children: displayName
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.memo)(SellerInfo));


/***/ }),

/***/ 41863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(79895);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86010);
/* harmony import */ var components_v2_mocules_mobile_CardProduct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57096);
/* harmony import */ var components_v2_mocules_mobile_SliderMobile_ProductPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28677);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69251);
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66520);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13270);
/* harmony import */ var hooks_useOnScreen__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97429);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46680);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34588);
/* harmony import */ var zustand_lib_storeMobile__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35810);
/* harmony import */ var _material_ui_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(66735);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(96242);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_18__);

























var SliderProduct = function(param) {
    var children = param.children, name = param.name, redirect = param.redirect, viewMore = param.viewMore, _page = param.page, page = _page === void 0 ? "PRD_DETAIL" : _page, icon = param.icon, iconWidth = param.iconWidth, iconHeight = param.iconHeight, _isBestProducts = param.isBestProducts, isBestProducts = _isBestProducts === void 0 ? false : _isBestProducts, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _type = param.type, type = _type === void 0 ? "" : _type, products = param.products, className = param.className, _hideArrow = param.hideArrow, hideArrow = _hideArrow === void 0 ? false : _hideArrow;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    var isMobileV2 = (0,zustand_lib_storeMobile__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(state) {
        return state.isMobileV2();
    });
    var TITLE_ICON = name === "Sản phẩm c\xf9ng nh\xe0 b\xe1n h\xe0ng" ? constants_Images__WEBPACK_IMPORTED_MODULE_5__/* .SAME_STORE */ .T2Q : constants_Images__WEBPACK_IMPORTED_MODULE_5__/* .SAME_INGREDIENT */ .cau;
    var SlideItems = products === null || products === void 0 ? void 0 : products.map(function(item) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_v2_mocules_mobile_CardProduct__WEBPACK_IMPORTED_MODULE_1__/* .ProductCardVertical */ .A1, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), item === null || item === void 0 ? void 0 : item.sku);
    });
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    var visible = (0,hooks_useOnScreen__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(wrapperRef);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        if (ref1 === null || ref1 === void 0 ? void 0 : ref1.current) if (visible) {
            ref1.current.slickPlay();
        } else {
            ref1.current.slickPause();
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
        ref: wrapperRef,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().wrapper), isBestProducts && (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().bestProductsWrapper), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().wrapper_mv2), isMobileV2), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().icon_name), isBestProducts && (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().bestProducts), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().icon_name_mv2), isMobileV2)),
                children: [
                    isMobileV2 && icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_13__/* .ImageFallbackStatic */ .ez, {
                        src: icon,
                        width: iconWidth || 24,
                        height: iconHeight || 24,
                        alt: "icon"
                    }),
                    !isMobileV2 && icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_13__/* .ImageFallbackStatic */ .ez, {
                        src: icon,
                        width: iconWidth || 40,
                        height: iconHeight || 40,
                        alt: "icon"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().name), isBestProducts && (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().bestProductsName), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().name_mv2), isMobileV2)),
                        variant: "h5",
                        children: name
                    }),
                    isBestProducts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().bestProducts_view_more),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "".concat(redirect),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: translateCommon("see_more")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_13__/* .ImageFallbackStatic */ .ez, {
                                    src: constants_Images__WEBPACK_IMPORTED_MODULE_5__/* .DOUBLE_ARROW_ICON */ .uVr,
                                    width: 12,
                                    height: 12,
                                    alt: "icon"
                                })
                            ]
                        })
                    })
                ]
            }),
            isBestProducts && (isMobileV2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_v2_mocules_mobile_SliderMobile_ProductPreview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                slideItems: SlideItems,
                appendSettings: {
                    initialSlide: (SlideItems === null || SlideItems === void 0 ? void 0 : SlideItems.length) < 3 ? 0 : 1
                }
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                ref: ref1
            }, constants_data__WEBPACK_IMPORTED_MODULE_4__/* .settingsBestProduct */ .$B), {
                slidesToShow: children.length < 3 ? children.length : 3,
                initialSlide: children.length < 3 ? 0 : 1,
                centerMode: children.length >= 3,
                autoplay: visible,
                arrows: !hideArrow,
                children: children
            }))),
            !isBestProducts && (isMobileV2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_v2_mocules_mobile_SliderMobile_ProductPreview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                slideItems: SlideItems,
                appendSettings: {
                    infinite: (SlideItems === null || SlideItems === void 0 ? void 0 : SlideItems.length) > 4
                }
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                ref: ref1
            }, constants_data__WEBPACK_IMPORTED_MODULE_4__/* .settingsProduct */ .PM), {
                infinite: children.length > 4,
                autoplay: visible,
                arrows: !hideArrow,
                children: children
            }))),
            viewMore && !isBestProducts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().see_more_wrapper),
                onClick: function() {
                    if (type === "SAME_MANUFACTURER") {
                        utils__WEBPACK_IMPORTED_MODULE_12__/* .gtag.clickViewAllProductSameManufacturer */ .SX.clickViewAllProductSameManufacturer();
                    }
                    if (type === "SAME_INGREDIENT") {
                        utils__WEBPACK_IMPORTED_MODULE_12__/* .gtag.clickViewAllProductSameIngredient */ .SX.clickViewAllProductSameIngredient();
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .LinkComp */ .vk, {
                    href: "".concat(redirect),
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().see_more_btn),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: translateCommon("see_more")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_18___default().see_more_icon)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SliderProduct);


/***/ }),

/***/ 22535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_TagComponent; },
  "T": function() { return /* binding */ getShowTags; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(52543);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/deviceUtils.js
var deviceUtils = __webpack_require__(97121);
;// CONCATENATED MODULE: ./src/components-v2/mocules/TooltipMobile/index.js







var CustomizeTooltip = (0,withStyles/* default */.Z)({
    tooltip: {
        backgroundColor: "#ffffff",
        boxShadow: " 0px 0px 6px rgba(0, 0, 0, 0.05)",
        borderRadius: "5px",
        width: "auto",
        maxWidth: "249px",
        border: "1px solid #e9e9e9",
        padding: "10px",
        color: "black"
    }
})(Tooltip/* default */.ZP);
function TooltipMobile(param) {
    var _valueTitle = param.valueTitle, valueTitle = _valueTitle === void 0 ? "" : _valueTitle, children = param.children, isMobile = param.isMobile, classNameChildren = param.classNameChildren, classNameTooltip = param.classNameTooltip;
    var isTablet = deviceUtils/* default.isTablet */.Z.isTablet();
    var isDeviceMobile = isTablet || isMobile;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isHoverTooltip = ref[0], setIsHoverTooltip = ref[1];
    if (!children || !isDeviceMobile || !valueTitle) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizeTooltip, {
        enterTouchDelay: 0,
        title: valueTitle,
        open: isHoverTooltip,
        placement: "top",
        className: (0,clsx_m/* default */.Z)(classNameTooltip),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return setIsHoverTooltip(true);
            },
            onMouseOver: function() {
                return setIsHoverTooltip(true);
            },
            onMouseLeave: function() {
                return setIsHoverTooltip(false);
            },
            onFocus: function() {
                return setIsHoverTooltip(true);
            },
            role: "presentation",
            className: (0,clsx_m/* default */.Z)(classNameChildren),
            children: children
        })
    });
}
/* harmony default export */ var mocules_TooltipMobile = (TooltipMobile);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./src/components/mocules/TagType/index.js + 1 modules
var TagType = __webpack_require__(85201);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/atoms/AdditionalTooltip/styles.module.css
var styles_module = __webpack_require__(84446);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/atoms/AdditionalTooltip/index.js










var AdditionalTooltip = function(param) {
    var tags = param.tags, _exp = param.exp, exp = _exp === void 0 ? null : _exp;
    var CustomizeTooltip = (0,withStyles/* default */.Z)({
        tooltip: {
            backgroundColor: "#ffffff",
            border: "1px solid #eaeaea",
            display: "flex",
            justifyContent: "space-beetwen",
            flexWrap: "wrap"
        },
        arrow: {
            "&:before": {
                border: "1px solid #eaeaea",
                backgroundColor: "#ffffff"
            }
        }
    })(Tooltip/* default */.ZP);
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var remainTagType = tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            style: {
                padding: "2px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                item: tag,
                exp: exp
            })
        }, tag);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizeTooltip, {
        title: remainTagType,
        disableFocusListener: true,
        disableTouchListener: true,
        className: (0,clsx_m/* default */.Z)((styles_module_default()).tag_quantity),
        arrow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (0,clsx_m/* default */.Z)((styles_module_default()).tag, (0,_define_property/* default */.Z)({}, (styles_module_default()).tag_mv2, isMobileV2)),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                style: {
                    marginBottom: "8px"
                },
                children: "..."
            })
        })
    });
};
/* harmony default export */ var atoms_AdditionalTooltip = (AdditionalTooltip);

// EXTERNAL MODULE: ./src/constants/TagTypeProps/index.js
var TagTypeProps = __webpack_require__(11917);
// EXTERNAL MODULE: ./src/constants/Tags/index.js
var Tags = __webpack_require__(91983);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
// EXTERNAL MODULE: ./src/components/mocules/TagComponent/style.module.css
var style_module = __webpack_require__(66086);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/mocules/TagComponent/index.js
/*
 * @deprecated Module tag cũ (port từ VN). Bản chuẩn cho KH là
 * `src/components-v2/organisms/pages/landingPageCam/mocules/TagComponent` + `src/utils/TagUtils.js`.
 *
 * Còn sống vì đang phục vụ giỏ hàng / checkout / đơn hàng / bulk-order / quick-order / export XLSX,
 * và vì chip ở đây có hình dạng khác bản KH nên hợp nhất là thay đổi design, cần sign-off.
 *
 * Đừng thêm rule mới vào đây.
 */ // xử lý tag
















/*
TAG
Rule 1: 3 Tag Priority bắt buộc phải hiển thị đủ: Thứ tự ưu tiên hiển thị: Cận date (text) - Hóa đơn nhanh (có icon) - Đặt trước 7 ngày (text) (các tags còn lại có thể nằm trong nút …)
Rule 2: Sp chứa Tag text (>1) và tag icon (>1) sẽ hiển thị:
Th1: nếu có tag priority → ưu tiển hiển thị theo Rule 1
TH2: nếu không có tag priority → hiển thị 1 tag text và 2 tag icon (đảm bảo là nằm trên cùng 1 dòng)
Rule 3: nếu ko có tags icon nào hiển thị thì sẽ hiển thị tags có chữ ra ngoài, max là 2 tags text (cho phép rớt xuống thành 2 dòng ở trường hợp này)
Giao diện chỗ +number đổi thành nút ba chấm … (đang chờ update UI để update vô card, dev cứ giữ … như bản web hiện tại là dc) (rule của nút vẫn giữ như trong card)
  */ var TooltipTagMobile = function(param) {
    var remainTags = param.remainTags, isMobile = param.isMobile, _isChatMobile = param.isChatMobile, isChatMobile = _isChatMobile === void 0 ? false : _isChatMobile;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var tagType = remainTags === null || remainTags === void 0 ? void 0 : remainTags.map(function(tag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            style: {
                padding: "2px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                item: tag
            })
        }, "tag-".concat(tag));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_TooltipMobile, {
        valueTitle: tagType,
        classNameChildren: (0,clsx_m/* default */.Z)((style_module_default()).tag_quantity, (0,_define_property/* default */.Z)({}, (style_module_default()).tag_quantity_mv2, isMobileV2)),
        classNameTooltip: (style_module_default()).tagMobile,
        isMobile: isMobile,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(isChatMobile && (style_module_default()).chatMobile_moreTag),
            onClick: function(e) {
                return e.stopPropagation();
            },
            style: {
                marginBottom: "8px"
            },
            children: "..."
        })
    });
};
var tagsHidden = [
    sysconfig/* TAG_NEW */.cC
];
var TAG_PRIORITY = [
    "NEAR_EXPIRATION",
    "HOADONNHANH",
    "HANG_DAT_TRUOC"
];
var tagHideHoaDonNhanh = [
    Tags/* ENUM_TAG_CODES.HANG_DIEM */.c.HANG_DIEM,
    Tags/* ENUM_TAG_CODES.HANG_HANG */.c.HANG_HANG
];
var getShowTags = function(tags, getStyleBySlugOfTag, provinceCode) {
    // Cận date- Hóa đơn nhanh - Đặt trước 7 ngày - Có ở kho - Bán Chạy - Giá Tốt - Nhãn hàng 3 tốt
    var sortprioritizedTag = tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
        return (TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag)) && tagsHidden.indexOf(tag) === -1;
    }).sort(function(a, b) {
        var ref, ref1;
        return (((ref = TagTypeProps/* default */.Z[b]) === null || ref === void 0 ? void 0 : ref.index) || 10) - (((ref1 = TagTypeProps/* default */.Z[a]) === null || ref1 === void 0 ? void 0 : ref1.index) || 10);
    });
    // bỏ duplicate
    var setTags = Array.from(new Set(sortprioritizedTag));
    // 05Augh2022
    /*
    nếu SP có tag hàng hãng / hàng điểm thì auto ẩn Tag hoá đơn nhanh 
    ẩn trên toàn bộ trang
    khi ẩn tag hoá đơn nhanh thì sẽ ưu tiên  Hàng hãng -> Hàng Điểm 
    https://buymed.atlassian.net/browse/APO-772 
  */ var indexTagHoaDonNhanh = setTags.indexOf(Tags/* ENUM_TAG_CODES.HOADONNHANH */.c.HOADONNHANH);
    if (indexTagHoaDonNhanh >= 0 && setTags.some(function(tag) {
        return tagHideHoaDonNhanh.includes(tag);
    })) {
        setTags.splice(indexTagHoaDonNhanh, 1);
    }
    // check user miền bắc chỉ hiển thị tag HANG_DAT_TRUOC
    var isUserInRegionMb = sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(provinceCode)) < 0;
    var indexTagHangDatTruoc = setTags.indexOf(sysconfig/* TAG_HANG_DAT_TRUOC */.lE);
    if (indexTagHangDatTruoc >= 0 && isUserInRegionMb) {
        setTags.splice(indexTagHangDatTruoc, 1);
    }
    return setTags;
};
var TagComponent = function(param) {
    var product = param.product, _isProductCard = param.isProductCard, isProductCard = _isProductCard === void 0 ? true : _isProductCard, _isSellerList = param.isSellerList, isSellerList = _isSellerList === void 0 ? false : _isSellerList, _isCombo = param.isCombo, isCombo = _isCombo === void 0 ? false : _isCombo, _isGift = param.isGift, isGift = _isGift === void 0 ? false : _isGift, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isShowDeal = param.isShowDeal, isShowDeal = _isShowDeal === void 0 ? true : _isShowDeal, link = param.link, isLinkTagDeal = param.isLinkTagDeal, _isChatMobile = param.isChatMobile, isChatMobile = _isChatMobile === void 0 ? false : _isChatMobile;
    // const { getStyleBySlugOfTag } = useSetting();
    var getStyleBySlugOfTag = (0,storeGlobal/* useStore */.o)(function(state) {
        return state === null || state === void 0 ? void 0 : state.getStyleBySlugOfTag;
    }) || null;
    var user = (0,storeGlobal/* useStore */.o)(function(state) {
        return state === null || state === void 0 ? void 0 : state.user;
    }) || null;
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    // nếu gift thì không hiển thị tag
    if (isSellerList || isGift) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var ref = product || {}, _tags = ref.tags, tags = _tags === void 0 ? [] : _tags, _statusData = ref.statusData, statusData = _statusData === void 0 ? {} : _statusData, _expiredDate = ref.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate;
    // nếu combo chỉ hiển thị tag hoá đơn nhanh
    if (isCombo) {
        return tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
            return tag === Tags/* ENUM_TAG_CODES.HOADONNHANH */.c.HOADONNHANH || tag === sysconfig/* TAG_HANG_DAT_TRUOC */.lE;
        }).map(function(item) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                item: item,
                exp: statusData === null || statusData === void 0 ? void 0 : statusData.date,
                isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
                link: link,
                isLinkTagDeal: isLinkTagDeal
            }, (0,v4/* default */.Z)());
        });
    }
    // Cận date- Hóa đơn nhanh - Đặt trước 7 ngày - Có ở kho - Bán Chạy - Giá Tốt - Nhãn hàng 3 tốt
    var sortprioritizedTag = tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
        return (TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag)) && tagsHidden.indexOf(tag) === -1;
    }).sort(function(a, b) {
        var ref, ref1;
        return (((ref = TagTypeProps/* default */.Z[b]) === null || ref === void 0 ? void 0 : ref.index) || 10) - (((ref1 = TagTypeProps/* default */.Z[a]) === null || ref1 === void 0 ? void 0 : ref1.index) || 10);
    });
    // bỏ duplicate
    var setTags = Array.from(new Set(sortprioritizedTag));
    // 05Augh2022
    /*
    nếu SP có tag hàng hãng / hàng điểm thì auto ẩn Tag hoá đơn nhanh 
    ẩn trên toàn bộ trang
    khi ẩn tag hoá đơn nhanh thì sẽ ưu tiên  Hàng hãng -> Hàng Điểm 
    https://buymed.atlassian.net/browse/APO-772 
  */ var indexTagHoaDonNhanh = setTags.indexOf(Tags/* ENUM_TAG_CODES.HOADONNHANH */.c.HOADONNHANH);
    if (indexTagHoaDonNhanh >= 0 && setTags.some(function(tag) {
        return tagHideHoaDonNhanh.includes(tag);
    })) {
        setTags.splice(indexTagHoaDonNhanh, 1);
    }
    // check user miền bắc chỉ hiển thị tag HANG_DAT_TRUOC
    var isUserInRegionMb = sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(user === null || user === void 0 ? void 0 : user.provinceCode)) < 0;
    var indexTagHangDatTruoc = setTags.indexOf(sysconfig/* TAG_HANG_DAT_TRUOC */.lE);
    if (indexTagHangDatTruoc >= 0 && isUserInRegionMb) {
        setTags.splice(indexTagHangDatTruoc, 1);
    }
    // Ở trang giỏ hàng thì  không hiển thị tag DEAL
    if (!isShowDeal) {
        var indexDeal = setTags.indexOf("DEAL");
        if (indexDeal >= 0) {
            setTags.splice(indexDeal, 1);
        }
    }
    // isMobile show hết
    // if (isMobile) {
    //   return setTags.map((item) => <TagType key={uuidv4()} item={item} exp={statusData?.date} />);
    // }
    // thêm rule 28Jun2022
    // nếu có 3 tag thì hiển thị hết
    // isProductCard  = true -> hiển thị icon , và rule ở trên
    if (isProductCard && (setTags === null || setTags === void 0 ? void 0 : setTags.length) > 3) {
        // check có tag priority không
        // rule 1
        var tagPriorityCur = setTags.filter(function(t) {
            return TAG_PRIORITY.indexOf(t) >= 0;
        });
        // rule 2 : nếu không có tagPriority -> 1 tag tex & 1 tag icon
        if ((tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) === 0) {
            var tagIcons = [];
            var tagNoIcons = [];
            var tagStyles = setTags.map(function(tag) {
                return TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag);
            });
            tagStyles.forEach(function(tag) {
                if (tag) {
                    if (tag.isTooltip) {
                        tagIcons.push(tag === null || tag === void 0 ? void 0 : tag.code);
                    } else {
                        tagNoIcons.push(tag === null || tag === void 0 ? void 0 : tag.code);
                    }
                }
            });
            // nếu có 2 tag icon -> 1 icon 1 text
            if ((tagIcons === null || tagIcons === void 0 ? void 0 : tagIcons.length) >= 1 && (tagNoIcons === null || tagNoIcons === void 0 ? void 0 : tagNoIcons.length) > 0) {
                tagPriorityCur = (0,_to_consumable_array/* default */.Z)(tagIcons.splice(0, 2)).concat([
                    tagNoIcons === null || tagNoIcons === void 0 ? void 0 : tagNoIcons[0]
                ]);
            } else {
                // nếu không có 2 tag Icon thì sẽ hiển thị 2 tag text
                tagPriorityCur = tagNoIcons.splice(0, 2);
            }
        }
        var remainTags = setTags.filter(function(tag) {
            return tagPriorityCur.indexOf(tag) === -1;
        });
        if ((tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) <= 2) {
            tagPriorityCur = tagPriorityCur.concat(remainTags.splice(0, 3 - tagPriorityCur.length));
        }
        // const remainTagType = remainTags?.map((tag) => (
        //   <Box style={{ padding: '2px' }}>
        //     <TagType item={tag} />
        //   </Box>
        // ));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) > 0 && tagPriorityCur.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                        item: item,
                        exp: item === "NEAR_EXPIRATION" ? expiredDate : statusData === null || statusData === void 0 ? void 0 : statusData.date,
                        isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
                        isLinkTagDeal: isLinkTagDeal,
                        link: link
                    }, (0,v4/* default */.Z)());
                }),
                (remainTags === null || remainTags === void 0 ? void 0 : remainTags.length) > 0 && (isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipTagMobile, {
                    remainTags: remainTags,
                    isMobile: beta ? isMobileV2 : isMobile,
                    isChatMobile: isChatMobile
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_AdditionalTooltip, {
                    tags: remainTags
                }))
            ]
        });
    }
    // isProductCard  = false -> trang chi tiết - hiển thị full,
    return setTags.map(function(item) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
            item: item,
            exp: item !== "NEAR_EXPIRATION" ? statusData === null || statusData === void 0 ? void 0 : statusData.date : expiredDate,
            isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
            isLinkTagDeal: isLinkTagDeal,
            link: link
        }, (0,v4/* default */.Z)());
    });
};
/* harmony default export */ var mocules_TagComponent = (TagComponent);


/***/ }),

/***/ 85201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ mocules_TagType; },
  "f9": function() { return /* binding */ getTagName; },
  "fb": function() { return /* binding */ tagTypePropsArr; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/TagTypeProps/index.js
var TagTypeProps = __webpack_require__(11917);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(46680);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var index_es = __webpack_require__(78947);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__(51417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var react_fontawesome_index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/mocules/ProductTag/tag.module.css
var tag_module = __webpack_require__(12404);
var tag_module_default = /*#__PURE__*/__webpack_require__.n(tag_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductTag/index.js
/* eslint-disable no-param-reassign */ /*
 * @deprecated Module tag cũ (port từ VN). Bản chuẩn cho KH là
 * `src/components-v2/organisms/pages/landingPageCam/mocules/TagComponent` + `src/utils/TagUtils.js`.
 *
 * Còn sống vì đang phục vụ giỏ hàng / checkout / đơn hàng / bulk-order / quick-order / export XLSX,
 * và vì chip ở đây có hình dạng khác bản KH nên hợp nhất là thay đổi design, cần sign-off.
 *
 * Đừng thêm rule mới vào đây.
 */ 
















var iconList = [
    {
        label: "✯ Ng\xf4i sao",
        value: "star",
        icon: free_solid_svg_icons_index_es.faStar
    },
    {
        label: "＋ Cộng",
        value: "plus",
        icon: free_solid_svg_icons_index_es.faPlus
    },
    {
        label: "♫ Nốt nhạc",
        value: "music",
        icon: free_solid_svg_icons_index_es.faMusic
    },
    {
        label: "❄ Tuyết",
        value: "snowflake",
        icon: free_solid_svg_icons_index_es.faSnowflake
    },
    {
        label: "✈ M\xe1y bay",
        value: "plane",
        icon: free_solid_svg_icons_index_es.faPlane
    },
    {
        label: "❤ Tr\xe1i tim",
        value: "heart",
        icon: free_solid_svg_icons_index_es.faHeart
    },
    {
        label: "ϟ S\xe9t",
        value: "bolt",
        icon: free_solid_svg_icons_index_es.faBolt
    },
    {
        label: "☀ Mặt trời",
        value: "sun",
        icon: free_solid_svg_icons_index_es.faSun
    },
    {
        label: "☁ M\xe2y",
        value: "cloud",
        icon: free_solid_svg_icons_index_es.faCloud
    },
    {
        label: "♨ Lửa",
        value: "fab gripfire",
        icon: free_brands_svg_icons_index_es.faGripfire
    },
    {
        label: "Qu\xe0 tặng",
        value: "gift",
        icon: free_solid_svg_icons_index_es.faGift
    },
    {
        label: "Giao nhanh",
        value: "shipping-fast",
        icon: free_solid_svg_icons_index_es.faShippingFast
    },
    {
        label: "H\xf3a đơn",
        value: "file-invoice-dollar",
        icon: free_solid_svg_icons_index_es.faFileInvoiceDollar
    },
    {
        label: "B\xe1nh sinh nhật",
        value: "birthday-cake",
        icon: free_solid_svg_icons_index_es.faBirthdayCake
    },
    {
        label: "Huy chương",
        value: "medal",
        icon: free_solid_svg_icons_index_es.faMedal
    },
    {
        label: "Th\xedch",
        value: "thumbs-up",
        icon: free_solid_svg_icons_index_es.faThumbsUp
    },
    {
        label: "Trẻ em",
        value: "baby",
        icon: free_solid_svg_icons_index_es.faBaby
    },
    {
        label: "Giọt nước",
        value: "tint",
        icon: free_solid_svg_icons_index_es.faTint
    },
    {
        label: "B\xf9ng nổ",
        value: "bahai",
        icon: free_solid_svg_icons_index_es.faBahai
    }, 
];
iconList.forEach(function(icon) {
    index_es.library.add(icon.icon);
});
index_es.dom.watch();
var getUrlTag = function(param) {
    var slug = param.slug, url = param.url, code = param.code;
    if (url) return url;
    if (slug) return "/tag/".concat(slug);
    return "".concat(Paths/* PRODUCTS_LOADING_URL */.iB, "?tag=").concat(code);
};
function ProductTag(param) {
    var name = param.name, preIcon = param.preIcon, _Icon = param.Icon, Icon = _Icon === void 0 ? null : _Icon, nameAsTooltip = param.nameAsTooltip, textColor = param.textColor, style = param.style, styleName = param.styleName, code = param.code, backgroundColor = param.backgroundColor, date = param.date, _isTooltip = param.isTooltip, isTooltip = _isTooltip === void 0 ? false : _isTooltip, _url = param.url, url = _url === void 0 ? null : _url, borderColor = param.borderColor, _isStyleV2 = param.isStyleV2, isStyleV2 = _isStyleV2 === void 0 ? false : _isStyleV2, slug = param.slug, link = param.link, isLinkTagDeal = param.isLinkTagDeal, tcode = param.tcode;
    var ref, ref1;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var ref2 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref2.t;
    // // set cho mobile version 2
    // if (!isDesktop && beta) {
    //   return (
    //     <MobileProductTag
    //       style={{
    //         borderColor: borderColor || backgroundColor,
    //         color: textColor,
    //         backgroundColor,
    //         ...(style || {}),
    //       }}
    //       name={name}
    //       Icon={Icon}
    //       preIcon={preIcon}
    //     />
    //   );
    // }
    // parse preIcon
    if (preIcon) {
        if (typeof preIcon === "string") {
            if (preIcon.indexOf(" ") > 0) {
                preIcon = preIcon.split(" ");
            }
        } else if (typeof preIcon === "object" && preIcon.value) {
            preIcon = preIcon.value;
        }
    }
    var iconToDisplay;
    if (preIcon) {
        var foundIcon = iconList.find(function(icon) {
            return preIcon === icon.value;
        });
        if (foundIcon) {
            iconToDisplay = foundIcon.icon;
        }
    }
    // capitalize
    name = (ref1 = (ref = name === null || name === void 0 ? void 0 : name.split(" ")) === null || ref === void 0 ? void 0 : ref.map(function(word) {
        return word.length > 1 ? word.charAt(0).toUpperCase() + word.substr(1) : word.toUpperCase();
    })) === null || ref1 === void 0 ? void 0 : ref1.join(" ");
    if (isTooltip && (Icon || preIcon)) {
        var urlTag = getUrlTag({
            code: code,
            url: code === "DEAL" && isLinkTagDeal ? link : url,
            slug: slug
        });
        var _obj;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
            stopProp: true,
            removeStyles: true,
            href: urlTag,
            "data-test": "tags-".concat(code),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: tcode ? translateCommon("tag.".concat(code)) : name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    style: (0,_object_spread/* default */.Z)({
                        borderColor: borderColor || backgroundColor,
                        color: textColor,
                        backgroundColor: backgroundColor
                    }, style || {}),
                    // className={isStyleV2 ? styles.tag_containerv2 : styles.icon_tag_container}
                    className: (0,clsx_m/* default */.Z)((_obj = {}, (0,_define_property/* default */.Z)(_obj, (tag_module_default()).icon_tag_container, !isStyleV2), (0,_define_property/* default */.Z)(_obj, (tag_module_default()).tag_containerv2, isStyleV2), (0,_define_property/* default */.Z)(_obj, (tag_module_default()).tag_container_mobilev2, isMobileV2), _obj)),
                    onClick: function() {
                        utils/* gtag.clickTagInProduct */.SX.clickTagInProduct(name);
                    },
                    children: [
                        Icon && Icon,
                        preIcon && iconToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                            icon: iconToDisplay
                        })
                    ]
                })
            })
        });
    }
    // normal display
    if (!nameAsTooltip && name) {
        var urlTag1 = getUrlTag({
            tcode: tcode,
            code: code,
            url: code === "DEAL" && isLinkTagDeal ? link : url,
            slug: slug
        });
        var _obj1, _obj2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
            stopProp: true,
            removeStyles: true,
            href: urlTag1,
            "data-test": "tags-".concat(code),
            prefetch: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                style: (0,_object_spread/* default */.Z)({
                    borderColor: borderColor || backgroundColor,
                    color: textColor,
                    backgroundColor: backgroundColor
                }, style || {}),
                // className={clsx(isStyleV2 ? styles.tag_containerv2 : styles.tag_container, date ? styles.date_tag_container : styles.normal_tag_container)}
                className: (0,clsx_m/* default */.Z)((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).tag_container, !isStyleV2), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).tag_containerv2, isStyleV2), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).normal_tag_container, !date), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).date_tag_container, date), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).tag_container_mobilev2, isMobileV2), _obj1)),
                onClick: function() {
                    utils/* gtag.clickTagInProduct */.SX.clickTagInProduct(name);
                },
                children: [
                    Icon && Icon,
                    preIcon && iconToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                        icon: iconToDisplay
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)((_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).nameTag, true), (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).nameTagMobileV2, isMobileV2), _obj2)),
                        style: (0,_object_spread/* default */.Z)({}, styleName || {}),
                        children: tcode ? translateCommon("tag.".concat(code)) : name
                    })
                ]
            })
        });
    }
    // quick order display
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: preIcon && name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
            title: tcode ? translateCommon("tag.".concat(code)) : name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: (0,_object_spread/* default */.Z)({
                    borderColor: borderColor || backgroundColor,
                    color: textColor,
                    backgroundColor: backgroundColor
                }, style || {}),
                className: isStyleV2 ? (tag_module_default()).tag_containerv2 : (tag_module_default()).tag_container,
                data: "no link",
                children: [
                    Icon && Icon,
                    preIcon && iconToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                        icon: iconToDisplay
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/mocules/TagType/index.js
/*
 * @deprecated Module tag cũ (port từ VN). Bản chuẩn cho KH là
 * `src/components-v2/organisms/pages/landingPageCam/mocules/TagComponent` + `src/utils/TagUtils.js`.
 *
 * Còn sống vì đang phục vụ giỏ hàng / checkout / đơn hàng / bulk-order / quick-order / export XLSX,
 * và vì chip ở đây có hình dạng khác bản KH nên hợp nhất là thay đổi design, cần sign-off.
 *
 * Đừng thêm rule mới vào đây.
 */ 









var tagTypePropsArr = [
    "OUT_OF_STOCK",
    "SUSPENDED",
    "GIFT",
    "FLASH_SALE",
    "MEGA_DAY",
    "DEAL",
    sysconfig/* TAG_HANG_DAT_TRUOC */.lE,
    "FV2U",
    "2ABC",
    "HOADONNHANH",
    "BAN_CHAY",
    "BANCHAY",
    "Y7GB",
    "84AB",
    "3ABC", 
];
var tagIconArr = [
    "GIAONHANH",
    "W80T",
    "BAN_CHAY",
    "BANCHAY",
    "HOADONNHANH"
];
var tagNoDisplayArr = [
    sysconfig/* TAG_NEW */.cC
];
var getTagName = function(item, getStyleBySlugOfTag) {
    var ref;
    if (item === "NEAR_EXPIRATION") {
        return "Cận date";
    }
    if ((tagNoDisplayArr === null || tagNoDisplayArr === void 0 ? void 0 : tagNoDisplayArr.indexOf(item)) >= 0) {
        return null;
    }
    var tagInfo = TagTypeProps/* default */.Z[item];
    if (tagInfo === null || tagInfo === void 0 ? void 0 : tagInfo.name) {
        return tagInfo.name;
    }
    return ((ref = getStyleBySlugOfTag(item)) === null || ref === void 0 ? void 0 : ref.name) || "";
};
// notes
// cận date chưa làm ,  nếu có status cận date
// khuyến mãi , nếu có deal tự thêm mã giảm giá vào tag
// nên chuyển về 1 cái , làm sau
var TagType = function(param) {
    var item = param.item, exp = param.exp, _isTooltip = param.isTooltip, isTooltip = _isTooltip === void 0 ? false : _isTooltip, _isDisplayFull = param.isDisplayFull, isDisplayFull = _isDisplayFull === void 0 ? false : _isDisplayFull, link = param.link, isLinkTagDeal = param.isLinkTagDeal;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var getStyleBySlugOfTag = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.getStyleBySlugOfTag;
    });
    var customerInfo = (0,context/* useAuth */.aC)().customerInfo;
    var props = {};
    if (item === sysconfig/* TAG_HANG_DAT_TRUOC */.lE && sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.provinceCode)) < 0) {
        return null;
    }
    if (item === "NEAR_EXPIRATION") {
        var date = utils/* DateTimeUtils.getFormattedDate */.IM.getFormattedDate(new Date(exp), "DD-MM-YYYY");
        var _NEAR_EXPIRATION = TagTypeProps/* default.NEAR_EXPIRATION */.Z.NEAR_EXPIRATION, code = _NEAR_EXPIRATION.code, textColor = _NEAR_EXPIRATION.textColor, backgroundColor = _NEAR_EXPIRATION.backgroundColor, url = _NEAR_EXPIRATION.url;
        props = {
            name: "".concat(translateCommon("tag.NEAR_EXPIRATION"), " ").concat(date),
            date: date,
            code: code,
            textColor: textColor,
            backgroundColor: backgroundColor,
            url: url
        };
    } else if (!isDisplayFull && (tagNoDisplayArr === null || tagNoDisplayArr === void 0 ? void 0 : tagNoDisplayArr.indexOf(item)) >= 0) {
        return null;
    } else {
        // nếu ko có option nào thì lấy theo API trả về
        var tagInfo = TagTypeProps/* default */.Z[item];
        props = tagInfo ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tagInfo), {
            isTooltip: isTooltip
        }) : getStyleBySlugOfTag(item);
        if (props && !(props === null || props === void 0 ? void 0 : props.name)) {
            var ref1;
            props.name = ((ref1 = getStyleBySlugOfTag(item)) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
        }
        if (props && !(props === null || props === void 0 ? void 0 : props.slug)) {
            var ref2;
            props.slug = ((ref2 = getStyleBySlugOfTag(item)) === null || ref2 === void 0 ? void 0 : ref2.slug) || "";
        }
        if (!props) {
            return null;
        }
        if ((tagIconArr === null || tagIconArr === void 0 ? void 0 : tagIconArr.indexOf(item)) >= 0) {
            props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                isTooltip: isTooltip
            });
        }
    }
    // translate tag số lượng có hạn
    if (item === "LIMIT") {
        props.name = translateCommon("tag.LIMIT");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag, (0,_object_spread/* default */.Z)({
        link: link,
        isLinkTagDeal: isLinkTagDeal
    }, props));
};
/* harmony default export */ var mocules_TagType = (TagType);


/***/ }),

/***/ 75932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(55517);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35996);
/* harmony import */ var _material_ui_icons_HighlightOff__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(35736);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38169);
/* harmony import */ var clients_UploadFileClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31181);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71569);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13270);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5233);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(32512);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46680);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34588);
/* harmony import */ var utils_ImageUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13744);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(72045);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59598);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_15__);
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];


















// @ts-ignore







var UploadFiles = function(param) {
    var _required = param.required, required = _required === void 0 ? false : _required, fileList = param.fileList, val = param.val, handleSetValue = param.handleSetValue, label = param.label, subLabel = param.subLabel, children = param.children, isMobile = param.isMobile, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("myAccount"), translateMyAccount = ref.t;
    var ref1 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("alert-action"), translateAlertAction = ref1.t;
    var onDrop = function(acceptedFiles) {
        if ((fileList === null || fileList === void 0 ? void 0 : fileList.length) + acceptedFiles.length > 3) {
            utils__WEBPACK_IMPORTED_MODULE_7__/* .NotifyUtils.error */ .QP.error(translateAlertAction("message_max_files"));
            return;
        }
        acceptedFiles.forEach(function(file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            var type = file.type;
            reader.onload = /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                var base64, blob, limitSize, ref, ref1, Pica, ref2, ImageBlobReduce, pica, _tmp, reduce, _tmp1, _tmp2, buffer, result, _tmp3, _tmp4, err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                6,
                                ,
                                7
                            ]);
                            base64 = reader.result;
                            blob = new Blob([
                                reader.result
                            ]);
                            limitSize = blob.size / 1024 / 1024;
                            if (!((type === constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.PNG */ .Gk.PNG || type === constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.JPEG */ .Gk.JPEG) && limitSize > 2)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                Promise.all([
                                    __webpack_require__.e(/* import() */ 6373).then(__webpack_require__.t.bind(__webpack_require__, 16373, 23)),
                                    __webpack_require__.e(/* import() */ 434).then(__webpack_require__.bind(__webpack_require__, 434))
                                ])
                            ];
                        case 1:
                            ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"].apply */ .Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), ref1 = ref[0], Pica = ref1.default, ref2 = ref[1], ImageBlobReduce = ref2.default;
                            _tmp = {};
                            pica = Pica((_tmp.features = [
                                "js",
                                "wasm",
                                "cib"
                            ], _tmp));
                            _tmp1 = {};
                            reduce = new ImageBlobReduce((_tmp1.pica = pica, _tmp1));
                            _tmp2 = {};
                            return [
                                4,
                                reduce.toBlob(file, (_tmp2.max = 2000, _tmp2))
                            ];
                        case 2:
                            blob = _state.sent();
                            return [
                                4,
                                (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_9__/* .blobToBase64 */ .w8)(blob)
                            ];
                        case 3:
                            base64 = _state.sent();
                            buffer = Buffer.from(base64.substring(base64.indexOf(",") + 1));
                            limitSize = buffer.length / 1e6;
                            _state.label = 4;
                        case 4:
                            if (limitSize > 5) {
                                utils__WEBPACK_IMPORTED_MODULE_7__/* .NotifyUtils.error */ .QP.error(translateMyAccount("size_is_too_big"));
                                return [
                                    2
                                ];
                            }
                            if (type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.PDF */ .Gk.PDF && type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.DOC */ .Gk.DOC && type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.DOCX */ .Gk.DOCX && type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.PNG */ .Gk.PNG && type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.JPEG */ .Gk.JPEG) {
                                utils__WEBPACK_IMPORTED_MODULE_7__/* .NotifyUtils.error */ .QP.error(translateMyAccount("wrong_format_file"));
                                return [
                                    2
                                ];
                            }
                            if (val === "businessImages" && type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.PNG */ .Gk.PNG && type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.JPEG */ .Gk.JPEG) {
                                utils__WEBPACK_IMPORTED_MODULE_7__/* .NotifyUtils.error */ .QP.error(translateMyAccount("wrong_format_file"));
                                return [
                                    2
                                ];
                            }
                            if (val === "orderFeedBack" && type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.PNG */ .Gk.PNG && type !== constants_Enums__WEBPACK_IMPORTED_MODULE_3__/* .FILE_TYPE.JPEG */ .Gk.JPEG) {
                                utils__WEBPACK_IMPORTED_MODULE_7__/* .NotifyUtils.error */ .QP.error(translateMyAccount("wrong_format_file"));
                                return [
                                    2
                                ];
                            }
                            _tmp3 = {};
                            return [
                                4,
                                clients_UploadFileClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"].upload */ .Z.upload((_tmp3.body = {
                                    file: base64,
                                    type: type
                                }, _tmp3))
                            ];
                        case 5:
                            result = _state.sent();
                            if (!(0,clients__WEBPACK_IMPORTED_MODULE_1__/* .isValidWithoutData */ .Wk)(result)) utils__WEBPACK_IMPORTED_MODULE_7__/* .NotifyUtils.error */ .QP.error(translateMyAccount("upload_file_fail"));
                            _tmp4 = {};
                            if (val !== "businessImages") fileList.push((_tmp4.name = file.name, _tmp4.publicURL = (0,clients__WEBPACK_IMPORTED_MODULE_1__/* .getFirst */ .Xi)(result), _tmp4));
                            else fileList.push((0,clients__WEBPACK_IMPORTED_MODULE_1__/* .getFirst */ .Xi)(result));
                            handleSetValue(val, fileList);
                            return [
                                3,
                                7
                            ];
                        case 6:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
        });
    };
    var handleDeleteFile = function(link, value) {
        var tmpList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(fileList);
        if (value !== "businessImages") {
            tmpList = tmpList.filter(function(l) {
                return l.publicURL !== link;
            });
        } else tmpList = tmpList.filter(function(l) {
            return l !== link;
        });
        handleSetValue(value, tmpList);
    };
    var handleViewFile = function(link) {
        window.open((0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_9__/* .getLinkCDNGCS */ .re)(link));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrap), isMobileV2 && (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().mobileWrap)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                className: isMobileV2 ? (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().mobileUpload_title) : "",
                style: {
                    textAlign: "start",
                    fontSize: 16,
                    color: "#868585",
                    marginBottom: "10px"
                },
                children: [
                    label,
                    required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            color: "red"
                        },
                        children: "*"
                    })
                ]
            }),
            children,
            fileList && fileList.length > 0 && val !== "businessImages" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    margin: "8px 0"
                },
                children: [
                    fileList.map(function(file) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().file),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                handleViewFile(file.publicURL);
                                            },
                                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().preview),
                                            children: file.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            fontSize: "small",
                                            onClick: function() {
                                                return handleDeleteFile(file.publicURL, val);
                                            },
                                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().clearIcon)
                                        })
                                    ]
                                })
                            ]
                        }, (0,uuid__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)());
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {})
                ]
            }),
            fileList && fileList.length > 0 && val === "businessImages" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                container: true,
                spacing: 2,
                direction: "row",
                style: {
                    margin: "10px 0"
                },
                children: fileList.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        item: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapImage),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().inner),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_HighlightOff__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        fontSize: "small",
                                        onClick: function() {
                                            return handleDeleteFile(item, val);
                                        },
                                        style: {
                                            color: "#666666",
                                            cursor: "pointer"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    src: (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_9__/* .getLinkGCS */ .jA)(item || constants_Images__WEBPACK_IMPORTED_MODULE_4__/* .MISSING_IMAGE */ .g_W),
                                    width: 100,
                                    height: 100,
                                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().image),
                                    onClick: function() {
                                        handleViewFile(item);
                                    }
                                })
                            ]
                        })
                    }, (0,uuid__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)());
                })
            }),
            fileList && fileList.length > 0 && val === "orderFeedBack" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                container: true,
                spacing: 2,
                direction: "row",
                style: {
                    marginTop: 10
                },
                children: fileList.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        item: true,
                        md: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapImage),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().inner),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        fontSize: "small",
                                        onClick: function() {
                                            return handleDeleteFile(item.publicURL, val);
                                        },
                                        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().clearIcon)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    src: (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_9__/* .getLinkGCS */ .jA)(item.publicURL || constants_Images__WEBPACK_IMPORTED_MODULE_4__/* .MISSING_IMAGE */ .g_W),
                                    width: "265px",
                                    height: "175px",
                                    // layout="responsive"
                                    // objectFit="contain"
                                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().image),
                                    onClick: function() {
                                        handleViewFile(item.publicURL);
                                    }
                                })
                            ]
                        })
                    }, (0,uuid__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)());
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_dropzone__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                onDrop: onDrop,
                children: function(param) {
                    var getRootProps = param.getRootProps, getInputProps = param.getInputProps;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, getRootProps({
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_15___default().dropzone)
                        })), {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, getInputProps())),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackStatic */ .ez, {
                                            src: constants_Images__WEBPACK_IMPORTED_MODULE_4__/* .ADD_FILE_ICON */ .ZL$,
                                            width: "13px",
                                            height: "16px"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            style: {
                                                marginLeft: "14px",
                                                fontSize: "12px"
                                            },
                                            children: isMobile ? translateMyAccount("add_file") : translateMyAccount("drag_and_drop")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    style: {
                                        fontSize: 12
                                    },
                                    children: subLabel
                                })
                            ]
                        }))
                    });
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UploadFiles);


/***/ }),

/***/ 10565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eD": function() { return /* reexport */ mocules_AlertRequestLogin; },
  "zS": function() { return /* reexport */ mocules_AlphabetFilter; },
  "bi": function() { return /* reexport */ BlockTitle; },
  "Pk": function() { return /* reexport */ CartNote/* default */.Z; },
  "iL": function() { return /* reexport */ mocules_CheckoutSticky; },
  "Fj": function() { return /* reexport */ mocules_CountdownTimer/* default */.Z; },
  "WD": function() { return /* reexport */ mocules_CountdownTimerDetail; },
  "P0": function() { return /* reexport */ mocules_CustomModal["default"]; },
  "Nf": function() { return /* reexport */ mocules_CustomNoRowsOverlay; },
  "l9": function() { return /* reexport */ mocules_DeliveryCardList; },
  "kU": function() { return /* reexport */ mocules_DeliveryInfoForm; },
  "Gl": function() { return /* reexport */ mocules_DeliveryMethod; },
  "I5": function() { return /* reexport */ mocules_EditOrderButton; },
  "su": function() { return /* reexport */ mocules_FloatSearch; },
  "St": function() { return /* reexport */ mocules_ForgetPasswordFormV2; },
  "NR": function() { return /* reexport */ mocules_InvoiceCheckout; },
  "Jn": function() { return /* reexport */ LineItem; },
  "$i": function() { return /* reexport */ mocules_MultiImageBoxV2; },
  "Ah": function() { return /* reexport */ mocules_NewAuthModal; },
  "Db": function() { return /* reexport */ mocules_NewChangePasswordForm; },
  "o2": function() { return /* reexport */ mocules_NewInvoiceModal; },
  "Sz": function() { return /* reexport */ mocules_NewRegisterGuestForm; },
  "ow": function() { return /* reexport */ NewRegisterOrderInvoiceForm/* default */.Z; },
  "SY": function() { return /* reexport */ mocules_NewSignInForm; },
  "_B": function() { return /* reexport */ mocules_NewSignUpForm; },
  "XL": function() { return /* reexport */ mocules_PaymentMethod; },
  "YG": function() { return /* reexport */ mocules_PrintInvoiceButton; },
  "vS": function() { return /* reexport */ ProductCardContent/* default */.Z; },
  "jF": function() { return /* reexport */ ProductCardInput/* default */.Z; },
  "kV": function() { return /* reexport */ ProductDetailTabs/* default */.Z; },
  "pI": function() { return /* reexport */ ProductDetailTabsV2; },
  "Py": function() { return /* reexport */ ProductHorizontal; },
  "mF": function() { return /* reexport */ mocules_PromotionDetailModal; },
  "sb": function() { return /* reexport */ mocules_SearchOrder; },
  "Ji": function() { return /* reexport */ SearchResultText; },
  "Nq": function() { return /* reexport */ SellerInfo/* default */.Z; },
  "Uo": function() { return /* reexport */ mocules_SellerInfoProductDetail; },
  "mh": function() { return /* reexport */ mocules_TicketDetailModal; },
  "dp": function() { return /* reexport */ mocules_TicketFormModal; }
});

// UNUSED EXPORTS: AccountForm, AuthModal, ButtonReOrder, CartCouponCard, ComboList, CommonQuestion, Copyright, CouponCard, CouponCardV2, DealSection, DeliveryForm, EnterpriseForm, EventBadge, ForgetPasswordForm, HeaderUser, InfoInput, InfoTabs, IngredientList, InvoiceInfoCardList, InvoiceInfoForm, ManufacturerList, MultiImageBox, NewBadge, NewFeedbackForm, NewPasswordForm, OrderDetailInfo, OrderDetailProduct, OrderDetailStep, OrderInfoTabs, PromoListModal, RegisterGuestForm, RibbonPriceDown, RibbonPriceUp, SearchInput, SignInForm, SignUpForm, SliderProduct, StatusProduct, TagType, TicketButton, Toggle, UploadImages

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/mocules/InfoInput/index.js
var mocules_InfoInput = __webpack_require__(42150);
;// CONCATENATED MODULE: ./src/components/mocules/AccountForm/index.js









var AccountForm = function(param) {
    var name = param.name, email = param.email, phone = param.phone, handleSetValue = param.handleSetValue, err = param.err;
    // const [isShowPassword, setIsShowPassword] = useState(false);
    var toggleChangePassword = useAuth().toggleChangePassword;
    // const handleClickShowPassword = () => {
    //   setIsShowPassword(!isShowPassword);
    // };
    // const IconEndPassword = () => (
    //   <InputAdornment className={styles.padding_none}>
    //     <IconButton onClick={handleClickShowPassword}>{isShowPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
    //   </InputAdornment>
    // );
    return /*#__PURE__*/ _jsxs(Paper, {
        className: styles.root,
        elevation: 4,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles.title,
                children: " Th\xf4ng tin t\xe0i khoản "
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                children: [
                    /*#__PURE__*/ _jsx(InfoFormControl, {
                        xs: 12,
                        isRequired: true,
                        label: "Họ t\xean kh\xe1ch h\xe0ng",
                        htmlFor: "name",
                        error: err.name,
                        children: /*#__PURE__*/ _jsx(InfoInput, {
                            id: "name",
                            placeholder: "Họ v\xe0 t\xean",
                            value: name,
                            error: err.name,
                            onChange: function(e) {
                                return handleSetValue("name", e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(InfoFormControl, {
                        xs: 12,
                        isRequired: true,
                        label: "Số điện thoại",
                        htmlFor: "phone",
                        error: err.phone,
                        children: /*#__PURE__*/ _jsx(InfoInput, {
                            id: "phone",
                            placeholder: "Số điện thoại",
                            value: phone,
                            error: err.phone,
                            onChange: function(e) {
                                return handleSetValue("phone", e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(InfoFormControl, {
                        xs: 12,
                        label: "Email",
                        htmlFor: "email",
                        error: err.email,
                        children: /*#__PURE__*/ _jsx(InfoInput, {
                            id: "email",
                            placeholder: "Email",
                            value: email,
                            error: err.email,
                            onChange: function(e) {
                                return handleSetValue("email", e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.changepw,
                        children: /*#__PURE__*/ _jsx(Button, {
                            onClick: toggleChangePassword,
                            color: "primary",
                            children: "Thay đổi mật khẩu"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_AccountForm = ((/* unused pure expression or super */ null && (AccountForm)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid_Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
;// CONCATENATED MODULE: ./src/components/mocules/AlertRequestLogin/index.js





var AlertRequestLogin = function(param) {
    var bgColor = param.bgColor;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var ref1 = (0,context/* useAuth */.aC)(), toggleLogin = ref1.toggleLogin, toggleSignUp = ref1.toggleSignUp;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
        container: true,
        style: {
            background: bgColor || "#F7F8FB",
            maxWidth: "400",
            borderRadius: "5px",
            padding: "5px",
            fontSize: "14px"
        },
        alignItems: "center",
        children: [
            translateCommon("message_please"),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                style: {
                    marginLeft: "2px",
                    color: "#0E1983",
                    cursor: "pointer",
                    fontSize: "14px"
                },
                href: "#",
                onClick: toggleLogin,
                children: translateCommon("login")
            }),
            "/",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                style: {
                    marginRight: "2px",
                    color: "#0E1983",
                    cursor: "pointer",
                    fontSize: "14px"
                },
                href: "#",
                onClick: toggleSignUp,
                children: translateCommon("signup")
            }),
            " ",
            translateCommon("message_view_detail")
        ]
    });
};
/* harmony default export */ var mocules_AlertRequestLogin = (AlertRequestLogin);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/mocules/AlphabetFilter/styles.module.css
var styles_module = __webpack_require__(5177);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/AlphabetFilter/index.js





var getAlphabets = function() {
    var arr = [];
    for(var i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i += 1)arr.push(String.fromCharCode(i));
    arr.push("#");
    return arr;
};
var AlphabetFilter = function(param) {
    var word = param.word, handleChangeWord = param.handleChangeWord, isMobile = param.isMobile;
    var characters = getAlphabets();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((styles_module_default()).alphabetFilterWrapper, isMobile && (styles_module_default()).mobileAlphabetFilterWrapper),
        children: characters.map(function(character) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Fab */.Lg, {
                className: (0,clsx_m/* default */.Z)((styles_module_default()).alphabetFilterItem, (0,src_define_property/* default */.Z)({}, (styles_module_default()).alphabetFilterItemActive, character === word)),
                handleClick: handleChangeWord,
                children: character
            }, "fab-alphabet-".concat(character));
        })
    });
};
/* harmony default export */ var mocules_AlphabetFilter = (AlphabetFilter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton_IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
;// CONCATENATED MODULE: ./src/components/mocules/AuthModal/AuthModal.js








var AuthModal = /*#__PURE__*/ (0,react.memo)(function(props) {
    var onClose = props.onClose, visible = props.visible, children = props.children, title = props.title, className = props.className, restProps = props.restProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "auth-modal-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "auth-modal-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: "auth-modal-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            "aria-label": "close",
                            className: "auth-modal-close",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es.FontAwesomeIcon, {
                                icon: free_solid_svg_icons_index_es.faTimes
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "auth-modal-body",
                    children: children
                })
            ]
        })
    }));
});
/* harmony default export */ var AuthModal_AuthModal = (AuthModal);

;// CONCATENATED MODULE: ./src/components/mocules/AuthModal/index.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .auth-modal {\n    &-content {\n      position: relative;\n      width: ",
        "px;\n      background: ",
        ";\n      border: 1px solid rgba(0, 0, 0, 0.2);\n      box-shadow: theme.shadows[5];\n      border-radius: 1.25em;\n      outline: 0;\n      overflow: hidden;\n    }\n    &-header {\n      display: flex;\n      align-items: flex-start;\n      text-align: center;\n      justify-content: space-between;\n      border-bottom: 1px solid rgba(195, 204, 220, 0.4);\n    }\n    &-title {\n      padding: 1rem 2rem;\n      font-size: larger;\n      font-weight: 500;\n      margin-bottom: 0;\n      line-height: 1.5;\n      text-transform: capitalize;\n    }\n    &-close {\n      background-color: transparent;\n      border: 0;\n      color: #000;\n      opacity: 0.5;\n    }\n    &-body {\n      position: relative;\n      flex: 1 1 auto;\n      padding: 1rem;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    .auth-modal {\n      &-header {\n        line-height: 32px;\n      }\n    }\n    .auth-modal-content {\n      overflow: hidden;\n    }\n    .auth-modal-body {\n      padding: 0;\n      height: calc(100% - 60px);\n      overflow: auto;\n    }\n    .auth-modal-body .form-control {\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 450px) {\n    .auth-modal-content {\n      padding: 15px;\n      width: 100%;\n    }\n    .auth-modal-title {\n      padding-left: 5px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var mocules_AuthModal_AuthModal = (0,styled_components_browser_esm/* default */.ZP)(AuthModal_AuthModal).withConfig({
    componentId: "sc-1fb2d6bd-0"
})(_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 500 : _width;
    return width;
}, function(param) {
    var theme = param.theme;
    return theme.modal.background;
});
/* harmony default export */ var mocules_AuthModal = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(mocules_AuthModal_AuthModal))));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box_Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography_Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton_Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/components/mocules/BlockTitle/styles.module.css
var BlockTitle_styles_module = __webpack_require__(78762);
var BlockTitle_styles_module_default = /*#__PURE__*/__webpack_require__.n(BlockTitle_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/BlockTitle/index.js









function BlockTitle(_param) {
    var icon = _param.icon, title = _param.title, total = _param.total, totalTitle = _param.totalTitle, loading = _param.loading, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "icon",
        "title",
        "total",
        "totalTitle",
        "loading"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            className: (BlockTitle_styles_module_default()).titleWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                width: 200,
                height: 50
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    className: (BlockTitle_styles_module_default()).titleWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            className: (BlockTitle_styles_module_default()).title,
                            style: {
                                marginLeft: icon ? "12px" : "0"
                            },
                            children: title
                        })
                    ]
                }),
                total && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (BlockTitle_styles_module_default()).total,
                    children: [
                        (0,FormatNumber/* formatNumber */.uf)(total),
                        " ",
                        totalTitle
                    ]
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./src/clients/index.js + 21 modules
var clients = __webpack_require__(38169);
// EXTERNAL MODULE: ./src/hooks/index.js + 8 modules
var hooks = __webpack_require__(12807);
// EXTERNAL MODULE: ./src/services/index.js + 18 modules
var services = __webpack_require__(24508);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(46680);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/components/mocules/CustomModal/index.js
var mocules_CustomModal = __webpack_require__(39542);
;// CONCATENATED MODULE: ./src/components/mocules/ButtonReOrder/index.js




















var ButtonReOrder_ButtonReOrder = function(param) {
    var orderId = param.orderId;
    var ref = useTranslation("alert-action"), translateAlertAction = ref.t;
    var ref1 = useTranslation("tooltip-action"), translateTooltipAction = ref1.t;
    var ref2 = useTranslation("myOrder"), translateMyOrder = ref2.t;
    // const router = useRouter();
    var user = useAuth().user;
    var reOrderById = useCart().reOrderById;
    var ref3 = _sliced_to_array(useModal(), 2), isShowPopupConfirm = ref3[0], togglePopupConfirm = ref3[1];
    var ref4 = useState([]), items = ref4[0], setItems = ref4[1];
    var handleShowInfo = function() {
        var _ref = _async_to_generator(function() {
            var orderInfoRes, _tmp, orderInfo;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            OrderService.getOrderDetail((_tmp.orderId = orderId, _tmp.locationCode = user === null || user === void 0 ? void 0 : user.provinceCode, _tmp.customerLevel = user === null || user === void 0 ? void 0 : user.level, _tmp.getCombo = false, _tmp))
                        ];
                    case 1:
                        orderInfoRes = _state.sent();
                        orderInfo = getFirst(orderInfoRes);
                        if (!orderInfo) {
                            NotifyUtils.warn(translateAlertAction("message_not_found_order"));
                            return [
                                2
                            ];
                        }
                        setItems((orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.products) || []);
                        gtag.reOrderShowPopup();
                        togglePopupConfirm();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleShowInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClosePopup = function() {
        togglePopupConfirm();
        gtag.reOrderClickCancel();
    };
    var handleReOrder = function() {
        var _ref = _async_to_generator(function() {
            var result, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            reOrderById((_tmp.orderId = orderId, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        // const { products = [] } = orderInfo;
                        // const promiseAddProduct = [];
                        // products.forEach((item) => {
                        //   promiseAddProduct.push(updateCartItem({ product: item, q: item.quantity || 1 }));
                        // });
                        // await Promise.any(promiseAddProduct);
                        // update delivery info
                        // await updateCartInfo(orderInfo);
                        if (isShowPopupConfirm) {
                            togglePopupConfirm();
                        }
                        gtag.reOrderClickOk();
                        // const response = await CartService.checkoutCart(orderInfo);
                        if (isValid(result)) {
                            NotifyUtils.success(translateAlertAction("message_add_to_cart"));
                        } else {
                            NotifyUtils.error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_error_try_again"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                title: translateTooltipAction("tooltip_re-order"),
                arrow: true,
                children: /*#__PURE__*/ _jsx(ButtonDefault, {
                    onClick: handleShowInfo,
                    className: "my-order__button my-order__button--secondary",
                    children: translateMyOrder("my-order.re_order")
                })
            }),
            isShowPopupConfirm && /*#__PURE__*/ _jsx(CustomModal, {
                icon: false,
                visible: isShowPopupConfirm,
                onClose: handleClosePopup,
                title: translateMyOrder("my-order.re_buy"),
                content: translateMyOrder("my-order.do_you_want_to_re_add_product", {
                    numberProducts: items.length,
                    orderId: orderId
                }),
                btnOk: translateMyOrder("my-order.addCart"),
                onClickOk: handleReOrder,
                children: /*#__PURE__*/ _jsx(Grid, {
                    style: {
                        overflowY: "auto",
                        maxHeight: "400px"
                    },
                    children: items && items.length > 0 && items.map(function(param) {
                        var productInfo = param.productInfo, _quantity = param.quantity, quantity = _quantity === void 0 ? 1 : _quantity;
                        var ref = productInfo || {}, defaultImage = ref.defaultImage, name = ref.name, salePrice = ref.salePrice;
                        return /*#__PURE__*/ _jsxs(Card, {
                            className: styles.remove_item,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.remove_item_image,
                                    children: /*#__PURE__*/ _jsx(ImageFallbackProductImage, {
                                        className: styles.remove_item_image,
                                        src: defaultImage && "".concat(defaultImage, "?size=200"),
                                        fallbackSrc: defaultImage,
                                        width: 80,
                                        height: 80,
                                        alt: name && name
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.remove_item_content,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: styles.remove_item_cart_name,
                                            children: name && name
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: styles.remove_item_cart_price,
                                            children: [
                                                quantity,
                                                " x ",
                                                salePrice && formatCurrency(salePrice)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, uuidv4());
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_ButtonReOrder = ((/* unused pure expression or super */ null && (ButtonReOrder_ButtonReOrder)));

// EXTERNAL MODULE: ./src/constants/Colors/index.js
var Colors = __webpack_require__(47387);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/DateTimeUtils.js
var utils_DateTimeUtils = __webpack_require__(33213);
// EXTERNAL MODULE: ./src/utils/ValidateUtils.js
var utils_ValidateUtils = __webpack_require__(70220);
// EXTERNAL MODULE: ./src/components/mocules/CountdownTimer/index.js
var mocules_CountdownTimer = __webpack_require__(72640);
;// CONCATENATED MODULE: ./src/components/mocules/CartCouponCard/index.js


function CartCouponCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px !important;\n  margin-left: 22px !important;\n  text-transform: none !important;\n  color: #fff !important;\n  background-color: #005c29 !important;\n  border: 1px solid #005c29 !important;\n  border-radius: 8px;\n  padding: 4px 10px !important;\n  transition: 0.5s;\n  &:hover {\n    color: #005c29 !important;\n    background-color: #fff !important;\n    border-color: #005c29 !important;\n  }\n"
    ]);
    CartCouponCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px !important;\n  margin-left: 22px !important;\n  text-transform: none !important;\n  color: #005c29 !important;\n  background-color: #fff !important;\n  border: 1px solid #005c29 !important;\n  border-radius: 8px;\n  padding: 4px 10px !important;\n  transition: 0.5s;\n  opacity: 0.65;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

























var UseButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).withConfig({
    componentId: "sc-54c83cc6-0"
})(CartCouponCard_templateObject());
var UsedButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).withConfig({
    componentId: "sc-54c83cc6-1"
})(_templateObject1());
var CartCouponCard_CartCouponCard = function(props) {
    var ref = useTranslation("common"), translateCommon = ref.t;
    var _code = props.code, code = _code === void 0 ? "" : _code, _promotion = props.promotion, promotion = _promotion === void 0 ? {} : _promotion, tmp = props.promotionType, type = tmp === void 0 ? PROMO_TYPE.COMBO : tmp, expiredDate = props.endTime, startTime = props.startTime, _rewards = props.rewards, rewards = _rewards === void 0 ? [] : _rewards, _redeemCode = props.redeemCode, redeemCode = _redeemCode === void 0 ? [] : _redeemCode, handleChangePromo = props.handleChangePromo, _subPrice = props.subPrice, subPrice = _subPrice === void 0 ? 0 : _subPrice, isDisable = props.isDisable, message = props.message, className = props.className, _conditionsVi = props.conditionsVi, conditionsVi = _conditionsVi === void 0 ? [] : _conditionsVi, _giftList = props.giftList, giftList = _giftList === void 0 ? [] : _giftList;
    var ref1 = promotion || {}, _description = ref1.description, description = _description === void 0 ? "" : _description;
    var listCondition = conditionsVi.filter(function(item) {
        return item && !isEmpty(item.message);
    });
    var maxDiscountValue = 0;
    var discountValue = 0;
    var percent = 0;
    var ruleType = PROMO_REWARD_TYPE.ABSOLUTE;
    var isNotStart = startTime && DateTimeUtils.compareTime(startTime, Date.now()) > 0;
    var ref2 = _sliced_to_array(useModal(false), 2), expanded = ref2[0], toggleExpanded = ref2[1];
    // @TODO: datle rewards is only 1 now
    if (rewards.length !== 0) {
        var ref3, ref4, ref5, ref6;
        maxDiscountValue = ((ref3 = rewards[0]) === null || ref3 === void 0 ? void 0 : ref3.maxDiscount) || 0;
        discountValue = ((ref4 = rewards[0]) === null || ref4 === void 0 ? void 0 : ref4.absoluteDiscount) || 0;
        percent = ((ref5 = rewards[0]) === null || ref5 === void 0 ? void 0 : ref5.percentageDiscount) || 0;
        ruleType = ((ref6 = rewards[0]) === null || ref6 === void 0 ? void 0 : ref6.type) || PROMO_REWARD_TYPE.ABSOLUTE;
    }
    var getBenefitAvatar = function() {
        if (type === PROMO_TYPE.GIFT) return /*#__PURE__*/ _jsx(Image, {
            width: 60,
            height: 60,
            src: GIFT_ICON
        });
        if (type === PROMO_TYPE.COMBO) return /*#__PURE__*/ _jsx(Image, {
            width: 60,
            height: 60,
            src: GIFT_IMAGE
        });
        if (type === PROMO_TYPE.VOUCHERCODE && ruleType === PROMO_REWARD_TYPE.ABSOLUTE) return /*#__PURE__*/ _jsx("div", {
            style: {
                fontWeight: "bold",
                textAlign: "center"
            },
            children: formatCurrency(String(discountValue))
        });
        if (type === PROMO_TYPE.VOUCHERCODE && ruleType === PROMO_REWARD_TYPE.PERCENTAGE) return /*#__PURE__*/ _jsx("div", {
            style: {
                fontWeight: "bold",
                textAlign: "center"
            },
            children: "Giảm ".concat(percent, "% Tối đa ").concat(formatCurrency(String(maxDiscountValue)))
        });
        return "";
    };
    var caculatePrice = function() {
        if (ruleType === PROMO_REWARD_TYPE.ABSOLUTE) return Math.max(subPrice - discountValue, 0);
        if (ruleType === PROMO_REWARD_TYPE.PERCENTAGE) return Math.max(subPrice - subPrice * percent / 100, subPrice - maxDiscountValue);
        return subPrice;
    };
    var ButtonEle = function() {
        return String(code) === redeemCode[0] ? /*#__PURE__*/ _jsx(UsedButton, {
            children: " Đang d\xf9ng "
        }) : /*#__PURE__*/ _jsx(UseButton, {
            onClick: function() {
                return handleChangePromo(String(code), description);
            },
            children: "D\xf9ng ngay"
        });
    };
    var getTimeShow = function() {
        if (isNotStart) return /*#__PURE__*/ _jsxs("div", {
            children: [
                "Thời gian bắt đầu :",
                " ",
                /*#__PURE__*/ _jsx("span", {
                    children: DateTimeUtils.getFormattedDate(new Date(startTime), translateCommon, "HH:mm DD/MM/YYYY")
                })
            ]
        });
        return expiredDate ? /*#__PURE__*/ _jsx(CountdownTimer, {
            translateCommon: translateCommon,
            prefix: "Thời hạn: ",
            dealEndDay: expiredDate
        }) : "Kh\xf4ng giới hạn";
    };
    var getButtonShow = function() {
        return isDisable || isNotStart ? /*#__PURE__*/ _jsx(ImageFallbackStatic, {
            src: LOGO_NOT_MATCH_CONDITIONS,
            width: 72,
            height: 56
        }) : /*#__PURE__*/ _jsx(ButtonEle, {});
    };
    return /*#__PURE__*/ _jsx(Card, {
        className: clsx(styles.coupon_card, type === PROMO_TYPE.COMBO ? styles.coupon_yellow : styles.coupon_green),
        children: /*#__PURE__*/ _jsxs(Grid, {
            container: true,
            className: className,
            direction: "row",
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ _jsx(Grid, {
                    className: styles.col_left,
                    item: true,
                    container: true,
                    xs: 12,
                    md: 9,
                    children: /*#__PURE__*/ _jsxs(Grid, {
                        className: styles.col_left_inner,
                        container: true,
                        children: [
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                xs: 12,
                                sm: 3,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: styles.benefit,
                                    children: [
                                        getBenefitAvatar(),
                                        type === PROMO_TYPE.COMBO && "COMBO",
                                        type === PROMO_TYPE.GIFT && "Qu\xe0 Tặng",
                                        type === PROMO_TYPE.VOUCHERCODE && "Giảm gi\xe1"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Grid, {
                                item: true,
                                xs: 12,
                                sm: 9,
                                container: true,
                                direction: "column",
                                children: [
                                    type !== PROMO_TYPE.COMBO && /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        className: styles.coupon_description,
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: description
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        children: /*#__PURE__*/ _jsx("div", {
                                            style: {
                                                display: "flex"
                                            },
                                            children: getTimeShow()
                                        })
                                    }),
                                    isDisable && /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        style: {
                                            paddingTop: "5px"
                                        },
                                        children: /*#__PURE__*/ _jsx("strong", {
                                            style: {
                                                color: "red"
                                            },
                                            children: "Đơn h\xe0ng chưa thoả điều kiện."
                                        })
                                    }),
                                    !isDisable && type === PROMO_TYPE.VOUCHERCODE && /*#__PURE__*/ _jsxs(Grid, {
                                        item: true,
                                        style: {
                                            paddingTop: "5px"
                                        },
                                        children: [
                                            "Đơn h\xe0ng sau khi \xe1p dụng:",
                                            " ",
                                            /*#__PURE__*/ _jsx("strong", {
                                                style: {
                                                    color: "red"
                                                },
                                                children: formatCurrency(String(caculatePrice()))
                                            })
                                        ]
                                    }),
                                    !isDisable && type === PROMO_TYPE.GIFT && giftList && giftList.length > 0 && /*#__PURE__*/ _jsxs(Grid, {
                                        item: true,
                                        style: {
                                            paddingTop: "5px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "label",
                                                children: "Sản phẩm : "
                                            }),
                                            /*#__PURE__*/ _jsx("ul", {
                                                className: styles.giftList,
                                                children: giftList && giftList.length > 0 && giftList.map(function(item) {
                                                    /*#__PURE__*/ return _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: item === null || item === void 0 ? void 0 : item.name
                                                        })
                                                    }, item === null || item === void 0 ? void 0 : item.skuId);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        children: /*#__PURE__*/ _jsxs(Accordion, {
                                            expanded: expanded,
                                            onChange: toggleExpanded,
                                            style: {
                                                backgroundColor: "#fff",
                                                boxShadow: "none",
                                                border: "none",
                                                padding: "0px",
                                                margin: "0px",
                                                "&$expanded": {
                                                    margin: "0px",
                                                    padding: "0px"
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(AccordionSummary, {
                                                    style: {
                                                        padding: "0px",
                                                        textDecoration: "underline",
                                                        color: palette.grey[700],
                                                        fontSize: "10px",
                                                        minHeight: "25px",
                                                        margin: "0 0 -10px -5px"
                                                    },
                                                    children: !isEmpty(listCondition) && /*#__PURE__*/ _jsx(_Fragment, {
                                                        children: !expanded ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(ExpandMoreIcon, {
                                                                    fontSize: "small"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Typography, {
                                                                    style: {
                                                                        fontSize: "small"
                                                                    },
                                                                    children: "Xem th\xeam điều kiện"
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(ExpandLessIcon, {
                                                                    fontSize: "small"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Typography, {
                                                                    style: {
                                                                        fontSize: "small"
                                                                    },
                                                                    children: "Thu gọn điều kiện"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs(AccordionDetails, {
                                                    style: {
                                                        padding: 0,
                                                        display: "flex",
                                                        flexDirection: "column"
                                                    },
                                                    children: [
                                                        !isEmpty(listCondition) && listCondition.map(function(param) {
                                                            var conditionMsg = param.message;
                                                            return conditionMsg.map(function(param) {
                                                                var text = param.text, tmp = param.isDisable, messageDisable = tmp === void 0 ? false : tmp;
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    children: /*#__PURE__*/ _jsxs(Typography, {
                                                                        style: {
                                                                            fontSize: "small",
                                                                            color: messageDisable ? palette.error.light : palette.info.default,
                                                                            marginBottom: "10px"
                                                                        },
                                                                        children: [
                                                                            "* ",
                                                                            text
                                                                        ]
                                                                    })
                                                                }, uuidv4());
                                                            });
                                                        }),
                                                        message && /*#__PURE__*/ _jsx(Typography, {
                                                            style: {
                                                                fontSize: "small",
                                                                color: palette.error.main,
                                                                marginBottom: "10px"
                                                            },
                                                            children: message
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    className: styles.col_right,
                    item: true,
                    xs: 12,
                    md: 3,
                    container: true,
                    direction: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            className: styles.code,
                            children: code
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            style: {
                                paddingTop: 10
                            },
                            children: getButtonShow()
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_CartCouponCard = ((/* unused pure expression or super */ null && (CartCouponCard_CartCouponCard)));

// EXTERNAL MODULE: ./src/components/mocules/CartNote/index.js
var CartNote = __webpack_require__(86635);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider_Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel_FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper_Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip_Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocalOfferOutlined.js
var LocalOfferOutlined = __webpack_require__(25237);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Delete.js
var Delete = __webpack_require__(28428);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Alert/Alert.js + 4 modules
var Alert_Alert = __webpack_require__(8936);
// EXTERNAL MODULE: ./src/clients/ConfigManagerClient.js
var ConfigManagerClient = __webpack_require__(75340);
// EXTERNAL MODULE: ./src/clients/BotClient.js
var BotClient = __webpack_require__(33172);
// EXTERNAL MODULE: ./src/components-v2/mocules/CartPriceFluctuationModal/index.js + 1 modules
var CartPriceFluctuationModal = __webpack_require__(37566);
// EXTERNAL MODULE: ./src/components-v2/mocules/ErrorProductsPayment/index.js
var ErrorProductsPayment = __webpack_require__(17863);
// EXTERNAL MODULE: ./src/components-v2/mocules/ModalListProduct/index.js
var ModalListProduct = __webpack_require__(40907);
// EXTERNAL MODULE: ./src/constants/ErrorCart/index.js
var ErrorCart = __webpack_require__(83084);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/AddressService.js
var AddressService = __webpack_require__(84378);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/Insider.js
var Insider = __webpack_require__(78130);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js + 2 modules
var useSellers = __webpack_require__(14626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button_Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog_Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent_DialogContent = __webpack_require__(29525);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 3 modules
var Radio_Radio = __webpack_require__(79324);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js
var RadioGroup_RadioGroup = __webpack_require__(52541);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./src/components/mocules/PaymentMethod/styles.module.css
var PaymentMethod_styles_module = __webpack_require__(5397);
var PaymentMethod_styles_module_default = /*#__PURE__*/__webpack_require__.n(PaymentMethod_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/PaymentMethod/CurrencyPopup.js


















var CurrencyPopup = function(param) {
    var paymentMethod = param.paymentMethod, open = param.open, onClose = param.onClose, handleSubmit = param.handleSubmit, cartTotalPrice = param.cartTotalPrice, cartTotalUsdPrice = param.cartTotalUsdPrice, currencySelected = param.currencySelected, setCurrencySelected = param.setCurrencySelected;
    var locale = js_cookie_default().get("NEXT_LOCALE") || sysconfig/* LANG_DEFAULT */.YY;
    var t = (0,es/* useTranslation */.$G)("checkout").t;
    var ref;
    var currencyOptions = (0,react.useMemo)(function() {
        var ref1;
        return paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref1 = paymentMethod.currency) === null || ref1 === void 0 ? void 0 : ref1.map(function(method) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, method), {
                title: (ref = method["name_".concat(locale)]) !== null && ref !== void 0 ? ref : method.name,
                totalPrice: method.code === "USD" ? (0,FormatNumber/* formatCurrency */.xG)(cartTotalUsdPrice, ",", "$") : (0,FormatNumber/* formatCurrency */.xG)(Math.max(0, cartTotalPrice))
            });
        });
    }, [
        paymentMethod,
        cartTotalPrice,
        cartTotalUsdPrice
    ]);
    var handleChange = function(event) {
        setCurrencySelected(event.target.value);
    };
    if (!currencyOptions) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog_Dialog/* default */.Z, {
        open: open,
        maxWidth: "xs",
        fullWidth: true,
        classes: (PaymentMethod_styles_module_default()).currencyPopup,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent_DialogContent/* default */.Z, {
            style: {
                textAlign: "center",
                padding: "16px 20px 20px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ImageFallback */.oy, {
                    src: "/icons/credit_card_green.svg" // Replace with your icon path
                    ,
                    alt: "Wallet Icon",
                    width: 40,
                    height: 40,
                    style: {
                        marginBottom: "20px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    style: {
                        lineHeight: "24px",
                        fontSize: "20px",
                        fontWeight: 800,
                        fontFamily: "ggsm",
                        marginBottom: "8px"
                    },
                    children: t("currency_popup.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    style: {
                        lineHeight: "20px",
                        fontSize: "16px",
                        fontWeight: 400,
                        fontFamily: "ggsr",
                        color: "#0A0A0A"
                    },
                    children: t("currency_popup.sub_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "grid",
                        gap: 24,
                        margin: "20px 0px",
                        padding: "16px",
                        border: "1px solid #F0F0F0",
                        borderRadius: "8px"
                    },
                    children: currencyOptions.map(function(method) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup_RadioGroup/* default */.Z, {
                            className: (PaymentMethod_styles_module_default()).fieldset,
                            style: {
                                gap: 12
                            },
                            onChange: handleChange,
                            value: currencySelected,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                className: "".concat(currencySelected === method.code ? "active_payment" : ""),
                                disabled: !method.isActive,
                                value: method.code,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                                    classes: {
                                        root: currencySelected === method.code ? (PaymentMethod_styles_module_default()).checkbox_color : (PaymentMethod_styles_module_default()).noncheckbox_color
                                    },
                                    size: "small"
                                }),
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    container: true,
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                        item: true,
                                        container: true,
                                        direction: "column",
                                        alignItems: "left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                item: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body1",
                                                    style: {
                                                        textAlign: "left",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        fontFamily: "ggsr",
                                                        color: currencySelected === method.code ? "#005C29" : "#000000de"
                                                    },
                                                    children: method.title
                                                })
                                            }),
                                            method.isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                item: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body1",
                                                    style: {
                                                        textAlign: "left",
                                                        fontSize: "20px",
                                                        fontWeight: 700,
                                                        fontFamily: "ggsm"
                                                    },
                                                    children: method.totalPrice
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                item: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body1",
                                                    style: {
                                                        textAlign: "left",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        fontFamily: "ggsr",
                                                        color: "#0E1983"
                                                    },
                                                    children: t("currency_popup.currency_unavailable")
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }, method.code);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    container: true,
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                onClick: onClose,
                                style: {
                                    color: "#666",
                                    fontWeight: 600,
                                    borderRadius: "8px"
                                },
                                children: t("currency_popup.cancel")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                onClick: handleSubmit,
                                type: "submit",
                                variant: "contained",
                                color: "primary",
                                style: {
                                    backgroundColor: "#005C29",
                                    fontWeight: 600,
                                    borderRadius: "8px"
                                },
                                children: t("currency_popup.continue")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var PaymentMethod_CurrencyPopup = (CurrencyPopup);

// EXTERNAL MODULE: ./src/components/mocules/NewCustomModal/index.js
var mocules_NewCustomModal = __webpack_require__(24547);
;// CONCATENATED MODULE: ./src/components/mocules/CheckoutSticky/VerifyPaymentDiablog.js
/* eslint-disable no-case-declarations */ 







// status
// verifying , VERIFY_OK VERIFY_FAIL , proceess_payment , payment_ok , payment_fail
var STATUS_PROCESSING = {
    VERIFYING: "VERIFYING",
    VERIFY_OK: "VERIFY_OK",
    VERIFY_FAIL: "VERIFY_FAIL",
    PROCESS_PAYMENT: "PROCESS_PAYMENT",
    PAYMENT_OK: "PAYMENT_OK",
    PAYMENT_FAIL: "PAYMENT_FAIL"
};
var MESSAGE_VERIFY = {
    VERIFYING: {
        content: "Đang kiểm tra th\xf4ng tin thanh to\xe1n "
    },
    VERIFY_OK: "Kiểm tra th\xe0nh c\xf4ng",
    VERIFY_FAIL: "Kiểm tra gh\xf4ng tin thất bại",
    PROCESS_PAYMENT: "Đang thanh to\xe1n đơn h\xe0ng",
    PAYMENT_OK: "Thanh to\xe1n th\xe0nh c\xf4ng",
    PAYMENT_FAIL: "Thanh to\xe1n thất bại"
};
var VerifyPaymentDiablog = /*#__PURE__*/ (0,react.memo)(function(param) {
    var visible = param.visible, dataCart = param.dataCart;
    var router = (0,next_router.useRouter)();
    var verifyPayment = (0,context/* useCart */.jD)().verifyPayment;
    var ref = (0,react.useState)(STATUS_PROCESSING.VERIFYING), status = ref[0], setStatus = ref[1];
    var handleClickReload = function() {
        return window.location.reload(false);
    };
    var handleGotoCart = function() {
        return router.push("/cart");
    };
    (0,react.useEffect)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var rsPayment;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    switch(status){
                        case STATUS_PROCESSING.VERIFYING:
                            return [
                                3,
                                1
                            ];
                        case STATUS_PROCESSING.VERIFY_OK:
                            return [
                                3,
                                3
                            ];
                        case STATUS_PROCESSING.PROCESS_PAYMENT:
                            return [
                                3,
                                4
                            ];
                        case STATUS_PROCESSING.PAYMENT_FAIL:
                            return [
                                3,
                                5
                            ];
                        case STATUS_PROCESSING.PAYMENT_OK:
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        7
                    ];
                case 1:
                    return [
                        4,
                        verifyPayment(dataCart)
                    ];
                case 2:
                    rsPayment = _state.sent();
                    if ((0,clients/* isValid */.JY)(rsPayment)) {
                        setStatus(STATUS_PROCESSING.VERIFY_OK);
                    } else {
                        setStatus(STATUS_PROCESSING.VERIFY_FAIL);
                    }
                    return [
                        3,
                        8
                    ];
                case 3:
                    setStatus(STATUS_PROCESSING.PROCESS_PAYMENT);
                    // TODO: chuyển status sang payment
                    return [
                        3,
                        8
                    ];
                case 4:
                    // TODO: call API checkout ,
                    return [
                        3,
                        8
                    ];
                case 5:
                    // action fail --> display popup with message error , change function on button
                    return [
                        3,
                        8
                    ];
                case 6:
                    // action ok --> display popup with message error , change function on button
                    // redirect to thankoy
                    router.push("/thank-you");
                    return [
                        3,
                        8
                    ];
                case 7:
                    return [
                        3,
                        8
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    }), [
        status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_NewCustomModal/* default */.Z, {
        visible: visible,
        onClose: handleGotoCart,
        title: "Th\xf4ng b\xe1o",
        btnOk: "Thanh to\xe1n lại",
        content: MESSAGE_VERIFY[status].content,
        btnOnClose: "Xem lại giỏ h\xe0ng",
        onClickOk: handleClickReload
    });
});
/* harmony default export */ var CheckoutSticky_VerifyPaymentDiablog = (VerifyPaymentDiablog);

// EXTERNAL MODULE: ./src/components/mocules/CheckoutSticky/styles.module.css
var CheckoutSticky_styles_module = __webpack_require__(20430);
var CheckoutSticky_styles_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutSticky_styles_module);
// EXTERNAL MODULE: ./src/utils/StringUtils.js
var StringUtils = __webpack_require__(52380);
;// CONCATENATED MODULE: ./src/components/mocules/InvoiceInfoModal/validateForm.js


var validateForm_validateForm = function(param) {
    var companyName = param.companyName, companyAddress = param.companyAddress, taxCode = param.taxCode, mst = param.mst, translateAlertAction = param.translateAlertAction;
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty((0,StringUtils/* trimText */.rd)(companyName))) throw Error(translateAlertAction("message_empty_company_name"));
    if ((0,StringUtils/* trimText */.rd)(companyName).length <= 2) throw Error(translateAlertAction("message_valid_company_name"));
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(taxCode || mst)) throw Error(translateAlertAction("message_empty_tax_code"));
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty((0,StringUtils/* trimText */.rd)(companyAddress))) throw Error(translateAlertAction("message_empty_company_addresss"));
    if ((0,StringUtils/* trimText */.rd)(companyAddress).length <= 2) throw Error(translateAlertAction("message_invalid_company_address"));
    // if (!ValidateUtils.isNumber(mst)) throw Error('Mã số thuế sai định dạng');
    var mstError = utils/* ValidateUtils.validateMst */.IN.validateMst(taxCode || mst) || "";
    if (mstError) throw Error(translateAlertAction("".concat(mstError)));
// Truong Phan confirm
// if (mst.length !== 10 && mst.length !== 14) throw Error('Mã số thuế phải có 10 hoặc 14 số');
};
/* harmony default export */ var InvoiceInfoModal_validateForm = (validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/CheckoutSticky/validateForm.js




var CheckoutSticky_validateForm_validateForm = function(param, onSetError, translateAlertAction) {
    var customerName = param.customerName, customerPhone = param.customerPhone, customerEmail = param.customerEmail, customerShippingAddress = param.customerShippingAddress, customerProvinceCode = param.customerProvinceCode, customerDistrictCode = param.customerDistrictCode, customerWardCode = param.customerWardCode, totalWard = param.totalWard, invoice = param.invoice;
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(customerName)) {
        onSetError("name", true);
        throw new Error(translateAlertAction("message_not_input_name"));
    }
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(customerPhone)) {
        onSetError("phone", true);
        throw new Error(translateAlertAction("message_not_input_phone"));
    }
    if (!utils/* ValidateUtils.validatePhone */.IN.validatePhone(customerPhone)) {
        onSetError("phone", true);
        throw new Error(translateAlertAction("message_correct_phone_number_format"));
    }
    if (!utils/* ValidateUtils.isEmpty */.IN.isEmpty(customerEmail) && !utils/* ValidateUtils.validateEmail */.IN.validateEmail(customerEmail)) {
        onSetError("email", true);
        throw new Error(translateAlertAction("message_invalid_email"));
    }
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(customerShippingAddress)) {
        onSetError("address", true);
        throw new Error(translateAlertAction("message_not_input_address"));
    }
    if (customerProvinceCode === "0") {
        throw new Error(translateAlertAction("message_you_have_not_selected_province_City"));
    }
    if (customerDistrictCode === "0") {
        throw new Error(translateAlertAction("message_you_have_not_selected_the_district"));
    }
    if (customerWardCode === "0" && totalWard > 0) {
        throw new Error(translateAlertAction("message_you_have_not_selected_province_City"));
    }
    var invoiceRequest = (invoice || {}).invoiceRequest;
    // validate invoice
    if (invoice && invoiceRequest) {
        InvoiceInfoModal_validateForm((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, invoice), {
            translateAlertAction: translateAlertAction
        }));
    // if (ValidateUtils.isEmpty(customerEmail) || !ValidateUtils.validateEmail(customerEmail)) {
    //   onSetError('email', true);
    //   throw new Error('Xuất hoá đơn yêu cầu thông tin email.');
    // }
    }
};
/* harmony default export */ var CheckoutSticky_validateForm = (CheckoutSticky_validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/CheckoutSticky/index.js




















































// chưa lên popup chan tag 7 ngay
// const isHaveTag7Ngay = (items, dataCustomer) => {
//   if (REGION_MB.indexOf(`${dataCustomer?.provinceCode}`) < 0) {
//     return false;
//   }
//   let result = false;
//   items
//     ?.filter((item) => item.isSelected)
//     .forEach((item) => {
//       const resultItem = item?.productTags?.find((tag) => tag === TAG_HANG_DAT_TRUOC) || false;
//       if (resultItem) result = resultItem;
//     });
//   return result;
// };
var ERROR_REDIRECT_TO_CART = [
    ErrorCart/* ERROR_CODE_CART.VOUCHER_CODE_INVALID */.M5.VOUCHER_CODE_INVALID,
    ErrorCart/* ERROR_CODE_CART.VOUCHER_NOT_MATCH */.M5.VOUCHER_NOT_MATCH,
    ErrorCart/* ERROR_CODE_CART.COMBO_INVALID */.M5.COMBO_INVALID,
    ErrorCart/* ERROR_CODE_CART.TYPE_INVALID */.M5.TYPE_INVALID,
    ErrorCart/* ERROR_CODE_CART.QUANTITY_INVALID */.M5.QUANTITY_INVALID,
    ErrorCart/* ERROR_CODE_CART.SKU_MISSING */.M5.SKU_MISSING,
    ErrorCart/* ERROR_CODE_CART.SKU_NOT_FOUND */.M5.SKU_NOT_FOUND,
    ErrorCart/* ERROR_CODE_CART.TOTAL_PRICE_NOT_MATCH */.M5.TOTAL_PRICE_NOT_MATCH,
    ErrorCart/* ERROR_CODE_CART.LIMIT_SKU */.M5.LIMIT_SKU, 
];
// BE trả message chi tiết cho các lỗi này (ngưỡng giá trị đơn, khu vực, method vừa được đổi sang)
// => hiện nguyên văn message BE thay cho text chung đã map trong i18n.
var DELIVERY_METHOD_DETAIL_ERRORS = [
    ErrorCart/* ERROR_CODE_CART.DELIVERY_METHOD_NOT_MATCH */.M5.DELIVERY_METHOD_NOT_MATCH,
    ErrorCart/* ERROR_CODE_CART.DELIVERY_METHOD_INVALID */.M5.DELIVERY_METHOD_INVALID, 
];
// Lỗi phương thức giao hàng: ở lại checkout và tải lại giỏ để khách thấy method/phí BE vừa chọn lại.
var DELIVERY_METHOD_ERRORS = (0,src_to_consumable_array/* default */.Z)(DELIVERY_METHOD_DETAIL_ERRORS).concat([
    ErrorCart/* ERROR_CODE_CART.DELIVERY_METHOD_NOT_FOUND */.M5.DELIVERY_METHOD_NOT_FOUND, 
]);
// comp thanh toán , sticky
var CheckoutSticky = function(param) {
    var data = param.data, dataCustomer = param.dataCustomer, onSetError = param.onSetError, isMobile = param.isMobile, onLoading = param.onLoading, isSaveInfo = param.isSaveInfo, user = param.user, invoice = param.invoice, _invoices = param.invoices, invoices = _invoices === void 0 ? [] : _invoices, cart = param.cart, currentAddress = param.currentAddress, deliveryLimitData = param.deliveryLimitData, translateCheckout = param.translateCheckout, paymentMethods = param.paymentMethods;
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var getCartErrorMessage = function(res) {
        var fallbackKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "message_error_checkout";
        return DELIVERY_METHOD_DETAIL_ERRORS.includes(res === null || res === void 0 ? void 0 : res.errorCode) && (res === null || res === void 0 ? void 0 : res.message) || translateAlertAction("message_error_cart.".concat(res === null || res === void 0 ? void 0 : res.errorCode)) || (res === null || res === void 0 ? void 0 : res.message) || translateAlertAction(fallbackKey);
    };
    var ref1 = (0,context/* useCart */.jD)(), _redeemCode = ref1.redeemCode, redeemCode = _redeemCode === void 0 ? [] : _redeemCode, _price = ref1.price, price = _price === void 0 ? 0 : _price, _totalPrice = ref1.totalPrice, totalPrice = _totalPrice === void 0 ? 0 : _totalPrice, _totalUsdPrice = ref1.totalUsdPrice, totalUsdPrice = _totalUsdPrice === void 0 ? 0 : _totalUsdPrice, _deliveryMethodFee = ref1.deliveryMethodFee, deliveryMethodFee = _deliveryMethodFee === void 0 ? 0 : _deliveryMethodFee, _paymentMethodFee = ref1.paymentMethodFee, paymentMethodFee = _paymentMethodFee === void 0 ? 0 : _paymentMethodFee, _totalItemSelected = ref1.totalItemSelected, totalItemSelected = _totalItemSelected === void 0 ? 0 : _totalItemSelected, updateCart = ref1.updateCart, _redeemApplyResult = ref1.redeemApplyResult, redeemApplyResult = _redeemApplyResult === void 0 ? [] : _redeemApplyResult, cartNo = ref1.cartNo, _extraFee = ref1.extraFee, extraFee = _extraFee === void 0 ? null : _extraFee, _extraFeeNote = ref1.extraFeeNote, extraFeeNote = _extraFeeNote === void 0 ? null : _extraFeeNote, isOverWeightOrVolume = ref1.isOverWeightOrVolume, cartItems = ref1.cartItems, _errProducts = ref1.errProducts, errProducts = _errProducts === void 0 ? [] : _errProducts, removeCartItem = ref1.removeCartItem, selectCartItem = ref1.selectCartItem, removeImportant = ref1.removeImportant, paymentMethod = ref1.paymentMethod, getState = ref1.getState, _cartFluctuates = ref1.cartFluctuates, cartFluctuates = _cartFluctuates === void 0 ? [] : _cartFluctuates, isOpenPriceFluctuationModal = ref1.isOpenPriceFluctuationModal, togglePriceFluctuationModal = ref1.togglePriceFluctuationModal, confirmPriceFluctuation = ref1.confirmPriceFluctuation, applyPriceFluctuationFromVerify = ref1.applyPriceFluctuationFromVerify;
    // const redeemRs = redeemApplyResult && redeemApplyResult?.find((item) => !item?.autoApply && item?.canUse === true);
    // const autoRedeemRs = redeemApplyResult && redeemApplyResult?.find((item) => item?.autoApply && item?.canUse === true);
    // multi voucher
    var redeemRs = redeemApplyResult && (redeemApplyResult === null || redeemApplyResult === void 0 ? void 0 : redeemApplyResult.filter(function(item) {
        return !(item === null || item === void 0 ? void 0 : item.autoApply);
    }));
    var autoRedeemRs = redeemApplyResult && (redeemApplyResult === null || redeemApplyResult === void 0 ? void 0 : redeemApplyResult.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.autoApply) && (item === null || item === void 0 ? void 0 : item.canUse) === true;
    }));
    var ref2 = redeemRs || {}, code = ref2.code, tmp = ref2.discountValue, discountValueManual = tmp === void 0 ? 0 : tmp, tmp1 = ref2.gifts, giftsManual = tmp1 === void 0 ? null : tmp1;
    var ref3 = autoRedeemRs || {}, tmp2 = ref3.discountValue, discountValueAuto = tmp2 === void 0 ? 0 : tmp2, tmp3 = ref3.gifts, giftsAuto = tmp3 === void 0 ? null : tmp3;
    var totalGiftManual = (giftsManual === null || giftsManual === void 0 ? void 0 : giftsManual.length) > 0 && giftsManual.reduce(function(a, b) {
        return a + b.quantity;
    }, 0) || 0;
    var totalGiftAuto = (giftsAuto === null || giftsAuto === void 0 ? void 0 : giftsAuto.length) > 0 && giftsAuto.reduce(function(a, b) {
        return a + b.quantity;
    }, 0) || 0;
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var getSellerByCodeSync = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCodeSync;
    });
    var handleRedCustomer = (0,context/* useAuth */.aC)().handleRedCustomer;
    // TODO: feature-debt
    var debt = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.getDebt();
    });
    var appConfig = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.appConfig;
    });
    var setAppConfig = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.setAppConfig;
    });
    // const availableBalanceFormated = useStore((state) => state.getAvailableDebtBalance({ isFormated: true }));
    var beta = (0,storeMobile/* default */.Z)().beta;
    var clearMapProduct = (0,context/* useProduct */.iB)().clearMapProduct;
    // const { user } = useAuth();
    var needToBuy = function() {
        if (extraFee) {
            if (data.customerProvinceCode === "79" || data.customerProvinceCode === "01") return 1500000 - price;
            return 2000000 - price;
        }
        return 0;
    };
    // kiem tra loi truoc khi thanh toan
    // const [verifyNotice, setVerifyNotice] = useState(false);
    var locale = js_cookie_default().get("NEXT_LOCALE") || sysconfig/* LANG_DEFAULT */.YY;
    // doing: chỗ này là togggle popup
    var ref4 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 1), showModal = ref4[0];
    var router = (0,next_router.useRouter)();
    var ref5 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 2), showConfirmModal = ref5[0], toggleConfirm = ref5[1];
    var ref6 = (0,react.useState)(false), showMaintenanceModal = ref6[0], setShowMaintenanceModal = ref6[1];
    var ref7 = (0,react.useState)(""), errorMessage = ref7[0], setErrorMessage = ref7[1];
    var ref8 = (0,react.useState)({
        checked: true
    }), checkCondition = ref8[0], setCheckCondition = ref8[1];
    var ref9 = (0,react.useState)(false), openCurrencyPopup = ref9[0], setOpenCurrencyPopup = ref9[1];
    var ref10 = (0,react.useState)(""), currencySelected = ref10[0], setCurrencySelected = ref10[1];
    var deliveryData = dataCustomer.deliveryMethods.find(function(item) {
        return item.code === dataCustomer.deliveryMethod;
    }) || {};
    var ref11, ref12;
    var deliveryFeeName = (0,react.useMemo)(function() {
        return deliveryData ? (ref12 = (ref11 = deliveryData["name_".concat(locale)]) !== null && ref11 !== void 0 ? ref11 : deliveryData.name) !== null && ref12 !== void 0 ? ref12 : "" : "";
    }, [
        deliveryData,
        locale
    ]);
    var ref13;
    var deliveryFeeSubTitle = (0,react.useMemo)(function() {
        return (ref13 = deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.subTitle) !== null && ref13 !== void 0 ? ref13 : "";
    }, [
        deliveryData
    ]);
    var paymentData = dataCustomer.paymentMethods.find(function(item) {
        return item.code === dataCustomer.paymentMethod;
    }) || {};
    var ref14, ref15;
    var paymentName = (0,react.useMemo)(function() {
        return paymentData ? (ref15 = (ref14 = paymentData["name_".concat(locale)]) !== null && ref14 !== void 0 ? ref14 : paymentData.name) !== null && ref15 !== void 0 ? ref15 : "" : "";
    }, [
        paymentData,
        locale
    ]);
    var ref16, ref17;
    var paymentSubTitle = (0,react.useMemo)(function() {
        return paymentData ? (ref17 = (ref16 = paymentData["subTitle_".concat(locale)]) !== null && ref16 !== void 0 ? ref16 : paymentData.subTitle) !== null && ref17 !== void 0 ? ref17 : "" : "";
    }, [
        paymentData,
        locale
    ]);
    var GreenCheckbox = /*#__PURE__*/ react.memo(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,src_object_spread/* default */.Z)({
            classes: {
                root: (CheckoutSticky_styles_module_default()).checkbox
            },
            color: "default"
        }, props));
    });
    var ref18 = currentAddress || {}, district = ref18.district, province = ref18.province, ward = ref18.ward;
    var deliveryLimitMessage = "";
    var deliveryLimitCheck = false;
    var handleCheckCondition = function(event) {
        setCheckCondition((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, checkCondition), (0,src_define_property/* default */.Z)({}, event.target.name, event.target.checked)));
    };
    var GreenCheckBoxElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenCheckbox, {
        checked: checkCondition.checked,
        onChange: handleCheckCondition,
        name: "checked",
        "data-test": "checkbox-checkout-terms-of-use"
    });
    var LabelConfirm = /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (CheckoutSticky_styles_module_default()).check_agree_txt,
        children: [
            translateCheckout("i_agree_with"),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* LinkComp */.vk, {
                href: Paths/* TERMS_URL */.qy,
                color: "#005C29",
                target: true,
                children: [
                    "\xa0",
                    translateCheckout("condition_of_use")
                ]
            })
        ]
    });
    // const offPayment = user?.settings?.isDisablePayment;
    var validateSubmit = function(formData) {
        try {
            CheckoutSticky_validateForm(formData, onSetError, translateAlertAction);
            return true;
        } catch (error) {
            utils/* NotifyUtils.error */.QP.error(error.message);
            return false;
        }
    };
    var handleVerify = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, formValue, _tmp, _tmp1, districts, isExistDistrict, dataValidate, _tmp2, _tmp3, validateRs, _tmp4, _tmp5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onLoading(true);
                        _tmp = {};
                        _tmp1 = {};
                        formValue = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, data, dataCustomer), (_tmp1.invoice = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, invoice), {
                            email: data.customerEmail || dataCustomer.customerEmail
                        }), _tmp1.cartNo = cartNo, _tmp1));
                        Object.keys(formValue).forEach(function(key) {
                            if (typeof formValue[key] === "string") formValue[key] = formValue[key].trim();
                        });
                        if (!validateSubmit(formValue)) {
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        if (!checkCondition.checked) {
                            onLoading(false);
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_agree_condition_of_use"));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            AddressService/* default.getDistrictsByProvince */.Z.getDistrictsByProvince(formValue.customerProvinceCode)
                        ];
                    case 1:
                        districts = _state.sent();
                        if (!districts) {
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_found_ward_district"));
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        isExistDistrict = districts.find(function(item) {
                            return item.value === formValue.customerDistrictCode;
                        });
                        if (!isExistDistrict) {
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_found_ward_district"));
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        _tmp2 = {};
                        _tmp3 = {};
                        dataValidate = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp2, formValue), (_tmp3.totalPrice = totalPrice, _tmp3.voucherCode = redeemCode[0], _tmp3.skus = ((ref = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
                            return item.isSelected || item.type === "GIFT";
                        })) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var sku = param.sku, quantity = param.quantity, type = param.type;
                            return {
                                sku: sku,
                                type: type,
                                quantity: quantity
                            };
                        })) || [], _tmp3));
                        _tmp4 = {};
                        return [
                            4,
                            services/* CartService.validateCart */.Ni.validateCart((_tmp4.body = dataValidate, _tmp4))
                        ];
                    case 2:
                        validateRs = _state.sent();
                        utils/* NotifyUtils.success */.QP.success(JSON.stringify(validateRs));
                        _tmp5 = {};
                        BotClient/* default.sendMesageBotOrderKh */.Z.sendMesageBotOrderKh((_tmp5.message = "Test validate - ".concat((user === null || user === void 0 ? void 0 : user.phone) || "", " : ").concat(JSON.stringify(validateRs || {})), _tmp5));
                        onLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleVerify() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, formValue, _tmp, _tmp1, districts, isExistDistrict, ref2, tmp, latestTotalPrice, tmp1, latestCartItems, _tmp2, dataValidate, _tmp3, _tmp4, validateRs, _tmp5, ref3, _fluctuatedItems, fluctuatedItems, _tmp6, _tmp7, getErrorMessage, _tmp8, _tmp9, response, dataOrder, ref4, ref5, ref6, GATrackCart, _tmp10, _tmp11, address, _tmp12, addressResp, _tmp13, resp, _tmp14, addressResp1, _tmp15, orderId, _tmp16, _tmp17, _tmp18;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        formValue = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, data, dataCustomer), (_tmp1.invoice = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, invoice), {
                            email: data.customerEmail || dataCustomer.customerEmail
                        }), _tmp1.cartNo = cartNo, _tmp1));
                        Object.keys(formValue).forEach(function(key) {
                            if (typeof formValue[key] === "string") formValue[key] = formValue[key].trim();
                        });
                        // validate currency
                        if (Enums/* PAYMENT_METHOD_NEED_WAITING.includes */.IN.includes(formValue.paymentMethod)) {
                            if (!openCurrencyPopup) {
                                setOpenCurrencyPopup(true);
                                return [
                                    2
                                ];
                            }
                            if (currencySelected === "") {
                                utils/* NotifyUtils.error */.QP.error(translateCheckout("message_select_currency"));
                                return [
                                    2
                                ];
                            }
                            formValue.currency = currencySelected;
                        }
                        onLoading(true);
                        clearMapProduct();
                        if (!validateSubmit(formValue)) {
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        if (!checkCondition.checked) {
                            onLoading(false);
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_agree_condition_of_use"));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            AddressService/* default.getDistrictsByProvince */.Z.getDistrictsByProvince(formValue.customerProvinceCode)
                        ];
                    case 1:
                        districts = _state.sent();
                        if (!districts) {
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_found_ward_district"));
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        isExistDistrict = districts.find(function(item) {
                            return item.value === formValue.customerDistrictCode;
                        });
                        if (!isExistDistrict) {
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_found_ward_district"));
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        _tmp2 = {};
                        ref2 = getState() || _tmp2, tmp = ref2.totalPrice, latestTotalPrice = tmp === void 0 ? totalPrice : tmp, tmp1 = ref2.cartItems, latestCartItems = tmp1 === void 0 ? cartItems : tmp1;
                        _tmp3 = {};
                        _tmp4 = {};
                        dataValidate = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp3, formValue), (_tmp4.totalPrice = latestTotalPrice, _tmp4.voucherCode = redeemCode[0], _tmp4.skus = ((ref = latestCartItems === null || latestCartItems === void 0 ? void 0 : latestCartItems.filter(function(item) {
                            return item.isSelected || item.type === "GIFT";
                        })) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var sku = param.sku, quantity = param.quantity, type = param.type;
                            return {
                                sku: sku,
                                type: type,
                                quantity: quantity
                            };
                        })) || [], _tmp4));
                        _tmp5 = {};
                        return [
                            4,
                            services/* CartService.validateCart */.Ni.validateCart((_tmp5.body = dataValidate, _tmp5))
                        ];
                    case 2:
                        validateRs = _state.sent();
                        _tmp6 = {};
                        ref3 = (0,clients/* getFirst */.Xi)(validateRs) || _tmp6, _fluctuatedItems = ref3.fluctuatedItems, fluctuatedItems = _fluctuatedItems === void 0 ? [] : _fluctuatedItems;
                        if (applyPriceFluctuationFromVerify(fluctuatedItems)) {
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        if (!!(0,clients/* isValidWithoutData */.Wk)(validateRs)) return [
                            3,
                            7
                        ];
                        // nếu voucher, giỏ hàng lỗi sẽ tự động redirect về giỏ Hàng
                        // APO-1559
                        if (ERROR_REDIRECT_TO_CART.includes(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) {
                            router.replace(Paths/* CART_URL */.fh);
                            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error_cart.".concat(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) || (validateRs === null || validateRs === void 0 ? void 0 : validateRs.message) || translateAlertAction("message_error_checkout"));
                            return [
                                2
                            ];
                        }
                        if ((validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode) === Enums/* TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER */.q0.LOCKED_CUSTOMER && handleRedCustomer()) {
                            return [
                                2
                            ];
                        }
                        if (!ErrorCart/* ERROR_PRODUCTS.includes */.L$.includes(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) return [
                            3,
                            4
                        ];
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error_products_cart"));
                        onLoading(false);
                        return [
                            4,
                            updateCart()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                    case 4:
                        if (!DELIVERY_METHOD_ERRORS.includes(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) return [
                            3,
                            6
                        ];
                        utils/* NotifyUtils.error */.QP.error(getCartErrorMessage(validateRs));
                        onLoading(false);
                        _tmp7 = {};
                        // DELIVERY_METHOD_NOT_MATCH là luồng bình thường (BE đã tự đổi method), chỉ báo bot khi
                        // không có method nào áp dụng được — thường là lỗi config delivery-fee.
                        if ((validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode) !== ErrorCart/* ERROR_CODE_CART.DELIVERY_METHOD_NOT_MATCH */.M5.DELIVERY_METHOD_NOT_MATCH) {
                            BotClient/* default.sendMesageBotOrderKh */.Z.sendMesageBotOrderKh((_tmp7.message = "TS validate error - ".concat((user === null || user === void 0 ? void 0 : user.phone) || "", ": ").concat(JSON.stringify(validateRs || {})), _tmp7));
                        }
                        return [
                            4,
                            updateCart()
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if ((validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode) === "ORDER_MIN_1MILION") {
                            getErrorMessage = function(errorData) {
                                var defaultMessage = translateAlertAction("message_error_cart.ORDER_MIN_1MILION");
                                try {
                                    var ref = errorData.data[0], message = ref.message, messageEN = ref.messageEN;
                                    if (locale === "cam") {
                                        return message || defaultMessage;
                                    }
                                    return messageEN || defaultMessage;
                                } catch (e) {
                                    return defaultMessage;
                                }
                            };
                            utils/* NotifyUtils.error */.QP.error(getErrorMessage(validateRs));
                        } else {
                            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error_cart.".concat(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) || (validateRs === null || validateRs === void 0 ? void 0 : validateRs.message) || translateAlertAction("message_error_checkout"));
                        }
                        onLoading(false);
                        _tmp8 = {};
                        BotClient/* default.sendMesageBotOrderKh */.Z.sendMesageBotOrderKh((_tmp8.message = "TS validate error - ".concat((user === null || user === void 0 ? void 0 : user.phone) || "", ": ").concat(JSON.stringify(validateRs || {})), _tmp8));
                        return [
                            2
                        ];
                    case 7:
                        if (!(invoices && invoices.length < 10 && invoice && invoice.invoiceRequest && invoices.findIndex(function(item) {
                            return item.code === invoice.code;
                        }) === -1 && ((ref1 = invoices.filter(function(param) {
                            var taxCode = param.taxCode, companyName = param.companyName, companyAddress = param.companyAddress;
                            return taxCode === invoice.taxCode && companyName === invoice.companyName && companyAddress === invoice.companyAddress;
                        })) === null || ref1 === void 0 ? void 0 : ref1.length) === 0)) return [
                            3,
                            9
                        ];
                        _tmp9 = {};
                        return [
                            4,
                            clients/* CustomerClient.createInvoiceInfo */.YP.createInvoiceInfo((_tmp9.body = invoice, _tmp9))
                        ];
                    case 8:
                        _state.sent();
                        _state.label = 9;
                    case 9:
                        return [
                            4,
                            services/* CartService.checkoutCart */.Ni.checkoutCart(formValue)
                        ];
                    case 10:
                        response = _state.sent();
                        if (!(0,clients/* isValid */.JY)(response)) return [
                            3,
                            20
                        ];
                        // TODO: insider
                        Insider/* default.confirmation */.Z.confirmation();
                        dataOrder = (0,clients/* getFirst */.Xi)(response);
                        if (!dataOrder) return [
                            3,
                            12
                        ];
                        _tmp10 = {};
                        _tmp11 = {};
                        GATrackCart = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp10, cart), (_tmp11.cartItems = (cart === null || cart === void 0 ? void 0 : (ref4 = cart.cartItems) === null || ref4 === void 0 ? void 0 : ref4.filter(function(item) {
                            return item.isSelected;
                        })) || [], _tmp11));
                        // load data seller nếu chưa có bằng hàm này
                        return [
                            4,
                            Promise.all(GATrackCart === null || GATrackCart === void 0 ? void 0 : (ref5 = GATrackCart.cartItems) === null || ref5 === void 0 ? void 0 : ref5.map(function(prd) {
                                return getSellerByCode({
                                    code: prd === null || prd === void 0 ? void 0 : prd.sellerCode
                                });
                            }))
                        ];
                    case 11:
                        _state.sent();
                        // lấy data seller từ store
                        // nếu từ cart / sp là combo thì retailPrice là 1000 -> cần lấy lại giá theo cartItem
                        GATrackCart.cartItems = (GATrackCart === null || GATrackCart === void 0 ? void 0 : (ref6 = GATrackCart.cartItems) === null || ref6 === void 0 ? void 0 : ref6.map(function(prd) {
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prd), {
                                sellerInfo: getSellerByCodeSync({
                                    code: prd === null || prd === void 0 ? void 0 : prd.sellerCode
                                }),
                                displayPrice: prd.price
                            });
                        })) || [];
                        utils/* gtag.purchase */.SX.purchase(GATrackCart);
                        _state.label = 12;
                    case 12:
                        if (!isSaveInfo) return [
                            3,
                            19
                        ];
                        _tmp12 = {};
                        address = (_tmp12.code = formValue.customerAddressCode, _tmp12.name = formValue.customerName, _tmp12.phone = formValue.customerPhone, _tmp12.email = formValue.customerEmail, _tmp12.address = formValue.customerShippingAddress, _tmp12.provinceCode = formValue.customerProvinceCode, _tmp12.districtCode = formValue.customerDistrictCode, _tmp12.wardCode = formValue.customerWardCode, _tmp12.regionCode = formValue.customerRegionCode, _tmp12);
                        if (!!formValue.customerAddressCode) return [
                            3,
                            14
                        ];
                        _tmp13 = {};
                        return [
                            4,
                            clients/* CustomerClient.createAddress */.YP.createAddress((_tmp13.body = address, _tmp13))
                        ];
                    case 13:
                        addressResp = _state.sent();
                        if (!(0,clients/* isValid */.JY)(addressResp)) utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_failed_save_address"));
                        return [
                            3,
                            19
                        ];
                    case 14:
                        _tmp14 = {};
                        return [
                            4,
                            clients/* CustomerClient.updateAddress */.YP.updateAddress((_tmp14.body = address, _tmp14))
                        ];
                    case 15:
                        resp = _state.sent();
                        if (!(0,clients/* isValid */.JY)(resp)) return [
                            3,
                            16
                        ];
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_save_address"));
                        return [
                            3,
                            19
                        ];
                    case 16:
                        if (!(resp && resp.status === Enums/* HTTP_STATUS.NotFound */.MG.NotFound)) return [
                            3,
                            18
                        ];
                        _tmp15 = {};
                        return [
                            4,
                            clients/* CustomerClient.createAddress */.YP.createAddress((_tmp15.body = address, _tmp15))
                        ];
                    case 17:
                        addressResp1 = _state.sent();
                        if ((0,clients/* isValid */.JY)(addressResp1)) utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_save_address"));
                        else utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_failed_save_address"));
                        return [
                            3,
                            19
                        ];
                    case 18:
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_failed_save_address"));
                        _state.label = 19;
                    case 19:
                        setTimeout(function() {
                            updateCart();
                        }, 1000);
                        _tmp16 = {};
                        orderId = (response.data[0] || _tmp16).orderId;
                        if (Enums/* PAYMENT_METHOD_NEED_WAITING.includes */.IN.includes(formValue.paymentMethod)) {
                            // redirect checkout to waiting payment page
                            router.push("".concat(Paths/* WAITING_PAYMENT */.a1, "/").concat(orderId));
                        } else {
                            router.push("".concat(Paths/* THANKYOU_URL */.NY, "/").concat(orderId));
                        }
                        return [
                            3,
                            21
                        ];
                    case 20:
                        if ((response === null || response === void 0 ? void 0 : response.errorCode) === Enums/* TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER */.q0.LOCKED_CUSTOMER && handleRedCustomer()) {
                            return [
                                2
                            ];
                        }
                        onLoading(false);
                        _tmp17 = {};
                        BotClient/* default.sendMessage */.Z.sendMessage((_tmp17.message = "TS checkout error - ".concat(user === null || user === void 0 ? void 0 : user.phone, ": ").concat(JSON.stringify(response || {})), _tmp17));
                        _tmp18 = {};
                        BotClient/* default.sendMesageBotOrderKh */.Z.sendMesageBotOrderKh((_tmp18.message = "TS checkout error - ".concat(user === null || user === void 0 ? void 0 : user.phone, ": ").concat(JSON.stringify(response || {})), _tmp18));
                        utils/* NotifyUtils.error */.QP.error(getCartErrorMessage(response));
                        setErrorMessage("".concat(translateAlertAction("message__failed_payment"), ": ").concat(getCartErrorMessage(response, "message_system_error")));
                        updateCart();
                        _state.label = 21;
                    case 21:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    // Feature flag: chặn checkout khi hệ thống đang bảo trì (app config key ALLOW_CHECKOUT)
    // status === 0 => không cho checkout => hiển thị popup bảo trì.
    // status khác 0 (hoặc không tìm thấy config) => cho phép checkout bình thường.
    var getCheckoutBlockedFromConfig = function() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        try {
            var item = config === null || config === void 0 ? void 0 : config.find(function(cfg) {
                var ref;
                return (cfg === null || cfg === void 0 ? void 0 : (ref = cfg.value) === null || ref === void 0 ? void 0 : ref.key) === "ALLOW_CHECKOUT";
            });
            var status = ((item === null || item === void 0 ? void 0 : item.value) || {}).status;
            return status === 0;
        } catch (e) {
            return false;
        }
    };
    // Lấy trạng thái cờ ALLOW_CHECKOUT mới nhất ngay tại thời điểm bấm checkout.
    // Tránh dùng appConfig đã cache từ SSR (có thể bị stale nếu admin vừa đổi status).
    // Nếu request lỗi => fallback về giá trị đã cache trong store để không chặn nhầm toàn bộ khách.
    var fetchCheckoutBlockedLatest = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var res, _tmp, freshConfig, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            ConfigManagerClient/* default.getAppValueByCode */.Z.getAppValueByCode((_tmp.appCode = sysconfig/* APP_CONFIG_CODE */.pC, _tmp))
                        ];
                    case 1:
                        res = _state.sent();
                        if ((0,clients/* isValid */.JY)(res)) {
                            freshConfig = (0,clients/* getData */.Yu)(res) || [];
                            setAppConfig(freshConfig);
                            return [
                                2,
                                getCheckoutBlockedFromConfig(freshConfig)
                            ];
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            getCheckoutBlockedFromConfig(appConfig)
                        ];
                }
            });
        });
        return function fetchCheckoutBlockedLatest() {
            return _ref.apply(this, arguments);
        };
    }();
    var proceedCheckout = function() {
        if (extraFee) {
            toggleConfirm();
        } else {
            handleSubmit();
        }
    };
    // Bọc hành động checkout: fetch config mới nhất rồi mới quyết định cho qua hay chặn.
    // Gate biến động giá KHÔNG nằm ở đây mà nằm trong handleSubmit, ngay sau validateCart:
    // vừa dùng lại được request verify sẵn có (không phải load lại giỏ), vừa phủ luôn nhánh
    // đi qua modal xác nhận phụ thu (proceedCheckout -> toggleConfirm -> handleSubmit).
    var handleCheckoutClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var blocked;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onLoading(true);
                        return [
                            4,
                            fetchCheckoutBlockedLatest()
                        ];
                    case 1:
                        blocked = _state.sent();
                        onLoading(false);
                        if (blocked) {
                            setShowMaintenanceModal(true);
                            return [
                                2
                            ];
                        }
                        proceedCheckout();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCheckoutClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // Khách chấp nhận giá mới: chốt giá rồi đặt hàng luôn, không bắt bấm lại nút thanh toán.
    var handleConfirmPriceFluctuation = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            confirmPriceFluctuation()
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) return [
                            2
                        ];
                        togglePriceFluctuationModal(false);
                        proceedCheckout();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmPriceFluctuation() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBackToCart = function() {
        togglePriceFluctuationModal(false);
        router.push(Paths/* CART_URL */.fh);
    };
    if (deliveryLimitData) {
        deliveryLimitData === null || deliveryLimitData === void 0 ? void 0 : deliveryLimitData.forEach(function(item) {
            var ref, ref1, ref2;
            if ((item === null || item === void 0 ? void 0 : (ref = item.wardCodes) === null || ref === void 0 ? void 0 : ref.indexOf(ward)) >= 0 || (item === null || item === void 0 ? void 0 : (ref1 = item.districtCodes) === null || ref1 === void 0 ? void 0 : ref1.indexOf(district)) >= 0 || (item === null || item === void 0 ? void 0 : (ref2 = item.provinceCodes) === null || ref2 === void 0 ? void 0 : ref2.indexOf(province)) >= 0) {
                deliveryLimitMessage = item === null || item === void 0 ? void 0 : item.message;
                deliveryLimitCheck = true;
            }
        });
    }
    var DisplayPrice = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CheckoutSticky_styles_module_default()).total,
            children: utils/* FormatNumber.formatCurrency */.AV.formatCurrency(Math.max(Math.max(totalPrice, 0), 0))
        });
    };
    var DisplayPriceMobileNew = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CheckoutSticky_styles_module_default()).totalM,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: translateCheckout("total_money")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: utils/* FormatNumber.formatCurrency */.AV.formatCurrency(Math.max(totalPrice, 0))
                })
            ]
        });
    };
    // del err items in cart
    var ref19 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openErrItems = ref19[0], toggleErrItems = ref19[1];
    // card lỗi nằm dưới cùng cột thanh toán, khách không cuộn xuống sẽ không thấy
    // -> tự cuộn tới khi có sản phẩm lỗi
    var isShowErrCard = (errProducts === null || errProducts === void 0 ? void 0 : errProducts.length) > 0 && !isMobile;
    var errCardRef = (0,hooks/* useScrollIntoViewOnShow */.aT)(isShowErrCard);
    var handleDeleteErrProducts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            errProducts === null || errProducts === void 0 ? void 0 : errProducts.forEach(function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(function(item) {
                                    var _tmp, _tmp1;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (Enums/* ARR_REMOVE_PRODUCT.indexOf */.mJ.indexOf(item === null || item === void 0 ? void 0 : item.errorCode) >= 0) {
                                                    removeCartItem(item);
                                                }
                                                if (!((item === null || item === void 0 ? void 0 : item.errorCode) === "MAX_QUANTITY")) return [
                                                    3,
                                                    3
                                                ];
                                                if (!(item === null || item === void 0 ? void 0 : item.isImportant)) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    removeImportant(item)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                _tmp = {};
                                                _tmp1 = {};
                                                selectCartItem((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, item), (_tmp1.isSelected = !item.isSelected, _tmp1)));
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(item) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_remove_all_error"));
                        toggleErrItems();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(error.message || translateAlertAction("message_remove_all_error_fail"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        router.reload();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteErrProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    // translate
    var MapExtraFee = {
        vi: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        children: [
                            "Với đơn h\xe0ng dưới 1.5 triệu đồng (TP HCM v\xe0 H\xe0 Nội) hoặc dưới 2 triệu đồng (c\xe1c tỉnh kh\xe1c) sẽ bị phụ ph\xed",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                children: [
                                    " ",
                                    (0,FormatNumber/* formatCurrency */.xG)(50000)
                                ]
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        children: [
                            "Bạn c\xf2n cần ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: (0,FormatNumber/* formatCurrency */.xG)(needToBuy())
                            }),
                            " để được kh\xf4ng bị t\xednh phụ ph\xed. Bạn muốn tiếp tục chứ?"
                        ]
                    })
                ]
            });
        },
        // need to translate to English
        en: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        children: [
                            "Với đơn h\xe0ng dưới 1.5 triệu đồng (TP HCM v\xe0 H\xe0 Nội) hoặc dưới 2 triệu đồng (c\xe1c tỉnh kh\xe1c) sẽ bị phụ ph\xed",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                children: [
                                    " ",
                                    (0,FormatNumber/* formatCurrency */.xG)(50000)
                                ]
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        children: [
                            "Bạn c\xf2n cần ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: (0,FormatNumber/* formatCurrency */.xG)(needToBuy())
                            }),
                            " để được kh\xf4ng bị t\xednh phụ ph\xed. Bạn muốn tiếp tục chứ?"
                        ]
                    })
                ]
            });
        },
        // need to translate to Cambodia
        cam: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        children: [
                            "Với đơn h\xe0ng dưới 1.5 triệu đồng (TP HCM v\xe0 H\xe0 Nội) hoặc dưới 2 triệu đồng (c\xe1c tỉnh kh\xe1c) sẽ bị phụ ph\xed",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                children: [
                                    " ",
                                    (0,FormatNumber/* formatCurrency */.xG)(50000)
                                ]
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        children: [
                            "Bạn c\xf2n cần ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: (0,FormatNumber/* formatCurrency */.xG)(needToBuy())
                            }),
                            " để được kh\xf4ng bị t\xednh phụ ph\xed. Bạn muốn tiếp tục chứ?"
                        ]
                    })
                ]
            });
        }
    };
    // multi voucher
    var getTotalRedeemRs = function() {
        var autoRedeem = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], redeem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        var total = 0;
        var validDiscounts = {
            auto: autoRedeem === null || autoRedeem === void 0 ? void 0 : autoRedeem.filter(function(child) {
                return child.discountValue && typeof +child.discountValue === "number";
            }),
            redeem: redeem === null || redeem === void 0 ? void 0 : redeem.filter(function(child) {
                return child.discountValue && typeof +child.discountValue === "number";
            })
        };
        if (validDiscounts.auto && validDiscounts.redeem) {
            var ref, ref1;
            total = ((ref = validDiscounts.auto) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, cur) {
                return acc + cur.discountValue;
            }, 0)) + ((ref1 = validDiscounts.redeem) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, cur) {
                return acc + cur.discountValue;
            }, 0));
        } else {
            // eslint-disable-next-line no-lonely-if
            if (validDiscounts.auto) {
                var ref2;
                total = (ref2 = validDiscounts.auto) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(acc, cur) {
                    return acc + cur.discountValue;
                }, 0);
            } else if (validDiscounts.redeem) {
                var ref3;
                total = (ref3 = validDiscounts.redeem) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, cur) {
                    return acc + cur.discountValue;
                }, 0);
            } else {
                total = 0;
            }
        }
        return (0,FormatNumber/* formatCurrency */.xG)(total);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CheckoutSticky_styles_module_default()).checkout_sticky,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CheckoutSticky_styles_module_default()).checkout_title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        children: [
                            translateCheckout("order"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                children: [
                                    "(",
                                    (0,FormatNumber/* formatNumber */.uf)(totalItemSelected),
                                    " ",
                                    translateCheckout("product"),
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                        onClick: function() {
                            return router.push("/cart");
                        },
                        className: (CheckoutSticky_styles_module_default()).btn,
                        title: translateCheckout("edit_cart"),
                        "data-test": "btn-checkout-edit",
                        children: translateCheckout("edit")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper_Paper/* default */.Z, {
                className: (CheckoutSticky_styles_module_default()).root,
                elevation: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: translateCheckout("estimated_total")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: (0,FormatNumber/* formatCurrency */.xG)(price)
                            })
                        ]
                    }),
                    (debt === null || debt === void 0 ? void 0 : debt.isActive) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: translateCheckout("debt_remain")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: debt.balanceFormated
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label_first,
                                        children: deliveryFeeName || translateCheckout("delivery_fee")
                                    }),
                                    deliveryFeeSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label_second,
                                        children: deliveryFeeSubTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: (0,FormatNumber/* formatCurrency */.xG)(deliveryMethodFee)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label_first,
                                        children: paymentName || translateCheckout("checkout_fee")
                                    }),
                                    paymentSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label_second,
                                        children: paymentSubTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: (paymentData === null || paymentData === void 0 ? void 0 : paymentData.code) !== Enums/* PAYMENT_METHOD.CREDIT */.hL.CREDIT && (0,FormatNumber/* formatCurrency */.xG)(paymentMethodFee)
                            })
                        ]
                    }),
                    extraFee && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label_first,
                                        children: translateCheckout("surcharge")
                                    }),
                                    extraFeeNote && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label_second,
                                        children: extraFeeNote
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: (0,FormatNumber/* formatCurrency */.xG)(extraFee)
                            })
                        ]
                    }),
                    ((redeemRs === null || redeemRs === void 0 ? void 0 : redeemRs.length) > 0 || (autoRedeemRs === null || autoRedeemRs === void 0 ? void 0 : autoRedeemRs.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                className: (CheckoutSticky_styles_module_default()).dividerCustom
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((CheckoutSticky_styles_module_default()).total_redeems, "  ").concat((CheckoutSticky_styles_module_default()).d_flex),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label,
                                        children: translateCheckout("total_discount")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_content,
                                        children: "-".concat(getTotalRedeemRs(autoRedeemRs, redeemRs))
                                    })
                                ]
                            }),
                            (autoRedeemRs === null || autoRedeemRs === void 0 ? void 0 : autoRedeemRs.length) > 0 && autoRedeemRs.map(function(child, index) {
                                var ref, ref1, ref2;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).d_flex, (CheckoutSticky_styles_module_default()).checkout_promo_code),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalOfferOutlined/* default */.Z, {
                                                    fontSize: "small"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "#A2A0A0",
                                                        marginLeft: "4px",
                                                        fontSize: "14px",
                                                        maxWidth: "70%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    },
                                                    children: child === null || child === void 0 ? void 0 : child.code
                                                })
                                            ]
                                        }),
                                        (child === null || child === void 0 ? void 0 : child.discountValue) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).checkout_content, (CheckoutSticky_styles_module_default()).break_line),
                                            children: "-".concat((0,FormatNumber/* formatCurrency */.xG)(child.discountValue))
                                        }),
                                        (child === null || child === void 0 ? void 0 : (ref = child.gifts) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    style: {
                                                        fontFamily: "ggsm",
                                                        marginRight: 5,
                                                        color: "#000"
                                                    },
                                                    children: [
                                                        "x",
                                                        ((ref2 = (ref1 = child.gifts) === null || ref1 === void 0 ? void 0 : ref1.flat()) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(accmulator, currentChild) {
                                                            return accmulator + (currentChild === null || currentChild === void 0 ? void 0 : currentChild.quantity);
                                                        }, 0)) || 0
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* CART_NEW_GIFT_ICON */.rQw,
                                                    alt: "icon gift",
                                                    height: "19",
                                                    width: "19"
                                                })
                                            ]
                                        })
                                    ]
                                }, (child === null || child === void 0 ? void 0 : child.code) || index);
                            }),
                            redeemRs && redeemRs.length > 0 && redeemRs.map(function(child, index) {
                                var ref, ref1, ref2;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).d_flex, (CheckoutSticky_styles_module_default()).checkout_promo_code),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalOfferOutlined/* default */.Z, {
                                                    fontSize: "small"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "#A2A0A0",
                                                        marginLeft: "4px",
                                                        fontSize: "14px",
                                                        maxWidth: "70%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    },
                                                    children: child.code
                                                })
                                            ]
                                        }),
                                        child.discountValue > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).checkout_content, (CheckoutSticky_styles_module_default()).break_line),
                                            children: "-".concat((0,FormatNumber/* formatCurrency */.xG)(child.discountValue))
                                        }),
                                        ((ref = child.gifts) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    style: {
                                                        fontFamily: "ggsm",
                                                        marginRight: 5,
                                                        color: "#000"
                                                    },
                                                    children: [
                                                        "x",
                                                        ((ref2 = (ref1 = child.gifts) === null || ref1 === void 0 ? void 0 : ref1.flat()) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(accmulator, currentChild) {
                                                            return accmulator + (currentChild === null || currentChild === void 0 ? void 0 : currentChild.quantity);
                                                        }, 0)) || 0
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* CART_NEW_GIFT_ICON */.rQw,
                                                    alt: "icon gift",
                                                    height: "19",
                                                    width: "19"
                                                })
                                            ]
                                        })
                                    ]
                                }, child.code || index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        style: {
                            margin: "auto",
                            width: "90%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            margin: "12px 0"
                        },
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                style: {
                                    fontSize: 16
                                },
                                children: translateCheckout("total_money")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).total,
                                children: (0,FormatNumber/* formatCurrency */.xG)(Math.max(0, totalPrice))
                            })
                        ]
                    }),
                    totalUsdPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            margin: "12px 0"
                        },
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                style: {
                                    fontSize: 16
                                },
                                children: "USD"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).total,
                                children: (0,FormatNumber/* formatCurrency */.xG)(totalUsdPrice, ",", "$")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        style: {
                            margin: "auto",
                            width: "90%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    padding: "8px 16px",
                                    color: "#000"
                                },
                                children: translateCheckout("check_info_alert")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).condition,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                        style: {
                                            padding: "8px 16px"
                                        },
                                        control: GreenCheckBoxElement,
                                        label: LabelConfirm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (CheckoutSticky_styles_module_default()).list_note,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "1. ",
                                                    translateCheckout("alert_cancel").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "2. ",
                                                    translateCheckout("alert_wrong_quantity")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: "0 16px",
                            color: "#000"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip/* default */.ZP, {
                            title: checkCondition.checked && translateCheckout("agree_with_condition"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                                disabled: !checkCondition.checked || deliveryLimitCheck || isOverWeightOrVolume || debt && debt.debtBalance <= 0,
                                className: (0,clsx_m/* default */.Z)("payment_button", (CheckoutSticky_styles_module_default()).continue_btn),
                                onClick: handleCheckoutClick,
                                "data-test": "btn-checkout-payment",
                                children: translateCheckout("checkout")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CheckoutSticky_styles_module_default()).text_right,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutSticky_VerifyPaymentDiablog, {
                        visible: showModal
                    }),
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CheckoutSticky_styles_module_default()).condition,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                            severity: "error",
                            style: {
                                marginTop: "10px",
                                borderRadius: "8px"
                            },
                            children: errorMessage
                        })
                    }),
                    deliveryLimitMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CheckoutSticky_styles_module_default()).condition,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                            severity: "error",
                            style: {
                                marginTop: "10px",
                                borderRadius: "8px"
                            },
                            children: deliveryLimitMessage
                        })
                    }),
                    (debt === null || debt === void 0 ? void 0 : debt.balance) <= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CheckoutSticky_styles_module_default()).condition,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                            severity: "error",
                            style: {
                                marginTop: "10px",
                                borderRadius: "8px"
                            },
                            children: debt === null || debt === void 0 ? void 0 : debt.balanceMessageError
                        })
                    }),
                    sysconfig/* FEATURE_SHOW_BUTTON_VERIFY_CART */.LU && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                        btnType: "success",
                        className: (CheckoutSticky_styles_module_default()).checkout_btn,
                        onClick: handleVerify,
                        children: translateCheckout("check")
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).sticky_checkout_bar_mobile, beta && (CheckoutSticky_styles_module_default()).sticky_checkout_bar_mobileNew),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CheckoutSticky_styles_module_default()).fwc_container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CheckoutSticky_styles_module_default()).flex_price,
                                    children: beta ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayPriceMobileNew, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayPrice, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                                        disabled: !checkCondition.checked || user.isQuest || deliveryLimitCheck || isOverWeightOrVolume || debt && debt.balance <= 0,
                                        btnType: beta ? "primary" : "warning",
                                        onClick: handleCheckoutClick,
                                        classes: {
                                            label: (CheckoutSticky_styles_module_default()).label,
                                            outlined: (CheckoutSticky_styles_module_default()).outlined,
                                            root: beta ? (CheckoutSticky_styles_module_default()).mobileRoot_btn : (CheckoutSticky_styles_module_default()).root_btn
                                        },
                                        children: translateCheckout("checkout")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            isShowErrCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CheckoutSticky_styles_module_default()).card_err_container,
                ref: errCardRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        className: (CheckoutSticky_styles_module_default()).text_err_notification,
                        children: [
                            translateCheckout("message_error_products_in_cart"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                className: (CheckoutSticky_styles_module_default()).delete_text,
                                role: "presentation",
                                onClick: toggleErrItems,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {
                                        fontSize: "small"
                                    }),
                                    " ",
                                    translateCheckout("click_here_to_delete")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorProductsPayment/* default */.Z, {})
                ]
            }),
            openErrItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalListProduct/* default */.Z, {
                products: errProducts,
                isShowPopupConfirm: openErrItems,
                handleClosePopup: toggleErrItems,
                handleClick: handleDeleteErrProducts,
                title: translateCheckout("confirmation"),
                content: // eslint-disable-next-line react/jsx-wrap-multilines
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            className: (CheckoutSticky_styles_module_default()).text_content_modal,
                            style: {
                                fontWeight: "700",
                                marginTop: "15px"
                            },
                            children: translateCheckout("message_delete_all_error_products")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            className: (CheckoutSticky_styles_module_default()).text_content_modal,
                            style: {
                                marginTop: "20px"
                            },
                            children: translateCheckout("message_exceed_back")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CustomModal["default"], {
                visible: showConfirmModal,
                onClose: toggleConfirm,
                title: translateCheckout("confirmation"),
                btnOk: translateCheckout("confirm"),
                onClickOk: handleSubmit,
                btnOnClose: translateCheckout("check_cart"),
                children: extraFee && MapExtraFee[sysconfig/* LANG_DEFAULT */.YY]()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPriceFluctuationModal/* default */.Z, {
                visible: isOpenPriceFluctuationModal,
                onClose: function() {
                    return togglePriceFluctuationModal(false);
                },
                onBack: handleBackToCart,
                onConfirm: handleConfirmPriceFluctuation,
                products: cartFluctuates,
                isMobile: isMobile,
                isFromCheckout: true
            }),
            showMaintenanceModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CustomModal["default"], {
                visible: showMaintenanceModal,
                onClose: function() {
                    return setShowMaintenanceModal(false);
                },
                icon: false,
                title: translateCheckout("maintenance_title"),
                content: translateCheckout("maintenance_message"),
                btnOkRender: false,
                btnCloseRender: false,
                customBtnRender: // eslint-disable-next-line react/jsx-wrap-multilines
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                        btnType: "primary",
                        className: (CheckoutSticky_styles_module_default()).checkout_btn,
                        onClick: function() {
                            return setShowMaintenanceModal(false);
                        },
                        children: translateCheckout("maintenance_understand")
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "center",
                    my: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: 48,
                        thickness: 4,
                        style: {
                            color: "#005C29"
                        }
                    })
                })
            }),
            openCurrencyPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethod_CurrencyPopup, {
                paymentMethod: paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.find(function(item) {
                    return item.code === dataCustomer.paymentMethod;
                }),
                cartTotalPrice: totalPrice,
                cartTotalUsdPrice: totalUsdPrice,
                open: openCurrencyPopup,
                currencySelected: currencySelected,
                setCurrencySelected: setCurrencySelected,
                onClose: function() {
                    setCurrencySelected("");
                    setOpenCurrencyPopup(false);
                },
                handleSubmit: handleSubmit
            })
        ]
    });
};
/* harmony default export */ var mocules_CheckoutSticky = (CheckoutSticky);

// EXTERNAL MODULE: ./src/components/mocules/TagType/index.js + 1 modules
var mocules_TagType = __webpack_require__(85201);
// EXTERNAL MODULE: ./src/constants/Tags/index.js
var Tags = __webpack_require__(91983);
;// CONCATENATED MODULE: ./src/components/mocules/ComboList/index.js
/* eslint-disable no-nested-ternary */ 









var ComboList = function(param) {
    var items = param.items, title = param.title;
    /*#__PURE__*/ return _jsxs(Grid, {
        container: true,
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                children: title && /*#__PURE__*/ _jsx(Typography, {
                    className: styles.cb_title,
                    children: title
                })
            }),
            /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.comboList,
                    children: items.map(function(item) {
                        var ref;
                        var name = item.name, slug = item.slug, isGift = item.isGift, salePrice = item.salePrice, tags = item.tags, _quantity = item.quantity, quantity = _quantity === void 0 ? 0 : _quantity;
                        return /*#__PURE__*/ _jsxs("div", {
                            className: styles.cb_item,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.cb_name,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: isGift ? /*#__PURE__*/ _jsxs(Typography, {
                                                className: styles.cb_unlink,
                                                children: [
                                                    name,
                                                    " "
                                                ]
                                            }) : /*#__PURE__*/ _jsx(LinkComp, {
                                                className: styles.cb_link,
                                                href: "/product/".concat(slug),
                                                prefetch: false,
                                                children: name
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: styles.product_tags,
                                            children: tags && ((ref = tags.filter(function(tag) {
                                                return tag === ENUM_TAG_CODES.HOADONNHANH || tag === TAG_HANG_DAT_TRUOC;
                                            })) === null || ref === void 0 ? void 0 : ref.map(function(tag) {
                                                return /*#__PURE__*/ _jsx(TagType, {
                                                    item: tag
                                                }, uuidv4());
                                            }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.priceGroup,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: styles.qty,
                                            children: "SL: ".concat(formatNumber(quantity))
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: styles.price_label,
                                            children: "Gi\xe1 b\xe1n hiện tại: "
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: styles.cb_price,
                                            children: isGift ? "Qu\xe0 tặng" : formatCurrency(salePrice)
                                        })
                                    ]
                                })
                            ]
                        }, item.productId);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_ComboList = ((/* unused pure expression or super */ null && (ComboList)));

// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
;// CONCATENATED MODULE: ./src/components/mocules/CommonQuestion/index.js








var renderLinkItem = function(data) {
    return data.map(function(item) {
        return /*#__PURE__*/ _jsx(LinkComp, {
            target: "_blank",
            className: styles.link,
            href: item.href,
            children: item.title
        }, "question-".concat(uuidv4()));
    });
};
var CommonQuestion = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: styles.wrapper,
        children: /*#__PURE__*/ _jsxs(Container, {
            fixed: true,
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: styles.title,
                    children: "C\xe2u hỏi thường gặp"
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    container: true,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            container: true,
                            style: {
                                display: "flex"
                            },
                            direction: "column",
                            item: true,
                            sm: 6,
                            children: renderLinkItem(linkQuestionItemLeft)
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            container: true,
                            style: {
                                display: "flex"
                            },
                            direction: "column",
                            item: true,
                            sm: 6,
                            children: renderLinkItem(linkQuestionItemRight)
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        display: "flex",
                        marginTop: "16px",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ _jsx(ButtonDefault, {
                        classes: {
                            label: styles.label,
                            outlined: styles.outlined,
                            root: styles.root
                        },
                        href: LINK_ALL_QUESTION,
                        variant: "outlined",
                        target: "_blank",
                        children: "Xem tất cả c\xe2u hỏi"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_CommonQuestion = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(CommonQuestion))));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/mocules/Copyright/index.js






var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var useStyle = (0,makeStyles/* default */.Z)({
    root: {
        height: "56px",
        padding: "15px"
    }
});
var Copyright = function() {
    var classes = useStyle();
    var version = publicRuntimeConfig.buildId;
    return /*#__PURE__*/ _jsx("div", {
        className: classes.root,
        children: /*#__PURE__*/ _jsxs(Typography, {
            variant: "body2",
            color: "textSecondary",
            align: "center",
            children: [
                "\xa9 Bản quy\xeàn thu\xf4̣c C\xf4ng Ty TNHH Buymed -",
                " ",
                ENV === "prd" ? new Date().getFullYear() : version
            ]
        })
    });
};
/* harmony default export */ var mocules_Copyright = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(Copyright))));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(58769);
;// CONCATENATED MODULE: ./src/components/mocules/CountdownTimerDetail/index.js







// thuannc
// TODO:
// MUST FIX
function CountdownTimerDetail(_param) {
    var prefix = _param.prefix, dealEndDay = _param.dealEndDay, translateProductDetail = _param.translateProductDetail, otherProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "prefix",
        "dealEndDay",
        "translateProductDetail"
    ]);
    var ref = (0,react.useState)((0,utils/* calculateTimeLeft */.VZ)(dealEndDay)), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setTimeLeft((0,utils/* calculateTimeLeft */.VZ)(dealEndDay));
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function(interval) {
        if (!timeLeft[interval]) {
            return;
        }
        timerComponents.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                timeLeft[interval],
                interval === "days" ? " : " : null
            ]
        }, "timer-".concat(Math.random())));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, otherProps), {
            children: timerComponents.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: timerComponents
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: translateProductDetail("promotion_ended")
            })
        }))
    });
}
/* harmony default export */ var mocules_CountdownTimerDetail = (CountdownTimerDetail);

// EXTERNAL MODULE: ./src/utils/ImageUtils.js
var ImageUtils = __webpack_require__(13744);
;// CONCATENATED MODULE: ./src/components/mocules/CouponCard/index.js















// fix right name
var CouponCard = function(props) {
    var ref;
    var ref1 = useTranslation("common"), translateCommon = ref1.t;
    var _code = props.code, code = _code === void 0 ? "" : _code, tmp = props.endTime, expiredDate = tmp === void 0 ? new Date(Date.now()) : tmp, _promotion = props.promotion, promotion = _promotion === void 0 ? {} : _promotion, _conditions = props.conditions, conditions = _conditions === void 0 ? [] : _conditions;
    var ref2 = promotion || "", _rewards = ref2.rewards, rewards = _rewards === void 0 ? [] : _rewards, _description = ref2.description, description = _description === void 0 ? "" : _description, promotionName = ref2.promotionName;
    var maxDiscountValue = 0;
    var discountValue = 0;
    var percent = 0;
    var minOrderValue = 0;
    var type = ((ref = rewards[0]) === null || ref === void 0 ? void 0 : ref.type) || PROMO_TYPE.COMBO;
    var ruleType = type === PROMO_REWARD_TYPE.ABSOLUTE;
    // @TODO: datle rewards is only 1 now
    if (rewards.length !== 0) {
        var ref3, ref4, ref5, ref6;
        maxDiscountValue = ((ref3 = rewards[0]) === null || ref3 === void 0 ? void 0 : ref3.maxDiscount) || 0;
        discountValue = ((ref4 = rewards[0]) === null || ref4 === void 0 ? void 0 : ref4.absoluteDiscount) || 0;
        percent = ((ref5 = rewards[0]) === null || ref5 === void 0 ? void 0 : ref5.percentageDiscount) || 0;
        ruleType = ((ref6 = rewards[0]) === null || ref6 === void 0 ? void 0 : ref6.type) || PROMO_REWARD_TYPE.ABSOLUTE;
    }
    // @TODO: datle conditions is only 1 now
    if (conditions.length !== 0) {
        var ref7;
        minOrderValue = ((ref7 = conditions[0]) === null || ref7 === void 0 ? void 0 : ref7.minOrderValue) || 0;
    }
    var getBenefitAvatar = function() {
        if (type === PROMO_TYPE.COMBO || type === PROMO_TYPE.GIFT) return /*#__PURE__*/ _jsx(Image, {
            width: 60,
            height: 60,
            src: getLinkGCS(GIFT_IMAGE)
        });
        if (type === PROMO_TYPE.ABSOLUTE) return /*#__PURE__*/ _jsx("div", {
            style: {
                fontWeight: "bold",
                textAlign: "center"
            },
            children: formatCurrency(String(discountValue))
        });
        if (type === PROMO_TYPE.VOUCHERCODE && ruleType === PROMO_REWARD_TYPE.PERCENTAGE) return /*#__PURE__*/ _jsx("div", {
            style: {
                fontWeight: "bold",
                textAlign: "center"
            },
            children: "Giảm ".concat(percent, "% Tối đa ").concat(formatCurrency(String(maxDiscountValue)))
        });
        return "";
    };
    var getTitle = function() {
        if (type === PROMO_TYPE.COMBO || type === PROMO_TYPE.GIFT || type === PROMO_TYPE.ABSOLUTE || type === PROMO_TYPE.POINT) return description || promotionName;
        if (type === PROMO_TYPE.ABSOLUTE) return "GIẢM ".concat(formatCurrency(discountValue));
        if (type === PROMO_TYPE.PERCENTAGE) return "GIẢM ".concat(percent, "% TỐI ĐA ").concat(formatCurrency(maxDiscountValue));
        return "";
    };
    // TODO: đặt hàng ngay chưa chạy
    var getPromoType = function() {
        if (type === PROMO_TYPE.COMBO) return "COMBO";
        if (type === PROMO_TYPE.GIFT) return "Qu\xe0 Tặng";
        if (type === PROMO_TYPE.VOUCHERCODE) return "Giảm gi\xe1";
        if (type === PROMO_TYPE.FREESHIP) return "Miễn ph\xed giao h\xe0ng";
        if (type === PROMO_TYPE.POINT) return "Điểm thưởng";
        return "Khuyến m\xe3i";
    };
    return /*#__PURE__*/ _jsx(Card, {
        className: clsx(styles.coupon_card, type === PROMO_TYPE.COMBO ? styles.coupon_yellow : styles.coupon_green),
        children: /*#__PURE__*/ _jsxs(Grid, {
            container: true,
            direction: "row",
            spacing: 3,
            children: [
                /*#__PURE__*/ _jsxs(Grid, {
                    item: true,
                    xs: 4,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.benefit,
                            children: [
                                getBenefitAvatar(),
                                getPromoType()
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.coundown,
                            style: {
                                display: "flex"
                            },
                            children: /*#__PURE__*/ _jsx(CountdownTimer, {
                                translateCommon: translateCommon,
                                prefix: "C\xf2n",
                                dealEndDay: expiredDate
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    item: true,
                    container: true,
                    xs: 8,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: styles.coupon_description,
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "h6",
                                        style: {
                                            fontSize: "large"
                                        },
                                        children: getTitle()
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.coupon_discount,
                                        children: type === PROMO_TYPE.VOUCHERCODE && "cho đơn h\xe0ng tối thiểu ".concat(formatCurrency(String(minOrderValue)))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            className: styles.code,
                            xs: 12,
                            children: code
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ _jsx(LinkComp, {
                                href: QUICK_ORDER,
                                children: /*#__PURE__*/ _jsx(Button, {
                                    className: "promo__button",
                                    children: " Đặt h\xe0ng ngay"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_CouponCard = ((/* unused pure expression or super */ null && (CouponCard)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(33681);
;// CONCATENATED MODULE: ./src/components/mocules/CouponDetailModal/index.js









var CouponDetailModal_CouponDetailModal = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(param) {
    var children = param.children, onClose = param.onClose, onClickOk = param.onClickOk, visible = param.visible, className = param.className, restProps = param.restProps, title = param.title, content = param.content, btnOk = param.btnOk, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2, _btnOkRender = param.btnOkRender, btnOkRender = _btnOkRender === void 0 ? /*#__PURE__*/ _jsx(ModalButton, {
        className: styles.yes_btn,
        onClick: onClickOk,
        children: btnOk
    }) : _btnOkRender;
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "".concat(styles.confirm_modal_wrap, "  ").concat(title && content && styles.fixed_width_wrapper, " ").concat(isMobileV2 && styles.confirm_modal_wrap_mv2),
            children: [
                /*#__PURE__*/ _jsx(CloseIcon, {
                    className: styles.closeIcon,
                    onClick: onClose
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        title && /*#__PURE__*/ _jsx(Typography, {
                            className: styles.modal_title,
                            children: title
                        }),
                        content && /*#__PURE__*/ _jsx("div", {
                            className: styles.modal_content,
                            children: content
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.children,
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Box, {
                    className: styles.btn_container,
                    children: btnOk && btnOkRender
                })
            ]
        })
    }));
})));
/* harmony default export */ var mocules_CouponDetailModal = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(CouponDetailModal_CouponDetailModal))));

// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
;// CONCATENATED MODULE: ./src/components/mocules/CouponCardV2/index.js




























var BorderLinearProgress = (0,styled_components_browser_esm/* default */.ZP)(LinearProgress/* default */.Z).withConfig({
    componentId: "sc-b1d3662-0"
})(function() {
    return {
        height: 10,
        borderRadius: 10,
        margin: "0 5px",
        maxWidth: "120px",
        minWidth: "80px",
        backgroundColor: "#e9e9e9",
        ".MuiLinearProgress-barColorPrimary": {
            backgroundColor: "#DC5C00"
        }
    };
});
var CouponCardV2 = function(props) {
    var ref;
    var _code = props.code, code = _code === void 0 ? "" : _code, tmp = props.endTime, expiredDate = tmp === void 0 ? new Date(Date.now()) : tmp, _voucher = props.voucher, voucher = _voucher === void 0 ? {} : _voucher, _promotionName = props.promotionName, promotionName = _promotionName === void 0 ? "" : _promotionName, _description = props.description, description = _description === void 0 ? "" : _description, _conditionDescription = props.conditionDescription, conditionDescription = _conditionDescription === void 0 ? "" : _conditionDescription, isMobile = props.isMobile, _maxUsage = props.maxUsage, maxUsage = _maxUsage === void 0 ? 0 : _maxUsage, _usageTotal = props.usageTotal, usageTotal = _usageTotal === void 0 ? 0 : _usageTotal;
    var ref1 = useTranslation("common"), translateCommon = ref1.t;
    var _conditions = voucher.conditions, conditions = _conditions === void 0 ? [] : _conditions, _rewards = voucher.rewards, rewards = _rewards === void 0 ? [] : _rewards;
    var ref2 = _sliced_to_array(useModal(false), 2), toggleModal = ref2[0], setToggleModal = ref2[1];
    var isMobileV2 = useMobileV2(function(state) {
        return state.isMobileV2();
    });
    var ref3 = useAuth(), _user = ref3.user, _accountID = _user.accountID, accountID = _accountID === void 0 ? "" : _accountID, _customerID = _user.customerID, customerID = _customerID === void 0 ? "" : _customerID;
    var router = useRouter();
    // check tooltip with ... css
    var ref4 = _sliced_to_array(useOverflowTooltip(), 2), isOverflowed = ref4[0], textElementRef = ref4[1];
    var ref5 = useState(false), isHoverTooltip = ref5[0], setIsHoverTooltip = ref5[1];
    var maxDiscountValue = 0;
    var discountValue = 0;
    var percent = 0;
    var minOrderValue = 0;
    var type = ((ref = conditions[0]) === null || ref === void 0 ? void 0 : ref.type) || PROMO_TYPE.COMBO;
    if (rewards.length !== 0) {
        var ref6, ref7, ref8;
        maxDiscountValue = ((ref6 = rewards[0]) === null || ref6 === void 0 ? void 0 : ref6.maxDiscount) || 0;
        discountValue = ((ref7 = rewards[0]) === null || ref7 === void 0 ? void 0 : ref7.absoluteDiscount) || 0;
        percent = ((ref8 = rewards[0]) === null || ref8 === void 0 ? void 0 : ref8.percentageDiscount) || 0;
    }
    // conditions is an array contains condition of voucher
    if (conditions.length !== 0) {
        var ref9;
        minOrderValue = ((ref9 = conditions[0]) === null || ref9 === void 0 ? void 0 : ref9.minOrderValue) || 0;
    }
    // check timer coutdown
    var checkTimeCountDown = function() {
        var oneDay = new Date().getTime() + 1 * 24 * 60 * 60 * 1000;
        var endVoucher = new Date(expiredDate).getTime();
        return expiredDate && oneDay > endVoucher ? /*#__PURE__*/ _jsxs("div", {
            style: {
                margin: "5px 0"
            },
            children: [
                translateCommon("voucher.HSD"),
                ":",
                " ",
                /*#__PURE__*/ _jsx("span", {
                    style: {
                        color: "#D4323B"
                    },
                    children: /*#__PURE__*/ _jsx(CountdownTimer, {
                        prefix: "",
                        dealEndDay: expiredDate,
                        style: {
                            display: "inline-block"
                        },
                        translateCommon: translateCommon
                    })
                })
            ]
        }) : /*#__PURE__*/ _jsxs(Typography, {
            className: styles.expiredDate,
            children: [
                translateCommon("voucher.HSD"),
                ":",
                " ",
                /*#__PURE__*/ _jsx("span", {
                    children: DateTimeUtils.getFormattedWithDate(new Date(expiredDate), translateCommon, "DD/MM/YYYY")
                })
            ]
        });
    };
    var getTitle = function() {
        if (type === PROMO_TYPE.COMBO || type === PROMO_TYPE.GIFT || type === PROMO_TYPE.ABSOLUTE || type === PROMO_TYPE.POINT) return description || promotionName;
        if (type === PROMO_TYPE.ABSOLUTE) return "".concat(translateCommon("voucher.HSD"), " ").concat(formatCurrency(discountValue));
        if (type === PROMO_TYPE.PERCENTAGE) return "".concat(translateCommon("voucher.HSD"), " ").concat(percent, "% ").concat(translateCommon("voucher.max"), " ").concat(formatCurrency(maxDiscountValue));
        return "";
    };
    var CouponDetail = function(couponCode, expiryDate, open) {
        var ref = useState(false), isCoppied = ref[0], setIsCoppied = ref[1];
        var handleCopied = function() {
            setIsCoppied(true);
            // TODO: TRACKING
            Tracking.trackingFunc(ENUM_TRACKING_ACTION.PROMO_COPY_VOUCHER_CODE, {
                page: PROMO_CODES,
                accountId: accountID,
                customerID: customerID,
                currentPage: window.location.href,
                // ...(isMobile && { source: 'thuocsi-mobile' }),
                isMobile: isMobile
            });
        };
        useEffect(function() {
            if (!open) {
                setIsCoppied(false);
            }
        }, [
            !open
        ]);
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Grid, {
                    container: true,
                    direction: "row",
                    className: styles.couponDetailRow,
                    children: [
                        /*#__PURE__*/ _jsxs(Grid, {
                            item: true,
                            xs: 5,
                            sm: 6,
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: styles.couponDetailLabel,
                                    children: translateCommon("voucher.discount_code")
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 7,
                            sm: 6,
                            className: styles.wrapInfoCode,
                            alignItems: "center",
                            container: true,
                            children: /*#__PURE__*/ _jsxs(Grid, {
                                className: styles.couponDetailValue,
                                style: {
                                    color: "#005c29",
                                    position: "relative",
                                    bottom: "5px"
                                },
                                children: [
                                    couponCode,
                                    /*#__PURE__*/ _jsxs("span", {
                                        style: {
                                            display: "inline-flex",
                                            flexWrap: "nowrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(CopyToClipboard, {
                                                text: couponCode,
                                                onCopy: handleCopied,
                                                children: /*#__PURE__*/ _jsx(FileCopyOutlinedIcon, {
                                                    className: styles.iconCopy
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                style: {
                                                    display: !isCoppied && "none"
                                                },
                                                children: isCoppied ? /*#__PURE__*/ _jsx(DoneIcon, {
                                                    className: styles.iconCopyDone
                                                }) : null
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    container: true,
                    direction: "row",
                    className: styles.couponDetailRow,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 5,
                            sm: 6,
                            children: /*#__PURE__*/ _jsxs("span", {
                                className: styles.couponDetailLabel,
                                children: [
                                    translateCommon("voucher.expiry"),
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 7,
                            sm: 6,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: styles.couponDetailValue,
                                style: {
                                    position: "relative",
                                    bottom: "4px"
                                },
                                children: expiryDate()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.condition,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: styles.couponDetailLabel,
                            children: translateCommon("voucher.condition_of_use")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.conditionContent,
                            children: conditionDescription ? /*#__PURE__*/ _jsx("div", {
                                dangerouslySetInnerHTML: {
                                    __html: conditionDescription
                                }
                            }) : /*#__PURE__*/ _jsx("p", {
                                children: translateCommon("voucher.applies_all_order")
                            })
                        })
                    ]
                })
            ]
        });
    };
    var handleClickInfoVoucher = function() {
        setToggleModal(true);
        // TODO: TRACKING EVENT
        Tracking.trackingFunc(ENUM_TRACKING_ACTION.PROMO_CLICK_INFO_VOUCHER, {
            page: PROMO_CODES,
            accountId: accountID,
            customerID: customerID,
            currentPage: window.location.href,
            // ...(isMobile && { source: 'thuocsi-mobile' }),
            isMobile: isMobile
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(CouponDetailModal, {
                visible: toggleModal,
                onClose: function() {
                    setToggleModal(false);
                },
                title: translateCommon("voucher.discount_code"),
                content: CouponDetail(code, checkTimeCountDown, toggleModal),
                btnOk: translateCommon("btn.apply"),
                onClickOk: function() {
                    router.push("/cart");
                    // TODO: TRACKING EVENT
                    Tracking.trackingFunc(ENUM_TRACKING_ACTION.PROMO_CLICK_APPLY_VOUCHER, {
                        page: PROMO_CODES,
                        accountId: accountID,
                        customerID: customerID,
                        currentPage: window.location.href,
                        // ...(isMobile && { source: 'thuocsi-mobile' }),
                        isMobile: isMobile
                    });
                },
                isMobileV2: isMobileV2,
                btnOnClose: translateCommon("no")
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.couponBoxMargin,
                children: /*#__PURE__*/ _jsx(Box, {
                    className: styles.couponBox,
                    children: /*#__PURE__*/ _jsx(Box, {
                        className: styles.borderBox,
                        children: /*#__PURE__*/ _jsxs(Grid, {
                            container: true,
                            direction: "row",
                            spacing: 3,
                            style: {
                                margin: 0,
                                height: "100%"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(Grid, {
                                    item: true,
                                    xs: 4,
                                    className: styles.flexCenter,
                                    children: [
                                        /*#__PURE__*/ _jsx(Image, {
                                            className: styles.logo,
                                            href: "/",
                                            src: NEW_LOGO || "/images/logo_thuocsi_new.png",
                                            width: 108,
                                            height: 19
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            component: "span",
                                            className: styles.halfCircle
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            component: "span",
                                            className: styles.line
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            component: "span",
                                            className: styles.halfCircleBottom
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Grid, {
                                    item: true,
                                    xs: 8,
                                    children: /*#__PURE__*/ _jsxs(Box, {
                                        className: styles.couponInfo,
                                        children: [
                                            /*#__PURE__*/ _jsx(Tooltip, {
                                                title: description || promotionName,
                                                arrow: true,
                                                open: isMobile ? isHoverTooltip : isOverflowed && isHoverTooltip,
                                                enterTouchDelay: 0,
                                                disableHoverListener: isMobile ? null : !isOverflowed,
                                                children: /*#__PURE__*/ _jsx(Typography, {
                                                    ref: textElementRef,
                                                    onClick: function() {
                                                        return setIsHoverTooltip(true);
                                                    },
                                                    onMouseOver: function() {
                                                        return setIsHoverTooltip(true);
                                                    },
                                                    onMouseLeave: function() {
                                                        return setIsHoverTooltip(false);
                                                    },
                                                    className: styles.promotionTitle,
                                                    role: "presentation",
                                                    children: getTitle()
                                                })
                                            }),
                                            type === PROMO_TYPE.VOUCHERCODE && /*#__PURE__*/ _jsx("p", {
                                                children: "".concat(translateCommon("voucher.for_minimun_order_from"), " ").concat(formatCurrency(String(minOrderValue)))
                                            }),
                                            maxUsage > 0 && /*#__PURE__*/ _jsxs("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            translateCommon("voucher.used"),
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(BorderLinearProgress, {
                                                        variant: "determinate",
                                                        value: Math.floor((usageTotal || 0) * 100 / maxUsage) || 0
                                                    }),
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        style: {
                                                            color: "#DC5C00",
                                                            fontWeight: "bold"
                                                        },
                                                        children: [
                                                            Math.floor((usageTotal || 0) * 100 / maxUsage) || 0,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            checkTimeCountDown(),
                                            /*#__PURE__*/ _jsx(InfoIconOutlined, {
                                                className: styles.infoIcon,
                                                onClick: handleClickInfoVoucher
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_CouponCardV2 = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CouponCardV2))));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createTheme.js + 6 modules
var createTheme = __webpack_require__(73690);
// EXTERNAL MODULE: ./node_modules/@material-ui/data-grid/dist/index-esm.js
var index_esm = __webpack_require__(96084);
;// CONCATENATED MODULE: ./src/components/mocules/CustomNoRowsOverlay/index.js



var defaultTheme = (0,createTheme/* default */.Z)();
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            padding: 20,
            flexDirection: "column",
            "& .ant-empty-img-1": {
                fill: theme.palette.type === "light" ? "#aeb8c2" : "#262626"
            },
            "& .ant-empty-img-2": {
                fill: theme.palette.type === "light" ? "#f5f5f7" : "#595959"
            },
            "& .ant-empty-img-3": {
                fill: theme.palette.type === "light" ? "#dce0e6" : "#434343"
            },
            "& .ant-empty-img-4": {
                fill: theme.palette.type === "light" ? "#fff" : "#1c1c1c"
            },
            "& .ant-empty-img-5": {
                fillOpacity: theme.palette.type === "light" ? "0.8" : "0.08",
                fill: theme.palette.type === "light" ? "#f5f5f5" : "#fff"
            }
        },
        label: {
            marginTop: theme.spacing(1)
        }
    };
}, {
    defaultTheme: defaultTheme
});
function CustomNoRowsOverlay(param) {
    var _text = param.text, text = _text === void 0 ? "" : _text;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridOverlay */.nik, {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "120",
                height: "100",
                viewBox: "0 0 184 152",
                "aria-hidden": true,
                focusable: "false",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            transform: "translate(24 31.67)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                    className: "ant-empty-img-5",
                                    cx: "67.797",
                                    cy: "106.89",
                                    rx: "67.797",
                                    ry: "12.668"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "ant-empty-img-1",
                                    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "ant-empty-img-2",
                                    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "ant-empty-img-3",
                                    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            className: "ant-empty-img-3",
                            d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            className: "ant-empty-img-4",
                            transform: "translate(149.65 15.383)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                    cx: "20.654",
                                    cy: "3.167",
                                    rx: "2.849",
                                    ry: "2.815"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.label,
                children: text
            })
        ]
    });
}
/* harmony default export */ var mocules_CustomNoRowsOverlay = (CustomNoRowsOverlay);

// EXTERNAL MODULE: ./src/components/mocules/DealSection/index.js
var DealSection = __webpack_require__(80550);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card_Card = __webpack_require__(18463);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent_CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AddCircle.js
var AddCircle = __webpack_require__(76220);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardHeader/CardHeader.js
var CardHeader_CardHeader = __webpack_require__(94697);
// EXTERNAL MODULE: ./src/components/mocules/DeleteAddressModal/index.js
var DeleteAddressModal = __webpack_require__(40174);
// EXTERNAL MODULE: ./src/components/mocules/AddressCard/styles.module.css
var AddressCard_styles_module = __webpack_require__(96584);
var AddressCard_styles_module_default = /*#__PURE__*/__webpack_require__.n(AddressCard_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/AddressCard/index.js

















var CardComp = function(param) {
    var isSelect = param.isSelect, address = param.address, handleOnSelect = param.handleOnSelect, handleReloadData = param.handleReloadData, handleEdit = param.handleEdit, selectAddressCode = param.selectAddressCode;
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var ref1 = (0,esm/* useTranslation */.$G)("myAccount"), translateMyAccount = ref1.t;
    var _name = address.name, name = _name === void 0 ? "" : _name, _phone = address.phone, phone = _phone === void 0 ? "" : _phone, _isDefault = address.isDefault, isDefault = _isDefault === void 0 ? false : _isDefault, _masterAddress = address.masterAddress, masterAddress = _masterAddress === void 0 ? "" : _masterAddress, _code = address.code, code = _code === void 0 ? "" : _code;
    var ref2 = (0,context/* useAuth */.aC)(), customerID = ref2.user.customerID;
    var ref3 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), open = ref3[0], toggle = ref3[1];
    var handleDelete = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var result, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            clients/* CustomerClient.deleteAddress */.YP.deleteAddress((_tmp.code = code, _tmp.customerID = customerID, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) throw Error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_delete_address_fail"));
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_delete_address_success"));
                        handleReloadData();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction(error.message));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetDefault = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var result, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            clients/* CustomerClient.updateAddressDefault */.YP.updateAddressDefault((_tmp.code = code, _tmp.customerID = customerID, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) throw Error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_failed_update_default_address"));
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_update_default_address"));
                        handleReloadData();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction(error.message));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSetDefault() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
        item: true,
        xs: 12,
        md: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                className: isSelect && selectAddressCode === address.code ? (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).card_selected, (AddressCard_styles_module_default()).card) : (AddressCard_styles_module_default()).card,
                "data-test": "card-address",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader_CardHeader/* default */.Z, {
                        action: isDefault ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AddressCard_styles_module_default()).default_tag,
                            children: [
                                " ",
                                translateMyAccount("default")
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        title: name,
                        subheader: "".concat(translateMyAccount("phone_number"), ": ").concat(phone)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AddressCard_styles_module_default()).float_bottom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (AddressCard_styles_module_default()).ellipsis_2_line,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                children: [
                                                    " ",
                                                    translateMyAccount("address"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            masterAddress
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (AddressCard_styles_module_default()).group_button,
                                    children: [
                                        isSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "contained",
                                            className: (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).action_button, (AddressCard_styles_module_default()).important_action_button),
                                            onClick: function() {
                                                handleOnSelect(address);
                                            },
                                            "data-test": "btn-select-address",
                                            children: translateMyAccount("deliver_to_this_address")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            className: isSelect ? (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).action_button, (AddressCard_styles_module_default()).defaull_button) : (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).action_button, (AddressCard_styles_module_default()).important_action_button),
                                            onClick: function() {
                                                return handleEdit(address);
                                            },
                                            children: translateMyAccount("edit")
                                        }),
                                        !isDefault && !isSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            className: (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).action_button, (AddressCard_styles_module_default()).defaull_button),
                                            onClick: handleSetDefault,
                                            children: translateMyAccount("default")
                                        }),
                                        !isDefault && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            className: (AddressCard_styles_module_default()).action_button,
                                            onClick: toggle,
                                            "data-test": "btn-delete-address-card",
                                            children: translateMyAccount("remove")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteAddressModal/* default */.Z, {
                visible: open,
                onClose: toggle,
                onClickOk: handleDelete
            })
        ]
    });
};
/* harmony default export */ var AddressCard = (CardComp);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogActions/DialogActions.js
var DialogActions_DialogActions = __webpack_require__(66856);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogTitle/DialogTitle.js
var DialogTitle_DialogTitle = __webpack_require__(66083);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/NativeSelect.js
var NativeSelect = __webpack_require__(75445);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
;// CONCATENATED MODULE: ./src/components/mocules/AddressSelect/index.js




function AddressSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .MuiNativeSelect-select {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  & .MuiNativeSelect-icon {\n    right: 5px !important;\n    color: #005c29 !important;\n  }\n  &.MuiOutlinedInput-root {\n    height: 2.4em !important;\n  }\n  & .MuiNativeSelect-select:focus {\n    background-color: transparent !important;\n  }\n"
    ]);
    AddressSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var AddressSelect = function(_param) /*#__PURE__*/ {
    var label = _param.label, id = _param.id, _options = _param.options, options = _options === void 0 ? [] : _options, onChange = _param.onChange, _value = _param.value, value = _value === void 0 ? "0" : _value, disabled = _param.disabled, className = _param.className, error = _param.error, dataTest = _param.dataTest, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "label",
        "id",
        "options",
        "onChange",
        "value",
        "disabled",
        "className",
        "error",
        "dataTest"
    ]);
    return (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xs: 12,
        md: 4,
        label: label,
        htmlFor: id
    }, restProps), {
        isRequired: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
            id: id,
            input: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                error: error
            }),
            IconComponent: ExpandMore/* default */.Z,
            value: value,
            onChange: onChange,
            className: className,
            disabled: disabled,
            "data-test": dataTest,
            children: options.map(function(option) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: option.value,
                    children: option.label
                }, (0,v4/* default */.Z)());
            })
        })
    }));
};
var StyledAddressSelect = (0,styled_components_browser_esm/* default */.ZP)(AddressSelect).withConfig({
    componentId: "sc-6bbfe1d7-0"
})(AddressSelect_templateObject());
/* harmony default export */ var mocules_AddressSelect = (StyledAddressSelect);

// EXTERNAL MODULE: ./src/components/mocules/GroupAddressSelect/styles.module.css
var GroupAddressSelect_styles_module = __webpack_require__(81966);
var GroupAddressSelect_styles_module_default = /*#__PURE__*/__webpack_require__.n(GroupAddressSelect_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/GroupAddressSelect/index.js















var GroupAddressSelect_GroupAddressSelect = function(_param) {
    var _setTotalWard = _param.setTotalWard, setTotalWard = _setTotalWard === void 0 ? null : _setTotalWard, _error = _param.error, error = _error === void 0 ? {} : _error, _type = _param.type, type = _type === void 0 ? Enums/* GROUP_ADDRESS_TYPE.HORIZONTAL */.$O.HORIZONTAL : _type, currentAddress = _param.currentAddress, handleSetCurrentAddress = _param.handleSetCurrentAddress, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "setTotalWard",
        "error",
        "type",
        "currentAddress",
        "handleSetCurrentAddress"
    ]);
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var DEFAULT_PROVINCE = {
        label: translateCommon("enter_province"),
        value: "0"
    };
    var DEFAULT_DISTRICT = {
        label: translateCommon("enter_district"),
        value: "0"
    };
    var DEFAULT_WARD = {
        label: translateCommon("enter_ward"),
        value: "0"
    };
    // const { itemCount } = useCart();
    var ref1 = (0,react.useState)({
        provinces: [
            DEFAULT_PROVINCE
        ],
        districts: [
            DEFAULT_DISTRICT
        ],
        wards: [
            DEFAULT_WARD
        ]
    }), address = ref1[0], setAddress = ref1[1];
    var getProvinces = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var provinces;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AddressService/* default.getProvinces */.Z.getProvinces()
                        ];
                    case 1:
                        provinces = _state.sent();
                        return [
                            2,
                            [
                                DEFAULT_PROVINCE
                            ].concat((0,src_to_consumable_array/* default */.Z)(provinces))
                        ];
                }
            });
        });
        return function getProvinces() {
            return _ref.apply(this, arguments);
        };
    }();
    var getDistricts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(prv) {
            var dists;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AddressService/* default.getDistrictsByProvince */.Z.getDistrictsByProvince(prv)
                        ];
                    case 1:
                        dists = _state.sent();
                        return [
                            2,
                            [
                                DEFAULT_DISTRICT
                            ].concat((0,src_to_consumable_array/* default */.Z)(dists))
                        ];
                }
            });
        });
        return function getDistricts(prv) {
            return _ref.apply(this, arguments);
        };
    }();
    var getWards = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(dist) {
            var wards;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AddressService/* default.getWardsByDistrict */.Z.getWardsByDistrict(dist)
                        ];
                    case 1:
                        wards = _state.sent();
                        if (setTotalWard) {
                            setTotalWard(wards.length);
                        }
                        return [
                            2,
                            [
                                DEFAULT_WARD
                            ].concat((0,src_to_consumable_array/* default */.Z)(wards))
                        ];
                }
            });
        });
        return function getWards(dist) {
            return _ref.apply(this, arguments);
        };
    }();
    var getProvinceMasterData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var provinces, addressinfo, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getProvinces()
                        ];
                    case 1:
                        provinces = _state.sent();
                        _tmp = {};
                        addressinfo = (_tmp.provinces = provinces, _tmp.districts = [
                            DEFAULT_DISTRICT
                        ], _tmp.wards = [
                            DEFAULT_WARD
                        ], _tmp);
                        if (!(currentAddress.province !== DEFAULT_PROVINCE.value)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getDistricts(currentAddress.province)
                        ];
                    case 2:
                        addressinfo.districts = _state.sent();
                        _state.label = 3;
                    case 3:
                        if (!(currentAddress.district !== DEFAULT_DISTRICT.value)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            getWards(currentAddress.district)
                        ];
                    case 4:
                        addressinfo.wards = _state.sent();
                        _state.label = 5;
                    case 5:
                        setAddress(addressinfo);
                        return [
                            2
                        ];
                }
            });
        });
        return function getProvinceMasterData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getDistrictMasterData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var addressinfo, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        addressinfo = (_tmp.districts = [
                            DEFAULT_DISTRICT
                        ], _tmp.wards = [
                            DEFAULT_WARD
                        ], _tmp);
                        if (!(currentAddress.province !== DEFAULT_PROVINCE.value)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getDistricts(currentAddress.province)
                        ];
                    case 1:
                        addressinfo.districts = _state.sent();
                        if (!(currentAddress.district !== DEFAULT_DISTRICT.value)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getWards(currentAddress.district)
                        ];
                    case 2:
                        addressinfo.wards = _state.sent();
                        _state.label = 3;
                    case 3:
                        _tmp1 = {};
                        setAddress((0,src_object_spread/* default */.Z)(_tmp1, address, addressinfo));
                        return [
                            2
                        ];
                }
            });
        });
        return function getDistrictMasterData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getWardMasterData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var addressinfo, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        addressinfo = (_tmp.wards = [
                            DEFAULT_WARD
                        ], _tmp);
                        if (!(currentAddress.district !== DEFAULT_DISTRICT.value)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getWards(currentAddress.district)
                        ];
                    case 1:
                        addressinfo.wards = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp1 = {};
                        setAddress((0,src_object_spread/* default */.Z)(_tmp1, address, addressinfo));
                        return [
                            2
                        ];
                }
            });
        });
        return function getWardMasterData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (currentAddress.changeType === Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED) {
            getProvinceMasterData();
        }
        if (currentAddress.changeType === Enums/* ADDRESS_CHANGE_TYPE.PROVINCE_CHANGE */.Ei.PROVINCE_CHANGE) {
            getDistrictMasterData();
        }
        if (currentAddress.changeType === Enums/* ADDRESS_CHANGE_TYPE.DISTRICT_CHANGE */.Ei.DISTRICT_CHANGE) {
            getWardMasterData();
        }
    }, [
        currentAddress
    ]);
    var handleChangeProvince = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var prv, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                prv = e.target.value;
                _tmp = {};
                _tmp1 = {};
                if (prv !== currentAddress.province) handleSetCurrentAddress((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, currentAddress), (_tmp1.province = prv, _tmp1.district = DEFAULT_DISTRICT.value, _tmp1.ward = DEFAULT_WARD.value, _tmp1.changeType = Enums/* ADDRESS_CHANGE_TYPE.PROVINCE_CHANGE */.Ei.PROVINCE_CHANGE, _tmp1)));
                return [
                    2
                ];
            });
        // } else NotifyUtils.error('Bạn không được thay đổi tỉnh/thành phố khi đang có sản phẩm trong giỏ hàng.');
        });
        return function handleChangeProvince(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeDistrict = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var dist, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                dist = e.target.value;
                _tmp = {};
                _tmp1 = {};
                if (dist !== currentAddress.district) handleSetCurrentAddress((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, currentAddress), (_tmp1.district = dist, _tmp1.ward = DEFAULT_WARD.value, _tmp1.changeType = Enums/* ADDRESS_CHANGE_TYPE.DISTRICT_CHANGE */.Ei.DISTRICT_CHANGE, _tmp1)));
                return [
                    2
                ];
            });
        });
        return function handleChangeDistrict(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeWard = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var war, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                war = e.target.value;
                _tmp = {};
                _tmp1 = {};
                handleSetCurrentAddress((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, currentAddress), (_tmp1.ward = war, _tmp1.changeType = Enums/* ADDRESS_CHANGE_TYPE.WARD_CHANGE */.Ei.WARD_CHANGE, _tmp1)));
                return [
                    2
                ];
            });
        });
        return function handleChangeWard(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: (GroupAddressSelect_styles_module_default()).address_field,
        container: true,
        spacing: 3,
        style: {
            marginTop: "10px"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AddressSelect, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (GroupAddressSelect_styles_module_default()).fw500,
                    children: translateCommon("province")
                }),
                id: (0,v4/* default */.Z)(),
                value: currentAddress.province || 0,
                onChange: handleChangeProvince,
                options: address.provinces,
                error: error.province,
                md: type === Enums/* GROUP_ADDRESS_TYPE.VERTICAL */.$O.VERTICAL ? 12 : 4,
                dataTest: "select-address-city"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AddressSelect, {
                id: (0,v4/* default */.Z)(),
                value: currentAddress.district || 0,
                onChange: handleChangeDistrict,
                options: address.districts,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (GroupAddressSelect_styles_module_default()).fw500,
                    children: translateCommon("district")
                }),
                disabled: address.districts.length === 1,
                error: error.district,
                md: type === Enums/* GROUP_ADDRESS_TYPE.VERTICAL */.$O.VERTICAL ? 12 : 4,
                dataTest: "select-address-district"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AddressSelect, {
                id: (0,v4/* default */.Z)(),
                value: currentAddress.ward || 0,
                onChange: handleChangeWard,
                options: address.wards,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (GroupAddressSelect_styles_module_default()).fw500,
                    children: translateCommon("ward")
                }),
                disabled: address.wards.length === 1,
                error: error.ward,
                md: type === Enums/* GROUP_ADDRESS_TYPE.VERTICAL */.$O.VERTICAL ? 12 : 4,
                dataTest: "select-address-ward"
            })
        ]
    }));
};
/* harmony default export */ var mocules_GroupAddressSelect = (GroupAddressSelect_GroupAddressSelect);

// EXTERNAL MODULE: ./src/components/mocules/AddressModal/styles.module.css
var AddressModal_styles_module = __webpack_require__(56889);
var AddressModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(AddressModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/AddressModal/validateForm.js

var AddressModal_validateForm_validateForm = function(param) {
    var name = param.name, phone = param.phone, email = param.email, address = param.address, provinceCode = param.provinceCode, districtCode = param.districtCode, wardCode = param.wardCode;
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(name)) throw Error("message_empty_name");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(phone)) throw Error("message_empty_phone");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(address)) throw Error("message_empty_address");
    if (provinceCode === "0") throw Error("message_empty_province_city");
    if (districtCode === "0") throw Error("message_empty_district");
    if (wardCode === "0") throw Error("message_empty_ward");
    if (!utils/* ValidateUtils.isEmpty */.IN.isEmpty(email) && !utils/* ValidateUtils.validateEmail */.IN.validateEmail(email)) throw Error("message_invalid_email");
    if (!utils/* ValidateUtils.validatePhone */.IN.validatePhone(phone)) throw Error("message_invalid_phone");
};
/* harmony default export */ var AddressModal_validateForm = (AddressModal_validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/AddressModal/index.js























var AddressModal = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var ref1 = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref1.t;
    var onClose = props.onClose, visible = props.visible, _address = props.address, address = _address === void 0 ? {} : _address, handleReloadData = props.handleReloadData, customerID = props.customerID;
    var ref2 = (0,react.useState)(address), val = ref2[0], setVal = ref2[1];
    var ref3 = (0,react.useState)(address), addressSelected = ref3[0], setAddressSelected = ref3[1];
    var isEdit = address.code;
    var handleChangeValue = function(key, value) {
        setVal((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, val), (0,src_define_property/* default */.Z)({}, key, value)));
    };
    var handleSetAddress = function(addressInfo) {
        setAddressSelected(addressInfo);
    };
    (0,react.useEffect)(function() {
        setVal(address);
        setAddressSelected(address);
    }, [
        address
    ]);
    var handleClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var formData, _tmp, _tmp1, result, _tmp2, result1, _tmp3, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        formData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, val), (_tmp1.wardCode = addressSelected.ward, _tmp1.districtCode = addressSelected.district, _tmp1.provinceCode = addressSelected.province, _tmp1.customerID = customerID, _tmp1));
                        delete formData.isDefault;
                        Object.keys(formData).forEach(function(key) {
                            if (typeof formData[key] === "string") {
                                formData[key] = formData[key].trim();
                            }
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        AddressModal_validateForm(formData);
                        if (!isEdit) return [
                            3,
                            3
                        ];
                        _tmp2 = {};
                        return [
                            4,
                            clients/* CustomerClient.updateAddress */.YP.updateAddress((_tmp2.body = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
                                code: address.code
                            }), _tmp2))
                        ];
                    case 2:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) throw Error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message__failed_update_addres"));
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_edit_address"));
                        return [
                            3,
                            5
                        ];
                    case 3:
                        _tmp3 = {};
                        return [
                            4,
                            clients/* CustomerClient.createAddress */.YP.createAddress((_tmp3.body = formData, _tmp3))
                        ];
                    case 4:
                        result1 = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result1)) throw Error((result1 === null || result1 === void 0 ? void 0 : result1.message) || translateAlertAction("message_failed_create_new_address"));
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_create_address"));
                        _state.label = 5;
                    case 5:
                        onClose();
                        handleReloadData();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction(error.message));
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AddressModal_styles_module_default()).address_dialog,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog_Dialog/* default */.Z, {
            onClose: onClose,
            "aria-labelledby": "customized-dialog-title",
            open: visible,
            className: (AddressModal_styles_module_default()).address_dialog,
            "data-test": "modal-add-address",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle_DialogTitle/* default */.Z, {
                    id: "customized-dialog-title",
                    onClose: onClose,
                    style: {
                        width: "100%"
                    },
                    children: [
                        isEdit ? translatePopupAction("popup-address.edit_address") : translatePopupAction("popup-address.add_address"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            "aria-label": "close",
                            className: (AddressModal_styles_module_default()).close_button,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent_DialogContent/* default */.Z, {
                    dividers: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        container: true,
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                container: true,
                                direction: "row",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        label: translatePopupAction("popup-address.name"),
                                        htmlFor: "name",
                                        isRequired: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "name",
                                            value: (val === null || val === void 0 ? void 0 : val.name) || "",
                                            onChange: function(e) {
                                                return handleChangeValue("name", e.target.value);
                                            },
                                            placeholder: translatePopupAction("popup-address.enterName"),
                                            "data-test": "input-address-name-modal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        label: translatePopupAction("popup-address.mobile_number"),
                                        htmlFor: "phone",
                                        isRequired: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "phone",
                                            value: (val === null || val === void 0 ? void 0 : val.phone) || "",
                                            onChange: function(e) {
                                                return handleChangeValue("phone", e.target.value);
                                            },
                                            placeholder: translatePopupAction("popup-address.enterPhone"),
                                            "data-test": "input-address-phone-modal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        label: translatePopupAction("popup-address.address"),
                                        htmlFor: "address",
                                        isRequired: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "address",
                                            value: (val === null || val === void 0 ? void 0 : val.address) || "",
                                            onChange: function(e) {
                                                return handleChangeValue("address", e.target.value);
                                            },
                                            placeholder: translatePopupAction("popup-address.address"),
                                            "data-test": "input-address-place-modal"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_GroupAddressSelect, {
                                currentAddress: addressSelected,
                                handleSetCurrentAddress: handleSetAddress,
                                type: Enums/* GROUP_ADDRESS_TYPE.VERTICAL */.$O.VERTICAL
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions_DialogActions/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        autoFocus: true,
                        color: "primary",
                        variant: "contained",
                        className: "my-order__button--secondary",
                        style: {
                            borderRadius: "30px",
                            padding: "5px 40px"
                        },
                        onClick: handleClick,
                        "data-test": "btn-address-add-modal",
                        children: isEdit ? translatePopupAction("popup-address.edit") : translatePopupAction("popup-address.add")
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var mocules_AddressModal = (AddressModal);

// EXTERNAL MODULE: ./src/components/mocules/DeliveryCardList/styles.module.css
var DeliveryCardList_styles_module = __webpack_require__(37838);
var DeliveryCardList_styles_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryCardList_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/DeliveryCardList/index.js

















var DeliveryCardList_DeliveryCardList = function(param) {
    var _isSelect = param.isSelect, isSelect = _isSelect === void 0 ? false : _isSelect, addresses = param.addresses, handleOnSelect = param.handleOnSelect, handleReloadData = param.handleReloadData, selectAddressCode = param.selectAddressCode, customerID = param.customerID;
    var ref = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref.t;
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openAddressModal = ref1[0], toggleAddressModal = ref1[1];
    var ref2 = (0,react.useState)({
        name: "",
        phone: "",
        changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED,
        province: "0",
        district: "0",
        ward: "0"
    }), value = ref2[0], setValue = ref2[1];
    var handleEdit = function(address) {
        setValue((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, address), {
            changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED,
            province: address.provinceCode,
            district: address.districtCode,
            ward: address.wardCode
        }));
        toggleAddressModal();
    };
    var handleNew = function() {
        setValue({
            changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED,
            province: "0",
            district: "0",
            ward: "0"
        });
        toggleAddressModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                container: true,
                spacing: 2,
                children: [
                    addresses.map(function(address) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressCard, {
                            address: address,
                            isSelect: isSelect,
                            handleReloadData: handleReloadData,
                            handleEdit: handleEdit,
                            handleOnSelect: handleOnSelect,
                            selectAddressCode: selectAddressCode
                        }, (0,v4/* default */.Z)());
                    }),
                    addresses.length <= 10 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                            className: (DeliveryCardList_styles_module_default()).card,
                            onClick: handleNew,
                            "data-test": "btn-add-new-address",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (DeliveryCardList_styles_module_default()).add_icon_column,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (DeliveryCardList_styles_module_default()).add_icon_row,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCircle/* default */.Z, {
                                                    size: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: translatePopupAction("add_address")
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AddressModal, {
                visible: openAddressModal,
                onClose: toggleAddressModal,
                address: value,
                handleReloadData: handleReloadData,
                customerID: customerID
            })
        ]
    });
};
/* harmony default export */ var mocules_DeliveryCardList = (DeliveryCardList_DeliveryCardList);

;// CONCATENATED MODULE: ./src/components/mocules/DeliveryForm/index.js








var DeliveryForm = function() {
    var ref = useState([]), addresses = ref[0], setAddresses = ref[1];
    var loadData = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var addressList, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        CustomerService.getListAddress(_tmp)
                    ];
                case 1:
                    addressList = _state.sent();
                    setAddresses(addressList);
                    return [
                        2
                    ];
            }
        });
    }), []);
    useEffect(function() {
        loadData();
    }, []);
    return /*#__PURE__*/ _jsxs(Paper, {
        className: styles.root,
        elevation: 4,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles.title,
                children: " Th\xf4ng tin giao h\xe0ng "
            }),
            /*#__PURE__*/ _jsx(DeliveryCardList, {
                addresses: addresses,
                handleReloadData: loadData
            })
        ]
    });
};
/* harmony default export */ var mocules_DeliveryForm = ((/* unused pure expression or super */ null && (DeliveryForm)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery_useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./src/components/atoms/InfoFormControl/index.js
var atoms_InfoFormControl = __webpack_require__(96317);
// EXTERNAL MODULE: ./src/components/mocules/DeliveryInfoForm/styles.module.css
var DeliveryInfoForm_styles_module = __webpack_require__(54773);
var DeliveryInfoForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryInfoForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/DeliveryInfoForm/index.js













var GreenCheckbox = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,src_object_spread/* default */.Z)({
        classes: {
            root: (DeliveryInfoForm_styles_module_default()).checkbox
        },
        color: "default"
    }, props));
};
var DeliveryInfoForm = function(param) {
    var handleSetValue = param.handleSetValue, name = param.name, phone = param.phone, address = param.address, setTotalWard = param.setTotalWard, handleChangeCheckbox = param.handleChangeCheckbox, setError = param.setError, manageAddressModalToggle = param.manageAddressModalToggle, customerName = param.customerName, customerEmail = param.customerEmail, customerPhone = param.customerPhone, customerShippingAddress = param.customerShippingAddress, currentAddress = param.currentAddress, handleSetCurrentAddress = param.handleSetCurrentAddress, _isChecked = param.isChecked, isChecked = _isChecked === void 0 ? false : _isChecked, translateCheckout = param.translateCheckout;
    var maxWidthScope = (0,useMediaQuery_useMediaQuery/* default */.Z)("(max-width:600px)");
    // STATUS: PENDING
    var checkBox = /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenCheckbox, {
        checked: isChecked,
        onChange: function(e) {
            return handleChangeCheckbox(e);
        },
        name: "saveInfoShipping"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper_Paper/* default */.Z, {
        className: (DeliveryInfoForm_styles_module_default()).root,
        elevation: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: (DeliveryInfoForm_styles_module_default()).title,
                children: [
                    translateCheckout("shipping_info"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        className: (DeliveryInfoForm_styles_module_default()).add_new_button,
                        onClick: manageAddressModalToggle,
                        "data-test": "btn-checkout-change-address",
                        children: translateCheckout("change_address")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InfoFormControl/* default */.Z, {
                        xs: 12,
                        isRequired: true,
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (DeliveryInfoForm_styles_module_default()).fw500,
                            children: translateCheckout("full_name")
                        }),
                        htmlFor: "customerName",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                            error: name,
                            id: "customerName",
                            placeholder: translateCheckout("first_and_lastname"),
                            value: customerName || "",
                            onChange: function(e) {
                                if (e.target.value !== "") {
                                    setError(true);
                                }
                                handleSetValue("customerName", e.target.value);
                            },
                            "data-test": "input-checkout-customer-name"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        className: (DeliveryInfoForm_styles_module_default()).grid_fix,
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InfoFormControl/* default */.Z, {
                                xs: maxWidthScope ? 12 : 3,
                                isRequired: true,
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (DeliveryInfoForm_styles_module_default()).fw500,
                                    children: translateCheckout("phone_number")
                                }),
                                htmlFor: "customerPhone",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    error: phone,
                                    id: "customerPhone",
                                    placeholder: translateCheckout("phone_number"),
                                    value: customerPhone || "",
                                    onChange: function(e) {
                                        return handleSetValue("customerPhone", e.target.value);
                                    },
                                    "data-test": "input-checkout-cusomter-phone"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InfoFormControl/* default */.Z, {
                                xs: maxWidthScope ? 12 : 9,
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (DeliveryInfoForm_styles_module_default()).fw500,
                                    children: translateCheckout("email")
                                }),
                                htmlFor: "customerEmail",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "customerEmail",
                                    placeholder: translateCheckout("email"),
                                    value: customerEmail || "",
                                    onChange: function(e) {
                                        return handleSetValue("customerEmail", e.target.value);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InfoFormControl/* default */.Z, {
                        xs: 12,
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (DeliveryInfoForm_styles_module_default()).fw500,
                            children: translateCheckout("address")
                        }),
                        isRequired: true,
                        htmlFor: "customerShippingAddress",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                            error: address,
                            id: "customerShippingAddress",
                            placeholder: translateCheckout("address"),
                            value: customerShippingAddress || "",
                            onChange: function(e) {
                                if (e.target.value !== "") {
                                    setError(true);
                                }
                                handleSetValue("customerShippingAddress", e.target.value);
                            },
                            "data-test": "input-checkout-customer-address"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_GroupAddressSelect, {
                        id: (0,v4/* default */.Z)(),
                        setTotalWard: setTotalWard,
                        currentAddress: currentAddress,
                        handleSetCurrentAddress: handleSetCurrentAddress,
                        style: {
                            margonTop: 0
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                            control: checkBox,
                            className: (DeliveryInfoForm_styles_module_default()).save_info_cb,
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (DeliveryInfoForm_styles_module_default()).fw500,
                                children: translateCheckout("save_my_info")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_DeliveryInfoForm = (DeliveryInfoForm);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl_FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./src/components/mocules/DeliveryMethod/styles.module.css
var DeliveryMethod_styles_module = __webpack_require__(91618);
var DeliveryMethod_styles_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryMethod_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/DeliveryMethod/index.js
/* eslint-disable react/no-danger */ 















var currentDate = utils/* DateTimeUtils.getFormattedDate */.IM.getFormattedDate(new Date(), "YYYYMMDD");
var DeliveryMethodItem = function(param) {
    var item = param.item, addressSelect = param.addressSelect, _orderPrice = param.orderPrice, orderPrice = _orderPrice === void 0 ? 0 : _orderPrice, _productItems = param.productItems, productItems = _productItems === void 0 ? [] : _productItems, _provinces = param.provinces, provinces = _provinces === void 0 ? [] : _provinces, translateCheckout = param.translateCheckout, locale = param.locale;
    var ref;
    var description = item.description, code = item.code, _condition = item.condition, condition = _condition === void 0 ? {} : _condition, subTitle = item.subTitle, _status = item.status, status = _status === void 0 ? "ON" : _status, _mapLocationFee = item.mapLocationFee, mapLocationFee = _mapLocationFee === void 0 ? {} : _mapLocationFee;
    var _customerDistrictCode = addressSelect.customerDistrictCode, customerDistrictCode = _customerDistrictCode === void 0 ? "0" : _customerDistrictCode, _customerProvinceCode = addressSelect.customerProvinceCode, customerProvinceCode = _customerProvinceCode === void 0 ? "0" : _customerProvinceCode, _customerWardCode = addressSelect.customerWardCode, customerWardCode = _customerWardCode === void 0 ? "0" : _customerWardCode;
    var regionCode = ((ref = provinces.find(function(province) {
        return province.value === customerProvinceCode;
    })) === null || ref === void 0 ? void 0 : ref.regionCode) || "";
    var ref1, ref2;
    var deliveryName = (0,react.useMemo)(function() {
        return (ref2 = (ref1 = item["name_".concat(locale)]) !== null && ref1 !== void 0 ? ref1 : item.name) !== null && ref2 !== void 0 ? ref2 : "";
    }, [
        locale
    ]);
    var disable = status !== "ON";
    var message = "";
    var isDisableByDeliveryLocation = false;
    // info
    var isFullLocation = !!mapLocationFee["00"];
    var ref3;
    var defaultValue = (ref3 = mapLocationFee["00"]) !== null && ref3 !== void 0 ? ref3 : null;
    var _customerWardCode1, ref4, ref5, ref6;
    // Cùng thứ tự ưu tiên với BE: ward > district > province > region > toàn quốc. Dùng `??` vì phí 0
    // (vd Phnom Penh free) là giá trị hợp lệ, không được rơi xuống phí toàn quốc.
    var feeValue = (ref6 = (ref5 = (ref4 = (_customerWardCode1 = mapLocationFee[customerWardCode]) !== null && _customerWardCode1 !== void 0 ? _customerWardCode1 : mapLocationFee[customerDistrictCode]) !== null && ref4 !== void 0 ? ref4 : mapLocationFee[customerProvinceCode]) !== null && ref5 !== void 0 ? ref5 : mapLocationFee[regionCode]) !== null && ref6 !== void 0 ? ref6 : defaultValue;
    if (isDisableByDeliveryLocation && !isFullLocation) {
        message = translateCheckout("not_in_deliver_region");
        disable = true;
    }
    var label = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                className: (DeliveryMethod_styles_module_default()).fw500,
                children: deliveryName
            }),
            subTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "\xa0",
                    subTitle
                ]
            }),
            feeValue > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "\xa0(",
                    translateCheckout("plus_more"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                        className: (DeliveryMethod_styles_module_default()).fw500,
                        children: [
                            (0,FormatNumber/* formatCurrency */.xG)(feeValue),
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
    // check status
    var maxPrice = condition.maxPrice, minPrice = condition.minPrice, _notSupportYYYYMMDDs = condition.notSupportYYYYMMDDs, notSupportYYYYMMDDs = _notSupportYYYYMMDDs === void 0 ? null : _notSupportYYYYMMDDs, _notSupportLocationCodes = condition.notSupportLocationCodes, notSupportLocationCodes = _notSupportLocationCodes === void 0 ? null : _notSupportLocationCodes, _tags = condition.tags, tags = _tags === void 0 ? null : _tags;
    if (!disable && notSupportYYYYMMDDs && notSupportYYYYMMDDs.indexOf(currentDate) >= 0) {
        disable = true;
        message = translateCheckout("not_support_this_day");
    }
    if (!disable && tags && tags.length > 0 && productItems) {
        productItems.forEach(function(product) {
            if (!disable) {
                disable = !(product.tags && tags.every(function(t) {
                    return product.tags.indexOf(t) >= 0;
                }));
            }
        });
    }
    // So với giá trị đơn (cart.price: tổng tiền sản phẩm được chọn, trước voucher, chưa cộng phí) —
    // đúng con số BE dùng để validate. Không dùng totalPrice: nó đã cộng phí của chính method đang
    // chọn nên đơn sát ngưỡng sẽ tự disable method đang chọn.
    if (!disable && maxPrice && maxPrice > 0 && orderPrice > maxPrice) {
        disable = true;
        message = translateCheckout("exceeded_allowable_value");
    }
    if (!disable && minPrice && minPrice > 0 && orderPrice < minPrice) {
        message = translateCheckout("lower_than_alloweable_value");
        disable = true;
    }
    if (!disable && notSupportLocationCodes && notSupportLocationCodes.length > 0 && (notSupportLocationCodes.indexOf(regionCode) !== -1 || notSupportLocationCodes.indexOf(customerProvinceCode) !== -1 || notSupportLocationCodes.indexOf(customerDistrictCode) !== -1 || notSupportLocationCodes.indexOf(customerWardCode) !== -1)) {
        message = translateCheckout("not_support_this_area");
        disable = true;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip/* default */.ZP, {
                title: message,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                    value: code,
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                        classes: {
                            root: (0,clsx_m/* default */.Z)((DeliveryMethod_styles_module_default()).checkbox, (DeliveryMethod_styles_module_default()).checkbox_color)
                        },
                        "data-test": "radio-checkout-delivery"
                    }),
                    label: label,
                    disabled: disable
                })
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                className: (DeliveryMethod_styles_module_default()).checkout_description,
                icon: false,
                severity: "info",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (DeliveryMethod_styles_module_default()).content,
                    dangerouslySetInnerHTML: {
                        __html: description
                    }
                })
            })
        ]
    }, (0,v4/* default */.Z)());
};
var DeliveryMethod = function(param) {
    var handleChange = param.handleChange, deliveryMethods = param.deliveryMethods, selectedValue = param.selectedValue, addressSelect = param.addressSelect, orderPrice = param.orderPrice, productItems = param.productItems, provinces = param.provinces, translateCheckout = param.translateCheckout;
    var ref;
    var selectedVal = selectedValue || ((ref = deliveryMethods[0]) === null || ref === void 0 ? void 0 : ref.code);
    var locale = js_cookie_default().get("NEXT_LOCALE") || sysconfig/* LANG_DEFAULT */.YY;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper_Paper/* default */.Z, {
        className: (DeliveryMethod_styles_module_default()).root,
        elevation: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (DeliveryMethod_styles_module_default()).title,
                children: translateCheckout("shipping_method")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                component: "fieldset",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup_RadioGroup/* default */.Z, {
                    value: selectedVal,
                    onChange: handleChange,
                    children: deliveryMethods && deliveryMethods.map(function(item) {
                        return DeliveryMethodItem({
                            item: item,
                            addressSelect: addressSelect,
                            orderPrice: orderPrice,
                            productItems: productItems,
                            provinces: provinces,
                            translateCheckout: translateCheckout,
                            locale: locale
                        });
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_DeliveryMethod = (DeliveryMethod);

// EXTERNAL MODULE: ./src/components-v2/atoms/ButtonV2/index.js
var ButtonV2 = __webpack_require__(47554);
// EXTERNAL MODULE: ./src/components/mocules/EditOrderModal/index.js
var EditOrderModal = __webpack_require__(59784);
// EXTERNAL MODULE: ./src/components/mocules/EditOrderButton/styles.module.css
var EditOrderButton_styles_module = __webpack_require__(92929);
var EditOrderButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(EditOrderButton_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/EditOrderButton/index.js



















var EditOrderButton_EditOrderButton = function(param) {
    var orderId = param.orderId, canEdit = param.canEdit, _btnStyle = param.btnStyle, btnStyle = _btnStyle === void 0 ? false : _btnStyle, btnText = param.btnText;
    var ref = (0,esm/* useTranslation */.$G)("myOrder"), translateMyOrder = ref.t;
    var ref1 = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref1.t;
    var ref2 = (0,react.useState)(false), val = ref2[0], setVal = ref2[1];
    var router = (0,next_router.useRouter)();
    var updateCart = (0,context/* useCart */.jD)().updateCart;
    var user = (0,context/* useAuth */.aC)().user;
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var getSellerByCodeSync = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCodeSync;
    });
    var handleChangeVal = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setVal(!val);
    };
    var handleClickOk = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var ref, ref1, orderRes, _tmp, orderDetail, res, _tmp1, promiseAllSellerInfo, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        e.stopPropagation();
                        _tmp = {};
                        return [
                            4,
                            services/* OrderService.getOrderDetail */.px.getOrderDetail((_tmp.orderId = orderId, _tmp.getCombo = false, _tmp.customerLevel = user === null || user === void 0 ? void 0 : user.level, _tmp.locationCode = user === null || user === void 0 ? void 0 : user.provinceCode, _tmp))
                        ];
                    case 1:
                        orderRes = _state.sent();
                        if (!(0,clients/* isValid */.JY)(orderRes)) {
                            return [
                                2
                            ];
                        }
                        orderDetail = (0,clients/* getFirst */.Xi)(orderRes);
                        _tmp1 = {};
                        return [
                            4,
                            services/* OrderService.deleteOrder */.px.deleteOrder((_tmp1.orderId = orderId, _tmp1))
                        ];
                    case 2:
                        res = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(res)) {
                            utils/* NotifyUtils.error */.QP.error((res === null || res === void 0 ? void 0 : res.message) || translateAlertAction("message_error_try_again"));
                            return [
                                2
                            ];
                        }
                        promiseAllSellerInfo = orderDetail === null || orderDetail === void 0 ? void 0 : (ref = orderDetail.products) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var productInfo = param.productInfo;
                            return getSellerByCode({
                                code: productInfo === null || productInfo === void 0 ? void 0 : productInfo.sellerCode
                            });
                        });
                        return [
                            4,
                            Promise.all(promiseAllSellerInfo)
                        ];
                    case 3:
                        _state.sent();
                        _tmp2 = {};
                        _tmp3 = {};
                        utils/* gtag.refund */.SX.refund((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp2, orderDetail), (_tmp3.products = (orderDetail === null || orderDetail === void 0 ? void 0 : (ref1 = orderDetail.products) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                            var _productInfo = param.productInfo, productInfo = _productInfo === void 0 ? {} : _productInfo, _price = param.price, price = _price === void 0 ? 0 : _price, _quantity = param.quantity, quantity = _quantity === void 0 ? 0 : _quantity;
                            return {
                                name: (productInfo === null || productInfo === void 0 ? void 0 : productInfo.name) || "",
                                displayPrice: price || 0,
                                productId: (productInfo === null || productInfo === void 0 ? void 0 : productInfo.productId) || 0,
                                quantity: quantity,
                                sellerInfo: getSellerByCodeSync({
                                    code: productInfo === null || productInfo === void 0 ? void 0 : productInfo.sellerCode
                                })
                            };
                        })) || [], _tmp3)));
                        updateCart();
                        if ((orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.paymentMethod) === Enums/* PAYMENT_METHOD.CREDIT */.hL.CREDIT) {
                            setTimeout(function() {
                                router.push(Paths/* CART_URL */.fh);
                            }, 2000);
                        } else {
                            router.push(Paths/* CART_URL */.fh);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickOk(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // const classNameBtn = canEdit ? "my-order__button my-order__button--green" : "my-order__button my-order__button--green"
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            btnStyle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                className: canEdit ? (EditOrderButton_styles_module_default()).editBtn : (EditOrderButton_styles_module_default()).disableBtn,
                onClick: handleChangeVal,
                disabled: !canEdit,
                "data-test": "btn-edit-order",
                children: btnText || translateMyOrder("btn_edit_order")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonV2/* default */.Z, {
                className: btnStyle ? (EditOrderButton_styles_module_default()).editBtn : (EditOrderButton_styles_module_default()).order_edit_btn,
                onClick: handleChangeVal,
                disabled: !canEdit,
                "data-test": "btn-edit-order",
                children: btnText || translateMyOrder("btn_edit_order")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOrderModal/* default */.Z, {
                visible: val,
                onClose: handleChangeVal,
                onClickOk: handleClickOk
            })
        ]
    });
};
/* harmony default export */ var mocules_EditOrderButton = (/*#__PURE__*/react.memo(EditOrderButton_EditOrderButton));

// EXTERNAL MODULE: ./src/clients/UploadFileClient.js
var clients_UploadFileClient = __webpack_require__(31181);
;// CONCATENATED MODULE: ./src/components/mocules/EnterpriseForm/index.js
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];





























var ButtonUploadFile = function(param) {
    var disabled = param.disabled;
    return /*#__PURE__*/ _jsx(InputAdornment, {
        position: "start",
        children: /*#__PURE__*/ _jsx(Button, {
            variant: "contained",
            classes: {
                root: styles.upload_button
            },
            disabled: disabled,
            style: {
                backgroundColor: disabled ? "#DFE3E8" : "rgb(0, 180, 110)",
                color: disabled ? "rgb(158 156 173)" : "#fff"
            },
            children: "Tải file"
        })
    });
};
var EnterpriseForm = function(param) {
    var scope = param.scope, _legalRepresentative = param.legalRepresentative, legalRepresentative = _legalRepresentative === void 0 ? "" : _legalRepresentative, _businessName = param.businessName, businessName = _businessName === void 0 ? "" : _businessName, _taxCode = param.taxCode, taxCode = _taxCode === void 0 ? "" : _taxCode, _address = param.address, address = _address === void 0 ? "" : _address, licenses = param.licenses, _wardCode = param.wardCode, wardCode = _wardCode === void 0 ? "0" : _wardCode, _districtCode = param.districtCode, districtCode = _districtCode === void 0 ? "0" : _districtCode, _provinceCode = param.provinceCode, provinceCode = _provinceCode === void 0 ? "0" : _provinceCode, handleSetValue = param.handleSetValue, handleChangeAddress = param.handleChangeAddress, error = param.error, isMobile = param.isMobile, _gpp = param.gpp, gpp = _gpp === void 0 ? [] : _gpp, businessImages = param.businessImages;
    var maxWidthScope = useMediaQuery("(max-width:600px)");
    var ref = useState({
        changeType: ADDRESS_CHANGE_TYPE.ASSIGNED,
        province: provinceCode,
        district: districtCode,
        ward: wardCode
    }), currentAddress = ref[0], setCurrentAddress = ref[1];
    var handleSetCurrentAddress = function(addressinfo) {
        setCurrentAddress(addressinfo);
        handleChangeAddress("provinceCode", "districtCode", "wardCode", addressinfo.province, addressinfo.district, addressinfo.ward);
    };
    var handleChangeFile = function(e, fileList, val) {
        var files = e.target.files;
        if (fileList.length + files.length > 3) {
            NotifyUtils.error("Chỉ được gửi tối đa 3 file");
            return;
        }
        _to_consumable_array(files).forEach(function(file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            var type = file.type;
            reader.onload = /*#__PURE__*/ _async_to_generator(function() {
                var base64, blob, limitSize, ref, ref1, Pica, ref2, ImageBlobReduce, pica, _tmp, reduce, _tmp1, _tmp2, buffer, result, _tmp3, _tmp4, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                6,
                                ,
                                7
                            ]);
                            base64 = reader.result;
                            blob = new Blob([
                                reader.result
                            ]);
                            limitSize = blob.size / 1024 / 1024;
                            if (!((type === FILE_TYPE.PNG || type === FILE_TYPE.JPEG) && limitSize > 2)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                Promise.all([
                                    __webpack_require__.e(/* import() */ 6373).then(__webpack_require__.t.bind(__webpack_require__, 16373, 23)),
                                    __webpack_require__.e(/* import() */ 434).then(__webpack_require__.bind(__webpack_require__, 434))
                                ])
                            ];
                        case 1:
                            ref = _sliced_to_array.apply(void 0, [
                                _state.sent(),
                                2
                            ]), ref1 = ref[0], Pica = ref1.default, ref2 = ref[1], ImageBlobReduce = ref2.default;
                            _tmp = {};
                            pica = Pica((_tmp.features = [
                                "js",
                                "wasm",
                                "cib"
                            ], _tmp));
                            _tmp1 = {};
                            reduce = new ImageBlobReduce((_tmp1.pica = pica, _tmp1));
                            _tmp2 = {};
                            return [
                                4,
                                reduce.toBlob(file, (_tmp2.max = 2000, _tmp2))
                            ];
                        case 2:
                            blob = _state.sent();
                            return [
                                4,
                                blobToBase64(blob)
                            ];
                        case 3:
                            base64 = _state.sent();
                            buffer = Buffer.from(base64.substring(base64.indexOf(",") + 1));
                            limitSize = buffer.length / 1e6;
                            _state.label = 4;
                        case 4:
                            if (limitSize > 5) throw Error("K\xedch thước qu\xe1 lớn");
                            if (val === "licenses" && type !== FILE_TYPE.PDF && type !== FILE_TYPE.PNG && type !== FILE_TYPE.JPEG) throw Error("Sai định dạng file");
                            if (val === "gpp" && type !== FILE_TYPE.PDF && type !== FILE_TYPE.DOC && type !== FILE_TYPE.DOCX && type !== FILE_TYPE.PNG && type !== FILE_TYPE.JPEG) throw Error("Sai định dạng file");
                            if (val === "businessImages" && type !== FILE_TYPE.PNG && type !== FILE_TYPE.JPEG) throw Error("Sai định dạng file");
                            _tmp3 = {};
                            return [
                                4,
                                UploadFileClient.upload((_tmp3.body = {
                                    file: base64,
                                    type: type
                                }, _tmp3))
                            ];
                        case 5:
                            result = _state.sent();
                            if (!isValidWithoutData(result)) throw Error((result === null || result === void 0 ? void 0 : result.message) || "Tải file kh\xf4ng th\xe0nh c\xf4ng");
                            _tmp4 = {};
                            if (val !== "businessImages") {
                                fileList.push((_tmp4.name = file.name, _tmp4.publicURL = getFirst(result), _tmp4));
                            } else {
                                fileList.push(getFirst(result));
                            }
                            handleSetValue(val, fileList);
                            return [
                                3,
                                7
                            ];
                        case 6:
                            err = _state.sent();
                            NotifyUtils.error(err.message);
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
        });
    };
    var handleDeleteFile = function(link, fileList, val) {
        // let fileList = licenses;
        var tmpList = _to_consumable_array(fileList);
        if (val !== "businessImages") tmpList = tmpList.filter(function(l) {
            return l.publicURL !== link;
        });
        else tmpList = tmpList.filter(function(l) {
            return l !== link;
        });
        handleSetValue(val, tmpList);
    };
    var handleViewFile = function(link) {
        window.open(link);
    };
    var disabledLicense = licenses.length > 3;
    var disabledGpp = gpp.length > 3;
    var disabledBusinessImage = businessImages.length > 3;
    return /*#__PURE__*/ _jsxs(Paper, {
        className: styles.root,
        elevation: 4,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles.title,
                children: " Th\xf4ng tin doanh nghiệp "
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ _jsx(InfoFormControl, {
                        xs: maxWidthScope ? 12 : 3,
                        label: "Bạn l\xe0",
                        htmlFor: "scope",
                        children: /*#__PURE__*/ _jsx(InfoInput, {
                            id: "scope",
                            value: ENUM_SCOPE_LABEL[scope],
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ _jsx(InfoFormControl, {
                        xs: maxWidthScope ? 12 : 9,
                        label: "T\xean nh\xe0 thuốc/ph\xf2ng kh\xe1m",
                        htmlFor: "businessName",
                        children: /*#__PURE__*/ _jsx(InfoInput, {
                            id: "businessName",
                            placeholder: "T\xean nh\xe0 thuốc/ph\xf2ng kh\xe1m",
                            value: businessName,
                            onChange: function(e) {
                                return handleSetValue("businessName", e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(InfoFormControl, {
                        xs: 12,
                        label: "T\xean người đại diện ph\xe1p luật",
                        htmlFor: "legalRepresentative",
                        children: /*#__PURE__*/ _jsx(InfoInput, {
                            id: "legalRepresentative",
                            placeholder: "T\xean người đại diện ph\xe1p luật",
                            value: legalRepresentative,
                            onChange: function(e) {
                                return handleSetValue("legalRepresentative", e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        type: "file",
                        hidden: true,
                        id: "input-file",
                        onChange: function(e) {
                            return handleChangeFile(e, licenses, "licenses");
                        },
                        accept: "".concat(FILE_TYPE.PDF, ",").concat(FILE_TYPE.DOC, ",").concat(FILE_TYPE.DOCX, ",").concat(FILE_TYPE.JPEG, ",").concat(FILE_TYPE.PNG),
                        multiple: true,
                        disabled: disabledLicense
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        type: "file",
                        hidden: true,
                        id: "input-file-gpp",
                        onChange: function(e) {
                            return handleChangeFile(e, gpp, "gpp");
                        },
                        accept: "".concat(FILE_TYPE.PDF, ",").concat(FILE_TYPE.DOC, ",").concat(FILE_TYPE.DOCX, ",").concat(FILE_TYPE.JPEG, ",").concat(FILE_TYPE.PNG),
                        multiple: true,
                        disabled: disabledGpp
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        type: "file",
                        hidden: true,
                        id: "business-images",
                        onChange: function(e) {
                            return handleChangeFile(e, businessImages, "businessImages");
                        },
                        accept: "".concat(FILE_TYPE.JPEG, ",").concat(FILE_TYPE.PNG),
                        multiple: true,
                        disabled: disabledLicense
                    }),
                    !isMobile && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(InfoFormControl, {
                                xs: 12,
                                label: "Giấy ph\xe9p kinh doanh ph\xf2ng kh\xe1m/nh\xe0 thuốc",
                                htmlFor: "license",
                                variant: "contained",
                                children: [
                                    /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "license",
                                        placeholder: "Chọn file",
                                        endAdornment: /*#__PURE__*/ _jsx(ButtonUploadFile, {
                                            disabled: disabledLicense
                                        }),
                                        startAdornment: licenses.length > 0 && /*#__PURE__*/ _jsx(Grid, {
                                            container: true,
                                            direction: "row",
                                            className: styles.license_chip_list,
                                            children: licenses.map(function(license) {
                                                return /*#__PURE__*/ _jsx(Grid, {
                                                    item: true,
                                                    children: /*#__PURE__*/ _jsx(Tooltip, {
                                                        title: license.name,
                                                        arrow: true,
                                                        children: /*#__PURE__*/ _jsx(Chip, {
                                                            label: license.name,
                                                            style: {
                                                                maxWidth: "150px"
                                                            },
                                                            clickable: true,
                                                            color: "default",
                                                            avatar: /*#__PURE__*/ _jsx(FileCopyIcon, {}),
                                                            onDelete: function() {
                                                                handleDeleteFile(license.publicURL, licenses, "licenses");
                                                            },
                                                            onClick: function() {
                                                                handleViewFile(license.publicURL);
                                                            }
                                                        })
                                                    })
                                                }, uuidV4());
                                            })
                                        }),
                                        component: "span",
                                        htmlFor: "icon-button-file",
                                        style: {
                                            paddingRight: 0,
                                            color: "black"
                                        },
                                        disabled: true,
                                        onClick: function() {
                                            document.getElementById("input-file").click();
                                        },
                                        className: "input__info ".concat(licenses.length > 0 ? styles.license : "")
                                    }),
                                    /*#__PURE__*/ _jsx(FormHelperText, {
                                        children: "File PNG, JPEG hoặc PDF - tối đa 3 files"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(InfoFormControl, {
                                xs: 12,
                                label: "Hồ sơ GPP",
                                htmlFor: "gpp",
                                variant: "contained",
                                children: [
                                    /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "gpp",
                                        placeholder: "Chọn file",
                                        endAdornment: /*#__PURE__*/ _jsx(ButtonUploadFile, {
                                            disabled: disabledGpp
                                        }),
                                        startAdornment: gpp.length > 0 && /*#__PURE__*/ _jsx(Grid, {
                                            container: true,
                                            direction: "row",
                                            className: styles.license_chip_list,
                                            children: gpp.map(function(item) {
                                                return /*#__PURE__*/ _jsx(Grid, {
                                                    item: true,
                                                    children: /*#__PURE__*/ _jsx(Tooltip, {
                                                        title: item.name,
                                                        arrow: true,
                                                        children: /*#__PURE__*/ _jsx(Chip, {
                                                            label: item.name,
                                                            style: {
                                                                maxWidth: "150px"
                                                            },
                                                            clickable: true,
                                                            color: "default",
                                                            avatar: /*#__PURE__*/ _jsx(FileCopyIcon, {}),
                                                            onDelete: function() {
                                                                handleDeleteFile(item.publicURL, gpp, "gpp");
                                                            },
                                                            onClick: function() {
                                                                handleViewFile(item.publicURL);
                                                            }
                                                        })
                                                    })
                                                }, uuidV4());
                                            })
                                        }),
                                        component: "span",
                                        htmlFor: "icon-button-file",
                                        style: {
                                            paddingRight: 0,
                                            color: "black"
                                        },
                                        disabled: true,
                                        onClick: function() {
                                            document.getElementById("input-file-gpp").click();
                                        },
                                        className: "input__info ".concat(gpp.length > 0 ? styles.license : "")
                                    }),
                                    /*#__PURE__*/ _jsx(FormHelperText, {
                                        children: "File PDF, PNG, JPEG, DOC hoặc DOCX - tối đa 3 files"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(InfoFormControl, {
                                xs: 12,
                                label: "H\xecnh ảnh nh\xe0 thuốc",
                                htmlFor: "businessImages",
                                variant: "contained",
                                children: [
                                    /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "businessImages",
                                        placeholder: "Chọn file",
                                        endAdornment: /*#__PURE__*/ _jsx(ButtonUploadFile, {
                                            disabled: disabledBusinessImage
                                        }),
                                        component: "span",
                                        htmlFor: "icon-button-file",
                                        style: {
                                            paddingRight: 0,
                                            color: "black"
                                        },
                                        disabled: true,
                                        onClick: function() {
                                            document.getElementById("business-images").click();
                                        },
                                        className: "input__info ".concat(licenses.length > 0 ? styles.license : "")
                                    }),
                                    /*#__PURE__*/ _jsx(FormHelperText, {
                                        children: "File PNG, JPEG - tối đa 3 files"
                                    })
                                ]
                            }),
                            businessImages.length > 0 && /*#__PURE__*/ _jsx(Grid, {
                                container: true,
                                spacing: 2,
                                direction: "row",
                                style: {
                                    marginLeft: 3
                                },
                                children: businessImages.map(function(item) {
                                    return /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: styles.wrapImage,
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: styles.inner,
                                                    children: /*#__PURE__*/ _jsx(HighlightOffIcon, {
                                                        fontSize: "small",
                                                        onClick: function() {
                                                            return handleDeleteFile(item, businessImages, "businessImages");
                                                        },
                                                        style: {
                                                            color: "#666666",
                                                            cursor: "pointer"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Image, {
                                                    src: getLinkGCS(item || MISSING_IMAGE),
                                                    width: "100",
                                                    height: "100",
                                                    className: styles.image,
                                                    onClick: function() {
                                                        handleViewFile(item);
                                                    }
                                                })
                                            ]
                                        })
                                    }, uuidV4());
                                })
                            })
                        ]
                    }),
                    isMobile && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.label_mobile,
                                        children: "Giấy ph\xe9p kinh doanh ph\xf2ng kh\xe1m/nh\xe0 thuốc"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            width: "100%",
                                            padding: "10px"
                                        },
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            variant: "contained",
                                            classes: {
                                                root: clsx(styles.upload_button, styles.border_radius_8)
                                            },
                                            onClick: function() {
                                                document.getElementById("input-file").click();
                                            },
                                            style: {
                                                backgroundColor: disabledLicense ? "#DFE3E8" : "rgb(0, 180, 110)",
                                                color: disabledLicense ? "rgb(158 156 173)" : "#fff"
                                            },
                                            children: "Tải file"
                                        })
                                    }),
                                    licenses.length > 0 && /*#__PURE__*/ _jsx(Grid, {
                                        container: true,
                                        direction: "column",
                                        className: styles.license_chip_list,
                                        children: licenses.map(function(license) {
                                            return /*#__PURE__*/ _jsx(Grid, {
                                                item: true,
                                                container: true,
                                                direction: "row",
                                                style: {
                                                    justifyContent: "center"
                                                },
                                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                                    title: license.name,
                                                    arrow: true,
                                                    children: /*#__PURE__*/ _jsx(Chip, {
                                                        label: license.name,
                                                        style: {
                                                            maxWidth: "200px"
                                                        },
                                                        clickable: true,
                                                        color: "default",
                                                        avatar: /*#__PURE__*/ _jsx(FileCopyIcon, {}),
                                                        onDelete: function() {
                                                            handleDeleteFile(license.publicURL, licenses, "licenses");
                                                        },
                                                        onClick: function() {
                                                            handleViewFile(license.publicURL);
                                                        }
                                                    })
                                                })
                                            }, uuidV4());
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(FormHelperText, {
                                        className: styles.helperTextMobile,
                                        children: "File PNG, JPEG hoặc PDF - tối đa 3 files"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.label_mobile,
                                        children: "Hồ sơ GPP"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            width: "100%",
                                            padding: "10px"
                                        },
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            variant: "contained",
                                            classes: {
                                                root: clsx(styles.upload_button, styles.border_radius_8)
                                            },
                                            onClick: function() {
                                                document.getElementById("input-file-gpp").click();
                                            },
                                            style: {
                                                backgroundColor: disabledGpp ? "#DFE3E8" : "rgb(0, 180, 110)",
                                                color: disabledGpp ? "rgb(158 156 173)" : "#fff"
                                            },
                                            children: "Tải file"
                                        })
                                    }),
                                    gpp.length > 0 && /*#__PURE__*/ _jsx(Grid, {
                                        container: true,
                                        direction: "column",
                                        className: styles.license_chip_list,
                                        children: gpp.map(function(item) {
                                            return /*#__PURE__*/ _jsx(Grid, {
                                                item: true,
                                                container: true,
                                                direction: "row",
                                                style: {
                                                    justifyContent: "center"
                                                },
                                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                                    title: item.name,
                                                    arrow: true,
                                                    children: /*#__PURE__*/ _jsx(Chip, {
                                                        label: item.name,
                                                        style: {
                                                            maxWidth: "200px"
                                                        },
                                                        clickable: true,
                                                        color: "default",
                                                        avatar: /*#__PURE__*/ _jsx(FileCopyIcon, {}),
                                                        onDelete: function() {
                                                            handleDeleteFile(item.publicURL, gpp, "gpp");
                                                        },
                                                        onClick: function() {
                                                            handleViewFile(item.publicURL);
                                                        }
                                                    })
                                                })
                                            }, uuidV4());
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(FormHelperText, {
                                        className: styles.helperTextMobile,
                                        children: "File PDF, PNG, JPEG, DOC hoặc DOCX - tối đa 3 files"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.label_mobile,
                                        children: "H\xecnh ảnh nh\xe0 thuốc"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            width: "100%",
                                            padding: "10px"
                                        },
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            variant: "contained",
                                            classes: {
                                                root: clsx(styles.upload_button, styles.border_radius_8)
                                            },
                                            onClick: function() {
                                                document.getElementById("business-images").click();
                                            },
                                            style: {
                                                backgroundColor: disabledBusinessImage ? "#DFE3E8" : "rgb(0, 180, 110)",
                                                color: disabledBusinessImage ? "rgb(158 156 173)" : "#fff"
                                            },
                                            children: "Tải file"
                                        })
                                    }),
                                    businessImages.length > 0 && /*#__PURE__*/ _jsx(Grid, {
                                        container: true,
                                        spacing: 2,
                                        direction: "row",
                                        children: businessImages.map(function(item) {
                                            return /*#__PURE__*/ _jsx(Grid, {
                                                item: true,
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    style: {
                                                        position: "relative"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            style: {
                                                                position: "absolute",
                                                                top: -10,
                                                                right: -10,
                                                                zIndex: 1
                                                            },
                                                            children: /*#__PURE__*/ _jsx(HighlightOffIcon, {
                                                                fontSize: "small",
                                                                onClick: function() {
                                                                    return handleDeleteFile(item, businessImages, "businessImages");
                                                                },
                                                                style: {
                                                                    color: "#666666",
                                                                    cursor: "pointer"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(Image, {
                                                            src: getLinkGCS(item || MISSING_IMAGE),
                                                            width: "100",
                                                            height: "100",
                                                            onClick: function() {
                                                                handleViewFile(item);
                                                            }
                                                        })
                                                    ]
                                                })
                                            }, uuidV4());
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(FormHelperText, {
                                        className: styles.helperTextMobile,
                                        children: "File PNG, JPEG - tối đa 3 files"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ _jsx(InfoFormControl, {
                        xs: 12,
                        label: "M\xe3 số thuế",
                        htmlFor: "taxCode",
                        error: error.taxCode,
                        children: /*#__PURE__*/ _jsx(InfoInput, {
                            id: "taxCode",
                            placeholder: "M\xe3 số thuế",
                            value: taxCode,
                            error: error.taxCode,
                            onChange: function(e) {
                                handleSetValue("taxCode", e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(InfoFormControl, {
                        xs: 12,
                        label: "Địa chỉ nh\xe0 thuốc/ph\xf2ng kh\xe1m",
                        htmlFor: "address",
                        isRequired: true,
                        children: /*#__PURE__*/ _jsx(InfoInput, {
                            id: "address",
                            placeholder: "Địa chỉ",
                            value: address,
                            onChange: function(e) {
                                handleSetValue("address", e.target.value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(GroupAddressSelect, {
                id: uuidV4(),
                currentAddress: currentAddress,
                handleSetCurrentAddress: handleSetCurrentAddress,
                error: error
            })
        ]
    });
};
/* harmony default export */ var mocules_EnterpriseForm = ((/* unused pure expression or super */ null && (EnterpriseForm)));

;// CONCATENATED MODULE: ./src/components/mocules/EventBadge/index.js



var EventBadge_EventBadge = function(param) {
    var url = param.url, children = param.children;
    return /*#__PURE__*/ _jsx(Badge, {
        className: "badge--event badge",
        url: url,
        children: children
    });
};
/* harmony default export */ var mocules_EventBadge = ((/* unused pure expression or super */ null && (EventBadge_EventBadge)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment_InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem_MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 1 modules
var Select = __webpack_require__(55296);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var icons_Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./src/components/mocules/FloatSearch/styles.module.css
var FloatSearch_styles_module = __webpack_require__(90124);
var FloatSearch_styles_module_default = /*#__PURE__*/__webpack_require__.n(FloatSearch_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/FloatSearch/index.js



function FloatSearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  height: 40px !important;\n  background: #ffffff;\n  color: #606060;\n  z-index: 1;\n  border-radius: 8px 0px 0px 8px;\n  margin: 0;\n  border-right: 1.2px solid #e8e9f8;\n  &.Mui-focused {\n    z-index: 4;\n    border-right: 1.2px solid #e8e9f8 !important;\n    border-color: transparent;\n  }\n"
    ]);
    FloatSearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FloatSearch_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  height: 40px !important;\n  background: #ffffff;\n  color: #606060;\n  z-index: 1;\n  border-radius: 0px 8px 8px 0px;\n  margin: 0;\n  width: 100%;\n  border: none;\n  & .MuiSelect-select {\n    padding-left: 5px;\n  }\n"
    ]);
    FloatSearch_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var IngredientInput = function(_param) /*#__PURE__*/ {
    var className = _param.className, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
        className: className
    }, rest));
};
var StyledIngredientInput = (0,styled_components_browser_esm/* default */.ZP)(IngredientInput).withConfig({
    componentId: "sc-81cc0e0e-0"
})(FloatSearch_templateObject());
var StyledMedicineTypeSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-81cc0e0e-1"
})(FloatSearch_templateObject1());
var CloseButton = function(param) {
    var handleClose = param.handleClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
        onClick: handleClose
    });
};
var FloatSearch = function(param) {
    var value = param.value, handleChangeValue = param.handleChangeValue, handleClose = param.handleClose, placeholder = param.placeholder, isMobile = param.isMobile;
    var ref;
    var ref1 = (0,esm/* useTranslation */.$G)("ingredients"), translateIngredients = ref1.t;
    var router = (0,next_router.useRouter)();
    var handleKeyPress = function(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            event.target.blur();
        }
    };
    var medicineTypes = [
        {
            label: translateIngredients("medicine"),
            value: "medicine"
        },
        {
            label: translateIngredients("non_medicine"),
            value: "notmedicine"
        }, 
    ];
    var handleChangeType = function(e) {
        router.push("".concat(router.pathname, "?type=").concat(e.target.value));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((FloatSearch_styles_module_default()).searchBox, isMobile && (FloatSearch_styles_module_default()).mobileSearchBox),
        container: true,
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                item: true,
                xs: 9,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIngredientInput, {
                    fullWidth: true,
                    placeholder: placeholder,
                    value: value,
                    onChange: handleChangeValue,
                    onKeyPress: handleKeyPress,
                    endAdornment: value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                        handleClose: handleClose
                    }) : null,
                    startAdornment: // eslint-disable-next-line react/jsx-wrap-multilines
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
                        position: "start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Search/* default */.Z, {})
                    }),
                    className: (FloatSearch_styles_module_default()).searchInput
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                item: true,
                xs: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMedicineTypeSelect, {
                    labelId: "demo-simple-select-label",
                    id: "demo-simple-select",
                    value: (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.type) || medicineTypes[0].value,
                    onChange: handleChangeType,
                    disableUnderline: true,
                    children: medicineTypes.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                            value: option.value,
                            children: option.label
                        }, option.value);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_FloatSearch = (FloatSearch);

// EXTERNAL MODULE: ./src/components/mocules/ForgetPasswordForm/styles.module.css
var ForgetPasswordForm_styles_module = __webpack_require__(52200);
var ForgetPasswordForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(ForgetPasswordForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ForgetPasswordForm/ForgetPasswordForm.js








var ForgetPasswordForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickPhoneForm = param.onClickPhoneForm, onClickNewPasswordForm = param.onClickNewPasswordForm, step = param.step, onTimeout = param.onTimeout, isTimeOut = param.isTimeOut, setIsTimeOut = param.setIsTimeOut, toggleResend = param.toggleResend, onClose = param.onClose;
    var toggleLogin = (0,context/* useAuth */.aC)().toggleLogin;
    var regExp = /(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
    var regExpOpt = /^.{6,6}$/;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    var SECOND_TIMEOUT = 180;
    var ref = (0,react.useState)(false), phoneValue = ref[0], setPhoneValue = ref[1];
    var ref1 = (0,react.useState)(false), errorPhone = ref1[0], setErrorPhone = ref1[1];
    var ref2 = (0,react.useState)(""), errorPhoneMessage = ref2[0], setErrorPhoneMessage = ref2[1];
    var ref3 = (0,react.useState)(false), errorOtp = ref3[0], setErrorOtp = ref3[1];
    var ref4 = (0,react.useState)(""), errorOtpMessage = ref4[0], setErrorOtpMessage = ref4[1];
    var ref5 = (0,react.useState)(""), pwValue = ref5[0], setPwValue = ref5[1];
    var ref6 = (0,react.useState)(false), errorPw = ref6[0], setErrorPw = ref6[1];
    var ref7 = (0,react.useState)(""), errorPwMessage = ref7[0], setErrorPwMessage = ref7[1];
    var ref8 = (0,react.useState)(false), errorPwConfirm = ref8[0], setErrorPwConfirm = ref8[1];
    var ref9 = (0,react.useState)(""), errorPwConfirmMessage = ref9[0], setErrorPwConfirmMessage = ref9[1];
    var ref10 = (0,react.useState)(-1), second = ref10[0], setSecond = ref10[1];
    var handleLoginFunc = function() {
        onClose();
        toggleLogin();
    };
    // handle validate
    var validatePhone = function(data) {
        setErrorPhone(false);
        if (data === "") {
            setErrorPhone(true);
            setErrorPhoneMessage("Vui l\xf2ng nhập số điện thoại");
            return false;
        }
        if (!data.match(regExp)) {
            setErrorPhone(true);
            setErrorPhoneMessage("Số điện thoại bạn nhập kh\xf4ng đ\xfang");
            return false;
        }
        return true;
    };
    var validateOtp = function(data) {
        setErrorOtp(false);
        if (data === "") {
            setErrorOtp(true);
            setErrorOtpMessage("Vui l\xf2ng nhập m\xe3 OTP");
            return false;
        }
        if (!data.match(regExpOpt)) {
            setErrorOtp(true);
            setErrorOtpMessage("M\xe3 OTP gồm 6 chữ số");
            return false;
        }
        return true;
    };
    var validatePw = function(data) {
        setErrorPw(false);
        if (data === "") {
            setErrorPw(true);
            setErrorPwMessage("Bạn chưa điền mật khẩu");
            return false;
        }
        if (data.length > 30 || data.length < 8) {
            setErrorPw(true);
            setErrorPwMessage("Mật khẩu tối thiểu 8 v\xe0 tối đa 30 k\xed tự");
            return false;
        }
        return true;
    };
    var validatePwConfirm = function(data) {
        setErrorPwConfirm(false);
        if (data === "") {
            setErrorPwConfirm(true);
            setErrorPwConfirmMessage("Bạn chưa điền mật khẩu x\xe1c nhận");
            return false;
        }
        if (data !== pwValue) {
            setErrorPwConfirm(true);
            setErrorPwConfirmMessage("Mật khẩu x\xe1c nhận kh\xf4ng khớp");
            return false;
        }
        return true;
    };
    // handle submit form
    var onSubmitPhoneForm = function(e) {
        e.preventDefault();
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        setPhoneValue(data.phoneNumber);
        if (!validatePhone(data.phoneNumber)) {
            return;
        }
        // data type is customer on web
        data.type = "CUSTOMER";
        onClickPhoneForm(data);
    };
    var onSubmitNewPasswordForm = function(e) {
        e.preventDefault();
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        if (!validateOtp(data.token)) {
            return;
        }
        if (!validatePw(data.newPassword) || !validatePwConfirm(data.confirmPassword)) {
            return;
        }
        delete data.confirmPassword;
        // data type is customer on web
        data.type = "CUSTOMER";
        onClickNewPasswordForm(data);
    };
    // handle input
    var handleOnChangePhone = function(e) {
        e.preventDefault();
        validatePhone(e.target.value);
    };
    var handleOnChangeOpt = function(e) {
        e.preventDefault();
        validateOtp(e.target.value);
    };
    var handleOnChangePw = function(e) {
        e.preventDefault();
        setPwValue(e.target.value);
        validatePw(e.target.value);
    };
    var handleOnChangePwConfirm = function(e) {
        e.preventDefault();
        validatePwConfirm(e.target.value);
    };
    var startCoundown = function(time) {
        setSecond(time);
        setIsTimeOut(false);
    };
    var onResend = function() {
        startCoundown(SECOND_TIMEOUT);
        onClickPhoneForm({
            phoneNumber: phoneValue,
            type: "CUSTOMER"
        });
    };
    (0,react.useEffect)(function() {
        if (step === 2) {
            startCoundown(SECOND_TIMEOUT);
        }
    }, [
        toggleResend
    ]);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            if (second > 0 && second !== -1) {
                setSecond(second - 1);
            // setMinute(Math.floor(second / 60));
            }
            if (second === 0) {
                onTimeout();
            }
        }, 1000);
        // Clear timeout if the component is unmounted
        return function() {
            return clearTimeout(timer);
        };
    }, [
        second
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "forget-password",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "Nhập số điện thoại cần kh\xf4i phục"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "form-forget-password ".concat(className),
                        onSubmit: onSubmitPhoneForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "phoneNumber",
                                        name: "phoneNumber",
                                        type: "number",
                                        placeholder: "Nhập số điện thoại",
                                        variant: "outlined",
                                        className: (ForgetPasswordForm_styles_module_default()).input,
                                        error: errorPhone,
                                        onChange: handleOnChangePhone
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).error,
                                        children: errorPhone && errorPhoneMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "action",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    className: "btnForgetPassword",
                                    color: "white",
                                    children: "Gửi"
                                })
                            })
                        ]
                    })
                ]
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "forget-password",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "Nhập m\xe3 OTP v\xe0 mật khẩu mới"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "form-forget-password ".concat(className),
                        onSubmit: onSubmitNewPasswordForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "phoneNumber",
                                    name: "phoneNumber",
                                    type: "number",
                                    placeholder: "Nhập số điện thoại",
                                    variant: "outlined",
                                    className: [
                                        (ForgetPasswordForm_styles_module_default()).input,
                                        (ForgetPasswordForm_styles_module_default()).disabled
                                    ],
                                    value: phoneValue,
                                    inputProps: {
                                        readOnly: true
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).custom_field,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                                className: (ForgetPasswordForm_styles_module_default()).input,
                                                id: "token",
                                                name: "token",
                                                text: "text",
                                                placeholder: "Nhập m\xe3 OTP",
                                                variant: "outlined",
                                                error: errorOtp,
                                                onChange: handleOnChangeOpt
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ForgetPasswordForm_styles_module_default()).right_c,
                                                children: !isTimeOut ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ForgetPasswordForm_styles_module_default()).remaining,
                                                    children: second
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                                    className: "btnForgetPassword",
                                                    color: "white",
                                                    onClick: onResend,
                                                    children: "Gửi lại"
                                                })
                                            })
                                        ]
                                    }),
                                    errorOtp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).error,
                                        children: errorOtpMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "newPassword",
                                        name: "newPassword",
                                        type: "password",
                                        placeholder: "Nhập mật khẩu mới",
                                        variant: "outlined",
                                        className: (ForgetPasswordForm_styles_module_default()).input,
                                        error: errorPw,
                                        onChange: handleOnChangePw
                                    }),
                                    errorPw && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).error,
                                        children: errorPwMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "confirmPassword",
                                        name: "confirmPassword",
                                        type: "password",
                                        placeholder: "X\xe1c nhận lại mật khẩu",
                                        variant: "outlined",
                                        error: errorPwConfirm,
                                        className: (ForgetPasswordForm_styles_module_default()).input,
                                        onChange: handleOnChangePwConfirm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).error,
                                        children: errorPwConfirm && errorPwConfirmMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "action",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    className: "btnForgetPassword",
                                    color: "white",
                                    children: "Gửi"
                                })
                            })
                        ]
                    })
                ]
            }),
            (step === 3 || step === 4) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "forget-password",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordForm_styles_module_default()).confirm_modal_wrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ForgetPasswordForm_styles_module_default()).warning_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (ForgetPasswordForm_styles_module_default()).text_icon,
                                        children: "✓"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (ForgetPasswordForm_styles_module_default()).modal_title,
                                    children: "Thay đổi mật khẩu th\xe0nh c\xf4ng"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordForm_styles_module_default()).btngroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonHeader */.X9, {
                            variant: "contained",
                            btnType: "primary",
                            onClick: handleLoginFunc,
                            children: "Đăng nhập"
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var ForgetPasswordForm_ForgetPasswordForm = (ForgetPasswordForm);

;// CONCATENATED MODULE: ./src/components/mocules/ForgetPasswordForm/index.js

function ForgetPasswordForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .form-forget-password {\n    margin-top: 10px;\n  }\n\n  .form-control {\n    width: ",
        "px;\n    margin-bottom: 10px;\n  }\n\n  .btnForgetPassword {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    padding: 1.5rem;\n    border-radius: 50px;\n  }\n  .action {\n    margin-top: 10px;\n    max-width: 200px;\n    width: 100%;\n  }\n  .desc {\n    font-size: 16px;\n    margin: 15px auto;\n    max-width: 450px;\n  }\n  .forget-password {\n    width: 100%;\n  }\n"
    ]);
    ForgetPasswordForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var styledForgetPasswordForm = (0,styled_components_browser_esm/* default */.ZP)(ForgetPasswordForm_ForgetPasswordForm).withConfig({
    componentId: "sc-c146e701-0"
})(ForgetPasswordForm_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 450 : _width;
    return width;
});
/* harmony default export */ var mocules_ForgetPasswordForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(styledForgetPasswordForm))));

// EXTERNAL MODULE: ./src/components-v2/atoms/PasswordWarningText/index.js
var PasswordWarningText = __webpack_require__(73238);
// EXTERNAL MODULE: ./node_modules/react-countdown-circle-timer/lib/index.js
var react_countdown_circle_timer_lib = __webpack_require__(7907);
// EXTERNAL MODULE: ./src/components/mocules/CircleTimer/styles.module.css
var CircleTimer_styles_module = __webpack_require__(7867);
var CircleTimer_styles_module_default = /*#__PURE__*/__webpack_require__.n(CircleTimer_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/CircleTimer/index.js




var RenderTime = function(param) {
    var remainingTime = param.remainingTime;
    var t = (0,es/* useTranslation */.$G)("common").t;
    if (remainingTime === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CircleTimer_styles_module_default()).timer,
            children: t("expire")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CircleTimer_styles_module_default()).timer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CircleTimer_styles_module_default()).value,
            children: remainingTime
        })
    });
};
var CircleTimer = function(param) {
    var duration = param.duration;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_countdown_circle_timer_lib.CountdownCircleTimer, {
        isPlaying: true,
        duration: duration,
        size: 80,
        strokeWidth: 8,
        colors: [
            [
                "#005C29",
                0.4
            ],
            [
                "#3cb56b",
                0.35
            ],
            [
                "#9ac100",
                0.25
            ], 
        ],
        children: RenderTime
    });
};
/* harmony default export */ var mocules_CircleTimer = (CircleTimer);

// EXTERNAL MODULE: ./src/components/mocules/ForgetPasswordFormV2/styles.module.css
var ForgetPasswordFormV2_styles_module = __webpack_require__(69470);
var ForgetPasswordFormV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(ForgetPasswordFormV2_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ForgetPasswordFormV2/index.js











var ForgetPasswordFormV2 = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickPhoneForm = param.onClickPhoneForm, onClickNewPasswordForm = param.onClickNewPasswordForm, step = param.step, onTimeout = param.onTimeout, isTimeOut = param.isTimeOut, setIsTimeOut = param.setIsTimeOut, toggleResend = param.toggleResend, onClose = param.onClose, translatePopupAction = param.translatePopupAction;
    var toggleLogin = (0,context/* useAuth */.aC)().toggleLogin;
    var regExp = /^([0-9]{6,10})\b/;
    var regExpOpt = /^.{6,6}$/;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    var SECOND_TIMEOUT = 60 * 3; // 5 minutes -> change to 3 minutes
    var ref = (0,react.useState)(false), phoneValue = ref[0], setPhoneValue = ref[1];
    var ref1 = (0,react.useState)(false), errorPhone = ref1[0], setErrorPhone = ref1[1];
    var ref2 = (0,react.useState)(""), errorPhoneMessage = ref2[0], setErrorPhoneMessage = ref2[1];
    var ref3 = (0,react.useState)(false), errorOtp = ref3[0], setErrorOtp = ref3[1];
    var ref4 = (0,react.useState)(""), errorOtpMessage = ref4[0], setErrorOtpMessage = ref4[1];
    var ref5 = (0,react.useState)(""), pwValue = ref5[0], setPwValue = ref5[1];
    var ref6 = (0,react.useState)(false), errorPw = ref6[0], setErrorPw = ref6[1];
    var ref7 = (0,react.useState)(""), errorPwMessage = ref7[0], setErrorPwMessage = ref7[1];
    var ref8 = (0,react.useState)(false), errorPwConfirm = ref8[0], setErrorPwConfirm = ref8[1];
    var ref9 = (0,react.useState)(""), errorPwConfirmMessage = ref9[0], setErrorPwConfirmMessage = ref9[1];
    var ref10 = (0,react.useState)(0), second = ref10[0], setSecond = ref10[1];
    var handleLoginFunc = function() {
        onClose();
        toggleLogin();
    };
    // handle validate
    var validatePhone = function(data) {
        setErrorPhone(false);
        if (data === "") {
            setErrorPhone(true);
            setErrorPhoneMessage(translatePopupAction("forgetpassword_step2.entered_numberPhone"));
            return false;
        }
        if (!data.match(regExp)) {
            setErrorPhone(true);
            setErrorPhoneMessage(translatePopupAction("popup-trial-account.error_wrong_format_phone_number"));
            return false;
        }
        return true;
    };
    var validateOtp = function(data) {
        setErrorOtp(false);
        if (data === "") {
            setErrorOtp(true);
            setErrorOtpMessage(translatePopupAction("forgetpassword_step2.enter_otp"));
            return false;
        }
        if (!data.match(regExpOpt)) {
            setErrorOtp(true);
            setErrorOtpMessage(translatePopupAction("forgetpassword_step2.opt_have_6_num"));
            return false;
        }
        return true;
    };
    var validatePw = function(data) {
        setErrorPw(false);
        if (data === "") {
            setErrorPw(true);
            setErrorPwMessage(translatePopupAction("popup_login.validate_password_empty"));
            return false;
        }
        if (data.length > 30 || data.length < 8) {
            setErrorPw(true);
            setErrorPwMessage(translatePopupAction("popup-validateUntil.password_must_be_entered_min2_and_max30_character"));
            return false;
        }
        return true;
    };
    var validatePwConfirm = function(data) {
        setErrorPwConfirm(false);
        if (data === "") {
            setErrorPwConfirm(true);
            setErrorPwConfirmMessage(translatePopupAction("forgetpassword_step2.enter_confirm_password"));
            return false;
        }
        if (data !== pwValue) {
            setErrorPwConfirm(true);
            setErrorPwConfirmMessage(translatePopupAction("forgetpassword_step2.wrong_confirm_password"));
            return false;
        }
        return true;
    };
    // handle submit form
    var onSubmitPhoneForm = function(e) {
        e.preventDefault();
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        setPhoneValue(data.phoneNumber);
        if (!validatePhone(data.phoneNumber)) {
            return;
        }
        // data type is customer on web
        data.type = "CUSTOMER";
        data.setErrorPhone = function() {
            return setErrorPhone(true);
        };
        data.setErrorPhoneMessage = function() {
            return setErrorPhoneMessage(translatePopupAction("popup-trial-account.error_wrong_format_phone_number"));
        };
        onClickPhoneForm(data);
    };
    var onSubmitNewPasswordForm = function(e) {
        e.preventDefault();
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        if (!validateOtp(data.token)) {
            return;
        }
        if (!validatePw(data.newPassword) || !validatePwConfirm(data.confirmPassword)) {
            return;
        }
        delete data.confirmPassword;
        // data type is customer on web
        data.type = "CUSTOMER";
        data.setErrorOtp = function() {
            return setErrorOtp(true);
        };
        data.setErrorOtpMessage = function() {
            return setErrorOtpMessage(translatePopupAction("change-password.err_entered_OTP"));
        };
        onClickNewPasswordForm(data);
    };
    // handle input
    var handleOnChangePhone = function(e) {
        e.preventDefault();
        validatePhone(e.target.value);
    };
    var handleOnChangeOpt = function(e) {
        e.preventDefault();
        validateOtp(e.target.value);
    };
    var handleOnChangePw = function(e) {
        e.preventDefault();
        setPwValue(e.target.value);
        validatePw(e.target.value);
    };
    var handleOnChangePwConfirm = function(e) {
        e.preventDefault();
        validatePwConfirm(e.target.value);
    };
    var startCoundown = function(time) {
        setSecond(time);
        setIsTimeOut(false);
    };
    var onResend = function() {
        startCoundown(SECOND_TIMEOUT);
        onClickPhoneForm({
            phoneNumber: phoneValue,
            type: "CUSTOMER"
        });
    };
    (0,react.useEffect)(function() {
        if (step === 2) {
            startCoundown(SECOND_TIMEOUT);
        }
    }, [
        toggleResend
    ]);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            if (second > 0) {
                setSecond(second - 1);
            // setMinute(Math.floor(second / 60));
            }
            if (second === 0) {
                onTimeout();
            }
        }, 1000);
        // Clear timeout if the component is unmounted
        return function() {
            return clearTimeout(timer);
        };
    }, [
        second
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordFormV2_styles_module_default()).desc,
                        children: translatePopupAction("forgetpassword.sub_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: className,
                        onSubmit: onSubmitPhoneForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "phoneNumber",
                                        name: "phoneNumber",
                                        placeholder: translatePopupAction("forgetpassword.description"),
                                        variant: "outlined",
                                        className: (ForgetPasswordFormV2_styles_module_default()).input,
                                        error: errorPhone,
                                        onChange: handleOnChangePhone
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordFormV2_styles_module_default()).error,
                                        children: errorPhone && errorPhoneMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordWarningText/* default */.Z, {
                                className: (ForgetPasswordFormV2_styles_module_default()).mb_10
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                className: (ForgetPasswordFormV2_styles_module_default()).center,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    className: (ForgetPasswordFormV2_styles_module_default()).btn,
                                    children: translatePopupAction("forgetpassword.send")
                                })
                            })
                        ]
                    })
                ]
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordFormV2_styles_module_default()).desc,
                        children: translatePopupAction("forgetpassword_step2.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: className,
                        onSubmit: onSubmitNewPasswordForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ForgetPasswordFormV2_styles_module_default()).timing_wrapper,
                                children: !isTimeOut ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CircleTimer, {
                                        duration: second
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    className: (ForgetPasswordFormV2_styles_module_default()).btn,
                                    onClick: onResend,
                                    children: translatePopupAction("forgetpassword_step2.send")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "phoneNumber",
                                    name: "phoneNumber",
                                    type: "number",
                                    placeholder: translatePopupAction("forgetpassword_step2.entered_numberPhone"),
                                    variant: "outlined",
                                    className: [
                                        (ForgetPasswordFormV2_styles_module_default()).input,
                                        (ForgetPasswordFormV2_styles_module_default()).disabled
                                    ],
                                    value: phoneValue,
                                    inputProps: {
                                        readOnly: true
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        className: (ForgetPasswordFormV2_styles_module_default()).input,
                                        id: "token",
                                        name: "token",
                                        text: "text",
                                        placeholder: translatePopupAction("forgetpassword_step2.enter_otp"),
                                        variant: "outlined",
                                        error: errorOtp,
                                        onChange: handleOnChangeOpt
                                    }),
                                    errorOtp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordFormV2_styles_module_default()).error,
                                        children: errorOtpMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "newPassword",
                                        name: "newPassword",
                                        type: "password",
                                        placeholder: translatePopupAction("forgetpassword_step2.enter_new_password"),
                                        variant: "outlined",
                                        className: (ForgetPasswordFormV2_styles_module_default()).input,
                                        error: errorPw,
                                        onChange: handleOnChangePw
                                    }),
                                    errorPw && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordFormV2_styles_module_default()).error,
                                        children: errorPwMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "confirmPassword",
                                        name: "confirmPassword",
                                        type: "password",
                                        placeholder: translatePopupAction("forgetpassword_step2.confirm_password"),
                                        variant: "outlined",
                                        error: errorPwConfirm,
                                        className: (ForgetPasswordFormV2_styles_module_default()).input,
                                        onChange: handleOnChangePwConfirm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordFormV2_styles_module_default()).error,
                                        children: errorPwConfirm && errorPwConfirmMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                className: (ForgetPasswordFormV2_styles_module_default()).center,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    className: (ForgetPasswordFormV2_styles_module_default()).btn,
                                    children: translatePopupAction("forgetpassword.confirm_reset_password")
                                })
                            })
                        ]
                    })
                ]
            }),
            (step === 3 || step === 4) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordFormV2_styles_module_default()).confirm_modal_wrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ForgetPasswordFormV2_styles_module_default()).warning_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (ForgetPasswordFormV2_styles_module_default()).text_icon,
                                        children: "✓"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (ForgetPasswordFormV2_styles_module_default()).modal_title,
                                    children: translatePopupAction("forgetpassword_step3.changePassword_success")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: (ForgetPasswordFormV2_styles_module_default()).center,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            className: (ForgetPasswordFormV2_styles_module_default()).btn,
                            onClick: handleLoginFunc,
                            children: translatePopupAction("forgetpassword_step3.login")
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var mocules_ForgetPasswordFormV2 = (ForgetPasswordFormV2);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js
var Backdrop_Backdrop = __webpack_require__(32692);
// EXTERNAL MODULE: ./src/components-v2/atoms/LoadingBM/index.js
var LoadingBM = __webpack_require__(30274);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/components/mocules/PromotionDetailModal/styles.module.css
var PromotionDetailModal_styles_module = __webpack_require__(57770);
var PromotionDetailModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(PromotionDetailModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/PromotionDetailModal/index.js













var PromotionDetailModal = /*#__PURE__*/ (0,react.memo)(function(param) {
    var onClose = param.onClose, visible = param.visible, className = param.className, restProps = param.restProps, title = param.title, _listsPromo = param.listsPromo, listsPromo = _listsPromo === void 0 ? [] : _listsPromo, loading = param.loading, err = param.err;
    // max 5 list promo
    // const maxPromoLists = listsPromo.slice(0, 5);
    var renderDescriptionPromo = function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: data
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: Backdrop_Backdrop/* default */.Z,
        BackdropProps: {
            timeout: 300
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
            in: visible,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                className: (PromotionDetailModal_styles_module_default()).confirm_modal_wrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        className: (PromotionDetailModal_styles_module_default()).header,
                        style: {
                            background: "#005c29",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px 0px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                style: {
                                    display: "flex",
                                    marginLeft: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                        className: (PromotionDetailModal_styles_module_default()).wrapImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* VOUCHER_TITLE_BOX */.Ue, {})
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (PromotionDetailModal_styles_module_default()).modal_title,
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                className: (PromotionDetailModal_styles_module_default()).closeIcon,
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                        className: (PromotionDetailModal_styles_module_default()).containerPromoDiablog,
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            className: (PromotionDetailModal_styles_module_default()).wrapLoading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBM/* default */.Z, {
                                animateText: true
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            className: (PromotionDetailModal_styles_module_default()).children,
                            children: [
                                err && err,
                                listsPromo === null || listsPromo === void 0 ? void 0 : listsPromo.map(function(param) {
                                    var _conditionDescription = param.conditionDescription, conditionDescription = _conditionDescription === void 0 ? "" : _conditionDescription, voucherId = param.voucherId;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: renderDescriptionPromo(conditionDescription)
                                    }, voucherId);
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
});
/* harmony default export */ var mocules_PromotionDetailModal = (/*#__PURE__*/react.memo(PromotionDetailModal));

;// CONCATENATED MODULE: ./src/components/mocules/HeaderUser/HeaderUser.js






var HeaderUser = /*#__PURE__*/ react.memo(function(props) {
    var user = props.user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "header_user",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header_user_name",
                children: (user === null || user === void 0 ? void 0 : user.name) || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header_user_avatar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                    href: Paths/* MY_ACCOUNT */.RX,
                    padding: "0px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip/* default */.ZP, {
                        title: "Th\xf4ng tin t\xe0i khoản",
                        arrow: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "header_user_avatar_image",
                                src: "/images/avatar/user_avatar_default.svg",
                                width: 39,
                                height: 39
                            })
                        })
                    })
                })
            })
        ]
    });
});
/* harmony default export */ var HeaderUser_HeaderUser = (HeaderUser);

;// CONCATENATED MODULE: ./src/components/mocules/HeaderUser/index.js

function HeaderUser_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    HeaderUser_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledHeaderUser = (0,styled_components_browser_esm/* default */.ZP)(HeaderUser_HeaderUser).withConfig({
    componentId: "sc-b8e0454c-0"
})(HeaderUser_templateObject());
/* harmony default export */ var mocules_HeaderUser = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(StyledHeaderUser))));

;// CONCATENATED MODULE: ./src/components/mocules/InfoTabs/index.js













var InfoTabs = function(param) {
    var value = param.value, name = param.name;
    var ref;
    var ref1 = useTranslation("common"), translateCommon = ref1.t;
    var tabs = [
        {
            label: translateCommon("tab_menu.my_account"),
            icon: /*#__PURE__*/ _jsx(USER, {}),
            id: 1,
            link: "/my-account",
            enable: true
        },
        // { label: 'Thông tin cấp bậc', icon: <LEVEL />, id: 2, link: '/user/level', enable: FEATURE_LEVEL },
        {
            label: translateCommon("tab_menu.my_points"),
            icon: /*#__PURE__*/ _jsx(POINTS, {}),
            id: 8,
            link: "/users/loyalty_points",
            enable: true
        },
        {
            label: translateCommon("tab_menu.my_orders"),
            icon: /*#__PURE__*/ _jsx(ORDER, {}),
            id: 3,
            link: "/my-order",
            enable: true
        },
        {
            label: translateCommon("tab_menu.statistics"),
            icon: /*#__PURE__*/ _jsx(STATISTICAL, {}),
            id: 4,
            link: "/user/dashboard",
            enable: true
        },
        {
            label: translateCommon("tab_menu.refer_friends"),
            icon: /*#__PURE__*/ _jsx(REFER, {}),
            id: 5,
            link: "/users/referrals",
            enable: true
        },
        {
            label: translateCommon("tab_menu.my_discount"),
            icon: /*#__PURE__*/ _jsx(VOUCHER, {}),
            id: 6,
            link: "/users/user-promo-codes",
            enable: true
        },
        {
            label: translateCommon("tab_menu.my_feedback"),
            icon: /*#__PURE__*/ _jsx(FEEDBACK, {}),
            id: 7,
            link: "/users/my-ticket",
            enable: true
        },
        {
            label: translateCommon("tab_menu.bill_of_lading_lookup"),
            icon: /*#__PURE__*/ _jsx(BILL, {}),
            id: 9,
            link: "https://tracuu.thuocsi.vn",
            enable: ENV_COUNTRY === "vn"
        },
        {
            label: translateCommon("tab_menu.qr_code_lookup"),
            icon: /*#__PURE__*/ _jsx(QR, {}),
            id: 10,
            link: "/qr",
            enable: true
        },
        {
            label: translateCommon("interested_products"),
            icon: /*#__PURE__*/ _jsx(WISHLIST, {}),
            id: 11,
            link: "/user/wishlist",
            enable: true
        },
        {
            label: translateCommon("viewed_products"),
            icon: /*#__PURE__*/ _jsx(VIEWED, {}),
            id: 12,
            link: "/productviewed",
            enable: true
        }, 
    ];
    var user = useAuth().user;
    var ref2 = user || {}, _level = ref2.level, level = _level === void 0 ? "" : _level;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.tab_box,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.account_name,
                children: [
                    translateCommon("tab_menu.account_of"),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h5",
                        className: styles.name,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuList, {
                children: (ref = tabs === null || tabs === void 0 ? void 0 : tabs.filter(function(item) {
                    return item.enable;
                })) === null || ref === void 0 ? void 0 : ref.map(function(tab) {
                    return (level !== "LEVEL_BLACKLIST" || tab.id !== 2) && /*#__PURE__*/ _jsx(LinkComp, {
                        href: tab.link,
                        prefetch: false,
                        children: /*#__PURE__*/ _jsxs(MenuItem, {
                            button: false,
                            classes: {
                                root: value === tab.id ? styles.tab_active : styles.tab_inactive
                            },
                            value: tab.id,
                            onClick: function() {
                                if ((tab === null || tab === void 0 ? void 0 : tab.link) === "https://tracuu.thuocsi.vn") {
                                    gtag.clickTrackingOrder();
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsx(ListItemIcon, {
                                    children: tab.icon
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "inherit",
                                    children: tab.label
                                })
                            ]
                        })
                    }, "tab-".concat(uuidv4()));
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_InfoTabs = ((/* unused pure expression or super */ null && (InfoTabs)));

// EXTERNAL MODULE: ./src/components/mocules/IngredientList/index.js
var IngredientList = __webpack_require__(28222);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js
var Accordion_Accordion = __webpack_require__(36939);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails_AccordionDetails = __webpack_require__(61201);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary_AccordionSummary = __webpack_require__(50743);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField_TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./src/components/mocules/InvoiceCheckout/styles.module.css
var InvoiceCheckout_styles_module = __webpack_require__(91066);
var InvoiceCheckout_styles_module_default = /*#__PURE__*/__webpack_require__.n(InvoiceCheckout_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/InvoiceCheckout/index.js
/* eslint-disable react/jsx-wrap-multilines */ 























var DEFAULT_INVOICE_INFO = {
    companyName: "",
    companyAddress: "",
    taxCode: ""
};
var invoiceInfoOtherID = (0,v4/* default */.Z)();
var InvoiceCheckout = function(param) {
    var _invoiceInfoList = param.invoiceInfoList, invoiceInfoList = _invoiceInfoList === void 0 ? [] : _invoiceInfoList, handleChangeInvoice = param.handleChangeInvoice, handleSetAllInvoice = param.handleSetAllInvoice, _invoice = param.invoice, invoice = _invoice === void 0 ? {} : _invoice, translateCheckout = param.translateCheckout;
    var ref = invoice || {}, _invoiceRequest = ref.invoiceRequest, invoiceRequest = _invoiceRequest === void 0 ? true : _invoiceRequest, _companyAddress = ref.companyAddress, companyAddress = _companyAddress === void 0 ? "" : _companyAddress, _companyName = ref.companyName, companyName = _companyName === void 0 ? "" : _companyName, _mst = ref.mst, mst = _mst === void 0 ? "" : _mst, _taxCode = ref.taxCode, taxCode = _taxCode === void 0 ? "" : _taxCode;
    var ref1 = (0,react.useState)(invoiceRequest), expanded = ref1[0], setExpanded = ref1[1];
    var invoiceInfoDefault = invoiceInfoList && invoiceInfoList[0] && invoiceInfoList[0].code || invoiceInfoOtherID;
    // find invoice select by compare all data
    var invoiceInfo = invoiceInfoList.find(function(item) {
        return item.companyAddress === companyAddress && item.companyName === companyName && (mst || taxCode) === item.taxCode;
    });
    if (invoiceInfo && invoiceInfo.code) {
        invoiceInfoDefault = invoiceInfo.code;
    } else if (companyAddress && companyName && (mst || taxCode)) {
        invoiceInfoDefault = invoiceInfoOtherID;
    }
    var ref2 = (0,react.useState)(invoiceInfoDefault), invoiceInfoSelected = ref2[0], setInvoiceInfoSelected = ref2[1];
    var isInvoiceInfoOther = invoiceInfoSelected === invoiceInfoOtherID;
    var ref3 = (0,react.useState)((0,src_object_spread/* default */.Z)({}, DEFAULT_INVOICE_INFO, invoice)), form = ref3[0], setForm = ref3[1];
    var handleExpand = function() {
        setExpanded(!expanded);
        if (expanded) {
            handleSetAllInvoice((0,src_object_spread/* default */.Z)({
                invoiceRequest: false
            }, DEFAULT_INVOICE_INFO));
        } else if (isInvoiceInfoOther) {
            handleSetAllInvoice((0,src_object_spread/* default */.Z)({
                invoiceRequest: true
            }, DEFAULT_INVOICE_INFO));
        } else {
            var info = invoiceInfoList.find(function(item) {
                return item.code === invoiceInfoDefault;
            });
            handleSetAllInvoice((0,src_object_spread/* default */.Z)({
                invoiceRequest: true
            }, info));
        }
    };
    var handleChangeForm = function(key, value) {
        setForm((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, form), (0,src_define_property/* default */.Z)({}, key, value.trim())));
        handleChangeInvoice(key, value.trim());
    };
    var handleChangeInvoiceInfoSelected = function(e) {
        var _target = e.target, _value = _target.value, value = _value === void 0 ? invoiceInfoOtherID : _value;
        setInvoiceInfoSelected(value);
        if (value !== invoiceInfoOtherID) {
            var info = invoiceInfoList.find(function(item) {
                return item.code === value;
            });
            handleSetAllInvoice((0,src_object_spread/* default */.Z)({
                invoiceRequest: true
            }, info));
        } else {
            handleSetAllInvoice((0,src_object_spread/* default */.Z)({
                invoiceRequest: true,
                isUseCustom: true
            }, DEFAULT_INVOICE_INFO));
        }
    };
    // {} === {} -> false || new Set array like obj with JSON.
    var uniqueInvoiceList = (0,src_to_consumable_array/* default */.Z)(new Set(invoiceInfoList === null || invoiceInfoList === void 0 ? void 0 : invoiceInfoList.map(JSON.stringify))).map(JSON.parse);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper_Paper/* default */.Z, {
        elevation: 4,
        className: (InvoiceCheckout_styles_module_default()).paperroot,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion_Accordion/* default */.Z, {
            expanded: expanded,
            className: (InvoiceCheckout_styles_module_default()).root,
            elevation: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary_AccordionSummary/* default */.Z, {
                    "aria-controls": "panel1a-content",
                    id: "panel1a-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                classes: {
                                    root: (InvoiceCheckout_styles_module_default()).checkbox
                                },
                                checked: expanded,
                                onChange: handleExpand,
                                "data-test": "checkbox-checkout-invoice"
                            }),
                            label: translateCheckout("export_invoice_info")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails_AccordionDetails/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        container: true,
                        "data-test": "list-invoice-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup_RadioGroup/* default */.Z, {
                                    "aria-label": "gender",
                                    name: "gender1",
                                    value: invoiceInfoSelected,
                                    onChange: handleChangeInvoiceInfoSelected,
                                    children: [
                                        uniqueInvoiceList.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                                                    name: "checkedC",
                                                    classes: {
                                                        root: (InvoiceCheckout_styles_module_default()).checkbox
                                                    },
                                                    value: item.code
                                                }),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                            children: [
                                                                " ",
                                                                item.companyName
                                                            ]
                                                        }),
                                                        " - ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                " ",
                                                                item.taxCode,
                                                                " "
                                                            ]
                                                        }),
                                                        " (",
                                                        item.companyAddress,
                                                        ")"
                                                    ]
                                                })
                                            }, item.code);
                                        }),
                                        (!invoiceInfoList || invoiceInfoList.length < 10) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                                                name: "checkedC",
                                                value: invoiceInfoOtherID,
                                                classes: {
                                                    root: (InvoiceCheckout_styles_module_default()).checkbox
                                                }
                                            }),
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: translateCheckout("other")
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            isInvoiceInfoOther && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        isRequired: true,
                                        label: translateCheckout("company_name"),
                                        htmlFor: "companyName",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "companyName",
                                            placeholder: translateCheckout("at_least_2_character"),
                                            onBlur: function(e) {
                                                return handleChangeForm("companyName", e.target.value);
                                            },
                                            defaultValue: companyName
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        isRequired: true,
                                        label: translateCheckout("tax_code"),
                                        htmlFor: "taxCode",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "taxCode",
                                            placeholder: translateCheckout("tax_code"),
                                            onBlur: function(e) {
                                                return handleChangeForm("taxCode", e.target.value);
                                            },
                                            defaultValue: mst || taxCode
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        isRequired: true,
                                        label: translateCheckout("address2"),
                                        htmlFor: "address",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
                                            id: "address",
                                            type: "text",
                                            multiline: true,
                                            name: "address",
                                            variant: "outlined",
                                            "aria-label": "Địa chỉ",
                                            placeholder: translateCheckout("address_placeholder"),
                                            minRows: 4,
                                            style: {
                                                marginTop: "15px"
                                            },
                                            defaultValue: companyAddress,
                                            onBlur: function(e) {
                                                return handleChangeForm("companyAddress", e.target.value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (InvoiceCheckout_styles_module_default()).helper_text,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                            className: (InvoiceCheckout_styles_module_default()).text_muted,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es.FontAwesomeIcon, {
                                                    icon: free_solid_svg_icons_index_es.faInfoCircle,
                                                    className: (InvoiceCheckout_styles_module_default()).icon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (InvoiceCheckout_styles_module_default()).fw500,
                                                    children: [
                                                        translateCheckout("notice"),
                                                        ": "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (InvoiceCheckout_styles_module_default()).notifi_list,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: translateCheckout("fill_correct_invoice_info")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: translateCheckout("export_invoice_text").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            !isInvoiceInfoOther && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InvoiceCheckout_styles_module_default()).helper_text,
                                style: {
                                    marginTop: 10
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                    className: (InvoiceCheckout_styles_module_default()).text_muted,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es.FontAwesomeIcon, {
                                            icon: free_solid_svg_icons_index_es.faInfoCircle,
                                            className: (InvoiceCheckout_styles_module_default()).icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (InvoiceCheckout_styles_module_default()).fw500,
                                            children: [
                                                translateCheckout("fill_correct_invoice_info"),
                                                ":",
                                                " ",
                                                translateCheckout("export_invoice_text").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_InvoiceCheckout = (InvoiceCheckout);

// EXTERNAL MODULE: ./src/components/mocules/InvoiceInfoDeleteModal/index.js
var InvoiceInfoDeleteModal = __webpack_require__(87895);
;// CONCATENATED MODULE: ./src/components/mocules/InvoiceInfoCard/index.js
















var InvoiceInfoCard_CardComp = function(param) {
    var invoiceInfo = param.invoiceInfo, handleReloadData = param.handleReloadData, handleEdit = param.handleEdit;
    var _companyName = invoiceInfo.companyName, companyName = _companyName === void 0 ? "" : _companyName, _companyAddress = invoiceInfo.companyAddress, companyAddress = _companyAddress === void 0 ? "" : _companyAddress, _taxCode = invoiceInfo.taxCode, taxCode = _taxCode === void 0 ? "" : _taxCode, code = invoiceInfo.code;
    var ref = _sliced_to_array(useModal(), 2), open = ref[0], toggle = ref[1];
    var handleDelete = function() {
        var _ref = _async_to_generator(function() {
            var result, _tmp, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            CustomerClient.deleteInvoiceInfo((_tmp.code = code, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!isValidWithoutData(result)) throw Error((result === null || result === void 0 ? void 0 : result.errorCode) === "INVOICE_NOT_FOUND" ? "Kh\xf4ng t\xecm thấy th\xf4ng tin xuất h\xf3a đơn" : "X\xf3a th\xf4ng tin kh\xf4ng th\xe0nh c\xf4ng");
                        NotifyUtils.success("Xo\xe1 th\xf4ng tin th\xe0nh c\xf4ng");
                        handleReloadData();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        NotifyUtils.error(error.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(Grid, {
        item: true,
        xs: 12,
        md: 6,
        children: [
            /*#__PURE__*/ _jsxs(Card, {
                className: styles.card,
                children: [
                    /*#__PURE__*/ _jsx(CardHeader, {}),
                    /*#__PURE__*/ _jsx(CardContent, {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.float_bottom,
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.ellipsis_2_line,
                                        children: [
                                            /*#__PURE__*/ _jsx("b", {
                                                children: " T\xean c\xf4ng ty: "
                                            }),
                                            " ",
                                            companyName
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.ellipsis_2_line,
                                        children: [
                                            /*#__PURE__*/ _jsx("b", {
                                                children: " M\xe3 số thuế: "
                                            }),
                                            " ",
                                            taxCode
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.ellipsis_2_line,
                                        children: [
                                            /*#__PURE__*/ _jsx("b", {
                                                children: " Địa chỉ c\xf4ng ty: "
                                            }),
                                            " ",
                                            companyAddress
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.group_button,
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                variant: "outlined",
                                                className: clsx(styles.action_button, styles.important_action_button),
                                                onClick: function() {
                                                    return handleEdit(invoiceInfo);
                                                },
                                                children: "Sửa"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                variant: "outlined",
                                                className: styles.action_button,
                                                onClick: toggle,
                                                children: "Xo\xe1"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DeleteInvoiceInfoModal, {
                visible: open,
                onClose: toggle,
                onClickOk: handleDelete
            })
        ]
    });
};
/* harmony default export */ var mocules_InvoiceInfoCard = ((/* unused pure expression or super */ null && (InvoiceInfoCard_CardComp)));

// EXTERNAL MODULE: ./src/styles/index.js
var src_styles = __webpack_require__(71637);
;// CONCATENATED MODULE: ./src/components/mocules/InvoiceInfoModal/index.js























var InvoiceInfoModal_InvoiceInfoModal = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(props) {
    var ref = useTranslation("alert-action"), translateAlertAction = ref.t;
    var onClose = props.onClose, visible = props.visible, _invoiceInfo = props.invoiceInfo, invoiceInfo = _invoiceInfo === void 0 ? {} : _invoiceInfo, handleReloadData = props.handleReloadData;
    var ref1 = useState(invoiceInfo), val = ref1[0], setVal = ref1[1];
    var isEdit = invoiceInfo.code;
    var handleChangeValue = function(key, value) {
        setVal(_object_spread_props(_object_spread({}, val), _define_property({}, key, value)));
    };
    useEffect(function() {
        setVal(invoiceInfo);
    }, [
        invoiceInfo
    ]);
    var handleSubmit = function() {
        var _ref = _async_to_generator(function() {
            var formData, result, _tmp, _tmp1, result1, _tmp2, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        formData = val;
                        Object.keys(formData).forEach(function(key) {
                            if (typeof formData[key] === "string") {
                                formData[key] = formData[key].trim();
                            }
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        validateForm(formData);
                        if (!isEdit) return [
                            3,
                            3
                        ];
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            CustomerClient.updateInvoiceInfo(_object_spread_props(_object_spread(_tmp, formData), (_tmp1.code = invoiceInfo.code, _tmp1)))
                        ];
                    case 2:
                        result = _state.sent();
                        if (!isValidWithoutData(result)) throw Error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_edit_info_fail"));
                        NotifyUtils.success(translateAlertAction("message_update_info"));
                        return [
                            3,
                            5
                        ];
                    case 3:
                        _tmp2 = {};
                        return [
                            4,
                            CustomerClient.createInvoiceInfo((_tmp2.body = formData, _tmp2))
                        ];
                    case 4:
                        result1 = _state.sent();
                        if (!isValidWithoutData(result1)) throw Error((result1 === null || result1 === void 0 ? void 0 : result1.message) || translateAlertAction("message_failed_create_new_info"));
                        NotifyUtils.success(translateAlertAction("message_create_new_info"));
                        _state.label = 5;
                    case 5:
                        onClose();
                        handleReloadData();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        NotifyUtils.error(translateAlertAction(error.message));
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx("div", {
        className: styles.address_dialog,
        children: /*#__PURE__*/ _jsxs(Dialog, {
            onClose: onClose,
            "aria-labelledby": "customized-dialog-title",
            open: visible,
            className: styles.address_dialog,
            children: [
                /*#__PURE__*/ _jsxs(DialogTitle, {
                    id: "customized-dialog-title",
                    onClose: onClose,
                    style: {
                        width: "100%",
                        color: APP_STYLES.COLORS.GREEN
                    },
                    children: [
                        isEdit ? "Chỉnh sửa th\xf4ng tin xuất ho\xe1 đơn" : "Th\xeam th\xf4ng tin xuất ho\xe1 đơn",
                        /*#__PURE__*/ _jsx(IconButton, {
                            "aria-label": "close",
                            className: styles.close_button,
                            onClick: onClose,
                            children: /*#__PURE__*/ _jsx(CloseIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DialogContent, {
                    dividers: true,
                    children: /*#__PURE__*/ _jsx(Grid, {
                        container: true,
                        direction: "row",
                        children: /*#__PURE__*/ _jsxs(Grid, {
                            container: true,
                            direction: "row",
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ _jsx(InfoFormControl, {
                                    xs: 12,
                                    label: "T\xean c\xf4ng ty/Nh\xe0 thuốc/Quầy thuốc",
                                    htmlFor: "companyName",
                                    isRequired: true,
                                    children: /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "companyName",
                                        value: (val === null || val === void 0 ? void 0 : val.companyName) || "",
                                        onChange: function(e) {
                                            return handleChangeValue("companyName", e.target.value);
                                        },
                                        placeholder: "Nhập t\xean c\xf4ng ty"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(InfoFormControl, {
                                    xs: 12,
                                    label: "M\xe3 số thuế",
                                    htmlFor: "taxCode",
                                    isRequired: true,
                                    children: /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "taxCode",
                                        value: (val === null || val === void 0 ? void 0 : val.taxCode) || "",
                                        onChange: function(e) {
                                            return handleChangeValue("taxCode", e.target.value);
                                        },
                                        placeholder: "Nhập m\xe3 số thuế"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(InfoFormControl, {
                                    xs: 12,
                                    label: "Địa chỉ c\xf4ng ty",
                                    htmlFor: "companyAddress",
                                    isRequired: true,
                                    children: /*#__PURE__*/ _jsx(TextField, {
                                        id: "companyAddress",
                                        type: "text",
                                        multiline: true,
                                        name: "companyAddress",
                                        variant: "outlined",
                                        "aria-label": "Địa chỉ",
                                        placeholder: "Nhập địa chỉ c\xf4ng ty (bao gồm Phường/X\xe3, Quận/Huyện, Tỉnh/Th\xe0nh phố nếu c\xf3)",
                                        rows: 5,
                                        style: {
                                            marginTop: "15px"
                                        },
                                        onChange: function(e) {
                                            return handleChangeValue("companyAddress", e.target.value);
                                        },
                                        value: (val === null || val === void 0 ? void 0 : val.companyAddress) || ""
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(DialogActions, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        autoFocus: true,
                        color: "primary",
                        variant: "contained",
                        className: "my-order__button--secondary",
                        style: {
                            borderRadius: "30px",
                            padding: "5px 40px"
                        },
                        onClick: handleSubmit,
                        children: isEdit ? "Sửa" : "Th\xeam"
                    })
                })
            ]
        })
    });
})));
/* harmony default export */ var mocules_InvoiceInfoModal = ((/* unused pure expression or super */ null && (InvoiceInfoModal_InvoiceInfoModal)));

;// CONCATENATED MODULE: ./src/components/mocules/InvoiceInfoCardList/index.js













var InvoiceInfoCardList_InvoiceInfoCardList = function(param) {
    var _invoiceInfos = param.invoiceInfos, invoiceInfos = _invoiceInfos === void 0 ? [] : _invoiceInfos, handleReloadData = param.handleReloadData;
    var ref = _sliced_to_array(useModal(), 2), openAddressModal = ref[0], toggleAddressModal = ref[1];
    var invoiceInfo = useRef({
        companyName: "",
        companyAddress: "",
        taxCode: ""
    });
    var handleEdit = function(info) {
        invoiceInfo.current = info;
        toggleAddressModal();
        handleReloadData();
    };
    var handleNew = function() {
        invoiceInfo.current = {
            companyName: "",
            companyAddress: "",
            taxCode: ""
        };
        toggleAddressModal();
        handleReloadData();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                spacing: 2,
                children: [
                    invoiceInfos.map(function(info) {
                        return /*#__PURE__*/ _jsx(InvoiceInfoCard, {
                            invoiceInfo: info,
                            handleReloadData: handleReloadData,
                            handleEdit: handleEdit
                        }, uuidv4());
                    }),
                    invoiceInfos.length < 10 && /*#__PURE__*/ _jsx(Grid, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ _jsx(Card, {
                            className: styles.card,
                            onClick: handleNew,
                            children: /*#__PURE__*/ _jsx(CardContent, {
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: styles.add_icon_column,
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: styles.add_icon_row,
                                        children: [
                                            /*#__PURE__*/ _jsx(IconButton, {
                                                children: /*#__PURE__*/ _jsx(AddCircleIcon, {
                                                    size: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("b", {
                                                children: "Th\xeam th\xf4ng tin xuất ho\xe1 đơn "
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(InvoiceInfoModal, {
                visible: openAddressModal,
                onClose: toggleAddressModal,
                invoiceInfo: invoiceInfo.current,
                handleReloadData: handleReloadData
            })
        ]
    });
};
/* harmony default export */ var mocules_InvoiceInfoCardList = ((/* unused pure expression or super */ null && (InvoiceInfoCardList_InvoiceInfoCardList)));

;// CONCATENATED MODULE: ./src/components/mocules/InvoiceInfoForm/index.js








var InvoiceInfoForm = function() {
    var ref = useState([]), invoiceInfos = ref[0], setInvoiceInfos = ref[1];
    var loadData = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var invoiceInfoList, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        CustomerClient.getListInvoiceInfo(_tmp)
                    ];
                case 1:
                    invoiceInfoList = _state.sent();
                    setInvoiceInfos(getData(invoiceInfoList));
                    return [
                        2
                    ];
            }
        });
    }), []);
    useEffect(function() {
        loadData();
    }, []);
    return /*#__PURE__*/ _jsxs(Paper, {
        className: styles.root,
        elevation: 4,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles.title,
                children: " Danh s\xe1ch th\xf4ng tin xuất ho\xe1 đơn"
            }),
            /*#__PURE__*/ _jsx(InvoiceInfoCardList, {
                invoiceInfos: invoiceInfos,
                handleReloadData: loadData
            })
        ]
    });
};
/* harmony default export */ var mocules_InvoiceInfoForm = ((/* unused pure expression or super */ null && (InvoiceInfoForm)));

// EXTERNAL MODULE: ./src/components/mocules/ManufacturerList/index.js
var ManufacturerList = __webpack_require__(38319);
// EXTERNAL MODULE: ./src/hooks/useMultiImageBox.js
var hooks_useMultiImageBox = __webpack_require__(66621);
// EXTERNAL MODULE: ./src/hooks/useToggle.js
var hooks_useToggle = __webpack_require__(53376);
;// CONCATENATED MODULE: ./src/components/mocules/MultiImageBox/index.js


















var MultiImageBox = function(param) {
    var loading = param.loading, _images = param.images, images = _images === void 0 ? null : _images, _title = param.title, title = _title === void 0 ? "" : _title;
    var ref = useMultiImageBox({
        images: images
    }), selectedImage = ref.selectedImage, handleKeyDown = ref.handleKeyDown, handleImageSelection = ref.handleImageSelection;
    var ref1 = useToggle(), open = ref1.open, handleOpen = ref1.handleOpen, handleClose = ref1.handleClose;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                direction: "row",
                justifyContent: "flex-start",
                classes: {
                    root: styles.container
                },
                children: [
                    /*#__PURE__*/ _jsx(Grid, {
                        item: true,
                        xs: 12,
                        style: {
                            flex: "80%"
                        },
                        children: loading ? /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rect",
                            classes: {
                                root: styles.imageMain
                            }
                        }) : /*#__PURE__*/ _jsx(_Fragment, {
                            children: images && images.length > 0 ? /*#__PURE__*/ _jsx(ButtonBase, {
                                classes: {
                                    root: styles.imgButtonBase
                                },
                                onClick: handleOpen,
                                children: /*#__PURE__*/ _jsx(ImageFallbackProductImage, {
                                    width: 227,
                                    height: 143,
                                    alt: title,
                                    fallbackSrc: images[selectedImage],
                                    className: styles.imageMain,
                                    src: "".concat(images[selectedImage]),
                                    quality: 100
                                })
                            }) : /*#__PURE__*/ _jsx(Image, {
                                width: 227,
                                height: 227,
                                alt: "Image Not Found",
                                loader: myLoader,
                                className: styles.imageNotFound,
                                src: MISSING_IMAGE
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Grid, {
                        children: images && images.map(function(src, index) {
                            return /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                spacing: 1,
                                container: true,
                                direction: "column",
                                classes: {
                                    root: styles.thumbnail
                                },
                                alignItems: "flex-start",
                                alignContent: "flex-start",
                                children: /*#__PURE__*/ _jsx(Grid, {
                                    item: true,
                                    children: loading ? /*#__PURE__*/ _jsx(Skeleton, {
                                        variant: "rect",
                                        classes: {
                                            root: styles.thumbnailImage
                                        }
                                    }) : /*#__PURE__*/ _jsx(ButtonBase, {
                                        classes: {
                                            root: styles.imgButtonBase
                                        },
                                        onClick: function() {
                                            return index !== selectedImage && handleImageSelection(index);
                                        },
                                        children: /*#__PURE__*/ _jsx(ImageFallbackProductImage, {
                                            width: 70,
                                            height: 70,
                                            alt: title,
                                            className: clsx(styles.thumbnailImage, _define_property({}, styles.thumbnailSelected, index === selectedImage)),
                                            src: "".concat(src),
                                            fallbackSrc: src,
                                            quality: 100
                                        })
                                    })
                                }, uuidv4())
                            }, uuidv4());
                        })
                    })
                ]
            }),
            images && /*#__PURE__*/ _jsx(Modal, {
                open: open,
                onClose: handleClose,
                hideBackdrop: true,
                "aria-labelledby": "image-gallery-title",
                "aria-describedby": "image-gallery-description",
                children: /*#__PURE__*/ _jsx(Backdrop, {
                    className: styles.modalBackdrop,
                    open: open,
                    onClick: handleClose,
                    onKeyDown: handleKeyDown,
                    children: /*#__PURE__*/ _jsx(Grid, {
                        container: true,
                        alignItems: "center",
                        justifyContent: "center",
                        direction: "row",
                        children: /*#__PURE__*/ _jsx("img", {
                            alt: title,
                            // layout="fill"
                            className: styles.modalImage,
                            src: getLinkGCS(images[selectedImage])
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_MultiImageBox = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(MultiImageBox))));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase_ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip_Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./src/components-v2/mocules/PopupMultilImage/index.tsx
var PopupMultilImage = __webpack_require__(53371);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/components/mocules/MultiImageBoxV2/styles.module.css
var MultiImageBoxV2_styles_module = __webpack_require__(73330);
var MultiImageBoxV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(MultiImageBoxV2_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/MultiImageBoxV2/index.js






















var MultiImageBoxV2 = function(param) {
    var loading = param.loading, _images = param.images, images = _images === void 0 ? null : _images, _title = param.title, title = _title === void 0 ? "" : _title, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _imageName = param.imageName, imageName = _imageName === void 0 ? "" : _imageName, translateProductDetail = param.translateProductDetail, nameLabel = param.nameLabel, product = param.product, link = param.link;
    var ref = (0,hooks_useMultiImageBox/* default */.Z)({
        images: images
    }), selectedImage = ref.selectedImage, handleHoverImage = ref.handleHoverImage, handleImageSelection = ref.handleImageSelection, handlePrevious = ref.handlePrevious, handleNext = ref.handleNext;
    var ref1 = (0,hooks_useToggle/* default */.Z)(), open = ref1.open, handleOpen = ref1.handleOpen, handleClose = ref1.handleClose;
    var ref2 = (0,react.useState)(null), mainImg = ref2[0], setMainImg = ref2[1];
    var handleOpenImageModal = function() {
        setMainImg(images[selectedImage]);
        handleOpen();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MultiImageBoxV2_styles_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MultiImageBoxV2_styles_module_default()).wrapperImg,
                        children: [
                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rect",
                                classes: {
                                    root: (MultiImageBoxV2_styles_module_default()).imageMain
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: images && images.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase_ButtonBase/* default */.Z, {
                                    onClick: handleOpenImageModal,
                                    className: "openImg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                        width: 295,
                                        height: 295,
                                        alt: title,
                                        fallbackSrc: (0,ImageUtils/* getLinkProxyCDNFallback */.F4)(images[selectedImage]),
                                        className: (MultiImageBoxV2_styles_module_default()).imageMain,
                                        src: "".concat(open ? mainImg : images[selectedImage]),
                                        quality: 100
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 295,
                                    height: 295,
                                    alt: "Image Not Found",
                                    loader: utils/* myLoader */.tQ,
                                    className: (MultiImageBoxV2_styles_module_default()).imageNotFound,
                                    src: Images/* MISSING_IMAGE */.g_W
                                })
                            }),
                            nameLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_Chip/* default */.Z, {
                                label: nameLabel,
                                className: (MultiImageBoxV2_styles_module_default()).product_tag
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        className: (MultiImageBoxV2_styles_module_default()).slider
                    }, data/* settingsMultiImageBoxV2 */.bZ), {
                        children: images && images.map(function(src, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MultiImageBoxV2_styles_module_default()).thumbnail,
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rect",
                                    classes: {
                                        root: (MultiImageBoxV2_styles_module_default()).thumbnailImage
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase_ButtonBase/* default */.Z, {
                                    onClick: handleOpenImageModal,
                                    onMouseOver: function() {
                                        return handleHoverImage(index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                        width: 60,
                                        height: 60,
                                        alt: title,
                                        className: (0,clsx_m/* default */.Z)((MultiImageBoxV2_styles_module_default()).thumbnailImage, (0,src_define_property/* default */.Z)({}, (MultiImageBoxV2_styles_module_default()).thumbnailSelected, index === selectedImage)),
                                        src: "".concat(src),
                                        fallbackSrc: (0,ImageUtils/* getLinkProxyCDNFallback */.F4)(src),
                                        quality: 100
                                    })
                                })
                            }, (0,v4/* default */.Z)());
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        className: (MultiImageBoxV2_styles_module_default()).descImg,
                        children: [
                            "* ",
                            translateProductDetail("images_may_change_overtime")
                        ]
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupMultilImage/* default */.Z, {
                isMobile: isMobile,
                images: images,
                open: open,
                handleClose: handleClose,
                imageName: imageName,
                selectedImage: selectedImage,
                handleClickImage: handleImageSelection,
                handlePrevious: handlePrevious,
                handleNext: handleNext
            })
        ]
    });
};
/* harmony default export */ var mocules_MultiImageBoxV2 = (MultiImageBoxV2);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CloseOutlined.js
var CloseOutlined = __webpack_require__(31863);
// EXTERNAL MODULE: ./src/components/mocules/NewAuthModal/styles.module.css
var NewAuthModal_styles_module = __webpack_require__(99148);
var NewAuthModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewAuthModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewAuthModal/index.js









var NewAuthModal = /*#__PURE__*/ react.memo(function(props) {
    var width = props.width, onClose = props.onClose, visible = props.visible, children = props.children, title = props.title, className = props.className, restProps = props.restProps, height = props.height, _isShowCloseBtn = props.isShowCloseBtn, isShowCloseBtn = _isShowCloseBtn === void 0 ? true : _isShowCloseBtn;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (NewAuthModal_styles_module_default()).auth_modal_content,
            style: {
                width: "".concat(width),
                height: "".concat(height)
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    container: true,
                    className: (NewAuthModal_styles_module_default()).auth_modal_header,
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: isShowCloseBtn ? 10 : 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                "data-test": "modal-title",
                                className: (NewAuthModal_styles_module_default()).auth_modal_title,
                                children: title
                            })
                        }),
                        isShowCloseBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                "data-test": "signup-close",
                                "aria-label": "close",
                                className: (NewAuthModal_styles_module_default()).auth_modal_close,
                                onClick: onClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NewAuthModal_styles_module_default()).auth_modal_body,
                    children: children
                })
            ]
        })
    }));
});
/* harmony default export */ var mocules_NewAuthModal = (NewAuthModal);

;// CONCATENATED MODULE: ./src/components/mocules/NewBadge/index.js



var NewBadge_NewBadge = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs(Badge, {
        className: "badge--new badge",
        children: [
            " ",
            children,
            " "
        ]
    });
};
/* harmony default export */ var mocules_NewBadge = ((/* unused pure expression or super */ null && (NewBadge_NewBadge)));

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LockOutlined.js
var LockOutlined = __webpack_require__(62267);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Visibility.js
var Visibility = __webpack_require__(20067);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOff.js
var VisibilityOff = __webpack_require__(28270);
// EXTERNAL MODULE: ./src/components/mocules/NewChangePasswordForm/styles.module.css
var NewChangePasswordForm_styles_module = __webpack_require__(6911);
var NewChangePasswordForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewChangePasswordForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewChangePasswordForm/index.js












var NewChangePasswordForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickNewPasswordForm = param.onClickNewPasswordForm, step = param.step, toggleModalAndSignout = param.toggleModalAndSignout, translatePopupAction = param.translatePopupAction;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var ref1 = (0,react.useState)(false), errorPw = ref1[0], setErrorPw = ref1[1];
    var ref2 = (0,react.useState)(""), errorPwMessage = ref2[0], setErrorPwMessage = ref2[1];
    var ref3 = (0,react.useState)(false), errorNewPassword = ref3[0], setErrorNewPassword = ref3[1];
    var ref4 = (0,react.useState)(""), errorNewPasswordMessage = ref4[0], setErrorNewPasswordMessage = ref4[1];
    var ref5 = (0,react.useState)(""), currentPassword = ref5[0], setCurrentPassword = ref5[1];
    var ref6 = (0,react.useState)(""), newPassword = ref6[0], setNewPassword = ref6[1];
    // handle validate
    var validatePw = function(data) {
        setErrorPw(false);
        if (data === "") {
            setErrorPw(true);
            setErrorPwMessage(translatePopupAction("popup-validateUntil.not_entered_your_password"));
            return false;
        }
        if (data.length > 50) {
            setErrorPw(true);
            setErrorPwMessage(translatePopupAction("popup-validateUntil.password_too_long"));
            return false;
        }
        // if (!data.match(regExpPw)) {
        //   setErrorPw(true);
        //   setErrorPwMessage(
        //     'Mật khẩu phải ít nhất 8 ký tự và không quá 20 ký tự. Có chứa ít nhất 1 chữ thường, 1 chữ hoa, và 1 số',
        //   );
        //   return false;
        // }
        return true;
    };
    var validateNewPassword = function(data, oldPassword) {
        setErrorNewPassword(false);
        if (data === "") {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage(translatePopupAction("popup-validateUntil.you_have_not_entered_a_new_password"));
            return false;
        }
        if (data.length > 30 || data.length < 8) {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage(translatePopupAction("popup-validateUntil.password_minimum_maximum_characters"));
            return false;
        }
        if (oldPassword === data) {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage("");
            // setErrorNewPasswordMessage('Mật khẩu mới không được trùng với mật khẩu gần nhất.');
            utils/* NotifyUtils.error */.QP.error(translatePopupAction("popup-validateUntil.new_password_not_same_latest_password"));
            return false;
        }
        return true;
    };
    // handle submit form
    var onSubmitNewPasswordForm = function() {
        var data = {
            password: currentPassword,
            newPassword: newPassword
        };
        if (!validateNewPassword(data.newPassword, currentPassword)) {
            return;
        }
        onClickNewPasswordForm(data);
    };
    // handle input
    var handleOnChangePw = function(e) {
        e.preventDefault();
        validatePw(e.target.value);
        setCurrentPassword(e.target.value);
    };
    var handleOnChangeNewPassword = function(e) {
        e.preventDefault();
        validateNewPassword(e.target.value);
        setNewPassword(e.target.value);
    };
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewChangePasswordForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        className: (NewChangePasswordForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (NewChangePasswordForm_styles_module_default()).forget_password,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "".concat((NewChangePasswordForm_styles_module_default()).form_forget_password, " ").concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                            fullWidth: true,
                            className: (NewChangePasswordForm_styles_module_default()).form_control,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    placeholder: translatePopupAction("popup-validateUntil.please_enter_your_current_password"),
                                    variant: "outlined",
                                    className: (NewChangePasswordForm_styles_module_default()).input,
                                    error: errorPw,
                                    onChange: handleOnChangePw
                                }),
                                errorPw && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewChangePasswordForm_styles_module_default()).error,
                                    children: errorPwMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                            fullWidth: true,
                            className: (NewChangePasswordForm_styles_module_default()).form_control,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "newPassword",
                                    name: "newPassword",
                                    type: showPassword ? "text" : "password",
                                    startAdornment: IconPassword,
                                    endAdornment: IconEndPassword,
                                    placeholder: translatePopupAction("popup-validateUntil.please_enter_a_new_password"),
                                    variant: "outlined",
                                    error: errorNewPassword,
                                    className: (NewChangePasswordForm_styles_module_default()).input,
                                    onChange: handleOnChangeNewPassword
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewChangePasswordForm_styles_module_default()).error,
                                    children: errorNewPassword && errorNewPasswordMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NewChangePasswordForm_styles_module_default()).center,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                className: (NewChangePasswordForm_styles_module_default()).btn,
                                onClick: onSubmitNewPasswordForm,
                                children: translatePopupAction("change-password.send")
                            })
                        })
                    ]
                })
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewChangePasswordForm_styles_module_default()).confirm_modal_wrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NewChangePasswordForm_styles_module_default()).center,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewChangePasswordForm_styles_module_default()).warning_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (NewChangePasswordForm_styles_module_default()).text_icon,
                                        children: "✓"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    className: (NewChangePasswordForm_styles_module_default()).modal_title,
                                    children: [
                                        " ",
                                        translatePopupAction("change-password.success")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (NewChangePasswordForm_styles_module_default()).modal_title,
                                    children: translatePopupAction("change-password.re-login-finish")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewChangePasswordForm_styles_module_default()).center,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            className: (NewChangePasswordForm_styles_module_default()).btn,
                            onClick: toggleModalAndSignout,
                            children: translatePopupAction("change-password.login")
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var mocules_NewChangePasswordForm = (NewChangePasswordForm);

// EXTERNAL MODULE: ./src/components/mocules/UploadFiles/index.js
var mocules_UploadFiles = __webpack_require__(75932);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/components/mocules/NewFeedbackForm/index.js















function NewFeedbackForm(param) {
    var className = param.className, _fileList = param.fileList, fileList = _fileList === void 0 ? [] : _fileList, handleSetValue = param.handleSetValue;
    var schema = yup.object().shape({
        reasonFeedback: yup.string().required("L\xfd do kh\xf4ng được để trống"),
        username: yup.string().required("L\xfd do kh\xf4ng được để trống")
    });
    var ref = useForm({
        resolver: yupResolver(schema)
    }), errors = ref.formState.errors, control = ref.control, handleSubmit = ref.handleSubmit;
    var onSubmit = function(data) {
        return console.log(data);
    };
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(className, styles.form_sign_up),
        children: /*#__PURE__*/ _jsxs("form", {
            className: className,
            onSubmit: handleSubmit(function(d) {
                return console.log(d);
            }),
            children: [
                /*#__PURE__*/ _jsx(Controller, {
                    name: "reasonFeedback",
                    defaultValue: "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        var ref;
                        /*#__PURE__*/ return _jsxs(FormControl, {
                            variant: "filled",
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ _jsx(InputV2, _object_spread_props(_object_spread({
                                    className: styles.input,
                                    label: "L\xfd do phản hồi",
                                    select: true,
                                    required: true,
                                    error: !!errors.reasonFeedback
                                }, field), {
                                    children: LIST_REASONS.map(function(param) {
                                        var code = param.code, name = param.name;
                                        return /*#__PURE__*/ _jsx(MenuItem, {
                                            value: code,
                                            children: name
                                        }, code);
                                    })
                                })),
                                errors.reasonFeedback && /*#__PURE__*/ _jsxs("div", {
                                    className: styles.textError,
                                    "data-test": "reason-feedback",
                                    children: [
                                        /*#__PURE__*/ _jsx(ErrorIconOutlined, {
                                            className: styles.iconError
                                        }),
                                        " ",
                                        (ref = errors.reasonFeedback) === null || ref === void 0 ? void 0 : ref.message
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    name: "username",
                    defaultValue: "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        var ref;
                        /*#__PURE__*/ return _jsxs(FormControl, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ _jsx(InputV2, _object_spread({
                                    className: styles.input,
                                    label: "T\xean chủ t\xe0i khoản ",
                                    required: true,
                                    error: !!errors.username
                                }, field)),
                                errors.username && /*#__PURE__*/ _jsxs("div", {
                                    className: styles.textError,
                                    "data-test": "signup-err-username",
                                    children: [
                                        /*#__PURE__*/ _jsx(ErrorIconOutlined, {
                                            className: styles.iconError
                                        }),
                                        " ",
                                        (ref = errors.username) === null || ref === void 0 ? void 0 : ref.message
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    name: "addressCompany",
                    defaultValue: "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ _jsx(FormControl, {
                            fullWidth: true,
                            children: /*#__PURE__*/ _jsx(InputV2, _object_spread({
                                className: styles.input,
                                label: "Số t\xe0i khoản"
                            }, field))
                        });
                    }
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    name: "addressVoice",
                    defaultValue: "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ _jsx(FormControl, {
                            fullWidth: true,
                            children: /*#__PURE__*/ _jsx(InputV2, _object_spread({
                                className: styles.input,
                                label: "Ng\xe2n h\xe0ng"
                            }, field))
                        });
                    }
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    name: "addressVoice",
                    defaultValue: "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ _jsx(FormControl, {
                            fullWidth: true,
                            children: /*#__PURE__*/ _jsx(InputV2, _object_spread({
                                className: styles.input,
                                label: "Chi nh\xe1nh"
                            }, field))
                        });
                    }
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    name: "contentFeedback",
                    defaultValue: "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ _jsx(FormControl, {
                            fullWidth: true,
                            children: /*#__PURE__*/ _jsx(InputV2, _object_spread({
                                style: {
                                    width: "-webkit-fill-available",
                                    margin: "8px 0px"
                                },
                                className: styles.textArea,
                                label: "Nội dung phản hồi",
                                type: "text",
                                multiline: true,
                                rows: 4
                            }, field))
                        });
                    }
                }),
                /*#__PURE__*/ _jsx(Box, {
                    children: /*#__PURE__*/ _jsx(UploadFiles, {
                        className: styles.input,
                        handleSetValue: handleSetValue,
                        fileList: fileList,
                        val: "businessImages",
                        label: "Th\xeam h\xecnh ảnh (Tối đa 6 h\xecnh)",
                        subLabel: "File PNG, JPEG hoặc PDF - tối đa 3 files"
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    textAlign: "center",
                    marginTop: "20px",
                    children: /*#__PURE__*/ _jsx(Button, {
                        className: styles.btn_register,
                        type: "submit",
                        onClick: handleSubmit(onSubmit),
                        children: "gửi phản hồi"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(71843);
// EXTERNAL MODULE: ./src/components/mocules/NewInvoiceModal/styles.module.css
var NewInvoiceModal_styles_module = __webpack_require__(77827);
var NewInvoiceModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewInvoiceModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewInvoiceModal/index.js












var NewInvoiceModal = function(param) {
    var className = param.className, visible = param.visible, onClose = param.onClose, restProps = param.restProps, width = param.width, title = param.title, children = param.children, isAdding = param.isAdding, step = param.step, getStepInvoiceSubtract = param.getStepInvoiceSubtract, check = param.check, setCheck = param.setCheck;
    var handleBackStepInvoice = function() {
        getStepInvoiceSubtract();
        setCheck(false);
    };
    var renderTitle = function() {
        if (step === 2 && !check) return "Th\xeam mới th\xf4ng tin h\xf3a đơn";
        if (step === 2 && check) return "Sửa th\xf4ng tin xuất h\xf3a đơn";
        return title;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (NewInvoiceModal_styles_module_default()).auth_modal_content,
            style: {
                width: "".concat(width)
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    container: true,
                    className: (NewInvoiceModal_styles_module_default()).auth_modal_header,
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 10,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                        onClick: handleBackStepInvoice,
                                        className: isAdding ? (NewInvoiceModal_styles_module_default()).hiddenClose : (NewInvoiceModal_styles_module_default()).iconBack,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                        className: (NewInvoiceModal_styles_module_default()).auth_modal_title,
                                        children: renderTitle()
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                "aria-label": "close",
                                className: (NewInvoiceModal_styles_module_default()).auth_modal_close,
                                onClick: onClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)((NewInvoiceModal_styles_module_default()).auth_modal_body, (NewInvoiceModal_styles_module_default()).slideRight),
                    children: children
                })
            ]
        })
    }));
};
/* harmony default export */ var mocules_NewInvoiceModal = (/*#__PURE__*/react.memo(NewInvoiceModal));

// EXTERNAL MODULE: ./src/components/mocules/NewPasswordForm/styles.module.css
var NewPasswordForm_styles_module = __webpack_require__(31312);
var NewPasswordForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewPasswordForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewPasswordForm/NewPasswordForm.js











var NewPasswordForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickNewPasswordForm = param.onClickNewPasswordForm, step = param.step, toggleModalAndSignout = param.toggleModalAndSignout;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var ref1 = (0,react.useState)(false), errorPw = ref1[0], setErrorPw = ref1[1];
    var ref2 = (0,react.useState)(""), errorPwMessage = ref2[0], setErrorPwMessage = ref2[1];
    var ref3 = (0,react.useState)(false), errorNewPassword = ref3[0], setErrorNewPassword = ref3[1];
    var ref4 = (0,react.useState)(""), errorNewPasswordMessage = ref4[0], setErrorNewPasswordMessage = ref4[1];
    var ref5 = (0,react.useState)(""), currentPassword = ref5[0], setCurrentPassword = ref5[1];
    var ref6 = (0,react.useState)(""), newPassword = ref6[0], setNewPassword = ref6[1];
    // handle validate
    var validatePw = function(data) {
        setErrorPw(false);
        if (data === "") {
            setErrorPw(true);
            setErrorPwMessage("Bạn chưa nhập mật khẩu");
            return false;
        }
        if (data.length > 50) {
            setErrorPw(true);
            setErrorPwMessage("Mật khẩu qu\xe1 d\xe0i");
            return false;
        }
        // if (!data.match(regExpPw)) {
        //   setErrorPw(true);
        //   setErrorPwMessage(
        //     'Mật khẩu phải ít nhất 8 ký tự và không quá 20 ký tự. Có chứa ít nhất 1 chữ thường, 1 chữ hoa, và 1 số',
        //   );
        //   return false;
        // }
        return true;
    };
    var validateNewPassword = function(data) {
        setErrorNewPassword(false);
        if (data === "") {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage("Bạn chưa nhập mật khẩu mới");
            return false;
        }
        if (data.length > 30 || data.length < 8) {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage("Mật khẩu tối thiểu 8 v\xe0 tối đa 30 k\xed tự");
            return false;
        }
        return true;
    };
    // handle submit form
    var onSubmitNewPasswordForm = function() {
        var data = {
            password: currentPassword,
            newPassword: newPassword
        };
        if (!validateNewPassword(data.newPassword)) {
            return;
        }
        onClickNewPasswordForm(data);
    };
    // handle input
    var handleOnChangePw = function(e) {
        e.preventDefault();
        validatePw(e.target.value);
        setCurrentPassword(e.target.value);
    };
    var handleOnChangeNewPassword = function(e) {
        e.preventDefault();
        validateNewPassword(e.target.value);
        setNewPassword(e.target.value);
    };
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "forget-password",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "form-forget-password ".concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    placeholder: "Mật khẩu hiện tại",
                                    variant: "outlined",
                                    className: (NewPasswordForm_styles_module_default()).input,
                                    error: errorPw,
                                    onChange: handleOnChangePw
                                }),
                                errorPw && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewPasswordForm_styles_module_default()).error,
                                    children: errorPwMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "newPassword",
                                    name: "newPassword",
                                    type: showPassword ? "text" : "password",
                                    startAdornment: IconPassword,
                                    endAdornment: IconEndPassword,
                                    placeholder: "Mật khẩu mới",
                                    variant: "outlined",
                                    error: errorNewPassword,
                                    className: (NewPasswordForm_styles_module_default()).input,
                                    onChange: handleOnChangeNewPassword
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewPasswordForm_styles_module_default()).error,
                                    children: errorNewPassword && errorNewPasswordMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "action",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                className: "btnForgetPassword",
                                color: "white",
                                onClick: onSubmitNewPasswordForm,
                                children: "Gửi"
                            })
                        })
                    ]
                })
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "forget-password",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewPasswordForm_styles_module_default()).confirm_modal_wrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewPasswordForm_styles_module_default()).warning_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (NewPasswordForm_styles_module_default()).text_icon,
                                        children: "✓"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (NewPasswordForm_styles_module_default()).modal_title,
                                    children: "Th\xe0nh c\xf4ng"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (NewPasswordForm_styles_module_default()).modal_title,
                                    children: "Đăng nhập lại để ho\xe0n tất!"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewPasswordForm_styles_module_default()).btngroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonHeader */.X9, {
                            variant: "contained",
                            btnType: "primary",
                            onClick: toggleModalAndSignout,
                            children: "Đăng nhập lại"
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var NewPasswordForm_NewPasswordForm = (NewPasswordForm);

;// CONCATENATED MODULE: ./src/components/mocules/NewPasswordForm/index.js

function NewPasswordForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .form-forget-password {\n    margin-top: 10px;\n  }\n\n  .form-control {\n    width: ",
        "px;\n    margin-bottom: 10px;\n  }\n\n  .btnForgetPassword {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    padding: 1.5rem;\n    border-radius: 50px;\n  }\n  .action {\n    margin-top: 10px;\n    max-width: 200px;\n    width: 100%;\n  }\n  .desc {\n    font-size: 16px;\n    margin: 15px auto;\n    max-width: 450px;\n  }\n  .forget-password {\n    width: 100%;\n  }\n"
    ]);
    NewPasswordForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var styledNewPasswordForm = (0,styled_components_browser_esm/* default */.ZP)(NewPasswordForm_NewPasswordForm).withConfig({
    componentId: "sc-ecad00cd-0"
})(NewPasswordForm_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 450 : _width;
    return width;
});
/* harmony default export */ var mocules_NewPasswordForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(styledNewPasswordForm))));

// EXTERNAL MODULE: ./src/components/mocules/NewRegisterGuestForm/styles.module.css
var NewRegisterGuestForm_styles_module = __webpack_require__(74689);
var NewRegisterGuestForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewRegisterGuestForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewRegisterGuestForm/index.js






// outdate
var NewRegisterGuestForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickRegister = param.onClickRegister;
    var regExp = /(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
    var ref = (0,react.useState)(false), errorPhone = ref[0], setErrorPhone = ref[1];
    var ref1 = (0,react.useState)(""), errorPhoneMessage = ref1[0], setErrorPhoneMessage = ref1[1];
    var validatePhone = function(data) {
        setErrorPhone(false);
        if (data === "") {
            setErrorPhone(true);
            setErrorPhoneMessage("Vui l\xf2ng nhập số điện thoại v\xe0 bắt đầu bằng số 0");
            return false;
        }
        if (!data.match(regExp)) {
            setErrorPhone(true);
            setErrorPhoneMessage("Số điện thoại bạn nhập kh\xf4ng đ\xfang");
            return false;
        }
        return true;
    };
    // handle login with data
    var handleRegisterGuest = function(e) {
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        e.preventDefault();
        if (!validatePhone(data.phone)) {
            return;
        }
        onClickRegister(data);
    };
    var handleOnChange = function(e) {
        e.preventDefault();
        validatePhone(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (NewRegisterGuestForm_styles_module_default()).form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: className,
            onSubmit: handleRegisterGuest,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: (NewRegisterGuestForm_styles_module_default()).title,
                    children: [
                        "Vui l\xf2ng nhập số điện thoại ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " trước khi d\xf9ng thử"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                            id: "phone",
                            name: "phone",
                            type: "number",
                            placeholder: "Nhập số điện thoại",
                            variant: "outlined",
                            error: errorPhone,
                            onChange: handleOnChange,
                            className: (NewRegisterGuestForm_styles_module_default()).input
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NewRegisterGuestForm_styles_module_default()).error,
                            children: errorPhone && errorPhoneMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NewRegisterGuestForm_styles_module_default()).bottom_text,
                    children: "M\xe3 giảm gi\xe1 100k d\xe0nh cho nh\xe0 thuốc mới đăng k\xfd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NewRegisterGuestForm_styles_module_default()).btn_wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        className: (NewRegisterGuestForm_styles_module_default()).btn,
                        color: "white",
                        type: "submit",
                        children: "Đăng K\xfd"
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var mocules_NewRegisterGuestForm = (NewRegisterGuestForm);

// EXTERNAL MODULE: ./src/components/mocules/NewRegisterOrderInvoiceForm/index.js
var NewRegisterOrderInvoiceForm = __webpack_require__(27733);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var dist_yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Switch/Switch.js
var Switch = __webpack_require__(9570);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AccountCircleOutlined.js
var AccountCircleOutlined = __webpack_require__(60737);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ErrorOutlined.js
var ErrorOutlined = __webpack_require__(64839);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOffOutlined.js
var VisibilityOffOutlined = __webpack_require__(31138);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOutlined.js
var VisibilityOutlined = __webpack_require__(97246);
// EXTERNAL MODULE: ./src/components-v2/atoms/MobileBadge/index.js
var MobileBadge = __webpack_require__(48748);
// EXTERNAL MODULE: ./src/constants/Images/mobile/Icons/index.js
var mobile_Icons = __webpack_require__(76726);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/utils/transVersion.js
var transVersion = __webpack_require__(89388);
// EXTERNAL MODULE: ./src/components/mocules/NewSignUpForm/styles.module.css
var NewSignUpForm_styles_module = __webpack_require__(9992);
var NewSignUpForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewSignUpForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewSignInForm/index.js






























var NewSignInForm = function(param) {
    var className = param.className, onClickForget = param.onClickForget, onClickLogin = param.onClickLogin, onClickSignUp = param.onClickSignUp, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _page = param.page, page = _page === void 0 ? null : _page, _setPage = param.setPage, setPage = _setPage === void 0 ? null : _setPage, _isShowLogin = param.isShowLogin, isShowLogin = _isShowLogin === void 0 ? false : _isShowLogin, _isShowSignUp = param.isShowSignUp, isShowSignUp = _isShowSignUp === void 0 ? false : _isShowSignUp, toggleLogin = param.toggleLogin, toggleSignUp = param.toggleSignUp, user = param.user, translatePopupAction = param.translatePopupAction;
    var ref;
    var schema = yup_es/* object */.Ry({
        username: yup_es/* string */.Z_().required(translatePopupAction("popup_login.validate_phone_number_email_empty")),
        password: yup_es/* string */.Z_().required(translatePopupAction("popup_login.validate_password_empty"))
    }).required();
    var ref1 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,dist_yup/* yupResolver */.X)(schema)
    }), errors = ref1.formState.errors, control = ref1.control, handleSubmit = ref1.handleSubmit;
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var router = (0,next_router.useRouter)();
    var handleChangeUI = (0,storeMobile/* default */.Z)(function(state) {
        return state.toggleBeta;
    });
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    // handle login with data
    var handleLogin = function(data) {
        onClickLogin(data);
    // if (isAuthenticated && isMobile && beta && openNewLogin) {
    //   handleLoginV2();
    //   console.log(123);
    // }
    // if (isAuthenticated && isMobile && beta && openSignupV2) {
    //   handleSignupV2();
    // }
    };
    // handle forget password
    var handleClickForget = (0,react.useCallback)(function(e) {
        if (dist_lib/* isMobile */.tq && beta) {
            e.preventDefault();
            router.push("/?forgetpass=true");
            setPage(page + 2);
        } else {
            e.preventDefault();
            onClickForget();
        }
    }, [
        onClickForget,
        page,
        dist_lib/* isMobile */.tq
    ]);
    var handleClickSignUp = (0,react.useCallback)(function(e) {
        if (dist_lib/* isMobile */.tq && beta) {
            e.preventDefault();
            router.push("/?register=true");
            setPage(page + 1);
        } else {
            e.preventDefault();
            onClickSignUp();
        }
    }, [
        onClickSignUp,
        page,
        dist_lib/* isMobile */.tq
    ]);
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconAccount = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircleOutlined/* default */.Z, {})
    });
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOffOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOutlined/* default */.Z, {})
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            beta && dist_lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NewSignUpForm_styles_module_default()).wrapperTitle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        marginBottom: "100px",
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_Icons/* MOBILE_LOGO */.ge, {
                                    className: (NewSignUpForm_styles_module_default()).logo
                                })
                            }),
                            isShowLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBadge/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((NewSignUpForm_styles_module_default()).badge, (NewSignUpForm_styles_module_default()).greenIcon),
                                onClick: toggleLogin,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_Icons/* ICON_MOBILE_ICON_HOME */.cE, {})
                            }),
                            isShowSignUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBadge/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((NewSignUpForm_styles_module_default()).badge, (NewSignUpForm_styles_module_default()).greenIcon),
                                onClick: toggleSignUp,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_Icons/* ICON_MOBILE_ICON_HOME */.cE, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "title",
                        children: [
                            translatePopupAction("popup_login.greeting"),
                            " ",
                            Enums/* BRAND_NAME */.RS
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "desc",
                        children: translatePopupAction("popup_login.sub_title")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: className,
                onSubmit: handleSubmit(function(data) {
                    return handleLogin(data);
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "username",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        error: !!errors.username,
                                        startAdornment: IconAccount,
                                        placeholder: translatePopupAction("popup_login.placeholder_username"),
                                        variant: "outlined",
                                        className: (NewSignUpForm_styles_module_default()).input
                                    }, field), {
                                        "data-test": "signin-username"
                                    })),
                                    ((ref = errors.username) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signin-err-username",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.username) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "password",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        error: !!errors.password,
                                        type: showPassword ? "text" : "password",
                                        startAdornment: IconPassword,
                                        endAdornment: IconEndPassword,
                                        placeholder: translatePopupAction("popup_login.password"),
                                        autoComplete: "password",
                                        variant: "outlined",
                                        className: (NewSignUpForm_styles_module_default()).input
                                    }, field), {
                                        "data-test": "signin-password"
                                    })),
                                    ((ref = errors.password) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signin-err-password",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "rememberMe",
                        defaultValue: true,
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (NewSignUpForm_styles_module_default()).agree_term,
                                style: {
                                    padding: "0 0 1rem 0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CheckBox */.Jg, (0,src_object_spread/* default */.Z)({
                                    "data-test": "signin-rememberMe",
                                    label: translatePopupAction("popup_login.keep_me_signed_in"),
                                    onChange: function(e) {
                                        return field.onChange(e.target.checked);
                                    },
                                    isChecked: field.value
                                }, field))
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((NewSignUpForm_styles_module_default()).link_login_wrapper, " ").concat((NewSignUpForm_styles_module_default()).center),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/",
                            onClick: handleClickForget,
                            className: (NewSignUpForm_styles_module_default()).link_login,
                            children: translatePopupAction("popup_login.forgot_your_password")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: (NewSignUpForm_styles_module_default()).center,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            type: "submit",
                            className: (NewSignUpForm_styles_module_default()).btn_register,
                            disabled: isLoading,
                            "data-test": "signin-submit",
                            children: translatePopupAction("popup_login.sign_in")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((NewSignUpForm_styles_module_default()).link_login_wrapper, " ").concat((NewSignUpForm_styles_module_default()).center),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                translatePopupAction("popup_login.get_deal_member"),
                                ",\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#top",
                                    className: (NewSignUpForm_styles_module_default()).link_login,
                                    onClick: handleClickSignUp,
                                    children: translatePopupAction("popup_login.register_member")
                                })
                            ]
                        })
                    })
                ]
            }),
            sysconfig/* ENV_COUNTRY */.ng === "vn" && beta && dist_lib/* isMobile */.tq && !(0,transVersion/* checkNewUser */.Uw)(user === null || user === void 0 ? void 0 : (ref = user.account) === null || ref === void 0 ? void 0 : ref.createdTime) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "flex",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                    component: "label",
                    container: true,
                    alignItems: "center",
                    justifyContent: "center",
                    spacing: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        item: true,
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                                color: "primary",
                                checked: beta,
                                onChange: handleChangeUI,
                                name: "checkedMobileNew"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    fontFamily: "googlesansregular",
                                    fontSize: "14px",
                                    color: "#000000DE"
                                },
                                children: translatePopupAction("popup_login.trial_mv2_switch")
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_NewSignInForm = (NewSignInForm);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/EditOutlined.js
var EditOutlined = __webpack_require__(65166);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/EmailOutlined.js
var EmailOutlined = __webpack_require__(14662);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocalHospital.js
var LocalHospital = __webpack_require__(2742);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocationOn.js
var LocationOn = __webpack_require__(59832);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/PeopleOutlined.js
var PeopleOutlined = __webpack_require__(803);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/PhoneOutlined.js
var PhoneOutlined = __webpack_require__(93218);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CampaignOutlined.js
var CampaignOutlined = __webpack_require__(97397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popover/Popover.js
var Popover = __webpack_require__(52387);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./src/components/mocules/SearchableSelect/styles.module.css
var SearchableSelect_styles_module = __webpack_require__(46639);
var SearchableSelect_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchableSelect_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchableSelect/index.js
/*
 * SearchableSelect: single-value dropdown with a search box (register form: business type,
 * "How did you find us").
 * This file and styles.module.css are kept byte-identical between `web` (TH) and `kh_web` (KH):
 * change one repo, copy the files to the other.
 *
 * Props:
 * - id: base id for the listbox / option ids (a11y), e.g. "signup-scope"
 * - value, onChange(value, option), onBlur(): controlled value (react-hook-form `field`)
 * - options: [{ value, label }]
 * - placeholder, searchPlaceholder, noResultsText: translated texts from the caller
 * - startIcon: icon element shown at the start of the trigger
 * - error: red border; disabled; className: root wrapper class
 * - ref: forwarded to the trigger button (react-hook-form focuses it on validation error)
 * - other props (data-test, aria-*) go to the trigger button (aria-label defaults to placeholder)
 * - each option <li> has data-value={option.value} (QA automation)
 *
 * The panel is an MUI Popover (portal to document.body, z-index above MUI Dialog), so it is never
 * clipped by the dialog / scroll container overflow. Popover is a Modal: while open it is the top
 * modal, so the focus trap of the surrounding Dialog pauses and the search box can keep focus
 * (a plain Popper portal inside a Dialog would get its focus stolen back by the Dialog).
 */ 











var PANEL_Z_INDEX = 1400; // above MUI Modal / Dialog (theme.zIndex.modal = 1300)
var PANEL_GAP = 6; // px between trigger and panel
var VIEWPORT_MARGIN = 16; // Popover marginThreshold
var LIST_MAX_HEIGHT = 300;
var LIST_MIN_HEIGHT = 120;
var OPTION_HEIGHT = 36; // keep in sync with .option min-height
var PANEL_CHROME_HEIGHT = 72; // .panel padding (2 x 12) + .search height (40) + .list margin-top (8)
var isEmptyValue = function(value) {
    return value === undefined || value === null || value === "";
};
// Latin combining diacritics only (U+0300-U+036F). Do not use \p{M}: it would also strip Thai / Khmer
// vowel signs and tone marks.
var LATIN_DIACRITICS = /[\u0300-\u036f]/g;
// Search key: lower case, trimmed, Latin accents removed ("Nhà thuốc" -> "nha thuoc", "đ" -> "d").
// Thai / Khmer text is unchanged.
var normalizeText = function(text) {
    var str = String(text || "").toLowerCase().trim();
    var stripped = typeof str.normalize === "function" ? str.normalize("NFD").replace(LATIN_DIACRITICS, "") : str;
    return stripped.replace(/đ/g, "d");
};
// Visible area in layout-viewport coordinates. visualViewport excludes the iOS virtual keyboard,
// which changes neither window.innerHeight nor fires window resize.
var getVisibleArea = function() {
    var vv = window.visualViewport;
    if (vv && vv.height > 0) return {
        top: vv.offsetTop,
        bottom: vv.offsetTop + vv.height
    };
    return {
        top: 0,
        bottom: window.innerHeight
    };
};
var isSameLayout = function(a, b) {
    return a.width === b.width && a.placeAbove === b.placeAbove && a.listMaxHeight === b.listMaxHeight;
};
// No search autofocus on touch devices (would pop up the virtual keyboard). `isMobile` misses
// iPadOS (desktop UA), hence also `(pointer: coarse)`.
var shouldAutoFocusSearch = function() {
    if (dist_lib/* isMobile */.tq) return false;
    if ( true && typeof window.matchMedia === "function") {
        return !window.matchMedia("(pointer: coarse)").matches;
    }
    return true;
};
var SearchableSelect = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var id = props.id, name = props.name, value = props.value, _options = props.options, options = _options === void 0 ? [] : _options, onChange = props.onChange, onBlur = props.onBlur, _placeholder = props.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _searchPlaceholder = props.searchPlaceholder, searchPlaceholder = _searchPlaceholder === void 0 ? "" : _searchPlaceholder, _noResultsText = props.noResultsText, noResultsText = _noResultsText === void 0 ? "" : _noResultsText, _startIcon = props.startIcon, startIcon = _startIcon === void 0 ? null : _startIcon, _error = props.error, error = _error === void 0 ? false : _error, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, className = props.className, rest = (0,src_object_without_properties/* default */.Z)(props, [
        "id",
        "name",
        "value",
        "options",
        "onChange",
        "onBlur",
        "placeholder",
        "searchPlaceholder",
        "noResultsText",
        "startIcon",
        "error",
        "disabled",
        "className"
    ]);
    var baseId = id || name || "searchable-select";
    var listboxId = "".concat(baseId, "-listbox");
    var getOptionId = function(index) {
        return "".concat(baseId, "-option-").concat(index);
    };
    var triggerRef = (0,react.useRef)(null);
    var searchRef = (0,react.useRef)(null);
    var listRef = (0,react.useRef)(null);
    var popoverActionRef = (0,react.useRef)(null);
    var openRef = (0,react.useRef)(false);
    var restoreFocusRef = (0,react.useRef)(false);
    var keyboardNavRef = (0,react.useRef)(false);
    var _$ref = (0,react.useState)(false), open = _$ref[0], setOpen = _$ref[1];
    var _$ref1 = (0,react.useState)(""), query = _$ref1[0], setQuery = _$ref1[1];
    var _$ref2 = (0,react.useState)(-1), activeIndex = _$ref2[0], setActiveIndex = _$ref2[1];
    var _$ref3 = (0,react.useState)({
        width: 0,
        placeAbove: false,
        listMaxHeight: LIST_MAX_HEIGHT
    }), layout = _$ref3[0], setLayout = _$ref3[1];
    openRef.current = open;
    var selectedOption = options.find(function(option) {
        return option.value === value;
    });
    var hasValue = !isEmptyValue(value);
    var displayText = selectedOption && selectedOption.label || value;
    var filteredOptions = (0,react.useMemo)(function() {
        var keyword = normalizeText(query);
        if (!keyword) return options;
        return options.filter(function(option) {
            return normalizeText(option.label).includes(keyword);
        });
    }, [
        options,
        query
    ]);
    var activeOption = open ? filteredOptions[activeIndex] : undefined;
    // aria-controls only while the listbox is rendered
    var listboxControls = open && filteredOptions.length > 0 ? listboxId : undefined;
    var setTriggerRef = (0,react.useCallback)(function(node) {
        triggerRef.current = node;
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
    }, [
        ref
    ]);
    // Panel width = trigger width; open below the trigger, flip above when there is not enough space
    var computeLayout = (0,react.useCallback)(function() {
        var node = triggerRef.current;
        if (!node || "object" === "undefined") return null;
        var rect = node.getBoundingClientRect();
        var visible = getVisibleArea();
        var spaceBelow = visible.bottom - rect.bottom - VIEWPORT_MARGIN - PANEL_GAP;
        var spaceAbove = rect.top - visible.top - VIEWPORT_MARGIN - PANEL_GAP;
        var listHeight = Math.min(LIST_MAX_HEIGHT, Math.max(options.length, 1) * OPTION_HEIGHT);
        var placeAbove = spaceBelow < listHeight + PANEL_CHROME_HEIGHT && spaceAbove > spaceBelow;
        var space = placeAbove ? spaceAbove : spaceBelow;
        return {
            width: rect.width,
            placeAbove: placeAbove,
            listMaxHeight: Math.max(LIST_MIN_HEIGHT, Math.min(LIST_MAX_HEIGHT, space - PANEL_CHROME_HEIGHT))
        };
    }, [
        options.length
    ]);
    var scrollOptionIntoView = function(index, center) {
        var list = listRef.current;
        var optionNode = list && index >= 0 ? list.querySelector('[data-option-index="'.concat(index, '"]')) : null;
        if (!optionNode) return;
        if (center) {
            list.scrollTop = optionNode.offsetTop - (list.clientHeight - optionNode.offsetHeight) / 2;
            return;
        }
        if (optionNode.offsetTop < list.scrollTop) {
            list.scrollTop = optionNode.offsetTop;
        } else if (optionNode.offsetTop + optionNode.offsetHeight > list.scrollTop + list.clientHeight) {
            list.scrollTop = optionNode.offsetTop + optionNode.offsetHeight - list.clientHeight;
        }
    };
    var openPanel = function() {
        if (disabled || openRef.current) return;
        var nextLayout = computeLayout();
        if (nextLayout) setLayout(nextLayout);
        setQuery("");
        setActiveIndex(options.findIndex(function(option) {
            return option.value === value;
        }));
        setOpen(true);
    };
    var closePanel = function(restoreFocus) {
        if (!openRef.current) return;
        restoreFocusRef.current = !!restoreFocus;
        setOpen(false);
        if (onBlur) onBlur();
    };
    var handleSelect = function(option) {
        if (!option) return;
        if (onChange) onChange(option.value, option);
        closePanel(true);
    };
    var moveActive = function(step) {
        var count = filteredOptions.length;
        if (!count) return;
        keyboardNavRef.current = true;
        setActiveIndex(function(prev) {
            if (prev < 0 || prev >= count) return step > 0 ? 0 : count - 1;
            return Math.min(count - 1, Math.max(0, prev + step));
        });
    };
    var handleTriggerKeyDown = function(event) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            openPanel();
        }
    };
    // Safari does not focus a <button> on click: focus it so MUI restores focus to the trigger
    // when the panel is closed by an outside click.
    var handleTriggerMouseDown = function() {
        if (!disabled && triggerRef.current) triggerRef.current.focus({
            preventScroll: true
        });
    };
    var handleTriggerBlur = function() {
        // focus moving into the open panel is not a blur of the field
        if (!openRef.current && onBlur) onBlur();
    };
    var handlePanelKeyDown = function(event) {
        if (event.nativeEvent && event.nativeEvent.isComposing) return;
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                moveActive(1);
                break;
            case "ArrowUp":
                event.preventDefault();
                moveActive(-1);
                break;
            case "Enter":
                event.preventDefault();
                handleSelect(filteredOptions[activeIndex]);
                break;
            case "Escape":
                // stop here so the surrounding Dialog does not close too
                event.preventDefault();
                event.stopPropagation();
                closePanel(true);
                break;
            case "Tab":
                event.preventDefault();
                closePanel(true);
                break;
            default:
                break;
        }
    };
    var handleQueryChange = function(event) {
        var nextQuery = event.target.value;
        setQuery(nextQuery);
        setActiveIndex(normalizeText(nextQuery) ? 0 : options.findIndex(function(option) {
            return option.value === value;
        }));
        if (listRef.current) listRef.current.scrollTop = 0;
    };
    var handleEntering = function() {
        scrollOptionIntoView(options.findIndex(function(option) {
            return option.value === value;
        }), true);
        if (shouldAutoFocusSearch() && searchRef.current) {
            searchRef.current.focus({
                preventScroll: true
            });
        }
    };
    var handleExited = function() {
        setQuery("");
        setActiveIndex(-1);
        var trigger = triggerRef.current;
        if (restoreFocusRef.current && trigger && document.activeElement !== trigger) {
            trigger.focus({
                preventScroll: true
            });
        }
        restoreFocusRef.current = false;
    };
    var handlePopoverClose = function(event, reason) {
        closePanel(reason === "escapeKeyDown");
    };
    // keyboard navigation keeps the active option visible
    (0,react.useEffect)(function() {
        if (!open || !keyboardNavRef.current) return;
        keyboardNavRef.current = false;
        scrollOptionIntoView(activeIndex, false);
    }, [
        open,
        activeIndex
    ]);
    // panel height changes while filtering: re-anchor (matters when the panel is flipped above)
    (0,react.useEffect)(function() {
        if (open && popoverActionRef.current) popoverActionRef.current.updatePosition();
    }, [
        open,
        filteredOptions.length,
        layout
    ]);
    // Re-fit the panel when the visible area changes: window resize, and visualViewport resize/scroll
    // (iOS virtual keyboard opening while typing in the search box).
    (0,react.useEffect)(function() {
        if (!open) return undefined;
        var vv = window.visualViewport;
        var frame = null;
        var handleViewportChange = function() {
            if (frame !== null) return;
            frame = window.requestAnimationFrame(function() {
                frame = null;
                var nextLayout = computeLayout();
                if (nextLayout) setLayout(function(prev) {
                    return isSameLayout(prev, nextLayout) ? prev : nextLayout;
                });
                if (popoverActionRef.current) popoverActionRef.current.updatePosition();
            });
        };
        window.addEventListener("resize", handleViewportChange);
        if (vv) {
            vv.addEventListener("resize", handleViewportChange);
            vv.addEventListener("scroll", handleViewportChange);
        }
        return function() {
            if (frame !== null) window.cancelAnimationFrame(frame);
            window.removeEventListener("resize", handleViewportChange);
            if (vv) {
                vv.removeEventListener("resize", handleViewportChange);
                vv.removeEventListener("scroll", handleViewportChange);
            }
        };
    }, [
        open,
        computeLayout
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((SearchableSelect_styles_module_default()).root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                "aria-label": placeholder || undefined
            }, rest), {
                ref: setTriggerRef,
                type: "button",
                role: "combobox",
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                "aria-controls": listboxControls,
                "aria-invalid": error || undefined,
                disabled: disabled,
                className: (0,clsx_m/* default */.Z)((SearchableSelect_styles_module_default()).trigger, open && (SearchableSelect_styles_module_default()).trigger_open, error && (SearchableSelect_styles_module_default()).trigger_error),
                onMouseDown: handleTriggerMouseDown,
                onClick: openPanel,
                onKeyDown: handleTriggerKeyDown,
                onBlur: handleTriggerBlur,
                children: [
                    startIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SearchableSelect_styles_module_default()).start_icon,
                        children: startIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)((SearchableSelect_styles_module_default()).value, !hasValue && (SearchableSelect_styles_module_default()).placeholder),
                        children: hasValue ? displayText : placeholder
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                        className: (SearchableSelect_styles_module_default()).chevron
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                open: open,
                anchorEl: triggerRef.current,
                onClose: handlePopoverClose,
                anchorOrigin: {
                    vertical: layout.placeAbove ? "top" : "bottom",
                    horizontal: "left"
                },
                transformOrigin: {
                    vertical: layout.placeAbove ? "bottom" : "top",
                    horizontal: "left"
                },
                marginThreshold: VIEWPORT_MARGIN,
                action: popoverActionRef,
                style: {
                    zIndex: PANEL_Z_INDEX
                },
                TransitionProps: {
                    onEntering: handleEntering,
                    onExited: handleExited
                },
                PaperProps: {
                    className: (SearchableSelect_styles_module_default()).paper,
                    style: {
                        width: layout.width || undefined,
                        marginTop: layout.placeAbove ? -PANEL_GAP : PANEL_GAP
                    },
                    onKeyDown: handlePanelKeyDown
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SearchableSelect_styles_module_default()).panel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SearchableSelect_styles_module_default()).search,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Search/* default */.Z, {
                                    className: (SearchableSelect_styles_module_default()).search_icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    ref: searchRef,
                                    type: "text",
                                    className: (SearchableSelect_styles_module_default()).search_input,
                                    value: query,
                                    onChange: handleQueryChange,
                                    placeholder: searchPlaceholder,
                                    "aria-label": searchPlaceholder,
                                    "aria-controls": listboxControls,
                                    "aria-autocomplete": "list",
                                    "aria-activedescendant": activeOption ? getOptionId(activeIndex) : undefined,
                                    autoComplete: "off"
                                })
                            ]
                        }),
                        filteredOptions.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            ref: listRef,
                            id: listboxId,
                            role: "listbox",
                            "aria-label": placeholder,
                            className: (SearchableSelect_styles_module_default()).list,
                            style: {
                                maxHeight: layout.listMaxHeight
                            },
                            children: filteredOptions.map(function(option, index) {
                                var isSelected = option.value === value;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    id: getOptionId(index),
                                    role: "option",
                                    "aria-selected": isSelected,
                                    "data-option-index": index,
                                    "data-value": option.value,
                                    className: (0,clsx_m/* default */.Z)((SearchableSelect_styles_module_default()).option, index === activeIndex && (SearchableSelect_styles_module_default()).option_active, isSelected && (SearchableSelect_styles_module_default()).option_selected),
                                    onMouseMove: function() {
                                        if (activeIndex !== index) setActiveIndex(index);
                                    },
                                    onClick: function() {
                                        return handleSelect(option);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SearchableSelect_styles_module_default()).option_label,
                                            children: option.label
                                        }),
                                        isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                            className: (SearchableSelect_styles_module_default()).option_check
                                        })
                                    ]
                                }, option.value);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SearchableSelect_styles_module_default()).empty,
                            role: "status",
                            children: noResultsText
                        })
                    ]
                })
            })
        ]
    });
});
/* harmony default export */ var mocules_SearchableSelect = (SearchableSelect);

// EXTERNAL MODULE: ./src/clients/CustomerClient.js
var clients_CustomerClient = __webpack_require__(59261);
;// CONCATENATED MODULE: ./src/hooks/useLeadSources.js





// Fetch the active lead sources ("How did you find us?") for the sign-up form.
// Any failure (error, non-OK, empty list) resolves to an empty list so the caller can hide the field
// and never block registration.
var useLeadSources = function() {
    var ref = (0,react.useState)([]), leadSources = ref[0], setLeadSources = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    (0,react.useEffect)(function() {
        var isMounted = true;
        var fetchLeadSources = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var res, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            return [
                                4,
                                (0,clients_CustomerClient/* getLeadSources */.mA)()
                            ];
                        case 1:
                            res = _state.sent();
                            if (!isMounted) return [
                                2
                            ];
                            if ((res === null || res === void 0 ? void 0 : res.status) !== Enums/* HTTP_STATUS.Ok */.MG.Ok || !Array.isArray(res === null || res === void 0 ? void 0 : res.data)) {
                                setLeadSources([]);
                                return [
                                    2
                                ];
                            }
                            setLeadSources(res.data.filter(function(item) {
                                return item === null || item === void 0 ? void 0 : item.value;
                            }));
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            if (isMounted) setLeadSources([]);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            if (isMounted) setLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLeadSources() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchLeadSources();
        return function() {
            isMounted = false;
        };
    }, []);
    return {
        leadSources: leadSources,
        loading: loading
    };
};
/* harmony default export */ var hooks_useLeadSources = (useLeadSources);

// EXTERNAL MODULE: ./src/utils/registerURL.js
var registerURL = __webpack_require__(15563);
;// CONCATENATED MODULE: ./src/components/mocules/NewSignUpForm/index.js









































var validateData = utils/* ValidateUtils.validateData */.IN.validateData, NewSignUpForm_Error = utils/* ValidateUtils.Error */.IN.Error, NewSignUpForm_isEmpty = utils/* ValidateUtils.isEmpty */.IN.isEmpty;
// update to zustand for country
var PHONE_REGEX = utils/* regUtils.PHONE_REGEX */.d7.PHONE_REGEX, PHONE_REGEX_CAM = utils/* regUtils.PHONE_REGEX_CAM */.d7.PHONE_REGEX_CAM, EMAIL_REGEX = utils/* regUtils.EMAIL_REGEX */.d7.EMAIL_REGEX;
// Lead source option whose selection requires the free-text `otherSourceDetail`
var LEAD_SOURCE_OTHER = "other";
// Business type (scope) options, same order as the former 2-column radio list
var SCOPE_OPTIONS = [
    Enums/* ENUM_SCOPE.PHARMACY */.hD.PHARMACY,
    Enums/* ENUM_SCOPE.PHARMA_COMPANY */.hD.PHARMA_COMPANY,
    Enums/* ENUM_SCOPE.CLINIC */.hD.CLINIC,
    Enums/* ENUM_SCOPE.HOSPITAL */.hD.HOSPITAL,
    Enums/* ENUM_SCOPE.DENTISTRY */.hD.DENTISTRY,
    Enums/* ENUM_SCOPE.BEAUTY_SALON */.hD.BEAUTY_SALON,
    Enums/* ENUM_SCOPE.HEALTH_CENTER */.hD.HEALTH_CENTER,
    Enums/* ENUM_SCOPE.CABINET */.hD.CABINET, 
];
var validateSignUp = function(param, failCallback, translatePopupAction) {
    var isCheckAgree = param.isCheckAgree, name = param.name, email = param.email, password = param.password, phone = param.phone;
    try {
        validateData.name(name);
        validateData.phoneNumber(phone);
        if (!NewSignUpForm_isEmpty(email)) {
            validateData.email(email);
        }
        validateData.password(password);
        if (!isCheckAgree) throw new NewSignUpForm_Error("message_agree_terms");
        return true;
    } catch (error) {
        utils/* NotifyUtils.error */.QP.error(translatePopupAction("popup_register.".concat(error === null || error === void 0 ? void 0 : error.message)) || translatePopupAction("popup_register.message_error"));
        failCallback(error);
        return false;
    }
};
var NewSignUpForm = /*#__PURE__*/ react.memo(function(props) {
    var ref;
    var ref1 = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref1.t, i18n = ref1.i18n;
    var ref2 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref2.t;
    var ref3 = (0,react.useState)(false), showPassword = ref3[0], setShowPassword = ref3[1];
    var className = props.className, onClickSignIn = props.onClickSignIn, onClickSignUp = props.onClickSignUp, referCode = props.referCode, page = props.page, setPage = props.setPage, handleScrollTop = props.handleScrollTop;
    var ref4 = (0,react.useState)([]), provinces = ref4[0], setProvinces = ref4[1];
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    var router = (0,next_router.useRouter)();
    // Lead source: only shown and required when the API returns a non-empty list.
    // While loading / on error / empty list the field is hidden and never blocks registration.
    var leadSources = hooks_useLeadSources().leadSources;
    var hasLeadSources = leadSources.length > 0;
    var currentLocale = (i18n === null || i18n === void 0 ? void 0 : i18n.language) || (router === null || router === void 0 ? void 0 : router.locale) || sysconfig/* LANG_DEFAULT */.YY;
    var leadSourceOptions = (0,react.useMemo)(function() {
        return leadSources.map(function(source) {
            var ref;
            return {
                value: source.value,
                label: ((ref = source.labels) === null || ref === void 0 ? void 0 : ref[currentLocale]) || source.label
            };
        });
    }, [
        leadSources,
        currentLocale
    ]);
    var scopeOptions = (0,react.useMemo)(function() {
        return SCOPE_OPTIONS.map(function(item) {
            return {
                value: item,
                label: translateCommon("scope.".concat(item))
            };
        });
    }, [
        translateCommon
    ]);
    var leadSourceSchema = hasLeadSources ? {
        leadSource: yup_es/* string */.Z_().required(translatePopupAction("popup_register.lead_source_required")),
        otherSourceDetail: yup_es/* string */.Z_().trim().when("leadSource", {
            is: LEAD_SOURCE_OTHER,
            then: function(fieldSchema) {
                return fieldSchema.required(translatePopupAction("popup_register.other_source_detail_required"));
            }
        })
    } : {};
    var schema = yup_es/* object */.Ry((0,src_object_spread/* default */.Z)({
        name: yup_es/* string */.Z_().required(translatePopupAction("popup_register.validate_require_username")).min(2, translatePopupAction("popup_register.validate_username_min_2_word")),
        password: yup_es/* string */.Z_().required(translatePopupAction("popup_register.validate_password_empty")),
        phone: yup_es/* string */.Z_().required(translatePopupAction("popup_register.not_entered_your_phoneNumber")).matches(sysconfig/* ENV_COUNTRY */.ng === "vn" ? PHONE_REGEX : PHONE_REGEX_CAM, translatePopupAction("popup_register.phone_not_correct_format")),
        email: yup_es/* string */.Z_().matches(EMAIL_REGEX, translatePopupAction("popup_register.email_not_correct_format"))
    }, leadSourceSchema)).required();
    var ref5 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,dist_yup/* yupResolver */.X)(schema)
    }), errors = ref5.formState.errors, control = ref5.control, handleSubmit = ref5.handleSubmit, reset = ref5.reset, watch = ref5.watch;
    var selectedLeadSource = watch("leadSource");
    (0,react.useEffect)(function() {
        var getListProvince = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var ref, provinceResult, _tmp, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                AddressService/* default.getProvinces */.Z.getProvinces()
                            ];
                        case 1:
                            provinceResult = _state.sent();
                            setProvinces(provinceResult);
                            _tmp = {};
                            reset((_tmp.provinceCode = (ref = provinceResult[0]) === null || ref === void 0 ? void 0 : ref.value, _tmp));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getListProvince() {
                return _ref.apply(this, arguments);
            };
        }();
        getListProvince();
    }, [
        reset
    ]);
    var handleSubmitSignUp = (0,react.useCallback)(function(data) {
        // validate
        if (validateSignUp(data, function(error) {
            if (error) {
                var newError = {};
                newError[error.type] = true;
            // setErrors({ ...newError });
            }
        }, translatePopupAction)) {
            // Lead tracking: registerURL is always sent (backend reads UTM from it, last-click UTM landing URL);
            // leadSource / otherSourceDetail only when the field is shown and selected.
            var leadSource = data.leadSource, otherSourceDetail = data.otherSourceDetail, restData = (0,src_object_without_properties/* default */.Z)(data, [
                "leadSource",
                "otherSourceDetail"
            ]);
            var signUpData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restData), {
                registerURL: (0,registerURL/* getRegisterURL */.RQ)()
            });
            if (hasLeadSources && leadSource) {
                signUpData.leadSource = leadSource;
                if (leadSource === LEAD_SOURCE_OTHER) {
                    signUpData.otherSourceDetail = otherSourceDetail;
                }
            }
            onClickSignUp(signUpData);
        }
    }, [
        onClickSignUp,
        hasLeadSources
    ]);
    var handleClickSignIn = (0,react.useCallback)(function(e) {
        e.preventDefault();
        onClickSignIn();
    }, [
        onClickSignIn
    ]);
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var handleClickTerms = (0,react.useCallback)(function(e) {
        e.preventDefault();
        router.push("/?terms=true");
        setPage(page + 2);
        handleScrollTop();
    }, [
        page
    ]);
    var IconAccount = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircleOutlined/* default */.Z, {})
    });
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconPhone = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: !showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOffOutlined/* default */.Z, {})
        })
    });
    var IconInviter = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleOutlined/* default */.Z, {})
    });
    var IconEmail = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailOutlined/* default */.Z, {})
    });
    var IconOtherSource = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOutlined/* default */.Z, {})
    });
    var labelAgree = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            translatePopupAction("popup_register.agree_policy"),
            "\xa0",
            beta && dist_lib/* isMobile */.tq ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                component: "a",
                onClick: handleClickTerms,
                style: {
                    color: "#005c29"
                },
                children: translatePopupAction("popup_register.policy")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/terms-and-condition",
                target: "_blank",
                rel: "noreferrer",
                style: {
                    color: "#005c29"
                },
                children: translatePopupAction("popup_register.policy")
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(className, (NewSignUpForm_styles_module_default()).form_sign_up),
        children: [
            beta && dist_lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (NewSignUpForm_styles_module_default()).wrapperTitle,
                style: {
                    marginTop: "60px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "title",
                    children: translatePopupAction("popup_register.title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: className,
                onSubmit: handleSubmit(handleSubmitSignUp),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "name",
                        defaultValue: "",
                        control: control,
                        className: (NewSignUpForm_styles_module_default()).form_control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                        startAdornment: IconAccount,
                                        placeholder: translatePopupAction("popup_register.username"),
                                        variant: "outlined",
                                        error: !!errors.name || false,
                                        className: (NewSignUpForm_styles_module_default()).input,
                                        "data-test": "signup-username"
                                    }, field)),
                                    ((ref = errors.name) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signup-err-username",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.name) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "phone",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                        startAdornment: IconPhone,
                                        placeholder: translatePopupAction("popup_register.phone_number"),
                                        variant: "outlined",
                                        error: !!errors.phone || false,
                                        className: (NewSignUpForm_styles_module_default()).input,
                                        "data-test": "signup-phone"
                                    }, field)),
                                    ((ref = errors.phone) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signup-err-phone",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.phone) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "email",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                        startAdornment: IconEmail,
                                        placeholder: translatePopupAction("popup_register.email"),
                                        variant: "outlined",
                                        error: !!errors.email || false,
                                        className: (NewSignUpForm_styles_module_default()).input,
                                        "data-test": "signup-email"
                                    }, field)),
                                    ((ref = errors.email) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signup-err-email",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.email) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "password",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                        type: showPassword ? "text" : "password",
                                        autoComplete: "password",
                                        startAdornment: IconPassword,
                                        endAdornment: IconEndPassword,
                                        placeholder: translatePopupAction("popup_register.password"),
                                        variant: "outlined",
                                        error: !!errors.password || false,
                                        className: (NewSignUpForm_styles_module_default()).input,
                                        "data-test": "signup-password"
                                    }, field)),
                                    ((ref = errors.password) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signup-err-password",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "provinceCode",
                        defaultValue: (ref = provinces[0]) === null || ref === void 0 ? void 0 : ref.value,
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchableSelect, {
                                    ref: field.ref,
                                    id: "signup-provinceCode",
                                    name: field.name,
                                    value: field.value,
                                    onChange: field.onChange,
                                    onBlur: field.onBlur,
                                    options: provinces,
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {}),
                                    placeholder: translatePopupAction("popup_register.choose_province"),
                                    searchPlaceholder: translatePopupAction("popup_register.search_province"),
                                    noResultsText: translatePopupAction("popup_register.no_results"),
                                    className: (NewSignUpForm_styles_module_default()).select_field,
                                    "data-test": "signup-provinceCode"
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "referCode",
                        defaultValue: referCode,
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                    startAdornment: IconInviter,
                                    value: referCode,
                                    placeholder: referCode || translatePopupAction("popup_register.referral_number"),
                                    variant: "outlined",
                                    // disabled={!!referCode}
                                    className: (NewSignUpForm_styles_module_default()).input,
                                    "data-test": "signup-referCode"
                                }, field))
                            });
                        }
                    }),
                    hasLeadSources && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "leadSource",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchableSelect, {
                                        ref: field.ref,
                                        id: "signup-leadSource",
                                        name: field.name,
                                        value: field.value,
                                        onChange: field.onChange,
                                        onBlur: field.onBlur,
                                        options: leadSourceOptions,
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignOutlined/* default */.Z, {}),
                                        placeholder: "".concat(translatePopupAction("popup_register.lead_source_placeholder", {
                                            brandname: Enums/* BRAND_NAME */.RS
                                        }), " *"),
                                        searchPlaceholder: translatePopupAction("popup_register.search_lead_source"),
                                        noResultsText: translatePopupAction("popup_register.no_results"),
                                        error: !!errors.leadSource,
                                        className: (NewSignUpForm_styles_module_default()).select_field,
                                        "data-test": "signup-leadSource"
                                    }),
                                    ((ref = errors.leadSource) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signup-err-leadSource",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.leadSource) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    hasLeadSources && selectedLeadSource === LEAD_SOURCE_OTHER && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "otherSourceDetail",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        startAdornment: IconOtherSource,
                                        placeholder: translatePopupAction("popup_register.other_source_detail_placeholder"),
                                        variant: "outlined",
                                        error: !!errors.otherSourceDetail || false,
                                        className: (NewSignUpForm_styles_module_default()).input,
                                        "data-test": "signup-otherSourceDetail"
                                    }, field), {
                                        value: field.value || ""
                                    })),
                                    ((ref = errors.otherSourceDetail) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signup-err-otherSourceDetail",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.otherSourceDetail) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "scope",
                        defaultValue: Enums/* ENUM_SCOPE.PHARMACY */.hD.PHARMACY,
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                className: (NewSignUpForm_styles_module_default()).scope_field,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchableSelect, {
                                    ref: field.ref,
                                    id: "signup-scope",
                                    name: field.name,
                                    value: field.value,
                                    onChange: field.onChange,
                                    onBlur: field.onBlur,
                                    options: scopeOptions,
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalHospital/* default */.Z, {}),
                                    placeholder: translatePopupAction("popup_register.choose_your_business_type"),
                                    searchPlaceholder: translatePopupAction("popup_register.search_business_type"),
                                    noResultsText: translatePopupAction("popup_register.no_results"),
                                    className: (NewSignUpForm_styles_module_default()).select_field,
                                    "data-test": "signup-scope"
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        className: (NewSignUpForm_styles_module_default()).disclaimer,
                        children: translatePopupAction("popup_register.message_confirm_signup_account").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "isCheckAgree",
                        defaultValue: false,
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (NewSignUpForm_styles_module_default()).agree_term,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CheckBox */.Jg, (0,src_object_spread/* default */.Z)({
                                    "data-test": "signup-isCheckAgree",
                                    label: labelAgree
                                }, field))
                            });
                        }
                    }),
                    dist_lib/* isDesktop */.nI && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((NewSignUpForm_styles_module_default()).link_login_wrapper, " ").concat((NewSignUpForm_styles_module_default()).center),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                translatePopupAction("popup_register.have_account"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#top",
                                    className: (NewSignUpForm_styles_module_default()).link_login,
                                    onClick: handleClickSignIn,
                                    children: translatePopupAction("popup_register.login")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: (NewSignUpForm_styles_module_default()).center,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            className: (NewSignUpForm_styles_module_default()).btn_register,
                            type: "submit",
                            "data-test": "signup-submit",
                            children: translatePopupAction("popup_register.create_account")
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var mocules_NewSignUpForm = (NewSignUpForm);

;// CONCATENATED MODULE: ./src/components/mocules/OrderDetailInfo/index.js











var NOT_YET = "(Chưa c\xf3)";
var OrderDetailInfo_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            flexGrow: 1
        },
        paper: {
            padding: theme.spacing(2)
        }
    };
});
var OrderDetailInfo = function(param) {
    var customerName = param.customerName, masterAddress = param.masterAddress, customerEmail = param.customerEmail, customerPhone = param.customerPhone, note = param.note, deliveryTrackingNumber = param.deliveryTrackingNumber, deliveryDate = param.deliveryDate, deliveryCarrier = param.deliveryCarrier, deliveryMethodName = param.deliveryMethodName, paymentMethod = param.paymentMethod, _invoice = param.invoice, invoice = _invoice === void 0 ? {} : _invoice;
    var ref = useTranslation("common"), translateCommon = ref.t;
    var ref1 = useTranslation("detailOrders"), translateOrderDetail = ref1.t;
    var classes = OrderDetailInfo_useStyles();
    var _invoiceRequest = invoice.invoiceRequest, invoiceRequest = _invoiceRequest === void 0 ? false : _invoiceRequest, companyName = invoice.companyName, companyAddress = invoice.companyAddress, taxCode = invoice.taxCode, mst = invoice.mst, email = invoice.email;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.info,
        children: /*#__PURE__*/ _jsxs(Grid, {
            container: true,
            spacing: 2,
            className: styles.info_inner_grid,
            children: [
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 5,
                    className: styles.info_adress,
                    children: /*#__PURE__*/ _jsxs(Paper, {
                        className: classes.paper,
                        elevation: 3,
                        classes: {
                            root: styles.info_left_paper
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: translateOrderDetail("receiver_name")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: clsx(styles.info_value, styles.ellipsis_1_line),
                                children: customerName
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: translateOrderDetail("receiver_address")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: clsx(styles.info_value, styles.ellipsis_2_line),
                                children: masterAddress
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: translateOrderDetail("phone_number")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: styles.info_value,
                                children: customerPhone
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: "Email"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: clsx(styles.info_value, styles.ellipsis_1_line),
                                children: customerEmail || NOT_YET
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    item: true,
                    xs: 7,
                    container: true,
                    spacing: 2,
                    direction: "column",
                    className: styles.info_container,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            className: styles.info_container,
                            children: /*#__PURE__*/ _jsxs(Paper, {
                                className: classes.paper,
                                elevation: 3,
                                children: [
                                    /*#__PURE__*/ _jsxs(Grid, {
                                        children: [
                                            /*#__PURE__*/ _jsxs(Typography, {
                                                display: "inline",
                                                variant: "h5",
                                                className: styles.info_label,
                                                children: [
                                                    translateOrderDetail("payment_method"),
                                                    ":"
                                                ]
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(Typography, {
                                                display: "inline",
                                                variant: "h6",
                                                className: styles.info_value,
                                                children: translateCommon(paymentMethod)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Grid, {
                                        children: paymentMethod !== "PAYMENT_METHOD_NORMAL" && /*#__PURE__*/ _jsxs(Alert, {
                                            className: styles.bank_info,
                                            icon: false,
                                            severity: "info",
                                            children: [
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Chủ t\xe0i khoản \xa0\xa0\xa0\xa0\xa0\xa0"
                                                        }),
                                                        "C\xf4ng Ty TNHH Buymed"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Số t\xe0i khoản \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                                                        }),
                                                        "1913 45430 30020"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Ng\xe2n h\xe0ng \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                                                        }),
                                                        "Ng\xe2n h\xe0ng Techcombank - Chi nh\xe1nh Bắc Hải"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Nội dung \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                                                        }),
                                                        "M\xe3 đơn h\xe0ng - T\xean nh\xe0 thuốc"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            className: styles.info_container,
                            children: /*#__PURE__*/ _jsxs(Paper, {
                                className: classes.paper,
                                elevation: 3,
                                children: [
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("delivery_method"),
                                            ":\xa0",
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    deliveryMethodName,
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("shipping_unit"),
                                            ":\xa0",
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    deliveryCarrier || NOT_YET,
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("date"),
                                            ":\xa0",
                                            /*#__PURE__*/ _jsx("span", {
                                                children: deliveryDate ? DateTimeUtils.getFormattedWithDate(new Date(deliveryDate), translateCommon) : NOT_YET
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("order_number"),
                                            ":\xa0",
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    deliveryTrackingNumber || NOT_YET,
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            className: styles.info_container,
                            children: /*#__PURE__*/ _jsxs(Paper, {
                                className: classes.paper,
                                elevation: 3,
                                children: [
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("note"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "h6",
                                        className: styles.info_value,
                                        children: note || NOT_YET
                                    })
                                ]
                            })
                        })
                    ]
                }),
                invoiceRequest && /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    className: styles.info_address,
                    children: /*#__PURE__*/ _jsxs(Paper, {
                        className: classes.paper,
                        elevation: 3,
                        classes: {
                            root: styles.info_left_paper
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h4",
                                className: styles.info_title,
                                children: translateOrderDetail("export_invoice_info")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: clsx(styles.info_label),
                                children: /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        translateOrderDetail("company_name"),
                                        ":\xa0",
                                        /*#__PURE__*/ _jsx("span", {
                                            children: companyName
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h5",
                                className: clsx(styles.info_label),
                                children: [
                                    translateOrderDetail("tax_code"),
                                    ":\xa0",
                                    /*#__PURE__*/ _jsx("span", {
                                        children: taxCode || mst
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: [
                                    translateOrderDetail("address_export_invoice"),
                                    ":\xa0",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: styles.break_down,
                                        children: companyAddress
                                    })
                                ]
                            }),
                            email && /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: [
                                    "Email:\xa0",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: styles.break_down,
                                        children: email
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_OrderDetailInfo = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(OrderDetailInfo))));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/mocules/SellerInfo/index.js
var SellerInfo = __webpack_require__(69200);
;// CONCATENATED MODULE: ./src/components/mocules/OrderDetailProduct/index.js
/* eslint-disable no-nested-ternary */ /* eslint-disable no-shadow */ /* react/self-closing-comp */ 










































var STATUS_CHECK_DELIVER = (/* unused pure expression or super */ null && ([
    "WAIT_TO_DELIVER",
    "DELIVERING",
    "DELIVERED",
    "COMPLETED"
]));
var OrderDetailProduct = function(param) {
    var products = param.products, promoName = param.promoName, totalDiscount = param.totalDiscount, totalPriceAll = param.totalPrice, paymentMethodFee = param.paymentMethodFee, deliveryMethodFee = param.deliveryMethodFee, price = param.price, _extraFee = param.extraFee, extraFee = _extraFee === void 0 ? 0 : _extraFee, status = param.status, orderItems = param.orderItems, _point = param.point, point = _point === void 0 ? null : _point;
    var ref = _sliced_to_array(useModal(), 2), isShowOutBoundInfo = ref[0], toggle = ref[1];
    var ref1 = _sliced_to_array(useModal(), 2), isShowPopupConfirm = ref1[0], togglePopupConfirm = ref1[1];
    var totalReturnedPrice = 0;
    var productsReturn = [];
    var totalUndeliverablePrice = 0;
    var undeliverableProducts = [];
    var ref2 = useCart(), updateCartItem = ref2.updateCartItem, updateCart = ref2.updateCart, cartItems = ref2.cartItems;
    // kiểm tra có có sản phẩm xuất kho chưa
    var checkOutbondProducts = !!(products === null || products === void 0 ? void 0 : products.find(function(product) {
        return (product === null || product === void 0 ? void 0 : product.outboundQuantity) >= 0 && (product === null || product === void 0 ? void 0 : product.outboundInfos);
    }));
    var isShowOutboundUndeliverable = !!products.find(function(product) {
        return (product === null || product === void 0 ? void 0 : product.outboundQuantity) > 0;
    });
    // kiểm tra có sản phẩm nào không giao
    var checkUndeliverableProducts = !!products.find(function(product) {
        return (product === null || product === void 0 ? void 0 : product.quantity) - ((product === null || product === void 0 ? void 0 : product.outboundQuantity) || 0) > 0;
    });
    if (STATUS_CHECK_DELIVER.indexOf(status) >= 0 && checkUndeliverableProducts) {
        var ref3;
        undeliverableProducts = (ref3 = products.filter(function(product) {
            return (product === null || product === void 0 ? void 0 : product.quantity) - ((product === null || product === void 0 ? void 0 : product.outboundQuantity) || 0) > 0;
        })) === null || ref3 === void 0 ? void 0 : ref3.map(function(product, index) {
            var tmp = product.price, salePrice = tmp === void 0 ? 0 : tmp, quantity = product.quantity, _outboundQuantity = product.outboundQuantity, outboundQuantity = _outboundQuantity === void 0 ? 0 : _outboundQuantity;
            var undeliverableQuantity = quantity - outboundQuantity;
            var undeliverablePrice = undeliverableQuantity * salePrice;
            totalUndeliverablePrice += undeliverablePrice;
            return _object_spread_props(_object_spread({}, product), {
                index: index,
                undeliverableQuantity: undeliverableQuantity,
                undeliverablePrice: undeliverablePrice
            });
        });
    }
    // kiểm tra có sản phẩm nào trả lại hay không
    var checkReturnProducts = !!(products === null || products === void 0 ? void 0 : products.find(function(product) {
        return (product === null || product === void 0 ? void 0 : product.returnedQuantity) > 0;
    }));
    if (checkReturnProducts) {
        var ref4;
        productsReturn = (ref4 = products.filter(function(product) {
            return (product === null || product === void 0 ? void 0 : product.returnedQuantity) > 0;
        })) === null || ref4 === void 0 ? void 0 : ref4.map(function(product, index) {
            var tmp = product.price, salePrice = tmp === void 0 ? 0 : tmp, returnedQuantity = product.returnedQuantity;
            var productPrice = salePrice * returnedQuantity;
            totalReturnedPrice += productPrice;
            return _object_spread_props(_object_spread({}, product), {
                index: index,
                productPrice: productPrice
            });
        });
    }
    var handleReOrder = function() {
        if (!isShowPopupConfirm) {
            togglePopupConfirm();
        }
    };
    var handleClosePopup = function() {
        togglePopupConfirm();
    };
    // thêm sản phẩm không giao vào giỏ hàng
    var updateUndeliverableProductsCart = function() {
        var _ref = _async_to_generator(function() {
            var isReload, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReload = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _loop = function() {
                            var item, ref, product, _tmp, cartQuantity, _tmp1;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        item = _step.value;
                                        _tmp = {};
                                        product = (_tmp.isDeal = item.productInfo.isDeal, _tmp.name = item.productInfo.name, _tmp.price = item.price, _tmp.quantity = item.undeliverableQuantity, _tmp.sku = item.productInfo.sku, _tmp.type = item.type, _tmp);
                                        cartQuantity = ((ref = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartProduct) {
                                            return (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.productId) === (item === null || item === void 0 ? void 0 : item.productID);
                                        })) === null || ref === void 0 ? void 0 : ref.quantity) || 0;
                                        _tmp1 = {};
                                        // eslint-disable-next-line no-await-in-loop
                                        return [
                                            4,
                                            updateCartItem((_tmp1.product = product, _tmp1.q = cartQuantity + item.undeliverableQuantity, _tmp1), isReload)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = undeliverableProducts[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        return [
                            5,
                            _ts_values(_loop())
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            4,
                            updateCart()
                        ];
                    case 9:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function updateUndeliverableProductsCart() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            STATUS_CHECK_DELIVER.indexOf(status) >= 0 && checkUndeliverableProducts && isShowOutboundUndeliverable ? /*#__PURE__*/ _jsxs(TableContainer, {
                component: Paper,
                className: styles.table,
                elevation: 4,
                children: [
                    /*#__PURE__*/ _jsxs(Grid, {
                        container: true,
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: styles.title_list,
                                    children: "Danh s\xe1ch sản phẩm kh\xf4ng giao"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Grid, {
                                item: true,
                                children: [
                                    /*#__PURE__*/ _jsx(Tooltip, {
                                        title: "Th\xeam lại sản phẩm v\xe0o giỏ h\xe0ng",
                                        children: /*#__PURE__*/ _jsx(IconButton, {
                                            size: "small",
                                            className: styles.btn,
                                            onClick: handleReOrder,
                                            children: /*#__PURE__*/ _jsx(ShoppingCartIcon, {
                                                className: styles.icon
                                            })
                                        })
                                    }),
                                    isShowPopupConfirm && /*#__PURE__*/ _jsx(CustomModal, {
                                        icon: false,
                                        visible: isShowPopupConfirm,
                                        onClose: handleClosePopup,
                                        title: "Đặt h\xe0ng lại",
                                        content: "Bạn c\xf3 muốn th\xeam ".concat(undeliverableProducts.length, " sản phẩm kh\xf4ng giao được trong đơn h\xe0ng v\xe0o giỏ h\xe0ng hiện tại?"),
                                        btnOk: "Th\xeam v\xe0o giỏ h\xe0ng",
                                        onClickOk: updateUndeliverableProductsCart
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Table, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHead, {
                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            children: "STT"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "left",
                                            children: "Sản phẩm"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Số lượng kh\xf4ng giao"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Gi\xe1 (đ)"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Tổng cộng (đ)"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(TableBody, {
                                children: [
                                    undeliverableProducts.map(function(product) {
                                        var salePrice = product.price, index = product.index, undeliverableQuantity = product.undeliverableQuantity, undeliverablePrice = product.undeliverablePrice;
                                        var ref = (product === null || product === void 0 ? void 0 : product.productInfo) || {}, _name = ref.name, name = _name === void 0 ? "" : _name, slug = ref.slug;
                                        return /*#__PURE__*/ _jsx(React.Fragment, {
                                            children: (product === null || product === void 0 ? void 0 : product.quantity) - ((product === null || product === void 0 ? void 0 : product.outboundQuantity) || 0) > 0 ? /*#__PURE__*/ _jsx(_Fragment, {
                                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "left",
                                                            children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                variant: "h5",
                                                                className: styles.product_name,
                                                                href: "/product/".concat(slug || ""),
                                                                prefetch: false,
                                                                padding: "0px",
                                                                children: name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            children: formatNumber(undeliverableQuantity || 0)
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            children: formatNumber(salePrice)
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            children: formatNumber(undeliverablePrice)
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                        }, uuidV4());
                                    }),
                                    /*#__PURE__*/ _jsxs(TableRow, {
                                        children: [
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right",
                                                children: /*#__PURE__*/ _jsx("b", {
                                                    children: "Tổng Cộng"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right",
                                                children: /*#__PURE__*/ _jsx("b", {
                                                    children: formatCurrency(totalUndeliverablePrice)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
            /*#__PURE__*/ _jsxs(TableContainer, {
                component: Paper,
                className: styles.table,
                elevation: 4,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.title_list,
                        children: "Danh s\xe1ch sản phẩm đ\xe3 đặt"
                    }),
                    /*#__PURE__*/ _jsxs(Table, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHead, {
                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "left",
                                            children: checkOutbondProducts && /*#__PURE__*/ _jsx(Button, {
                                                onClick: toggle,
                                                className: styles.toggle_button,
                                                children: isShowOutBoundInfo ? /*#__PURE__*/ _jsx(ExpandMoreIcon, {}) : /*#__PURE__*/ _jsx(ExpandLessIcon, {})
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {}),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            colSpan: status !== "COMPLETED" ? "2" : "1",
                                            children: "Sản phẩm"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "center",
                                            children: "L\xf4/ HSD"
                                        }),
                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(Tooltip, {
                                            title: "Điểm t\xedch lũy của từng sản phẩm được l\xe0m tr\xf2n xuống, t\xednh đến số thập ph\xe2n số 2",
                                            children: /*#__PURE__*/ _jsxs(TableCell, {
                                                align: "center",
                                                children: [
                                                    "Tổng điểm t\xedch lũy",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: styles.icon_point,
                                                        children: /*#__PURE__*/ _jsx(ErrorRoundedIcon, {})
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "center",
                                            children: "Số lượng"
                                        }),
                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                            align: "center",
                                            children: "Số lượng thực nhận"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "center",
                                            children: "Gi\xe1 (đ)"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Tổng cộng (đ)"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(TableBody, {
                                children: [
                                    products && products.map(function(product) {
                                        var ref, ref1;
                                        var salePrice = product.price, totalPrice = product.totalPrice, quantity = product.quantity, isImportant = product.isImportant, _comboList = product.comboList, comboList = _comboList === void 0 ? [] : _comboList, outboundInfos = product.outboundInfos, outboundQuantity = product.outboundQuantity, type = product.type, skuProduct = product.sku, _totalPoint = product.totalPoint, totalPoint = _totalPoint === void 0 ? null : _totalPoint;
                                        var ref2 = (product === null || product === void 0 ? void 0 : product.productInfo) || {}, _imagesProxy = ref2.imagesProxy, imagesProxy = _imagesProxy === void 0 ? [] : _imagesProxy, _name = ref2.name, name = _name === void 0 ? "" : _name, _slug = ref2.slug, slug = _slug === void 0 ? "" : _slug, _seller = ref2.seller, seller = _seller === void 0 ? null : _seller, isGift = ref2.isGift, tags = ref2.tags, statusData = ref2.statusData, requireGPPMessage = ref2.requireGPPMessage;
                                        return /*#__PURE__*/ _jsxs(React.Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsxs(TableRow, {
                                                    className: clsx(styles.product_row, (comboList === null || comboList === void 0 ? void 0 : comboList.length) > 0 ? styles.has_combo : ""),
                                                    children: [
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "center",
                                                            children: /*#__PURE__*/ _jsx(StarIcon, {
                                                                style: {
                                                                    color: isImportant ? "#f9b514" : ""
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                href: "/product/".concat(slug || ""),
                                                                children: /*#__PURE__*/ _jsx(Image, {
                                                                    loader: myLoader,
                                                                    src: !isEmpty(imagesProxy) ? getLinkGCS("".concat(imagesProxy[0])) : MISSING_IMAGE,
                                                                    alt: name,
                                                                    width: 120,
                                                                    height: 80
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs(TableCell, {
                                                            align: "left",
                                                            className: styles.product_table_name,
                                                            colSpan: status !== "COMPLETED" ? "2" : "1",
                                                            children: [
                                                                isGift ? name : /*#__PURE__*/ _jsxs(_Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(LinkComp, {
                                                                            variant: "h5",
                                                                            href: "/product/".concat(slug || ""),
                                                                            className: styles.product_name,
                                                                            padding: "0px",
                                                                            children: name
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: styles.product_tags,
                                                                            children: [
                                                                                (type === "DEAL" || type === "CAMPAIGN") && tags.indexOf("CAMPAIGN") === -1 && tags.indexOf("DEAL") === -1 && /*#__PURE__*/ _jsx(Link, {
                                                                                    href: "/deals",
                                                                                    prefetch: false,
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: styles.discount_flag,
                                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                                            className: styles.discount_flag_text,
                                                                                            children: "Khuyến m\xe3i"
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                orderItems && ((ref = orderItems === null || orderItems === void 0 ? void 0 : orderItems.find(function(param) {
                                                                                    var sku = param.sku;
                                                                                    return sku === skuProduct;
                                                                                })) === null || ref === void 0 ? void 0 : (ref1 = ref.tags) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                                                                    /*#__PURE__*/ return _jsx(TagType, {
                                                                                        item: item,
                                                                                        exp: (statusData === null || statusData === void 0 ? void 0 : statusData.date) || null
                                                                                    }, uuidV4());
                                                                                })) || "",
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: orderItems && (orderItems === null || orderItems === void 0 ? void 0 : orderItems.find(function(param) {
                                                                                        var sku = param.sku;
                                                                                        return sku === skuProduct;
                                                                                    }).type) === "DEAL" && tags.indexOf("DEAL") > -1 && /*#__PURE__*/ _jsx(TagType, {
                                                                                        item: "DEAL",
                                                                                        exp: (statusData === null || statusData === void 0 ? void 0 : statusData.date) || null
                                                                                    }, uuidV4())
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                isGift && /*#__PURE__*/ _jsx("div", {
                                                                    className: styles.product_tags,
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: styles.gift_flag,
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            className: styles.gift_flag_text,
                                                                            children: "Qu\xe0 tặng"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(_Fragment, {
                                                                    children: requireGPPMessage && /*#__PURE__*/ _jsx(Typography, {
                                                                        className: styles.text_danger,
                                                                        children: requireGPPMessage
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right"
                                                        }),
                                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            className: styles.product_price,
                                                            children: formatFloatNumber(totalPoint) || 0
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            className: styles.product_price,
                                                            children: formatNumber(quantity)
                                                        }),
                                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            className: styles.product_price,
                                                            children: formatNumber(product === null || product === void 0 ? void 0 : product.completedQuantity)
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            className: styles.product_price,
                                                            children: isGift ? "-" : formatNumber(salePrice)
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            children: isGift ? "-" : formatNumber(totalPrice)
                                                        })
                                                    ]
                                                }, uuidV4()),
                                                (comboList === null || comboList === void 0 ? void 0 : comboList.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(TableRow, {
                                                            className: styles.combo_head,
                                                            children: [
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "left",
                                                                    colSpan: "4",
                                                                    children: "Mua combo bao gồm"
                                                                })
                                                            ]
                                                        }),
                                                        comboList === null || comboList === void 0 ? void 0 : comboList.map(function(item, key) {
                                                            var ref;
                                                            var name = item.name, slug = item.slug, isGift = item.isGift, price = item.price, tags = item.tags, _quantity = item.quantity, quantity = _quantity === void 0 ? 0 : _quantity, totalPrice = item.totalPrice, productId = item.productId;
                                                            return /*#__PURE__*/ _jsxs(TableRow, {
                                                                className: clsx(styles.combo_row, comboList.length - 1 === key ? styles.last : ""),
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(TableCell, {
                                                                        align: "left",
                                                                        className: styles.product_table_name,
                                                                        children: [
                                                                            isGift ? /*#__PURE__*/ _jsx(Typography, {
                                                                                className: styles.cb_unlink,
                                                                                children: name
                                                                            }) : /*#__PURE__*/ _jsx(LinkComp, {
                                                                                className: styles.cb_link,
                                                                                href: "/product/".concat(slug),
                                                                                prefetch: false,
                                                                                children: name
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: styles.product_tags,
                                                                                children: tags && ((ref = tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
                                                                                    return tag === ENUM_TAG_CODES.HOADONNHANH || tag === TAG_HANG_DAT_TRUOC;
                                                                                })) === null || ref === void 0 ? void 0 : ref.map(function(tag) {
                                                                                    return /*#__PURE__*/ _jsx(TagType, {
                                                                                        item: tag
                                                                                    }, uuidV4());
                                                                                }))
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right",
                                                                        className: styles.product_price,
                                                                        children: formatNumber(quantity)
                                                                    }),
                                                                    status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right",
                                                                        className: styles.product_price,
                                                                        children: isGift ? "-" : formatNumber(price)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right",
                                                                        children: isGift ? "Qu\xe0 Tặng" : formatNumber(totalPrice)
                                                                    })
                                                                ]
                                                            }, productId);
                                                        })
                                                    ]
                                                }),
                                                isShowOutBoundInfo && outboundQuantity >= 0 && outboundInfos ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(TableRow, {
                                                            className: styles.combo_head,
                                                            style: {
                                                                background: " rgba(224, 224, 224, 1)"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "left",
                                                                    colSpan: "4",
                                                                    style: {
                                                                        paddingTop: "15px"
                                                                    },
                                                                    children: "Danh s\xe1ch sản phẩm xuất kho"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                })
                                                            ]
                                                        }),
                                                        outboundInfos === null || outboundInfos === void 0 ? void 0 : outboundInfos.map(function(info) {
                                                            /*#__PURE__*/ return _jsxs(TableRow, {
                                                                style: {
                                                                    background: " rgba(246, 246, 247, 1)"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "left",
                                                                        children: /*#__PURE__*/ _jsxs(LinkComp, {
                                                                            variant: "h5",
                                                                            className: styles.product_name,
                                                                            href: "/product/".concat(slug || ""),
                                                                            prefetch: false,
                                                                            padding: "0px",
                                                                            children: [
                                                                                name,
                                                                                "h"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(TableCell, {
                                                                        align: "center",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                                className: styles.cb_unlink,
                                                                                children: info === null || info === void 0 ? void 0 : info.lot
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                                className: styles.cb_unlink,
                                                                                children: info === null || info === void 0 ? void 0 : info.expDate
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right",
                                                                        children: info.quantity
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    })
                                                                ]
                                                            }, uuidV4());
                                                        }),
                                                        comboList && (comboList === null || comboList === void 0 ? void 0 : comboList.map(function(item) {
                                                            var ref;
                                                            return item === null || item === void 0 ? void 0 : (ref = item.outboundInfos) === null || ref === void 0 ? void 0 : ref.map(function(info) {
                                                                /*#__PURE__*/ return _jsxs(TableRow, {
                                                                    style: {
                                                                        background: " rgba(246, 246, 247, 1)"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "left",
                                                                            children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                                variant: "h5",
                                                                                className: styles.product_name,
                                                                                href: "/product/".concat(slug || ""),
                                                                                prefetch: false,
                                                                                padding: "0px",
                                                                                children: item.name
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs(TableCell, {
                                                                            align: "center",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Typography, {
                                                                                    className: styles.cb_unlink,
                                                                                    children: info === null || info === void 0 ? void 0 : info.lot
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Typography, {
                                                                                    className: styles.cb_unlink,
                                                                                    children: info === null || info === void 0 ? void 0 : info.expDate
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right",
                                                                            children: info.quantity
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        }),
                                                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        })
                                                                    ]
                                                                }, uuidV4());
                                                            });
                                                        }))
                                                    ]
                                                }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                            ]
                                        }, uuidV4());
                                    }),
                                    /*#__PURE__*/ _jsxs(TableRow, {
                                        className: styles.product_row,
                                        children: [
                                            status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right"
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right"
                                            }),
                                            /*#__PURE__*/ _jsxs(TableCell, {
                                                align: "right",
                                                colSpan: "5",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: "Tạm t\xednh :"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: "Ph\xed theo h\xecnh thức thanh to\xe1n :"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: "Ph\xed vận chuyển :"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: "Phụ ph\xed:"
                                                    }),
                                                    !isEmpty(promoName) && /*#__PURE__*/ _jsxs("div", {
                                                        className: styles.total_bottom,
                                                        children: [
                                                            "M\xe3 giảm gi\xe1 ",
                                                            /*#__PURE__*/ _jsxs("strong", {
                                                                children: [
                                                                    promoName,
                                                                    " :"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    status === "COMPLETED" && /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        style: {
                                                            fontWeight: "bold"
                                                        },
                                                        children: "Tổng điểm t\xedch lũy:"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(TableCell, {
                                                align: "right",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(price)
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(paymentMethodFee)
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(deliveryMethodFee)
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(extraFee)
                                                    }),
                                                    !isEmpty(promoName) && /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(-totalDiscount)
                                                    }),
                                                    status === "COMPLETED" && /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        style: {
                                                            fontWeight: "bold"
                                                        },
                                                        children: formatFloatNumber(point)
                                                    })
                                                ]
                                            })
                                        ]
                                    }, uuidV4())
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Grid, {
                        className: styles.total_price,
                        container: true,
                        justifyContent: "flex-end",
                        style: {
                            padding: " 0px 15px 30px 15px"
                        },
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.price_label,
                                children: /*#__PURE__*/ _jsx("b", {
                                    children: "Tổng cộng"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.price,
                                children: formatCurrency(totalPriceAll)
                            })
                        ]
                    })
                ]
            }),
            (status === "DELIVERED" || status === "COMPLETED") && checkReturnProducts ? /*#__PURE__*/ _jsxs(TableContainer, {
                component: Paper,
                className: styles.table,
                elevation: 4,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.title_list,
                        children: "Danh s\xe1ch sản phẩm trả h\xe0ng"
                    }),
                    /*#__PURE__*/ _jsxs(Table, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHead, {
                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            children: "STT"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "left",
                                            children: "Sản phẩm"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "left",
                                            children: "L\xf4/ HSD"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Số lượng trả"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Gi\xe1 (đ)"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Tổng cộng (đ)"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(TableBody, {
                                children: [
                                    productsReturn.map(function(product) {
                                        var ref, ref1;
                                        var salePrice = product.price, _returnInfos = product.returnInfos, returnInfos = _returnInfos === void 0 ? [] : _returnInfos, returnedQuantity = product.returnedQuantity, index = product.index, productPrice = product.productPrice;
                                        var ref2 = (product === null || product === void 0 ? void 0 : product.productInfo) || {}, _name = ref2.name, name = _name === void 0 ? "" : _name, slug = ref2.slug;
                                        return /*#__PURE__*/ _jsx(React.Fragment, {
                                            children: returnedQuantity > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs(TableRow, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                children: index + 1
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "left",
                                                                children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                    variant: "h5",
                                                                    className: styles.product_name,
                                                                    href: "/product/".concat(slug || ""),
                                                                    prefetch: false,
                                                                    padding: "0px",
                                                                    children: name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "left",
                                                                children: returnInfos.length === 1 ? "".concat(((ref = returnInfos[0]) === null || ref === void 0 ? void 0 : ref.lot) || "", "/ ").concat(((ref1 = returnInfos[0]) === null || ref1 === void 0 ? void 0 : ref1.expDate) || "") : "-"
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "right",
                                                                children: formatNumber(returnedQuantity)
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "right",
                                                                children: formatNumber(salePrice)
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "right",
                                                                children: formatNumber(productPrice)
                                                            })
                                                        ]
                                                    }),
                                                    returnInfos.length > 1 && returnInfos.map(function(returnInfo) {
                                                        /*#__PURE__*/ return _jsxs(TableRow, {
                                                            style: {
                                                                background: " rgba(246, 246, 247, 1)"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx(TableCell, {}),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "left",
                                                                    children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                        variant: "h5",
                                                                        className: styles.product_name,
                                                                        href: "/product/".concat(slug || ""),
                                                                        prefetch: false,
                                                                        padding: "0px",
                                                                        children: name
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "left",
                                                                    children: "".concat((returnInfo === null || returnInfo === void 0 ? void 0 : returnInfo.lot) || "", "/ ").concat((returnInfo === null || returnInfo === void 0 ? void 0 : returnInfo.expDate) || "")
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right",
                                                                    children: formatNumber(returnInfo.quantity)
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                })
                                                            ]
                                                        }, uuidV4());
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                        }, uuidV4());
                                    }),
                                    /*#__PURE__*/ _jsxs(TableRow, {
                                        children: [
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right",
                                                children: /*#__PURE__*/ _jsx("b", {
                                                    children: "Tổng Cộng"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right",
                                                children: /*#__PURE__*/ _jsx("b", {
                                                    children: formatCurrency(totalReturnedPrice)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx(_Fragment, {})
        ]
    });
};
/* harmony default export */ var mocules_OrderDetailProduct = ((/* unused pure expression or super */ null && (OrderDetailProduct)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/StepConnector/StepConnector.js
var StepConnector = __webpack_require__(18530);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(52543);
;// CONCATENATED MODULE: ./src/components/mocules/OrderDetailStep/index.js

















var ColorlibConnector = (0,withStyles/* default */.Z)({
    alternativeLabel: {
        top: 40
    },
    active: {
        "& $line": {
            backgroundColor: "#005C29!important"
        }
    },
    completed: {
        "& $line": {
            backgroundColor: "#005C29!important"
        }
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: "#eaeaf0",
        borderRadius: 1
    }
})(StepConnector/* default */.Z);
var useColorlibStepIconStyles = (0,makeStyles/* default */.Z)({
    root: {
        backgroundColor: "white",
        border: "4px solid #ced4da",
        zIndex: 1,
        color: "#ced4da",
        width: 80,
        height: 80,
        display: "flex",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center"
    },
    active: {
        border: "4px solid #005C29",
        background: "white",
        color: "#005C29"
    },
    completed: {
        border: "4px solid #005C29",
        background: "white",
        color: "#005C29"
    }
});
function ColorlibStepIcon(param) {
    var icon = param.icon, active = param.active, completed = param.completed;
    var classes = useColorlibStepIconStyles();
    var icons = {
        1: /*#__PURE__*/ _jsx(AssignmentIcon, {
            fontSize: "large"
        }),
        2: /*#__PURE__*/ _jsx(AssignmentTurnedInIcon, {
            fontSize: "large"
        }),
        3: /*#__PURE__*/ _jsx(BusinessCenterIcon, {
            fontSize: "large"
        }),
        4: /*#__PURE__*/ _jsx(AirportShuttleIcon, {
            fontSize: "large"
        }),
        5: /*#__PURE__*/ _jsx(EventAvailableIcon, {
            fontSize: "large"
        }),
        6: /*#__PURE__*/ _jsx(CheckIcon, {
            fontSize: "large"
        })
    };
    var _obj;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(classes.root, (_obj = {}, _define_property(_obj, classes.active, active), _define_property(_obj, classes.completed, completed), _obj)),
        children: icons[String(icon)]
    });
}
var steps = (/* unused pure expression or super */ null && ([
    "Chờ x\xe1c nhận",
    "Đ\xe3 x\xe1c nhận",
    "Đang xử l\xfd",
    "Đang trung chuyển",
    "Đang giao h\xe0ng",
    "Đ\xe3 giao",
    "Ho\xe0n tất", 
]));
var _obj;
var MappingStep = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.WAIT_TO_CONFIRM */.TJ.WAIT_TO_CONFIRM, 0), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.CONFIRMED */.TJ.CONFIRMED, 1), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.PROCESSING */.TJ.PROCESSING, 2), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.WAIT_TO_DELIVER */.TJ.WAIT_TO_DELIVER, 2), // forbidden
(0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.DELIVERING */.TJ.DELIVERING, 3), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.DELIVERED */.TJ.DELIVERED, 4), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.COMPLETED */.TJ.COMPLETED, 5), _obj);
var OrderDetailStep = function(param) {
    var _status = param.status, status = _status === void 0 ? 1 : _status;
    return /*#__PURE__*/ _jsx(Stepper, {
        className: styles.step,
        alternativeLabel: true,
        activeStep: status !== "CANCEL" ? MappingStep[status] : -1,
        connector: /*#__PURE__*/ _jsx(ColorlibConnector, {}),
        children: steps.map(function(label) {
            return /*#__PURE__*/ _jsx(Step, {
                children: /*#__PURE__*/ _jsx(StepLabel, {
                    StepIconComponent: ColorlibStepIcon,
                    children: label
                })
            }, uuidv4());
        })
    });
};
/* harmony default export */ var mocules_OrderDetailStep = ((/* unused pure expression or super */ null && (OrderDetailStep)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./src/components/organisms/ExportDataOrderDetail/index.js
var organisms_ExportDataOrderDetail = __webpack_require__(98358);
// EXTERNAL MODULE: ./src/components/organisms/InvoiceList/index.js
var organisms_InvoiceList = __webpack_require__(66402);
// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var utils_NotifyUtils = __webpack_require__(25872);
;// CONCATENATED MODULE: ./src/components/mocules/ButtonReturnOrder/index.js



















function ButtonReturnOrder_ButtonReturnOrder(param) {
    var disabled = param.disabled, orderId = param.orderId, className = param.className, V2style = param.V2style;
    var ref = useTranslation("alert-action"), translateAlertAction = ref.t;
    var ref1 = useTranslation("detailOrders"), translateDetailOrders = ref1.t;
    var router = useRouter();
    var ref2 = _sliced_to_array(React.useState([]), 2), ticketReturn = ref2[0], setTicketReturn = ref2[1];
    var token = Cookies.get(ACCESS_TOKEN);
    var returnOrderRes = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var res;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        TicketClient.getTicketReturn(orderId)
                    ];
                case 1:
                    res = _state.sent();
                    setTicketReturn(getData(res));
                    return [
                        2
                    ];
            }
        });
    }), [
        orderId
    ]);
    React.useEffect(function() {
        returnOrderRes();
    }, []);
    var handleRedirectPOS = function() {
        var _ref = _async_to_generator(function() {
            var statusRes;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TicketClient.getVerifyTickerReturn(orderId)
                        ];
                    case 1:
                        statusRes = _state.sent();
                        if (isValidWithoutData(statusRes)) {
                            router.push("".concat(RETURN_ORDER_DOMAIN, "?token=").concat(token, "&orderId=").concat(orderId));
                        } else {
                            NotifyUtils.error(translateAlertAction("message_import_order_so_request_can_not_completed"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRedirectPOS() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(Grid, {
        className: styles.wrapBtn,
        children: ticketReturn.length > 0 ? ticketReturn === null || ticketReturn === void 0 ? void 0 : ticketReturn.map(function(param) {
            var code = param.code, ticketId = param.ticketId;
            return /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                alignItems: "center",
                justifyContent: "center",
                className: clsx(styles.wrapTicketId, className),
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        className: styles.ticketCode,
                        children: [
                            translateDetailOrders("detail-orders.return_request_form"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(LinkComp, {
                        style: {
                            color: "#2360d8",
                            cursor: "pointer",
                            fontSize: "16px"
                        },
                        href: "".concat(RETURN_ORDER_DOMAIN_TICKETID, "?ticketId=").concat(ticketId, "&token=").concat(token),
                        "aria-hidden": "true",
                        className: styles.redirectLink,
                        children: ticketId
                    })
                ]
            }, code);
        }) : /*#__PURE__*/ _jsx(Button, {
            style: {
                display: V2style ? "none" : ""
            },
            disabled: disabled,
            onClick: handleRedirectPOS,
            startIcon: /*#__PURE__*/ _jsx(Image, {
                src: ReturnOrderIcon,
                width: 29,
                height: 29
            }),
            className: styles.btnReturn,
            children: translateDetailOrders("detail-orders.request_return")
        })
    });
}
/* harmony default export */ var mocules_ButtonReturnOrder = ((/* unused pure expression or super */ null && (ButtonReturnOrder_ButtonReturnOrder)));

;// CONCATENATED MODULE: ./src/components/mocules/RequestInvoiceButton/index.js








var RequestInvoiceButton_RequestInvoiceButton = function(param) {
    var handleOpenModal = param.handleOpenModal, invoice = param.invoice, _numberOfSellerMEDX = param.numberOfSellerMEDX, numberOfSellerMEDX = _numberOfSellerMEDX === void 0 ? 0 : _numberOfSellerMEDX, _numberProduct = param.numberProduct, numberProduct = _numberProduct === void 0 ? 0 : _numberProduct, status = param.status, numberOfUpdates = param.numberOfUpdates, enable = param.enable;
    var handleOnClick = function() {
        handleOpenModal();
    };
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: (invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest) ? [
            !enable ? "Kh\xf4ng thể chỉnh sửa do đơn h\xe0ng kh\xf4ng c\xf3 sản phẩm của nh\xe0 cung cấp MEDX hoặc kh\xf4ng nằm trong thời gian cho ph\xe9p." : [
                (status === ENUM_ORDER_STATUS.DELIVERED || status === ENUM_ORDER_STATUS.COMPLETED) && numberOfUpdates === 0 ? "Bạn chỉ được cập nhật đ\xfang 1 lần nữa trong v\xf2ng 14 ng\xe0y kể từ ng\xe0y giao." : [
                    numberOfSellerMEDX === numberProduct ? "Chỉ nhận th\xf4ng tin trong v\xf2ng 14 ng\xe0y kể từ ng\xe0y giao h\xe0ng th\xe0nh c\xf4ng." : "Chỉ nhận th\xf4ng tin trong v\xf2ng 14 ng\xe0y kể từ ng\xe0y giao h\xe0ng th\xe0nh c\xf4ng. \xc1p dụng cho sản phẩm của nh\xe0 cung cấp MEDX", 
                ], 
            ], 
        ] : [
            !enable ? "Kh\xf4ng thể chỉnh sửa do đ\xe3 qu\xe1 thời gian cho ph\xe9p." : "Chỉ nhận th\xf4ng tin trong v\xf2ng 7 ng\xe0y kể từ ng\xe0y giao h\xe0ng th\xe0nh c\xf4ng.", 
        ],
        leaveTouchDelay: 1000,
        enterTouchDelay: 150,
        children: /*#__PURE__*/ _jsx(Button, {
            disabled: !enable,
            startIcon: /*#__PURE__*/ _jsx(ReceiptIcon, {}),
            className: clsx("my-order__button my-order__button--orange", styles.btn),
            onClick: handleOnClick,
            children: (invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest) ? "Chỉnh sửa th\xf4ng tin xuất h\xf3a đơn" : "Y\xeau cầu xuất h\xf3a đơn"
        })
    });
};
/* harmony default export */ var mocules_RequestInvoiceButton = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(RequestInvoiceButton_RequestInvoiceButton))));

;// CONCATENATED MODULE: ./src/components/mocules/RequestInvoiceFormModal/validateForm.js

var RequestInvoiceFormModal_validateForm_validateForm = function(param) {
    var companyName = param.companyName, taxCode = param.taxCode, email = param.email, companyAddress = param.companyAddress;
    if (ValidateUtils.isEmpty(companyName.trim())) throw Error("message_must_enter_company_name_invoice_document");
    else if (companyName.length < 2) throw Error("message_company_at_least_2characters");
    else if (ValidateUtils.isEmpty(taxCode)) throw Error("message_must_enter_the_tax_code_invoice_document");
    else if (!ValidateUtils.isEmpty(email) && !ValidateUtils.validateEmail(email)) throw Error("message_invalid_email");
    else if (ValidateUtils.isEmpty(companyAddress.trim())) throw Error("message_you_must_enter_your_address_invoice document");
    else if (!ValidateUtils.isNumber(taxCode) || !(taxCode.length === 10 || taxCode.length === 14)) throw Error("message_tax_code_wrong_format");
};
/* harmony default export */ var RequestInvoiceFormModal_validateForm = ((/* unused pure expression or super */ null && (RequestInvoiceFormModal_validateForm_validateForm)));

;// CONCATENATED MODULE: ./src/components/mocules/RequestInvoiceFormModal/index.js
/* eslint-disable react/jsx-wrap-multilines */ 


























var RequestInvoiceFormModal_RequestInvoiceModal = function(props) {
    var ref = useTranslation("alert-action"), translateAlertAction = ref.t;
    var visible = props.visible, onClose = props.onClose, orderId = props.orderId, listInvoiceInfo = props.listInvoiceInfo, customerEmail = props.customerEmail, invoice = props.invoice, isMobile = props.isMobile;
    // const [disable, setDisable] = useState(true);
    var router = useRouter();
    var initVal = {
        companyName: (invoice === null || invoice === void 0 ? void 0 : invoice.companyName) || "",
        taxCode: (invoice === null || invoice === void 0 ? void 0 : invoice.taxCode) || "",
        email: (invoice === null || invoice === void 0 ? void 0 : invoice.email) || customerEmail || "",
        companyAddress: (invoice === null || invoice === void 0 ? void 0 : invoice.companyAddress) || ""
    };
    var ref1 = useState(initVal), val = ref1[0], setVal = ref1[1];
    // useEffect(() => {
    //   if (
    //     val.companyName === initVal.companyName &&
    //     val.taxCode === initVal.taxCode &&
    //     val.email === initVal.email &&
    //     val.companyAddress === initVal.companyAddress
    //   )
    //     setDisable(true);
    //   else setDisable(false);
    // }, [val]);
    var handleChangeValue = function(key, value) {
        setVal(_object_spread_props(_object_spread({}, val), _define_property({}, key, value)));
    };
    var onSubmit = function() {
        var _ref = _async_to_generator(function() {
            var data, _tmp, _tmp1, requestInvoiceResult, message, errorCode, _tmp2, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        data = _object_spread_props(_object_spread(_tmp, val), (_tmp1.orderId = orderId, _tmp1.invoiceRequest = true, _tmp1));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        validateForm(val);
                        return [
                            4,
                            CustomerClient.updateInvoiceInfoOrder(data)
                        ];
                    case 2:
                        requestInvoiceResult = _state.sent();
                        if (!isValidWithoutData(requestInvoiceResult)) {
                            message = "";
                            errorCode = requestInvoiceResult.errorCode;
                            switch(errorCode){
                                case "ERR_UPDATE_MANUALLY_EXPORTED_INVOICE":
                                    message = " Đơn h\xe0ng kh\xf4ng thể giao th\xe0nh c\xf4ng cho qu\xfd kh\xe1ch. Vui l\xf2ng kh\xf4ng cập nhật th\xf4ng tin cho h\xf3a đơn của đơn h\xe0ng n\xe0y";
                                    break;
                                case "ERR_UPDATE_MANUALLY_IMPORTED_INVOICE":
                                    message = "Vui l\xf2ng kh\xf4ng cập nhật th\xf4ng tin cho h\xf3a đơn của đơn h\xe0ng n\xe0y";
                                    break;
                                case "ERR_UPDATE_INVOICE_MULTIPLE_TIMES":
                                    message = "Đơn h\xe0ng y\xeau cầu thay đổi th\xf4ng tin h\xf3a đơn > 1 lần";
                                    break;
                                case "ERR_INVALID_CHANGE_REQUEST_TIME":
                                    message = "Kh\xf4ng thể y\xeau cầu xuất h\xf3a đơn sau 7 ng\xe0y.";
                                    break;
                                case "ERR_INVALID_CHANGE_INVOICE_INFO_TIME":
                                    message = "Kh\xf4ng thể thay đổi th\xf4ng tin xuất h\xf3a đơn sau 14 ng\xe0y.";
                                    break;
                                default:
                                    message = requestInvoiceResult.message || "Gửi cập nhật th\xf4ng tin h\xf3a đơn thất bại";
                            }
                            throw new Error(message);
                        }
                        NotifyUtils.success("Gửi cập nhật th\xf4ng tin h\xf3a đơn th\xe0nh c\xf4ng");
                        // clear
                        onClose();
                        _tmp2 = {};
                        setVal(_tmp2);
                        gtag.requestInvoice();
                        router.push(window.location.href);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        NotifyUtils.error(translateAlertAction(error.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = useState(""), invoiceInfoSelected = ref2[0], setInvoiceInfoSelected = ref2[1];
    var handleChangeInvoiceInfoSelected = function(e) {
        var value = e.target.value;
        setInvoiceInfoSelected(value);
        var choosenItem = listInvoiceInfo.find(function(item) {
            return item.code === value;
        });
        setVal(_object_spread_props(_object_spread({}, val), {
            email: (invoice === null || invoice === void 0 ? void 0 : invoice.email) || customerEmail || "",
            companyName: (choosenItem === null || choosenItem === void 0 ? void 0 : choosenItem.companyName) || "",
            companyAddress: (choosenItem === null || choosenItem === void 0 ? void 0 : choosenItem.companyAddress) || "",
            taxCode: (choosenItem === null || choosenItem === void 0 ? void 0 : choosenItem.taxCode) || ""
        }));
    };
    return /*#__PURE__*/ _jsx(Modal, {
        open: visible,
        onClose: onClose,
        className: styles.modal,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.wrap,
            children: [
                isMobile && /*#__PURE__*/ _jsx("div", {
                    style: {
                        position: "sticky",
                        top: "0px",
                        zIndex: 999
                    },
                    children: /*#__PURE__*/ _jsx(CancelIcon, {
                        style: {
                            float: "right",
                            margin: "5px"
                        },
                        onClick: onClose
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: clsx(styles.title, isMobile && styles.titleMobile),
                    children: !(invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest) ? "Y\xeau cầu xuất h\xf3a đơn" : "Chỉnh sửa th\xf4ng tin xuất h\xf3a đơn"
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    container: true,
                    className: styles.container,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Th\xf4ng tin xuất h\xf3a đơn"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Grid, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ _jsxs(InfoFormControl, {
                                    xs: 12,
                                    md: 12,
                                    htmlFor: "companyName",
                                    label: "T\xean c\xf4ng ty",
                                    isRequired: true,
                                    children: [
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx(TextField, {
                                            id: "companyName",
                                            multiline: true,
                                            variant: "outlined",
                                            minRows: 2,
                                            style: {
                                                background: "#fff"
                                            },
                                            value: val.companyName,
                                            placeholder: "\xcdt nhất 2 k\xed tự",
                                            onChange: function(e) {
                                                return handleChangeValue("companyName", e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(InfoFormControl, {
                                    xs: 12,
                                    md: 12,
                                    label: "M\xe3 số thuế",
                                    htmlFor: "taxCode",
                                    isRequired: true,
                                    children: /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "taxCode",
                                        placeholder: "M\xe3 số thuế",
                                        value: val.taxCode,
                                        onChange: function(e) {
                                            return handleChangeValue("taxCode", e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(InfoFormControl, {
                                    xs: 12,
                                    label: "Địa chỉ",
                                    htmlFor: "companyAddress",
                                    isRequired: true,
                                    children: [
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx(TextField, {
                                            multiline: true,
                                            minRows: 4,
                                            variant: "outlined",
                                            id: "companyAddress",
                                            placeholder: "Nhập địa chỉ xuất h\xf3a đơn (bao gồm Phường/X\xe3, Quận/Huyện, Tỉnh/Th\xe0nh phố nếu c\xf3)",
                                            value: val.companyAddress,
                                            onChange: function(e) {
                                                return handleChangeValue("companyAddress", e.target.value);
                                            },
                                            style: {
                                                background: "#fff"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(InfoFormControl, {
                                    xs: 12,
                                    md: 12,
                                    label: "Email",
                                    htmlFor: "email",
                                    children: /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "email",
                                        placeholder: "Email",
                                        value: val.email,
                                        onChange: function(e) {
                                            return handleChangeValue("email", e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.helper_text,
                                    children: /*#__PURE__*/ _jsxs("small", {
                                        className: styles.text_muted,
                                        children: [
                                            /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                                icon: faInfoCircle,
                                                className: styles.icon
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: styles.fw500,
                                                children: "Lưu \xfd:"
                                            }),
                                            /*#__PURE__*/ _jsxs("ul", {
                                                className: styles.notifi_list,
                                                children: [
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: "Phải điền ch\xednh x\xe1c th\xf4ng tin xuất h\xf3a đơn"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("li", {
                                                        children: [
                                                            "H\xf3a đơn đối t\xe1c ",
                                                            BRAND_NAME,
                                                            " sẽ xuất từ 8-10 ng\xe0y sau khi đơn h\xe0ng được giao th\xe0nh c\xf4ng"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        listInvoiceInfo.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Grid, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        style: {
                                            fontWeight: "bold"
                                        },
                                        children: "Hoặc chọn: "
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Grid, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ _jsx(RadioGroup, {
                                        "aria-label": "gender",
                                        name: "gender1",
                                        value: invoiceInfoSelected,
                                        onClick: handleChangeInvoiceInfoSelected,
                                        children: listInvoiceInfo.map(function(item) {
                                            return /*#__PURE__*/ _jsx(FormControlLabel, {
                                                control: /*#__PURE__*/ _jsx(Radio, {
                                                    name: "checkedC",
                                                    classes: {
                                                        root: styles.checkbox
                                                    },
                                                    value: item.code
                                                }),
                                                label: /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("i", {
                                                            style: {
                                                                textTransform: "capitalize"
                                                            },
                                                            children: [
                                                                " ",
                                                                item.companyName
                                                            ]
                                                        }),
                                                        " -",
                                                        " ",
                                                        /*#__PURE__*/ _jsxs("b", {
                                                            children: [
                                                                " ",
                                                                item.taxCode,
                                                                " "
                                                            ]
                                                        }),
                                                        " (",
                                                        item.companyAddress,
                                                        ")"
                                                    ]
                                                })
                                            }, item.code);
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            className: styles.textarea,
                            item: true,
                            container: true,
                            justifyContent: "center",
                            xs: 12,
                            spacing: 1,
                            children: /*#__PURE__*/ _jsx(Button, {
                                className: "payment_button",
                                onClick: onSubmit,
                                children: "Gửi y\xeau cầu"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RequestInvoiceFormModal = ((/* unused pure expression or super */ null && (RequestInvoiceFormModal_RequestInvoiceModal)));

;// CONCATENATED MODULE: ./src/components/mocules/TicketButton/index.js




var TicketButton_TicketButton = function(param) {
    var order = param.order, handleChangeOrderTicket = param.handleChangeOrderTicket, handleOpenModal = param.handleOpenModal;
    var handleOnClick = function() {
        handleChangeOrderTicket(order);
        handleOpenModal();
    };
    return /*#__PURE__*/ _jsx(Button, {
        startIcon: /*#__PURE__*/ _jsx(InsertCommentIcon, {}),
        className: "my-order__button my-order__button--blue",
        onClick: handleOnClick,
        children: "Gửi phản hồi"
    });
};
/* harmony default export */ var mocules_TicketButton = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(TicketButton_TicketButton))));

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/mocules/SearchProduct/index.js + 1 modules
var SearchProduct = __webpack_require__(66926);
// EXTERNAL MODULE: ./src/components/mocules/UploadImages/index.js + 14 modules
var UploadImages = __webpack_require__(55478);
// EXTERNAL MODULE: ./src/components/mocules/TicketFormModal/style.module.css
var style_module = __webpack_require__(81330);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/mocules/TicketFormModal/validateForm.js

var TicketFormModal_validateForm_validateForm = function(param) {
    var type = param.type, phone = param.phone, orderId = param.orderId, orderDetail = param.orderDetail, sku = param.sku, email = param.email;
    // if (ValidateUtils.isEmpty(feedbackContent)) throw Error('message_feedback_empty');
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(type)) throw Error("message_not_choose_feedback_type");
    if (email && !utils/* ValidateUtils.validateEmail */.IN.validateEmail(email)) throw Error("message_wrong_email");
    switch(type){
        case "PRODUCT":
            {
                if (!sku || utils/* ValidateUtils.isEmpty */.IN.isEmpty(sku)) throw Error("message_not_choose_product");
                if (orderId && !orderDetail) throw Error("message_wrong_order_code");
                if (phone && !utils/* ValidateUtils.validatePhone */.IN.validatePhone(phone)) throw Error("message_invalid_phone");
                break;
            }
        case "ORDER":
            {
                if (!orderId || utils/* ValidateUtils.isEmpty */.IN.isEmpty(orderId)) throw Error("message_empty_order_info");
                if (!orderDetail) throw Error("message_wrong_order_code");
                break;
            }
        case "ACCOUNT":
        case "OTHER ":
            {
                if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(phone)) throw Error("message_not_input_phone");
                if (!utils/* ValidateUtils.validatePhone */.IN.validatePhone(phone)) throw Error("message_invalid_phone");
                break;
            }
        default:
            {
                break;
            }
    }
};
/* harmony default export */ var TicketFormModal_validateForm = (TicketFormModal_validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/TicketFormModal/index.js



































var TicketFormModal_TicketFormModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var visible = props.visible, onClose = props.onClose, _orderId = props.orderId, orderId = _orderId === void 0 ? 0 : _orderId, productName = props.productName, productId = props.productId, sku = props.sku, orderCode = props.orderCode, customerCode = props.customerCode, customerId = props.customerId, _ticketType = props.ticketType, ticketType = _ticketType === void 0 ? "ORDER" : _ticketType, _user = props.user, user = _user === void 0 ? null : _user, reloadFunc = props.reloadFunc, optionSelected = props.optionSelected, handleCancelRequestOrder = props.handleCancelRequestOrder, statusOrder = props.status;
    var ref6 = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref6.t;
    var ref7 = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref7.t;
    var ref8 = (0,esm/* useTranslation */.$G)("myTicket"), translateMyTicket = ref8.t;
    var ref9 = (0,react.useState)(ticketType), curType = ref9[0], setCurType = ref9[1];
    var ref10 = (0,context/* useAuth */.aC)(), customerInfo = ref10.customerInfo, handleRedCustomer = ref10.handleRedCustomer;
    var ref11 = (0,context/* useSetting */.yu)(), reasonsTicket = ref11.reasonsTicket, provinces = ref11.provinces;
    var reasonsByType = (reasonsTicket === null || reasonsTicket === void 0 ? void 0 : reasonsTicket.filter(function(item) {
        return item.status === "ACTIVE" && item.ticketType === curType;
    })) || [];
    var listTicketTypes = (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.isActive) ? Enums/* EnumsTicket.TicketTypes */.t7.TicketTypes : Enums/* EnumsTicket.TicketTypesNotActive */.t7.TicketTypesNotActive;
    var ref12 = (0,react.useState)(reasonsByType), listReasons = ref12[0], setListReasons = ref12[1];
    var ref13 = (0,react.useState)(optionSelected && reasonsByType.find(function(item) {
        return item.code === optionSelected;
    }) || reasonsByType && reasonsByType[0] || null), curReason = ref13[0], setCurReason = ref13[1];
    var ref14 = (0,react.useState)({}), orderDetail = ref14[0], setOrderDetail = ref14[1];
    var handleChangeType = function(e) {
        var ticketTypeSelected = e.target.value;
        setCurType(ticketTypeSelected);
    };
    (0,react.useEffect)(function() {
        var reasons = (reasonsTicket === null || reasonsTicket === void 0 ? void 0 : reasonsTicket.filter(function(item) {
            return item.status === "ACTIVE" && item.ticketType === curType;
        })) || [];
        if (orderDetail) {
            var status = orderDetail.status;
            if (status) {
                reasons = reasons.filter(function(item) {
                    var ref;
                    return item && ((item === null || item === void 0 ? void 0 : item.orderStatuses) === null || (item === null || item === void 0 ? void 0 : (ref = item.orderStatuses) === null || ref === void 0 ? void 0 : ref.indexOf(status)) >= 0);
                });
            }
        }
        setListReasons(reasons);
        setCurReason(optionSelected && reasonsByType.find(function(item) {
            return item.code === optionSelected;
        }) || reasons[0] || null);
    }, [
        curType,
        orderDetail,
        reasonsTicket
    ]);
    // const [reason, setReason] = useState(curReason?.name);
    var ref15 = (0,react.useState)({
        bankCode: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref = customerInfo.bank) === null || ref === void 0 ? void 0 : ref.bankCode) || "",
        bankName: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref1 = customerInfo.bank) === null || ref1 === void 0 ? void 0 : ref1.bankName) || "",
        bankBranch: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref2 = customerInfo.bank) === null || ref2 === void 0 ? void 0 : ref2.bankBranch) || "",
        bankAccountName: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref3 = customerInfo.bank) === null || ref3 === void 0 ? void 0 : ref3.bankAccountName) || "",
        bankAccountCode: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref4 = customerInfo.bank) === null || ref4 === void 0 ? void 0 : ref4.code) || "",
        feedbackContent: "",
        imageUrls: [],
        productId: productId,
        orderId: orderId,
        sku: sku,
        productName: productName,
        phone: (user === null || user === void 0 ? void 0 : user.phone) || (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.phone) || "",
        email: (user === null || user === void 0 ? void 0 : user.email) || (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.email) || "",
        ticketType: curType,
        isDisableSubmit: false
    }), val = ref15[0], setVal = ref15[1];
    var handleChangeValue = function(key, value) {
        setVal((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, val), (0,src_define_property/* default */.Z)({}, key, value)));
    };
    var disableSubmit = function() {
        handleChangeValue("isDisableSubmit", true);
    };
    var ref16 = (0,react.useState)(null), productSearch = ref16[0], setProductSearch = ref16[1];
    var handleLoadOrderDetail = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(id) {
            var orderResult, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!id) return [
                            3,
                            2
                        ];
                        if (!([
                            Enums/* EnumsTicket.TicketEnums.ORDER */.t7.TicketEnums.ORDER,
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT
                        ].indexOf(curType) >= 0)) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            services/* OrderService.getOrderById */.px.getOrderById((_tmp.orderId = id, _tmp))
                        ];
                    case 1:
                        orderResult = _state.sent();
                        setOrderDetail((0,clients/* getFirst */.Xi)(orderResult));
                        if (!(0,clients/* isValid */.JY)(orderResult)) {
                            utils_NotifyUtils/* default.error */.Z.error(translateAlertAction("message_incorrect_valid_order_number"));
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), [
        curType
    ]);
    var handleChangeOrderId = function(orderIdCur) {
        try {
            // const orderIdCur = parseInt(id, 10);
            if (orderIdCur) {
                handleLoadOrderDetail(orderIdCur);
            }
            handleChangeValue("orderId", Number(orderIdCur));
        } catch (error) {
            utils_NotifyUtils/* default.warn */.Z.warn(translateAlertAction("message_incorrect_format_order_number"));
        }
    };
    (0,react.useEffect)(function() {
        handleLoadOrderDetail(val.orderId);
    }, [
        handleLoadOrderDetail,
        val.orderId
    ]);
    var handleOnChangeReason = function(e) {
        var reasonCode = e.target.value;
        var reason = reasonsByType.find(function(item) {
            return item.code === reasonCode;
        });
        setCurReason(reason);
    };
    var handleSearchProduct = function(product) {
        var ref, ref1, ref2;
        handleChangeValue("productName", product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.name);
        handleChangeValue("productId", product === null || product === void 0 ? void 0 : (ref1 = product.product) === null || ref1 === void 0 ? void 0 : ref1.productID);
        handleChangeValue("sku", product === null || product === void 0 ? void 0 : (ref2 = product.sku) === null || ref2 === void 0 ? void 0 : ref2.code);
        setProductSearch(product);
    };
    // const handleChangeReasons =(reasonId) => {
    // }
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var data, _tmp, _tmp1, feedbackResult, _tmp2, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (optionSelected) {
                            handleCancelRequestOrder();
                        }
                        if (optionSelected && (statusOrder === "COMPLETED" || statusOrder === "DELIVERED" || statusOrder === "DELIVERING")) {
                            onClose();
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        _tmp1 = {};
                        data = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, val), (_tmp1.orderCode = orderCode, _tmp1.customerId = customerId, _tmp1.customerCode = customerCode, _tmp1.reasonName = (curReason === null || curReason === void 0 ? void 0 : curReason.name) || "", _tmp1.reasonCodes = [
                            (curReason === null || curReason === void 0 ? void 0 : curReason.code) || ""
                        ], _tmp1.type = curType, _tmp1.ticketType = curType, _tmp1.source = "WEB", _tmp1.orderDetail = orderDetail, _tmp1));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        // validate form data
                        TicketFormModal_validateForm(data);
                        if (data.orderId && orderDetail) {
                            data.orderId = Number(data.orderId);
                        }
                        switch(data.type){
                            case Enums/* EnumsTicket.TicketEnums.ACCOUNT */.t7.TicketEnums.ACCOUNT:
                            case Enums/* EnumsTicket.TicketEnums.OTHER */.t7.TicketEnums.OTHER:
                                delete data.reasonCodes;
                                delete data.orderId;
                                delete data.productId;
                                delete data.sku;
                                break;
                            default:
                                break;
                        }
                        if (!(curReason === null || curReason === void 0 ? void 0 : curReason.showBankAccount) || [
                            Enums/* EnumsTicket.TicketEnums.ACCOUNT */.t7.TicketEnums.ACCOUNT,
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.OTHER */.t7.TicketEnums.OTHER
                        ].indexOf(data.ticketType) >= 0) {
                            delete data.bankCode;
                            delete data.bankName;
                            delete data.bankBranch;
                            delete data.bankAccountCode;
                        }
                        return [
                            4,
                            clients/* TicketClient.createFeedback */.ZX.createFeedback(data)
                        ];
                    case 2:
                        feedbackResult = _state.sent();
                        if (!(0,clients/* isValid */.JY)(feedbackResult)) {
                            if ((feedbackResult === null || feedbackResult === void 0 ? void 0 : feedbackResult.errorCode) === Enums/* TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER */.q0.LOCKED_CUSTOMER && handleRedCustomer()) {
                                return [
                                    2
                                ];
                            }
                            throw new Error(feedbackResult.message || translateAlertAction("message_send_feedback_fail"));
                        }
                        utils_NotifyUtils/* default.success */.Z.success(translateAlertAction("message_send_feedback"));
                        // clear
                        onClose();
                        if (reloadFunc) {
                            reloadFunc();
                        }
                        _tmp2 = {};
                        setVal(_tmp2);
                        utils/* gtag.sendFeedback */.SX.sendFeedback();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        utils_NotifyUtils/* default.error */.Z.error(translateAlertAction(error.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnChangeImages = function() {
        var imgs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        setTimeout(function() {
            setVal((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, val), {
                isDisableSubmit: false,
                imageUrls: (0,src_to_consumable_array/* default */.Z)((val === null || val === void 0 ? void 0 : val.imageUrls) || []).concat((0,src_to_consumable_array/* default */.Z)(imgs))
            }));
        }, 1500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
        open: visible,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (style_module_default()).feedback_order,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).title,
                    children: translatePopupAction("popup-ticket.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    container: true,
                    className: (style_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).info_group,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                md: 12,
                                className: (style_module_default()).text_body,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: [
                                        translatePopupAction("popup-ticket.subtitle"),
                                        " ",
                                        customerInfo.name,
                                        "!"
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "flex-start",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                md: 12,
                                label: translatePopupAction("popup-ticket.help_problem"),
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                    input: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {}),
                                    IconComponent: ExpandMore/* default */.Z,
                                    value: curType,
                                    onChange: handleChangeType,
                                    className: (style_module_default()).reason_select,
                                    disabled: ticketType === Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT || !!orderId || !!optionSelected,
                                    children: listTicketTypes === null || listTicketTypes === void 0 ? void 0 : listTicketTypes.map(function(type) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                            value: type,
                                            children: translateMyTicket((ref = Enums/* EnumsTicket.TicketLabelEnums */.t7.TicketLabelEnums[type]) === null || ref === void 0 ? void 0 : ref.code)
                                        }, "ticket-type-".concat(type));
                                    })
                                })
                            })
                        }),
                        curType === Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                md: 12,
                                label: translatePopupAction("popup-ticket.What_product_do_you_want_to_support"),
                                htmlFor: "productId",
                                isRequired: true,
                                children: productName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "productId",
                                    placeholder: translatePopupAction("popup-ticket.What_product_do_you_want_to_support"),
                                    defaultValue: productName || "",
                                    disabled: ticketType === "PRODUCT"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProduct/* default */.Z, {
                                            handleKeyDown: function() {},
                                            onClickItem: handleSearchProduct,
                                            id: "productId",
                                            placeholder: translatePopupAction("popup-ticket.What_product_do_you_want_to_support")
                                        }),
                                        productSearch && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    style: {
                                                        fontWeight: 400,
                                                        fontSize: "14px"
                                                    },
                                                    children: [
                                                        translatePopupAction("popup-ticket.selected_product"),
                                                        " :"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                                                    severity: "info",
                                                    icon: false,
                                                    style: {
                                                        borderRadius: "8px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: [
                                                            " ",
                                                            (productSearch === null || productSearch === void 0 ? void 0 : (ref5 = productSearch.product) === null || ref5 === void 0 ? void 0 : ref5.name) || ""
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                md: 12,
                                label: translatePopupAction("popup-ticket.enter_order_number"),
                                htmlFor: "orderId",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "orderId",
                                    placeholder: translatePopupAction("popup-ticket.enter_order_number"),
                                    type: "number",
                                    defaultValue: (val === null || val === void 0 ? void 0 : val.orderId) || "",
                                    onBlur: function(e) {
                                        var ref;
                                        return handleChangeOrderId((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || "");
                                    }
                                })
                            })
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.ORDER */.t7.TicketEnums.ORDER
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 6,
                                    md: 6,
                                    label: translatePopupAction("popup-ticket.enter_order_number"),
                                    htmlFor: "orderId",
                                    isRequired: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "orderId",
                                        placeholder: translatePopupAction("popup-ticket.enter_order_number"),
                                        type: "number",
                                        disabled: !!orderId,
                                        defaultValue: (val === null || val === void 0 ? void 0 : val.orderId) || "",
                                        onBlur: function(e) {
                                            var ref;
                                            return handleChangeOrderId((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || 0);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 6,
                                    md: 6,
                                    label: translatePopupAction("popup-ticket.order_status"),
                                    htmlFor: "orderStatus",
                                    isRequired: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "orderStatus",
                                        placeholder: translatePopupAction("popup-ticket.order_status"),
                                        value: translateMyTicket("".concat((orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.status) || (orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.orderStatus) || "")),
                                        disabled: true
                                    })
                                })
                            ]
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.ACCOUNT */.t7.TicketEnums.ACCOUNT,
                            Enums/* EnumsTicket.TicketEnums.OTHER */.t7.TicketEnums.OTHER, 
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 6,
                                    md: 6,
                                    label: translatePopupAction("popup-ticket.phoneNumber"),
                                    htmlFor: "phone",
                                    isRequired: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "phone",
                                        placeholder: translatePopupAction("popup-ticket.phoneNumber"),
                                        value: val.phone,
                                        onChange: function(e) {
                                            return handleChangeValue("phone", e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 6,
                                    md: 6,
                                    label: "Email",
                                    htmlFor: "email",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "email",
                                        placeholder: "Email",
                                        value: val.email,
                                        onChange: function(e) {
                                            return handleChangeValue("email", e.target.value);
                                        }
                                    })
                                })
                            ]
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.PROMOTION */.t7.TicketEnums.PROMOTION
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    container: true,
                                    justifyContent: "space-evenly",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                            xs: 6,
                                            md: 6,
                                            label: translatePopupAction("popup-ticket.phoneNumber"),
                                            htmlFor: "phone",
                                            isRequired: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                                disabled: true,
                                                id: "phone",
                                                placeholder: translatePopupAction("popup-ticket.phoneNumber"),
                                                value: val.phone,
                                                onChange: function(e) {
                                                    return handleChangeValue("phone", e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                            xs: 6,
                                            md: 6,
                                            label: translatePopupAction("popup-ticket.your_area"),
                                            htmlFor: "provine",
                                            disabled: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                                input: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {}),
                                                IconComponent: ExpandMore/* default */.Z,
                                                value: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.provinceCode,
                                                className: (style_module_default()).reason_select,
                                                disabled: true,
                                                children: provinces === null || provinces === void 0 ? void 0 : provinces.map(function(province) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: province.value,
                                                        children: province.label
                                                    }, "provinces-".concat((0,v4/* default */.Z)()));
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    container: true,
                                    justifyContent: "space-evenly",
                                    spacing: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        md: 12,
                                        label: translatePopupAction("popup-ticket.name_store"),
                                        htmlFor: "scope",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "scope",
                                            placeholder: translatePopupAction("popup-ticket.name_store"),
                                            value: (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.businessName) || "",
                                            disabled: true
                                        })
                                    })
                                })
                            ]
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.ORDER */.t7.TicketEnums.ORDER,
                            Enums/* EnumsTicket.TicketEnums.PROMOTION */.t7.TicketEnums.PROMOTION, 
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "flex-start",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                md: 12,
                                label: translatePopupAction("popup-ticket.sup_reasons"),
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                    input: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {}),
                                    IconComponent: ExpandMore/* default */.Z,
                                    value: curReason === null || curReason === void 0 ? void 0 : curReason.code,
                                    onChange: handleOnChangeReason,
                                    className: (style_module_default()).reason_select,
                                    disabled: !!optionSelected,
                                    children: listReasons === null || listReasons === void 0 ? void 0 : listReasons.map(function(reasonE) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: reasonE.code,
                                            children: reasonE.name
                                        }, "key-reason-".concat((0,v4/* default */.Z)()));
                                    })
                                })
                            })
                        }),
                        (curReason === null || curReason === void 0 ? void 0 : curReason.showBankAccount) && [
                            Enums/* EnumsTicket.TicketEnums.ORDER */.t7.TicketEnums.ORDER
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "flex-start",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    style: {
                                        fontWeight: 500,
                                        paddingLeft: "4px"
                                    },
                                    children: translatePopupAction("popup-ticket.bank_info")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                                container: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.acc_holder"),
                                                                ": ",
                                                                val.bankAccountName
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.acc_number"),
                                                                ": ",
                                                                val.bankCode
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.bank"),
                                                                ": ",
                                                                val.bankName
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.branch_bank"),
                                                                ": ",
                                                                val.bankBranch
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    container: true,
                                    alignContent: "flex-start",
                                    direction: "row",
                                    style: {
                                        paddingTop: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            style: {
                                                fontWeight: 500,
                                                paddingTop: 3,
                                                paddingLeft: 4
                                            },
                                            children: (val === null || val === void 0 ? void 0 : val.bankCode) ? translatePopupAction("popup-ticket.change_bank") : translatePopupAction("popup-ticket.have_bank")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                            href: "".concat(Paths/* MY_ACCOUNT */.RX, "?tab=4"),
                                            target: "_blank",
                                            style: {
                                                color: "green"
                                            },
                                            variant: "body2",
                                            children: (val === null || val === void 0 ? void 0 : val.bankCode) ? translatePopupAction("popup-ticket.click_here") : translatePopupAction("popup-ticket.add_bank")
                                        })
                                    ]
                                })
                            ]
                        }),
                        sysconfig/* REASON_VOUCHER_BIRTHDAY */.xE === (curReason === null || curReason === void 0 ? void 0 : curReason.code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            className: (style_module_default()).imagesField,
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    className: (style_module_default()).imagesField,
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    lg: 6,
                                    container: true,
                                    justifyContent: "space-evenly",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                            label: translatePopupAction("popup-ticket.image_front_of_citizen_identification"),
                                            xs: 12,
                                            className: (style_module_default()).customText,
                                            isRequired: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImages/* default */.Z, {
                                            onChange: handleOnChangeImages,
                                            setLoading: disableSubmit,
                                            isOnlyOneImage: true,
                                            limit: 1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    className: (style_module_default()).imagesField,
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    lg: 6,
                                    container: true,
                                    justifyContent: "space-evenly",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                            label: translatePopupAction("popup-ticket.image_back_of_citizen_identification"),
                                            xs: 12,
                                            className: (style_module_default()).customText,
                                            isRequired: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImages/* default */.Z, {
                                            onChange: handleOnChangeImages,
                                            setLoading: disableSubmit,
                                            isOnlyOneImage: true,
                                            limit: 1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    style: {
                                        color: "red",
                                        fontFamily: "ggsr",
                                        fontSize: "13px"
                                    },
                                    children: [
                                        "*",
                                        translatePopupAction("popup-ticket.message_alert_citizen_identification")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            className: (style_module_default()).textarea,
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* InfoFormControl */.iD, {
                                label: translatePopupAction("popup-ticket.feedback"),
                                xs: 12,
                                htmlFor: "description",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
                                        id: "feedbackContent",
                                        multiline: true,
                                        minRows: 4,
                                        variant: "outlined",
                                        placeholder: translatePopupAction("popup-ticket.entered_feedback_content"),
                                        value: val === null || val === void 0 ? void 0 : val.note,
                                        onChange: function(e) {
                                            return handleChangeValue("feedbackContent", e.target.value);
                                        },
                                        style: {
                                            background: "#fff"
                                        }
                                    })
                                ]
                            })
                        }),
                        sysconfig/* REASON_VOUCHER_BIRTHDAY */.xE !== (curReason === null || curReason === void 0 ? void 0 : curReason.code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            className: (style_module_default()).imagesField,
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    label: translatePopupAction("popup-ticket.images"),
                                    xs: 12,
                                    className: (style_module_default()).customText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImages/* default */.Z, {
                                    onChange: handleOnChangeImages,
                                    setLoading: disableSubmit
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                marginTop: "18px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordWarningText/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            className: (style_module_default()).textarea,
                            item: true,
                            container: true,
                            justifyContent: "center",
                            xs: 12,
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                className: "payment_button",
                                onClick: onSubmit,
                                disabled: val.isDisableSubmit,
                                children: translatePopupAction("popup-ticket.send_request")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
TicketFormModal_TicketFormModal.propsTypes = {
    visible: (prop_types_default()).bool.isRequired,
    onClose: (prop_types_default()).func,
    orderId: (prop_types_default()).number,
    productName: (prop_types_default()).string,
    productId: (prop_types_default()).number,
    phone: (prop_types_default()).string,
    orderTime: (prop_types_default()).string,
    orderCode: (prop_types_default()).string,
    bankInfo: (prop_types_default()).object,
    customerCode: (prop_types_default()).string,
    customerId: (prop_types_default()).number,
    ticketType: (prop_types_default()).string.isRequired
};
/* harmony default export */ var mocules_TicketFormModal = (TicketFormModal_TicketFormModal);

// EXTERNAL MODULE: ./src/components/mocules/OrderInfoTabs/OrderStatusButton.js
var OrderInfoTabs_OrderStatusButton = __webpack_require__(32181);
;// CONCATENATED MODULE: ./src/components/mocules/OrderInfoTabs/OrderRow.js





































var MyOrderDetail = function(param) {
    var _amount = param.amount, amount = _amount === void 0 ? null : _amount, createdTime = param.createdTime, _deliveryDate = param.deliveryDate, deliveryDate = _deliveryDate === void 0 ? null : _deliveryDate, _totalQuantity = param.totalQuantity, totalQuantity = _totalQuantity === void 0 ? null : _totalQuantity, _redeemCode = param.redeemCode, redeemCode = _redeemCode === void 0 ? null : _redeemCode, _totalDiscount = param.totalDiscount, totalDiscount = _totalDiscount === void 0 ? 0 : _totalDiscount, paymentMethod = param.paymentMethod;
    var ref = useTranslation("common"), translateCommon = ref.t;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            overflowX: "auto"
        },
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                item: true,
                xs: 12,
                lg: 4,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "Sản phẩm: "
                            }),
                            " ",
                            amount && formatNumber(amount)
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "Tổng số lượng: "
                            }),
                            " ",
                            totalQuantity && formatNumber(totalQuantity)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                item: true,
                xs: 12,
                lg: 8,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "Ng\xe0y mua: "
                            }),
                            DateTimeUtils.getFormattedDate(new Date(createdTime), translateCommon, "DD/MM/YYYY HH:mm:ss")
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "H\xecnh thức thanh to\xe1n: "
                            }),
                            PAYMENT_METHOD_NAME_SHORT[paymentMethod]
                        ]
                    }),
                    deliveryDate && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: " Dự kiến giao ng\xe0y: "
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: DateTimeUtils.getFormattedWithDate(new Date(deliveryDate), translateCommon)
                            })
                        ]
                    }),
                    redeemCode && redeemCode.length > 0 && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "M\xe3 giảm gi\xe1: "
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: redeemCode[0]
                            })
                        ]
                    }),
                    totalDiscount > 0 && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "Giảm gi\xe1: "
                            }),
                            " ",
                            formatCurrency(totalDiscount)
                        ]
                    })
                ]
            })
        ]
    });
};
var OrderRow_OrderRow = function(param) {
    var orderId = param.orderId, orderCode = param.orderCode, createdTime = param.createdTime, deliveryDate = param.deliveryDate, customerName = param.customerName, customerPhone = param.customerPhone, customerId = param.customerId, customerCode = param.customerCode, customerEmail = param.customerEmail, status = param.status, totalPrice = param.totalPrice, handleSetOrderStatus = param.handleSetOrderStatus, bankInfo = param.bankInfo, reasonsList = param.reasonsList, totalItem = param.totalItem, totalQuantity = param.totalQuantity, canEdit = param.canEdit, invoiceInfo = param.invoiceInfo, redeemCode = param.redeemCode, totalDiscount = param.totalDiscount, paymentMethod = param.paymentMethod, listInvoiceInfo = param.listInvoiceInfo, invoice = param.invoice, isMobile = param.isMobile, products = param.products, completedTime = param.completedTime;
    var ref = useTranslation("common"), translateCommon = ref.t;
    var router = useRouter();
    var ref1 = useState({}), orderTicket = ref1[0], setOrderTicket = ref1[1];
    var ref2 = _sliced_to_array(useModal(), 2), open = ref2[0], toggleOpen = ref2[1];
    var ref3 = _sliced_to_array(useModal(), 2), openCancelOrder = ref3[0], toggleOpenCancelOrder = ref3[1];
    var _reconcileTime = invoiceInfo.reconcileTime, reconcileTime = _reconcileTime === void 0 ? null : _reconcileTime, _numberOfUpdates = invoiceInfo.// arisingInvoiceTime = null,
    numberOfUpdates, numberOfUpdates = _numberOfUpdates === void 0 ? 0 : _numberOfUpdates;
    var now = +new Date();
    // thời gian giao thành công
    var deliveredTime = reconcileTime && +new Date(reconcileTime) || 0;
    // thời gian xuất hóa đơn
    // const arasingInvoice = (arisingInvoiceTime && +new Date(arisingInvoiceTime)) || 0;
    var invoices = (invoiceInfo === null || invoiceInfo === void 0 ? void 0 : invoiceInfo.invoices) || [];
    var ref4 = useSetting(), _mapSeller = ref4.mapSeller, mapSeller = _mapSeller === void 0 ? new Map() : _mapSeller;
    var numberOfSellerMEDX = products.filter(function(param) {
        var sellerCode = param.sellerCode, tags = param.tags;
        var sellerInfo = (mapSeller === null || mapSeller === void 0 ? void 0 : mapSeller.get(sellerCode)) || null;
        var isVAT = (tags === null || tags === void 0 ? void 0 : tags.indexOf("HOADONNHANH")) >= 0 || false;
        return (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isInternal) && isVAT;
    }).length;
    // const displayInvoiceBtn = () => {
    //   switch (status) {
    //     case ENUM_ORDER_STATUS.CANCEL:
    //       return false;
    //     case ENUM_ORDER_STATUS.DELIVERED:
    //     case ENUM_ORDER_STATUS.COMPLETED:
    //       // nếu có yêu cầu xuất hoá đơn
    //       if (invoice?.invoiceRequest) {
    //         // trong trường hợp có yêu cầu xuất hoá đơn
    //         // nếu có đã có hoá đơn thì sẽ dc cập nhập 1 lần - nếu quá thì ko dc
    //         if (numberOfUpdates > 0 && numberOfSellerMEDX === 0) {
    //           // numberOfUpdate chỉ dc đếm khi sau khi có hoá đơn
    //           return false;
    //         }
    //         // trong vòng 14 ngày thì vẫn hiện nút
    //         return arasingInvoice !== 0 && remainTime(now, arasingInvoice) <= 14 && numberOfSellerMEDX > 0;
    //       }
    //       // không yêu cầu xuất hoá đơn , thì sẽ tính 7 ngày từ ngày giao thành công để ẩn nút ( mặc định là hiện )
    //       // trong vòng 7 ngày thì sẽ hiện nút
    //       return deliveredTime !== 0 && remainTime(now, deliveredTime) <= 7;
    //     default:
    //       return true;
    //   }
    // };
    var enableBtn = function() {
        switch(status){
            case ENUM_ORDER_STATUS.CANCEL:
                return false;
            case ENUM_ORDER_STATUS.DELIVERING:
                return !(invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest);
            case ENUM_ORDER_STATUS.DELIVERED:
            case ENUM_ORDER_STATUS.COMPLETED:
                if (!(invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest)) return deliveredTime !== 0 && remainTime(now, deliveredTime) <= 7;
                return deliveredTime !== 0 && remainTime(now, deliveredTime) <= 14 && numberOfUpdates === 0;
            default:
                return true;
        }
    };
    var checkTime30days = completedTime !== 0 && remainTime(now, +new Date(completedTime)) >= 30;
    var ref5 = _sliced_to_array(useModal(), 2), openModalInvoice = ref5[0], toggleOpenModalInvoice = ref5[1];
    var handleChangeOrderTicket = function(value) {
        setOrderTicket(value);
    };
    var handleCancel = function() {
        var _ref = _async_to_generator(function() {
            var result, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            OrderClient.cancelOrder(orderId)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!isValid(result)) {
                            if ((result === null || result === void 0 ? void 0 : result.errorCode) === "INTERNAL_SERVICE_ERROR") throw new Error("Đ\xe3 c\xf3 lỗi xảy ra, vui l\xf2ng thử lại");
                            else throw new Error((result === null || result === void 0 ? void 0 : result.message) || "Gửi y\xeau cầu giữ đơn thất bại");
                        }
                        NotifyUtils.success("Gửi y\xeau cầu hủy đơn th\xe0nh c\xf4ng");
                        toggleOpenCancelOrder();
                        router.push(window.location.href);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        NotifyUtils.error(error.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCancel() {
            return _ref.apply(this, arguments);
        };
    }();
    var maxWidth = useMediaQuery("(max-width:715px)");
    return /*#__PURE__*/ _jsxs(Paper, {
        square: !maxWidth,
        className: clsx(styles.paper, invoices.length > 0 && styles.paper_popup),
        elevation: 0,
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                children: [
                    /*#__PURE__*/ _jsxs(Grid, {
                        item: true,
                        xs: maxWidth ? 12 : 5,
                        container: true,
                        direction: "row",
                        justifyContent: maxWidth ? "space-between" : "flex-start",
                        className: styles.grid,
                        children: [
                            /*#__PURE__*/ _jsxs(Grid, {
                                item: true,
                                container: true,
                                children: [
                                    /*#__PURE__*/ _jsx(Grid, {
                                        itemScope: true,
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "".concat(MY_ORDER_URL, "/").concat(orderId),
                                            prefetch: false,
                                            children: /*#__PURE__*/ _jsxs("h4", {
                                                className: styles.order_id,
                                                children: [
                                                    "#",
                                                    orderId,
                                                    " \xa0"
                                                ]
                                            })
                                        }, "order-row-".concat(uuidv4()))
                                    }),
                                    /*#__PURE__*/ _jsx(Grid, {
                                        className: styles.order_status,
                                        item: true,
                                        style: {
                                            paddingTop: "5px"
                                        },
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: styles.status_export,
                                            children: [
                                                /*#__PURE__*/ _jsx(OrderStatusButton, {
                                                    status: status,
                                                    handleSetOrderStatus: handleSetOrderStatus
                                                }),
                                                /*#__PURE__*/ _jsx(ExportDataOrderDetail, {
                                                    orderId: orderId
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(MyOrderDetail, {
                                amount: totalItem,
                                totalQuantity: totalQuantity,
                                createdTime: createdTime,
                                redeemCode: redeemCode,
                                deliveryDate: deliveryDate,
                                totalDiscount: totalDiscount,
                                paymentMethod: paymentMethod,
                                maxWidth: maxWidth
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Grid, {
                        item: true,
                        xs: maxWidth ? 12 : 2,
                        container: true,
                        direction: "row",
                        justifyContent: "space-between",
                        className: clsx(styles.grid),
                        children: /*#__PURE__*/ _jsx(Grid, {
                            className: clsx(maxWidth ? styles.price_small_screen : styles.price),
                            item: true,
                            children: formatCurrency(totalPrice)
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Grid, {
                        item: true,
                        xs: maxWidth ? 12 : 5,
                        container: true,
                        direction: maxWidth ? "row" : "column",
                        justifyContent: "center",
                        className: styles.grid,
                        children: [
                            status === ENUM_ORDER_STATUS.WAIT_TO_CONFIRM && /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.gridBtn,
                                children: canEdit && /*#__PURE__*/ _jsx(EditOrderButton, {
                                    orderId: orderId,
                                    canEdit: canEdit
                                })
                            }),
                            FEATURE_RE_ORDER && /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.gridBtn,
                                children: /*#__PURE__*/ _jsx(ButtonReOrder, {
                                    orderId: orderId
                                })
                            }),
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.gridBtn,
                                children: /*#__PURE__*/ _jsx(TicketButton, {
                                    order: {
                                        orderId: orderId,
                                        orderCode: orderCode,
                                        orderTime: createdTime,
                                        deliveryDate: deliveryDate,
                                        name: customerName,
                                        phone: customerPhone,
                                        orderStatus: status
                                    },
                                    handleChangeOrderTicket: handleChangeOrderTicket,
                                    handleOpenModal: toggleOpen
                                })
                            }),
                            status === ENUM_ORDER_STATUS.DELIVERED || status === ENUM_ORDER_STATUS.COMPLETED ? /*#__PURE__*/ _jsx(ButtonReturnOrder, {
                                orderId: orderId,
                                disabled: status === ENUM_ORDER_STATUS.DELIVERED ? false : checkTime30days
                            }) : null,
                            status !== ENUM_ORDER_STATUS.CANCEL && /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.gridBtn,
                                children: /*#__PURE__*/ _jsx(RequestInvoiceButton, {
                                    invoice: invoice,
                                    handleOpenModal: toggleOpenModalInvoice,
                                    numberOfSellerMEDX: numberOfSellerMEDX,
                                    numberProduct: (products === null || products === void 0 ? void 0 : products.length) || 0,
                                    status: status,
                                    numberOfUpdates: numberOfSellerMEDX,
                                    enable: enableBtn()
                                })
                            })
                        ]
                    })
                ]
            }),
            (invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest) && (invoices === null || invoices === void 0 ? void 0 : invoices.map(function(invoiceData) {
                return /*#__PURE__*/ _jsx(InvoiceList, {
                    invoiceData: invoiceData,
                    orderId: orderId
                }, uuidv4());
            })),
            open && /*#__PURE__*/ _jsx(TicketFormModal, _object_spread_props(_object_spread({}, orderTicket), {
                bankInfo: bankInfo,
                reasonsList: reasonsList,
                customerId: customerId,
                customerCode: customerCode,
                visible: open,
                onClose: toggleOpen,
                ticketType: "ORDER"
            })),
            openCancelOrder && /*#__PURE__*/ _jsx(CustomModal, {
                visible: openCancelOrder,
                onClose: toggleOpenCancelOrder,
                title: "Xin x\xe1c nhận",
                content: "Qu\xfd kh\xe1ch c\xf3 muốn hủy đơn h\xe0ng kh\xf4ng.",
                onClickOk: handleCancel,
                btnOnClose: "T\xf4i xem lại",
                btnOk: "Đồng \xfd"
            }),
            openModalInvoice && /*#__PURE__*/ _jsx(RequestInvoiceModal, {
                listInvoiceInfo: listInvoiceInfo,
                visible: openModalInvoice,
                onClose: toggleOpenModalInvoice,
                orderId: orderId,
                customerEmail: customerEmail,
                invoice: invoice,
                isMobile: isMobile
            })
        ]
    });
};
/* harmony default export */ var OrderInfoTabs_OrderRow = ((/* unused pure expression or super */ null && (OrderRow_OrderRow)));

;// CONCATENATED MODULE: ./src/components/mocules/OrderInfoTabs/index.js



function OrderInfoTabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff !important;\n  background-color: #005c29 !important;\n  border-color: #005c29 !important;\n  border: 1px solid transparent !important;\n  padding: 0.375rem 0.75rem !important;\n  font-size: 1rem !important;\n  line-height: 1.5 !important;\n  border-radius: 50px !important;\n  text-transform: none !important;\n"
    ]);
    OrderInfoTabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















var CustomTab = (0,withStyles/* default */.Z)({
    root: {
        textTransform: "none",
        minWidth: 130
    },
    selected: {
        color: "#005C29!important",
        fontWeight: "bold"
    }
})(Tab/* default */.Z);
var ComeHomeButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).withConfig({
    componentId: "sc-98bcad17-0"
})(OrderInfoTabs_templateObject());
var tabs = [
    {
        label: "Tất cả",
        value: Enums/* ENUM_ORDER_STATUS.ALL */.TJ.ALL
    },
    {
        label: "Chờ X\xe1c Nhận",
        value: Enums/* ENUM_ORDER_STATUS.WAIT_TO_CONFIRM */.TJ.WAIT_TO_CONFIRM
    },
    {
        label: "Đ\xe3 X\xe1c Nhận",
        value: Enums/* ENUM_ORDER_STATUS.CONFIRMED */.TJ.CONFIRMED
    },
    {
        label: "Đang Xử L\xfd",
        value: Enums/* ENUM_ORDER_STATUS.PROCESSING */.TJ.PROCESSING
    },
    {
        label: "Đang Giao",
        value: Enums/* ENUM_ORDER_STATUS.DELIVERING */.TJ.DELIVERING
    },
    {
        label: "Đ\xe3 Giao",
        value: Enums/* ENUM_ORDER_STATUS.DELIVERED */.TJ.DELIVERED
    },
    {
        label: "Ho\xe0n Tất",
        value: Enums/* ENUM_ORDER_STATUS.COMPLETED */.TJ.COMPLETED
    },
    {
        label: "Huỷ",
        value: Enums/* ENUM_ORDER_STATUS.CANCEL */.TJ.CANCEL
    }, 
];
var limit = clients/* LIMIT_DEFAULT */.J0;
function OrderInfoTabs(param) {
    var user = param.user, orders = param.orders, status = param.status, bankInfo = param.bankInfo, reasonsList = param.reasonsList, pageSize = param.pageSize, listInvoiceInfo = param.listInvoiceInfo, isMobile = param.isMobile;
    var router = useRouter();
    var ref = (router === null || router === void 0 ? void 0 : router.query) || {}, _offset = ref.offset, offset = _offset === void 0 ? 0 : _offset;
    var ref1 = useState((+offset + limit) / limit), numPage = ref1[0], setNumpage = ref1[1];
    var handleChangeOrderStatus = function(statusR) {
        router.push({
            pathname: router.pathname,
            query: {
                status: statusR
            }
        });
        setNumpage(1);
    };
    var handleComehome = function() {
        router.push("/");
    };
    var handleChangePage = function(_, page) {
        var offsetByPage = (page - 1) * limit;
        setNumpage(page);
        router.push({
            pathname: router.pathname,
            query: {
                offset: offsetByPage,
                limit: limit,
                status: status
            }
        });
    };
    return /*#__PURE__*/ _jsxs(Grid, {
        container: true,
        spacing: 1,
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                className: styles.tabs,
                children: /*#__PURE__*/ _jsx(Paper, {
                    elevation: 0,
                    children: /*#__PURE__*/ _jsx(Tabs, {
                        value: status,
                        textColor: "primary",
                        centered: true,
                        classes: {
                            indicator: styles.indicator
                        },
                        children: tabs && tabs.map(function(param) {
                            var label = param.label, value = param.value;
                            return /*#__PURE__*/ _jsx(CustomTab, {
                                label: label,
                                disableFocusRipple: true,
                                disableRipple: true,
                                onClick: function() {
                                    return handleChangeOrderStatus(value);
                                },
                                value: value
                            }, uuidV4());
                        })
                    })
                })
            }),
            orders.length === 0 ? /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                container: true,
                justifyContent: "center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.not_order_container,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.not_order_title,
                            children: "Kh\xf4ng c\xf3 đơn h\xe0ng"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(ComeHomeButton, {
                                onClick: handleComehome,
                                children: " Đến trang đặt h\xe0ng nhanh "
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                children: orders && orders.map(function(order) {
                    return /*#__PURE__*/ _createElement(OrderRow, _object_spread_props(_object_spread({}, order), {
                        key: uuidV4(),
                        user: user,
                        handleSetOrderStatus: handleChangeOrderStatus,
                        bankInfo: bankInfo,
                        reasonsList: reasonsList,
                        listInvoiceInfo: listInvoiceInfo,
                        isMobile: isMobile
                    }));
                })
            }),
            orders.length > 0 && /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.justify_center,
                    children: /*#__PURE__*/ _jsx(Pagination, {
                        defaultPage: numPage,
                        count: pageSize,
                        onChange: handleChangePage,
                        page: numPage
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormGroup/FormGroup.js
var FormGroup = __webpack_require__(6562);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 1 modules
var Modal_Modal = __webpack_require__(72578);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(1197);
;// CONCATENATED MODULE: ./src/components/mocules/PaymentMethod/PaymentMethodMobile.js

















var PaymentMethodsTab = function(param) {
    var _openTab = param.openTab, openTab = _openTab === void 0 ? true : _openTab, _setOpenTab = param.setOpenTab, setOpenTab = _setOpenTab === void 0 ? function() {} : _setOpenTab, _translateCheckout = param.translateCheckout, translateCheckout = _translateCheckout === void 0 ? function() {} : _translateCheckout, _paymentMethods = param.paymentMethods, paymentMethods = _paymentMethods === void 0 ? [] : _paymentMethods, _selectedVal = param.selectedVal, selectedVal = _selectedVal === void 0 ? "" : _selectedVal, _handleChange = param.handleChange, handleChange = _handleChange === void 0 ? function() {} : _handleChange, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var ref = (0,react.useState)(selectedVal), paymentMethodSelected = ref[0], setPaymentMethodSelected = ref[1];
    var handleChangePaymentMethodOption = function(e) {
        setPaymentMethodSelected(e.target.value);
    };
    var handleClose = function() {
        setOpenTab(false);
    };
    var handleSubmitPaymentMethod = function() {
        var e = {
            target: {
                value: paymentMethodSelected
            }
        };
        handleChange(e);
        setOpenTab(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        open: openTab,
        handleClose: handleClose,
        fullScreen: true,
        fullWidth: true,
        style: {
            backgroundColor: "#fff",
            position: "fixed",
            zIndex: "1300",
            inset: "0px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
            container: true,
            direction: "column",
            className: (PaymentMethod_styles_module_default()).containerModal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                    item: true,
                    onClick: handleClose,
                    className: (PaymentMethod_styles_module_default()).headerBack,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                        className: (PaymentMethod_styles_module_default()).iconBackButton,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {
                                style: {
                                    width: "16px",
                                    height: "16px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (PaymentMethod_styles_module_default()).titleBackButton,
                                children: translateCheckout("payment_method")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                    item: true,
                    className: (PaymentMethod_styles_module_default()).listItemsBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        container: true,
                        direction: "column",
                        style: {
                            height: "100%",
                            flexWrap: "unset"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PaymentMethod_styles_module_default()).listItems,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                    component: "fieldset",
                                    style: {
                                        width: "100%",
                                        height: "85%",
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                        className: (PaymentMethod_styles_module_default()).radioGroup,
                                        children: (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) > 0 ? paymentMethods.map(function(item) {
                                            var ref, ref1;
                                            var paymentMethodName = item["name_".concat(locale)] || (item === null || item === void 0 ? void 0 : item.name) || "";
                                            var paymentMethodSubTitle = item["subTitle_".concat(locale)] || (item === null || item === void 0 ? void 0 : item.subTitle) || "";
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup_RadioGroup/* default */.Z, {
                                                value: paymentMethodSelected,
                                                className: (PaymentMethod_styles_module_default()).groupCheckBox,
                                                onChange: handleChangePaymentMethodOption,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                                    value: item.code,
                                                    disabled: item.isDisable,
                                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                                                        size: "small"
                                                    }),
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                        display: "flex",
                                                        gridGap: 8,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "center",
                                                                flexGrow: 1,
                                                                gridGap: 4,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                        className: (PaymentMethod_styles_module_default()).titleContent,
                                                                        children: paymentMethodName
                                                                    }),
                                                                    paymentMethodSubTitle.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (PaymentMethod_styles_module_default()).subTitle,
                                                                        children: (item === null || item === void 0 ? void 0 : (ref = item.url) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: item.url,
                                                                            target: "_blank",
                                                                            rel: "noreferrer",
                                                                            children: paymentMethodSubTitle
                                                                        }) : paymentMethodSubTitle
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                display: "flex",
                                                                flexWrap: "no-wrap",
                                                                gridGap: 4,
                                                                children: (item === null || item === void 0 ? void 0 : (ref1 = item.svgIcons) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && item.svgIcons.map(function(svgIconURL) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ImageFallback */.oy, {
                                                                        src: svgIconURL,
                                                                        alt: item.name,
                                                                        width: "40px",
                                                                        height: "36px"
                                                                    }, svgIconURL);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, item.code);
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PaymentMethod_styles_module_default()).listItems,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PaymentMethod_styles_module_default()).donePaymentButtonBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "contained",
                                        color: "primary",
                                        className: (PaymentMethod_styles_module_default()).donePaymentButton,
                                        onClick: handleSubmitPaymentMethod,
                                        children: translateCheckout("confirm")
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var PaymentMethodMobile = function(param) {
    var _translateCheckout = param.translateCheckout, translateCheckout = _translateCheckout === void 0 ? function() {} : _translateCheckout, _paymentMethods = param.paymentMethods, paymentMethods = _paymentMethods === void 0 ? [] : _paymentMethods, _selectedVal = param.selectedVal, selectedVal = _selectedVal === void 0 ? "" : _selectedVal, _handleChange = param.handleChange, handleChange = _handleChange === void 0 ? function() {} : _handleChange, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale, _selectedPaymentName = param.selectedPaymentName, selectedPaymentName = _selectedPaymentName === void 0 ? "" : _selectedPaymentName, _selectedPaymentSubTitle = param.selectedPaymentSubTitle, selectedPaymentSubTitle = _selectedPaymentSubTitle === void 0 ? "" : _selectedPaymentSubTitle, _selectedPaymentMethod = param.selectedPaymentMethod, selectedPaymentMethod = _selectedPaymentMethod === void 0 ? {} : _selectedPaymentMethod;
    var ref;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                container: true,
                alignItems: "space-between",
                onClick: function() {
                    return setOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                        item: true,
                        xs: 11,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (PaymentMethod_styles_module_default()).title,
                            children: translateCheckout("payment_method")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                        item: true,
                        xs: 1,
                        style: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            style: {
                                padding: 0,
                                position: "absolute",
                                top: 0,
                                right: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                style: {
                                    width: "14px",
                                    height: "14px",
                                    color: "#00000061"
                                }
                            })
                        })
                    })
                ]
            }),
            selectedPaymentMethod && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                container: true,
                alignItems: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        item: true,
                        xs: 10,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: (PaymentMethod_styles_module_default()).fw500,
                                children: selectedPaymentName
                            }),
                            (selectedPaymentSubTitle === null || selectedPaymentSubTitle === void 0 ? void 0 : selectedPaymentSubTitle.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PaymentMethod_styles_module_default()).subTitle,
                                children: selectedPaymentSubTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                        item: true,
                        xs: 2,
                        style: {
                            position: "relative"
                        },
                        children: selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : (ref = selectedPaymentMethod.svgIcons) === null || ref === void 0 ? void 0 : ref.map(function(svgIconURL) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ImageFallback */.oy, {
                                src: svgIconURL,
                                alt: selectedPaymentName,
                                width: "40px",
                                height: "36px"
                            }, svgIconURL);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsTab, {
                openTab: open,
                setOpenTab: setOpen,
                translateCheckout: translateCheckout,
                paymentMethods: paymentMethods,
                selectedVal: selectedVal,
                handleChange: handleChange,
                locale: locale
            })
        ]
    });
};
/* harmony default export */ var PaymentMethod_PaymentMethodMobile = (PaymentMethodMobile);

;// CONCATENATED MODULE: ./src/components/mocules/PaymentMethod/PaymentMethodWeb.js












var PaymentMethodItem = function(param) {
    var item = param.item, isSelected = param.isSelected, onChange = param.onChange, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var ref = item || {}, code = ref.code, name = ref.name, subTitle = ref.subTitle, url = ref.url, isDisable = ref.isDisable, _svgIcons = ref.svgIcons, svgIcons = _svgIcons === void 0 ? [] : _svgIcons;
    var paymentMethodName = item["name_".concat(locale)] || name || "";
    var paymentMethodSubTitle = item["subTitle_".concat(locale)] || subTitle || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup_RadioGroup/* default */.Z, {
        className: (PaymentMethod_styles_module_default()).fieldset,
        value: isSelected && code,
        onChange: onChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
            className: "".concat(isSelected ? "active_payment" : ""),
            value: code,
            disabled: isDisable,
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                classes: {
                    root: isSelected ? (PaymentMethod_styles_module_default()).checkbox_color : (PaymentMethod_styles_module_default()).noncheckbox_color
                },
                "data-test": "radio-checkout-payment",
                size: "small"
            }),
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                container: true,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        item: true,
                        xs: 10,
                        container: true,
                        direction: "column",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    className: (PaymentMethod_styles_module_default()).fw500,
                                    children: paymentMethodName
                                })
                            }),
                            (paymentMethodSubTitle === null || paymentMethodSubTitle === void 0 ? void 0 : paymentMethodSubTitle.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PaymentMethod_styles_module_default()).subTitle,
                                    children: url.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: url,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: paymentMethodSubTitle
                                    }) : paymentMethodSubTitle
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                        item: true,
                        xs: 2,
                        className: (PaymentMethod_styles_module_default()).textRight,
                        children: svgIcons.map(function(svgIconURL) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ImageFallback */.oy, {
                                src: svgIconURL,
                                alt: paymentMethodName,
                                width: "40px",
                                height: "36px"
                            }, svgIconURL);
                        })
                    })
                ]
            })
        })
    });
};
var PaymentMethodWeb = function(param) {
    var handleChange = param.handleChange, _selectedVal = param.selectedVal, selectedVal = _selectedVal === void 0 ? "" : _selectedVal, _paymentMethods = param.paymentMethods, paymentMethods = _paymentMethods === void 0 ? [] : _paymentMethods, errorMessage = param.errorMessage, description = param.description, locale = param.locale, translateCheckout = param.translateCheckout;
    var checkExistDescriptionContent = (0,react.useMemo)(function() {
        return description && description.length > 0 && description !== "<p></p>\n";
    }, [
        description
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (PaymentMethod_styles_module_default()).title,
                children: translateCheckout("payment_method")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                component: "fieldset",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PaymentMethod_styles_module_default()).paymentMethodsGrid,
                        children: (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) > 0 ? paymentMethods.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodItem, {
                                item: item,
                                isSelected: selectedVal === item.code,
                                onChange: handleChange,
                                locale: locale
                            }, item.code);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 70
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 70
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 70
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 70
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 70
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 70
                                })
                            ]
                        })
                    }),
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PaymentMethod_styles_module_default()).subTitle,
                        children: errorMessage
                    }),
                    checkExistDescriptionContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                            className: (PaymentMethod_styles_module_default()).bank_info,
                            icon: false,
                            severity: "info",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                container: true,
                                direction: "row",
                                justifyContent: "space-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    item: true,
                                    spacing: 2,
                                    className: (PaymentMethod_styles_module_default()).content,
                                    dangerouslySetInnerHTML: {
                                        __html: description
                                    }
                                })
                            })
                        })
                    }, (0,v4/* default */.Z)())
                ]
            })
        ]
    });
};
/* harmony default export */ var PaymentMethod_PaymentMethodWeb = (PaymentMethodWeb);

;// CONCATENATED MODULE: ./src/components/mocules/PaymentMethod/index.js










var MissingUserInformation = function(param) {
    var user = param.user, translateCheckout = param.translateCheckout;
    var _wardCode = user.wardCode, wardCode = _wardCode === void 0 ? "" : _wardCode, _districtCode = user.districtCode, districtCode = _districtCode === void 0 ? "" : _districtCode, _provinceCode = user.provinceCode, provinceCode = _provinceCode === void 0 ? "" : _provinceCode;
    return (!wardCode || !districtCode || !provinceCode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert_Alert/* default */.Z, {
        severity: "info",
        style: {
            borderRadius: "8px",
            marginTop: "15px"
        },
        children: [
            translateCheckout("please_enter_full"),
            " ",
            !wardCode && translateCheckout("ward"),
            !districtCode && ", ".concat(translateCheckout("district")),
            !provinceCode && ", ".concat(translateCheckout("province")),
            " ",
            translateCheckout("in"),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/my-account",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/my-account",
                        target: "_blank",
                        children: translateCheckout("account_info")
                    })
                })
            }),
            " ",
            translateCheckout("to_get_discount")
        ]
    });
};
var PaymentMethod = function(param) {
    var handleChange = param.handleChange, _selectedPayment = param.selectedPayment, selectedPayment = _selectedPayment === void 0 ? "" : _selectedPayment, _paymentMethods = param.paymentMethods, paymentMethods = _paymentMethods === void 0 ? [] : _paymentMethods, paymentMethodDefault = param.paymentMethodDefault, user = param.user, translateCheckout = param.translateCheckout, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var locale = js_cookie_default().get("NEXT_LOCALE") || sysconfig/* LANG_DEFAULT */.YY;
    // Get information's of selected payment method
    var selectedPaymentCode = (0,react.useMemo)(function() {
        return selectedPayment || (paymentMethodDefault === null || paymentMethodDefault === void 0 ? void 0 : paymentMethodDefault.code) || "";
    }, [
        selectedPayment,
        paymentMethodDefault === null || paymentMethodDefault === void 0 ? void 0 : paymentMethodDefault.code
    ]);
    var selectedPaymentMethod = (0,react.useMemo)(function() {
        return (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.find(function(method) {
            return method.code === selectedPaymentCode;
        })) || {};
    }, [
        paymentMethods,
        selectedPaymentCode
    ]);
    var ref = selectedPaymentMethod || {}, description = ref.description, errorMessage = ref.errorMessage, defaultName = ref.name, defaultSubTitle = ref.subTitle, currencyOptions = ref.currency;
    var ref1, ref2;
    var selectedPaymentName = (0,react.useMemo)(function() {
        return (ref2 = (ref1 = selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod["name_".concat(locale)]) !== null && ref1 !== void 0 ? ref1 : defaultName) !== null && ref2 !== void 0 ? ref2 : "";
    }, [
        selectedPaymentMethod,
        defaultName,
        locale
    ]);
    var ref3, ref4;
    var selectedPaymentSubTitle = (0,react.useMemo)(function() {
        return (ref4 = (ref3 = selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod["subTitle_".concat(locale)]) !== null && ref3 !== void 0 ? ref3 : defaultSubTitle) !== null && ref4 !== void 0 ? ref4 : "";
    }, [
        selectedPaymentMethod,
        defaultSubTitle,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper_Paper/* default */.Z, {
        className: (PaymentMethod_styles_module_default()).root,
        elevation: 4,
        children: [
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethod_PaymentMethodMobile, {
                translateCheckout: translateCheckout,
                paymentMethods: paymentMethods,
                selectedVal: selectedPaymentCode,
                handleChange: handleChange,
                locale: locale,
                selectedPaymentName: selectedPaymentName,
                selectedPaymentSubTitle: selectedPaymentSubTitle,
                selectedPaymentMethod: selectedPaymentMethod || {}
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethod_PaymentMethodWeb, {
                translateCheckout: translateCheckout,
                paymentMethods: paymentMethods,
                selectedVal: selectedPaymentCode,
                handleChange: handleChange,
                locale: locale,
                errorMessage: errorMessage,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissingUserInformation, {
                user: user,
                translateCheckout: translateCheckout
            })
        ]
    });
};
/* harmony default export */ var mocules_PaymentMethod = (/*#__PURE__*/react.memo(PaymentMethod));

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Print.js
var Print = __webpack_require__(20394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell_TableCell = __webpack_require__(88222);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow_TableRow = __webpack_require__(57394);
// EXTERNAL MODULE: ./src/components/mocules/PrintInvoiceModal/style.module.css
var PrintInvoiceModal_style_module = __webpack_require__(28829);
var PrintInvoiceModal_style_module_default = /*#__PURE__*/__webpack_require__.n(PrintInvoiceModal_style_module);
;// CONCATENATED MODULE: ./src/components/mocules/PrintInvoiceModal/validateForm.js

var PrintInvoiceModal_validateForm_validateForm = function(param) {
    var _businessName = param.businessName, businessName = _businessName === void 0 ? "" : _businessName, _mst = param.mst, mst = _mst === void 0 ? "" : _mst, _taxCode = param.taxCode, taxCode = _taxCode === void 0 ? "" : _taxCode, _email = param.email, email = _email === void 0 ? "" : _email, _address = param.address, address = _address === void 0 ? "" : _address, provinceCode = param.provinceCode, districtCode = param.districtCode, wardCode = param.wardCode;
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(businessName)) throw Error("message_clinic_name_cannot_be_empty");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(mst || taxCode)) throw Error("message_empty_tax_code");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(email)) throw Error("message_cannot_be_empty");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(address)) throw Error("message_empty_address");
    if (provinceCode === "0") throw Error("message_empty_province_city");
    if (districtCode === "0") throw Error("message_empty_district");
    if (wardCode === "0") throw Error("message_empty_ward");
    if (!utils/* ValidateUtils.validateEmail */.IN.validateEmail(email)) throw Error("message_invalid_email");
    if (!utils/* ValidateUtils.isNumber */.IN.isNumber(mst || taxCode)) throw Error("message_tax_code_wrong_format");
};
/* harmony default export */ var PrintInvoiceModal_validateForm = (PrintInvoiceModal_validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/PrintInvoiceModal/index.js






function PrintInvoiceModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff !important;\n  background-color: #005c29 !important;\n  border: 1px solid #005c29 !important;\n  font-weight: 500 !important;\n  margin-top: 50px !important;\n  border-radius: 10px !important;\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n\n  &:hover {\n    background: #fff !important;\n    color: #005c29 !important;\n    border: 1px solid #005c29 !important;\n  }\n"
    ]);
    PrintInvoiceModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















var StyledCompleteButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).withConfig({
    componentId: "sc-6e296b0d-0"
})(PrintInvoiceModal_templateObject());
var PrintInvoiceModal = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var heads = [
        {
            text: "Sản phẩm h\xf3a đơn nhanh",
            align: Enums/* ALIGN.LEFT */.Hp.LEFT
        },
        {
            text: "Gi\xe1 (đ)",
            align: Enums/* ALIGN.RIGHT */.Hp.RIGHT
        },
        {
            text: "Số lượng",
            align: Enums/* ALIGN.RIGHT */.Hp.RIGHT
        },
        {
            text: "Tổng cộng (đ)",
            align: Enums/* ALIGN.RIGHT */.Hp.RIGHT
        }, 
    ];
    var onClose = props.onClose, visible = props.visible, className = props.className, restProps = props.restProps, orderCode = props.orderCode, user = props.user;
    var add = user.address, businessName = user.businessName, email = user.email, taxCode = user.taxCode;
    var ref1 = (0,react.useState)({
        taxCode: taxCode || "",
        email: email || "",
        businessName: businessName || "",
        address: add || ""
    }), val = ref1[0], setVal = ref1[1];
    var ref2 = (0,react.useState)({
        province: user === null || user === void 0 ? void 0 : user.provinceCode,
        district: user === null || user === void 0 ? void 0 : user.districtCode,
        ward: user === null || user === void 0 ? void 0 : user.wardCode
    }), address = ref2[0], setAddress = ref2[1];
    var ref3 = (0,react.useState)({
        changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED,
        province: address.province,
        district: address.district,
        ward: address.ward
    }), currentAddress = ref3[0], setCurrentAddress = ref3[1];
    var handleSetCurrentAddress = function(addressinfo) {
        setCurrentAddress(addressinfo);
        setAddress((0,src_object_spread/* default */.Z)({}, address, addressinfo));
    };
    var ref4 = (0,react.useState)([]), products = ref4[0], setProducts = ref4[1];
    var handleChangeVal = function(key, value) {
        setVal((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, val), (0,src_define_property/* default */.Z)({}, key, value)));
    };
    var handleCompleted = function() {
        try {
            PrintInvoiceModal_validateForm(val);
            utils/* NotifyUtils.success */.QP.success("Xuất ho\xe1 đơn th\xe0nh c\xf4ng.");
            onClose();
        } catch (error) {
            utils/* NotifyUtils.error */.QP.error(translateAlertAction(error === null || error === void 0 ? void 0 : error.message) || "Xuất ho\xe1 đơn thất bại");
        }
    };
    (0,react.useEffect)(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,src_async_to_generator/* default */.Z)(function() {
                var res, _tmp, orderItems, orderItemInfoRes, _tmp1, orderItemInfoMap, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            _tmp = {};
                            return [
                                4,
                                clients/* OrderClient.getProductByOrderCode */.ZT.getProductByOrderCode((_tmp.orderCode = orderCode, _tmp))
                            ];
                        case 1:
                            res = _state.sent();
                            if (!(0,clients/* isValid */.JY)(res)) throw Error();
                            orderItems = (res === null || res === void 0 ? void 0 : res.data) || [];
                            _tmp1 = {};
                            return [
                                4,
                                services/* OrderService.getInfoOrderItem */.px.getInfoOrderItem((_tmp1.orderItems = orderItems, _tmp1))
                            ];
                        case 2:
                            orderItemInfoRes = _state.sent();
                            if (!(0,clients/* isValid */.JY)(orderItemInfoRes)) throw Error("Load th\xf4ng tin sản phẩm thất bại");
                            orderItemInfoMap = orderItemInfoRes.data[0];
                            orderItems = orderItems.map(function(product) {
                                var sku = product === null || product === void 0 ? void 0 : product.productSku;
                                return (0,src_object_spread/* default */.Z)({
                                    productInfo: orderItemInfoMap[sku] || {}
                                }, product);
                            });
                            setProducts(orderItems);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            setProducts([]);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchData.apply(this, arguments);
        }
        fetchData();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (PrintInvoiceModal_style_module_default()).confirm_modal_wrap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (PrintInvoiceModal_style_module_default()).title,
                        children: " Th\xf4ng tin xuất ho\xe1 đơn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                label: "T\xean nh\xe0 thuốc/ph\xf2ng kh\xe1m",
                                htmlFor: "address",
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "businessName",
                                    value: val.businessName,
                                    onChange: function(e) {
                                        return handleChangeVal("businessName", e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                label: "M\xe3 số thuế",
                                htmlFor: "address",
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "taxCode",
                                    value: val.taxCode,
                                    onChange: function(e) {
                                        return handleChangeVal("taxCode", e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                label: "Email",
                                htmlFor: "address",
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "email",
                                    value: val.email,
                                    onChange: function(e) {
                                        return handleChangeVal("email", e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                label: "Địa chỉ nhận ho\xe1 đơn",
                                htmlFor: "address",
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "address",
                                    value: val.address,
                                    onChange: function(e) {
                                        return handleChangeVal("address", e.target.value);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_GroupAddressSelect, {
                        id: (0,v4/* default */.Z)(),
                        currentAddress: currentAddress,
                        handleSetCurrentAddress: handleSetCurrentAddress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoTable */.CE, {
                        heads: heads,
                        stickyHeader: true,
                        className: (PrintInvoiceModal_style_module_default()).ovfy,
                        children: products.map(function(product) {
                            var salePrice = product.salePrice, quantity = product.quantity, totalPrice = product.totalPrice;
                            var ref = product.productInfo || {}, _name = ref.name, name = _name === void 0 ? "" : _name, _slug = ref.slug, slug = _slug === void 0 ? "" : _slug;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow_TableRow/* default */.Z, {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell_TableCell/* default */.Z, {
                                        align: Enums/* ALIGN.LEFT */.Hp.LEFT,
                                        className: (PrintInvoiceModal_style_module_default()).product_name,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                            variant: "h5",
                                            href: (0,Paths/* getPathProductBySlug */.hq)(slug),
                                            className: (PrintInvoiceModal_style_module_default()).product_name,
                                            children: name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell_TableCell/* default */.Z, {
                                        align: Enums/* ALIGN.RIGHT */.Hp.RIGHT,
                                        children: (0,FormatNumber/* formatNumber */.uf)(salePrice)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell_TableCell/* default */.Z, {
                                        align: Enums/* ALIGN.RIGHT */.Hp.RIGHT,
                                        children: (0,FormatNumber/* formatNumber */.uf)(quantity)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell_TableCell/* default */.Z, {
                                        align: Enums/* ALIGN.RIGHT */.Hp.RIGHT,
                                        children: (0,FormatNumber/* formatNumber */.uf)(totalPrice)
                                    })
                                ]
                            }, (0,v4/* default */.Z)());
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompleteButton, {
                        onClick: handleCompleted,
                        children: " Xuất ho\xe1 đơn "
                    })
                ]
            })
        })
    }));
});
/* harmony default export */ var mocules_PrintInvoiceModal = (PrintInvoiceModal);

;// CONCATENATED MODULE: ./src/components/mocules/PrintInvoiceButton/index.js





var PrintInvoiceButton = function(param) {
    var disabled = param.disabled, orderCode = param.orderCode, user = param.user;
    var ref = (0,react.useState)(false), val = ref[0], setVal = ref[1];
    var handleChangeVal = function() {
        setVal(!val);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Print/* default */.Z, {}),
                className: "my-order__button my-order__button--secondary",
                disabled: disabled,
                onClick: handleChangeVal,
                children: "Xuất ho\xe1 đơn"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_PrintInvoiceModal, {
                visible: val,
                onClose: handleChangeVal,
                orderCode: orderCode,
                user: user
            })
        ]
    });
};
/* harmony default export */ var mocules_PrintInvoiceButton = (/*#__PURE__*/react.memo(PrintInvoiceButton));

// EXTERNAL MODULE: ./src/components/mocules/ProductCardContent/index.js + 1 modules
var ProductCardContent = __webpack_require__(19963);
// EXTERNAL MODULE: ./src/components/mocules/ProductCardInput/index.js + 1 modules
var ProductCardInput = __webpack_require__(77524);
// EXTERNAL MODULE: ./src/components/mocules/ProductDetailTabs/index.js
var ProductDetailTabs = __webpack_require__(88491);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabContext/TabContext.js
var TabContext = __webpack_require__(78207);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabList/TabList.js
var TabList = __webpack_require__(37313);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabPanel/TabPanel.js
var TabPanel = __webpack_require__(64532);
// EXTERNAL MODULE: ./src/components/mocules/ProductDetailTabsV2/styles.module.css
var ProductDetailTabsV2_styles_module = __webpack_require__(69815);
var ProductDetailTabsV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductDetailTabsV2_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductDetailTabsV2/index.js
/* eslint-disable react/no-danger */ 














function ProductDetailTabsV2(param) {
    var data = param.data, product = param.product, _ingredients = param.ingredients, ingredients = _ingredients === void 0 ? [] : _ingredients, isMobile = param.isMobile;
    var ref = (0,esm/* useTranslation */.$G)("productDetail"), translateProductDetail = ref.t;
    var ref1 = (0,react.useState)(0), height = ref1[0], setHeight = ref1[1];
    var ref2 = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        setHeight((ref2 === null || ref2 === void 0 ? void 0 : (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.clientHeight) || 0);
    });
    var ref3 = product || {}, _description = ref3.description, description = _description === void 0 ? {} : _description;
    var ref4 = (0,context/* useSetting */.yu)(), _mapIngredients = ref4.mapIngredients, mapIngredients = _mapIngredients === void 0 ? null : _mapIngredients;
    var ref5 = (0,react.useState)(0), activeTab = ref5[0], setActiveTab = ref5[1];
    var handleChangeTab = function(e, newValue) {
        setActiveTab(newValue);
    };
    var tabPanels = [
        {
            label: translateProductDetail("general_information"),
            value: 0,
            data: data.slice(0, 2)
        },
        {
            label: translateProductDetail("in_depth_information"),
            value: 1,
            data: data.slice(2)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ProductDetailTabsV2_styles_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabContext/* default */.ZP, {
            value: activeTab,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabList/* default */.Z, {
                        TabIndicatorProps: {
                            className: (ProductDetailTabsV2_styles_module_default()).indicator
                        },
                        onChange: handleChangeTab,
                        "aria-label": "product details tabs",
                        variant: "scrollable",
                        className: (ProductDetailTabsV2_styles_module_default()).tabs,
                        children: tabPanels.map(function(tab) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                classes: {
                                    root: (ProductDetailTabsV2_styles_module_default()).tab,
                                    selected: (ProductDetailTabsV2_styles_module_default()).active_tab
                                },
                                label: tab.label,
                                value: tab.value
                            }, (0,v4/* default */.Z)());
                        })
                    })
                }),
                tabPanels.map(function(tabPanel, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)((ProductDetailTabsV2_styles_module_default()).tab_panel, (0,src_define_property/* default */.Z)({}, (ProductDetailTabsV2_styles_module_default()).tab_panel_mv2, isMobile)),
                        value: tabPanel === null || tabPanel === void 0 ? void 0 : tabPanel.value,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(!isMobile ? (ProductDetailTabsV2_styles_module_default()).item_wrapper : (ProductDetailTabsV2_styles_module_default()).mobile_item_wrapper),
                            children: tabPanel.data.map(function(tab) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(!isMobile ? (ProductDetailTabsV2_styles_module_default()).item : (ProductDetailTabsV2_styles_module_default()).mobile_item, index === 0 && (ProductDetailTabsV2_styles_module_default()).general_item),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ProductDetailTabsV2_styles_module_default()).item_label,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: tab.label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ProductDetailTabsV2_styles_module_default()).item_label_border
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ProductDetailTabsV2_styles_module_default()).item_content,
                                            children: [
                                                (tab === null || tab === void 0 ? void 0 : tab.code) === "ingredients" && (ingredients === null || ingredients === void 0 ? void 0 : ingredients.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (ProductDetailTabsV2_styles_module_default()).ingredientList,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)((ProductDetailTabsV2_styles_module_default()).ingredient_row, (ProductDetailTabsV2_styles_module_default()).ingredient_row_heading),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (0,clsx_m/* default */.Z)((ProductDetailTabsV2_styles_module_default()).ingredient_row_label, (ProductDetailTabsV2_styles_module_default()).ingredient_heading),
                                                                    children: translateProductDetail("composition")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (0,clsx_m/* default */.Z)((ProductDetailTabsV2_styles_module_default()).ingredient_row_content, (ProductDetailTabsV2_styles_module_default()).ingredient_heading),
                                                                    children: translateProductDetail("ingredient_content")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: ingredients === null || ingredients === void 0 ? void 0 : ingredients.map(function(param) {
                                                                var ingredientCode = param.ingredientCode, ingredientVolume = param.volume;
                                                                var ref = (mapIngredients === null || mapIngredients === void 0 ? void 0 : mapIngredients.get(ingredientCode)) || {}, slug = ref.slug, tmp = ref.name, ingredientName = tmp === void 0 ? "" : tmp;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (ProductDetailTabsV2_styles_module_default()).ingredient_row,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                                                            href: "".concat(Paths/* INGREDIENT */.gL, "/").concat(slug),
                                                                            className: (ProductDetailTabsV2_styles_module_default()).ingredient_row_label,
                                                                            children: ingredientName
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: (ProductDetailTabsV2_styles_module_default()).ingredient_row_content,
                                                                            children: ingredientVolume
                                                                        })
                                                                    ]
                                                                }, ingredientCode);
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (tab === null || tab === void 0 ? void 0 : tab.code) !== "ingredients" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: description[tab === null || tab === void 0 ? void 0 : tab.code]
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }, (0,v4/* default */.Z)());
                            })
                        })
                    }, tabPanel === null || tabPanel === void 0 ? void 0 : tabPanel.value);
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/LoadingScreen/index.js
var organisms_LoadingScreen = __webpack_require__(37071);
;// CONCATENATED MODULE: ./src/components/mocules/PromoListModal/Button.js

function Button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff !important;\n  background-color: #17a2b8 !important;\n  border: 1px solid #17a2b8 !important;\n  border-radius: 0 !important;\n  margin-right: 0 !important;\n  margin-top: 16px !important;\n"
    ]);
    Button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var FindButton = function(param) {
    var className = param.className, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
        className: className,
        onClick: onClick,
        children: "T\xecm"
    });
};
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(FindButton).withConfig({
    componentId: "sc-4290717e-0"
})(Button_templateObject());
/* harmony default export */ var PromoListModal_Button = ((/* unused pure expression or super */ null && (StyledButton)));

;// CONCATENATED MODULE: ./src/components/mocules/PromoListModal/Input.js

function Input_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0 0 10px !important;\n  height: calc(1.75em + 0.5rem + 2px);\n  border-radius: 0 !important;\n"
    ]);
    Input_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Input */.II).withConfig({
    componentId: "sc-30703f80-0"
})(Input_templateObject());
/* harmony default export */ var PromoListModal_Input = ((/* unused pure expression or super */ null && (StyledInput)));

;// CONCATENATED MODULE: ./src/components/mocules/PromoListModal/index.js























var TEXT_DEFAULT = "";
var searchString = function(arr, str) {
    var result = arr.filter(function(el) {
        var ref;
        return ((ref = el.code) === null || ref === void 0 ? void 0 : ref.indexOf(str)) > -1;
    });
    return result;
};
// TODO:PROMOTION
var PromoListModal = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(props) {
    var user = useAuth().user;
    var ref = useProduct(), getProductBySkus = ref.getProductBySkus, getProductsByIds = ref.getProductsByIds;
    var ref1 = useSetting(), mapIngredients = ref1.mapIngredients, mapSeller = ref1.mapSeller, mapManufactuers = ref1.mapManufactuers, mapCategories = ref1.mapCategories;
    var getStyleBySlugOfTag = useStore(function(state) {
        return state.getStyleBySlugOfTag;
    });
    var cartInfo = useCart();
    var onClose = props.onClose, visible = props.visible, className = props.className, restProps = props.restProps, redeemCode = props.redeemCode, handleChangePromo = props.handleChangePromo, subPrice = props.subPrice;
    // const { provinceCode } = user || {};
    // const regionCode = provinces?.find((item) => item.value === provinceCode)?.regionCode;
    var ref2 = useState(TEXT_DEFAULT), text = ref2[0], setText = ref2[1];
    var ref3 = useState([]), promoSearchs = ref3[0], setPromoSearchs = ref3[1];
    var ref4 = useState([]), promos = ref4[0], setPromos = ref4[1];
    var ref5 = useState(false), loading = ref5[0], setLoading = ref5[1];
    var handleChangeText = function(e) {
        setText(e.target.value);
    };
    var handleRemoveText = function() {
        setText(TEXT_DEFAULT);
    };
    // THUANNC
    var isHaveGift = function(voucher) {
        return (voucher === null || voucher === void 0 ? void 0 : voucher.rewards) && voucher.rewards.length > 0 && voucher.rewards[0].gifts && voucher.rewards[0].gifts.length > 0;
    };
    var filterSellerCodes = function(param) {
        var productCondition = param.productCondition, items = param.items;
        return (productCondition === null || productCondition === void 0 ? void 0 : productCondition.sellerQuantityType) === "MANY" ? items === null || items === void 0 ? void 0 : items.filter(function(item) {
            var ref;
            return (productCondition === null || productCondition === void 0 ? void 0 : (ref = productCondition.sellerCodes) === null || ref === void 0 ? void 0 : ref.indexOf(item === null || item === void 0 ? void 0 : item.sellerCode)) >= 0;
        }) : items;
    };
    var validateProductCondition = function(param) {
        var productCondition = param.productCondition, items = param.items;
        // console.log('validateProductCondition > ', productCondition, items);
        var _minQuantity = productCondition.minQuantity, minQuantity = _minQuantity === void 0 ? 0 : _minQuantity, _minTotalValue = productCondition.minTotalValue, minTotalValue = _minTotalValue === void 0 ? 0 : _minTotalValue;
        // const totalItems = items?.length || 0;
        var totalQuantity = items === null || items === void 0 ? void 0 : items.reduce(function(total_, item) {
            return total_ + item.quantity;
        }, 0);
        // console.log('totalQuantity > ', totalQuantity);
        if (minQuantity > 0 && minQuantity > totalQuantity) {
            return false;
        }
        if (minTotalValue > 0) {
            var totalPriceTag = items === null || items === void 0 ? void 0 : items.reduce(function(total_, item) {
                return total_ + (item === null || item === void 0 ? void 0 : item.total) || 0;
            }, 0);
            if (totalPriceTag < minTotalValue) {
                return false;
            }
        }
        return true;
    };
    var getSellerNames = function(param) {
        var sellerCodes = param.sellerCodes;
        return sellerCodes === null || sellerCodes === void 0 ? void 0 : sellerCodes.map(function(sellerCode) {
            var ref;
            return ((ref = mapSeller === null || mapSeller === void 0 ? void 0 : mapSeller.get(sellerCode)) === null || ref === void 0 ? void 0 : ref.name) || "";
        }).filter(function(item) {
            return item && item.length > 0;
        }).join(" , ");
    };
    var ONE_DAY = 86400000;
    var parseConditionVoucher = function() {
        var _ref = _async_to_generator(function(voucher, lastOrderInfo) {
            var ref, promotionType, _conditions, conditions, _tmp, ref1, _cartItems, cartItems, _tmp1, isGift, newConditionVi, isDisable, _tmp2, _tmp3;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        ref = voucher || _tmp, promotionType = ref.promotionType, _conditions = ref.conditions, conditions = _conditions === void 0 ? [] : _conditions;
                        _tmp1 = {};
                        ref1 = cartInfo || _tmp1, _cartItems = ref1.cartItems, cartItems = _cartItems === void 0 ? [] : _cartItems;
                        isGift = isHaveGift(voucher);
                        return [
                            4,
                            Promise.all(conditions === null || conditions === void 0 ? void 0 : conditions.map(function() {
                                var _ref = _async_to_generator(function(condition) {
                                    var message, ref, type, productConditions, _tmp, isDisable, ref1, _minOrderValue, minOrderValue, _minDaysNoOrder, minDaysNoOrder, _maxTotalOrder, maxTotalOrder, _minTotalOrder, minTotalOrder, _tmp1, tempIsDisable, _tmp2, ref2, ref3, ref4, tempIsDisable1, createdTime, today, diffDays, _tmp3, tempIsDisable2, _tmp4, tempIsDisable3, _tmp5, _tmp6, _tmp7;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!condition) return [
                                                    2,
                                                    null
                                                ];
                                                message = [];
                                                _tmp = {};
                                                ref = condition || _tmp, type = ref.type, productConditions = ref.productConditions;
                                                isDisable = false;
                                                switch(type){
                                                    case "ORDER_VALUE":
                                                        return [
                                                            3,
                                                            1
                                                        ];
                                                    case "PRODUCT":
                                                        return [
                                                            3,
                                                            2
                                                        ];
                                                    case "PRODUCT_TAG":
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case "INGREDIENT":
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case "PRODUCER":
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case "PRODUCT_CATEGORY":
                                                        return [
                                                            3,
                                                            10
                                                        ];
                                                    case "NO_RULE":
                                                        return [
                                                            3,
                                                            12
                                                        ];
                                                }
                                                return [
                                                    3,
                                                    13
                                                ];
                                            case 1:
                                                _tmp1 = {};
                                                _tmp2 = {};
                                                _tmp3 = {};
                                                _tmp4 = {};
                                                _tmp5 = {};
                                                {
                                                    ref1 = condition || _tmp1, _minOrderValue = ref1.minOrderValue, minOrderValue = _minOrderValue === void 0 ? 0 : _minOrderValue, _minDaysNoOrder = ref1.minDaysNoOrder, minDaysNoOrder = _minDaysNoOrder === void 0 ? 0 : _minDaysNoOrder, _maxTotalOrder = ref1.maxTotalOrder, maxTotalOrder = _maxTotalOrder === void 0 ? 0 : _maxTotalOrder, _minTotalOrder = ref1.minTotalOrder, minTotalOrder = _minTotalOrder === void 0 ? 0 : _minTotalOrder;
                                                    if (minOrderValue > 0) {
                                                        tempIsDisable = subPrice < minOrderValue;
                                                        if (tempIsDisable) isDisable = tempIsDisable;
                                                        message.push((_tmp2.text = "Gi\xe1 trị đơn h\xe0ng từ ".concat(formatCurrency(minOrderValue)), _tmp2.isDisable = tempIsDisable, _tmp2));
                                                    }
                                                    if (minDaysNoOrder > 0) {
                                                        ;
                                                        tempIsDisable1 = true;
                                                        createdTime = new Date(((ref4 = lastOrderInfo === null || lastOrderInfo === void 0 ? void 0 : (ref2 = lastOrderInfo.lastOrder) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.createdTime) === null || ref3 === void 0 ? void 0 : ref3.substring(0, 10)) === null || ref4 === void 0 ? void 0 : ref4.replaceAll("-", "/")) || new Date());
                                                        if (createdTime) {
                                                            today = new Date();
                                                            diffDays = Math.ceil((today - createdTime) / ONE_DAY) - 1;
                                                            tempIsDisable1 = diffDays <= minDaysNoOrder;
                                                        }
                                                        if (tempIsDisable1) isDisable = tempIsDisable1;
                                                        message.push((_tmp3.text = "Số ng\xe0y kh\xf4ng đặt h\xe0ng: ".concat(minDaysNoOrder, " ng\xe0y"), _tmp3.isDisable = tempIsDisable1, _tmp3));
                                                    }
                                                    if (maxTotalOrder > 0) {
                                                        tempIsDisable2 = true;
                                                        if (lastOrderInfo) {
                                                            tempIsDisable2 = (lastOrderInfo === null || lastOrderInfo === void 0 ? void 0 : lastOrderInfo.totalOrder) > maxTotalOrder;
                                                        }
                                                        if (tempIsDisable2) isDisable = tempIsDisable2;
                                                        message.push((_tmp4.text = "Số đơn h\xe0ng tối đa: ".concat(maxTotalOrder, " đơn h\xe0ng"), _tmp4.isDisable = tempIsDisable2, _tmp4));
                                                    }
                                                    if (minTotalOrder > 0) {
                                                        tempIsDisable3 = true;
                                                        if (lastOrderInfo) {
                                                            tempIsDisable3 = (lastOrderInfo === null || lastOrderInfo === void 0 ? void 0 : lastOrderInfo.totalOrder) < minTotalOrder;
                                                        }
                                                        if (tempIsDisable3) isDisable = tempIsDisable3;
                                                        message.push((_tmp5.text = "Số đơn h\xe0ng tối thiểu: ".concat(minTotalOrder, " đơn h\xe0ng"), _tmp5.isDisable = tempIsDisable3, _tmp5));
                                                    }
                                                    return [
                                                        3,
                                                        14
                                                    ];
                                                }
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    4,
                                                    Promise.all(productConditions === null || productConditions === void 0 ? void 0 : productConditions.map(function() {
                                                        var _ref = _async_to_generator(function(productCondition) {
                                                            var ref, productId, sellerCodes, minQuantity, minTotalValue, _tmp, mapProductId, _tmp1, productInfo, _tmp2, sellerNames, _tmp3, items, _tmp4;
                                                            return _ts_generator(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        _tmp = {};
                                                                        ref = productCondition || _tmp, productId = ref.productId, sellerCodes = ref.sellerCodes, minQuantity = ref.minQuantity, minTotalValue = ref.minTotalValue;
                                                                        _tmp1 = {};
                                                                        return [
                                                                            4,
                                                                            getProductsByIds((_tmp1.ids = [
                                                                                productId
                                                                            ], _tmp1))
                                                                        ];
                                                                    case 1:
                                                                        mapProductId = _state.sent();
                                                                        _tmp2 = {};
                                                                        productInfo = (mapProductId === null || mapProductId === void 0 ? void 0 : mapProductId.get(productId)) || _tmp2;
                                                                        _tmp3 = {};
                                                                        sellerNames = getSellerNames((_tmp3.sellerCodes = sellerCodes, _tmp3));
                                                                        items = cartItems || [];
                                                                        // validate sellerCodes
                                                                        items = items.filter(function(item) {
                                                                            return item.productId === productId;
                                                                        });
                                                                        items = filterSellerCodes({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        isDisable = !validateProductCondition({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        _tmp4 = {};
                                                                        message.push((_tmp4.text = "Cần mua \xedt nhất ".concat(formatNumber(minQuantity), " sản phẩm c\xf3 t\xean ").concat(productInfo.name, " ").concat(sellerNames ? "của người b\xe1n ".concat(sellerNames) : "", " \n                    ").concat(minTotalValue ? " tối thiểu ".concat(formatCurrency(minTotalValue)) : ""), _tmp4.isDisable = isDisable, _tmp4));
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                        return function(productCondition) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }()))
                                                ];
                                            case 3:
                                                _state.sent();
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 4:
                                                return [
                                                    4,
                                                    Promise.all(productConditions === null || productConditions === void 0 ? void 0 : productConditions.map(function() {
                                                        var _ref = _async_to_generator(function(productCondition) {
                                                            var ref, ref1, productTag, sellerCodes, minQuantity, minTotalValue, _tmp, tagName, sellerNames, _tmp1, items, mapProduct, _tmp2, _tmp3;
                                                            return _ts_generator(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        _tmp = {};
                                                                        ref1 = productCondition || _tmp, productTag = ref1.productTag, sellerCodes = ref1.sellerCodes, minQuantity = ref1.minQuantity, minTotalValue = ref1.minTotalValue;
                                                                        tagName = ((ref = getStyleBySlugOfTag(productTag)) === null || ref === void 0 ? void 0 : ref.name) || "";
                                                                        _tmp1 = {};
                                                                        sellerNames = getSellerNames((_tmp1.sellerCodes = sellerCodes, _tmp1));
                                                                        items = cartItems || [];
                                                                        // validate sellerCodes
                                                                        items = filterSellerCodes({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        _tmp2 = {};
                                                                        return [
                                                                            4,
                                                                            getProductBySkus((_tmp2.skus = (items === null || items === void 0 ? void 0 : items.map(function(item) {
                                                                                return item.sku;
                                                                            })) || [], _tmp2.getPrice = false, _tmp2))
                                                                        ];
                                                                    case 1:
                                                                        mapProduct = _state.sent();
                                                                        items = items === null || items === void 0 ? void 0 : items.filter(function(item) {
                                                                            var sku = (item || {}).sku;
                                                                            var info = (mapProduct === null || mapProduct === void 0 ? void 0 : mapProduct.get(sku)) || null;
                                                                            if (info) {
                                                                                var ref;
                                                                                return (info === null || info === void 0 ? void 0 : (ref = info.tags) === null || ref === void 0 ? void 0 : ref.indexOf(productTag)) >= 0;
                                                                            }
                                                                            return false;
                                                                        });
                                                                        isDisable = !validateProductCondition({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        _tmp3 = {};
                                                                        message.push((_tmp3.text = "Cần mua \xedt nhất ".concat(formatNumber(minQuantity), " sản phẩm c\xf3 tag ").concat(tagName, " ").concat(sellerNames ? "của người b\xe1n ".concat(sellerNames) : "", " \n                  ").concat(minTotalValue ? " tối thiểu ".concat(formatCurrency(minTotalValue)) : ""), _tmp3.isDisable = isDisable, _tmp3));
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                        return function(productCondition) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }()))
                                                ];
                                            case 5:
                                                _state.sent();
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 6:
                                                return [
                                                    4,
                                                    Promise.all(productConditions === null || productConditions === void 0 ? void 0 : productConditions.map(function() {
                                                        var _ref = _async_to_generator(function(productCondition) {
                                                            var ref, ingredientCode, minTotalValue, minQuantity, sellerCodes, _tmp, items, mapProduct, _tmp1, sellerNames, _tmp2, ref1, tmp, ingredientName, _tmp3, _tmp4;
                                                            return _ts_generator(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        _tmp = {};
                                                                        ref = productCondition || _tmp, ingredientCode = ref.ingredientCode, minTotalValue = ref.minTotalValue, minQuantity = ref.minQuantity, sellerCodes = ref.sellerCodes;
                                                                        items = cartItems || [];
                                                                        items = filterSellerCodes({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        _tmp1 = {};
                                                                        return [
                                                                            4,
                                                                            getProductBySkus((_tmp1.skus = (items === null || items === void 0 ? void 0 : items.map(function(item) {
                                                                                return item.sku;
                                                                            })) || [], _tmp1.getPrice = false, _tmp1))
                                                                        ];
                                                                    case 1:
                                                                        mapProduct = _state.sent();
                                                                        items = items === null || items === void 0 ? void 0 : items.filter(function(item) {
                                                                            var sku = (item || {}).sku;
                                                                            var info = (mapProduct === null || mapProduct === void 0 ? void 0 : mapProduct.get(sku)) || null;
                                                                            if (info) {
                                                                                var ref;
                                                                                return info === null || info === void 0 ? void 0 : (ref = info.ingredients) === null || ref === void 0 ? void 0 : ref.some(function(ingredient) {
                                                                                    return (ingredient === null || ingredient === void 0 ? void 0 : ingredient.ingredientCode) === ingredientCode;
                                                                                });
                                                                            }
                                                                            return true;
                                                                        });
                                                                        isDisable = !validateProductCondition({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        _tmp2 = {};
                                                                        sellerNames = getSellerNames((_tmp2.sellerCodes = sellerCodes, _tmp2));
                                                                        _tmp3 = {};
                                                                        ref1 = (mapIngredients === null || mapIngredients === void 0 ? void 0 : mapIngredients.get(ingredientCode)) || _tmp3, tmp = ref1.name, ingredientName = tmp === void 0 ? "" : tmp;
                                                                        _tmp4 = {};
                                                                        message.push((_tmp4.text = "Cần mua \xedt nhất ".concat(formatNumber(minQuantity), " sản phẩm c\xf3 hoạt chất ").concat(ingredientName, " \n                  ").concat(sellerNames ? "của người b\xe1n ".concat(sellerNames) : "", "\n                  ").concat(minTotalValue ? " tối thiểu ".concat(formatCurrency(minTotalValue)) : ""), _tmp4.isDisable = isDisable, _tmp4));
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                        return function(productCondition) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }()))
                                                ];
                                            case 7:
                                                _state.sent();
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 8:
                                                return [
                                                    4,
                                                    Promise.all(productConditions === null || productConditions === void 0 ? void 0 : productConditions.map(function() {
                                                        var _ref = _async_to_generator(function(productCondition) {
                                                            var ref, ref1, producerCode, sellerCodes, minQuantity, minTotalValue, _tmp, items, mapProduct, _tmp1, producerName, sellerNames, _tmp2, _tmp3;
                                                            return _ts_generator(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        _tmp = {};
                                                                        ref1 = productCondition || _tmp, producerCode = ref1.producerCode, sellerCodes = ref1.sellerCodes, minQuantity = ref1.minQuantity, minTotalValue = ref1.minTotalValue;
                                                                        items = cartItems || [];
                                                                        // validate sellerCodes
                                                                        items = filterSellerCodes({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        _tmp1 = {};
                                                                        return [
                                                                            4,
                                                                            getProductBySkus((_tmp1.skus = (items === null || items === void 0 ? void 0 : items.map(function(item) {
                                                                                return item.sku;
                                                                            })) || [], _tmp1.getPrice = false, _tmp1))
                                                                        ];
                                                                    case 1:
                                                                        mapProduct = _state.sent();
                                                                        items = items === null || items === void 0 ? void 0 : items.filter(function(item) {
                                                                            var sku = (item || {}).sku;
                                                                            var info = (mapProduct === null || mapProduct === void 0 ? void 0 : mapProduct.get(sku)) || null;
                                                                            if (info) {
                                                                                return (info === null || info === void 0 ? void 0 : info.manufacturerCode) === producerCode;
                                                                            }
                                                                            return true;
                                                                        });
                                                                        isDisable = !validateProductCondition({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        producerName = (ref = mapManufactuers === null || mapManufactuers === void 0 ? void 0 : mapManufactuers.get(producerCode)) === null || ref === void 0 ? void 0 : ref.name;
                                                                        _tmp2 = {};
                                                                        sellerNames = getSellerNames((_tmp2.sellerCodes = sellerCodes, _tmp2));
                                                                        _tmp3 = {};
                                                                        message.push((_tmp3.text = "Cần mua \xedt nhất ".concat(formatNumber(minQuantity), " sản phẩm của nh\xe0 sản xuất ").concat(producerName, " \n                  ").concat(sellerNames ? "của người b\xe1n ".concat(sellerNames) : "", " \n                  ").concat(minTotalValue ? " tối thiểu ".concat(formatCurrency(minTotalValue)) : ""), _tmp3.isDisable = isDisable, _tmp3));
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                        return function(productCondition) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }()))
                                                ];
                                            case 9:
                                                _state.sent();
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 10:
                                                return [
                                                    4,
                                                    Promise.all(productConditions === null || productConditions === void 0 ? void 0 : productConditions.map(function() {
                                                        var _ref = _async_to_generator(function(productCondition) {
                                                            var ref, ref1, categoryCode, minTotalValue, sellerCodes, minQuantity, _tmp, items, mapProduct, _tmp1, sellerNames, _tmp2, categoryName, _tmp3;
                                                            return _ts_generator(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        _tmp = {};
                                                                        ref1 = productCondition || _tmp, categoryCode = ref1.categoryCode, minTotalValue = ref1.minTotalValue, sellerCodes = ref1.sellerCodes, minQuantity = ref1.minQuantity;
                                                                        items = cartItems || [];
                                                                        // validate sellerCodes
                                                                        items = filterSellerCodes({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        _tmp1 = {};
                                                                        return [
                                                                            4,
                                                                            getProductBySkus((_tmp1.skus = (items === null || items === void 0 ? void 0 : items.map(function(item) {
                                                                                return item.sku;
                                                                            })) || [], _tmp1.getPrice = false, _tmp1))
                                                                        ];
                                                                    case 1:
                                                                        mapProduct = _state.sent();
                                                                        items = items === null || items === void 0 ? void 0 : items.filter(function(item) {
                                                                            var sku = (item || {}).sku;
                                                                            var info = (mapProduct === null || mapProduct === void 0 ? void 0 : mapProduct.get(sku)) || null;
                                                                            if (info) {
                                                                                var ref;
                                                                                return (info === null || info === void 0 ? void 0 : (ref = info.categoryCodes) === null || ref === void 0 ? void 0 : ref.indexOf(categoryCode)) >= 0;
                                                                            }
                                                                            return true;
                                                                        });
                                                                        isDisable = !validateProductCondition({
                                                                            productCondition: productCondition,
                                                                            items: items
                                                                        });
                                                                        _tmp2 = {};
                                                                        sellerNames = getSellerNames((_tmp2.sellerCodes = sellerCodes, _tmp2));
                                                                        categoryName = ((ref = mapCategories === null || mapCategories === void 0 ? void 0 : mapCategories.get(categoryCode)) === null || ref === void 0 ? void 0 : ref.name) || "";
                                                                        _tmp3 = {};
                                                                        message.push((_tmp3.text = "Cần mua \xedt nhất ".concat(formatNumber(minQuantity), " sản phẩm nằm trong danh mục ").concat(categoryName, " ").concat(sellerNames ? "của người b\xe1n ".concat(sellerNames) : "", "\n                  ").concat(minTotalValue ? " tối thiểu ".concat(formatCurrency(minTotalValue)) : ""), _tmp3.isDisable = isDisable, _tmp3));
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                        return function(productCondition) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }()))
                                                ];
                                            case 11:
                                                _state.sent();
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 12:
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 13:
                                                {
                                                    isDisable = false;
                                                }
                                                _state.label = 14;
                                            case 14:
                                                _tmp6 = {};
                                                _tmp7 = {};
                                                return [
                                                    2,
                                                    _object_spread_props(_object_spread(_tmp6, condition), (_tmp7.isDisable = isDisable, _tmp7.message = message, _tmp7))
                                                ];
                                        }
                                    });
                                });
                                return function(condition) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        newConditionVi = _state.sent();
                        isDisable = (newConditionVi === null || newConditionVi === void 0 ? void 0 : newConditionVi.some(function(condition) {
                            return condition.isDisable;
                        })) || false;
                        _tmp2 = {};
                        _tmp3 = {};
                        return [
                            2,
                            _object_spread_props(_object_spread(_tmp2, voucher), (_tmp3.conditionsVi = newConditionVi, _tmp3.isDisable = isDisable, _tmp3.promotionType = isGift ? PROMO_REWARD_TYPE.GIFT : promotionType, _tmp3))
                        ];
                }
            });
        });
        return function parseConditionVoucher(voucher, lastOrderInfo) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = _async_to_generator(function() {
                var customerId, orderRes, _tmp, lastOrderInfo, voucherActiveList, _tmp1, voucherListParsed, vouchers, prs;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            customerId = user.customerID;
                            _tmp = {};
                            return [
                                4,
                                OrderClient.getLastOrder((_tmp.customerId = customerId, _tmp))
                            ];
                        case 1:
                            orderRes = _state.sent();
                            lastOrderInfo = getFirst(orderRes);
                            _tmp1 = {};
                            return [
                                4,
                                PromoService.getVouchers((_tmp1.getProductBySkus = getProductBySkus, _tmp1.getStyleBySlugOfTag = getStyleBySlugOfTag, _tmp1.mapIngredients = mapIngredients, _tmp1.mapSeller = mapSeller, _tmp1.mapManufactuers = mapManufactuers, _tmp1.mapCategories = mapCategories, _tmp1))
                            ];
                        case 2:
                            voucherActiveList = _state.sent();
                            return [
                                4,
                                Promise.all(voucherActiveList.map(function() {
                                    var _ref = _async_to_generator(function(voucher) {
                                        var newVoucher;
                                        return _ts_generator(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        parseConditionVoucher(voucher, lastOrderInfo)
                                                    ];
                                                case 1:
                                                    newVoucher = _state.sent();
                                                    // console.log('new Voucher ', newVoucher);
                                                    return [
                                                        2,
                                                        newVoucher
                                                    ];
                                            }
                                        });
                                    });
                                    return function(voucher) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()).sort(function(a, b) {
                                    return a.isDisable - b.isDisable;
                                }))
                            ];
                        case 3:
                            voucherListParsed = _state.sent();
                            vouchers = voucherListParsed.filter(function(voucher) {
                                return !(voucher.endTime && DateTimeUtils.compareTime(voucher.endTime, Date.now()) <= 0);
                            });
                            prs = searchString(vouchers, "");
                            setPromos(prs);
                            setPromoSearchs(prs);
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchData.apply(this, arguments);
        }
        if (visible) {
            fetchData();
        }
    }, [
        subPrice,
        visible
    ]);
    useEffect(function() {
        var prms = searchString(promos, (text === null || text === void 0 ? void 0 : text.toUpperCase()) || "");
        setPromoSearchs(prms);
    }, [
        promos,
        text
    ]);
    var searchPromotionWithCode = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var ref, codeSearch, detailRes, myVoucher, _tmp, myVoucherCodeSearch, myAmountUsage, promoDetail, code, customerId, orderRes, _tmp1, lastOrderInfo, promotionSearchResult, promosUpdate;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    codeSearch = text || "";
                    if (!codeSearch) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        PromoService.getPromoCodeDetail(codeSearch)
                    ];
                case 1:
                    detailRes = _state.sent();
                    _tmp = {};
                    return [
                        4,
                        PromoService.getMyVoucher(_tmp)
                    ];
                case 2:
                    myVoucher = _state.sent();
                    myVoucherCodeSearch = myVoucher === null || myVoucher === void 0 ? void 0 : myVoucher.find(function(obj) {
                        return (obj === null || obj === void 0 ? void 0 : obj.code) === codeSearch;
                    });
                    myAmountUsage = (myVoucherCodeSearch === null || myVoucherCodeSearch === void 0 ? void 0 : (ref = myVoucherCodeSearch.used) === null || ref === void 0 ? void 0 : ref.amount) || 0;
                    if (!isValid(detailRes)) return [
                        3,
                        5
                    ];
                    promoDetail = getFirst(detailRes);
                    code = promoDetail.code;
                    customerId = user.customerID;
                    _tmp1 = {};
                    return [
                        4,
                        OrderClient.getLastOrder((_tmp1.customerId = customerId, _tmp1))
                    ];
                case 3:
                    orderRes = _state.sent();
                    lastOrderInfo = getFirst(orderRes);
                    if (!(promoSearchs.filter(function(item) {
                        return item.code === code;
                    }).length === 0)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        Promise.all([
                            promoDetail
                        ].filter(function(voucher) {
                            var ref, ref1;
                            if ((voucher === null || voucher === void 0 ? void 0 : (ref = voucher.appliedCustomers) === null || ref === void 0 ? void 0 : ref.length) > 0 && (voucher === null || voucher === void 0 ? void 0 : (ref1 = voucher.appliedCustomers) === null || ref1 === void 0 ? void 0 : ref1.indexOf(user.customerID)) === -1) {
                                return false;
                            }
                            return voucher.endTime && DateTimeUtils.compareTime(voucher.endTime, Date.now()) > 0 && voucher.status === "ACTIVE" && ((voucher === null || voucher === void 0 ? void 0 : voucher.maxUsagePerCustomer) === 0 || (voucher === null || voucher === void 0 ? void 0 : voucher.maxUsagePerCustomer) > myAmountUsage);
                        }).map(function(voucher) {
                            return parseConditionVoucher(voucher, lastOrderInfo);
                        }).sort(function(a, b) {
                            return a.isDisable - b.isDisable;
                        }))
                    ];
                case 4:
                    promotionSearchResult = _state.sent();
                    promosUpdate = promoSearchs.concat(promotionSearchResult);
                    setPromoSearchs(promosUpdate);
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    }));
    var handleSearchButton = function(event) {
        var code = event.target.value;
        if (event.key === "Enter") {
            searchPromotionWithCode(code);
            event.preventDefault();
        }
    };
    // TODO:
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: loading ? /*#__PURE__*/ _jsxs("div", {
            className: styles.confirm_modal_wrap,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.modal_title,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            children: "M\xe3 giảm gi\xe1"
                        }),
                        /*#__PURE__*/ _jsx(CloseIcon, {
                            className: styles.close,
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(LoadingScreen, {})
            ]
        }) : /*#__PURE__*/ _jsxs("div", {
            className: styles.confirm_modal_wrap,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.modal_title,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            children: "M\xe3 giảm gi\xe1"
                        }),
                        /*#__PURE__*/ _jsx(CloseIcon, {
                            className: styles.close,
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Divider, {}),
                /*#__PURE__*/ _jsxs(Grid, {
                    container: true,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 9,
                            md: 10,
                            children: /*#__PURE__*/ _jsx(Input, {
                                endAdornment: text === "" ? null : /*#__PURE__*/ _jsx(CloseIcon, {
                                    onClick: handleRemoveText
                                }),
                                placeholder: "Nhập m\xe3 cần t\xecm",
                                value: text,
                                onChange: handleChangeText,
                                onKeyDown: handleSearchButton,
                                style: {
                                    height: "auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 3,
                            md: 2,
                            children: /*#__PURE__*/ _jsx(Button, {
                                className: styles.button,
                                onClick: searchPromotionWithCode
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.counpon_list_wapper,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.counpon_list,
                        children: promoSearchs.length !== 0 ? /*#__PURE__*/ _jsx(Grid, {
                            container: true,
                            spacing: 1,
                            children: promoSearchs.map(function(voucher) {
                                return /*#__PURE__*/ _jsx(Grid, {
                                    className: styles.coupon_card_grid,
                                    item: true,
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ _jsx(CartCouponCard, _object_spread_props(_object_spread({}, voucher), {
                                        redeemCode: redeemCode,
                                        handleChangePromo: handleChangePromo,
                                        subPrice: subPrice
                                    }))
                                }, uuidv4());
                            })
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: styles.not_yet,
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "Chưa c\xf3 m\xe3"
                            })
                        })
                    })
                })
            ]
        })
    }));
})));
/* harmony default export */ var mocules_PromoListModal = ((/* unused pure expression or super */ null && (PromoListModal)));

// EXTERNAL MODULE: ./src/components/mocules/RegisterGuestForm/styles.module.css
var RegisterGuestForm_styles_module = __webpack_require__(5070);
var RegisterGuestForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(RegisterGuestForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/RegisterGuestForm/RegisterGuestForm.js






var SignInForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickRegister = param.onClickRegister;
    var regExp = /(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
    var ref = (0,react.useState)(false), errorPhone = ref[0], setErrorPhone = ref[1];
    var ref1 = (0,react.useState)(""), errorPhoneMessage = ref1[0], setErrorPhoneMessage = ref1[1];
    var validatePhone = function(data) {
        setErrorPhone(false);
        if (data === "") {
            setErrorPhone(true);
            setErrorPhoneMessage("Vui l\xf2ng nhập số điện thoại v\xe0 bắt đầu bằng số 0");
            return false;
        }
        if (!data.match(regExp)) {
            setErrorPhone(true);
            setErrorPhoneMessage("Số điện thoại bạn nhập kh\xf4ng đ\xfang");
            return false;
        }
        return true;
    };
    // handle login with data
    var handleRegisterGuest = function(e) {
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        e.preventDefault();
        if (!validatePhone(data.phone)) {
            return;
        }
        onClickRegister(data);
    };
    var handleOnChange = function(e) {
        e.preventDefault();
        validatePhone(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (RegisterGuestForm_styles_module_default()).form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: className,
            onSubmit: handleRegisterGuest,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (RegisterGuestForm_styles_module_default()).title,
                    children: "Vui l\xf2ng nhập số điện thoại trước khi d\xf9ng thử"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                    className: (RegisterGuestForm_styles_module_default()).formInput,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                            id: "phone",
                            name: "phone",
                            type: "number",
                            placeholder: "Nhập số điện thoại",
                            variant: "outlined",
                            error: errorPhone,
                            onChange: handleOnChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RegisterGuestForm_styles_module_default()).error,
                            children: errorPhone && errorPhoneMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RegisterGuestForm_styles_module_default()).bottom_text,
                    children: "M\xe3 giảm gi\xe1 100k d\xe0nh cho nh\xe0 thuốc mới đăng k\xfd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RegisterGuestForm_styles_module_default()).btnWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        className: "btnLogin",
                        color: "white",
                        type: "submit",
                        children: "Đăng K\xfd"
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var RegisterGuestForm = (SignInForm);

;// CONCATENATED MODULE: ./src/components/mocules/RegisterGuestForm/index.js

function RegisterGuestForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .form-control {\n    width: ",
        "px;\n  }\n  .rememberPassword {\n    align-self: flex-start;\n    font-size: 13px;\n  }\n  a.forgetPassword {\n    color: #005c29;\n    text-decoration: none;\n    background-color: transparent;\n  }\n  .btnLogin {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    color: white;\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    margin: 1rem 0;\n    border-radius: 50px;\n  }\n  .register {\n    padding: 1rem;\n  }\n"
    ]);
    RegisterGuestForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var RegisterGuestForm_RegisterGuestForm = (0,styled_components_browser_esm/* default */.ZP)(RegisterGuestForm).withConfig({
    componentId: "sc-4d2e0a5a-0"
})(RegisterGuestForm_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 400 : _width;
    return width;
});
/* harmony default export */ var mocules_RegisterGuestForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(RegisterGuestForm_RegisterGuestForm))));

;// CONCATENATED MODULE: ./src/components/mocules/RibbonPriceDown/index.js





var RibbonPriceDown = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Ribbon */.Vy, (0,src_object_spread/* default */.Z)({
        status: Enums/* RIBBON_STATUS.DOWN */.GC.DOWN
    }, props));
};
/* harmony default export */ var mocules_RibbonPriceDown = (RibbonPriceDown);

;// CONCATENATED MODULE: ./src/components/mocules/RibbonPriceUp/index.js





var RibbonPriceUp = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Ribbon */.Vy, (0,src_object_spread/* default */.Z)({
        status: Enums/* RIBBON_STATUS.UP */.GC.UP
    }, props));
};
/* harmony default export */ var mocules_RibbonPriceUp = (RibbonPriceUp);

// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var atoms_LinkComp = __webpack_require__(24618);
;// CONCATENATED MODULE: ./src/components/mocules/SearchDropdown/index.js






var SearchDropdown_SearchDropdown = function(props) {
    var data = props.data, keyword = props.keyword;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.searchDropdown,
        children: data ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(LinkComp, {
                    className: styles.searchResults,
                    href: "".concat(PRODUCTS_LOADING_URL, "?q=").concat(keyword),
                    children: [
                        /*#__PURE__*/ _jsx("em", {
                            children: keyword
                        }),
                        "\xa0\xa0Trong\xa0",
                        /*#__PURE__*/ _jsx("b", {
                            className: styles.textPrimary,
                            children: "Tất Cả Sản Phẩm"
                        })
                    ]
                }),
                data.map(function(item) {
                    return /*#__PURE__*/ _jsx(LinkComp, {
                        className: styles.searchResults,
                        href: getPathProductBySlug(item.sku.slug),
                        children: item.product.name
                    }, uuidv4());
                })
            ]
        }) : /*#__PURE__*/ _jsxs("span", {
            className: styles.searchResults,
            children: [
                "Kh\xf4ng c\xf3 sản phẩm với từ kh\xf3a ",
                /*#__PURE__*/ _jsx("em", {
                    children: keyword
                }),
                "\xa0\xa0Trong\xa0",
                /*#__PURE__*/ _jsx("b", {
                    className: styles.textPrimary,
                    children: "Tất Cả Sản Phẩm"
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_SearchDropdown = ((/* unused pure expression or super */ null && (SearchDropdown_SearchDropdown)));

;// CONCATENATED MODULE: ./src/components/mocules/SearchInput/index.js






// import InputAdornment from '@material-ui/core/InputAdornment';
// import TextField from '@material-ui/core/TextField';







var SearchInput = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(_param) {
    var useOutsideSearchCLick = function useOutsideSearchCLick(ref) {
        React.useEffect(function() {
            function handleClickOutside(e) {
                if (ref.current && !ref.current.contains(e.target)) {
                    setShow(false);
                }
            }
            document.addEventListener("click", handleClickOutside);
            return function() {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var classCustom = _param.classCustom, restProps = _object_without_properties(_param, [
        "classCustom"
    ]);
    var ref = useSearch(), keyword = ref.keyword, hidden = ref.hidden, searchProduct = ref.searchProduct, handleBlur = ref.handleBlur, handleSearchbox = ref.handleSearchbox, handleKeyDown = ref.handleKeyDown, handleFocus = ref.handleFocus;
    var inputEl = useRef(null);
    var ref1 = useState(false), show = ref1[0], setShow = ref1[1];
    var handleShowFirstClick = function() {
        setShow(true);
    };
    React.useEffect(function() {
        if (document.activeElement === inputEl.current) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [
        hidden,
        keyword
    ]);
    useOutsideSearchCLick(inputEl);
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx(styles.search_wrap, classCustom),
        onBlur: handleBlur,
        children: [
            /*#__PURE__*/ _jsx("form", {
                children: /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                    onClick: handleShowFirstClick,
                    inputRef: inputEl,
                    // defaultValue={keyword}
                    value: keyword
                }, restProps), {
                    classes: {
                        root: styles.root_input
                    },
                    async: true,
                    onChange: handleSearchbox,
                    onKeyDown: handleKeyDown,
                    InputProps: {
                        startAdornment: /*#__PURE__*/ _jsx(InputAdornment, {
                            position: "start",
                            children: /*#__PURE__*/ _jsx(Search, {
                                style: {
                                    color: WEB_STYLES.COLORS.GREEN
                                }
                            })
                        }),
                        placeholder: "Nhập t\xean thuốc, hoạt chất cần t\xecm...",
                        autoComplete: "off",
                        type: "search",
                        classes: {
                            focused: styles.focus
                        }
                    },
                    onFocus: handleFocus
                }))
            }),
            show && /*#__PURE__*/ _jsx(SearchDropdown, {
                keyword: keyword,
                data: searchProduct
            })
        ]
    });
})));
/* harmony default export */ var mocules_SearchInput = ((/* unused pure expression or super */ null && (SearchInput)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Input/Input.js
var Input_Input = __webpack_require__(38799);
// EXTERNAL MODULE: ./src/components/mocules/SearchOrder/styles.module.css
var SearchOrder_styles_module = __webpack_require__(19024);
var SearchOrder_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchOrder_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchOrder/index.js











var iconStart = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
    position: "start",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Search/* default */.Z, {
        style: {
            color: src_styles/* WEB_STYLES.COLORS.GREEN */.i.COLORS.GREEN
        }
    })
});
var SearchOrder = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var onSearch = _param.onSearch, isMobile = _param.isMobile, _text = _param.text, text = _text === void 0 ? "" : _text, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "onSearch",
        "isMobile",
        "text"
    ]);
    var ref = (0,esm/* useTranslation */.$G)("quickOrder"), translateQuickOrder = ref.t;
    var handleKeyDown = (0,react.useCallback)(function(event) {
        if (event.keyCode === 13) {
            onSearch(event);
            event.preventDefault();
            event.target.blur();
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        classes: {
            root: (SearchOrder_styles_module_default()).root_input,
            input: (SearchOrder_styles_module_default()).input,
            focused: (SearchOrder_styles_module_default()).focus
        },
        disableUnderline: true,
        value: text,
        placeholder: translateQuickOrder("search_input"),
        onKeyDown: handleKeyDown,
        startAdornment: !isMobile && iconStart,
        onChange: onSearch,
        type: "search"
    }));
});
/* harmony default export */ var mocules_SearchOrder = (SearchOrder);

// EXTERNAL MODULE: ./src/components/mocules/SearchResultText/style.module.css
var SearchResultText_style_module = __webpack_require__(55711);
var SearchResultText_style_module_default = /*#__PURE__*/__webpack_require__.n(SearchResultText_style_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchResultText/index.js




function SearchResultText(param) {
    var _total = param.total, total = _total === void 0 ? 0 : _total;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SearchResultText_style_module_default()).search_result,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                translateCommon("text_search_result_1"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: (0,FormatNumber/* formatNumber */.uf)(total, ",")
                }),
                " ",
                translateCommon("text_search_result_2")
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(67265);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Rating/Rating.js + 1 modules
var Rating = __webpack_require__(43871);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChevronRight.js
var ChevronRight = __webpack_require__(66735);
// EXTERNAL MODULE: ./src/components/mocules/SellerInfoProductDetail/styles.module.css
var SellerInfoProductDetail_styles_module = __webpack_require__(37721);
var SellerInfoProductDetail_styles_module_default = /*#__PURE__*/__webpack_require__.n(SellerInfoProductDetail_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SellerInfoProductDetail/index.js
/* eslint-disable react/destructuring-assignment */ 














// const ButtonChatNgay = ({ isMobileV2 = false, translateProductDetail }) => (
//   <LinkComp className={styles.linkShop} href="https://zalo.me/0932036749" target="_blank">
//     <ImageFallbackStatic src={`${ICON_CHAT_NGAY}?size=origin`} className={styles.sellerIcon} width={14} height={16} alt="" />
//     <Typography variant={`${isMobileV2 ? 'body2' : 'body'}`} style={{ marginLeft: 5 }}>
//       {translateProductDetail('chat_now')}
//     </Typography>
//   </LinkComp>
// );
var SellerInfoProductDetail = function(props) {
    var ref;
    var ref1 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref1.t;
    var ref2 = (0,esm/* useTranslation */.$G)("productDetail"), translateProductDetail = ref2.t;
    // gọi tới cache chung lấy seller map
    var _seller = props.seller, seller = _seller === void 0 ? {} : _seller, _tags = props.tags, tags = _tags === void 0 ? [] : _tags, _flagshipStoreInfo = props.flagshipStoreInfo, flagshipStoreInfo = _flagshipStoreInfo === void 0 ? null : _flagshipStoreInfo, isMobile = props.isMobile;
    var code = seller.code;
    var getNameSeller = (0,context/* useSetting */.yu)().getNameSeller;
    var ref3 = getNameSeller({
        seller: seller,
        tags: tags
    }), sellerName = ref3.sellerName, linkStore = ref3.linkStore, _avatar = ref3.avatar, avatar = _avatar === void 0 ? [] : _avatar, tcode = ref3.tcode, fullNameSeller = ref3.fullNameSeller;
    var displayName = tcode !== "seller" ? translateCommon("seller.".concat(tcode)).replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS) : fullNameSeller;
    // const newSellerName = translateCommon(`seller.${tcode}`) || fullNameSeller;
    var partnerName = ((ref = translateProductDetail("partner_of_thuocsi")) === null || ref === void 0 ? void 0 : ref.replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)) || "";
    // const [yearNumber, setYearNumber] = useState(null);
    // không show nút chat ngay đối với các seller từ bên supplier
    // các seller đó là seller internal & các seller flagshipstore durex & sanofi
    // yearNumber
    // useEffect(async () => {
    //   // số năm hợp tác với thuocsi -> deprecate
    //   const supplierRes = await SupplierService.getInfoSupplier({});
    //   if (isValid(supplierRes)) {
    //     const yearNumberCur = new Date().getFullYear() - getFirst(supplierRes).yearFounded;
    //     setYearNumber(yearNumberCur);
    //   }
    // }, []);
    if (flagshipStoreInfo) {
        var primaryColor = flagshipStoreInfo.primaryColor;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                position: "relative",
                marginTop: 8,
                backgroundColor: "#fff"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (SellerInfoProductDetail_styles_module_default()).flagshipTag,
                    style: {
                        backgroundColor: primaryColor
                    },
                    children: translateProductDetail("brand_booth")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SellerInfoProductDetail_styles_module_default()).seller_top_info,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SellerInfoProductDetail_styles_module_default()).avatar_name,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: flagshipStoreInfo.logo[0],
                                    className: (0,clsx_m/* default */.Z)((SellerInfoProductDetail_styles_module_default()).avatar, (0,src_define_property/* default */.Z)({}, (SellerInfoProductDetail_styles_module_default()).avatar_mv2, isMobile)),
                                    style: {
                                        border: "1px solid ".concat(primaryColor)
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            className: (SellerInfoProductDetail_styles_module_default()).name,
                                            children: flagshipStoreInfo.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            className: (SellerInfoProductDetail_styles_module_default()).subName,
                                            children: translateProductDetail("supplier")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* LinkComp */.vk, {
                            className: (SellerInfoProductDetail_styles_module_default()).linkCustomShop,
                            href: flagshipStoreInfo.url,
                            style: {
                                border: "1px solid #025BAC"
                            },
                            onClick: function() {
                                utils/* gtag.clickViewShop */.SX.clickViewShop(flagshipStoreInfo.name);
                            },
                            children: [
                                translateProductDetail("view_store"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    className: (SellerInfoProductDetail_styles_module_default()).subNameBottom,
                    children: translateProductDetail("authentic_product_x_distributed", {
                        slug: flagshipStoreInfo.slug.toUpperCase()
                    })
                })
            ]
        });
    }
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: code && sellerName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SellerInfoProductDetail_styles_module_default()).mobile_wrapper,
                role: "presentation",
                "data-test": "product-seller",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SellerInfoProductDetail_styles_module_default()).row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (SellerInfoProductDetail_styles_module_default()).mobile_avatar_name,
                                children: [
                                    sellerName === "MEDX" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStoreImage */.cE, {
                                        alt: "MEDX",
                                        src: Images/* LOGO_THUOCSI_SHORTENED */.SlS,
                                        className: (SellerInfoProductDetail_styles_module_default()).mobile_avatar,
                                        width: 18,
                                        height: 18
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: avatar[0],
                                        className: (SellerInfoProductDetail_styles_module_default()).mobile_avatar
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (SellerInfoProductDetail_styles_module_default()).mobile_name,
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* LinkComp */.vk, {
                                className: (SellerInfoProductDetail_styles_module_default()).visit_store,
                                href: linkStore,
                                onClick: function() {
                                    utils/* gtag.clickViewShop */.SX.clickViewShop(sellerName);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        children: translateProductDetail("view_store")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                        width: 16,
                                        height: 16
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SellerInfoProductDetail_styles_module_default()).row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                children: translateProductDetail("rating")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                name: "rating",
                                value: 5,
                                readOnly: true,
                                size: "medium",
                                className: (SellerInfoProductDetail_styles_module_default()).rating
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: code && sellerName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((SellerInfoProductDetail_styles_module_default()).wrapper, code && seller && (SellerInfoProductDetail_styles_module_default()).hide_border_top),
            role: "presentation",
            "data-test": "product-seller",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SellerInfoProductDetail_styles_module_default()).avatar_name,
                children: [
                    sellerName === "MEDX" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStoreImage */.cE, {
                        alt: "MEDX",
                        src: Images/* LOGO_THUOCSI_SHORTENED */.SlS,
                        className: (SellerInfoProductDetail_styles_module_default()).sellerIcon,
                        width: 48,
                        height: 48
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: avatar[0],
                        className: (SellerInfoProductDetail_styles_module_default()).avatar
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((SellerInfoProductDetail_styles_module_default()).name, sellerName === partnerName && (SellerInfoProductDetail_styles_module_default()).text_tf_none),
                            children: displayName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                        name: "rating",
                        value: 5,
                        readOnly: true,
                        size: "medium",
                        className: (SellerInfoProductDetail_styles_module_default()).rating
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* LinkComp */.vk, {
                        className: (SellerInfoProductDetail_styles_module_default()).visit_store,
                        href: linkStore,
                        onClick: function() {
                            utils/* gtag.clickViewShop */.SX.clickViewShop(sellerName);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                children: translateProductDetail("view_store")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                width: 16,
                                height: 16
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mocules_SellerInfoProductDetail = (SellerInfoProductDetail);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AccountCircle.js
var AccountCircle = __webpack_require__(82067);
// EXTERNAL MODULE: ./src/utils/EventUtils.js
var EventUtils = __webpack_require__(21986);
;// CONCATENATED MODULE: ./src/components/mocules/SignInForm/SignInForm.js













var SignInForm_SignInForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickForget = param.onClickForget, onClickLogin = param.onClickLogin, onClickSignUp = param.onClickSignUp;
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var ref1 = (0,react.useState)(false), errorUserName = ref1[0], setErrorUserName = ref1[1];
    var ref2 = (0,react.useState)(false), errorPassword = ref2[0], setErrorPassword = ref2[1];
    var ref3 = (0,react.useState)(""), userName = ref3[0], setUserName = ref3[1];
    var ref4 = (0,react.useState)(""), password = ref4[0], setPassword = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(true), 2), rememberMe = ref5[0], toggleRememberMe = ref5[1];
    var validateLogin = function(data) {
        setErrorUserName(false);
        setErrorPassword(false);
        if (!data) {
            setErrorUserName(true);
            setErrorPassword(true);
            return false;
        }
        if (!data.username) {
            setErrorUserName(true);
            return false;
        }
        if (!data.password) {
            setErrorPassword(true);
            return false;
        }
        return true;
    };
    // handle login with data
    var handleLogin = function() {
        var data = {
            username: userName,
            password: password,
            rememberMe: rememberMe
        };
        if (!validateLogin(data)) {
            return;
        }
        onClickLogin(data);
    };
    // handle forget password
    var handleClickForget = (0,react.useCallback)(function(e) {
        e.preventDefault();
        onClickForget();
    }, [
        onClickForget
    ]);
    var handleClickSignUp = (0,react.useCallback)(function(e) {
        e.preventDefault();
        onClickSignUp();
    }, [
        onClickSignUp
    ]);
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconAccount = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {})
    });
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: className,
            onSubmit: handleLogin,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "username",
                        name: "username",
                        startAdornment: IconAccount,
                        placeholder: "Nhập số điện thoại hoặc email",
                        variant: "outlined",
                        error: errorUserName,
                        onChange: function(e) {
                            var ref;
                            return setUserName((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || "");
                        },
                        onKeyPress: function(e) {
                            return EventUtils/* default.handleKeyPressEnter */.Z.handleKeyPressEnter(e, handleLogin);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "password",
                        name: "password",
                        type: showPassword ? "text" : "password",
                        startAdornment: IconPassword,
                        endAdornment: IconEndPassword,
                        placeholder: "Nhập mật khẩu",
                        variant: "outlined",
                        error: errorPassword,
                        onChange: function(e) {
                            var ref;
                            return setPassword((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || "");
                        },
                        onKeyPress: function(e) {
                            return EventUtils/* default.handleKeyPressEnter */.Z.handleKeyPressEnter(e, handleLogin);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rememberPassword",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CheckBox */.Jg, {
                        isChecked: rememberMe,
                        onClick: toggleRememberMe,
                        name: "rememberMe",
                        label: "Giữ t\xf4i đăng nhập"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "forgetPassword",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/",
                        className: "forgetPassword",
                        onClick: handleClickForget,
                        children: "Qu\xean Mật Khẩu"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    className: "btnLogin",
                    color: "white",
                    onClick: handleLogin,
                    children: "Đăng Nhập"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "register",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-capitalize",
                        children: [
                            "Để nhận Ưu đ\xe3i hấp dẫn,",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#top",
                                style: {
                                    color: "#f9b514",
                                    padding: "2px"
                                },
                                onClick: handleClickSignUp,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Đăng k\xfd th\xe0nh vi\xean"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var mocules_SignInForm_SignInForm = (SignInForm_SignInForm);

;// CONCATENATED MODULE: ./src/components/mocules/SignInForm/index.js

function SignInForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .form-control {\n    width: ",
        "px;\n  }\n  .rememberPassword {\n    align-self: flex-start;\n    font-size: 13px;\n  }\n  a.forgetPassword {\n    color: #005c29;\n    text-decoration: none;\n    background-color: transparent;\n  }\n  .btnLogin {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    color: white;\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    margin: 1rem;\n    border-radius: 50px;\n  }\n  .register {\n    padding: 1rem;\n  }\n"
    ]);
    SignInForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var components_mocules_SignInForm_SignInForm = (0,styled_components_browser_esm/* default */.ZP)(mocules_SignInForm_SignInForm).withConfig({
    componentId: "sc-fa9bb14c-0"
})(SignInForm_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 400 : _width;
    return width;
});
/* harmony default export */ var mocules_SignInForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(components_mocules_SignInForm_SignInForm))));

// EXTERNAL MODULE: ./src/components/mocules/SignUpForm/styles.module.css
var SignUpForm_styles_module = __webpack_require__(14025);
var SignUpForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(SignUpForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SignUpForm/SignUpForm.js


























var SignUpForm_validateData = utils/* ValidateUtils.validateData */.IN.validateData, SignUpForm_Error = utils/* ValidateUtils.Error */.IN.Error, SignUpForm_isEmpty = utils/* ValidateUtils.isEmpty */.IN.isEmpty;
var SignUpForm_validateSignUp = function(param, failCallback) {
    var isCheckAgree = param.isCheckAgree, name = param.name, email = param.email, password = param.password, phone = param.phone;
    try {
        SignUpForm_validateData.name(name);
        SignUpForm_validateData.phoneNumber(phone);
        if (!SignUpForm_isEmpty(email)) {
            SignUpForm_validateData.email(email);
        }
        SignUpForm_validateData.password(password);
        if (isCheckAgree !== "") throw new SignUpForm_Error("Vui l\xf2ng chọn Đồng \xfd với Điều khoản sử dụng.");
        return true;
    } catch (error) {
        utils/* NotifyUtils.error */.QP.error((error === null || error === void 0 ? void 0 : error.message) || "Đ\xe3 c\xf3 lỗi xảy ra");
        failCallback(error);
        return false;
    }
};
var SignUpForm = /*#__PURE__*/ react.memo(function(props) {
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var className = props.className, onClickSignIn = props.onClickSignIn, onClickSignUp = props.onClickSignUp, referCode = props.referCode;
    var ref1 = (0,react.useState)({}), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,react.useState)([]), provinces = ref2[0], setProvinces = ref2[1];
    (0,react.useEffect)(function() {
        var getListProvince = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var provinceResult, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                AddressService/* default.getProvinces */.Z.getProvinces()
                            ];
                        case 1:
                            provinceResult = _state.sent();
                            setProvinces(provinceResult);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            utils/* NotifyUtils.error */.QP.error("Lấy danh s\xe1ch tỉnh th\xe0nh kh\xf4ng th\xe0nh c\xf4ng");
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getListProvince() {
                return _ref.apply(this, arguments);
            };
        }();
        getListProvince();
    }, []);
    var handleSubmitSignUp = (0,react.useCallback)(function(e) {
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        e.preventDefault();
        // validate
        if (SignUpForm_validateSignUp(data, function(error) {
            if (error) {
                var newError = {};
                newError[error.type] = true;
                setErrors((0,src_object_spread/* default */.Z)({}, newError));
            }
        })) {
            onClickSignUp(data);
        }
    }, [
        onClickSignUp
    ]);
    var handleClickSignIn = (0,react.useCallback)(function(e) {
        e.preventDefault();
        onClickSignIn();
    }, [
        onClickSignIn
    ]);
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconAccount = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {})
    });
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconPhone = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneOutlined/* default */.Z, {})
    });
    var IconLocation = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: !showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {})
        })
    });
    var IconInviter = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleOutlined/* default */.Z, {})
    });
    var IconEmail = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailOutlined/* default */.Z, {})
    });
    var labelAgree = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            "T\xf4i đ\xe3 đọc v\xe0 đồng \xfd với",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/terms-and-condition",
                target: "_blank",
                rel: "noreferrer",
                style: {
                    color: "green"
                },
                children: "Điều khoản sử dụng *"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: className,
            onSubmit: handleSubmitSignUp,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "username",
                        name: "name",
                        startAdornment: IconAccount,
                        placeholder: "Nhập t\xean (bắt buộc)",
                        variant: "outlined",
                        error: errors.name || false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "phonenumber",
                        name: "phone",
                        startAdornment: IconPhone,
                        placeholder: "Nhập số điện thoại (bắt buộc)",
                        variant: "outlined",
                        error: errors.phone || false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "email",
                        name: "email",
                        startAdornment: IconEmail,
                        placeholder: "Nhập email",
                        variant: "outlined",
                        error: errors.email || false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "password",
                        name: "password",
                        type: showPassword ? "text" : "password",
                        startAdornment: IconPassword,
                        endAdornment: IconEndPassword,
                        placeholder: "Nhập mật khẩu (bắt buộc)",
                        variant: "outlined",
                        error: errors.password || false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                        id: "provinceCode",
                        name: "provinceCode",
                        IconComponent: ExpandMore/* default */.Z,
                        input: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                            startAdornment: IconLocation
                        }),
                        className: (SignUpForm_styles_module_default()).province,
                        children: provinces.map(function(province) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                value: province.value,
                                children: [
                                    " ",
                                    province.label
                                ]
                            }, (0,v4/* default */.Z)());
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "inviter",
                        name: "referCode",
                        startAdornment: IconInviter,
                        value: referCode,
                        placeholder: "Nhập m\xe3 người giới thiệu.",
                        variant: "outlined",
                        disabled: !!referCode
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        defaultValue: Enums/* ENUM_SCOPE.PHARMACY */.hD.PHARMACY,
                        variant: "standard",
                        id: "menu-dropDown",
                        className: (SignUpForm_styles_module_default()).menuDropdown,
                        IconComponent: ExpandMore/* default */.Z,
                        input: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {}),
                        name: "scope",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                className: (SignUpForm_styles_module_default()).itemMenu,
                                value: Enums/* ENUM_SCOPE.PHARMACY */.hD.PHARMACY,
                                children: "Nh\xe0 thuốc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                className: (SignUpForm_styles_module_default()).itemMenu,
                                value: Enums/* ENUM_SCOPE.CLINIC */.hD.CLINIC,
                                children: "Ph\xf2ng kh\xe1m"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.DRUGSTORE */.hD.DRUGSTORE,
                                children: "Quầy thuốc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.HOSPITAL */.hD.HOSPITAL,
                                children: "Bệnh viện"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.PHARMA_COMPANY */.hD.PHARMA_COMPANY,
                                children: "C\xf4ng ty Dược phẩm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.DENTISTRY */.hD.DENTISTRY,
                                children: "Nha khoa"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.BEAUTY_SALON */.hD.BEAUTY_SALON,
                                children: "Thẩm mỹ viện"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "agree-term",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CheckBox */.Jg, {
                        name: "isCheckAgree",
                        label: labelAgree
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "link-login",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-capitalize",
                        children: [
                            "Nếu bạn đ\xe3 c\xf3 t\xe0i khoản, vui l\xf2ng",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#top",
                                style: {
                                    color: "#f9b514",
                                    padding: "2px"
                                },
                                onClick: handleClickSignIn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: " Đăng nhập"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    className: "btn-register",
                    color: "white",
                    type: "submit",
                    children: "Tạo t\xe0i khoản"
                })
            ]
        })
    });
});
/* harmony default export */ var SignUpForm_SignUpForm = (SignUpForm);

;// CONCATENATED MODULE: ./src/components/mocules/SignUpForm/index.js

function SignUpForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .form-control {\n    width: 100%;\n  }\n  .agree-term {\n    align-self: flex-start;\n    font-size: 13px;\n  }\n  a.forgetPassword {\n    color: #005c29;\n    text-decoration: none;\n    background-color: transparent;\n  }\n  .btn-register {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    color: white;\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    padding: 1.5rem;\n    margin: 1rem;\n    border-radius: 50px;\n  }\n  .link-login {\n    padding: 1rem;\n  }\n"
    ]);
    SignUpForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var mocules_SignUpForm_SignUpForm = (0,styled_components_browser_esm/* default */.ZP)(SignUpForm_SignUpForm).withConfig({
    componentId: "sc-6b1b78a3-0"
})(SignUpForm_templateObject());
/* harmony default export */ var mocules_SignUpForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(mocules_SignUpForm_SignUpForm))));

;// CONCATENATED MODULE: ./src/components/mocules/Skeleton/LineItem.js




var LineItemSkeleton = /*#__PURE__*/ (0,react.memo)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            width: "100%",
            height: 24,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                children: "."
            })
        })
    });
});
/* harmony default export */ var LineItem = (LineItemSkeleton);

;// CONCATENATED MODULE: ./src/components/mocules/Skeleton/ProductHorizontal.js




var ProductHorizontalSkeleton = /*#__PURE__*/ (0,react.memo)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rect",
                height: 220
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    paddingTop: "4px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        width: "70%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        width: "50%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    paddingTop: "40px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    width: "25%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    paddingTop: "8px",
                    alignItems: "center",
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginRight: "8px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            animation: "wave",
                            variant: "circle",
                            width: 25,
                            height: 25
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        width: "100%",
                        height: 35,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            children: "."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginLeft: "8px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            animation: "wave",
                            variant: "circle",
                            width: 25,
                            height: 25
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var ProductHorizontal = (ProductHorizontalSkeleton);

// EXTERNAL MODULE: ./src/components/mocules/SliderProduct/index.js
var SliderProduct = __webpack_require__(41863);
;// CONCATENATED MODULE: ./src/components/mocules/BadgeContractPrice/index.js



var BadgeContractPrice_BadgeContractPrice = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Badge, {
        className: "badge badge--contract-price",
        children: children
    });
};
/* harmony default export */ var mocules_BadgeContractPrice = ((/* unused pure expression or super */ null && (BadgeContractPrice_BadgeContractPrice)));

;// CONCATENATED MODULE: ./src/components/mocules/StatusProduct/StatusProductProps.js



var StatusProductProps_StatusProductProps = {
    price_up: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_RibbonPriceUp, {}),
    price_down: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_RibbonPriceDown, {}),
    not_change: null
};
/* harmony default export */ var StatusProduct_StatusProductProps = ((/* unused pure expression or super */ null && (StatusProductProps_StatusProductProps)));

;// CONCATENATED MODULE: ./src/components/mocules/StatusProduct/index.js








var StatusProduct = function(param) {
    var isNew = param.is_new, _isContractPrice = param.isContractPrice, isContractPrice = _isContractPrice === void 0 ? false : _isContractPrice, status = param.status, isEvent = param.is_event, deal = param.deal, salePrice = param.salePrice;
    var statusProps = StatusProductProps[status];
    var percentDiscount = deal ? Math.round(100 - deal.price / salePrice * 100) : null;
    var timeLeft = calculateTimeLeft(deal === null || deal === void 0 ? void 0 : deal.startTime) || {};
    var dealReady = Object.keys(timeLeft).length === 0 || false;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            deal && dealReady && /*#__PURE__*/ _jsxs("div", {
                className: clsx(styles.ribbon, styles.price_down),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.ribbon_percent,
                        children: [
                            percentDiscount || 1,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.ribbon_status,
                        children: "Giảm"
                    })
                ]
            }),
            isNew && /*#__PURE__*/ _jsx(NewBadge, {
                children: "Mới"
            }),
            isContractPrice && /*#__PURE__*/ _jsx(BadgeContractPrice, {
                children: "Gi\xe1 hợp đồng"
            }),
            isEvent && /*#__PURE__*/ _jsx(EventBadge, {
                url: "/events/nguoi-viet-dung-hang-viet-nhan-1-5-diem-tich-luy",
                children: "x1.5 Điểm T\xedch Lũy"
            }),
            statusProps
        ]
    });
};
/* harmony default export */ var mocules_StatusProduct = ((/* unused pure expression or super */ null && (StatusProduct)));

// EXTERNAL MODULE: ./src/constants/Enums/EnumsTicket.js
var EnumsTicket = __webpack_require__(6899);
// EXTERNAL MODULE: ./src/constants/Images/default.js
var Images_default = __webpack_require__(44776);
// EXTERNAL MODULE: ./src/components/mocules/TicketDetailModal/style.module.css
var TicketDetailModal_style_module = __webpack_require__(469);
var TicketDetailModal_style_module_default = /*#__PURE__*/__webpack_require__.n(TicketDetailModal_style_module);
;// CONCATENATED MODULE: ./src/components/mocules/TicketDetailModal/index.js




































// const ChatMessages = styled.div`
//   overflow-y: scroll;
//   overflow: hidden;
// `;
var TicketDetailModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var ref12 = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref12.t;
    var ref13 = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref13.t;
    var ref14 = (0,esm/* useTranslation */.$G)("myTicket"), translateMyTicket = ref14.t;
    var ref15 = (0,context/* useSetting */.yu)(), _mapReasonsTicket = ref15.mapReasonsTicket, mapReasonsTicket = _mapReasonsTicket === void 0 ? new Map() : _mapReasonsTicket;
    // const { user } = useAuth();
    var visible = props.visible, onClose = props.onClose, user = props.user, reloadFunc = props.reloadFunc, ticketId = props.ticketId;
    var name = (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email) || "";
    // const { ticketId, orderId, bankName, bankAccountName, bankBranch, bankCode, feedbackContent, imageUrls, statusOrder, reasonCodes, type, status } =
    //   ticket;
    var ref16 = (0,react.useState)(true), setIsLoading = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 2), isShowSendFeedback = ref17[0], toogleSendFeedback = ref17[1];
    var ref18 = (0,react.useState)(0), reloadFeedbacks = ref18[0], setReloadFeedbacks = ref18[1];
    var ref19 = (0,react.useState)({}), detail = ref19[0], setDetail = ref19[1];
    var isShowBankAccount = false;
    detail === null || detail === void 0 ? void 0 : (ref = detail.reasonCodes) === null || ref === void 0 ? void 0 : ref.forEach(function(code) {
        var ref;
        if ((ref = mapReasonsTicket.get(code)) === null || ref === void 0 ? void 0 : ref.showBankAccount) isShowBankAccount = true;
    });
    // load data
    (0,react.useEffect)(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, ticketDetailRes, _tmp, ticketDetail, _feedbacks, feedbacks, feedbackContentDetail, reasonCodes, orderRes, _tmp1, productInfoRes, _tmp2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                clients/* TicketClient.getDetailTicket */.ZX.getDetailTicket((_tmp.ticketId = ticketId, _tmp))
                            ];
                        case 1:
                            ticketDetailRes = _state.sent();
                            if (!(0,clients/* isValid */.JY)(ticketDetailRes)) {
                                setIsLoading(false);
                                utils_NotifyUtils/* default.error */.Z.error(translatePopupAction("popup-ticket.No_information_found"));
                                onClose();
                                return [
                                    2
                                ];
                            }
                            ticketDetail = (0,clients/* getFirst */.Xi)(ticketDetailRes);
                            _feedbacks = ticketDetail.feedbacks, feedbacks = _feedbacks === void 0 ? [] : _feedbacks, feedbackContentDetail = ticketDetail.feedbackContent, reasonCodes = ticketDetail.reasonCodes;
                            ticketDetail.reasonCodesList = reasonCodes === null || reasonCodes === void 0 ? void 0 : reasonCodes.map(function(reasonCode) {
                                return mapReasonsTicket.get(reasonCode);
                            }).filter(function(item) {
                                return item;
                            });
                            ticketDetail.listFeedback = (feedbacks === null || feedbacks === void 0 ? void 0 : feedbacks.length) > 0 && ((ref = feedbacks[feedbacks.length - 1]) === null || ref === void 0 ? void 0 : ref.content) === feedbackContentDetail ? feedbacks.slice(0, -1) : feedbacks;
                            if (!ticketDetail.orderId) return [
                                3,
                                3
                            ];
                            _tmp1 = {};
                            return [
                                4,
                                clients/* OrderClient.getOrderById */.ZT.getOrderById((_tmp1.id = ticketDetail.orderId, _tmp1))
                            ];
                        case 2:
                            orderRes = _state.sent();
                            ticketDetail.order = (0,clients/* getFirst */.Xi)(orderRes);
                            ticketDetail.isOrderExist = (0,clients/* isValid */.JY)(orderRes);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            ticketDetail.isOrderExist = false;
                            _state.label = 4;
                        case 4:
                            if ((ticketDetail === null || ticketDetail === void 0 ? void 0 : (ref1 = ticketDetail.feedbackContent) === null || ref1 === void 0 ? void 0 : ref1.includes("Gi\xe1")) && (ticketDetail === null || ticketDetail === void 0 ? void 0 : (ref2 = ticketDetail.feedbackContent) === null || ref2 === void 0 ? void 0 : ref2.includes("Nguồn"))) {
                                ticketDetail.feedbackContent = ticketDetail.feedbackContent.replace(/Giá|Nguồn|/g, function(matched) {
                                    if (matched === "Gi\xe1") return translateMyTicket("price");
                                    if (matched === "Nguồn") return translateMyTicket("source");
                                    return matched;
                                });
                            }
                            if (!ticketDetail.sku) return [
                                3,
                                6
                            ];
                            _tmp2 = {};
                            return [
                                4,
                                services/* ProductServiceV2.getProductInfoFromSkus */.Rl.getProductInfoFromSkus((_tmp2.skus = [
                                    ticketDetail.sku
                                ], _tmp2))
                            ];
                        case 5:
                            productInfoRes = _state.sent();
                            ticketDetail.productInfo = (0,clients/* getFirst */.Xi)(productInfoRes);
                            _state.label = 6;
                        case 6:
                            setDetail(ticketDetail);
                            setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchData.apply(this, arguments);
        }
        fetchData();
    }, [
        reloadFeedbacks,
        ticketId
    ]);
    var ref20 = (0,react.useState)(""), currentImage = ref20[0], setCurrentImage = ref20[1];
    var ref21 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), open = ref21[0], toggle = ref21[1];
    var handleClickImage = function(imageUrl) {
        setCurrentImage(imageUrl);
        toggle();
    };
    // submit feedback
    var ref22 = (0,react.useState)({
        feedbackValue: ""
    }), feedback = ref22[0], setFeedback = ref22[1];
    var handleChange = function(e) {
        setFeedback((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback), {
            feedbackValue: e.target.value
        }));
    };
    var handleOnChangeImages = function(imgs) {
        setTimeout(function() {
            setFeedback((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback), {
                isDisableSubmit: false,
                attachments: imgs
            }));
        }, 1500);
    };
    var disableSubmitFeedback = function() {
        setFeedback((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback), {
            isDisableSubmit: true
        }));
    };
    var handleAcceptFeedback = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients/* TicketClient.acceptFeedback */.ZX.acceptFeedback(detail)
                        ];
                    case 1:
                        result = _state.sent();
                        if ((0,clients/* isValid */.JY)(result)) {
                            utils_NotifyUtils/* default.success */.Z.success(translateAlertAction("message_success"));
                            onClose();
                            reloadFunc();
                        } else {
                            utils_NotifyUtils/* default.error */.Z.error(result.message);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAcceptFeedback() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var content, send, _tmp, _tmp1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        content = feedback.feedbackValue;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!content) {
                            utils_NotifyUtils/* default.error */.Z.error(translatePopupAction("popup-ticket.please_fill_feedback"));
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            clients/* TicketClient.sendFeedback */.ZX.sendFeedback((_tmp.ticketId = detail.ticketId, _tmp.content = content, _tmp.attachments = (feedback === null || feedback === void 0 ? void 0 : feedback.attachments) || [], _tmp))
                        ];
                    case 2:
                        send = _state.sent();
                        if (!(0,clients/* isValid */.JY)(send)) throw new Error(send.message || translateAlertAction("message_error"));
                        toogleSendFeedback();
                        _tmp1 = {};
                        setFeedback((_tmp1.feedbackValue = "", _tmp1));
                        setReloadFeedbacks(reloadFeedbacks + 1);
                        utils_NotifyUtils/* default.success */.Z.success(translateAlertAction("message_send_feedback"));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        utils_NotifyUtils/* default.error */.Z.error(error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
                open: visible,
                onClose: onClose,
                className: "ticket-modal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TicketDetailModal_style_module_default()).feedback_order,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            className: (TicketDetailModal_style_module_default()).title,
                            container: true,
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: Images/* FEEDBACKSTATUS_ICON */.xrP,
                                                width: 24,
                                                height: 24
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                className: (TicketDetailModal_style_module_default()).statusTitle,
                                                children: translateMyTicket((ref1 = EnumsTicket/* default */.Z === null || EnumsTicket/* default */.Z === void 0 ? void 0 : EnumsTicket/* default.TicketStatus */.Z.TicketStatus[detail === null || detail === void 0 ? void 0 : detail.status]) === null || ref1 === void 0 ? void 0 : ref1.code) || translateMyTicket("IN_PROCESS")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                        container: true,
                                        justifyContent: "flex-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            "aria-label": "close",
                                            onClick: onClose,
                                            style: {
                                                float: "right",
                                                padding: "0px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es.FontAwesomeIcon, {
                                                icon: free_solid_svg_icons_index_es.faTimes
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            container: true,
                            className: (TicketDetailModal_style_module_default()).container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TicketDetailModal_style_module_default()).info_bank_title,
                                    children: [
                                        translatePopupAction("popup-ticket.feedback_info"),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TicketDetailModal_style_module_default()).info_group,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.Customer_name"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: name
                                                })
                                            ]
                                        }),
                                        (detail === null || detail === void 0 ? void 0 : detail.phone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.phoneNumber"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.phone
                                                })
                                            ]
                                        }),
                                        (detail === null || detail === void 0 ? void 0 : detail.email) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: "Email: "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: (detail === null || detail === void 0 ? void 0 : detail.orderId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (TicketDetailModal_style_module_default()).label,
                                                        children: [
                                                            translatePopupAction("popup-ticket.order_id"),
                                                            ":",
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (TicketDetailModal_style_module_default()).value,
                                                        children: [
                                                            "#",
                                                            detail === null || detail === void 0 ? void 0 : detail.orderId,
                                                            !detail.isOrderExist ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                style: {
                                                                    color: "rgb(204, 85, 85)"
                                                                },
                                                                children: [
                                                                    " ",
                                                                    "(",
                                                                    translatePopupAction("popup-ticket.No_information_found"),
                                                                    ")"
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                style: {
                                                                    color: "#000099"
                                                                },
                                                                children: [
                                                                    " ",
                                                                    translatePopupAction("order_status_label.".concat(detail === null || detail === void 0 ? void 0 : (ref2 = detail.order) === null || ref2 === void 0 ? void 0 : ref2.status)) || translateAlertAction("popup-ticket.other") || ""
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 12,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            style: {
                                                display: "flex"
                                            },
                                            children: (detail === null || detail === void 0 ? void 0 : detail.productInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (TicketDetailModal_style_module_default()).label,
                                                        children: [
                                                            translatePopupAction("popup-ticket.products"),
                                                            ":",
                                                            " "
                                                        ]
                                                    }),
                                                    "\xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                                        href: "".concat((0,Paths/* getPathProductBySlug */.hq)(detail === null || detail === void 0 ? void 0 : (ref3 = detail.productInfo) === null || ref3 === void 0 ? void 0 : ref3.slug)),
                                                        target: "_blank",
                                                        style: {
                                                            padding: "0px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                color: "green",
                                                                fontSize: "15px",
                                                                paddingRight: "5px"
                                                            },
                                                            children: detail === null || detail === void 0 ? void 0 : (ref4 = detail.productInfo) === null || ref4 === void 0 ? void 0 : ref4.name
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.Problems_needing_help"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: translateMyTicket((ref5 = EnumsTicket/* default.TicketLabelEnums */.Z.TicketLabelEnums[detail === null || detail === void 0 ? void 0 : detail.type]) === null || ref5 === void 0 ? void 0 : ref5.code)
                                                })
                                            ]
                                        }),
                                        (detail === null || detail === void 0 ? void 0 : (ref6 = detail.reasonCodesList) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            container: true,
                                            direction: "row",
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.sup_reasons"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                detail === null || detail === void 0 ? void 0 : (ref7 = detail.reasonCodesList) === null || ref7 === void 0 ? void 0 : ref7.map(function(reason) {
                                                    return reason ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                            variant: "contained",
                                                            disabled: true,
                                                            className: (TicketDetailModal_style_module_default()).reason_button,
                                                            children: reason.name
                                                        }, (0,v4/* default */.Z)())
                                                    }, (0,v4/* default */.Z)()) : null;
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (detail === null || detail === void 0 ? void 0 : detail.type) === EnumsTicket/* default.TicketEnums.ORDER */.Z.TicketEnums.ORDER && isShowBankAccount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                            container: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TicketDetailModal_style_module_default()).info_bank_title,
                                                children: translatePopupAction("popup-ticket.bank_info")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.acc_holder"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.bankAccountName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.bank"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.bankName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.acc_number"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.bankCode
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.branch_bank"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.bankBranch
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    container: true,
                                    className: (TicketDetailModal_style_module_default()).content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TicketDetailModal_style_module_default()).info_bank_title,
                                            style: {
                                                marginBottom: "7px"
                                            },
                                            children: translatePopupAction("popup-ticket.content_sp")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                    className: (TicketDetailModal_style_module_default()).feedbackWrap,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                            className: (TicketDetailModal_style_module_default()).feedbackConent,
                                                            children: (detail === null || detail === void 0 ? void 0 : detail.feedbackContent) || translatePopupAction("popup-ticket.sp_notice")
                                                        }),
                                                        (detail === null || detail === void 0 ? void 0 : detail.imageUrls) && (detail === null || detail === void 0 ? void 0 : detail.imageUrls.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                            className: (TicketDetailModal_style_module_default()).feedbackImg,
                                                            children: detail === null || detail === void 0 ? void 0 : (ref8 = detail.imageUrls) === null || ref8 === void 0 ? void 0 : ref8.map(function(imageUrl) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                    onClick: function() {
                                                                        return handleClickImage(imageUrl);
                                                                    },
                                                                    style: {
                                                                        marginRight: "8px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (TicketDetailModal_style_module_default()).ticket_img,
                                                                        width: "90",
                                                                        height: "90",
                                                                        src: (0,ImageUtils/* getLinkGCS */.jA)(imageUrl),
                                                                        alt: "ticket img"
                                                                    })
                                                                }, (0,v4/* default */.Z)());
                                                            })
                                                        })
                                                    ]
                                                }),
                                                detail === null || detail === void 0 ? void 0 : (ref9 = detail.listFeedback) === null || ref9 === void 0 ? void 0 : ref9.map(function(param) {
                                                    var source = param.source, createdTime = param.createdTime, content = param.content, _attachments = param.attachments, attachments = _attachments === void 0 ? [] : _attachments;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                        className: (TicketDetailModal_style_module_default()).feedbackReturn,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                                className: (TicketDetailModal_style_module_default()).feedbackReturn_title,
                                                                children: [
                                                                    sysconfig/* ENV_COUNTRY */.ng === "cam" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: source === "CUSTOMER" ? "/images/feedbackDetail/userFeedback.png" : Images_default/* LOGO_BUYMED_GG */.dV,
                                                                        width: source === "CUSTOMER" ? 22 : 80,
                                                                        height: source === "CUSTOMER" ? 22 : 20
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: source === "CUSTOMER" ? "/images/feedbackDetail/userFeedback.png" : "/images/feedbackDetail/logoThuocsi.png",
                                                                        width: 22,
                                                                        height: 22
                                                                    }),
                                                                    sysconfig/* ENV_COUNTRY */.ng === "cam" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                        className: (TicketDetailModal_style_module_default()).nameTS,
                                                                        children: source === "CUSTOMER" ? translateMyTicket("me") : ""
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                        className: (TicketDetailModal_style_module_default()).nameTS,
                                                                        children: source === "CUSTOMER" ? translateMyTicket("me") : Enums/* BRAND_NAME */.RS
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                        className: (TicketDetailModal_style_module_default()).date,
                                                                        children: utils/* DateTimeUtils.getFormattedDate */.IM.getFormattedDate(new Date(createdTime), "DD/MM/YYYY HH:mm")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                                className: (TicketDetailModal_style_module_default()).feedbackWrap,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                        className: (TicketDetailModal_style_module_default()).feedbackConent,
                                                                        children: content
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                        className: (TicketDetailModal_style_module_default()).feedbackImg,
                                                                        children: attachments && attachments.map(function(item) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                                onClick: function() {
                                                                                    return handleClickImage(item);
                                                                                },
                                                                                style: {
                                                                                    marginRight: "8px"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ImageFallback */.oy, {
                                                                                    className: (TicketDetailModal_style_module_default()).ticket_img,
                                                                                    src: item,
                                                                                    width: 90,
                                                                                    height: 90
                                                                                }, (0,v4/* default */.Z)())
                                                                            }, (0,v4/* default */.Z)());
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, (0,v4/* default */.Z)());
                                                }),
                                                [
                                                    EnumsTicket/* default.TicketStatus.IN_PROCESS.code */.Z.TicketStatus.IN_PROCESS.code,
                                                    EnumsTicket/* default.TicketStatus.PENDING.code */.Z.TicketStatus.PENDING.code,
                                                    EnumsTicket/* default.TicketStatus.REPLIED.code */.Z.TicketStatus.REPLIED.code, 
                                                ].indexOf(detail === null || detail === void 0 ? void 0 : detail.status) >= 0 && !isShowSendFeedback && detail.status !== EnumsTicket/* default.TicketStatus.DONE.code */.Z.TicketStatus.DONE.code && ((detail === null || detail === void 0 ? void 0 : (ref10 = detail.listFeedback) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 && (detail === null || detail === void 0 ? void 0 : detail.listFeedback[0]) && ((ref11 = detail === null || detail === void 0 ? void 0 : detail.listFeedback[0]) === null || ref11 === void 0 ? void 0 : ref11.source) !== "CUSTOMER" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                    className: (TicketDetailModal_style_module_default()).accept,
                                                    children: [
                                                        !(detail === null || detail === void 0 ? void 0 : detail.waitForCustomerFeedback) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.satisfied_content").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS),
                                                                " ",
                                                                utils/* DateTimeUtils.getFormattedDate */.IM.getFormattedDate(new Date(+new Date(detail === null || detail === void 0 ? void 0 : detail.listFeedback[0].createdTime) + data/* ONE_DAY */.s2), "DD/MM/YYYY HH:mm"),
                                                                ".",
                                                                translatePopupAction("popup-ticket.close_ticket").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                            className: (TicketDetailModal_style_module_default()).btnAcept,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                    className: (TicketDetailModal_style_module_default()).buttonActive,
                                                                    onClick: toogleSendFeedback,
                                                                    children: translatePopupAction("popup-ticket.send_feedback")
                                                                }),
                                                                !(detail === null || detail === void 0 ? void 0 : detail.waitForCustomerFeedback) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                    className: (TicketDetailModal_style_module_default()).buttonInActive,
                                                                    onClick: handleAcceptFeedback,
                                                                    children: translatePopupAction("popup-ticket.I_am_satisfied")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                    className: (TicketDetailModal_style_module_default()).accept,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                            className: (TicketDetailModal_style_module_default()).btnAcept,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                className: (TicketDetailModal_style_module_default()).buttonActive,
                                                                onClick: toogleSendFeedback,
                                                                children: translatePopupAction("popup-ticket.send_feedback")
                                                            })
                                                        })
                                                    ]
                                                }))
                                            ]
                                        })
                                    ]
                                }),
                                isShowSendFeedback && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* InfoFormControl */.iD, {
                                            xs: 12,
                                            htmlFor: "description",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
                                                    id: "description",
                                                    name: "formFeedback",
                                                    multiline: true,
                                                    minRows: 4,
                                                    variant: "outlined",
                                                    placeholder: translatePopupAction("popup-ticket.entered_feedback_content"),
                                                    className: (TicketDetailModal_style_module_default()).formfeedback,
                                                    onBlur: handleChange,
                                                    defaultValue: feedback.feedbackValue
                                                }, "formFeedback")
                                            ]
                                        }, (0,v4/* default */.Z)()),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            className: (TicketDetailModal_style_module_default()).imagesField,
                                            item: true,
                                            xs: 12,
                                            container: true,
                                            justifyContent: "space-evenly",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                                    label: translatePopupAction("popup-ticket.images"),
                                                    xs: 12,
                                                    className: (TicketDetailModal_style_module_default()).customText
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImages/* default */.Z, {
                                                    onChange: handleOnChangeImages,
                                                    setLoading: disableSubmitFeedback
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                            className: (TicketDetailModal_style_module_default()).buttonSend,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                    onClick: toogleSendFeedback,
                                                    className: (TicketDetailModal_style_module_default()).buttonCancel,
                                                    children: translatePopupAction("popup-ticket.cancel")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                    className: (TicketDetailModal_style_module_default()).buttonActive,
                                                    onClick: handleSubmit,
                                                    disabled: feedback.isDisableSubmit,
                                                    children: translatePopupAction("popup-ticket.send")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
                open: open,
                onClose: toggle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TicketDetailModal_style_module_default()).image_modal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            onClick: toggle,
                            className: (TicketDetailModal_style_module_default()).close_button,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,ImageUtils/* getLinkGCS */.jA)(currentImage),
                            style: {
                                maxWidth: "800px",
                                maxHeight: "800px"
                            },
                            alt: "ticket img"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_TicketDetailModal = (TicketDetailModal);

;// CONCATENATED MODULE: ./src/components/mocules/Toggle/index.js




















function Toggle(param) {
    var point = param.point, balance = param.balance;
    var ref = useTranslation("common"), translateCommon = ref.t;
    var ref1 = useTranslation("popup-action"), translatePopupAction = ref1.t;
    var ref2 = _sliced_to_array(React.useState(null), 2), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var ref3 = _sliced_to_array(useModal(false), 2), showPoupLogout = ref3[0], toggleLogout = ref3[1];
    var open = Boolean(anchorEl);
    var router = useRouter();
    var clearCart = useCart().clearCart;
    var logout = useAuth().logout;
    var handleClick = function(event) {
        setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
    };
    var handleLogout = function() {
        logout();
        clearCart();
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                className: styles.toggle_button,
                "aria-haspopup": "true",
                onClick: handleClick,
                cursor: "pointer",
                children: /*#__PURE__*/ _jsx(MenuRoundedIcon, {})
            }),
            /*#__PURE__*/ _jsxs(MenuDropDown, {
                anchorEl: anchorEl,
                open: open,
                handleClose: handleClose,
                children: [
                    /*#__PURE__*/ _jsxs(MenuItem, {
                        onClick: handleClose,
                        className: styles.menu_item,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.top_menu,
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        className: styles.top_text,
                                        variant: "h5",
                                        children: translateCommon("debts")
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        className: styles.top_text,
                                        variant: "h5",
                                        children: translateCommon("points")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.top_menu,
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        className: styles.top_text,
                                        variant: "h5",
                                        color: "primary",
                                        children: formatCurrency(balance)
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        className: styles.top_text,
                                        variant: "h5",
                                        color: "secondary",
                                        children: formatFloatNumber(point)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push("/my-account");
                        },
                        text: translateCommon("tab_menu.my_account"),
                        children: /*#__PURE__*/ _jsx(USER, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push("/users/loyalty_points");
                        },
                        text: translateCommon("tab_menu.my_points"),
                        children: /*#__PURE__*/ _jsx(POINTS, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push("/my-order");
                        },
                        text: translateCommon("tab_menu.my_orders"),
                        children: /*#__PURE__*/ _jsx(ORDER, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push("/user/dashboard");
                        },
                        text: translateCommon("tab_menu.statistics"),
                        children: /*#__PURE__*/ _jsx(STATISTICAL, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push("/users/referrals");
                        },
                        text: translateCommon("tab_menu.refer_friends"),
                        children: /*#__PURE__*/ _jsx(REFER, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push(USER_PROMO_CODES_URL);
                        },
                        text: translateCommon("tab_menu.my_discount"),
                        children: /*#__PURE__*/ _jsx(VOUCHER, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push("/users/my-ticket");
                        },
                        text: translateCommon("tab_menu.my_feedback"),
                        children: /*#__PURE__*/ _jsx(FEEDBACK, {})
                    }),
                    ENV_COUNTRY === "vn" && /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            gtag.clickTrackingOrder();
                            router.push("https://tracuu.thuocsi.vn");
                        },
                        text: translateCommon("tab_menu.bill_of_lading_lookup"),
                        children: /*#__PURE__*/ _jsx(BILL, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push("/qr");
                        },
                        text: translateCommon("tab_menu.qr_code_lookup"),
                        children: /*#__PURE__*/ _jsx(QR, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: function() {
                            return router.push("/user/wishlist");
                        },
                        text: translateCommon("tab_menu.interested_products"),
                        children: /*#__PURE__*/ _jsx(WISHLIST, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        text: translateCommon("tab_menu.viewed_products"),
                        handleClick: function() {
                            return router.push("/productviewed");
                        },
                        children: /*#__PURE__*/ _jsx(VIEWED, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        text: translateCommon("tab_menu.reward_events"),
                        handleClick: function() {
                            return router.push("/users/rewards");
                        },
                        children: /*#__PURE__*/ _jsx(REWARDS, {})
                    }),
                    /*#__PURE__*/ _jsx(MenuDropDownItem, {
                        handleClick: toggleLogout,
                        text: translateCommon("logout"),
                        children: /*#__PURE__*/ _jsx(LOGOUT_ICON_IMG, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(NewCustomModal, {
                visible: showPoupLogout,
                onClose: toggleLogout,
                title: translateCommon("comfirmation"),
                content: translatePopupAction("popup-action:popup-logout.logout_right"),
                btnOk: translateCommon("yes"),
                onClickOk: handleLogout,
                btnOnClose: translateCommon("no")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/mocules/index.js






// export { default as CardInfo } from './CardInfo';













































































/***/ }),

/***/ 98358:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38169);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71569);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33436);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24508);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46680);
/* harmony import */ var zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39423);










// import dynamic from 'next/dynamic';




// const XLSX = dynamic(() => import('xlsx'), { ssr: false });
var ExportDataOrderDetail = function(param) {
    var orderId = param.orderId;
    var getStyleBySlugOfTag = useStore(function(state) {
        return state.getStyleBySlugOfTag;
    });
    var user = useAuth().user;
    var productList = function() {
        var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var list = [];
        products.forEach(function(item, index) {
            var ref = (item === null || item === void 0 ? void 0 : item.productInfo) || {}, _tags = ref.tags, tags = _tags === void 0 ? null : _tags, _isGift = ref.isGift, isGift = _isGift === void 0 ? false : _isGift;
            var tagList = [];
            if (isGift) tagList.push("QU\xc0 TẶNG");
            else if (tags) {
                tags.forEach(function(tag) {
                    var ref;
                    if (tag !== "GIFT") tagList.push((ref = getStyleBySlugOfTag(tag)) === null || ref === void 0 ? void 0 : ref.name);
                });
            }
            var tagNameString = tagList.toString();
            list.push({
                order: index + 1,
                name: item.productInfo.name,
                quantity: (item === null || item === void 0 ? void 0 : item.quantity) || 1,
                tags: tagNameString,
                totalPrice: item.totalPrice
            });
        });
        return list;
    };
    var downloadFileOrderDetail = function() {
        var _ref = _async_to_generator(function(orderID) {
            var XLSX, orderRes, _tmp, order, _tmp1, productsInfo, totalItem, totalQuantity, totalPrice, createdTime, deliveryDate, paymentMethod, redeemCode, totalDiscount, customerName, customerPhone, extraFee, deliveryMethodFee, fileType, fileExtension, fileName, sheetName, wb, wsData, ws, _tmp2, _tmp3, _tmp4, excelBuffer, _tmp5, data, _tmp6, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(2599), __webpack_require__.e(4849), __webpack_require__.e(3524), __webpack_require__.e(139)]).then(__webpack_require__.t.bind(__webpack_require__, 7869, 23))
                        ];
                    case 1:
                        XLSX = _state.sent();
                        _tmp = {};
                        return [
                            4,
                            OrderService.getOrderDetail((_tmp.orderId = Number(orderID), _tmp.getCombo = false, _tmp.customerLevel = user === null || user === void 0 ? void 0 : user.level, _tmp.locationCode = user === null || user === void 0 ? void 0 : user.provinceCode, _tmp))
                        ];
                    case 2:
                        orderRes = _state.sent();
                        if (!isValid(orderRes)) {
                            throw Error((orderRes === null || orderRes === void 0 ? void 0 : orderRes.message) || "Xuất đơn h\xe0ng kh\xf4ng th\xe0nh c\xf4ng");
                        }
                        _tmp1 = {};
                        order = getFirst(orderRes, _tmp1);
                        productsInfo = productList(order.products);
                        totalItem = order.totalItem, totalQuantity = order.totalQuantity, totalPrice = order.totalPrice, createdTime = order.createdTime, deliveryDate = order.deliveryDate, paymentMethod = order.paymentMethod, redeemCode = order.redeemCode, totalDiscount = order.totalDiscount, customerName = order.customerName, customerPhone = order.customerPhone, extraFee = order.extraFee, deliveryMethodFee = order.deliveryMethodFee;
                        fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                        fileExtension = ".xlsx";
                        fileName = "Th\xf4ng tin chi tiết đơn h\xe0ng ".concat(orderId, " - ").concat(customerName, " - ").concat(customerPhone, " - ").concat(BRAND_NAME);
                        sheetName = "".concat(orderId);
                        wb = XLSX.utils.book_new();
                        wb.SheetNames.push(sheetName);
                        wsData = [
                            [
                                "M\xe3 đơn",
                                orderId
                            ],
                            [],
                            [
                                "Sản phẩm",
                                totalItem
                            ],
                            [
                                "Tổng số lượng",
                                totalQuantity
                            ],
                            [
                                "Tổng gi\xe1 tiền",
                                totalPrice
                            ],
                            [
                                "Ng\xe0y mua",
                                new Date(createdTime)
                            ],
                            [
                                "Ng\xe0y giao dự kiến",
                                new Date(deliveryDate)
                            ],
                            [
                                "H\xecnh thức thanh to\xe1n",
                                PAYMENT_METHOD_NAME[paymentMethod]
                            ],
                            [
                                "Ph\xed giao h\xe0ng",
                                deliveryMethodFee
                            ],
                            [
                                "Phụ ph\xed",
                                extraFee
                            ],
                            redeemCode && redeemCode.length > 0 && [
                                "M\xe3 giảm gi\xe1",
                                redeemCode[0]
                            ],
                            totalDiscount && totalDiscount > 0 && [
                                "Số tiền được giảm",
                                totalDiscount
                            ]
                        ];
                        ws = XLSX.utils.aoa_to_sheet(wsData);
                        _tmp2 = {};
                        _tmp3 = {};
                        XLSX.utils.sheet_add_json(ws, [
                            (_tmp2.A = "Số thứ tự", _tmp2.B = "T\xean sản phẩm", _tmp2.C = "Số lượng", _tmp2.D = "Tags", _tmp2.E = "Tổng tiền", _tmp2)
                        ], (_tmp3.skipHeader = true, _tmp3.origin = "A15", _tmp3));
                        _tmp4 = {};
                        XLSX.utils.sheet_add_json(ws, productsInfo, (_tmp4.skipHeader = true, _tmp4.origin = "A16", _tmp4));
                        wb.Sheets[sheetName] = ws;
                        _tmp5 = {};
                        excelBuffer = XLSX.write(wb, (_tmp5.bookType = "xlsx", _tmp5.type = "array", _tmp5));
                        _tmp6 = {};
                        data = new Blob([
                            excelBuffer
                        ], (_tmp6.type = fileType, _tmp6));
                        FileSaver.saveAs(data, fileName + fileExtension);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        NotifyUtils.error(error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function downloadFileOrderDetail(orderID) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: "Xuất th\xf4ng tin chi tiết đơn h\xe0ng",
        children: /*#__PURE__*/ _jsx(IconButton, {
            size: "small",
            className: styles.btn,
            onClick: function() {
                return downloadFileOrderDetail(orderId);
            },
            children: /*#__PURE__*/ _jsx(CloudDownloadIcon, {
                className: styles.icon
            })
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ExportDataOrderDetail)));


/***/ }),

/***/ 66402:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);














var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        expand: {
            transform: "rotate(-90deg)",
            marginLeft: "auto",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shortest
            })
        },
        expandOpen: {
            transform: "rotate(0deg)"
        },
        root: {
            padding: "12px !important",
            borderRadius: "50% !important"
        }
    };
});
var InvoiceList = function(param) {
    var tmp = param.invoiceData, invoiceObject = tmp === void 0 ? {} : tmp, orderId = param.orderId;
    var classes = useStyles();
    var ref = useState(false), expanded = ref[0], setExpanded = ref[1];
    if (!invoiceObject) {
        return null;
    }
    var _invoiceData = invoiceObject.invoiceData, invoiceData = _invoiceData === void 0 ? [] : _invoiceData, _source = invoiceObject.source, source = _source === void 0 ? "" : _source, _vatType = invoiceObject.vatType, vatType = _vatType === void 0 ? "" : _vatType;
    var fileList = [];
    invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.forEach(function(item) {
        if (item === null || item === void 0 ? void 0 : item.pdfUrl) fileList.push(item === null || item === void 0 ? void 0 : item.pdfUrl);
    });
    var name = "Chứng Từ H\xf3a Đơn";
    if (vatType === "VAT_ALL") {
        name += " MedX 5%,8%,10%";
    } else if (source === "MEDX") {
        name += " MedX 5%,10%";
    } else if (source === "MEDX-8") {
        name += " MedX 8%";
    }
    var handleExpandClick = function() {
        setExpanded(!expanded);
    };
    return (fileList === null || fileList === void 0 ? void 0 : fileList.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                className: styles.divider
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.head_popup,
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        className: styles.title_popup,
                        children: [
                            fileList.length,
                            " ",
                            name,
                            " "
                        ]
                    }),
                    fileList.length > 0 && /*#__PURE__*/ _jsx(IconButton, {
                        className: clsx(classes.root, classes.expand, _define_property({}, classes.expandOpen, expanded)),
                        onClick: handleExpandClick,
                        "aria-expanded": expanded,
                        "aria-label": "show more",
                        children: /*#__PURE__*/ _jsx(ExpandMoreIcon, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Collapse, {
                in: expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: fileList.map(function(file, i) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: styles.item,
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                className: styles.fileName,
                                children: [
                                    "VAT - ",
                                    orderId,
                                    " - ",
                                    i + 1
                                ]
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: file,
                                target: "blank",
                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                    title: "Xem v\xe0 tải xuống",
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        className: classes.root,
                                        "aria-label": "pdf",
                                        children: /*#__PURE__*/ _jsx(CloudDownloadIcon, {})
                                    })
                                })
                            })
                        ]
                    }, uuidv4());
                })
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InvoiceList)));


/***/ }),

/***/ 39796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_RemoveProductModal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(18463);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 18 modules
var atoms = __webpack_require__(69251);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/components/organisms/RemoveProductModal/style.module.css
var style_module = __webpack_require__(54304);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/organisms/RemoveProductModal/RemoveProductModal.js











var RemoveProductModal = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var onClose = props.onClose, onRemove = props.onRemove, visible = props.visible, className = props.className, restProps = props.restProps, product = props.product;
    var ref1 = product || {}, defaultImage = ref1.defaultImage, displayPriceFormated = ref1.displayPriceFormated;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: (style_module_default()).confirm_modal_wrap,
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (style_module_default()).modal_title,
                            children: translateCommon("confirmation")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).modal_content_wrap,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (style_module_default()).modal_content,
                                "data-test": "modal-remove-product-text",
                                children: translateCommon("confirm_delete_product")
                            })
                        })
                    ]
                }),
                product && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    className: (style_module_default()).remove_item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).remove_item_image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                className: (style_module_default()).remove_item_image,
                                src: defaultImage && "".concat(defaultImage, "?size=200"),
                                fallbackSrc: defaultImage,
                                width: 80,
                                height: 80,
                                alt: product.name && product.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (style_module_default()).remove_item_content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).remove_item_cart_name,
                                    children: product.name && product.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).remove_item_cart_price,
                                    children: displayPriceFormated
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginTop: "16px",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefaultLogin */.O2, {
                            btnType: "warning",
                            onClick: onClose,
                            "data-test": "btn-cancel-del-product-in-cart",
                            children: translateCommon("btn.no")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefaultLogin */.O2, {
                            onClick: function() {
                                return onRemove();
                            },
                            autoFocus: true,
                            "data-test": "btn-ok-del-product-in-cart",
                            children: translateCommon("btn.yes")
                        })
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ var RemoveProductModal_RemoveProductModal = (RemoveProductModal);

;// CONCATENATED MODULE: ./src/components/organisms/RemoveProductModal/index.js


/* harmony default export */ var organisms_RemoveProductModal = (/*#__PURE__*/react.memo(RemoveProductModal_RemoveProductModal));


/***/ }),

/***/ 11917:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * LEGACY — chỉ còn module tag cũ ở `src/components/mocules/{TagComponent,TagType}` dùng bảng này.
 *
 * Đừng thêm entry mới: style/nhãn/thứ tự của tag do CMS quyết định (xem `src/utils/TagUtils.js`
 * và `docs/product-tag-display-spec.md`). Toàn bộ entry hardcode khác đã được tắt từ
 * commit b19658a78 ("off tag hardcode", 27Jun2024) và được gỡ hẳn khi chuẩn hoá module TH.
 */ var TagTypeProps = {
    default: {
        border: "1px solid #000",
        color: "#000"
    },
    // Consumer duy nhất: src/components/mocules/TagType (chip "cận date" kèm ngày ở giỏ hàng/đơn hàng).
    NEAR_EXPIRATION: {
        code: "NEAR_EXPIRATION",
        tcode: "NEAR_EXPIRATION",
        name: "Cận date",
        textColor: "#DC5C00",
        backgroundColor: "#FFEEEF",
        index: 100,
        url: "/products"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (TagTypeProps);


/***/ }),

/***/ 30984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FX": function() { return /* binding */ FLAGSHIP_STORE_SLUGS; },
/* harmony export */   "_h": function() { return /* binding */ getHardcodeStoreByTagList; }
/* harmony export */ });
/* unused harmony exports DUREX_INFO, SANOFI_INFO, DUREX_SELLER_INFO, SANOFI_SELLER_INFO, MapFlagshipStoreBySlug, FLAGSHIP_STORE_TAGS, TITLE_IMAGE_RESPONSIVE_STEP */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);
/* harmony import */ var utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65342);



var DUREX_INFO = {
    primaryColor: "#025BAC",
    secondaryColor: "#D0E7FF",
    titleColor: "#025BAC",
    backgroundColor: "#E9F3FE",
    borderAvatarColor: "#2D9CDB",
    url: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex"),
    backgrounds: [
        "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .PROXY_IMAGE */ .mJ, "/thuocsi-testing/images/2022f79adf10d22789d52c674d398e40")
    ],
    thumbnail: [
        (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/thumbnail.png")
    ],
    banners: [
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-promotion-13_9_2022.png"), 
            ],
            isActive: true,
            link: "https://bit.ly/durex-store-banner",
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-1.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-2.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-4.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-5.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-6.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/banner.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_CONTENT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-0.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-1.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-2.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-3.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-4.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-5.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-6.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-7.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        }, 
    ],
    description: '<p>Bao Cao Su l\xe0 sản phẩm được lựa chọn nhiều nhất để ph\xf2ng tr\xe1nh thai, trong đ\xf3 k\xeanh nh\xe0 thuốc chiếm vai tr\xf2 rất quan trọng đối với việc ph\xe2n phối sản phẩm tới người ti\xeau d\xf9ng. Durex l\xe0 thương hiệu bao cao su số 1 thế giới v\xe0 Việt Nam. H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại <a target="_blank" href="http://thuocsi.vn">http://thuocsi.vn</a> để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.</p>\n	',
    email: "durex@thuocsi.vn",
    feedbacks: [
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/customer/customer1.png")
            ],
            content: "thuocsi c\xf3 đầy đủ mặt h\xe0ng của Durex n\xean mỗi lần l\xean đơn c\xf9ng một chỗ rất tiện, gi\xe1 sỉ d\xf9 mua lẻ.",
            customerName: "Chị Mai"
        },
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/customer/customer2.png")
            ],
            content: "H\xe0ng ch\xednh h\xe3ng, mua rất an t\xe2m.",
            customerName: "Chị Lan Anh"
        },
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/customer/customer3.png")
            ],
            content: "Giao h\xe0ng đủ khi đặt h\xe0ng.",
            customerName: "Anh Tuấn Văn"
        }, 
    ],
    landingPages: [],
    logo: [
        (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/logo.png")
    ],
    name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
    numberProductDisplay: 0,
    numberProducts: 0,
    sellerClass: "EXTERNAL",
    slug: "durex",
    status: "ACTIVE",
    storeType: "FLAGSHIP",
    videoIntroduces: [
        "https://www.youtube.com/watch?v=AVPOa6lyv_0"
    ],
    tags: [
        {
            code: "DUREX-HERO",
            type: "fav",
            backgroundTitleColor: "transparent",
            titleColor: "#025BAC",
            backgroundColor: "#D0E7FF"
        },
        {
            code: "DUREX",
            type: "new",
            backgroundTitleColor: "#025BAC",
            titleColor: "#fff",
            backgroundColor: "#fff"
        },
        {
            code: "DUREX-CAT1",
            type: "new",
            backgroundTitleColor: "#025BAC",
            titleColor: "#fff",
            backgroundColor: "#fff"
        },
        {
            code: "DUREX-CAT2",
            type: "new",
            backgroundTitleColor: "#025BAC",
            titleColor: "#fff",
            backgroundColor: "#fff"
        }, 
    ]
};
var SANOFI_INFO = {
    primaryColor: "#7404E0",
    secondaryColor: "#EEE9FE",
    titleColor: "#7404E0",
    backgroundColor: "#EEE9FE",
    borderAvatarColor: "#7404E0",
    backgrounds: [
        "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .PROXY_IMAGE */ .mJ, "/thuocsi-testing/images/2022f79adf10d22789d52c674d398e40")
    ],
    url: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi"),
    banners: [
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-1_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-2_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-5_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        // {
        //   description: 'Sanofi',
        //   hashTag: 'sanofi',
        //   images: [getLinkImageStatic(`/images/flagship-store/sanofi/home/sliding-banner-3_15-9-2022.png`)],
        //   isActive: true,
        //   link: `${WEB_HOST}/products?tag=SANOFI-CAT3`,
        //   name: 'Gian hàng SANOFI chính hãng',
        //   type: 'SLIDER',
        // },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-4_15-9-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/products?tag=SANOFI-CAT4"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-3_15-9-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/products?tag=SANOFI-CAT3"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-1_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-2_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-5_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-4_15-9-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/products?tag=SANOFI-CAT4"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-3_15-9-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul, "/products?tag=SANOFI-CAT3"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        }, 
    ],
    description: "<p>Sanofi l\xe0 tập đo\xe0n chăm s\xf3c sức khỏe h\xe0ng đầu thế giới, lu\xf4n cam kết hỗ trợ chăm s\xf3c v\xe0 cải thiện chất lượng sức khỏe của bệnh nh\xe2n. Từ ph\xf2ng ngừa đến điều trị, Sanofi đ\xe3 dựa tr\xean những th\xe0nh tựu nghi\xean cứu khoa học để đưa đến những giải ph\xe1p chăm s\xf3c sức khỏe con người, như vắc-xin, thuốc trị bệnh hiếm gặp, bệnh đa xơ cứng, ung thư, c\xe1c bệnh li\xean quan đến miễn dịch, bệnh truyền nhiễm, tiểu đường, c\xe1c giải ph\xe1p cho tim mạch cũng như chăm s\xf3c sức khỏe người ti\xeau d\xf9ng. Hơn 100.000 nh\xe2n vi\xean của Sanofi l\xe0m việc tại 100 quốc gia đang nỗ lực để tạo n\xean sự kh\xe1c biệt cho đời sống bệnh nh\xe2n ở bất cứ nơi n\xe0o họ sống v\xe0 cho ph\xe9p họ tận hưởng một cuộc sống l\xe0nh mạnh hơn.</p>",
    email: "sanofi@thuocsi.vn",
    feedbacks: [
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/customer/customer1.png")
            ],
            content: "Lượng mặt h\xe0ng đa dạng được liệt k\xea r\xf5 r\xe0ng, t\xf4i c\xf3 thể dễ d\xe0ng t\xecm kiếm được những sản phẩm m\xe0 t\xf4i cần.",
            customerName: "Chị Ho\xe0ng Ng\xe2n"
        },
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/customer/customer2.png")
            ],
            content: "Gi\xe1 c\xe1c sản phẩm lu\xf4n b\xecnh ổn cũng như c\xf3 nhiều chương tr\xecnh khuyến m\xe3i, qu\xe0 tặng v\xe0 ưu đ\xe3i trong th\xe1ng.",
            customerName: "Anh Tuấn Anh"
        },
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/customer/customer3.png")
            ],
            content: "H\xe0ng h\xf3a đ\xf3ng g\xf3i cẩn thận, kĩ c\xe0ng cũng như tư vấn về c\xe1c sản phẩm rất nhiệt t\xecnh v\xe0 r\xf5 r\xe0ng.",
            customerName: "Anh Duy H\xe0"
        }, 
    ],
    landingPages: [],
    logo: [
        (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/logo.png")
    ],
    name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
    numberProductDisplay: 0,
    numberProducts: 0,
    sellerClass: "EXTERNAL",
    slug: "sanofi",
    status: "ACTIVE",
    storeType: "FLAGSHIP",
    videoIntroduces: [
        "https://www.youtube.com/watch?v=ssY36cNs2SA&ab_channel=TPBVSKPharmaton"
    ],
    tags: [
        // {
        //   code: 'SANOFI-HERO',
        //   type: 'fav',
        //   backgroundColor: '#1E034A',
        //   backgroundTitleColor: 'transparent',
        //   titleColor: '#fff',
        // },
        {
            code: "SANOFI",
            type: "deal",
            backgroundColor: "#1E034A",
            backgroundTitleColor: "transparent",
            titleColor: "#fff"
        },
        // {
        //   code: 'SANOFI-CAT1',
        //   type: 'new',
        //   backgroundColor: '#1E034A',
        //   backgroundTitleColor: 'transparent',
        //   titleColor: '#fff',
        // },
        {
            code: "SANOFI-CAT2",
            type: "new",
            backgroundColor: "#0A71CE",
            titleColor: "#fff",
            titleBanner: (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/categoryBannerTitle/Duongruot.png"),
            bannerHeight: 81,
            priority: [
                "medx-enterogermina-4-billion5ml-sanofi-hop20ong5ml",
                "medx-enterogermina-2-billion5ml-sanofi-hop20ong5ml",
                "medx-phosphalugel-sanofi-hop26goi20gram",
                "medx-mepraz-omeprazol-20mg-sanofi-hop28-vien-nang", 
            ]
        },
        {
            code: "SANOFI-CAT3",
            type: "new",
            backgroundColor: "#EF8C21",
            titleColor: "#fff",
            titleBanner: (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/categoryBannerTitle/Thuocxuongkhop.png"),
            bannerHeight: 73,
            priority: [
                "medx-bo-sung-vitamin-va-khoang-chat-pharmaton-energy-rottendorf-chai30-vien-nen",
                "medx-bo-sung-vitamin-va-khoang-chat-pharmaton-essential-biofarma-srl-chai30-vien-nen",
                "medx-calcium-corbiere-extra-sanofi-hop30ong10ml",
                "medx-calcium-corbiere-kids-extra-hop30ong5ml", 
            ]
        },
        {
            code: "SANOFI-CAT4",
            type: "new",
            backgroundColor: "#AC3786",
            titleColor: "#fff",
            titleBanner: (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/categoryBannerTitle/Thuocho-Diung.png"),
            bannerHeight: 120,
            priority: [
                "medx-telfast-hd-fexofenadin-180mg-sanofi-hop10-vien-nen",
                "medx-telfast-bd-fexofenadin-60mg-sanofi-hop10-vien-nen",
                "medx-telfast-kids-fexofenadin-30mg-sanofi-hop10-vien-nen",
                "medx-bisolvon-kids-bromhexin-4mg5ml-sanofi-chai60ml",
                "medx-acemuc-acetylcysein-100mg-sanofi-hop30goi0.5gram",
                "medx-acemuc-acetylcystein-200mg-sanofi-hop30goi1gram", 
            ]
        }, 
    ]
};
var DUREX_SELLER_INFO = {
    code: "durex-hardcode-unique-id",
    name: DUREX_INFO.name,
    product: {
        topProducts: []
    },
    sellerStore: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, DUREX_INFO),
    slug: DUREX_INFO.slug,
    sellerType: "FLAGSHIP",
    isVip: true,
    favTag: "DUREX-HERO"
};
var SANOFI_SELLER_INFO = {
    code: "sanofi-hardcode-unique-id",
    name: SANOFI_INFO.name,
    product: {
        topProducts: []
    },
    sellerStore: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, SANOFI_INFO),
    slug: SANOFI_INFO.slug,
    sellerType: "FLAGSHIP",
    isVip: true,
    favTag: "SANOFI-HERO"
};
var MapFlagshipStoreBySlug = {
    durex: DUREX_INFO,
    sanofi: SANOFI_INFO,
    DUREX: DUREX_INFO,
    SANOFI: SANOFI_INFO
};
var FLAGSHIP_STORE_SLUGS = [
    "durex",
    "sanofi"
];
var FLAGSHIP_STORE_TAGS = [
    "DUREX",
    "SANOFI"
];
var TITLE_IMAGE_RESPONSIVE_STEP = (/* unused pure expression or super */ null && ([
    350,
    750
]));
var getHardcodeStoreByTagList = function(tags) {
    if (tags === null || tags === void 0 ? void 0 : tags.length) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tag = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // eslint-disable-next-line no-restricted-syntax
                    for(var _iterator1 = FLAGSHIP_STORE_TAGS[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var flagshipStoreTag = _step1.value;
                        if (tag.includes(flagshipStoreTag)) {
                            return MapFlagshipStoreBySlug[flagshipStoreTag];
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return null;
};


/***/ }),

/***/ 97429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOnScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/rules-of-hooks */ 

function useOnScreen(ref) {
    var isActive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (!IntersectionObserver) {
        return false;
    }
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isIntersecting = _$ref[0], setIsIntersecting = _$ref[1];
    var options = {
        threshold: 0.8
    };
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            return setIsIntersecting(entry.isIntersecting);
        }, options);
    }, []);
    var onScroll = function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            observer.observe(ref.current);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isActive) {
            return function() {
                observer.disconnect();
            };
        }
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            observer.observe(ref.current);
        }
        document.addEventListener("scroll", onScroll, true);
        document.addEventListener("touchmove", onScroll, true);
        return function() {
            observer.disconnect();
            document.removeEventListener("scroll", onScroll, true);
            document.addEventListener("touchmove", onScroll, true);
        };
    }, [
        ref,
        observer
    ]);
    return isIntersecting;
};


/***/ }),

/***/ 64875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTrackingMonitor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71569);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79903);
/* harmony import */ var zustand_lib_useSellers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14626);
/* harmony import */ var _useHover__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82163);
/* harmony import */ var _useOnScreen__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97429);
/* eslint-disable react-hooks/rules-of-hooks */ 











function useTrackingMonitor(ref, product, isMobile) {
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var isSendEvent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    var getSellerByCode = (0,zustand_lib_useSellers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(state) {
        return state.getSellerByCode;
    });
    var _$ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_useHover__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref, !isMobile || !isSendEvent.current, isMobile), 1), isHover = _$ref[0];
    var isOnScreen = (0,_useOnScreen__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ref, isMobile || !isSendEvent.current);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var sendEvent = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var sellerInfo, _tmp, res, _tmp1, _tmp2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            getSellerByCode((_tmp.code = product === null || product === void 0 ? void 0 : product.sellerCode, _tmp.tags = (product === null || product === void 0 ? void 0 : product.tags) || [], _tmp))
                        ];
                    case 1:
                        sellerInfo = _state.sent();
                        _tmp1 = {};
                        _tmp2 = {};
                        return [
                            4,
                            utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sendSKUEvent */ .ZP.sendSKUEvent(constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .MONITORING_COLLECTOR_TYPE.SKU_IMPRESSION */ .Hq.SKU_IMPRESSION, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_tmp1, product), (_tmp2.sellerInfo = sellerInfo, _tmp2)), router.pathname)
                        ];
                    case 2:
                        res = _state.sent();
                        if ((res === null || res === void 0 ? void 0 : res.status) === "OK") isSendEvent.current = true;
                        return [
                            2
                        ];
                }
            });
        });
        return function sendEvent() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!isSendEvent.current) {
        if (isMobile && isOnScreen) {
            timeoutRef.current = setTimeout(sendEvent, 2000);
        } else if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (isHover) {
            sendEvent();
        }
    }
};


/***/ }),

/***/ 71637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ WEB_STYLES; }
/* harmony export */ });
/* unused harmony export APP_STYLES */
/* harmony import */ var _material_ui_core_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18334);

var COLORS = {
    GREEN: "#005C29",
    TEXT: {
        DEFAULT: "#495057"
    },
    green: _material_ui_core_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
};
var BACKGROUND_COLORS = {
    MAIN: "#f4f7fc",
    WHITE: "#fff",
    BLACK: "#000"
};
var WEB_STYLES = {
    COLORS: COLORS,
    BACKGROUND_COLORS: BACKGROUND_COLORS
};
var APP_STYLES = {
    COLORS: COLORS,
    BACKGROUND_COLORS: BACKGROUND_COLORS
};


/***/ }),

/***/ 21986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ downloadPDFFile; }
/* harmony export */ });
/* eslint-disable no-shadow */ var handleKeyPressEnter = function(event, callback) {
    if (event.key === "Enter" && callback) {
        callback();
    }
};
var downloadPDFFile = function(link, fileName) {
    fetch(link, {
        method: "GET",
        headers: {
            "Content-Type": "application/pdf"
        }
    }).then(function(response) {
        return response.blob();
    }).then(function(blob) {
        // Create blob link to download
        var url = window.URL.createObjectURL(new Blob([
            blob
        ]));
        var _$link = document.createElement("a");
        _$link.href = url;
        _$link.setAttribute("download", fileName);
        // Append to html link element page
        document.body.appendChild(_$link);
        // Start download
        _$link.click();
        // Clean up and remove the link
        _$link.parentNode.removeChild(_$link);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    handleKeyPressEnter: handleKeyPressEnter,
    downloadPDFFile: downloadPDFFile
});


/***/ }),

/***/ 89388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QG": function() { return /* binding */ checkTrialSelected; },
/* harmony export */   "Uw": function() { return /* binding */ checkNewUser; }
/* harmony export */ });
/* harmony import */ var constants_data_mobile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76412);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17445);


var checkTrialSelected = function(user) {
    var userSelected = constants_data_mobile__WEBPACK_IMPORTED_MODULE_0__/* .ACCOUNTS_TRIAL */ .wf[ false ? 0 : "stg"] || [];
    return userSelected === null || userSelected === void 0 ? void 0 : userSelected.some(function(element) {
        return element === (user === null || user === void 0 ? void 0 : user.customerID);
    });
};
var checkNewUser = function(createdDate) {
    var TIME_OPEN_TRIAL = "November 24, 2022 00:00:00";
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(TIME_OPEN_TRIAL), new Date(createdDate)) >= 0;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ }),

/***/ 98300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38169);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36902);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38597);
/* eslint-disable no-param-reassign */ 





var promotionLists = {
    data: [],
    loading: true,
    err: "",
    listSku: []
};
var useGetPromoLists = function(set, get) {
    return {
        promotionLists: promotionLists,
        getPromoLists: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
                var _skus, skus, getVoucherInfo, signal, res, _tmp, err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _skus = param.skus, skus = _skus === void 0 ? [] : _skus, getVoucherInfo = param.getVoucherInfo, signal = param.signal;
                            set(function(state) {
                                state.promotionLists.loading = true;
                            }, false, "fetchDataPromotionLists");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            _tmp = {};
                            return [
                                4,
                                clients__WEBPACK_IMPORTED_MODULE_0__/* .PromotionClient.getPromoLists */ .$i.getPromoLists((_tmp.skus = skus, _tmp.getVoucherInfo = getVoucherInfo, _tmp.signal = signal, _tmp))
                            ];
                        case 2:
                            res = _state.sent();
                            set(function(state) {
                                state.promotionLists.loading = false;
                                state.promotionLists.data = [
                                    (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res)
                                ];
                                state.promotionLists.listSku = [
                                    skus
                                ];
                            }, false, "fetchDataPromotionLists_success");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            set(function(state) {
                                state.promotionLists.loading = false;
                                state.promotionLists.err = err;
                            }, false, "fetchDataPromotionLists_err");
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        dataByPromoListsDetail: function() {
            var data = get().promotionLists.data;
            return data;
        },
        filterTagGift: function(sku, dataFunc, productCode) {
            if (!sku || typeof dataFunc !== "function" || !dataFunc) return false;
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dataFunc() || [], 1), data = ref[0];
            var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((data === null || data === void 0 ? void 0 : data.filter(function(item) {
                if (item.sku) return item.sku === sku;
                return item.productCode === productCode;
            })) || [], 1), filterTagWithSku = ref1[0];
            if (filterTagWithSku && (filterTagWithSku === null || filterTagWithSku === void 0 ? void 0 : filterTagWithSku.hasGift)) return true;
            return false;
        }
    };
};
useGetPromoLists = (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .devtools */ .mW)(useGetPromoLists);
useGetPromoLists = (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .persist */ .tJ)(useGetPromoLists, {
    name: "gifts"
});
/* harmony default export */ __webpack_exports__["Z"] = ((0,zustand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(useGetPromoLists));


/***/ }),

/***/ 43775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"styles_drawerContainer__1HUsk","container":"styles_container__M30G0","title":"styles_title__lbyvo","header":"styles_header__EZSA5","iconButton":"styles_iconButton__w7_Ys","content":"styles_content__9O2wd","bottomSection":"styles_bottomSection__SPmQ_"};

/***/ }),

/***/ 5596:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text_warning":"styles_text_warning__OQOk3"};

/***/ }),

/***/ 9904:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"price_row":"styles_price_row__2YbWA","current_price":"styles_current_price__KWIc8","old_price":"styles_old_price__jArF3","price_after_voucher":"styles_price_after_voucher__mMzPz","price_after_voucher_label":"styles_price_after_voucher_label__fei_Y"};

/***/ }),

/***/ 99182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__52bCp","image_wrapper":"styles_image_wrapper__PD7e7","image":"styles_image__i60k7","content":"styles_content__qkkag","link":"styles_link__h7knV","product_name":"styles_product_name__hyq3G","product_volume":"styles_product_volume__UTWFu","product_tags":"styles_product_tags__gpxnV","price_block":"styles_price_block__RHZYm","price_row":"styles_price_row__0vMUa","price_label":"styles_price_label__Icpdp","price_label_strong":"styles_price_label_strong__j_rzo","old_price":"styles_old_price__mRrzI","new_price":"styles_new_price__SOb5W","fluctuation_row":"styles_fluctuation_row__h0W8E","fluctuation_text":"styles_fluctuation_text__XQy40","increased":"styles_increased__iRuvQ","reason_text":"styles_reason_text__5l1T8","quantity_block":"styles_quantity_block__S7ThG","limit_text":"styles_limit_text__vtYca","quantity_control":"styles_quantity_control__DNE_8","quantity_input_wrapper":"styles_quantity_input_wrapper__9R5GX","quantity_input":"styles_quantity_input__P4Ae_","item_mobile":"styles_item_mobile__P4NG5","minus_button":"styles_minus_button__jtZEP"};

/***/ }),

/***/ 57624:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__IbkF1","drawer_paper":"styles_drawer_paper__QO2LX","drawer_content":"styles_drawer_content__eEjXf","header":"styles_header__Bg5oB","title":"styles_title__SYE7i","btn_close":"styles_btn_close__e_0Bh","close_text":"styles_close_text__32zYk","body":"styles_body__q4u_P","group":"styles_group__PrBrh","group_header":"styles_group_header__wsgNY","group_header_increased":"styles_group_header_increased___aFDL","items":"styles_items__1aIhD","items_collapsed":"styles_items_collapsed__gPm_6","see_all":"styles_see_all__IKNjs","disclaimer":"styles_disclaimer__vHD6O","actions":"styles_actions__V8Jwb","btn_back":"styles_btn_back__QTM8w","btn_continue":"styles_btn_continue__mrukQ","footer":"styles_footer__pruHN"};

/***/ }),

/***/ 93454:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img_container":"styles_img_container__tyMor","text_product_name":"styles_text_product_name__KHDFa","text_product_quantity":"styles_text_product_quantity__QQzsv","text_product_err":"styles_text_product_err__9vwjb","link":"styles_link__MZXJp"};

/***/ }),

/***/ 4890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9cc9W","content":"styles_content__ZyEb2","text_err_notification":"styles_text_err_notification__EVbVf","text_total_style":"styles_text_total_style__V8Tve","img_container":"styles_img_container__q0v_U","text_product_name":"styles_text_product_name__c82xl","text_product_quantity":"styles_text_product_quantity__6w5xy","text_product_err":"styles_text_product_err__JDQl2","scroll_y":"styles_scroll_y__eAGjY"};

/***/ }),

/***/ 72910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_wrapper":"styles_modal_wrapper__ebZ5l","modal_mobile_wrapper":"styles_modal_mobile_wrapper__2zjZ8","warning_icon":"styles_warning_icon__sD2_w","text_icon":"styles_text_icon__vlSSv","btn_cancel":"styles_btn_cancel__tHSUr","btn_ok":"styles_btn_ok__7KRMT","text_title":"styles_text_title__1zNVV","btn_ok_mobile":"styles_btn_ok_mobile__CMCQ_","text_top_mobile":"styles_text_top_mobile__uiqhB","btn_ic_close":"styles_btn_ic_close__W99e8","icon_close":"styles_icon_close__p_9Wb"};

/***/ }),

/***/ 94328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper_modal":"styles_wrapper_modal__JD2VD","modalBackdrop":"styles_modalBackdrop__6l882","modalImage":"styles_modalImage__ATIHb","closeWrapper":"styles_closeWrapper__uCKj0","imageMain":"styles_imageMain__spbIb","imageMainMobile":"styles_imageMainMobile__hZnbT","wrapperImg":"styles_wrapperImg__PDDk2","wrapperMobileImg":"styles_wrapperMobileImg__L8TbE","imageNameText":"styles_imageNameText__9IHtY","wrapper_thumbnail":"styles_wrapper_thumbnail__oQiOk","scroll_vertical":"styles_scroll_vertical__l9ELW","wrapper_mobile_thumbnail":"styles_wrapper_mobile_thumbnail__qoNG6","flex_center":"styles_flex_center__p71b_","thumbnail_image_wrapper":"styles_thumbnail_image_wrapper__h4gYD","thumbnail_image_wrapper_mobile":"styles_thumbnail_image_wrapper_mobile__PqCTw","thumbnail_selected":"styles_thumbnail_selected__RBkuM","slider":"styles_slider__7hMX7","leftNavBtn":"styles_leftNavBtn__GOfq4","rightNavBtn":"styles_rightNavBtn__nZUo1"};

/***/ }),

/***/ 24357:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X3_ZQ","wrapperContent":"styles_wrapperContent__dRzqu"};

/***/ }),

/***/ 87653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__tFaLT","wrapper_slide":"styles_wrapper_slide__Efw12","wrapper_slide_image":"styles_wrapper_slide_image__lKjZa","section__item":"styles_section__item__gMD2c","arrowIcon":"styles_arrowIcon__uVUiz","arrowRight":"styles_arrowRight__mpUKk","arrowLeft":"styles_arrowLeft__GkAGp","emptyProduct":"styles_emptyProduct__Ib3J5","wrapperProductPreview":"styles_wrapperProductPreview__7kfCt","productPreviewItem":"styles_productPreviewItem__zIDj6","store_arrowRight":"styles_store_arrowRight__YMLKm","store_arrowLeft":"styles_store_arrowLeft__H6n7l","mobileGroupProduct_block":"styles_mobileGroupProduct_block__8KJZw","mobileBestProdSeller_block":"styles_mobileBestProdSeller_block__5X6qa","mobileProductSeller_block":"styles_mobileProductSeller_block__JPXuf","customSwiper_prev":"styles_customSwiper_prev___euDo","customSwiper_next":"styles_customSwiper_next__mkd1n"};

/***/ }),

/***/ 25150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_input":"styles_root_input__inaN0","input":"styles_input__FR2f4","focus":"styles_focus__3OGAr"};

/***/ }),

/***/ 96282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__1Sdx0","button_minus":"styles_button_minus__LsMUh","button_plus":"styles_button_plus__SmuWw","icon":"styles_icon__UtL_L","plus_disabled":"styles_plus_disabled__QCoJ0","button_root_minus":"styles_button_root_minus__8AKn7"};

/***/ }),

/***/ 12954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"deal_section":"styles_deal_section__VOH3K","root_process":"styles_root_process__sCQg0","count_down":"styles_count_down__kKwl1","startDate":"styles_startDate__e1eXH","process_wrapper":"styles_process_wrapper__5JD_c","process_content":"styles_process_content__IvAep","bar_background":"styles_bar_background__YQZ4R","blur_background":"styles_blur_background__j3SpP","process_wrapper_mv2":"styles_process_wrapper_mv2__FjPzU","deal_section_mv2":"styles_deal_section_mv2__ocl7p","root_process_mv2":"styles_root_process_mv2__qqMxb","countdown_timer_mv2":"styles_countdown_timer_mv2__xe_W9","startDate_mv2":"styles_startDate_mv2__sxN3k","w_45":"styles_w_45__TLRpx","w_90":"styles_w_90__xZLqX","w_85":"styles_w_85__Z4kS2","w_100":"styles_w_100___WWJ_","w_125":"styles_w_125__sNxbr","count_down_container":"styles_count_down_container__ZFy0K"};

/***/ }),

/***/ 76094:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"like":"styles_like__tDqbl","icon":"styles_icon__SIe5_","icon_wrapper":"styles_icon_wrapper__XjymV","favorite_icon":"styles_favorite_icon__fDsqQ","favorite_icon_wrapper":"styles_favorite_icon_wrapper__sS5aj","mobile_favorite_icon_wrapper":"styles_mobile_favorite_icon_wrapper__Xm8jj","favorite_icon_withnew":"styles_favorite_icon_withnew__z6ZQd","favorite_icon_withoutnew":"styles_favorite_icon_withoutnew__j1KtH"};

/***/ }),

/***/ 38103:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__OQiR2","product_card":"styles_product_card__q5wWW","product_card_bestProduct":"styles_product_card_bestProduct__V1WNf","product_tag":"styles_product_tag__jprvt","mobile_product_tag":"styles_mobile_product_tag__NJX0d","product_tab_contract":"styles_product_tab_contract__muV1P","icon_wrapper":"styles_icon_wrapper__hbOPU","favorite_icon":"styles_favorite_icon___SiFm","content_container":"styles_content_container__EjyVj","product_image":"styles_product_image__PrFE8","mobile_product_image":"styles_mobile_product_image___lKYh","image":"styles_image__FqZYH","image_mobile":"styles_image_mobile__xy68T","mobile_product_card":"styles_mobile_product_card__lbY7r","product_tags":"styles_product_tags__lZ4Ny","product_tags_column":"styles_product_tags_column__95EaE","tag_container":"styles_tag_container__0IXpi","mobile_product_tags":"styles_mobile_product_tags__HQY97","favorite_icon_withnew":"styles_favorite_icon_withnew__0_QA2","favorite_icon_withoutnew":"styles_favorite_icon_withoutnew__Odz72"};

/***/ }),

/***/ 41212:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_content_column":"styles_product_content_column__42aRr","product_content":"styles_product_content__JKghC","mobile_product_content":"styles_mobile_product_content__tF5w7","product_title_column_wrap":"styles_product_title_column_wrap__5rmVz","reward_points_wrapper":"styles_reward_points_wrapper__5qAy_","reward_points":"styles_reward_points__G2tzT","reward_text":"styles_reward_text__kzvnS","product_title_wrapper":"styles_product_title_wrapper__wEf0X","product_title":"styles_product_title__p5_Tt","new_tag":"styles_new_tag__wkEMD","dash_tag":"styles_dash_tag__rDlDP","product_name":"styles_product_name__D6dAL","giftlink":"styles_giftlink__Bc0p1","product_tag_mv2":"styles_product_tag_mv2__R0au5","product_name_mv2":"styles_product_name_mv2___0q96","align_center":"styles_align_center__UlWEh","muted":"styles_muted__AWYZj","seller_wrapper":"styles_seller_wrapper__sEZ_f","product_tags":"styles_product_tags__aDMTB","product_tags_column":"styles_product_tags_column__6sZeQ","h40":"styles_h40__zsEtE","wrapper":"styles_wrapper__4Bzij","product_volume":"styles_product_volume__47fCE","product_expiredDate":"styles_product_expiredDate__8JsXy","wrapPlusPoint":"styles_wrapPlusPoint__q7H9k","giftPromo":"styles_giftPromo__kRqKq","prioritizedGiftTag":"styles_prioritizedGiftTag__2d9tN","product_title_wrap":"styles_product_title_wrap__0V105","display_price":"styles_display_price__oca1S","wrapPlusPoint_mv2":"styles_wrapPlusPoint_mv2__aQiuY","card_wrapper":"styles_card_wrapper__u1ZY1","sale_price":"styles_sale_price__8hX7u","displayPrice_wrapper":"styles_displayPrice_wrapper__Q1oKe","wishlist_price_wrapper":"styles_wishlist_price_wrapper__5U1OM","display_wishlist_price_wrapper":"styles_display_wishlist_price_wrapper__CNLH3","wrap":"styles_wrap__HRi4c","will_buy_text":"styles_will_buy_text__dzTHv","discount_number":"styles_discount_number__IfBlp","up":"styles_up__Qm7Vb","down":"styles_down__0Hewj","text_danger":"styles_text_danger__9CmlI","text_desc":"styles_text_desc__mr8P7","text_padding":"styles_text_padding__GiKqE","text_center":"styles_text_center__u4EI7","product_action":"styles_product_action__Exwi5","product_action_mobile":"styles_product_action_mobile__vCYvT","btn_del_m_wrapper":"styles_btn_del_m_wrapper__beBBA","input_container":"styles_input_container__bGYQh","input_wishlist":"styles_input_wishlist__QRUdL","gift_label":"styles_gift_label__W_zA2","border_focus_left":"styles_border_focus_left___OTZR","border_focus_input":"styles_border_focus_input__AtGcu","border_focus_right":"styles_border_focus_right__JcAra","product_action_column":"styles_product_action_column__CkwzD","price_wrapper_column":"styles_price_wrapper_column__9clUy","remove_icon":"styles_remove_icon__6Oh1w","text_danger_column":"styles_text_danger_column__Eqk8D","price_wrapper":"styles_price_wrapper__SalcR","text_change_price":"styles_text_change_price__vwLAz","deal_price":"styles_deal_price__sJFQk","has_item":"styles_has_item__G7Ok6","displayPrice_wrapper_mv2":"styles_displayPrice_wrapper_mv2__prmgG","display_price_mv2":"styles_display_price_mv2__We7wy","sale_price_mv2":"styles_sale_price_mv2__0CFth","card_wishlist_wrapper":"styles_card_wishlist_wrapper__w632u","card_wishlist_mobile_wrapper":"styles_card_wishlist_mobile_wrapper__IoVjY","wishlist_input_container":"styles_wishlist_input_container__HADjO","wishlist_price":"styles_wishlist_price___r8so","mobile_wishlist_price":"styles_mobile_wishlist_price__HkFVP","discount_percent":"styles_discount_percent__cKvEy","text_desc_wishlist":"styles_text_desc_wishlist__l26Vc","text_desc_wishlist_mobile":"styles_text_desc_wishlist_mobile__RjZdq","text_quantity_wishlist":"styles_text_quantity_wishlist__h9F2S","text_quantity_wishlist_mobile":"styles_text_quantity_wishlist_mobile__i48Qn","wishlist_err_wrapper":"styles_wishlist_err_wrapper__uyoy7","wishlist_err_wrapper_mobile":"styles_wishlist_err_wrapper_mobile__6pXpk","remove_icon_mobile_err":"styles_remove_icon_mobile_err__bZMGB","remove_icon_mobile":"styles_remove_icon_mobile__8oKXv","fs_12":"styles_fs_12__Zn_yo","discount_percent_v2":"styles_discount_percent_v2__dTNAG","p_0":"styles_p_0__9WsAT","ml_10":"styles_ml_10__BfTD0","pt_55":"styles_pt_55__gAOM0","mt_5":"styles_mt_5__L1zD7","mt_15":"styles_mt_15__12jgX","mh_28":"styles_mh_28__wHKTf","hidden":"styles_hidden__xHO9t","btn_del_text":"styles_btn_del_text__5ZJ1y","card_wrapper_mv2":"styles_card_wrapper_mv2__tsY1_","contractLabel":"styles_contractLabel__JdzWx"};

/***/ }),

/***/ 53267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card_wrapper":"styles_card_wrapper__584_V","sale_price":"styles_sale_price__NEx8_","displayPrice_wrapper":"styles_displayPrice_wrapper__YOHG9","wishlist_price_wrapper":"styles_wishlist_price_wrapper__x97di","display_wishlist_price_wrapper":"styles_display_wishlist_price_wrapper__SDCw0","wrap":"styles_wrap__4AXuw","display_price":"styles_display_price__bH3V0","will_buy_text":"styles_will_buy_text___DGw1","discount_number":"styles_discount_number__aCzKC","up":"styles_up__FbED_","down":"styles_down__qlrVm","text_danger":"styles_text_danger__QkFbD","text_desc":"styles_text_desc__t6k0q","text_padding":"styles_text_padding__vNOjA","text_center":"styles_text_center__BwKj6","product_action":"styles_product_action__Z_mwd","product_action_mobile":"styles_product_action_mobile__l6idy","btn_del_m_wrapper":"styles_btn_del_m_wrapper__XDLpZ","input_container":"styles_input_container__bjoqL","input_wishlist":"styles_input_wishlist__iFI1h","gift_label":"styles_gift_label__D0twU","minus_btn":"styles_minus_btn__SDz_4","plus_btn":"styles_plus_btn__GWwO2","cart_icon":"styles_cart_icon__84Jgq","mobile_cart_icon":"styles_mobile_cart_icon__zTQ5K","cart_img":"styles_cart_img__wB8hW","border_focus_input":"styles_border_focus_input__otgjD","border_focus_right":"styles_border_focus_right___RF10","card_input":"styles_card_input__CnOY8","card_input_pl_3":"styles_card_input_pl_3__91jXs","card_input_pl_4":"styles_card_input_pl_4__YltEN","card_input_pl_5":"styles_card_input_pl_5__NdYLo","card_input_pl_6":"styles_card_input_pl_6__UX1q8","product_action_column":"styles_product_action_column__5joKK","price_wrapper_column":"styles_price_wrapper_column__1LnPQ","remove_icon":"styles_remove_icon__3CExk","text_danger_column":"styles_text_danger_column__jk_d7","price_wrapper":"styles_price_wrapper__Fkjt_","text_change_price":"styles_text_change_price__bQVyK","deal_price":"styles_deal_price__s2QDa","has_item":"styles_has_item__3QWUF","displayPrice_wrapper_mv2":"styles_displayPrice_wrapper_mv2__aPSwz","display_price_mv2":"styles_display_price_mv2__AaPJa","sale_price_mv2":"styles_sale_price_mv2__3__MN","card_wishlist_wrapper":"styles_card_wishlist_wrapper__MH_E3","card_wishlist_mobile_wrapper":"styles_card_wishlist_mobile_wrapper__eqO4I","wishlist_input_container":"styles_wishlist_input_container__cHH1l","wishlist_price":"styles_wishlist_price__cYgO3","discount_percent":"styles_discount_percent__boHDd","text_desc_wishlist":"styles_text_desc_wishlist__8WJxj","text_desc_wishlist_mobile":"styles_text_desc_wishlist_mobile__Vw_3I","text_quantity_wishlist":"styles_text_quantity_wishlist__dol_R","text_quantity_wishlist_mobile":"styles_text_quantity_wishlist_mobile__wOQT8","wishlist_err_wrapper":"styles_wishlist_err_wrapper__IM_ph","wishlist_err_wrapper_mobile":"styles_wishlist_err_wrapper_mobile__E2eR4","remove_icon_mobile_err":"styles_remove_icon_mobile_err__lgdMI","remove_icon_mobile":"styles_remove_icon_mobile__bGglR","fs_12":"styles_fs_12__sVMW_","discount_percent_v2":"styles_discount_percent_v2__nYhjI","p_0":"styles_p_0__aVll8","ml_10":"styles_ml_10__MAotp","pt_55":"styles_pt_55__jHJPM","mt_5":"styles_mt_5__Vu_9v","mt_15":"styles_mt_15__6HKOT","mh_28":"styles_mh_28__iWwol","hidden":"styles_hidden__Nm1Dz","btn_del_text":"styles_btn_del_text__h9SZI","card_wrapper_mv2":"styles_card_wrapper_mv2__QykuZ","contractLabel":"styles_contractLabel__HqBkG"};

/***/ }),

/***/ 65496:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"date_tag_container":"tag_date_tag_container__aTDAh","tag_container":"tag_tag_container__Sseqx","tag_containerv2":"tag_tag_containerv2__KFiol","normal_tag_container":"tag_normal_tag_container__l9f1f","icon_tag_container":"tag_icon_tag_container__PZrIZ","nameTag":"tag_nameTag__wobzk","nameTagMobileV2":"tag_nameTagMobileV2__qGVKA","tag_container_mobilev2":"tag_tag_container_mobilev2__fBXLU","tag_item":"tag_tag_item__n3GEt"};

/***/ }),

/***/ 84446:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tag_quantity":"styles_tag_quantity__1qcXT","tag":"styles_tag__eOcXj","tag_mv2":"styles_tag_mv2__MRr7b"};

/***/ }),

/***/ 26380:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_input":"styles_root_input__vwInC","input":"styles_input__eFT_l","focus":"styles_focus__2xmTx"};

/***/ }),

/***/ 5007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__KaOaC","button_minus":"styles_button_minus__fIaN1","button_plus":"styles_button_plus__qnrXa","icon":"styles_icon__tlEkS","plus_disabled":"styles_plus_disabled__UnzSr","button_root_minus":"styles_button_root_minus___TAIo"};

/***/ }),

/***/ 96584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default_tag":"styles_default_tag__0jRYW","selected_tag":"styles_selected_tag__kk0ls","card":"styles_card__EMuyE","card_selected":"styles_card_selected__tpbi7","action_button":"styles_action_button__oTgTK","important_action_button":"styles_important_action_button__ccpsy","group_button":"styles_group_button__Es4pH","defaull_button":"styles_defaull_button__lZjJH","ellipsis_1_line":"styles_ellipsis_1_line__MTRZ0","ellipsis_2_line":"styles_ellipsis_2_line__K3X8F"};

/***/ }),

/***/ 56889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"address_dialog":"styles_address_dialog__zARwE","close_button":"styles_close_button__joa5I"};

/***/ }),

/***/ 5177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alphabetFilterWrapper":"styles_alphabetFilterWrapper__k8Be4","mobileAlphabetFilterWrapper":"styles_mobileAlphabetFilterWrapper__e_6hC","alphabetFilterItem":"styles_alphabetFilterItem__Cof_l","alphabetFilterItemActive":"styles_alphabetFilterItemActive__5UvKP"};

/***/ }),

/***/ 78762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4vDlH","total":"styles_total__KriKQ","titleWrapper":"styles_titleWrapper__3vU__","title":"styles_title__1wYID"};

/***/ }),

/***/ 97230:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text_area":"styles_text_area__ay6bm"};

/***/ }),

/***/ 20430:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y_VKO","d_flex":"styles_d_flex__EGI5X","checkout_title":"styles_checkout_title__3gsGZ","checkout_label":"styles_checkout_label__iXelv","checkout_content":"styles_checkout_content__EmYHv","break_line":"styles_break_line__Z1rbC","checkout_promo_code":"styles_checkout_promo_code__xbF0m","total":"styles_total__X0oDt","debt":"styles_debt__h6UYV","btn":"styles_btn__m8hHk","icon":"styles_icon__VklQh","text_right":"styles_text_right__hPXHz","checkout_btn":"styles_checkout_btn__26HAi","condition":"styles_condition__YukLe","checkout_sticky":"styles_checkout_sticky__mRZtX","list_note":"styles_list_note__2N5zg","checkbox":"styles_checkbox__uHLqG","check_agree_txt":"styles_check_agree_txt__FzwMv","checkout_label_second":"styles_checkout_label_second___ZDk0","fwc_container":"styles_fwc_container__T7VIL","price":"styles_price___z6Km","flex_price":"styles_flex_price__37Ajs","label":"styles_label__3lchT","root_btn":"styles_root_btn__avvoU","sticky_checkout_bar_mobile":"styles_sticky_checkout_bar_mobile__1a98L","sticky_checkout_bar_mobileNew":"styles_sticky_checkout_bar_mobileNew__VUQf7","totalM":"styles_totalM__u_YSx","mobileRoot_btn":"styles_mobileRoot_btn__Ohedm","card_err_container":"styles_card_err_container__IA044","text_err_notification":"styles_text_err_notification__hfBAt","delete_text":"styles_delete_text__j74qS","text_content_modal":"styles_text_content_modal__sDWR8","checkout_label_first":"styles_checkout_label_first__8nbgt","continue_btn":"styles_continue_btn__mStF4"};

/***/ }),

/***/ 7867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timer":"styles_timer__bul_F","value":"styles_value__DKXci"};

/***/ }),

/***/ 13402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__ZgmeA","btn":"style_btn___MgGl","outlined_btn":"style_outlined_btn__B9iEy","brown_btn":"style_brown_btn__uRHWa","fill_btn":"style_fill_btn__op2rZ","warning_icon":"style_warning_icon__J42_2","text_icon":"style_text_icon__Ooxdl","modal_title":"style_modal_title__2G9R7","modal_content":"style_modal_content__KTErm","font_gg":"style_font_gg__R9o9V"};

/***/ }),

/***/ 13122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"deal_section":"styles_deal_section__hgRID","root_process":"styles_root_process__LQo7M","count_down":"styles_count_down__jaQd5","startDate":"styles_startDate__mMC_5","process_wrapper":"styles_process_wrapper__uOCun","process_content":"styles_process_content__VWYMN","bar_background":"styles_bar_background__j_v1w","blur_background":"styles_blur_background__ELhVQ"};

/***/ }),

/***/ 67364:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"deal_section":"styles_deal_section__HzbvE","root_process":"styles_root_process__cUfLG","count_down":"styles_count_down__1F_rA","startDate":"styles_startDate__Lmm0w","process_wrapper":"styles_process_wrapper__UEc5J","process_content":"styles_process_content__jdWkq","color_process_content":"styles_color_process_content__M34hs","bar_background":"styles_bar_background__fchhU","blur_background":"styles_blur_background__uRpvC","process_wrapper_mv2":"styles_process_wrapper_mv2__V6wHy","deal_section_mv2":"styles_deal_section_mv2__w1enq","root_process_mv2":"styles_root_process_mv2__V0ZNG","countdown_timer_mv2":"styles_countdown_timer_mv2__w_FvI","startDate_mv2":"styles_startDate_mv2__7i7ep","w_45":"styles_w_45__OpGn0","w_90":"styles_w_90__Fv8ys","w_85":"styles_w_85__zqHtb","w_100":"styles_w_100__tjkIX","w_125":"styles_w_125__5HLsL","count_down_container":"styles_count_down_container__e_XZW"};

/***/ }),

/***/ 68786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__AN39n","btn":"style_btn__vTgO_","outlined_btn":"style_outlined_btn__cJEJx","brown_btn":"style_brown_btn__fMyBz","fill_btn":"style_fill_btn__dQNkZ","warning_icon":"style_warning_icon__Ji2_B","text_icon":"style_text_icon__gkZCA","modal_title":"style_modal_title__EbHxf","modal_content":"style_modal_content__Ah6TT","root":"style_root__Yndk9","title":"style_title__XPQx_","display_none":"style_display_none___BMQx"};

/***/ }),

/***/ 37838:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__9H3QU","add_icon_row":"styles_add_icon_row__Xl49q","add_icon_column":"styles_add_icon_column__LUhdp"};

/***/ }),

/***/ 54773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bo4EW","title":"styles_title__jiXAZ","checkbox":"styles_checkbox__fYUKM","text_muted":"styles_text_muted__biVZO","required":"styles_required__JzwBo","fw500":"styles_fw500__iy8nG","add_new_button":"styles_add_new_button__2VFAd","full_width":"styles_full_width__xfCV7","text":"styles_text__FNHL9","grid_fix":"styles_grid_fix__B5rfu","save_info_cb":"styles_save_info_cb__cO1LP"};

/***/ }),

/***/ 91618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NL0Ar","title":"styles_title__c9FhR","checkbox_color":"styles_checkbox_color__I_LkQ","checkbox":"styles_checkbox__zxnw5","checkout_description":"styles_checkout_description__lyJea","icon":"styles_icon____coe","fw500":"styles_fw500__l1726","fw300":"styles_fw300__5a8kF"};

/***/ }),

/***/ 92929:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"editBtn":"styles_editBtn__I94Hu","disableBtn":"styles_disableBtn__1_yfC","order_edit_btn":"styles_order_edit_btn__0Ge1b"};

/***/ }),

/***/ 39335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__CYhqI","btn":"style_btn___Qno3","outlined_btn":"style_outlined_btn__klXg_","brown_btn":"style_brown_btn__u1xuR","fill_btn":"style_fill_btn__bLg8N","warning_icon":"style_warning_icon__ItUph","text_icon":"style_text_icon__8ptoU","modal_title":"style_modal_title__V9mgj","modal_content":"style_modal_content__IvlAY","root":"style_root__BWf9A","title":"style_title__9vpiB","display_none":"style_display_none___nl9i"};

/***/ }),

/***/ 58152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"like":"styles_like__3AApL","icon":"styles_icon__bpzF3","icon_wrapper":"styles_icon_wrapper__qCyVo","favorite_icon":"styles_favorite_icon__dzz2_","favorite_icon_wrapper":"styles_favorite_icon_wrapper__Xe5pn","favorite_icon_withnew":"styles_favorite_icon_withnew__pvv_R","favorite_icon_withoutnew":"styles_favorite_icon_withoutnew__MDM13"};

/***/ }),

/***/ 90124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"styles_searchBox__Mgjzq","mobileSearchBox":"styles_mobileSearchBox__3qg0e","searchInput":"styles_searchInput__y4Duh"};

/***/ }),

/***/ 52200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__Bvp9U","title":"styles_title__FbqSm","bottom_text":"styles_bottom_text__CZiM6","error":"styles_error__wWyib","formInput":"styles_formInput__3v20h","input":"styles_input__jqmJJ","disabled":"styles_disabled__kroW2","custom_field":"styles_custom_field__C0_Ks","right_c":"styles_right_c__hot1N","remaining":"styles_remaining__UVxTt","confirm_modal_wrap":"styles_confirm_modal_wrap__GAO__","btn":"styles_btn__s0npd","outlined_btn":"styles_outlined_btn__TdkBl","brown_btn":"styles_brown_btn__bb676","fill_btn":"styles_fill_btn__S6meI","warning_icon":"styles_warning_icon__V38QN","text_icon":"styles_text_icon__NbrIo","modal_title":"styles_modal_title__CaVu5","modal_content":"styles_modal_content__nQrFV","btngroup":"styles_btngroup__B3Bfc"};

/***/ }),

/***/ 69470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"desc":"styles_desc__gww0i","error":"styles_error__4ZRps","input":"styles_input__nk__v","disabled":"styles_disabled__oxEUf","timing_wrapper":"styles_timing_wrapper__9wcL2","timing":"styles_timing__i5kis","center":"styles_center__ijy9t","btn":"styles_btn__7hepk","confirm_modal_wrap":"styles_confirm_modal_wrap__0GQr7","warning_icon":"styles_warning_icon__vU7hL","text_icon":"styles_text_icon__5OcCc","modal_title":"styles_modal_title__8eybH","mb_10":"styles_mb_10__heATs"};

/***/ }),

/***/ 81966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fw500":"styles_fw500__bG5Yd","address_field":"styles_address_field__J2BY1"};

/***/ }),

/***/ 3681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ingredientList":"styles_ingredientList__Mn4zN","container":"styles_container__rFxqz","ingredient":"styles_ingredient__KruLD","total":"styles_total__jbGBD","totalIngredient":"styles_totalIngredient__ng2_m","item":"styles_item__BuaI2"};

/***/ }),

/***/ 91066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paperroot":"styles_paperroot__KzU4N","root":"styles_root__5BFMs","title":"styles_title__cCVNj","margin_none":"styles_margin_none__56x10","checkbox":"styles_checkbox__bRfmf","Mui-disabled":"styles_Mui-disabled__iVHe2","text_area":"styles_text_area__QO3Jm","red_bill":"styles_red_bill__N_EEP","fw500":"styles_fw500__9QhPv","icon":"styles_icon__7Dzvc","helper_text":"styles_helper_text__jRe_x","full_width":"styles_full_width__1adlY","notifi_list":"styles_notifi_list__SAdZo","text_muted":"styles_text_muted__UiBYI","text":"styles_text__XuLr_","grid_fix":"styles_grid_fix__0bxO1","save_info_cb":"styles_save_info_cb__0I6UO"};

/***/ }),

/***/ 48765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"styles_confirm_modal_wrap__ppZn_","btn":"styles_btn__GVOD2","outlined_btn":"styles_outlined_btn__Suyyt","brown_btn":"styles_brown_btn__9V_jv","fill_btn":"styles_fill_btn__mF3ux","warning_icon":"styles_warning_icon__BN1MO","text_icon":"styles_text_icon__QTo3o","modal_title":"styles_modal_title__NS9qC","modal_content":"styles_modal_content__liedI","root":"styles_root__nF6k_","title":"styles_title__XBmNP","display_none":"styles_display_none__tDUte"};

/***/ }),

/***/ 99009:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VebWI","manufacturer":"styles_manufacturer__EoCOt","total":"styles_total__aKSoR"};

/***/ }),

/***/ 73330:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__89Lnv","wrapperImg":"styles_wrapperImg__t3OOq","thumbnail":"styles_thumbnail__TbmOL","thumbnailImage":"styles_thumbnailImage__4VUxM","thumbnailSelected":"styles_thumbnailSelected__l9eW6","slider":"styles_slider___hiDP","imageMain":"styles_imageMain__UQ9fH","imageNotFound":"styles_imageNotFound__F6i5M","modalBackdrop":"styles_modalBackdrop__VHM2r","modalButton":"styles_modalButton__5sKlJ","imgButtonBase":"styles_imgButtonBase__RoFW4","descImg":"styles_descImg__MudDr","product_tag":"styles_product_tag__Ob_PB","product_tags":"styles_product_tags__24U9j"};

/***/ }),

/***/ 99148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"auth_modal_header":"styles_auth_modal_header__8MVV9","auth_modal_content":"styles_auth_modal_content__gD2DP","auth_modal_title":"styles_auth_modal_title__7Ht8G","auth_modal_close":"styles_auth_modal_close__CfXli","auth_modal_body":"styles_auth_modal_body__le_XM","form_control":"styles_form_control__Q6ZcO"};

/***/ }),

/***/ 6911:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"forget_password":"styles_forget_password__Bgi8f","form_forget_password":"styles_form_forget_password__LFLRV","form_control":"styles_form_control__Fh4Bx","error":"styles_error__kc_eh","input":"styles_input__nYkkM","disabled":"styles_disabled__9z3X7","input_icon":"styles_input_icon__GyGX0","confirm_modal_wrap":"styles_confirm_modal_wrap__3VIvi","warning_icon":"styles_warning_icon__ULHEc","text_icon":"styles_text_icon__5s1_y","modal_title":"styles_modal_title__pi0zH","modal_content":"styles_modal_content__QFga1","center":"styles_center__P1JFJ","btn":"styles_btn__hHdKy"};

/***/ }),

/***/ 77827:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"auth_modal_content":"styles_auth_modal_content__PvVG_","auth_modal_title":"styles_auth_modal_title__rXe5Q","auth_modal_close":"styles_auth_modal_close__FhiYT","hiddenClose":"styles_hiddenClose__7srCw","iconBack":"styles_iconBack__AF2xw"};

/***/ }),

/***/ 31312:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3o7Fu","title":"styles_title__aWThL","bottom_text":"styles_bottom_text__q10_X","error":"styles_error__vO_4D","formInput":"styles_formInput__4d5ir","input":"styles_input__uSP42","disabled":"styles_disabled__lVtJL","custom_field":"styles_custom_field__Q3Gf2","right_c":"styles_right_c__PZfHv","remaining":"styles_remaining___aV6o","confirm_modal_wrap":"styles_confirm_modal_wrap__pUV7U","btn":"styles_btn__iB1lB","outlined_btn":"styles_outlined_btn__TLYCx","brown_btn":"styles_brown_btn__At592","fill_btn":"styles_fill_btn__7GPS_","warning_icon":"styles_warning_icon__WOM0c","text_icon":"styles_text_icon__SRoaP","modal_title":"styles_modal_title__4Zaji","modal_content":"styles_modal_content__NYrDG","btngroup":"styles_btngroup__SlsQL"};

/***/ }),

/***/ 74689:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__55sKa","form":"styles_form__PkJAF","title":"styles_title__R0ICH","bottom_text":"styles_bottom_text__h6dKa","error":"styles_error__EVRHG","formInput":"styles_formInput__MS1rR","btn_wrapper":"styles_btn_wrapper__6uhGB","btn":"styles_btn__PdzcE"};

/***/ }),

/***/ 47638:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__EYLUj","sendData":"styles_sendData__I_cSt","textError":"styles_textError__V1TeQ","iconError":"styles_iconError__Qm_ie","textRequired":"styles_textRequired__4p7OM","slideLeft":"styles_slideLeft__tDHbv","slide-left":"styles_slide-left__7t8IP","slide-right":"styles_slide-right__cpbTS"};

/***/ }),

/***/ 9992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form_sign_up":"styles_form_sign_up__OFHCD","input":"styles_input__oe1e7","text_error":"styles_text_error__R_ylU","input_icon":"styles_input_icon__5UgkE","select_field":"styles_select_field__tsAy6","scope_field":"styles_scope_field__MlSXq","agree_term":"styles_agree_term__aVgph","link_login_wrapper":"styles_link_login_wrapper__5szuS","link_login":"styles_link_login__bBjfG","center":"styles_center__sgJJ3","btn_register":"styles_btn_register__zCg7F","disclaimer":"styles_disclaimer__4zlxV","wrapperTitle":"styles_wrapperTitle__emIpZ","badge":"styles_badge__26zQs","greenIcon":"styles_greenIcon__EUCw5","mt_16":"styles_mt_16__KJngJ"};

/***/ }),

/***/ 5397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PnlWX","title":"styles_title__WsbwW","checkbox_color":"styles_checkbox_color__KTpvK","checkbox":"styles_checkbox__eFdbB","bank_info":"styles_bank_info__QXFqo","MuiAlert-message":"styles_MuiAlert-message__QBX_8","bank_info_label":"styles_bank_info_label__amxRh","bank_info_content":"styles_bank_info_content__n_fsY","fw500":"styles_fw500__Ev_4_","d_flex":"styles_d_flex__DmMy6","text_muted":"styles_text_muted__QhYxo","subTitle":"styles_subTitle__J5Agn","paymentMethodsGrid":"styles_paymentMethodsGrid__ay1iS","fieldset":"styles_fieldset__BqASy","noncheckbox_color":"styles_noncheckbox_color__HYKWr","boxPercentage":"styles_boxPercentage__LRqfu","percentageText":"styles_percentageText__CPF7L","containerModal":"styles_containerModal__c6QqQ","headerBack":"styles_headerBack__auf2n","iconBackButton":"styles_iconBackButton__fb0dj","titleBackButton":"styles_titleBackButton__Q9PyQ","listItemsBox":"styles_listItemsBox__fSt2m","listItems":"styles_listItems__kmBgu","radioGroup":"styles_radioGroup__eKFeD","donePaymentButtonBox":"styles_donePaymentButtonBox__YtjM0","donePaymentButton":"styles_donePaymentButton__U4nZg","groupCheckBox":"styles_groupCheckBox__GInDK","titleContent":"styles_titleContent___ghPn","subTitleContent":"styles_subTitleContent__X1PM_","textRight":"styles_textRight__VJNH6","currencyPopup":"styles_currencyPopup__6aB_1"};

/***/ }),

/***/ 66727:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapPoint":"styles_wrapPoint__d0hF_","wrapPointLarge":"styles_wrapPointLarge__csU9O","pointTextSmall":"styles_pointTextSmall__yr0TW","titlePoint":"styles_titlePoint__g4JGm","coefficient":"styles_coefficient__Akac7","pointMultiplierWrap":"styles_pointMultiplierWrap__uN5Ce","point":"styles_point__n__jt","point_mv2":"styles_point_mv2__bOiu1","pointMultiplierWrap_mv2":"styles_pointMultiplierWrap_mv2__KNMss","coefficient_mv2":"styles_coefficient_mv2__TLAJG"};

/***/ }),

/***/ 28829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__vWm7v","title":"style_title__Se24i","button":"style_button__tDpHC","product_name":"style_product_name__ekoUR","ovfy":"style_ovfy__Wn635"};

/***/ }),

/***/ 37315:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_content_column":"styles_product_content_column__uMZ6Y","product_name":"styles_product_name__GYznx","flex_wrap":"styles_flex_wrap__pzZMG","giftlink":"styles_giftlink__sjx5V","link":"styles_link__9frSU","product_type":"styles_product_type__Bm_uX","align_center":"styles_align_center__4oU0Z","muted":"styles_muted__Hq7Sf","product_category":"styles_product_category__XKs0l","product_tags":"styles_product_tags__4oFLJ","product_tags_column":"styles_product_tags_column__Osvao","product_title_column_wrap":"styles_product_title_column_wrap__BXF_B","product_title":"styles_product_title__2A7U3","h40":"styles_h40__Ab6IB","product_content":"styles_product_content__bPOWw","discount_flag":"styles_discount_flag__rA_oc","boxPerDay":"styles_boxPerDay__w1O_U","product_name_mv2":"styles_product_name_mv2___Gi_9","product_tag_mv2":"styles_product_tag_mv2__Vww8e","linkMobile":"styles_linkMobile__v9CZ8","mobileProduct_type":"styles_mobileProduct_type__GhTdv","giftPromo":"styles_giftPromo__rWO81","prioritizedPromo":"styles_prioritizedPromo__zs2io","product_title_wrap":"styles_product_title_wrap__hdUa_","product_action":"styles_product_action__E8b9e","flex_70":"styles_flex_70__PSotj","flex_40":"styles_flex_40__0yh6j","mw_440":"styles_mw_440__iyM_s","product_name_mv2_horizontal":"styles_product_name_mv2_horizontal__N_Qdc"};

/***/ }),

/***/ 29606:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card_wrapper":"styles_card_wrapper__4gxsU","sale_price":"styles_sale_price__3DMNb","displayPrice_wrapper":"styles_displayPrice_wrapper__x2DAD","wishlist_price_wrapper":"styles_wishlist_price_wrapper__K1Zkq","display_wishlist_price_wrapper":"styles_display_wishlist_price_wrapper__OEznG","wrap":"styles_wrap__7gf3E","display_price":"styles_display_price__WOBxy","will_buy_text":"styles_will_buy_text__DKsyn","discount_number":"styles_discount_number___dHF_","up":"styles_up__EFBSl","down":"styles_down__lj1pm","text_danger":"styles_text_danger__6MGSW","text_desc":"styles_text_desc__holJt","text_padding":"styles_text_padding__kNIxs","text_center":"styles_text_center__PdXiJ","product_action":"styles_product_action___3AJk","product_action_mobile":"styles_product_action_mobile__lZhu1","btn_del_m_wrapper":"styles_btn_del_m_wrapper__6zA4N","input_container":"styles_input_container__39PB9","input_wishlist":"styles_input_wishlist__7jmXF","gift_label":"styles_gift_label__4zVF3","border_focus_left":"styles_border_focus_left__pQ7c9","border_focus_input":"styles_border_focus_input__lTSjB","border_focus_right":"styles_border_focus_right__uXNHT","product_action_column":"styles_product_action_column__zpEDF","price_wrapper_column":"styles_price_wrapper_column__iwhIo","remove_icon":"styles_remove_icon__xgMvj","text_danger_column":"styles_text_danger_column__ZDRZO","price_wrapper":"styles_price_wrapper__i6KqQ","text_change_price":"styles_text_change_price__bF_MP","deal_price":"styles_deal_price__056ey","has_item":"styles_has_item__Kxutj","displayPrice_wrapper_mv2":"styles_displayPrice_wrapper_mv2__mAy9L","display_price_mv2":"styles_display_price_mv2__d6AYg","sale_price_mv2":"styles_sale_price_mv2__fiRYi","card_wishlist_wrapper":"styles_card_wishlist_wrapper__V6j6d","card_wishlist_mobile_wrapper":"styles_card_wishlist_mobile_wrapper__tmcPn","wishlist_input_container":"styles_wishlist_input_container__OwGke","wishlist_price":"styles_wishlist_price__eUhq5","discount_percent":"styles_discount_percent__QLs_Y","text_desc_wishlist":"styles_text_desc_wishlist__Q0B3E","text_desc_wishlist_mobile":"styles_text_desc_wishlist_mobile__4gzFe","text_quantity_wishlist":"styles_text_quantity_wishlist__Z2J4v","text_quantity_wishlist_mobile":"styles_text_quantity_wishlist_mobile__hK6Uf","wishlist_err_wrapper":"styles_wishlist_err_wrapper__wtwRF","wishlist_err_wrapper_mobile":"styles_wishlist_err_wrapper_mobile__7TKwq","remove_icon_mobile_err":"styles_remove_icon_mobile_err__yntpf","remove_icon_mobile":"styles_remove_icon_mobile__Xi1f0","fs_12":"styles_fs_12__gpf7a","discount_percent_v2":"styles_discount_percent_v2__KTOMw","p_0":"styles_p_0__zvFS8","ml_10":"styles_ml_10__jqp00","pt_55":"styles_pt_55__4WT1C","mt_5":"styles_mt_5__wlmIH","mt_15":"styles_mt_15__N72g_","mh_28":"styles_mh_28___9iqL","hidden":"styles_hidden___lLy2","btn_del_text":"styles_btn_del_text__EOeXE","card_wrapper_mv2":"styles_card_wrapper_mv2__3CqDP","contractLabel":"styles_contractLabel__R9VpQ"};

/***/ }),

/***/ 17688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4dCGR","product_card":"styles_product_card__rfs0S","product_card_bestProduct":"styles_product_card_bestProduct__bxOj3","product_tag":"styles_product_tag__zrmuo","product_tab_contract":"styles_product_tab_contract__rcd_4","icon_wrapper":"styles_icon_wrapper__mUQwk","favorite_icon":"styles_favorite_icon__qTalW","favorite_icon_wrapper":"styles_favorite_icon_wrapper__SzqK3","content_container":"styles_content_container__gS16u","product_image":"styles_product_image__qKurA","image":"styles_image__lBshU","image_mobile":"styles_image_mobile__dEbCN","product_card_mv2":"styles_product_card_mv2__1Xi30","product_tag_mv2":"styles_product_tag_mv2__nd1qH","favorite_icon_withnew":"styles_favorite_icon_withnew__DEZiA","favorite_icon_withoutnew":"styles_favorite_icon_withoutnew__O86dq"};

/***/ }),

/***/ 67868:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_content_column":"styles_product_content_column__Ul0qN","product_content":"styles_product_content__DgGFZ","product_title_column_wrap":"styles_product_title_column_wrap__R3z9i","reward_points_wrapper":"styles_reward_points_wrapper__hvvpH","reward_points":"styles_reward_points___Lst6","reward_text":"styles_reward_text__kXrlv","product_title":"styles_product_title__uoDp2","new_tag":"styles_new_tag__mDeTn","dash_tag":"styles_dash_tag__RVGi_","product_name":"styles_product_name__R1JN_","giftlink":"styles_giftlink__3M_Ck","product_tag_mv2":"styles_product_tag_mv2__ZhbD2","product_name_mv2":"styles_product_name_mv2__ixKYi","align_center":"styles_align_center__MJn3j","muted":"styles_muted__K5Vro","seller_wrapper":"styles_seller_wrapper__LiHyw","product_tags":"styles_product_tags__rW1Ky","product_tags_column":"styles_product_tags_column__Ibprv","h40":"styles_h40__I44Xy","wrapper":"styles_wrapper__k9bGK","product_volume":"styles_product_volume__By5yH","wrapPlusPoint":"styles_wrapPlusPoint__KZPGp","giftPromo":"styles_giftPromo__j1tft","prioritizedGiftTag":"styles_prioritizedGiftTag__C6u_l","product_title_wrap":"styles_product_title_wrap__VYjLE","display_price":"styles_display_price__JgJa3","wrapPlusPoint_mv2":"styles_wrapPlusPoint_mv2__jeJqZ"};

/***/ }),

/***/ 65369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__F2fym","indicator":"styles_indicator__2pXj_","mobileIndicator":"styles_mobileIndicator__ZMT4p","content":"styles_content__6RTCG","tabs":"styles_tabs__gKnEf","tab_panel":"styles_tab_panel__ScV41"};

/***/ }),

/***/ 69815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__ul4ax","tab_panel":"styles_tab_panel__NAwAa","root":"styles_root__yHa_F","active_tab":"styles_active_tab__57bQP","indicator":"styles_indicator__oOTul","content":"styles_content__L0lSp","ingredient":"styles_ingredient__YBVN8","ingredientList":"styles_ingredientList___k512","cb_link":"styles_cb_link__XAKSc","product_tags":"styles_product_tags__ExhNu","warpper":"styles_warpper__a1pGy","manufactureInfo":"styles_manufactureInfo__3LBBp","manufactureInfoLink":"styles_manufactureInfoLink__NlYlw","warpperIcon":"styles_warpperIcon__8WfDk","tab_mv2":"styles_tab_mv2__f7QpT","tab_panel_mv2":"styles_tab_panel_mv2__j1JOq","mobile_item_wrapper":"styles_mobile_item_wrapper__jtSmF","item_wrapper":"styles_item_wrapper__FoAJK","manufactureInfo_mv2":"styles_manufactureInfo_mv2__W0QaA","mobile_item":"styles_mobile_item__lGYxd","item":"styles_item__8W9c_","general_item":"styles_general_item__PYGAu","input_label":"styles_input_label__oQp_e","item_label":"styles_item_label__Jq3we","item_label_border":"styles_item_label_border__fwR0E","item_content":"styles_item_content__fOfKI","ingredient_row":"styles_ingredient_row__FFyQU","ingredient_row_label":"styles_ingredient_row_label__P93In","ingredient_row_content":"styles_ingredient_row_content__seZL3","ingredient_heading":"styles_ingredient_heading__eQ4Pg","ingredient_row_heading":"styles_ingredient_row_heading__FkE_4"};

/***/ }),

/***/ 12404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"date_tag_container":"tag_date_tag_container__bq5VK","tag_container":"tag_tag_container__Ypz6S","tag_containerv2":"tag_tag_containerv2__66m1A","normal_tag_container":"tag_normal_tag_container__Twl9u","icon_tag_container":"tag_icon_tag_container__1zOAv","nameTag":"tag_nameTag__RvjhU","nameTagMobileV2":"tag_nameTagMobileV2__E_Q_J","tag_container_mobilev2":"tag_tag_container_mobilev2__NWEoN"};

/***/ }),

/***/ 57770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"styles_confirm_modal_wrap__uTxNL","header":"styles_header__lEBHn","closeIcon":"styles_closeIcon__8jfJQ","fixed_width_wrapper":"styles_fixed_width_wrapper__G_sjn","modal_title":"styles_modal_title__2q_64","children":"styles_children__W0hg0","gift_icon":"styles_gift_icon__TNl3o","wrapLoading":"styles_wrapLoading__tiTSv","containerPromoDiablog":"styles_containerPromoDiablog__tgs8S","wrapImg":"styles_wrapImg__iDCCh","btn_container":"styles_btn_container__7SXzj"};

/***/ }),

/***/ 5070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__4CR4M","title":"styles_title__Bye3n","bottom_text":"styles_bottom_text__nEKSZ","btnWrapper":"styles_btnWrapper__FW9IP","error":"styles_error__LIpZk","formInput":"styles_formInput__JstrB"};

/***/ }),

/***/ 55166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchDropdown":"styles_searchDropdown__FryBv","searchResults":"styles_searchResults__HEeR_","textPrimary":"styles_textPrimary__0O4Pe"};

/***/ }),

/***/ 19024:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_input":"styles_root_input__Gyi3H","input":"styles_input___qtIu","root_input_column":"styles_root_input_column__Y9PFv","focus":"styles_focus__Gs1L7"};

/***/ }),

/***/ 70179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_input":"styles_root_input__z8jk6","input":"styles_input__evwLt","focus":"styles_focus__iyfyA","search_wrap":"styles_search_wrap__0bclL"};

/***/ }),

/***/ 55711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search_result":"style_search_result__5jWKu"};

/***/ }),

/***/ 46639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5ZQbt","trigger":"styles_trigger__hJIBW","trigger_error":"styles_trigger_error__9LZOj","trigger_open":"styles_trigger_open__xerQj","start_icon":"styles_start_icon__8vwys","value":"styles_value__Ait1n","placeholder":"styles_placeholder__9u866","chevron":"styles_chevron__bRkmz","paper":"styles_paper__2zHdJ","panel":"styles_panel__Iw8bU","search":"styles_search__mKJuI","search_icon":"styles_search_icon__18Tue","search_input":"styles_search_input__YiuNK","list":"styles_list__xw3pX","option":"styles_option__6OEpz","option_active":"styles_option_active__gMfoH","option_selected":"styles_option_selected__5QzkJ","option_label":"styles_option_label__FN2LK","option_check":"styles_option_check__MllXt","empty":"styles_empty__nk2Z6"};

/***/ }),

/***/ 72303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"supplierTitle":"styles_supplierTitle__EiwjU","supplier_wishlist":"styles_supplier_wishlist__TZ0wr","name":"styles_name__IHYLk","supplierName":"styles_supplierName__AxHU6","link":"styles_link__T_OV2","link_v2":"styles_link_v2__De3Su","image_logo":"styles_image_logo__LIfop","supplierTitle_mv2":"styles_supplierTitle_mv2__qG9tD","link_mv2":"styles_link_mv2__v5Bi2","supplier_title_v2":"styles_supplier_title_v2__lm35d","text_tf_none":"styles_text_tf_none__5GpaE","m0":"styles_m0__7Jqd_","sellerProduct":"styles_sellerProduct__K25aq"};

/***/ }),

/***/ 37721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__cyIKQ","mobile_wrapper":"styles_mobile_wrapper__RMksv","row":"styles_row__aF_r7","avatar_name":"styles_avatar_name__AuzRP","mobile_avatar_name":"styles_mobile_avatar_name__vqF5m","avatar":"styles_avatar__itYY0","mobile_avatar":"styles_mobile_avatar__J3Ktl","name":"styles_name__Jz1Pr","mobile_name":"styles_mobile_name__Upo9k","visit_store":"styles_visit_store__e_j87","hide_border_top":"styles_hide_border_top__V20U7"};

/***/ }),

/***/ 14025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"province":"styles_province__grk_9","radioGroup":"styles_radioGroup__h9_i4","item":"styles_item__uNdJN","menuDropdown":"styles_menuDropdown__Gywm6"};

/***/ }),

/***/ 96242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__YAOQe","bestProducts":"styles_bestProducts__ldQga","title":"styles_title__Vd_MU","root":"styles_root__h04so","media":"styles_media__uBTFe","large":"styles_large__srZ1p","card_header":"styles_card_header__8sK1Z","header_customer":"styles_header_customer__QfIOE","header_title":"styles_header_title__yQP6r","wrapper_media":"styles_wrapper_media__UnKRd","wrapper_media_container":"styles_wrapper_media_container__EEYxx","card_content":"styles_card_content__T0dnj","comment_style":"styles_comment_style__G8Kwz","rotate":"styles_rotate__WapwC","quote":"styles_quote___apVt","seeAllWrapper":"styles_seeAllWrapper__jPff1","seeAll":"styles_seeAll__pezXi","SliderProductWrap":"styles_SliderProductWrap__m_PuB","SliderProductWrapV2":"styles_SliderProductWrapV2___k8xy","header":"styles_header__yyoPE","name":"styles_name__iX54Z","bestProductsName":"styles_bestProductsName__seiN_","view_more":"styles_view_more__wi78K","wrapper":"styles_wrapper__BpsRk","bestProductsWrapper":"styles_bestProductsWrapper__CTecY","bestProducts_view_more":"styles_bestProducts_view_more__OjYZL","icon_name":"styles_icon_name__O1BNU","wrapper_mv2":"styles_wrapper_mv2__jSrMT","view_more_mv2":"styles_view_more_mv2___ks2m","icon_name_mv2":"styles_icon_name_mv2__EeEjf","name_mv2":"styles_name_mv2__hY3iD","megaSale_container":"styles_megaSale_container__c0Dzx","megaSale_nameContainer":"styles_megaSale_nameContainer__NddnY","megaSale_name":"styles_megaSale_name__KUKiQ","megaSale_nameMobile":"styles_megaSale_nameMobile___3Vms","SliderProductWrap_megaSale":"styles_SliderProductWrap_megaSale__P8qbw","see_more_wrapper":"styles_see_more_wrapper__uoIuj","see_more_btn":"styles_see_more_btn__X_nkF","see_more_mobile_btn":"styles_see_more_mobile_btn__UQadk","see_more_icon":"styles_see_more_icon__i__at"};

/***/ }),

/***/ 66086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tagMobile":"style_tagMobile__C2g_u","tag_quantity":"style_tag_quantity__Jg2qT","tag_quantity_mv2":"style_tag_quantity_mv2__Cy9kK","chatMobile_moreTag":"style_chatMobile_moreTag__38lv6"};

/***/ }),

/***/ 469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"feedback_order":"style_feedback_order__54hgm","container":"style_container__kRZ5D","title":"style_title__jnP7a","statusTitle":"style_statusTitle__kImWo","label":"style_label__Zaovr","text_body":"style_text_body__gVrlt","value":"style_value__aN3JA","feedbackWrap":"style_feedbackWrap__BeNMN","feedbackConent":"style_feedbackConent__o_0ax","feedbackImg":"style_feedbackImg__dZK0N","button_find":"style_button_find__cGYdT","text_red":"style_text_red__krwD9","button_send":"style_button_send__8GGNd","reason_select":"style_reason_select__RO__H","textarea":"style_textarea__UVnXx","imagesField":"style_imagesField__K4t_c","info_group":"style_info_group__Or8_F","rug-handle-icon":"style_rug-handle-icon__sZq3B","customText":"style_customText__PYtfw","card":"style_card__lR2DI","bank_name":"style_bank_name__qRpsF","bank_code":"style_bank_code__m9t2n","info_bank_title":"style_info_bank_title__0pH0H","content":"style_content__UefVl","ticket_status_chip":"style_ticket_status_chip__7i97l","reason_button":"style_reason_button__FcOas","ticket_img_container":"style_ticket_img_container__UOaAE","ticket_img":"style_ticket_img__9bWAs","pop_over":"style_pop_over__Myhh6","text_field":"style_text_field__MRrI5","close_button":"style_close_button__wYgc2","image_modal":"style_image_modal__CjTAi","buttonSend":"style_buttonSend__zCDbp","SendFeedback":"style_SendFeedback__JQcbY","formfeedback":"style_formfeedback__TQv_T","buttonCancel":"style_buttonCancel__CZWud","buttonActive":"style_buttonActive__2q3Gt","buttonInActive":"style_buttonInActive__47cdd","feedbackReturn":"style_feedbackReturn__XSfye","feedbackReturn_title":"style_feedbackReturn_title__ZbfjC","nameTS":"style_nameTS__hkcBI","avatarUser":"style_avatarUser__j4p04","nameUser":"style_nameUser__E5ZG9","date":"style_date__sl6Ju","accept":"style_accept__xNYPw","btnAcept":"style_btnAcept__dVIjr"};

/***/ }),

/***/ 81330:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"feedback_order":"style_feedback_order__Z6zbB","container":"style_container__FxEZt","title":"style_title___O13n","label":"style_label__7PpI0","text_body":"style_text_body__UO9Ob","button_find":"style_button_find__6D_1p","text_red":"style_text_red__KJUwg","button_send":"style_button_send__QfvU9","reason_select":"style_reason_select__Ns8N8","textarea":"style_textarea__6lgdK","imagesField":"style_imagesField___qpc5","info_group":"style_info_group__CnrdR","rug-handle-icon":"style_rug-handle-icon__zrgJl","customText":"style_customText__9q0rK"};

/***/ }),

/***/ 59598:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"style_dropzone__U4yHJ","selected-file-wrapper":"style_selected-file-wrapper__kVNGZ","selected_file":"style_selected_file__A8wFw","wrap":"style_wrap__D9Ian","clearIcon":"style_clearIcon__SIrcz","wrapImage":"style_wrapImage__xctXF","inner":"style_inner__Pu_N6","preview":"style_preview__5F43t","image":"style_image__wzkor","file":"style_file__TCOBG","mobileWrap":"style_mobileWrap__PhfyM","mobileUpload_title":"style_mobileUpload_title__sDynV"};

/***/ }),

/***/ 54304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__bTIeR","btn":"style_btn__mnzG2","outlined_btn":"style_outlined_btn__Vbaqe","brown_btn":"style_brown_btn__tHwhV","fill_btn":"style_fill_btn__t4fmt","warning_icon":"style_warning_icon__n6NnH","text_icon":"style_text_icon__khra_","modal_title":"style_modal_title__hyVvF","modal_content":"style_modal_content__3Ut_p","remove_item":"style_remove_item__AFCYg","remove_item_content":"style_remove_item_content__vX3o4","remove_item_image":"style_remove_item_image__Xb3tU","remove_item_cart_name":"style_remove_item_cart_name__cIW_1","remove_item_cart_price":"style_remove_item_cart_price__vbIFg"};

/***/ })

}]);